webpackJsonp([0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var platform_browser_dynamic_1 = __webpack_require__(1);
	var core_1 = __webpack_require__(3);
	var app_module_1 = __webpack_require__(23);
	if (true) {
	    core_1.enableProdMode();
	}
	platform_browser_dynamic_1.platformBrowserDynamic().bootstrapModule(app_module_1.AppModule);


/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var platform_browser_1 = __webpack_require__(21);
	var forms_1 = __webpack_require__(24);
	var app_component_1 = __webpack_require__(28);
	var ng2_completer_1 = __webpack_require__(61);
	var http_1 = __webpack_require__(30);
	var ng2_translate_1 = __webpack_require__(29);
	var router_1 = __webpack_require__(76);
	var super_user_component_1 = __webpack_require__(93);
	var dashboard_component_1 = __webpack_require__(98);
	var messages_component_1 = __webpack_require__(124);
	var message_detail_component_1 = __webpack_require__(127);
	var profile_component_1 = __webpack_require__(131);
	var profile_change_email_component_1 = __webpack_require__(134);
	var profile_change_email_password_component_1 = __webpack_require__(136);
	var profile_change_password_component_1 = __webpack_require__(138);
	var profile_change_subrole_component_1 = __webpack_require__(140);
	var profile_edit_component_1 = __webpack_require__(145);
	var notifications_component_1 = __webpack_require__(148);
	var favorites_component_1 = __webpack_require__(151);
	var core_2 = __webpack_require__(154);
	var imageCropperComponent_1 = __webpack_require__(99);
	var main_component_1 = __webpack_require__(177);
	var dashboard_component_2 = __webpack_require__(187);
	var element_detail_component_1 = __webpack_require__(191);
	var change_password_component_1 = __webpack_require__(196);
	var cities_seeker_component_1 = __webpack_require__(199);
	var tags_handler_component_1 = __webpack_require__(201);
	var login_component_1 = __webpack_require__(204);
	var register_component_1 = __webpack_require__(219);
	var faq_component_1 = __webpack_require__(225);
	var info_component_1 = __webpack_require__(228);
	var who_component_1 = __webpack_require__(230);
	var forum_component_1 = __webpack_require__(232);
	var dashboard_component_3 = __webpack_require__(235);
	var topic_detail_component_1 = __webpack_require__(237);
	var message_childs_component_1 = __webpack_require__(239);
	var profile_component_2 = __webpack_require__(242);
	var profile_change_email_component_2 = __webpack_require__(245);
	var profile_change_email_password_component_2 = __webpack_require__(247);
	var profile_change_password_component_2 = __webpack_require__(249);
	var profile_change_subrole_component_2 = __webpack_require__(251);
	var profile_edit_component_2 = __webpack_require__(253);
	var messages_component_2 = __webpack_require__(256);
	var message_detail_component_2 = __webpack_require__(259);
	var favorites_component_2 = __webpack_require__(261);
	var start_component_1 = __webpack_require__(264);
	var verify_email_component_1 = __webpack_require__(270);
	var logout_component_1 = __webpack_require__(273);
	var profile_change_category_component_1 = __webpack_require__(276);
	var profile_change_category_component_2 = __webpack_require__(278);
	var transaction_return_component_1 = __webpack_require__(280);
	var profile_change_language_component_1 = __webpack_require__(284);
	var profile_change_language_component_2 = __webpack_require__(286);
	var auth_guard_service_1 = __webpack_require__(288);
	var auth_service_1 = __webpack_require__(289);
	var AppModule = (function () {
	    function AppModule() {
	    }
	    AppModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                platform_browser_1.BrowserModule,
	                forms_1.FormsModule,
	                http_1.HttpModule,
	                core_2.AgmCoreModule.forRoot({
	                    apiKey: 'AIzaSyB6uBpi9jOeko0WhohOXd5WKF2moHe2MGc'
	                }),
	                ng2_translate_1.TranslateModule.forRoot({
	                    provide: ng2_translate_1.TranslateLoader,
	                    useFactory: function (http) { return new ng2_translate_1.TranslateStaticLoader(http, '/assets/i18n', '.json'); },
	                    deps: [http_1.Http]
	                }),
	                router_1.RouterModule.forRoot([
	                    {
	                        path: 'login',
	                        component: login_component_1.LoginComponent
	                    },
	                    {
	                        path: 'register',
	                        component: register_component_1.RegisterComponent
	                    },
	                    {
	                        path: 'faq',
	                        component: faq_component_1.FaqComponent
	                    },
	                    {
	                        path: 'info',
	                        component: info_component_1.InfoComponent
	                    },
	                    {
	                        path: 'who',
	                        component: who_component_1.WhoComponent
	                    },
	                    {
	                        path: 'parada/:elementId',
	                        redirectTo: 'main/elementdetail/:elementId',
	                        pathMatch: 'full'
	                    },
	                    {
	                        path: 'main',
	                        component: main_component_1.MainComponent,
	                        children: [
	                            { path: 'dashboard', component: dashboard_component_2.MainDashboardComponent },
	                            { path: 'elementdetail/:elementId', component: element_detail_component_1.MainElementDetailComponent },
	                            { path: 'elementdetail', component: element_detail_component_1.MainElementDetailComponent },
	                            { path: 'messages', component: messages_component_2.MainMessagesComponent, canActivate: [auth_guard_service_1.AuthGuard] },
	                            { path: 'message', component: message_detail_component_2.MainMessageDetailComponent, canActivate: [auth_guard_service_1.AuthGuard] },
	                            { path: 'profile', component: profile_component_2.MainProfileComponent, canActivate: [auth_guard_service_1.AuthGuard] },
	                            { path: 'favorites', component: favorites_component_2.MainFavoritesComponent, canActivate: [auth_guard_service_1.AuthGuard] },
	                            { path: '', redirectTo: 'dashboard', pathMatch: 'full' }
	                        ]
	                    },
	                    {
	                        path: 'forum',
	                        component: forum_component_1.ForumComponent,
	                        children: [
	                            { path: 'dashboard', component: dashboard_component_3.ForumDashboardComponent },
	                            { path: 'topicdetail', component: topic_detail_component_1.ForumTopicDetailComponent },
	                            { path: '', redirectTo: 'dashboard', pathMatch: 'full' }
	                        ]
	                    },
	                    {
	                        path: 'superuser',
	                        component: super_user_component_1.SuperUserComponent,
	                        canActivate: [auth_guard_service_1.AuthGuard],
	                        children: [
	                            { path: 'start', component: start_component_1.SuperUserStartComponent },
	                            { path: 'dashboard', component: dashboard_component_1.SuperUserDashboardComponent },
	                            { path: 'messages', component: messages_component_1.SuperUserMessagesComponent },
	                            { path: 'message', component: message_detail_component_1.SuperUserMessageDetailComponent },
	                            { path: 'profile', component: profile_component_1.SuperUserProfileComponent },
	                            { path: 'notifications', component: notifications_component_1.SuperUserNotificationsComponent },
	                            { path: 'favorites', component: favorites_component_1.SuperUserFavoritesComponent },
	                            { path: 'logout', component: logout_component_1.SuperUserLogoutComponent },
	                            { path: 'transactionReturn/:transactionKey', component: transaction_return_component_1.SuperUserTransactionReturnComponent },
	                            { path: '', redirectTo: 'dashboard', pathMatch: 'full' }
	                        ]
	                    },
	                    {
	                        path: 'verifyemail/:emailKey',
	                        component: verify_email_component_1.SuperUserVerifyEmailComponent
	                    },
	                    {
	                        path: 'forgetPassword/:emailKey',
	                        component: change_password_component_1.MainChangePasswordComponent
	                    },
	                    {
	                        path: '',
	                        redirectTo: 'main',
	                        pathMatch: 'full'
	                    }
	                ], { useHash: true }),
	                ng2_completer_1.Ng2CompleterModule,
	            ],
	            declarations: [
	                app_component_1.AppComponent,
	                super_user_component_1.SuperUserComponent,
	                dashboard_component_1.SuperUserDashboardComponent,
	                messages_component_1.SuperUserMessagesComponent,
	                message_detail_component_1.SuperUserMessageDetailComponent,
	                profile_component_1.SuperUserProfileComponent,
	                profile_change_email_component_1.SuperUserProfileChangeEmailComponent,
	                profile_change_email_password_component_1.SuperUserProfileChangeEmailPasswordComponent,
	                profile_change_password_component_1.SuperUserProfileChangePasswordComponent,
	                profile_change_subrole_component_1.SuperUserProfileChangeSubroleComponent,
	                profile_edit_component_1.SuperUserProfileEditComponent,
	                notifications_component_1.SuperUserNotificationsComponent,
	                imageCropperComponent_1.ImageCropperComponent,
	                favorites_component_1.SuperUserFavoritesComponent,
	                main_component_1.MainComponent,
	                dashboard_component_2.MainDashboardComponent,
	                change_password_component_1.MainChangePasswordComponent,
	                cities_seeker_component_1.CitiesSeekerComponent,
	                tags_handler_component_1.TagsHandlerComponent,
	                element_detail_component_1.MainElementDetailComponent,
	                login_component_1.LoginComponent,
	                register_component_1.RegisterComponent,
	                faq_component_1.FaqComponent,
	                info_component_1.InfoComponent,
	                who_component_1.WhoComponent,
	                forum_component_1.ForumComponent,
	                dashboard_component_3.ForumDashboardComponent,
	                topic_detail_component_1.ForumTopicDetailComponent,
	                message_childs_component_1.ForumMessageChildsComponent,
	                profile_component_2.MainProfileComponent,
	                profile_change_email_component_2.MainProfileChangeEmailComponent,
	                profile_change_email_password_component_2.MainProfileChangeEmailPasswordComponent,
	                profile_change_password_component_2.MainProfileChangePasswordComponent,
	                profile_change_subrole_component_2.MainProfileChangeSubroleComponent,
	                profile_edit_component_2.MainProfileEditComponent,
	                messages_component_2.MainMessagesComponent,
	                message_detail_component_2.MainMessageDetailComponent,
	                favorites_component_2.MainFavoritesComponent,
	                start_component_1.SuperUserStartComponent,
	                verify_email_component_1.SuperUserVerifyEmailComponent,
	                logout_component_1.SuperUserLogoutComponent,
	                profile_change_category_component_1.SuperUserProfileChangeCategoryComponent,
	                profile_change_category_component_2.MainProfileChangeCategoryComponent,
	                transaction_return_component_1.SuperUserTransactionReturnComponent,
	                profile_change_language_component_1.MainProfileChangeLanguageComponent,
	                profile_change_language_component_2.SuperUserProfileChangeLanguageComponent
	            ],
	            bootstrap: [app_component_1.AppComponent],
	            providers: [
	                auth_guard_service_1.AuthGuard,
	                auth_service_1.AuthService
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AppModule);
	    return AppModule;
	}());
	exports.AppModule = AppModule;


/***/ },
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var ng2_translate_1 = __webpack_require__(29);
	__webpack_require__(56);
	var AppComponent = (function () {
	    function AppComponent(translate) {
	        console.log("APP COMPONENT");
	        var language = localStorage.getItem("language");
	        var hostname = location.host;
	        if (language != "" && language != "null" && language != "undefined" && language != null && language != undefined) {
	            translate.setDefaultLang(language);
	            translate.use(language);
	        }
	        else {
	            if (hostname == "www.mercatambulant.cat" || hostname == "mercatambulant.cat") {
	                translate.setDefaultLang('cat');
	                translate.use('cat');
	            }
	            else if (hostname == "www.mercadilloambulante.com" || hostname == "mercadilloambulante.com") {
	                translate.setDefaultLang('esp');
	                translate.use('esp');
	            }
	            else {
	                translate.setDefaultLang('esp');
	                translate.use('esp');
	                console.log(hostname);
	            }
	        }
	    }
	    AppComponent = __decorate([
	        core_1.Component({
	            selector: 'my-app',
	            template: __webpack_require__(60)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof ng2_translate_1.TranslateService !== 'undefined' && ng2_translate_1.TranslateService) === 'function' && _a) || Object])
	    ], AppComponent);
	    return AppComponent;
	    var _a;
	}());
	exports.AppComponent = AppComponent;


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(3), __webpack_require__(30), __webpack_require__(5), __webpack_require__(31), __webpack_require__(37), __webpack_require__(39), __webpack_require__(47), __webpack_require__(51), __webpack_require__(54));
		else if(typeof define === 'function' && define.amd)
			define(["@angular/core", "@angular/http", "rxjs/Observable", "rxjs/add/observable/of", "rxjs/add/operator/map", "rxjs/add/operator/merge", "rxjs/add/operator/share", "rxjs/add/operator/take", "rxjs/add/operator/toArray"], factory);
		else if(typeof exports === 'object')
			exports["ng2-translate"] = factory(require("@angular/core"), require("@angular/http"), require("rxjs/Observable"), require("rxjs/add/observable/of"), require("rxjs/add/operator/map"), require("rxjs/add/operator/merge"), require("rxjs/add/operator/share"), require("rxjs/add/operator/take"), require("rxjs/add/operator/toArray"));
		else
			root["ng2-translate"] = factory(root["@angular/core"], root["@angular/http"], root["rxjs/Observable"], root["rxjs/add/observable/of"], root["rxjs/add/operator/map"], root["rxjs/add/operator/merge"], root["rxjs/add/operator/share"], root["rxjs/add/operator/take"], root["rxjs/add/operator/toArray"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_8__, __WEBPACK_EXTERNAL_MODULE_9__, __WEBPACK_EXTERNAL_MODULE_10__, __WEBPACK_EXTERNAL_MODULE_11__, __WEBPACK_EXTERNAL_MODULE_12__, __WEBPACK_EXTERNAL_MODULE_13__, __WEBPACK_EXTERNAL_MODULE_14__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// identity function for calling harmory imports with the correct context
	/******/ 	__webpack_require__.i = function(value) { return value; };
	/******/
	/******/ 	// define getter function for harmory exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		Object.defineProperty(exports, name, {
	/******/ 			configurable: false,
	/******/ 			enumerable: true,
	/******/ 			get: getter
	/******/ 		});
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 15);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_0__;
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_observable_of__ = __webpack_require__(9);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_add_observable_of__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_share__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_share___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_share__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_add_operator_merge__ = __webpack_require__(11);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_add_operator_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_add_operator_merge__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_add_operator_toArray__ = __webpack_require__(14);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_add_operator_toArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_add_operator_toArray__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_add_operator_take__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_add_operator_take___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_add_operator_take__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__translate_parser__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(2);
	/* harmony export (binding) */ __webpack_require__.d(exports, "d", function() { return MissingTranslationHandler; });
	/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return TranslateLoader; });
	/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return TranslateStaticLoader; });
	/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return TranslateService; });
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	
	
	
	
	
	
	
	
	
	
	var MissingTranslationHandler = (function () {
	    function MissingTranslationHandler() {
	    }
	    return MissingTranslationHandler;
	}());
	var TranslateLoader = (function () {
	    function TranslateLoader() {
	    }
	    return TranslateLoader;
	}());
	var TranslateStaticLoader = (function () {
	    function TranslateStaticLoader(http, prefix, suffix) {
	        if (prefix === void 0) { prefix = "i18n"; }
	        if (suffix === void 0) { suffix = ".json"; }
	        this.http = http;
	        this.prefix = prefix;
	        this.suffix = suffix;
	    }
	    /**
	     * Gets the translations from the server
	     * @param lang
	     * @returns {any}
	     */
	    TranslateStaticLoader.prototype.getTranslation = function (lang) {
	        return this.http.get(this.prefix + "/" + lang + this.suffix)
	            .map(function (res) { return res.json(); });
	    };
	    return TranslateStaticLoader;
	}());
	var TranslateService = (function () {
	    /**
	     *
	     * @param currentLoader An instance of the loader currently used
	     * @param parser An instance of the parser currently used
	     * @param missingTranslationHandler A handler for missing translations.
	     */
	    function TranslateService(currentLoader, parser, missingTranslationHandler) {
	        this.currentLoader = currentLoader;
	        this.parser = parser;
	        this.missingTranslationHandler = missingTranslationHandler;
	        /**
	         * The lang currently used
	         */
	        this.currentLang = this.defaultLang;
	        /**
	         * An EventEmitter to listen to translation change events
	         * onTranslationChange.subscribe((params: TranslationChangeEvent) => {
	         *     // do something
	         * });
	         * @type {EventEmitter<TranslationChangeEvent>}
	         */
	        this.onTranslationChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        /**
	         * An EventEmitter to listen to lang change events
	         * onLangChange.subscribe((params: LangChangeEvent) => {
	         *     // do something
	         * });
	         * @type {EventEmitter<LangChangeEvent>}
	         */
	        this.onLangChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        /**
	         * An EventEmitter to listen to default lang change events
	         * onDefaultLangChange.subscribe((params: DefaultLangChangeEvent) => {
	         *     // do something
	         * });
	         * @type {EventEmitter<DefaultLangChangeEvent>}
	         */
	        this.onDefaultLangChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this.translations = {};
	        this.langs = [];
	    }
	    /**
	     * Sets the default language to use as a fallback
	     * @param lang
	     */
	    TranslateService.prototype.setDefaultLang = function (lang) {
	        var _this = this;
	        if (lang === this.defaultLang) {
	            return;
	        }
	        var pending = this.retrieveTranslations(lang);
	        if (typeof pending !== "undefined") {
	            // on init set the defaultLang immediately
	            if (!this.defaultLang) {
	                this.defaultLang = lang;
	            }
	            pending.take(1)
	                .subscribe(function (res) {
	                _this.changeDefaultLang(lang);
	            });
	        }
	        else {
	            this.changeDefaultLang(lang);
	        }
	    };
	    /**
	     * Gets the default language used
	     * @returns string
	     */
	    TranslateService.prototype.getDefaultLang = function () {
	        return this.defaultLang;
	    };
	    /**
	     * Changes the lang currently used
	     * @param lang
	     * @returns {Observable<*>}
	     */
	    TranslateService.prototype.use = function (lang) {
	        var _this = this;
	        var pending = this.retrieveTranslations(lang);
	        if (typeof pending !== "undefined") {
	            // on init set the currentLang immediately
	            if (!this.currentLang) {
	                this.currentLang = lang;
	            }
	            pending.take(1)
	                .subscribe(function (res) {
	                _this.changeLang(lang);
	            });
	            return pending;
	        }
	        else {
	            this.changeLang(lang);
	            return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(this.translations[lang]);
	        }
	    };
	    /**
	     * Retrieves the given translations
	     * @param lang
	     * @returns {Observable<*>}
	     */
	    TranslateService.prototype.retrieveTranslations = function (lang) {
	        var pending;
	        // if this language is unavailable, ask for it
	        if (typeof this.translations[lang] === "undefined") {
	            pending = this.getTranslation(lang);
	        }
	        return pending;
	    };
	    /**
	     * Gets an object of translations for a given language with the current loader
	     * @param lang
	     * @returns {Observable<*>}
	     */
	    TranslateService.prototype.getTranslation = function (lang) {
	        var _this = this;
	        this.pending = this.currentLoader.getTranslation(lang).share();
	        this.pending.take(1)
	            .subscribe(function (res) {
	            _this.translations[lang] = res;
	            _this.updateLangs();
	            _this.pending = undefined;
	        }, function (err) {
	            _this.pending = undefined;
	        });
	        return this.pending;
	    };
	    /**
	     * Manually sets an object of translations for a given language
	     * @param lang
	     * @param translations
	     * @param shouldMerge
	     */
	    TranslateService.prototype.setTranslation = function (lang, translations, shouldMerge) {
	        if (shouldMerge === void 0) { shouldMerge = false; }
	        if (shouldMerge && this.translations[lang]) {
	            Object.assign(this.translations[lang], translations);
	        }
	        else {
	            this.translations[lang] = translations;
	        }
	        this.updateLangs();
	        this.onTranslationChange.emit({ lang: lang, translations: this.translations[lang] });
	    };
	    /**
	     * Returns an array of currently available langs
	     * @returns {any}
	     */
	    TranslateService.prototype.getLangs = function () {
	        return this.langs;
	    };
	    /**
	     * @param langs
	     * Add available langs
	     */
	    TranslateService.prototype.addLangs = function (langs) {
	        var _this = this;
	        langs.forEach(function (lang) {
	            if (_this.langs.indexOf(lang) === -1) {
	                _this.langs.push(lang);
	            }
	        });
	    };
	    /**
	     * Update the list of available langs
	     */
	    TranslateService.prototype.updateLangs = function () {
	        this.addLangs(Object.keys(this.translations));
	    };
	    /**
	     * Returns the parsed result of the translations
	     * @param translations
	     * @param key
	     * @param interpolateParams
	     * @returns {any}
	     */
	    TranslateService.prototype.getParsedResult = function (translations, key, interpolateParams) {
	        var res;
	        if (key instanceof Array) {
	            var result = {}, observables = false;
	            for (var _i = 0, key_1 = key; _i < key_1.length; _i++) {
	                var k = key_1[_i];
	                result[k] = this.getParsedResult(translations, k, interpolateParams);
	                if (typeof result[k].subscribe === "function") {
	                    observables = true;
	                }
	            }
	            if (observables) {
	                var mergedObs = void 0;
	                for (var _a = 0, key_2 = key; _a < key_2.length; _a++) {
	                    var k = key_2[_a];
	                    var obs = typeof result[k].subscribe === "function" ? result[k] : __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(result[k]);
	                    if (typeof mergedObs === "undefined") {
	                        mergedObs = obs;
	                    }
	                    else {
	                        mergedObs = mergedObs.merge(obs);
	                    }
	                }
	                return mergedObs.toArray().map(function (arr) {
	                    var obj = {};
	                    arr.forEach(function (value, index) {
	                        obj[key[index]] = value;
	                    });
	                    return obj;
	                });
	            }
	            return result;
	        }
	        if (translations) {
	            res = this.parser.interpolate(this.parser.getValue(translations, key), interpolateParams);
	        }
	        if (typeof res === "undefined" && this.defaultLang && this.defaultLang !== this.currentLang) {
	            res = this.parser.interpolate(this.parser.getValue(this.translations[this.defaultLang], key), interpolateParams);
	        }
	        if (!res && this.missingTranslationHandler) {
	            var params = { key: key, translateService: this };
	            if (typeof interpolateParams !== 'undefined') {
	                params.interpolateParams = interpolateParams;
	            }
	            res = this.missingTranslationHandler.handle(params);
	        }
	        return typeof res !== "undefined" ? res : key;
	    };
	    /**
	     * Gets the translated value of a key (or an array of keys)
	     * @param key
	     * @param interpolateParams
	     * @returns {any} the translated key, or an object of translated keys
	     */
	    TranslateService.prototype.get = function (key, interpolateParams) {
	        var _this = this;
	        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util__["a" /* isDefined */])(key) || !key.length) {
	            throw new Error("Parameter \"key\" required");
	        }
	        // check if we are loading a new translation to use
	        if (this.pending) {
	            return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].create(function (observer) {
	                var onComplete = function (res) {
	                    observer.next(res);
	                    observer.complete();
	                };
	                var onError = function (err) {
	                    observer.error(err);
	                };
	                _this.pending.subscribe(function (res) {
	                    res = _this.getParsedResult(res, key, interpolateParams);
	                    if (typeof res.subscribe === "function") {
	                        res.subscribe(onComplete, onError);
	                    }
	                    else {
	                        onComplete(res);
	                    }
	                }, onError);
	            });
	        }
	        else {
	            var res = this.getParsedResult(this.translations[this.currentLang], key, interpolateParams);
	            if (typeof res.subscribe === "function") {
	                return res;
	            }
	            else {
	                return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(res);
	            }
	        }
	    };
	    /**
	     * Returns a translation instantly from the internal state of loaded translation.
	     * All rules regarding the current language, the preferred language of even fallback languages will be used except any promise handling.
	     * @param key
	     * @param interpolateParams
	     * @returns {string}
	     */
	    TranslateService.prototype.instant = function (key, interpolateParams) {
	        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util__["a" /* isDefined */])(key) || !key.length) {
	            throw new Error("Parameter \"key\" required");
	        }
	        var res = this.getParsedResult(this.translations[this.currentLang], key, interpolateParams);
	        if (typeof res.subscribe !== "undefined") {
	            if (key instanceof Array) {
	                var obj_1 = {};
	                key.forEach(function (value, index) {
	                    obj_1[key[index]] = key[index];
	                });
	                return obj_1;
	            }
	            return key;
	        }
	        else {
	            return res;
	        }
	    };
	    /**
	     * Sets the translated value of a key
	     * @param key
	     * @param value
	     * @param lang
	     */
	    TranslateService.prototype.set = function (key, value, lang) {
	        if (lang === void 0) { lang = this.currentLang; }
	        this.translations[lang][key] = value;
	        this.updateLangs();
	        this.onTranslationChange.emit({ lang: lang, translations: this.translations[lang] });
	    };
	    /**
	     * Changes the current lang
	     * @param lang
	     */
	    TranslateService.prototype.changeLang = function (lang) {
	        this.currentLang = lang;
	        this.onLangChange.emit({ lang: lang, translations: this.translations[lang] });
	        // if there is no default lang, use the one that we just set
	        if (!this.defaultLang) {
	            this.changeDefaultLang(lang);
	        }
	    };
	    /**
	     * Changes the default lang
	     * @param lang
	     */
	    TranslateService.prototype.changeDefaultLang = function (lang) {
	        this.defaultLang = lang;
	        this.onDefaultLangChange.emit({ lang: lang, translations: this.translations[lang] });
	    };
	    /**
	     * Allows to reload the lang file from the file
	     * @param lang
	     * @returns {Observable<any>}
	     */
	    TranslateService.prototype.reloadLang = function (lang) {
	        this.resetLang(lang);
	        return this.getTranslation(lang);
	    };
	    /**
	     * Deletes inner translation
	     * @param lang
	     */
	    TranslateService.prototype.resetLang = function (lang) {
	        this.translations[lang] = undefined;
	    };
	    /**
	     * Returns the language code name from the browser, e.g. "de"
	     *
	     * @returns string
	     */
	    TranslateService.prototype.getBrowserLang = function () {
	        if (typeof window === 'undefined' || typeof window.navigator === 'undefined') {
	            return undefined;
	        }
	        var browserLang = window.navigator.languages ? window.navigator.languages[0] : null;
	        browserLang = browserLang || window.navigator.language || window.navigator.browserLanguage || window.navigator.userLanguage;
	        if (browserLang.indexOf('-') !== -1) {
	            browserLang = browserLang.split('-')[0];
	        }
	        if (browserLang.indexOf('_') !== -1) {
	            browserLang = browserLang.split('_')[0];
	        }
	        return browserLang;
	    };
	    /**
	     * Returns the culture language code name from the browser, e.g. "de-DE"
	     *
	     * @returns string
	     */
	    TranslateService.prototype.getBrowserCultureLang = function () {
	        if (typeof window === 'undefined' || typeof window.navigator === 'undefined') {
	            return undefined;
	        }
	        var browserCultureLang = window.navigator.languages ? window.navigator.languages[0] : null;
	        browserCultureLang = browserCultureLang || window.navigator.language || window.navigator.browserLanguage || window.navigator.userLanguage;
	        return browserCultureLang;
	    };
	    TranslateService = __decorate([
	        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
	        __param(2, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"])()), 
	        __metadata('design:paramtypes', [TranslateLoader, __WEBPACK_IMPORTED_MODULE_8__translate_parser__["a" /* TranslateParser */], MissingTranslationHandler])
	    ], TranslateService);
	    return TranslateService;
	}());
	
	
	/***/ },
	/* 2 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ exports["b"] = equals;
	/* harmony export (immutable) */ exports["a"] = isDefined;
	/* tslint:disable */
	/**
	 * @name equals
	 *
	 * @description
	 * Determines if two objects or two values are equivalent.
	 *
	 * Two objects or values are considered equivalent if at least one of the following is true:
	 *
	 * * Both objects or values pass `===` comparison.
	 * * Both objects or values are of the same type and all of their properties are equal by
	 *   comparing them with `equals`.
	 *
	 * @param {*} o1 Object or value to compare.
	 * @param {*} o2 Object or value to compare.
	 * @returns {boolean} True if arguments are equal.
	 */
	function equals(o1, o2) {
	    if (o1 === o2)
	        return true;
	    if (o1 === null || o2 === null)
	        return false;
	    if (o1 !== o1 && o2 !== o2)
	        return true; // NaN === NaN
	    var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
	    if (t1 == t2 && t1 == 'object') {
	        if (Array.isArray(o1)) {
	            if (!Array.isArray(o2))
	                return false;
	            if ((length = o1.length) == o2.length) {
	                for (key = 0; key < length; key++) {
	                    if (!equals(o1[key], o2[key]))
	                        return false;
	                }
	                return true;
	            }
	        }
	        else {
	            if (Array.isArray(o2)) {
	                return false;
	            }
	            keySet = Object.create(null);
	            for (key in o1) {
	                if (!equals(o1[key], o2[key])) {
	                    return false;
	                }
	                keySet[key] = true;
	            }
	            for (key in o2) {
	                if (!(key in keySet) && typeof o2[key] !== 'undefined') {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	    return false;
	}
	/* tslint:enable */
	function isDefined(value) {
	    return typeof value !== 'undefined' && value !== null;
	}
	
	
	/***/ },
	/* 3 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(2);
	/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return TranslateParser; });
	/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return DefaultTranslateParser; });
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	var TranslateParser = (function () {
	    function TranslateParser() {
	    }
	    return TranslateParser;
	}());
	var DefaultTranslateParser = (function (_super) {
	    __extends(DefaultTranslateParser, _super);
	    function DefaultTranslateParser() {
	        _super.apply(this, arguments);
	        this.templateMatcher = /{{\s?([^{}\s]*)\s?}}/g;
	    }
	    DefaultTranslateParser.prototype.interpolate = function (expr, params) {
	        var _this = this;
	        if (typeof expr !== 'string' || !params) {
	            return expr;
	        }
	        return expr.replace(this.templateMatcher, function (substring, b) {
	            var r = _this.getValue(params, b);
	            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* isDefined */])(r) ? r : substring;
	        });
	    };
	    DefaultTranslateParser.prototype.getValue = function (target, key) {
	        var keys = key.split('.');
	        key = '';
	        do {
	            key += keys.shift();
	            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* isDefined */])(target) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* isDefined */])(target[key]) && (typeof target[key] === 'object' || !keys.length)) {
	                target = target[key];
	                key = '';
	            }
	            else if (!keys.length) {
	                target = undefined;
	            }
	            else {
	                key += '.';
	            }
	        } while (keys.length);
	        return target;
	    };
	    DefaultTranslateParser = __decorate([
	        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(), 
	        __metadata('design:paramtypes', [])
	    ], DefaultTranslateParser);
	    return DefaultTranslateParser;
	}(TranslateParser));
	
	
	/***/ },
	/* 4 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translate_service__ = __webpack_require__(1);
	/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return TranslateDirective; });
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	
	var TranslateDirective = (function () {
	    function TranslateDirective(translateService, element) {
	        var _this = this;
	        this.translateService = translateService;
	        this.element = element;
	        // subscribe to onTranslationChange event, in case the translations of the current lang change
	        if (!this.onTranslationChangeSub) {
	            this.onTranslationChangeSub = this.translateService.onTranslationChange.subscribe(function (event) {
	                if (event.lang === _this.translateService.currentLang) {
	                    _this.checkNodes(true, event.translations);
	                }
	            });
	        }
	        // subscribe to onLangChange event, in case the language changes
	        if (!this.onLangChangeSub) {
	            this.onLangChangeSub = this.translateService.onLangChange.subscribe(function (event) {
	                _this.checkNodes(true, event.translations);
	            });
	        }
	        // subscribe to onDefaultLangChange event, in case the default language changes
	        if (!this.onDefaultLangChangeSub) {
	            this.onDefaultLangChangeSub = this.translateService.onDefaultLangChange.subscribe(function (event) {
	                _this.checkNodes(true);
	            });
	        }
	    }
	    Object.defineProperty(TranslateDirective.prototype, "translate", {
	        set: function (key) {
	            if (key) {
	                this.key = key;
	                this.checkNodes();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TranslateDirective.prototype.ngAfterViewChecked = function () {
	        this.checkNodes();
	    };
	    TranslateDirective.prototype.checkNodes = function (forceUpdate, translations) {
	        if (forceUpdate === void 0) { forceUpdate = false; }
	        var nodes = this.element.nativeElement.childNodes;
	        for (var i = 0; i < nodes.length; ++i) {
	            var node = nodes[i];
	            if (node.nodeType === 3) {
	                var key = void 0;
	                if (this.key) {
	                    key = this.key;
	                }
	                else {
	                    var content = node.textContent.trim();
	                    if (content.length) {
	                        // we want to use the content as a key, not the translation value
	                        if (content !== node.currentValue) {
	                            key = content;
	                            // the content was changed from the user, we'll use it as a reference if needed
	                            node.originalContent = node.textContent;
	                        }
	                        else if (node.originalContent && forceUpdate) {
	                            node.lastKey = null;
	                            // the current content is the translation, not the key, use the last real content as key
	                            key = node.originalContent.trim();
	                        }
	                    }
	                }
	                this.updateValue(key, node, translations);
	            }
	        }
	    };
	    TranslateDirective.prototype.updateValue = function (key, node, translations) {
	        var _this = this;
	        if (key) {
	            var interpolateParams = this.translateParams;
	            if (node.lastKey === key && this.lastParams === interpolateParams) {
	                return;
	            }
	            this.lastParams = interpolateParams;
	            var onTranslation = function (res) {
	                if (res !== key) {
	                    node.lastKey = key;
	                }
	                if (!node.originalContent) {
	                    node.originalContent = node.textContent;
	                }
	                node.currentValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* isDefined */])(res) ? res : (node.originalContent || key);
	                // we replace in the original content to preserve spaces that we might have trimmed
	                node.textContent = _this.key ? node.currentValue : node.originalContent.replace(key, node.currentValue);
	            };
	            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* isDefined */])(translations)) {
	                var res = this.translateService.getParsedResult(translations, key, interpolateParams);
	                if (typeof res.subscribe === "function") {
	                    res.subscribe(onTranslation);
	                }
	                else {
	                    onTranslation(res);
	                }
	            }
	            else {
	                this.translateService.get(key, interpolateParams).subscribe(onTranslation);
	            }
	        }
	    };
	    TranslateDirective.prototype.ngOnDestroy = function () {
	        if (this.onLangChangeSub) {
	            this.onLangChangeSub.unsubscribe();
	        }
	        if (this.onDefaultLangChangeSub) {
	            this.onDefaultLangChangeSub.unsubscribe();
	        }
	        if (this.onTranslationChangeSub) {
	            this.onTranslationChangeSub.unsubscribe();
	        }
	    };
	    __decorate([
	        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(), 
	        __metadata('design:type', String), 
	        __metadata('design:paramtypes', [String])
	    ], TranslateDirective.prototype, "translate", null);
	    __decorate([
	        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(), 
	        __metadata('design:type', Object)
	    ], TranslateDirective.prototype, "translateParams", void 0);
	    TranslateDirective = __decorate([
	        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"])({
	            selector: '[translate],[ng2-translate]'
	        }), 
	        __metadata('design:paramtypes', [__WEBPACK_IMPORTED_MODULE_2__translate_service__["a" /* TranslateService */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]])
	    ], TranslateDirective);
	    return TranslateDirective;
	}());
	
	
	/***/ },
	/* 5 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translate_service__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(2);
	/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return TranslatePipe; });
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	
	var TranslatePipe = (function () {
	    function TranslatePipe(translate, _ref) {
	        this.translate = translate;
	        this._ref = _ref;
	        this.value = '';
	    }
	    TranslatePipe.prototype.updateValue = function (key, interpolateParams, translations) {
	        var _this = this;
	        var onTranslation = function (res) {
	            _this.value = res !== undefined ? res : key;
	            _this.lastKey = key;
	            _this._ref.markForCheck();
	        };
	        if (translations) {
	            var res = this.translate.getParsedResult(translations, key, interpolateParams);
	            if (typeof res.subscribe === 'function') {
	                res.subscribe(onTranslation);
	            }
	            else {
	                onTranslation(res);
	            }
	        }
	        this.translate.get(key, interpolateParams).subscribe(onTranslation);
	    };
	    TranslatePipe.prototype.transform = function (query) {
	        var _this = this;
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        if (!query || query.length === 0) {
	            return query;
	        }
	        // if we ask another time for the same key, return the last value
	        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* equals */])(query, this.lastKey) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* equals */])(args, this.lastParams)) {
	            return this.value;
	        }
	        var interpolateParams;
	        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* isDefined */])(args[0]) && args.length) {
	            if (typeof args[0] === 'string' && args[0].length) {
	                // we accept objects written in the template such as {n:1}, {'n':1}, {n:'v'}
	                // which is why we might need to change it to real JSON objects such as {"n":1} or {"n":"v"}
	                var validArgs = args[0]
	                    .replace(/(\')?([a-zA-Z0-9_]+)(\')?(\s)?:/g, '"$2":')
	                    .replace(/:(\s)?(\')(.*?)(\')/g, ':"$3"');
	                try {
	                    interpolateParams = JSON.parse(validArgs);
	                }
	                catch (e) {
	                    throw new SyntaxError("Wrong parameter in TranslatePipe. Expected a valid Object, received: " + args[0]);
	                }
	            }
	            else if (typeof args[0] === 'object' && !Array.isArray(args[0])) {
	                interpolateParams = args[0];
	            }
	        }
	        // store the query, in case it changes
	        this.lastKey = query;
	        // store the params, in case they change
	        this.lastParams = args;
	        // set the value
	        this.updateValue(query, interpolateParams);
	        // if there is a subscription to onLangChange, clean it
	        this._dispose();
	        // subscribe to onTranslationChange event, in case the translations change
	        if (!this.onTranslationChange) {
	            this.onTranslationChange = this.translate.onTranslationChange.subscribe(function (event) {
	                if (_this.lastKey && event.lang === _this.translate.currentLang) {
	                    _this.lastKey = null;
	                    _this.updateValue(query, interpolateParams, event.translations);
	                }
	            });
	        }
	        // subscribe to onLangChange event, in case the language changes
	        if (!this.onLangChange) {
	            this.onLangChange = this.translate.onLangChange.subscribe(function (event) {
	                if (_this.lastKey) {
	                    _this.lastKey = null; // we want to make sure it doesn't return the same value until it's been updated
	                    _this.updateValue(query, interpolateParams, event.translations);
	                }
	            });
	        }
	        // subscribe to onDefaultLangChange event, in case the default language changes
	        if (!this.onDefaultLangChange) {
	            this.onDefaultLangChange = this.translate.onDefaultLangChange.subscribe(function () {
	                if (_this.lastKey) {
	                    _this.lastKey = null; // we want to make sure it doesn't return the same value until it's been updated
	                    _this.updateValue(query, interpolateParams);
	                }
	            });
	        }
	        return this.value;
	    };
	    /**
	     * Clean any existing subscription to change events
	     * @private
	     */
	    TranslatePipe.prototype._dispose = function () {
	        if (typeof this.onTranslationChange !== 'undefined') {
	            this.onTranslationChange.unsubscribe();
	            this.onTranslationChange = undefined;
	        }
	        if (typeof this.onLangChange !== 'undefined') {
	            this.onLangChange.unsubscribe();
	            this.onLangChange = undefined;
	        }
	        if (typeof this.onDefaultLangChange !== 'undefined') {
	            this.onDefaultLangChange.unsubscribe();
	            this.onDefaultLangChange = undefined;
	        }
	    };
	    TranslatePipe.prototype.ngOnDestroy = function () {
	        this._dispose();
	    };
	    TranslatePipe = __decorate([
	        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
	        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"])({
	            name: 'translate',
	            pure: false // required to update the value when the promise is resolved
	        }), 
	        __metadata('design:paramtypes', [__WEBPACK_IMPORTED_MODULE_1__translate_service__["a" /* TranslateService */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"]])
	    ], TranslatePipe);
	    return TranslatePipe;
	}());
	
	
	/***/ },
	/* 6 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_http__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_http___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angular_http__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_translate_pipe__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_translate_parser__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_translate_service__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_translate_directive__ = __webpack_require__(4);
	/* harmony export (immutable) */ exports["a"] = translateLoaderFactory;
	/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return TranslateModule; });
	/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__src_translate_pipe__["a"]; });
	/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__src_translate_service__["d"]; });
	/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__src_translate_service__["c"]; });
	/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "f", function() { return __WEBPACK_IMPORTED_MODULE_4__src_translate_service__["b"]; });
	/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "g", function() { return __WEBPACK_IMPORTED_MODULE_4__src_translate_service__["a"]; });
	/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "h", function() { return __WEBPACK_IMPORTED_MODULE_3__src_translate_parser__["a"]; });
	/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "i", function() { return __WEBPACK_IMPORTED_MODULE_3__src_translate_parser__["b"]; });
	/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "j", function() { return __WEBPACK_IMPORTED_MODULE_5__src_translate_directive__["a"]; });
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	
	
	
	
	
	
	
	
	function translateLoaderFactory(http) {
	    return new __WEBPACK_IMPORTED_MODULE_4__src_translate_service__["b" /* TranslateStaticLoader */](http);
	}
	var TranslateModule = (function () {
	    function TranslateModule() {
	    }
	    TranslateModule.forRoot = function (providedLoader) {
	        if (providedLoader === void 0) { providedLoader = {
	            provide: __WEBPACK_IMPORTED_MODULE_4__src_translate_service__["c" /* TranslateLoader */],
	            useFactory: translateLoaderFactory,
	            deps: [__WEBPACK_IMPORTED_MODULE_1__angular_http__["Http"]]
	        }; }
	        return {
	            ngModule: TranslateModule,
	            providers: [
	                providedLoader,
	                __WEBPACK_IMPORTED_MODULE_4__src_translate_service__["a" /* TranslateService */],
	                { provide: __WEBPACK_IMPORTED_MODULE_3__src_translate_parser__["a" /* TranslateParser */], useClass: __WEBPACK_IMPORTED_MODULE_3__src_translate_parser__["b" /* DefaultTranslateParser */] }
	            ]
	        };
	    };
	    TranslateModule = __decorate([
	        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"])({
	            imports: [__WEBPACK_IMPORTED_MODULE_1__angular_http__["HttpModule"]],
	            declarations: [
	                __WEBPACK_IMPORTED_MODULE_2__src_translate_pipe__["a" /* TranslatePipe */],
	                __WEBPACK_IMPORTED_MODULE_5__src_translate_directive__["a" /* TranslateDirective */]
	            ],
	            exports: [
	                __WEBPACK_IMPORTED_MODULE_1__angular_http__["HttpModule"],
	                __WEBPACK_IMPORTED_MODULE_2__src_translate_pipe__["a" /* TranslatePipe */],
	                __WEBPACK_IMPORTED_MODULE_5__src_translate_directive__["a" /* TranslateDirective */]
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], TranslateModule);
	    return TranslateModule;
	}());
	
	
	/***/ },
	/* 7 */
	/***/ function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_7__;
	
	/***/ },
	/* 8 */
	/***/ function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_8__;
	
	/***/ },
	/* 9 */
	/***/ function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_9__;
	
	/***/ },
	/* 10 */
	/***/ function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_10__;
	
	/***/ },
	/* 11 */
	/***/ function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_11__;
	
	/***/ },
	/* 12 */
	/***/ function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_12__;
	
	/***/ },
	/* 13 */
	/***/ function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_13__;
	
	/***/ },
	/* 14 */
	/***/ function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_14__;
	
	/***/ },
	/* 15 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(6);
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "translateLoaderFactory", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["a"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "TranslateModule", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["b"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "TranslatePipe", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["c"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "MissingTranslationHandler", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["d"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "TranslateLoader", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["e"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "TranslateStaticLoader", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["f"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "TranslateService", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["g"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "TranslateParser", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["h"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "DefaultTranslateParser", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["i"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "TranslateDirective", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["j"]; });
	
	
	
	/***/ }
	/******/ ]);
	});
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ function(module, exports) {

	module.exports = "<router-outlet></router-outlet>\n";

/***/ },
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(76);
	var super_user_service_1 = __webpack_require__(94);
	var SuperUserComponent = (function () {
	    function SuperUserComponent(_parentRouter, _superUserService) {
	        this._superUserService = _superUserService;
	        this.isCollapsed = true;
	        this.nNotifications = 0;
	        this.router = _parentRouter;
	    }
	    SuperUserComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.notificationsToggle = false;
	        this._superUserService.getNotifications().then(function (notifications) { _this.notifications = notifications; console.log(notifications); _this.nNotifications = notifications.length; });
	    };
	    SuperUserComponent.prototype.toggleNotifications = function () {
	        if (this.isCollapsed) {
	            this.notificationsToggle = !this.notificationsToggle;
	        }
	        else {
	            this.router.navigate(['/superuser', 'notifications', { notificationId: 0 }]);
	            this.isCollapsed = true;
	        }
	    };
	    SuperUserComponent.prototype.handleClick = function (event) {
	        if (this.notificationsToggle && event.srcElement.id != "notification-pop")
	            this.notificationsToggle = false;
	    };
	    SuperUserComponent.prototype.collapse = function () {
	        this.isCollapsed = true;
	    };
	    SuperUserComponent = __decorate([
	        core_1.Component({
	            selector: 'superuser',
	            template: __webpack_require__(96),
	            host: {
	                '(document:click)': 'handleClick($event)',
	            },
	            providers: [super_user_service_1.SuperUserService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _a) || Object, (typeof (_b = typeof super_user_service_1.SuperUserService !== 'undefined' && super_user_service_1.SuperUserService) === 'function' && _b) || Object])
	    ], SuperUserComponent);
	    return SuperUserComponent;
	    var _a, _b;
	}());
	exports.SuperUserComponent = SuperUserComponent;


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(30);
	var Observable_1 = __webpack_require__(5);
	var json = __webpack_require__(95);
	var SuperUserService = (function () {
	    function SuperUserService(http) {
	        this.http = http;
	        this._notificationsUrl = '/notificationData/actives';
	        this.serverURL = json.api_url;
	    }
	    SuperUserService.prototype.getNotifications = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.get(this.serverURL + this._notificationsUrl, options)
	            .toPromise()
	            .then(function (res) { return JSON.parse(res.text()).rows; }, this.handleError);
	    };
	    SuperUserService.prototype.extractData = function (res) {
	        var body = res.json();
	        return body.data || {};
	    };
	    SuperUserService.prototype.handleError = function (error) {
	        // In a real world app, we might use a remote logging infrastructure
	        // We'd also dig deeper into the error to get a better message
	        var errMsg = (error.message) ? error.message :
	            error.status ? error.status + " - " + error.statusText : 'Server error';
	        console.error(errMsg); // log to console instead
	        return Observable_1.Observable.throw(errMsg);
	    };
	    SuperUserService.prototype.serializeObj = function (obj) {
	        var result = [];
	        for (var property in obj)
	            result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));
	        return result.join("&");
	    };
	    SuperUserService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], SuperUserService);
	    return SuperUserService;
	    var _a;
	}());
	exports.SuperUserService = SuperUserService;


/***/ },
/* 95 */
/***/ function(module, exports) {

	module.exports = {
		"api_url": "https://api.mveva.com"
	};

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<nav class=\"navbar navbar-inverse navbar-fixed-top navbar-blue\">\n    <div class=\"container-fluid\">\n        <div class=\"navbar-header\">\n            <button type=\"button\" class=\"navbar-toggle collapsed\" data-toggle=\"collapse\" (click)=\"isCollapsed=!isCollapsed;\" data-target=\"#navbar\"\n                aria-expanded=\"false\" aria-controls=\"navbar\">\n                <span class=\"sr-only\">Toggle navigation</span>\n                <span class=\"icon-bar\"></span>\n                <span class=\"icon-bar\"></span>\n                <span class=\"icon-bar\"></span>\n            </button>\n            <a class=\"navbar-brand\" [routerLink]=\"['/main', 'dashboard']\"><img style=\"height: 2.7em; width: auto; margin-top: -0.7em;\" class=\"logo\" src=\"" + __webpack_require__(97) + "\" /></a>\n\n        </div>\n        <div id=\"navbar\" class=\"navbar-collapse collapse\" [ngClass]=\"{in: !isCollapsed}\">\n            <ul id=\"notification-pop\" class=\"nav navbar-nav\">\n                <li id=\"notification-pop\" *ngIf=\"nNotifications>0\">\n                    <a id=\"notification-pop\" style=\"padding-bottom: 0px;\" (click)=\"toggleNotifications()\">\n                        <span id=\"notification-pop\" class=\"glyphicon glyphicon-globe white big-glyphicon clickable\" style=\"font-size: 1.6em;\">\n                            <label id=\"notification-pop\" class=\"notifications-number clickable\">{{nNotifications}}</label>\n                        </span>\n                        <span id=\"notification-pop\" *ngIf=\"!isCollapsed\" style=\"color: white; font-size: 1em;\" class=\"clickable\">  {{ 'NOTIFICATIONS' | translate }}</span>\n                    </a>\n                </li>\n            </ul>\n            <ul class=\"nav navbar-nav navbar-right\">\n                <li><a (click)=\"collapse()\" [routerLink]=\"['/superuser', 'dashboard']\"><span class=\"glyphicon glyphicon-home white big-glyphicon\"></span><span *ngIf=\"!isCollapsed\" style=\"color: white;\">  {{ 'HOME' | translate }}</span></a></li>\n                <li><a (click)=\"collapse()\" [routerLink]=\"['/superuser', 'profile']\"><span class=\"glyphicon glyphicon-user white big-glyphicon\"></span><span *ngIf=\"!isCollapsed\" style=\"color: white;\">  {{ 'PROFILE' | translate }}</span></a></li>\n                <li><a (click)=\"collapse()\" [routerLink]=\"['/superuser', 'messages']\"><span class=\"glyphicon glyphicon-envelope white big-glyphicon\"></span><span *ngIf=\"!isCollapsed\" style=\"color: white;\">  {{ 'MESSAGES' | translate }}</span></a></li>\n                <li><a (click)=\"collapse()\" [routerLink]=\"['/superuser', 'favorites']\"><span class=\"glyphicon glyphicon-heart white big-glyphicon\"></span><span *ngIf=\"!isCollapsed\" style=\"color: white;\">  {{ 'FAVORITES' | translate }}</span></a></li>\n                <li><a (click)=\"collapse()\" [routerLink]=\"['/superuser', 'logout']\"><span class=\"glyphicon glyphicon-off white big-glyphicon\"></span><span *ngIf=\"!isCollapsed\" style=\"color: white;\">  {{ 'LOGOUT' | translate }}</span></a></li>\n            </ul>\n            <!--<form class=\"navbar-form navbar-right\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"Search...\">\n            </form>-->\n            <!--<h1>{{title}}</h1>-->\n            <h1>{{isLogged}}</h1>\n        </div>\n    </div>\n</nav>\n\n<div class=\"container-fluid\">\n    <div class=\"row\">\n        <router-outlet></router-outlet>\n    </div>\n</div>\n\n<div id=\"notification-pop\" class=\"notifications-pop\" *ngIf=\"notificationsToggle\">\n    <div id=\"notification-pop\" *ngFor=\"let not of notifications\" class=\"notification-pop\">\n        <a [routerLink]=\"['/superuser', 'notifications',  {notificationId:not.id}]\" class=\"no-link\" (click)=\"toggleNotifications()\">\n            <div id=\"notification-pop\" class=\"notification-text-pop clickable\">{{not.short_text}}</div>\n        </a>\n        <div id=\"notification-pop\" class=\"notification-bar-pop\"><div id=\"notification-pop\"></div></div>\n    </div>\n    <a [routerLink]=\"['/superuser', 'notifications', {notificationId:0}]\" class=\"no-link\" (click)=\"toggleNotifications()\">\n        <div id=\"notification-pop\" class=\"notifications-show-all-pop\">\n            {{ 'SHOW_ALL' | translate }} ({{nNotifications}})\n        </div>\n    </a>\n</div>";

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/inverted-logo.4213a004c930906c9b801e4db41c127d.png";

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var imageCropperComponent_1 = __webpack_require__(99);
	var cropperSettings_1 = __webpack_require__(106);
	var ng2_completer_1 = __webpack_require__(61);
	var dashboard_service_1 = __webpack_require__(114);
	var images_service_1 = __webpack_require__(115);
	var day_information_service_1 = __webpack_require__(116);
	var geolocation_service_1 = __webpack_require__(117);
	var tags_service_1 = __webpack_require__(118);
	var cities_1 = __webpack_require__(119);
	var router_1 = __webpack_require__(76);
	var SuperUserDashboardComponent = (function (_super) {
	    __extends(SuperUserDashboardComponent, _super);
	    function SuperUserDashboardComponent(_parentRouter, _dashboardService, _completerService, _imagesService, _dayInformationService, _geolocationService, _tagsService) {
	        _super.call(this);
	        this._dashboardService = _dashboardService;
	        this._completerService = _completerService;
	        this._imagesService = _imagesService;
	        this._dayInformationService = _dayInformationService;
	        this._geolocationService = _geolocationService;
	        this._tagsService = _tagsService;
	        this.photos = [];
	        this.dayInformation = [];
	        this.dayInformationRecived = [];
	        this.tags = [];
	        this.tagsHaveNot = [];
	        this.modalTags = [];
	        this.days = [
	            { id: 1, name: "MONDAY" },
	            { id: 2, name: "TUESDAY" },
	            { id: 3, name: "WEDNESDAY" },
	            { id: 4, name: "THURSDAY" },
	            { id: 5, name: "FRIDAY" },
	            { id: 6, name: "SATURDAY" },
	            { id: 7, name: "SUNDAY" }
	        ];
	        this.dataService = _completerService.local(cities_1.CITIES, 'name', 'name');
	        this.myLatitude = 0;
	        this.myLongitude = 0;
	        this.classMapModal = { 'model': true, 'show': false, 'hide': true };
	        this.classTagsModal = { 'model': true, 'show': false, 'hide': true };
	        this.addingPhoto = false;
	        this.code = 0;
	        this.uploadProgress = 0;
	        this.selected = 0;
	        this.overMain = false;
	        this.cropperSettings1 = new cropperSettings_1.CropperSettings();
	        this.cropperSettings1.width = 320;
	        this.cropperSettings1.height = 400;
	        this.cropperSettings1.croppedWidth = 320;
	        this.cropperSettings1.croppedHeight = 400;
	        this.cropperSettings1.canvasWidth = 440;
	        this.cropperSettings1.canvasHeight = 450;
	        this.cropperSettings1.minWidth = 320;
	        this.cropperSettings1.minHeight = 400;
	        this.cropperSettings1.rounded = false;
	        this.cropperSettings1.fileInputName = "addImage";
	        this.cropperSettings1.cropperDrawSettings.strokeWidth = 1;
	        this.cropperSettings1.cropperDrawSettings.strokeColor = "rgb(44, 44, 44)";
	        this.cropperSettings2 = new cropperSettings_1.CropperSettings();
	        this.cropperSettings2.width = 405;
	        this.cropperSettings2.height = 270;
	        this.cropperSettings2.croppedWidth = 405;
	        this.cropperSettings2.croppedHeight = 270;
	        this.cropperSettings2.canvasWidth = 500;
	        this.cropperSettings2.canvasHeight = 334;
	        this.cropperSettings2.minWidth = 405;
	        this.cropperSettings2.minHeight = 270;
	        this.cropperSettings2.cropperDrawSettings.strokeWidth = 1;
	        this.cropperSettings2.cropperDrawSettings.strokeColor = "rgb(44, 44, 44)";
	        this.editName = 0;
	        this.editDescription = 0;
	        this.cropperSettings2.rounded = false;
	        this.cropperSettings2.fileInputName = "profileImage";
	        this.data1 = {};
	        this.data2 = {};
	        this.imageDelete = -1;
	        this.imageSelected = "";
	        this.selectedDay = -1;
	        this.marker = {
	            lat: 0,
	            lng: 0,
	            label: 'A',
	            draggable: true
	        };
	        this.cityNotFound = false;
	        this.cityNotIntroduced = false;
	        this.lastDaySaved = false;
	        this.lastDay = { 'city': null, 'name': "", 'information': "", 'latitude': "", 'longitude': "" };
	        this.tagHover = -1;
	        this.tagsModalFilter = "";
	        this.tagsHaveNot = [];
	        this.modalTags = [];
	        this.user = { 'email': "", 'id': 0, 'name': "", 'nif': "", 'phone': "", 'subrole': 0 };
	        this.tagsSelectedsOnMOdal = 0;
	        this.reachedLimitTags = false;
	        this.reachedLimitTagsOnModal = false;
	        this.editWeb = false;
	        this.editFacebook = false;
	        this.facebook_errorCode = 0;
	        this.web_errorCode = 0;
	    }
	    SuperUserDashboardComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        var that = this;
	        this.photos_number = 0;
	        this._dashboardService.getElement().then(function (element) {
	            _this.element = element;
	            _this.photos = element.photos;
	            _this.dayInformationRecived = element.dayInformation;
	            _this.mountDayInformation(element.dayInformation);
	            _this.photos_number = _this.photos.length;
	            if (_this.element.web_site == null || _this.element.web_site == undefined || _this.element.web_site == "null" || _this.element.web_site == "undefined") {
	                _this.element.web_site = "";
	            }
	            if (_this.element.facebook_site == null || _this.element.facebook_site == undefined || _this.element.facebook_site == "null" || _this.element.facebook_site == "undefined") {
	                _this.element.facebook_site = "";
	            }
	            else {
	                _this.element.facebook_site = _this.validateFacebookSite(_this.element.facebook_site);
	            }
	        });
	        this._dashboardService.getProfile().then(function (user) {
	            _this.user = user.row[0];
	            _this.subrole = _this.user.subrole;
	            if (_this.user.subrole == 1 || _this.user.subrole == 3) {
	                _this.limitTags = -1;
	                _this.limitPhotos = 100;
	            }
	            else if (_this.user.subrole == 2 || _this.user.subrole == 4) {
	                _this.limitTags = 30;
	                _this.limitPhotos = 50;
	            }
	            else {
	                _this.limitTags = 5;
	                _this.limitPhotos = 4;
	            }
	        });
	        this._geolocationService.getLocation().subscribe(function (position) {
	            that.myLatitude = position.coords.latitude;
	            that.myLongitude = position.coords.longitude;
	        });
	        this._tagsService.getTagsOfElement().then(function (tagsRecived) {
	            _this.tags = tagsRecived;
	        });
	    };
	    SuperUserDashboardComponent.prototype.cropped = function (result) {
	        if (result.save == 1) {
	            if (this.checkMaxPhotos()) {
	                this.psdUploadHandler(result.image, false, true, result.price);
	            }
	        }
	    };
	    SuperUserDashboardComponent.prototype.addTag = function (event) {
	        var _this = this;
	        this.reachedLimitTagsOnModal = false;
	        if (this.limitTags == -1 || this.limitTags > this.tags.length) {
	            this.reachedLimitTags = false;
	            this.tagsSelectedsOnMOdal = 0;
	            this._tagsService.getTagsThatElementHaveNot().then(function (tags) {
	                for (var i = 0; i < tags.length; i++) {
	                    tags[i].selected = false;
	                }
	                _this.tagsHaveNot = tags;
	                _this.modalTags = tags;
	            });
	            this.classTagsModal.show = true;
	            this.classTagsModal.hide = false;
	        }
	        else {
	            this.reachedLimitTags = true;
	        }
	    };
	    SuperUserDashboardComponent.prototype.selectTag = function (tag) {
	        this.reachedLimitTagsOnModal = false;
	        if (!tag.selected) {
	            if (this.limitTags == -1 || this.limitTags > this.tags.length + this.tagsSelectedsOnMOdal) {
	                tag.selected = true;
	                this.tagsSelectedsOnMOdal++;
	            }
	            else {
	                this.reachedLimitTagsOnModal = true;
	            }
	        }
	        else {
	            tag.selected = false;
	            this.tagsSelectedsOnMOdal--;
	        }
	    };
	    SuperUserDashboardComponent.prototype.getColor = function (tag) {
	        if (tag.selected) {
	            return "#97D685";
	        }
	        else {
	            return "LightSteelBlue";
	        }
	    };
	    SuperUserDashboardComponent.prototype.isTagSelected = function (tag) {
	        if (tag.selected) {
	            return true;
	        }
	        else {
	            return false;
	        }
	    };
	    SuperUserDashboardComponent.prototype.cropped2 = function (result) {
	        if (result.save == 1) {
	            this.psdUploadHandler(result.image, true, true, -1);
	        }
	    };
	    SuperUserDashboardComponent.prototype.mountDayInformation = function (dayInfo) {
	        var o = 0;
	        for (var i = 0; i < this.days.length; i++) {
	            if (dayInfo[o] !== undefined && this.days[i].id == dayInfo[o].id) {
	                this.dayInformation.push(dayInfo[o]);
	                o++;
	            }
	            else {
	                this.dayInformation.push({
	                    city: 0,
	                    element_id: this.element,
	                    id: i + 1,
	                    information: "",
	                    latitude: "",
	                    longitude: "",
	                    name: ""
	                });
	            }
	        }
	    };
	    SuperUserDashboardComponent.prototype.addPhoto = function () {
	        this.addingPhoto = true;
	    };
	    SuperUserDashboardComponent.prototype.onFileAddedMain = function (event) {
	        var files = event.srcElement.files;
	        var re = /(?:\.([^.]+))?$/;
	        var ext = re.exec(event.srcElement.files[0].name)[1];
	        if (ext != "jpg" && ext != "png" && ext != "jpeg") {
	            this.code = 121;
	        }
	        else if (event.srcElement.files[0].size > 2000000) {
	            this.code = 122;
	        }
	        else {
	            this.code = 120;
	            this.psdUploadHandler(event.srcElement.files[0], true, false, -1);
	        }
	    };
	    SuperUserDashboardComponent.prototype.onFileAdded = function (event) {
	        var files = event.srcElement.files;
	        var re = /(?:\.([^.]+))?$/;
	        var ext = re.exec(event.srcElement.files[0].name)[1];
	        if (ext != "jpg" && ext != "png" && ext != "jpeg") {
	            this.code = 21;
	        }
	        else if (event.srcElement.files[0].size > 2000000) {
	            this.code = 22;
	        }
	        else if (this.photos_number >= 10) {
	            this.code = 23;
	        }
	        else {
	            this.code = 20;
	            this.psdUploadHandler(event.srcElement.files[0], false, false, -1);
	        }
	    };
	    SuperUserDashboardComponent.prototype.checkMaxPhotos = function () {
	        if (this.photos_number >= this.limitPhotos) {
	            this.code = 23;
	            return false;
	        }
	        return true;
	    };
	    SuperUserDashboardComponent.prototype.psdUploadHandler = function (file, mainImage, encodedImage, price) {
	        var _this = this;
	        var result;
	        this._imagesService.getObserver()
	            .subscribe(function (progress) {
	            _this.uploadProgress = progress;
	        });
	        try {
	            if (encodedImage) {
	                if (!mainImage) {
	                    result = this._imagesService.uploadEncoded(file, price).then(function (data) {
	                        _this._imagesService.getImages(_this.element.id).then(function (photos) { _this.photos = photos; _this.photos_number = photos.length; });
	                    });
	                }
	                else {
	                    result = this._imagesService.uploadEncodedMain(file).then(function (data) { _this._imagesService.getImageMain(_this.element.id).then(function (data) { _this.element.mainImage = data.mainImage; }); });
	                }
	            }
	            else {
	                if (mainImage) {
	                    result = this._imagesService.uploadMain(file).then(function (data) { _this._imagesService.getImageMain(_this.element.id).then(function (data) { _this.element.mainImage = data.mainImage; }); });
	                }
	                else {
	                    result = this._imagesService.upload(file).then(function (data) { _this._imagesService.getImages(_this.element.id).then(function (photos) { _this.photos = photos; _this.photos_number = photos.length; }); });
	                }
	            }
	        }
	        catch (error) {
	            document.write(error);
	        }
	    };
	    SuperUserDashboardComponent.prototype.over = function (id) {
	        this.selected = id;
	    };
	    SuperUserDashboardComponent.prototype.overMainF = function () {
	        this.overMain = true;
	    };
	    SuperUserDashboardComponent.prototype.outMain = function () {
	        this.overMain = false;
	    };
	    SuperUserDashboardComponent.prototype.out = function (id) {
	        if (this.selected == id) {
	            this.selected = 0;
	        }
	    };
	    SuperUserDashboardComponent.prototype.selectImage = function (id) {
	        this.imageDelete = -1;
	        for (var i = 0; i < this.photos.length; i++) {
	            if (this.photos[i].id == id)
	                this.imageSelected = this.photos[i].url;
	        }
	        this.classMapModal.show = true;
	        this.classMapModal.hide = false;
	    };
	    SuperUserDashboardComponent.prototype.deleteImage = function (id) {
	        this.imageDelete = id;
	        for (var i = 0; i < this.photos.length; i++) {
	            if (this.photos[i].id == id)
	                this.imageSelected = this.photos[i].url;
	        }
	        this.classMapModal.show = true;
	        this.classMapModal.hide = false;
	    };
	    SuperUserDashboardComponent.prototype.deleteConfirm = function () {
	        var _this = this;
	        this._imagesService.deleteImage(this.imageDelete).subscribe(function (data) { _this.imageDelete = 0; _this._imagesService.getImages(_this.element.id).then(function (photos) { _this.photos = photos; _this.photos_number = photos.length; }); });
	        this.classMapModal.show = false;
	        this.classMapModal.hide = true;
	    };
	    SuperUserDashboardComponent.prototype.clickedMarker = function (label, index) {
	        console.log("clicked the marker: " + (label || index));
	    };
	    SuperUserDashboardComponent.prototype.editNameF = function () {
	        if (this.editName == 0)
	            this.editName = 1;
	        if (this.editName == 2)
	            this.editName = 0;
	    };
	    SuperUserDashboardComponent.prototype.postName = function (isKey) {
	        this._dashboardService.postName(this.element.comercial_name);
	        if (isKey)
	            this.editName = 0;
	        else
	            this.editName = 2;
	    };
	    SuperUserDashboardComponent.prototype.editDescriptionF = function () {
	        if (this.editDescription == 0)
	            this.editDescription = 1;
	        if (this.editDescription == 2)
	            this.editDescription = 0;
	    };
	    SuperUserDashboardComponent.prototype.postDescription = function () {
	        this._dashboardService.postDescription(this.element.description);
	        this.editDescription = 2;
	    };
	    SuperUserDashboardComponent.prototype.saveTagsModal = function () {
	        var _this = this;
	        var selectedTags = [];
	        for (var i = 0; i < this.modalTags.length; i++) {
	            if (this.modalTags[i].selected) {
	                selectedTags.push(this.modalTags[i]);
	            }
	        }
	        this._tagsService.addTags(selectedTags).then(function (result) {
	            console.log(result);
	            if (result == "1") {
	                _this.closeTagsModal();
	                _this._tagsService.getTagsOfElement().then(function (tags) {
	                    for (var i = 0; i < tags.length; i++) {
	                        tags[i].selected = false;
	                    }
	                    _this.tags = tags;
	                });
	            }
	        });
	    };
	    SuperUserDashboardComponent.prototype.closeModal = function () {
	        this.classMapModal.show = false;
	        this.classMapModal.hide = true;
	    };
	    SuperUserDashboardComponent.prototype.closeTagsModal = function () {
	        for (var i = 0; i < this.tags.length; i++) {
	            this.tags[i].selected = false;
	        }
	        this.tagsModalFilter = "";
	        this.classTagsModal.show = false;
	        this.classTagsModal.hide = true;
	    };
	    SuperUserDashboardComponent.prototype.editDay = function (id) {
	        if (!this.lastDaySaved && this.selectedDay != -1) {
	            this.dayInformation[this.selectedDay - 1].name = this.lastDay.name;
	            this.dayInformation[this.selectedDay - 1].city = this.lastDay.city;
	            this.dayInformation[this.selectedDay - 1].latitude = this.lastDay.latitude;
	            this.dayInformation[this.selectedDay - 1].longitude = this.lastDay.longitude;
	            this.dayInformation[this.selectedDay - 1].information = this.lastDay.information;
	            this.cityNotFound = false;
	            this.cityNotIntroduced = false;
	        }
	        this.lastDaySaved = false;
	        if (this.selectedDay == id) {
	            this.selectedDay = -1;
	        }
	        else {
	            this.selectedDay = id;
	            this.lastDay.city = this.dayInformation[this.selectedDay - 1].city;
	            this.lastDay.name = this.dayInformation[this.selectedDay - 1].name;
	            this.lastDay.latitude = this.dayInformation[this.selectedDay - 1].latitude;
	            this.lastDay.longitude = this.dayInformation[this.selectedDay - 1].longitude;
	            this.lastDay.information = this.dayInformation[this.selectedDay - 1].information;
	            console.log(this.dayInformation[this.selectedDay - 1]);
	            if (this.dayInformation[this.selectedDay - 1].latitude == "") {
	                console.log("null marker0");
	                this.marker =
	                    {
	                        lat: 0,
	                        lng: 0,
	                        draggable: true
	                    };
	            }
	            else {
	                console.log("marker " + this.dayInformation[this.selectedDay - 1].latitude + " " + this.dayInformation[this.selectedDay - 1].longitude);
	                this.marker =
	                    {
	                        lat: Number(this.dayInformation[this.selectedDay - 1].latitude),
	                        lng: Number(this.dayInformation[this.selectedDay - 1].longitude),
	                        draggable: true
	                    };
	                console.log("marker " + this.marker.lat + " " + this.marker.lng);
	            }
	            if ((this.marker.lat == 0 && this.marker.lng == 0) && (this.myLatitude != 0 && this.myLongitude != 0)) {
	                this.marker.lat = this.myLatitude;
	                this.marker.lng = this.myLongitude;
	                this.dayInformation[this.selectedDay - 1].latitude = "" + this.myLatitude;
	                this.dayInformation[this.selectedDay - 1].longitude = "" + this.myLongitude;
	            }
	        }
	    };
	    SuperUserDashboardComponent.prototype.isEditDay = function (id) {
	        return id == this.selectedDay;
	    };
	    SuperUserDashboardComponent.prototype.mapClicked = function ($event) {
	        this.marker.lat = $event.coords.lat;
	        this.marker.lng = $event.coords.lng;
	        this.dayInformation[this.selectedDay - 1].latitude = "" + $event.coords.lat;
	        this.dayInformation[this.selectedDay - 1].longitude = "" + $event.coords.lng;
	    };
	    SuperUserDashboardComponent.prototype.onCitySelected = function ($event) {
	        console.log($event);
	        //this.dayInformation[this.selectedDay - 1].city = $event.originalObject.id;
	    };
	    SuperUserDashboardComponent.prototype.postDayInformation = function (day) {
	        var _this = this;
	        var editDay = false;
	        if (day.name.length > 0) {
	            var cities = cities_1.CITIES.filter(function (city) { return city.name.toLowerCase() == day.name.toLowerCase(); });
	            if (cities.length != 0 && cities[0] !== undefined && cities[0] !== null) {
	                console.log(day);
	                day.name = cities[0].name;
	                day.city = cities[0].id;
	                editDay = true;
	                this.cityNotFound = false;
	            }
	            else {
	                this.cityNotFound = true;
	                editDay = false;
	            }
	            this.cityNotIntroduced = false;
	        }
	        else {
	            this.cityNotIntroduced = true;
	            this.cityNotFound = false;
	            editDay = false;
	        }
	        console.log(day);
	        if (editDay) {
	            this.lastDaySaved = true;
	            console.log(this.dayInformation[this.selectedDay - 1]);
	            this._dayInformationService.editDayInformation(this.dayInformation[this.selectedDay - 1]).then(function (data) {
	                console.log(data.code);
	                if (data.code == "1") {
	                    console.log("HOLA");
	                }
	                console.log(_this.dayInformation[_this.selectedDay - 1]);
	            });
	            this.dayInformation[this.selectedDay - 1].city = day.city;
	            this.dayInformation[this.selectedDay - 1].name = day.name;
	            this.dayInformation[this.selectedDay - 1].information = day.information;
	            this.dayInformation[this.selectedDay - 1].latitude = day.latitude;
	            this.dayInformation[this.selectedDay - 1].longitude = day.longitude;
	            this.selectedDay = -1;
	        }
	    };
	    SuperUserDashboardComponent.prototype.deleteDayInformation = function (day) {
	        var _this = this;
	        this.cityNotFound = false;
	        this.cityNotIntroduced = false;
	        day.name = null;
	        day.city = null;
	        day.latitude = null;
	        day.longitude = null;
	        day.information = null;
	        this.lastDaySaved = true;
	        this._dayInformationService.editDayInformation(this.dayInformation[this.selectedDay - 1]).then(function (data) {
	            console.log(data);
	            _this.marker.lat = 0;
	            _this.marker.lng = 0;
	            _this.selectedDay = -1;
	        });
	    };
	    SuperUserDashboardComponent.prototype.ubicateCity = function (day) {
	        var _this = this;
	        var ubicateCity = false;
	        if (day.name.length > 0) {
	            var cities = cities_1.CITIES.filter(function (city) { return city.name.toLowerCase() == day.name.toLowerCase(); });
	            if (cities.length != 0 && cities[0] !== undefined && cities[0] !== null) {
	                day.name = cities[0].name;
	                day.city = cities[0].id;
	                ubicateCity = true;
	                this.cityNotFound = false;
	            }
	            else {
	                this.cityNotFound = true;
	                ubicateCity = false;
	            }
	            this.cityNotIntroduced = false;
	        }
	        else {
	            this.cityNotIntroduced = true;
	            this.cityNotFound = false;
	            ubicateCity = false;
	        }
	        if (ubicateCity) {
	            this._dayInformationService.getDayLocation(this.dayInformation[this.selectedDay - 1]).then(function (res) {
	                _this.marker.lat = res['latitude'];
	                _this.marker.lng = res['longitude'];
	                day.latitude = res['latitude'];
	                day.longitude = res['longitude'];
	                _this.dayInformation[_this.selectedDay - 1].latitude = "" + res['latitude'];
	                _this.dayInformation[_this.selectedDay - 1].longitude = "" + res['longitude'];
	            });
	        }
	    };
	    SuperUserDashboardComponent.prototype.tagsModalFilterChanged = function () {
	        if (this.tagsModalFilter != null && this.tagsModalFilter != undefined && this.tagsModalFilter != "") {
	            this.modalTags = [];
	            for (var i = 0; i < this.tagsHaveNot.length; i++) {
	                var tagName = this.toUpperCaseReplacingAccents(this.tagsHaveNot[i].name);
	                var filterText = this.toUpperCaseReplacingAccents(this.tagsModalFilter);
	                if (tagName.indexOf(filterText) !== -1) {
	                    this.modalTags.push(this.tagsHaveNot[i]);
	                }
	            }
	        }
	        else {
	            this.modalTags = this.tagsHaveNot;
	        }
	    };
	    SuperUserDashboardComponent.prototype.toUpperCaseReplacingAccents = function (text) {
	        var mapObj = {
	            Á: "A",
	            À: "A",
	            Ä: "A",
	            É: "E",
	            È: "E",
	            Ë: "E",
	            Í: "I",
	            Ì: "I",
	            Ï: "I",
	            Ó: "O",
	            Ò: "O",
	            Ö: "O",
	            Ú: "U",
	            Ù: "U",
	            Ü: "U"
	        };
	        var trim = text.toUpperCase();
	        trim = trim.replace(/Á|À|Ä|É|È|Ë|Í|Ì|Ï|Ó|Ò|Ö|Ú|Ù|Ü/g, function (char) {
	            return mapObj[char];
	        });
	        return trim;
	    };
	    SuperUserDashboardComponent.prototype.mouseOverTag = function (id) {
	        this.tagHover = id;
	    };
	    SuperUserDashboardComponent.prototype.mouseLeaveTag = function () {
	        this.tagHover = -1;
	    };
	    SuperUserDashboardComponent.prototype.overTag = function (id) {
	        return this.tagHover == id || this.selectedTag == id;
	    };
	    SuperUserDashboardComponent.prototype.deleteTag = function (id) {
	        var _this = this;
	        console.log("DELETE TAG " + id);
	        this._tagsService.deleteTag(id).then(function (res) {
	            if (Number(res) == 1) {
	                _this._tagsService.getTagsOfElement().then(function (tags) {
	                    for (var i = 0; i < tags.length; i++) {
	                        tags[i].selected = false;
	                    }
	                    _this.tags = tags;
	                });
	            }
	        });
	    };
	    SuperUserDashboardComponent.prototype.selectTagMain = function (id) {
	        this.selectedTag = id;
	    };
	    SuperUserDashboardComponent.prototype.editImagePrice = function (image) {
	        image.edit = false;
	        this._imagesService.editPrice(image.id, image.price);
	    };
	    SuperUserDashboardComponent.prototype.editImagePriceKey = function (event, image) {
	        if (event.keyCode == 13) {
	            this.editImagePrice(image);
	        }
	    };
	    SuperUserDashboardComponent.prototype.editWebSite = function () {
	        if (this.editWeb) {
	            this.web_errorCode = 0;
	            this.editWeb = false;
	        }
	        else {
	            this.editWeb = true;
	        }
	    };
	    SuperUserDashboardComponent.prototype.editFacebookSite = function () {
	        if (this.editFacebook) {
	            this.facebook_errorCode = 0;
	            this.editFacebook = false;
	        }
	        else {
	            this.editFacebook = true;
	        }
	    };
	    SuperUserDashboardComponent.prototype.saveWebSite = function (web) {
	        if (web == "") {
	            this.web_errorCode = 1;
	        }
	        else {
	            this._dashboardService.editWebSite(web);
	            this.element.web_site = web;
	            this.editWeb = false;
	            this.web_errorCode = 0;
	        }
	    };
	    SuperUserDashboardComponent.prototype.saveFacebookSite = function (facebook) {
	        if (facebook == "") {
	            this.facebook_errorCode = 1;
	        }
	        else {
	            if (facebook.indexOf("www.facebook.com") == -1 && facebook.indexOf("www.facebook.es") == -1) {
	                console.log("hola");
	                console.log(facebook);
	                if (facebook.indexOf("/") == 0) {
	                    console.log("ie");
	                    var facebookUrl = "www.facebook.com" + facebook;
	                    console.log(facebookUrl);
	                }
	                else {
	                    console.log("ia");
	                    var facebookUrl = "www.facebook.com/" + facebook;
	                    console.log(facebookUrl);
	                }
	                console.log(facebookUrl);
	            }
	            else {
	                var facebookUrl = facebook;
	            }
	            console.log(facebookUrl);
	            this._dashboardService.editFacebookSite(facebookUrl);
	            this.element.facebook_site = this.validateFacebookSite(facebook);
	            this.editFacebook = false;
	            this.facebook_errorCode = 0;
	        }
	    };
	    SuperUserDashboardComponent.prototype.validateFacebookSite = function (facebook) {
	        if (facebook.indexOf("www.facebook.com") >= 0 || facebook.indexOf("www.facebook.es") >= 0) {
	            var urlParams = facebook.split("/");
	            var facebookUrl = "/";
	            for (var i = 1; i < urlParams.length; i++) {
	                facebookUrl += urlParams[i];
	                if (i != urlParams.length - 1) {
	                    facebookUrl += "/";
	                }
	            }
	            return facebookUrl;
	        }
	        else {
	            if (facebook.indexOf("/") != 0) {
	                return "/" + facebook;
	            }
	            else {
	                return facebook;
	            }
	        }
	    };
	    __decorate([
	        core_1.ViewChild('cropper', undefined), 
	        __metadata('design:type', (typeof (_a = typeof imageCropperComponent_1.ImageCropperComponent !== 'undefined' && imageCropperComponent_1.ImageCropperComponent) === 'function' && _a) || Object)
	    ], SuperUserDashboardComponent.prototype, "cropper", void 0);
	    __decorate([
	        core_1.ViewChild('cropper_main', undefined), 
	        __metadata('design:type', (typeof (_b = typeof imageCropperComponent_1.ImageCropperComponent !== 'undefined' && imageCropperComponent_1.ImageCropperComponent) === 'function' && _b) || Object)
	    ], SuperUserDashboardComponent.prototype, "cropper2", void 0);
	    SuperUserDashboardComponent = __decorate([
	        core_1.Component({
	            selector: 'dashboard',
	            template: __webpack_require__(120),
	            providers: [dashboard_service_1.DashboardService, images_service_1.ImagesService, ng2_completer_1.CompleterService, day_information_service_1.DayInformationService, geolocation_service_1.GeolocationService, tags_service_1.TagsService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof dashboard_service_1.DashboardService !== 'undefined' && dashboard_service_1.DashboardService) === 'function' && _d) || Object, (typeof (_e = typeof ng2_completer_1.CompleterService !== 'undefined' && ng2_completer_1.CompleterService) === 'function' && _e) || Object, (typeof (_f = typeof images_service_1.ImagesService !== 'undefined' && images_service_1.ImagesService) === 'function' && _f) || Object, (typeof (_g = typeof day_information_service_1.DayInformationService !== 'undefined' && day_information_service_1.DayInformationService) === 'function' && _g) || Object, (typeof (_h = typeof geolocation_service_1.GeolocationService !== 'undefined' && geolocation_service_1.GeolocationService) === 'function' && _h) || Object, (typeof (_j = typeof tags_service_1.TagsService !== 'undefined' && tags_service_1.TagsService) === 'function' && _j) || Object])
	    ], SuperUserDashboardComponent);
	    return SuperUserDashboardComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
	}(core_1.Type));
	exports.SuperUserDashboardComponent = SuperUserDashboardComponent;


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var imageCropper_1 = __webpack_require__(100);
	var cropperSettings_1 = __webpack_require__(106);
	var exif_1 = __webpack_require__(112);
	var cropPosition_1 = __webpack_require__(113);
	var ImageCropperComponent = (function () {
	    function ImageCropperComponent(renderer) {
	        this.cropPositionChange = new core_1.EventEmitter();
	        this.onCrop = new core_1.EventEmitter();
	        this.renderer = renderer;
	        this.classMapModal = { 'model': true, 'show': false, 'hide': true };
	        this.file = null;
	    }
	    ImageCropperComponent.prototype.closeModal = function () {
	        this.classMapModal.show = false;
	        this.classMapModal.hide = true;
	        this.classMapModal = { 'model': true, 'show': false, 'hide': true };
	        this.file = null;
	    };
	    ImageCropperComponent.prototype.saveModel = function () {
	        this.classMapModal.show = false;
	        this.classMapModal.hide = true;
	        this.onCrop.emit({ "save": 1, "bounds": this.cropper.getCropBounds(), "image": this.image, "price": this.priceModel });
	    };
	    ImageCropperComponent.prototype.ngAfterViewInit = function () {
	        var _this = this;
	        var canvas = this.cropcanvas.nativeElement;
	        if (!this.settings) {
	            this.settings = new cropperSettings_1.CropperSettings();
	        }
	        this.renderer.setElementAttribute(canvas, "class", this.settings.cropperClass);
	        if (!this.settings.dynamicSizing) {
	            this.renderer.setElementAttribute(canvas, "width", this.settings.canvasWidth.toString());
	            this.renderer.setElementAttribute(canvas, "height", this.settings.canvasHeight.toString());
	        }
	        else {
	            window.addEventListener('resize', function () {
	                _this.settings.canvasWidth = canvas.offsetWidth;
	                _this.settings.canvasHeight = canvas.offsetHeight;
	                _this.cropper.resizeCanvas(canvas.offsetWidth, canvas.offsetHeight, true);
	            });
	        }
	        if (!this.cropper) {
	            this.cropper = new imageCropper_1.ImageCropper(this.settings);
	        }
	        if (!this.productMode) {
	            this.productMode = false;
	        }
	        this.cropper.prepare(canvas);
	    };
	    ImageCropperComponent.prototype.ngOnChanges = function (changes) {
	        if (this.isCropPositionChanged(changes)) {
	            this.cropper.updateCropPosition(this.cropPosition.toBounds());
	            if (this.cropper.isImageSet()) {
	                var bounds = this.cropper.getCropBounds();
	                this.image.image = this.cropper.getCroppedImage().src;
	                this.onCrop.emit(bounds);
	            }
	            this.updateCropBounds();
	        }
	    };
	    ImageCropperComponent.prototype.onTouchMove = function (event) {
	        this.cropper.onTouchMove(event);
	    };
	    ImageCropperComponent.prototype.onTouchStart = function (event) {
	        this.cropper.onTouchStart(event);
	    };
	    ImageCropperComponent.prototype.onTouchEnd = function (event) {
	        this.cropper.onTouchEnd(event);
	        if (this.cropper.isImageSet()) {
	            this.image.image = this.cropper.getCroppedImage().src;
	            this.onCrop.emit(this.cropper.getCropBounds());
	            this.updateCropBounds();
	        }
	    };
	    ImageCropperComponent.prototype.onMouseDown = function (event) {
	        this.cropper.onMouseDown(event);
	    };
	    ImageCropperComponent.prototype.onMouseUp = function (event) {
	        if (this.cropper.isImageSet()) {
	            this.cropper.onMouseUp(event);
	            this.image.image = this.cropper.getCroppedImage().src;
	            this.onCrop.emit(this.cropper.getCropBounds());
	            this.updateCropBounds();
	        }
	    };
	    ImageCropperComponent.prototype.onMouseMove = function (event) {
	        this.cropper.onMouseMove(event);
	    };
	    ImageCropperComponent.prototype.onMouseOut = function (event) {
	        this.cropper.onMouseUp(event);
	        this.image.image = this.cropper.getCroppedImage().src;
	        this.onCrop.emit(this.cropper.getCropBounds());
	    };
	    ImageCropperComponent.prototype.fileChangeListener = function ($event) {
	        var file = $event.target.files[0];
	        if (this.settings.allowedFilesRegex.test(file.name)) {
	            var image_1 = new Image();
	            var fileReader = new FileReader();
	            var that_1 = this;
	            this.classMapModal.show = true;
	            this.classMapModal.hide = false;
	            fileReader.addEventListener("loadend", function (loadEvent) {
	                image_1.src = loadEvent.target.result;
	                that_1.setImage(image_1);
	            });
	            fileReader.readAsDataURL(file);
	        }
	    };
	    ImageCropperComponent.prototype.reset = function () {
	        this.cropper.reset();
	        this.renderer.setElementAttribute(this.cropcanvas.nativeElement, "class", this.settings.cropperClass);
	        this.image.image = this.cropper.getCroppedImage().src;
	    };
	    ImageCropperComponent.prototype.setImage = function (image, newBounds) {
	        var _this = this;
	        if (newBounds === void 0) { newBounds = null; }
	        var self = this;
	        this.renderer.setElementAttribute(this.cropcanvas.nativeElement, "class", this.settings.cropperClass + " " + this.settings.croppingClass);
	        this.intervalRef = window.setInterval(function () {
	            if (self.intervalRef) {
	                clearInterval(self.intervalRef);
	            }
	            if (image.naturalHeight > 0 && image.naturalWidth > 0) {
	                image.height = image.naturalHeight;
	                image.width = image.naturalWidth;
	                clearInterval(self.intervalRef);
	                self.getOrientedImage(image, function (img) {
	                    if (_this.settings.dynamicSizing) {
	                        var canvas = _this.cropcanvas.nativeElement;
	                        _this.settings.canvasWidth = canvas.offsetWidth;
	                        _this.settings.canvasHeight = canvas.offsetHeight;
	                        _this.cropper.resizeCanvas(canvas.offsetWidth, canvas.offsetHeight, false);
	                    }
	                    self.cropper.setImage(img);
	                    if (self.cropPosition && self.cropPosition.isInitialized()) {
	                        self.cropper.updateCropPosition(self.cropPosition.toBounds());
	                    }
	                    self.image.original = img;
	                    var bounds = self.cropper.getCropBounds();
	                    self.image.image = self.cropper.getCroppedImage().src;
	                    if (newBounds != null) {
	                        bounds = newBounds;
	                        self.cropper.setBounds(bounds);
	                    }
	                    self.onCrop.emit(bounds);
	                });
	            }
	        }, 10);
	    };
	    ImageCropperComponent.prototype.isCropPositionChanged = function (changes) {
	        if (this.cropper && changes["cropPosition"] && this.isCropPositionUpdateNeeded) {
	            return true;
	        }
	        else {
	            this.isCropPositionUpdateNeeded = true;
	            return false;
	        }
	    };
	    ImageCropperComponent.prototype.updateCropBounds = function () {
	        var cropBound = this.cropper.getCropBounds();
	        this.cropPositionChange.emit(new cropPosition_1.CropPosition(cropBound.left, cropBound.top, cropBound.width, cropBound.height));
	        this.isCropPositionUpdateNeeded = false;
	    };
	    ImageCropperComponent.prototype.getOrientedImage = function (image, callback) {
	        var img;
	        exif_1.Exif.getData(image, function () {
	            var orientation = exif_1.Exif.getTag(image, "Orientation");
	            if ([3, 6, 8].indexOf(orientation) > -1) {
	                var canvas = document.createElement("canvas"), ctx = canvas.getContext("2d"), cw = image.width, ch = image.height, cx = 0, cy = 0, deg = 0;
	                switch (orientation) {
	                    case 3:
	                        cx = -image.width;
	                        cy = -image.height;
	                        deg = 180;
	                        break;
	                    case 6:
	                        cw = image.height;
	                        ch = image.width;
	                        cy = -image.height;
	                        deg = 90;
	                        break;
	                    case 8:
	                        cw = image.height;
	                        ch = image.width;
	                        cx = -image.width;
	                        deg = 270;
	                        break;
	                    default:
	                        break;
	                }
	                canvas.width = cw;
	                canvas.height = ch;
	                ctx.rotate(deg * Math.PI / 180);
	                ctx.drawImage(image, cx, cy);
	                img = document.createElement("img");
	                img.width = cw;
	                img.height = ch;
	                img.addEventListener('load', function () {
	                    callback(img);
	                });
	                img.src = canvas.toDataURL("image/png");
	            }
	            else {
	                img = image;
	                callback(img);
	            }
	        });
	    };
	    __decorate([
	        core_1.ViewChild("cropcanvas", undefined), 
	        __metadata('design:type', (typeof (_a = typeof core_1.ElementRef !== 'undefined' && core_1.ElementRef) === 'function' && _a) || Object)
	    ], ImageCropperComponent.prototype, "cropcanvas", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_b = typeof cropperSettings_1.CropperSettings !== 'undefined' && cropperSettings_1.CropperSettings) === 'function' && _b) || Object)
	    ], ImageCropperComponent.prototype, "settings", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], ImageCropperComponent.prototype, "image", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_c = typeof imageCropper_1.ImageCropper !== 'undefined' && imageCropper_1.ImageCropper) === 'function' && _c) || Object)
	    ], ImageCropperComponent.prototype, "cropper", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_d = typeof cropPosition_1.CropPosition !== 'undefined' && cropPosition_1.CropPosition) === 'function' && _d) || Object)
	    ], ImageCropperComponent.prototype, "cropPosition", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], ImageCropperComponent.prototype, "productMode", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', (typeof (_e = typeof core_1.EventEmitter !== 'undefined' && core_1.EventEmitter) === 'function' && _e) || Object)
	    ], ImageCropperComponent.prototype, "cropPositionChange", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', (typeof (_f = typeof core_1.EventEmitter !== 'undefined' && core_1.EventEmitter) === 'function' && _f) || Object)
	    ], ImageCropperComponent.prototype, "onCrop", void 0);
	    ImageCropperComponent = __decorate([
	        core_1.Component({
	            selector: "img-cropper",
	            template: "\n        <span class=\"ng2-imgcrop\">\n            <input *ngIf=\"!settings.noFileInput\" style=\"display: none;\" type=\"file\" name=\"{{settings.fileInputName}}\" id=\"{{settings.fileInputName}}\" (change)=\"fileChangeListener($event)\" accept=\"image/*\" />\n            <div [ngClass]=\"classMapModal\" role=\"dialog\">\n                <div class=\"modal-dialog\">\n                    <!-- Modal content-->\n                    <div class=\"modal-content\" style=\"max-height: 100%;\">\n                        <div class=\"modal-header\">\n                            <button type=\"button\" class=\"close\" (click)=\"closeModal()\">&times;</button>\n                            <h4 class=\"modal-title\">{{modalTitle}}</h4>\n                        </div>\n                        <div class=\"modal-body\">\n                            <div style=\"text-align: center; max-height: 65%;\">\n                                <canvas #cropcanvas                            \n                                    on-mouseout=\"onMouseOut($event)\"\n                                    (mousedown)=\"onMouseDown($event)\"\n                                    (mouseup)=\"onMouseUp($event)\"\n                                    (mousemove)=\"onMouseMove($event)\"\n                                    (touchmove)=\"onTouchMove($event)\"\n                                    (touchend)=\"onTouchEnd($event)\"\n                                    (touchstart)=\"onTouchStart($event)\">\n                                </canvas>\n\n                            </div>\n                            <div *ngIf=\"productMode\" style=\"text-align: center; padding-top: 0.5em; padding-bottom: 0.5em; background-color: white; position: relative;\">\n                                <label style=\"font-size: 1.3em; padding-right: 1em; color: #333333;\">{{ 'PRICE' | translate }} {{ 'COIN_TYPE' | translate }}</label>\n                                <input style=\"padding-left: 1em; width: 7em;\" type='text' value='' [(ngModel)]=\"priceModel\"/>\n                            </div>\n                        </div>\n                        <div class=\"modal-footer\">\n                            <button type=\"button\" class=\"btn\" (click)=\"closeModal()\">{{ 'CLOSE' | translate }}</button>\n                            <button type=\"button\" class=\"btn btn-default\" (click)=\"saveModel()\">{{ 'SAVE' | translate }}</button>\n                        </div>\n                    </div>\n                </div>\n            </div>  \n        </span>\n      "
	        }), 
	        __metadata('design:paramtypes', [(typeof (_g = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _g) || Object])
	    ], ImageCropperComponent);
	    return ImageCropperComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.ImageCropperComponent = ImageCropperComponent;


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var bounds_1 = __webpack_require__(101);
	var cornerMarker_1 = __webpack_require__(104);
	var cropTouch_1 = __webpack_require__(108);
	var dragMarker_1 = __webpack_require__(109);
	var imageCropperModel_1 = __webpack_require__(110);
	var imageCropperDataShare_1 = __webpack_require__(111);
	var pointPool_1 = __webpack_require__(102);
	var ImageCropper = (function (_super) {
	    __extends(ImageCropper, _super);
	    function ImageCropper(cropperSettings) {
	        _super.call(this);
	        var x = 0;
	        var y = 0;
	        var width = cropperSettings.width;
	        var height = cropperSettings.height;
	        var keepAspect = cropperSettings.keepAspect;
	        var touchRadius = cropperSettings.touchRadius;
	        var minWidth = cropperSettings.minWidth;
	        var minHeight = cropperSettings.minHeight;
	        var croppedWidth = cropperSettings.croppedWidth;
	        var croppedHeight = cropperSettings.croppedHeight;
	        this.cropperSettings = cropperSettings;
	        this.crop = this;
	        this.x = x;
	        this.y = y;
	        if (width === void 0) {
	            this.width = 100;
	        }
	        if (height === void 0) {
	            this.height = 50;
	        }
	        if (keepAspect === void 0) {
	            this.keepAspect = true;
	        }
	        if (touchRadius === void 0) {
	            this.touchRadius = 20;
	        }
	        this.minWidth = minWidth;
	        this.minHeight = minHeight;
	        this.keepAspect = false;
	        this.aspectRatio = 0;
	        this.currentDragTouches = [];
	        this.isMouseDown = false;
	        this.ratioW = 1;
	        this.ratioH = 1;
	        this.fileType = cropperSettings.fileType;
	        this.imageSet = false;
	        this.pointPool = new pointPool_1.PointPool(200);
	        this.tl = new cornerMarker_1.CornerMarker(x, y, touchRadius, this.cropperSettings);
	        this.tr = new cornerMarker_1.CornerMarker(x + width, y, touchRadius, this.cropperSettings);
	        this.bl = new cornerMarker_1.CornerMarker(x, y + height, touchRadius, this.cropperSettings);
	        this.br = new cornerMarker_1.CornerMarker(x + width, y + height, touchRadius, this.cropperSettings);
	        this.tl.addHorizontalNeighbour(this.tr);
	        this.tl.addVerticalNeighbour(this.bl);
	        this.tr.addHorizontalNeighbour(this.tl);
	        this.tr.addVerticalNeighbour(this.br);
	        this.bl.addHorizontalNeighbour(this.br);
	        this.bl.addVerticalNeighbour(this.tl);
	        this.br.addHorizontalNeighbour(this.bl);
	        this.br.addVerticalNeighbour(this.tr);
	        this.markers = [this.tl, this.tr, this.bl, this.br];
	        this.center = new dragMarker_1.DragMarker(x + (width / 2), y + (height / 2), touchRadius, this.cropperSettings);
	        this.keepAspect = keepAspect;
	        this.aspectRatio = height / width;
	        this.croppedImage = new Image();
	        this.currentlyInteracting = false;
	        this.cropWidth = croppedWidth;
	        this.cropHeight = croppedHeight;
	    }
	    ImageCropper.sign = function (x) {
	        if (+x === x) {
	            return (x === 0) ? x : (x > 0) ? 1 : -1;
	        }
	        return NaN;
	    };
	    ImageCropper.getMousePos = function (canvas, evt) {
	        var rect = canvas.getBoundingClientRect();
	        return pointPool_1.PointPool.instance.borrow(evt.clientX - rect.left, evt.clientY - rect.top);
	    };
	    ImageCropper.getTouchPos = function (canvas, touch) {
	        var rect = canvas.getBoundingClientRect();
	        return pointPool_1.PointPool.instance.borrow(touch.clientX - rect.left, touch.clientY - rect.top);
	    };
	    ImageCropper.detectVerticalSquash = function (img) {
	        var ih = img.height;
	        var canvas = document.createElement("canvas");
	        canvas.width = 1;
	        canvas.height = ih;
	        var ctx = canvas.getContext("2d");
	        ctx.drawImage(img, 0, 0);
	        var imageData = ctx.getImageData(0, 0, 1, ih);
	        if (imageData) {
	            var data = imageData.data;
	            // search image edge pixel position in case it is squashed vertically.
	            var sy = 0;
	            var ey = ih;
	            var py = ih;
	            while (py > sy) {
	                var alpha = data[(py - 1) * 4 + 3];
	                if (alpha === 0) {
	                    ey = py;
	                }
	                else {
	                    sy = py;
	                }
	                py = (ey + sy) >> 1;
	            }
	            var ratio = (py / ih);
	            return (ratio === 0) ? 1 : ratio;
	        }
	        else {
	            return 1;
	        }
	    };
	    ImageCropper.prototype.getDataUriMimeType = function (dataUri) {
	        // Get a substring because the regex does not perform well on very large strings. Cater for optional charset. Length 50 shoould be enough.
	        var dataUriSubstring = dataUri.substring(0, 50);
	        var mimeType = 'image/png';
	        // data-uri scheme
	        // data:[<media type>][;charset=<character set>][;base64],<data>
	        var regEx = RegExp(/^(data:)([\w\/\+]+);(charset=[\w-]+|base64).*,(.*)/gi);
	        var matches = regEx.exec(dataUriSubstring);
	        if (matches && matches[2]) {
	            mimeType = matches[2];
	            if (mimeType == 'image/jpg') {
	                mimeType = 'image/jpeg';
	            }
	        }
	        return mimeType;
	    };
	    ImageCropper.prototype.prepare = function (canvas) {
	        this.buffer = document.createElement("canvas");
	        this.cropCanvas = document.createElement("canvas");
	        // todo get more reliable parent width value.
	        var responsiveWidth = canvas.parentElement ? canvas.parentElement.clientWidth : 0;
	        if (responsiveWidth > 0 && this.cropperSettings.dynamicSizing) {
	            this.cropCanvas.width = responsiveWidth;
	            this.buffer.width = responsiveWidth;
	            canvas.width = responsiveWidth;
	        }
	        else {
	            this.cropCanvas.width = this.cropWidth;
	            this.buffer.width = canvas.width;
	        }
	        this.cropCanvas.height = this.cropHeight;
	        this.buffer.height = canvas.height;
	        this.canvas = canvas;
	        this.ctx = this.canvas.getContext("2d");
	        this.draw(this.ctx);
	    };
	    ImageCropper.prototype.resizeCanvas = function (width, height, setImage) {
	        if (setImage === void 0) { setImage = false; }
	        this.canvas.width = this.cropCanvas.width = this.width = this.canvasWidth = this.buffer.width = width;
	        this.canvas.height = this.cropCanvas.height = this.height = this.canvasHeight = this.buffer.height = height;
	        if (setImage) {
	            this.setImage(this.srcImage);
	        }
	    };
	    ImageCropper.prototype.reset = function () {
	        this.setImage(undefined);
	    };
	    ImageCropper.prototype.draw = function (ctx) {
	        var bounds = this.getBounds();
	        if (this.srcImage) {
	            ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
	            var sourceAspect = this.srcImage.height / this.srcImage.width;
	            var canvasAspect = this.canvasHeight / this.canvasWidth;
	            var w = this.canvasWidth;
	            var h = this.canvasHeight;
	            if (canvasAspect > sourceAspect) {
	                w = this.canvasWidth;
	                h = this.canvasWidth * sourceAspect;
	            }
	            else {
	                h = this.canvasHeight;
	                w = this.canvasHeight / sourceAspect;
	            }
	            this.ratioW = w / this.srcImage.width;
	            this.ratioH = h / this.srcImage.height;
	            if (canvasAspect < sourceAspect) {
	                this.drawImageIOSFix(ctx, this.srcImage, 0, 0, this.srcImage.width, this.srcImage.height, this.buffer.width / 2 - w / 2, 0, w, h);
	            }
	            else {
	                this.drawImageIOSFix(ctx, this.srcImage, 0, 0, this.srcImage.width, this.srcImage.height, 0, this.buffer.height / 2 - h / 2, w, h);
	            }
	            this.buffer.getContext("2d")
	                .drawImage(this.canvas, 0, 0, this.canvasWidth, this.canvasHeight);
	            ctx.lineWidth = this.cropperSettings.cropperDrawSettings.strokeWidth;
	            ctx.strokeStyle = this.cropperSettings.cropperDrawSettings.strokeColor; // "rgba(255,228,0,1)";
	            if (!this.cropperSettings.rounded) {
	                ctx.fillStyle = "rgba(0, 0, 0, 0.6)";
	                ctx.fillRect(0, 0, this.canvasWidth, this.canvasHeight);
	                ctx.drawImage(this.buffer, bounds.left, bounds.top, Math.max(bounds.width, 1), Math.max(bounds.height, 1), bounds.left, bounds.top, bounds.width, bounds.height);
	                ctx.strokeRect(bounds.left, bounds.top, bounds.width, bounds.height);
	            }
	            else {
	                ctx.beginPath();
	                ctx.arc(bounds.left + bounds.width / 2, bounds.top + bounds.height / 2, bounds.width / 2, 0, Math.PI * 2, true);
	                ctx.closePath();
	                ctx.stroke();
	            }
	            var marker = void 0;
	            for (var i = 0; i < this.markers.length; i++) {
	                marker = this.markers[i];
	                marker.draw(ctx);
	            }
	            this.center.draw(ctx);
	        }
	        else {
	            ctx.fillStyle = "rgba(192,192,192,1)";
	            ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
	        }
	    };
	    ImageCropper.prototype.dragCenter = function (x, y, marker) {
	        var bounds = this.getBounds();
	        var left = x - (bounds.width / 2);
	        var right = x + (bounds.width / 2);
	        var top = y - (bounds.height / 2);
	        var bottom = y + (bounds.height / 2);
	        if (right >= this.maxXClamp) {
	            x = this.maxXClamp - bounds.width / 2;
	        }
	        if (left <= this.minXClamp) {
	            x = bounds.width / 2 + this.minXClamp;
	        }
	        if (top < this.minYClamp) {
	            y = bounds.height / 2 + this.minYClamp;
	        }
	        if (bottom >= this.maxYClamp) {
	            y = this.maxYClamp - bounds.height / 2;
	        }
	        this.tl.moveX(x - (bounds.width / 2));
	        this.tl.moveY(y - (bounds.height / 2));
	        this.tr.moveX(x + (bounds.width / 2));
	        this.tr.moveY(y - (bounds.height / 2));
	        this.bl.moveX(x - (bounds.width / 2));
	        this.bl.moveY(y + (bounds.height / 2));
	        this.br.moveX(x + (bounds.width / 2));
	        this.br.moveY(y + (bounds.height / 2));
	        marker.setPosition(x, y);
	    };
	    ImageCropper.prototype.enforceMinSize = function (x, y, marker) {
	        var xLength = x - marker.getHorizontalNeighbour().position.x;
	        var yLength = y - marker.getVerticalNeighbour().position.y;
	        var xOver = this.minWidth - Math.abs(xLength);
	        var yOver = this.minHeight - Math.abs(yLength);
	        if (xLength === 0 || yLength === 0) {
	            x = marker.position.x;
	            y = marker.position.y;
	            return pointPool_1.PointPool.instance.borrow(x, y);
	        }
	        if (this.keepAspect) {
	            if (xOver > 0 && (yOver / this.aspectRatio) > 0) {
	                if (xOver > (yOver / this.aspectRatio)) {
	                    if (xLength < 0) {
	                        x -= xOver;
	                        if (yLength < 0) {
	                            y -= xOver * this.aspectRatio;
	                        }
	                        else {
	                            y += xOver * this.aspectRatio;
	                        }
	                    }
	                    else {
	                        x += xOver;
	                        if (yLength < 0) {
	                            y -= xOver * this.aspectRatio;
	                        }
	                        else {
	                            y += xOver * this.aspectRatio;
	                        }
	                    }
	                }
	                else {
	                    if (yLength < 0) {
	                        y -= yOver;
	                        if (xLength < 0) {
	                            x -= yOver / this.aspectRatio;
	                        }
	                        else {
	                            x += yOver / this.aspectRatio;
	                        }
	                    }
	                    else {
	                        y += yOver;
	                        if (xLength < 0) {
	                            x -= yOver / this.aspectRatio;
	                        }
	                        else {
	                            x += yOver / this.aspectRatio;
	                        }
	                    }
	                }
	            }
	            else {
	                if (xOver > 0) {
	                    if (xLength < 0) {
	                        x -= xOver;
	                        if (yLength < 0) {
	                            y -= xOver * this.aspectRatio;
	                        }
	                        else {
	                            y += xOver * this.aspectRatio;
	                        }
	                    }
	                    else {
	                        x += xOver;
	                        if (yLength < 0) {
	                            y -= xOver * this.aspectRatio;
	                        }
	                        else {
	                            y += xOver * this.aspectRatio;
	                        }
	                    }
	                }
	                else {
	                    if (yOver > 0) {
	                        if (yLength < 0) {
	                            y -= yOver;
	                            if (xLength < 0) {
	                                x -= yOver / this.aspectRatio;
	                            }
	                            else {
	                                x += yOver / this.aspectRatio;
	                            }
	                        }
	                        else {
	                            y += yOver;
	                            if (xLength < 0) {
	                                x -= yOver / this.aspectRatio;
	                            }
	                            else {
	                                x += yOver / this.aspectRatio;
	                            }
	                        }
	                    }
	                }
	            }
	        }
	        else {
	            if (xOver > 0) {
	                if (xLength < 0) {
	                    x -= xOver;
	                }
	                else {
	                    x += xOver;
	                }
	            }
	            if (yOver > 0) {
	                if (yLength < 0) {
	                    y -= yOver;
	                }
	                else {
	                    y += yOver;
	                }
	            }
	        }
	        if (x < this.minXClamp || x > this.maxXClamp || y < this.minYClamp || y > this.maxYClamp) {
	            x = marker.position.x;
	            y = marker.position.y;
	        }
	        return pointPool_1.PointPool.instance.borrow(x, y);
	    };
	    ImageCropper.prototype.dragCorner = function (x, y, marker) {
	        var iX = 0;
	        var iY = 0;
	        var ax = 0;
	        var ay = 0;
	        var newHeight = 0;
	        var newWidth = 0;
	        var newY = 0;
	        var newX = 0;
	        var anchorMarker;
	        var fold = 0;
	        if (this.keepAspect) {
	            anchorMarker = marker.getHorizontalNeighbour().getVerticalNeighbour();
	            ax = anchorMarker.position.x;
	            ay = anchorMarker.position.y;
	            if (x <= anchorMarker.position.x) {
	                if (y <= anchorMarker.position.y) {
	                    iX = ax - (100 / this.aspectRatio);
	                    iY = ay - (100 / this.aspectRatio * this.aspectRatio);
	                    fold = this.getSide(pointPool_1.PointPool.instance.borrow(iX, iY), anchorMarker.position, pointPool_1.PointPool.instance.borrow(x, y));
	                    if (fold > 0) {
	                        newHeight = Math.abs(anchorMarker.position.y - y);
	                        newWidth = newHeight / this.aspectRatio;
	                        newY = anchorMarker.position.y - newHeight;
	                        newX = anchorMarker.position.x - newWidth;
	                        var min = this.enforceMinSize(newX, newY, marker);
	                        marker.move(min.x, min.y);
	                        pointPool_1.PointPool.instance.returnPoint(min);
	                    }
	                    else {
	                        if (fold < 0) {
	                            newWidth = Math.abs(anchorMarker.position.x - x);
	                            newHeight = newWidth * this.aspectRatio;
	                            newY = anchorMarker.position.y - newHeight;
	                            newX = anchorMarker.position.x - newWidth;
	                            var min = this.enforceMinSize(newX, newY, marker);
	                            marker.move(min.x, min.y);
	                            pointPool_1.PointPool.instance.returnPoint(min);
	                        }
	                    }
	                }
	                else {
	                    iX = ax - (100 / this.aspectRatio);
	                    iY = ay + (100 / this.aspectRatio * this.aspectRatio);
	                    fold = this.getSide(pointPool_1.PointPool.instance.borrow(iX, iY), anchorMarker.position, pointPool_1.PointPool.instance.borrow(x, y));
	                    if (fold > 0) {
	                        newWidth = Math.abs(anchorMarker.position.x - x);
	                        newHeight = newWidth * this.aspectRatio;
	                        newY = anchorMarker.position.y + newHeight;
	                        newX = anchorMarker.position.x - newWidth;
	                        var min = this.enforceMinSize(newX, newY, marker);
	                        marker.move(min.x, min.y);
	                        pointPool_1.PointPool.instance.returnPoint(min);
	                    }
	                    else {
	                        if (fold < 0) {
	                            newHeight = Math.abs(anchorMarker.position.y - y);
	                            newWidth = newHeight / this.aspectRatio;
	                            newY = anchorMarker.position.y + newHeight;
	                            newX = anchorMarker.position.x - newWidth;
	                            var min = this.enforceMinSize(newX, newY, marker);
	                            marker.move(min.x, min.y);
	                            pointPool_1.PointPool.instance.returnPoint(min);
	                        }
	                    }
	                }
	            }
	            else {
	                if (y <= anchorMarker.position.y) {
	                    iX = ax + (100 / this.aspectRatio);
	                    iY = ay - (100 / this.aspectRatio * this.aspectRatio);
	                    fold = this.getSide(pointPool_1.PointPool.instance.borrow(iX, iY), anchorMarker.position, pointPool_1.PointPool.instance.borrow(x, y));
	                    if (fold < 0) {
	                        newHeight = Math.abs(anchorMarker.position.y - y);
	                        newWidth = newHeight / this.aspectRatio;
	                        newY = anchorMarker.position.y - newHeight;
	                        newX = anchorMarker.position.x + newWidth;
	                        var min = this.enforceMinSize(newX, newY, marker);
	                        marker.move(min.x, min.y);
	                        pointPool_1.PointPool.instance.returnPoint(min);
	                    }
	                    else {
	                        if (fold > 0) {
	                            newWidth = Math.abs(anchorMarker.position.x - x);
	                            newHeight = newWidth * this.aspectRatio;
	                            newY = anchorMarker.position.y - newHeight;
	                            newX = anchorMarker.position.x + newWidth;
	                            var min = this.enforceMinSize(newX, newY, marker);
	                            marker.move(min.x, min.y);
	                            pointPool_1.PointPool.instance.returnPoint(min);
	                        }
	                    }
	                }
	                else {
	                    iX = ax + (100 / this.aspectRatio);
	                    iY = ay + (100 / this.aspectRatio * this.aspectRatio);
	                    fold = this.getSide(pointPool_1.PointPool.instance.borrow(iX, iY), anchorMarker.position, pointPool_1.PointPool.instance.borrow(x, y));
	                    if (fold < 0) {
	                        newWidth = Math.abs(anchorMarker.position.x - x);
	                        newHeight = newWidth * this.aspectRatio;
	                        newY = anchorMarker.position.y + newHeight;
	                        newX = anchorMarker.position.x + newWidth;
	                        var min = this.enforceMinSize(newX, newY, marker);
	                        marker.move(min.x, min.y);
	                        pointPool_1.PointPool.instance.returnPoint(min);
	                    }
	                    else {
	                        if (fold > 0) {
	                            newHeight = Math.abs(anchorMarker.position.y - y);
	                            newWidth = newHeight / this.aspectRatio;
	                            newY = anchorMarker.position.y + newHeight;
	                            newX = anchorMarker.position.x + newWidth;
	                            var min = this.enforceMinSize(newX, newY, marker);
	                            marker.move(min.x, min.y);
	                            pointPool_1.PointPool.instance.returnPoint(min);
	                        }
	                    }
	                }
	            }
	        }
	        else {
	            var min = this.enforceMinSize(x, y, marker);
	            marker.move(min.x, min.y);
	            pointPool_1.PointPool.instance.returnPoint(min);
	        }
	        this.center.recalculatePosition(this.getBounds());
	    };
	    ImageCropper.prototype.getSide = function (a, b, c) {
	        var n = ImageCropper.sign((b.x - a.x) * (c.y - a.y) - (b.y - a.y) * (c.x - a.x));
	        // TODO move the return of the pools to outside of this function
	        pointPool_1.PointPool.instance.returnPoint(a);
	        pointPool_1.PointPool.instance.returnPoint(c);
	        return n;
	    };
	    ImageCropper.prototype.handleRelease = function (newCropTouch) {
	        if (newCropTouch == null) {
	            return;
	        }
	        var index = 0;
	        for (var k = 0; k < this.currentDragTouches.length; k++) {
	            if (newCropTouch.id === this.currentDragTouches[k].id) {
	                this.currentDragTouches[k].dragHandle.setDrag(false);
	                index = k;
	            }
	        }
	        this.currentDragTouches.splice(index, 1);
	        this.draw(this.ctx);
	    };
	    ImageCropper.prototype.handleMove = function (newCropTouch) {
	        var matched = false;
	        for (var k = 0; k < this.currentDragTouches.length; k++) {
	            if (newCropTouch.id === this.currentDragTouches[k].id && this.currentDragTouches[k].dragHandle != null) {
	                var dragTouch = this.currentDragTouches[k];
	                var clampedPositions = this.clampPosition(newCropTouch.x - dragTouch.dragHandle.offset.x, newCropTouch.y - dragTouch.dragHandle.offset.y);
	                newCropTouch.x = clampedPositions.x;
	                newCropTouch.y = clampedPositions.y;
	                pointPool_1.PointPool.instance.returnPoint(clampedPositions);
	                if (dragTouch.dragHandle instanceof cornerMarker_1.CornerMarker) {
	                    this.dragCorner(newCropTouch.x, newCropTouch.y, dragTouch.dragHandle);
	                }
	                else {
	                    this.dragCenter(newCropTouch.x, newCropTouch.y, dragTouch.dragHandle);
	                }
	                this.currentlyInteracting = true;
	                matched = true;
	                imageCropperDataShare_1.ImageCropperDataShare.setPressed(this.canvas);
	                break;
	            }
	        }
	        if (!matched) {
	            for (var i = 0; i < this.markers.length; i++) {
	                var marker = this.markers[i];
	                if (marker.touchInBounds(newCropTouch.x, newCropTouch.y)) {
	                    newCropTouch.dragHandle = marker;
	                    this.currentDragTouches.push(newCropTouch);
	                    marker.setDrag(true);
	                    newCropTouch.dragHandle.offset.x = newCropTouch.x - newCropTouch.dragHandle.position.x;
	                    newCropTouch.dragHandle.offset.y = newCropTouch.y - newCropTouch.dragHandle.position.y;
	                    this.dragCorner(newCropTouch.x - newCropTouch.dragHandle.offset.x, newCropTouch.y - newCropTouch.dragHandle.offset.y, newCropTouch.dragHandle);
	                    break;
	                }
	            }
	            if (newCropTouch.dragHandle === null || typeof newCropTouch.dragHandle === "undefined") {
	                if (this.center.touchInBounds(newCropTouch.x, newCropTouch.y)) {
	                    newCropTouch.dragHandle = this.center;
	                    this.currentDragTouches.push(newCropTouch);
	                    newCropTouch.dragHandle.setDrag(true);
	                    newCropTouch.dragHandle.offset.x = newCropTouch.x - newCropTouch.dragHandle.position.x;
	                    newCropTouch.dragHandle.offset.y = newCropTouch.y - newCropTouch.dragHandle.position.y;
	                    this.dragCenter(newCropTouch.x - newCropTouch.dragHandle.offset.x, newCropTouch.y - newCropTouch.dragHandle.offset.y, newCropTouch.dragHandle);
	                }
	            }
	        }
	    };
	    ImageCropper.prototype.updateClampBounds = function () {
	        var sourceAspect = this.srcImage.height / this.srcImage.width;
	        var canvasAspect = this.canvas.height / this.canvas.width;
	        var w = this.canvas.width;
	        var h = this.canvas.height;
	        if (canvasAspect > sourceAspect) {
	            w = this.canvas.width;
	            h = this.canvas.width * sourceAspect;
	        }
	        else {
	            h = this.canvas.height;
	            w = this.canvas.height / sourceAspect;
	        }
	        this.minXClamp = this.canvas.width / 2 - w / 2;
	        this.minYClamp = this.canvas.height / 2 - h / 2;
	        this.maxXClamp = this.canvas.width / 2 + w / 2;
	        this.maxYClamp = this.canvas.height / 2 + h / 2;
	    };
	    ImageCropper.prototype.getCropBounds = function () {
	        var bounds = this.getBounds();
	        bounds.top = Math.round((bounds.top - this.minYClamp) / this.ratioH);
	        bounds.bottom = Math.round((bounds.bottom - this.minYClamp) / this.ratioH);
	        bounds.left = Math.round((bounds.left - this.minXClamp) / this.ratioW);
	        bounds.right = Math.round((bounds.right - this.minXClamp) / this.ratioW);
	        return bounds;
	    };
	    ImageCropper.prototype.clampPosition = function (x, y) {
	        if (x < this.minXClamp) {
	            x = this.minXClamp;
	        }
	        if (x > this.maxXClamp) {
	            x = this.maxXClamp;
	        }
	        if (y < this.minYClamp) {
	            y = this.minYClamp;
	        }
	        if (y > this.maxYClamp) {
	            y = this.maxYClamp;
	        }
	        return pointPool_1.PointPool.instance.borrow(x, y);
	    };
	    ImageCropper.prototype.isImageSet = function () {
	        return this.imageSet;
	    };
	    ImageCropper.prototype.setImage = function (img) {
	        this.srcImage = img;
	        if (!img) {
	            this.imageSet = false;
	            this.draw(this.ctx);
	        }
	        else {
	            this.imageSet = true;
	            this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
	            var bufferContext = this.buffer.getContext("2d");
	            bufferContext.clearRect(0, 0, this.buffer.width, this.buffer.height);
	            this.fileType = this.getDataUriMimeType(img.src);
	            if (this.cropperSettings.minWithRelativeToResolution) {
	                this.minWidth = (this.canvas.width * this.minWidth / this.srcImage.width);
	                this.minHeight = (this.canvas.height * this.minHeight / this.srcImage.height);
	            }
	            this.updateClampBounds();
	            this.canvasWidth = this.canvas.width;
	            this.canvasHeight = this.canvas.height;
	            var cropPosition = this.getCropPositionFromMarkers();
	            this.setCropPosition(cropPosition);
	        }
	    };
	    ImageCropper.prototype.updateCropPosition = function (cropBounds) {
	        var cropPosition = this.getCropPositionFromBounds(cropBounds);
	        this.setCropPosition(cropPosition);
	    };
	    ImageCropper.prototype.setCropPosition = function (cropPosition) {
	        this.tl.setPosition(cropPosition[0].x, cropPosition[0].y);
	        this.tr.setPosition(cropPosition[1].x, cropPosition[1].y);
	        this.bl.setPosition(cropPosition[2].x, cropPosition[2].y);
	        this.br.setPosition(cropPosition[3].x, cropPosition[3].y);
	        this.center.setPosition(cropPosition[4].x, cropPosition[4].y);
	        for (var _i = 0, cropPosition_1 = cropPosition; _i < cropPosition_1.length; _i++) {
	            var position = cropPosition_1[_i];
	            pointPool_1.PointPool.instance.returnPoint(position);
	        }
	        this.vertSquashRatio = ImageCropper.detectVerticalSquash(this.srcImage);
	        this.draw(this.ctx);
	        this.croppedImage = this.getCroppedImage(this.cropWidth, this.cropHeight);
	    };
	    ImageCropper.prototype.getCropPositionFromMarkers = function () {
	        var w = this.canvas.width;
	        var h = this.canvas.height;
	        var tlPos, trPos, blPos, brPos, center;
	        var sourceAspect = this.srcImage.height / this.srcImage.width;
	        var cropBounds = this.getBounds();
	        var cropAspect = cropBounds.height / cropBounds.width;
	        var cX = this.canvas.width / 2;
	        var cY = this.canvas.height / 2;
	        if (cropAspect > sourceAspect) {
	            var imageH = Math.min(w * sourceAspect, h);
	            var cropW = imageH / cropAspect;
	            tlPos = pointPool_1.PointPool.instance.borrow(cX - cropW / 2, cY + imageH / 2);
	            trPos = pointPool_1.PointPool.instance.borrow(cX + cropW / 2, cY + imageH / 2);
	            blPos = pointPool_1.PointPool.instance.borrow(cX - cropW / 2, cY - imageH / 2);
	            brPos = pointPool_1.PointPool.instance.borrow(cX + cropW / 2, cY - imageH / 2);
	        }
	        else {
	            var imageW = Math.min(h / sourceAspect, w);
	            var cropH = imageW * cropAspect;
	            tlPos = pointPool_1.PointPool.instance.borrow(cX - imageW / 2, cY + cropH / 2);
	            trPos = pointPool_1.PointPool.instance.borrow(cX + imageW / 2, cY + cropH / 2);
	            blPos = pointPool_1.PointPool.instance.borrow(cX - imageW / 2, cY - cropH / 2);
	            brPos = pointPool_1.PointPool.instance.borrow(cX + imageW / 2, cY - cropH / 2);
	        }
	        center = pointPool_1.PointPool.instance.borrow(cX, cY);
	        var positions = [tlPos, trPos, blPos, brPos, center];
	        return positions;
	    };
	    ImageCropper.prototype.getCropPositionFromBounds = function (cropPosition) {
	        var marginTop = 0;
	        var marginLeft = 0;
	        var canvasAspect = this.canvasHeight / this.canvasWidth;
	        var sourceAspect = this.srcImage.height / this.srcImage.width;
	        if (canvasAspect > sourceAspect) {
	            marginTop = this.buffer.height / 2 - (this.canvasWidth * sourceAspect) / 2;
	        }
	        else {
	            marginLeft = this.buffer.width / 2 - (this.canvasHeight / sourceAspect) / 2;
	        }
	        var ratioW = (this.canvasWidth - marginLeft * 2) / this.srcImage.width;
	        var ratioH = (this.canvasHeight - marginTop * 2) / this.srcImage.height;
	        var actualH = cropPosition.height * ratioH;
	        var actualW = cropPosition.width * ratioW;
	        var actualX = cropPosition.left * ratioW + marginLeft;
	        var actualY = cropPosition.top * ratioH + marginTop;
	        if (this.keepAspect) {
	            var scaledW = actualH / this.aspectRatio;
	            var scaledH = actualW * this.aspectRatio;
	            if (this.getCropBounds().height === cropPosition.height) {
	                actualH = scaledH;
	            }
	            else if (this.getCropBounds().width === cropPosition.width) {
	                actualW = scaledW;
	            }
	            else {
	                if (Math.abs(scaledH - actualH) < Math.abs(scaledW - actualW)) {
	                    actualW = scaledW;
	                }
	                else {
	                    actualH = scaledH;
	                }
	            }
	        }
	        var tlPos = pointPool_1.PointPool.instance.borrow(actualX, actualY + actualH);
	        var trPos = pointPool_1.PointPool.instance.borrow(actualX + actualW, actualY + actualH);
	        var blPos = pointPool_1.PointPool.instance.borrow(actualX, actualY);
	        var brPos = pointPool_1.PointPool.instance.borrow(actualX + actualW, actualY);
	        var center = pointPool_1.PointPool.instance.borrow(actualX + actualW / 2, actualY + actualH / 2);
	        var positions = [tlPos, trPos, blPos, brPos, center];
	        return positions;
	    };
	    // todo: Unused parameters?
	    ImageCropper.prototype.getCroppedImage = function (fillWidth, fillHeight) {
	        var bounds = this.getBounds();
	        if (!this.srcImage) {
	            return document.createElement('img');
	        }
	        else {
	            var sourceAspect = this.srcImage.height / this.srcImage.width;
	            var canvasAspect = this.canvas.height / this.canvas.width;
	            var w = this.canvas.width;
	            var h = this.canvas.height;
	            if (canvasAspect > sourceAspect) {
	                w = this.canvas.width;
	                h = this.canvas.width * sourceAspect;
	            }
	            else {
	                if (canvasAspect < sourceAspect) {
	                    h = this.canvas.height;
	                    w = this.canvas.height / sourceAspect;
	                }
	                else {
	                    h = this.canvas.height;
	                    w = this.canvas.width;
	                }
	            }
	            this.ratioW = w / this.srcImage.width;
	            this.ratioH = h / this.srcImage.height;
	            var offsetH = (this.buffer.height - h) / 2 / this.ratioH;
	            var offsetW = (this.buffer.width - w) / 2 / this.ratioW;
	            var ctx = this.cropCanvas.getContext("2d");
	            if (this.cropperSettings.preserveSize) {
	                //var left = Math.max(Math.round((bounds.left) / this.ratioW - offsetW), 0) * this.srcImage.width / this.canvas.width;
	                var width = Math.max(Math.round((bounds.right) / this.ratioW - offsetW), 0) * this.srcImage.width / this.canvas.width;
	                //var top = Math.max(Math.round((bounds.top) / this.ratioH - offsetH), 0) * this.srcImage.height / this.canvas.height;
	                var height = Math.max(Math.round((bounds.bottom) / this.ratioH - offsetH), 0) * this.srcImage.height / this.canvas.height;
	                this.cropCanvas.width = width;
	                this.cropCanvas.height = height;
	                this.cropperSettings.croppedWidth = this.cropCanvas.width;
	                this.cropperSettings.croppedHeight = this.cropCanvas.height;
	            }
	            ctx.clearRect(0, 0, this.cropCanvas.width, this.cropCanvas.height);
	            this.drawImageIOSFix(ctx, this.srcImage, Math.max(Math.round((bounds.left) / this.ratioW - offsetW), 0), Math.max(Math.round(bounds.top / this.ratioH - offsetH), 0), Math.max(Math.round(bounds.width / this.ratioW), 1), Math.max(Math.round(bounds.height / this.ratioH), 1), 0, 0, this.cropCanvas.width, this.cropCanvas.height);
	            if (this.cropperSettings.resampleFn) {
	                this.cropperSettings.resampleFn(this.cropCanvas);
	            }
	            this.croppedImage.width = this.cropCanvas.width;
	            this.croppedImage.height = this.cropCanvas.height;
	            this.croppedImage.src = this.cropCanvas.toDataURL(this.fileType, this.cropperSettings.compressRatio);
	            return this.croppedImage;
	        }
	    };
	    ImageCropper.prototype.getBounds = function () {
	        var minX = Number.MAX_VALUE;
	        var minY = Number.MAX_VALUE;
	        var maxX = -Number.MAX_VALUE;
	        var maxY = -Number.MAX_VALUE;
	        for (var i = 0; i < this.markers.length; i++) {
	            var marker = this.markers[i];
	            if (marker.position.x < minX) {
	                minX = marker.position.x;
	            }
	            if (marker.position.x > maxX) {
	                maxX = marker.position.x;
	            }
	            if (marker.position.y < minY) {
	                minY = marker.position.y;
	            }
	            if (marker.position.y > maxY) {
	                maxY = marker.position.y;
	            }
	        }
	        var bounds = new bounds_1.Bounds();
	        bounds.left = minX;
	        bounds.right = maxX;
	        bounds.top = minY;
	        bounds.bottom = maxY;
	        return bounds;
	    };
	    ImageCropper.prototype.setBounds = function (bounds) {
	        var topLeft;
	        var topRight;
	        var bottomLeft;
	        var bottomRight;
	        var currentBounds = this.getBounds();
	        for (var i = 0; i < this.markers.length; i++) {
	            var marker = this.markers[i];
	            if (marker.position.x === currentBounds.left) {
	                if (marker.position.y === currentBounds.top) {
	                    marker.setPosition(bounds.left, bounds.top);
	                }
	                else {
	                    marker.setPosition(bounds.left, bounds.bottom);
	                }
	            }
	            else {
	                if (marker.position.y === currentBounds.top) {
	                    marker.setPosition(bounds.right, bounds.top);
	                }
	                else {
	                    marker.setPosition(bounds.right, bounds.bottom);
	                }
	            }
	        }
	        this.center.recalculatePosition(bounds);
	        this.center.draw(this.ctx);
	        this.draw(this.ctx); // we need to redraw all canvas if we have changed bounds
	    };
	    ImageCropper.prototype.onTouchMove = function (event) {
	        if (this.crop.isImageSet()) {
	            event.preventDefault();
	            if (event.touches.length === 1) {
	                for (var i = 0; i < event.touches.length; i++) {
	                    var touch = event.touches[i];
	                    var touchPosition = ImageCropper.getTouchPos(this.canvas, touch);
	                    var cropTouch = new cropTouch_1.CropTouch(touchPosition.x, touchPosition.y, touch.identifier);
	                    pointPool_1.PointPool.instance.returnPoint(touchPosition);
	                    this.move(cropTouch);
	                }
	            }
	            else {
	                if (event.touches.length === 2) {
	                    var distance = ((event.touches[0].clientX - event.touches[1].clientX) * (event.touches[0].clientX - event.touches[1].clientX)) + ((event.touches[0].clientY - event.touches[1].clientY) * (event.touches[0].clientY - event.touches[1].clientY));
	                    if (this.previousDistance && this.previousDistance !== distance) {
	                        var increment = distance < this.previousDistance ? 1 : -1;
	                        var bounds = this.getBounds();
	                        bounds.top += increment;
	                        bounds.left += increment;
	                        bounds.right -= increment;
	                        bounds.bottom -= increment;
	                        this.setBounds(bounds);
	                    }
	                    this.previousDistance = distance;
	                }
	            }
	            this.draw(this.ctx);
	        }
	    };
	    ImageCropper.prototype.onMouseMove = function (e) {
	        if (this.crop.isImageSet() && this.isMouseDown) {
	            var mousePosition = ImageCropper.getMousePos(this.canvas, e);
	            this.move(new cropTouch_1.CropTouch(mousePosition.x, mousePosition.y, 0));
	            var dragTouch = this.getDragTouchForID(0);
	            if (dragTouch) {
	                dragTouch.x = mousePosition.x;
	                dragTouch.y = mousePosition.y;
	            }
	            else {
	                dragTouch = new cropTouch_1.CropTouch(mousePosition.x, mousePosition.y, 0);
	            }
	            pointPool_1.PointPool.instance.returnPoint(mousePosition);
	            this.drawCursors(dragTouch);
	            this.draw(this.ctx);
	        }
	    };
	    ImageCropper.prototype.move = function (cropTouch) {
	        if (this.isMouseDown) {
	            this.handleMove(cropTouch);
	        }
	    };
	    ImageCropper.prototype.getDragTouchForID = function (id) {
	        for (var i = 0; i < this.currentDragTouches.length; i++) {
	            if (id === this.currentDragTouches[i].id) {
	                return this.currentDragTouches[i];
	            }
	        }
	    };
	    ImageCropper.prototype.drawCursors = function (cropTouch) {
	        var cursorDrawn = false;
	        if (cropTouch != null) {
	            if (cropTouch.dragHandle === this.center) {
	                imageCropperDataShare_1.ImageCropperDataShare.setStyle(this.canvas, "move");
	                cursorDrawn = true;
	            }
	            if (cropTouch.dragHandle !== null && cropTouch.dragHandle instanceof cornerMarker_1.CornerMarker) {
	                this.drawCornerCursor(cropTouch.dragHandle, cropTouch.dragHandle.position.x, cropTouch.dragHandle.position.y);
	                cursorDrawn = true;
	            }
	        }
	        var didDraw = false;
	        if (!cursorDrawn) {
	            for (var i = 0; i < this.markers.length; i++) {
	                didDraw = didDraw || this.drawCornerCursor(this.markers[i], cropTouch.x, cropTouch.y);
	            }
	            if (!didDraw) {
	                imageCropperDataShare_1.ImageCropperDataShare.setStyle(this.canvas, "initial");
	            }
	        }
	        if (!didDraw && !cursorDrawn && this.center.touchInBounds(cropTouch.x, cropTouch.y)) {
	            this.center.setOver(true);
	            imageCropperDataShare_1.ImageCropperDataShare.setOver(this.canvas);
	            imageCropperDataShare_1.ImageCropperDataShare.setStyle(this.canvas, "move");
	        }
	        else {
	            this.center.setOver(false);
	        }
	    };
	    ImageCropper.prototype.drawCornerCursor = function (marker, x, y) {
	        if (marker.touchInBounds(x, y)) {
	            marker.setOver(true);
	            if (marker.getHorizontalNeighbour().position.x > marker.position.x) {
	                if (marker.getVerticalNeighbour().position.y > marker.position.y) {
	                    imageCropperDataShare_1.ImageCropperDataShare.setOver(this.canvas);
	                    imageCropperDataShare_1.ImageCropperDataShare.setStyle(this.canvas, "nwse-resize");
	                }
	                else {
	                    imageCropperDataShare_1.ImageCropperDataShare.setOver(this.canvas);
	                    imageCropperDataShare_1.ImageCropperDataShare.setStyle(this.canvas, "nesw-resize");
	                }
	            }
	            else {
	                if (marker.getVerticalNeighbour().position.y > marker.position.y) {
	                    imageCropperDataShare_1.ImageCropperDataShare.setOver(this.canvas);
	                    imageCropperDataShare_1.ImageCropperDataShare.setStyle(this.canvas, "nesw-resize");
	                }
	                else {
	                    imageCropperDataShare_1.ImageCropperDataShare.setOver(this.canvas);
	                    imageCropperDataShare_1.ImageCropperDataShare.setStyle(this.canvas, "nwse-resize");
	                }
	            }
	            return true;
	        }
	        marker.setOver(false);
	        return false;
	    };
	    // todo: Unused param
	    ImageCropper.prototype.onTouchStart = function (event) {
	        if (this.crop.isImageSet()) {
	            this.isMouseDown = true;
	        }
	    };
	    ImageCropper.prototype.onTouchEnd = function (event) {
	        if (this.crop.isImageSet()) {
	            for (var i = 0; i < event.changedTouches.length; i++) {
	                var touch = event.changedTouches[i];
	                var dragTouch = this.getDragTouchForID(touch.identifier);
	                if (dragTouch && dragTouch !== null) {
	                    if (dragTouch.dragHandle instanceof cornerMarker_1.CornerMarker || dragTouch.dragHandle instanceof dragMarker_1.DragMarker) {
	                        dragTouch.dragHandle.setOver(false);
	                    }
	                    this.handleRelease(dragTouch);
	                }
	            }
	            if (this.currentDragTouches.length === 0) {
	                this.isMouseDown = false;
	                this.currentlyInteracting = false;
	            }
	        }
	    };
	    // http://stackoverflow.com/questions/11929099/html5-canvas-drawimage-ratio-bug-ios
	    ImageCropper.prototype.drawImageIOSFix = function (ctx, img, sx, sy, sw, sh, dx, dy, dw, dh) {
	        // Works only if whole image is displayed:
	        // ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh / vertSquashRatio);
	        // The following works correct also when only a part of the image is displayed:
	        // ctx.drawImage(img, sx * this.vertSquashRatio, sy * this.vertSquashRatio, sw * this.vertSquashRatio, sh *
	        // this.vertSquashRatio, dx, dy, dw, dh);
	        ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
	    };
	    ImageCropper.prototype.onMouseDown = function (event) {
	        if (this.crop.isImageSet()) {
	            this.isMouseDown = true;
	        }
	    };
	    ImageCropper.prototype.onMouseUp = function (event) {
	        if (this.crop.isImageSet()) {
	            imageCropperDataShare_1.ImageCropperDataShare.setReleased(this.canvas);
	            this.isMouseDown = false;
	            this.handleRelease(new cropTouch_1.CropTouch(0, 0, 0));
	        }
	    };
	    return ImageCropper;
	}(imageCropperModel_1.ImageCropperModel));
	exports.ImageCropper = ImageCropper;


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var pointPool_1 = __webpack_require__(102);
	var Bounds = (function () {
	    function Bounds(x, y, width, height) {
	        if (x === void 0) {
	            x = 0;
	        }
	        if (y === void 0) {
	            y = 0;
	        }
	        if (width === void 0) {
	            width = 0;
	        }
	        if (height === void 0) {
	            height = 0;
	        }
	        this.left = x;
	        this.right = x + width;
	        this.top = y;
	        this.bottom = y + height;
	    }
	    Object.defineProperty(Bounds.prototype, "width", {
	        get: function () {
	            return this.right - this.left;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ;
	    Object.defineProperty(Bounds.prototype, "height", {
	        get: function () {
	            return this.bottom - this.top;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ;
	    Bounds.prototype.getCentre = function () {
	        var w = this.width;
	        var h = this.height;
	        return pointPool_1.PointPool.instance.borrow(this.left + (w / 2), this.top + (h / 2));
	    };
	    ;
	    return Bounds;
	}());
	exports.Bounds = Bounds;


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var point_1 = __webpack_require__(103);
	var PointPool = (function () {
	    function PointPool(initialSize) {
	        PointPool._instance = this;
	        var prev = this.firstAvailable = new point_1.Point();
	        for (var i = 1; i < initialSize; i++) {
	            var p = new point_1.Point();
	            prev.next = p;
	            prev = p;
	        }
	    }
	    Object.defineProperty(PointPool, "instance", {
	        get: function () {
	            return PointPool._instance;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    PointPool.prototype.borrow = function (x, y) {
	        if (this.firstAvailable == null) {
	            throw "Pool exhausted";
	        }
	        this.borrowed++;
	        var p = this.firstAvailable;
	        this.firstAvailable = p.next;
	        p.x = x;
	        p.y = y;
	        return p;
	    };
	    ;
	    PointPool.prototype.returnPoint = function (p) {
	        this.borrowed--;
	        p.x = 0;
	        p.y = 0;
	        p.next = this.firstAvailable;
	        this.firstAvailable = p;
	    };
	    ;
	    return PointPool;
	}());
	exports.PointPool = PointPool;


/***/ },
/* 103 */
/***/ function(module, exports) {

	"use strict";
	var Point = (function () {
	    function Point(x, y) {
	        if (x === void 0) { x = 0; }
	        if (y === void 0) { y = 0; }
	        this.x = x;
	        this.y = y;
	    }
	    Object.defineProperty(Point.prototype, "next", {
	        get: function () {
	            return this._next;
	        },
	        set: function (p) {
	            this._next = p;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Point.prototype, "prev", {
	        get: function () {
	            return this._prev;
	        },
	        set: function (p) {
	            this._prev = p;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return Point;
	}());
	exports.Point = Point;


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var handle_1 = __webpack_require__(105);
	var CornerMarker = (function (_super) {
	    __extends(CornerMarker, _super);
	    function CornerMarker(x, y, radius, cropperSettings) {
	        _super.call(this, x, y, radius, cropperSettings);
	    }
	    CornerMarker.prototype.drawCornerBorder = function (ctx) {
	        var sideLength = 10;
	        if (this.over || this.drag) {
	            sideLength = 12;
	        }
	        var hDirection = 1;
	        var vDirection = 1;
	        if (this.horizontalNeighbour.position.x < this.position.x) {
	            hDirection = -1;
	        }
	        if (this.verticalNeighbour.position.y < this.position.y) {
	            vDirection = -1;
	        }
	        if (this.cropperSettings.rounded) {
	            var width = this.position.x - this.horizontalNeighbour.position.x;
	            var height = this.position.y - this.verticalNeighbour.position.y;
	            var offX = Math.round(Math.sin(Math.PI / 2) * Math.abs(width / 2)) / 4;
	            var offY = Math.round(Math.sin(Math.PI / 2) * Math.abs(height / 2)) / 4;
	            this.offset.x = hDirection > 0 ? offX : -offX;
	            this.offset.y = vDirection > 0 ? offY : -offY;
	        }
	        else {
	            this.offset.x = 0;
	            this.offset.y = 0;
	        }
	        ctx.beginPath();
	        ctx.lineJoin = "miter";
	        ctx.moveTo(this.position.x + this.offset.x, this.position.y + this.offset.y);
	        ctx.lineTo(this.position.x + this.offset.x + (sideLength * hDirection), this.position.y + this.offset.y);
	        ctx.lineTo(this.position.x + this.offset.x + (sideLength * hDirection), this.position.y + this.offset.y +
	            (sideLength * vDirection));
	        ctx.lineTo(this.position.x + this.offset.x, this.position.y + this.offset.y + (sideLength * vDirection));
	        ctx.lineTo(this.position.x + this.offset.x, this.position.y + this.offset.y);
	        ctx.closePath();
	        ctx.lineWidth = this.cropperSettings.cropperDrawSettings.strokeWidth;
	        ctx.strokeStyle = this.cropperSettings.cropperDrawSettings.strokeColor;
	        ctx.stroke();
	    };
	    CornerMarker.prototype.drawCornerFill = function (ctx) {
	        var sideLength = 10;
	        if (this.over || this.drag) {
	            sideLength = 12;
	        }
	        var hDirection = 1;
	        var vDirection = 1;
	        if (this.horizontalNeighbour.position.x < this.position.x) {
	            hDirection = -1;
	        }
	        if (this.verticalNeighbour.position.y < this.position.y) {
	            vDirection = -1;
	        }
	        ctx.beginPath();
	        ctx.moveTo(this.position.x + this.offset.x, this.position.y + this.offset.y);
	        ctx.lineTo(this.position.x + this.offset.x + (sideLength * hDirection), this.position.y + this.offset.y);
	        ctx.lineTo(this.position.x + this.offset.x + (sideLength * hDirection), this.position.y + this.offset.y +
	            (sideLength * vDirection));
	        ctx.lineTo(this.position.x + this.offset.x, this.position.y + this.offset.y + (sideLength * vDirection));
	        ctx.lineTo(this.position.x + this.offset.x, this.position.y + this.offset.y);
	        ctx.closePath();
	        ctx.fillStyle = "rgba(255,255,255,.7)";
	        ctx.fill();
	    };
	    CornerMarker.prototype.moveX = function (x) {
	        this.setPosition(x, this.position.y);
	    };
	    CornerMarker.prototype.moveY = function (y) {
	        this.setPosition(this.position.x, y);
	    };
	    CornerMarker.prototype.move = function (x, y) {
	        this.setPosition(x, y);
	        this.verticalNeighbour.moveX(x);
	        this.horizontalNeighbour.moveY(y);
	    };
	    CornerMarker.prototype.addHorizontalNeighbour = function (neighbour) {
	        this.horizontalNeighbour = neighbour;
	    };
	    CornerMarker.prototype.addVerticalNeighbour = function (neighbour) {
	        this.verticalNeighbour = neighbour;
	    };
	    CornerMarker.prototype.getHorizontalNeighbour = function () {
	        return this.horizontalNeighbour;
	    };
	    CornerMarker.prototype.getVerticalNeighbour = function () {
	        return this.verticalNeighbour;
	    };
	    CornerMarker.prototype.draw = function (ctx) {
	        this.drawCornerFill(ctx);
	        this.drawCornerBorder(ctx);
	    };
	    return CornerMarker;
	}(handle_1.Handle));
	exports.CornerMarker = CornerMarker;


/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var point_1 = __webpack_require__(103);
	var cropperSettings_1 = __webpack_require__(106);
	var Handle = (function () {
	    function Handle(x, y, radius, settings) {
	        this.cropperSettings = new cropperSettings_1.CropperSettings();
	        this.over = false;
	        this.drag = false;
	        this._position = new point_1.Point(x, y);
	        this.offset = new point_1.Point(0, 0);
	        this.radius = radius;
	        this.cropperSettings = settings;
	    }
	    Handle.prototype.setDrag = function (value) {
	        this.drag = value;
	        this.setOver(value);
	    };
	    Handle.prototype.draw = function (ctx) {
	        // this should't be empty
	    };
	    Handle.prototype.setOver = function (over) {
	        this.over = over;
	    };
	    Handle.prototype.touchInBounds = function (x, y) {
	        return (x > this.position.x - this.radius + this.offset.x) &&
	            (x < this.position.x + this.radius + this.offset.x) &&
	            (y > this.position.y - this.radius + this.offset.y) &&
	            (y < this.position.y + this.radius + this.offset.y);
	    };
	    Object.defineProperty(Handle.prototype, "position", {
	        get: function () {
	            return this._position;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Handle.prototype.setPosition = function (x, y) {
	        this._position.x = x;
	        this._position.y = y;
	    };
	    return Handle;
	}());
	exports.Handle = Handle;


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var cropperDrawSettings_1 = __webpack_require__(107);
	var CropperSettings = (function () {
	    function CropperSettings() {
	        this.canvasWidth = 300;
	        this.canvasHeight = 300;
	        this.dynamicSizing = false;
	        this.width = 200;
	        this.height = 200;
	        this.minWidth = 50;
	        this.minHeight = 50;
	        this.minWithRelativeToResolution = true;
	        this.croppedWidth = 100;
	        this.croppedHeight = 100;
	        this.cropperDrawSettings = new cropperDrawSettings_1.CropperDrawSettings();
	        this.touchRadius = 20;
	        this.noFileInput = false;
	        this.fileType = "png";
	        this.allowedFilesRegex = /\.(jpe?g|png|gif)$/i;
	        this.preserveSize = false;
	        this.compressRatio = 1.0;
	        this.fileInputName = "file";
	        this._rounded = false;
	        this._keepAspect = true;
	        // init
	    }
	    Object.defineProperty(CropperSettings.prototype, "rounded", {
	        get: function () {
	            return this._rounded;
	        },
	        set: function (val) {
	            this._rounded = val;
	            if (val) {
	                this._keepAspect = true;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CropperSettings.prototype, "keepAspect", {
	        get: function () {
	            return this._keepAspect;
	        },
	        set: function (val) {
	            if (val === false && this._rounded) {
	                throw new Error("Cannot set keep aspect to false on rounded cropper. Ellipsis not supported");
	            }
	            this._keepAspect = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return CropperSettings;
	}());
	exports.CropperSettings = CropperSettings;


/***/ },
/* 107 */
/***/ function(module, exports) {

	"use strict";
	var CropperDrawSettings = (function () {
	    function CropperDrawSettings() {
	        this.strokeWidth = 1;
	        this.strokeColor = "rgba(255,255,255,1)";
	        this.dragIconStrokeWidth = 1;
	        this.dragIconStrokeColor = "rgba(0,0,0,1)";
	        this.dragIconFillColor = "rgba(255,255,255,1)";
	    }
	    return CropperDrawSettings;
	}());
	exports.CropperDrawSettings = CropperDrawSettings;


/***/ },
/* 108 */
/***/ function(module, exports) {

	"use strict";
	var CropTouch = (function () {
	    function CropTouch(x, y, id) {
	        if (x === void 0) { x = 0; }
	        if (y === void 0) { y = 0; }
	        if (id === void 0) { id = 0; }
	        this.id = id;
	        this.x = x;
	        this.y = y;
	    }
	    return CropTouch;
	}());
	exports.CropTouch = CropTouch;


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var handle_1 = __webpack_require__(105);
	var pointPool_1 = __webpack_require__(102);
	var DragMarker = (function (_super) {
	    __extends(DragMarker, _super);
	    function DragMarker(x, y, radius, cropperSettings) {
	        _super.call(this, x, y, radius, cropperSettings);
	        this.iconPoints = [];
	        this.scaledIconPoints = [];
	        this.getDragIconPoints(this.iconPoints, 1);
	        this.getDragIconPoints(this.scaledIconPoints, 1.2);
	    }
	    DragMarker.prototype.draw = function (ctx) {
	        if (this.over || this.drag) {
	            this.drawIcon(ctx, this.scaledIconPoints);
	        }
	        else {
	            this.drawIcon(ctx, this.iconPoints);
	        }
	    };
	    DragMarker.prototype.getDragIconPoints = function (arr, scale) {
	        var maxLength = 17 * scale;
	        var arrowWidth = 14 * scale;
	        var arrowLength = 8 * scale;
	        var connectorThroat = 4 * scale;
	        arr.push(pointPool_1.PointPool.instance.borrow(-connectorThroat / 2, maxLength - arrowLength));
	        arr.push(pointPool_1.PointPool.instance.borrow(-arrowWidth / 2, maxLength - arrowLength));
	        arr.push(pointPool_1.PointPool.instance.borrow(0, maxLength));
	        arr.push(pointPool_1.PointPool.instance.borrow(arrowWidth / 2, maxLength - arrowLength));
	        arr.push(pointPool_1.PointPool.instance.borrow(connectorThroat / 2, maxLength - arrowLength));
	        arr.push(pointPool_1.PointPool.instance.borrow(connectorThroat / 2, connectorThroat / 2));
	        arr.push(pointPool_1.PointPool.instance.borrow(maxLength - arrowLength, connectorThroat / 2));
	        arr.push(pointPool_1.PointPool.instance.borrow(maxLength - arrowLength, arrowWidth / 2));
	        arr.push(pointPool_1.PointPool.instance.borrow(maxLength, 0));
	        arr.push(pointPool_1.PointPool.instance.borrow(maxLength - arrowLength, -arrowWidth / 2));
	        arr.push(pointPool_1.PointPool.instance.borrow(maxLength - arrowLength, -connectorThroat / 2));
	        arr.push(pointPool_1.PointPool.instance.borrow(connectorThroat / 2, -connectorThroat / 2));
	        arr.push(pointPool_1.PointPool.instance.borrow(connectorThroat / 2, -maxLength + arrowLength));
	        arr.push(pointPool_1.PointPool.instance.borrow(arrowWidth / 2, -maxLength + arrowLength));
	        arr.push(pointPool_1.PointPool.instance.borrow(0, -maxLength));
	        arr.push(pointPool_1.PointPool.instance.borrow(-arrowWidth / 2, -maxLength + arrowLength));
	        arr.push(pointPool_1.PointPool.instance.borrow(-connectorThroat / 2, -maxLength + arrowLength));
	        arr.push(pointPool_1.PointPool.instance.borrow(-connectorThroat / 2, -connectorThroat / 2));
	        arr.push(pointPool_1.PointPool.instance.borrow(-maxLength + arrowLength, -connectorThroat / 2));
	        arr.push(pointPool_1.PointPool.instance.borrow(-maxLength + arrowLength, -arrowWidth / 2));
	        arr.push(pointPool_1.PointPool.instance.borrow(-maxLength, 0));
	        arr.push(pointPool_1.PointPool.instance.borrow(-maxLength + arrowLength, arrowWidth / 2));
	        arr.push(pointPool_1.PointPool.instance.borrow(-maxLength + arrowLength, connectorThroat / 2));
	        arr.push(pointPool_1.PointPool.instance.borrow(-connectorThroat / 2, connectorThroat / 2));
	    };
	    DragMarker.prototype.drawIcon = function (ctx, points) {
	        ctx.beginPath();
	        ctx.moveTo(points[0].x + this.position.x, points[0].y + this.position.y);
	        for (var k = 0; k < points.length; k++) {
	            var p = points[k];
	            ctx.lineTo(p.x + this.position.x, p.y + this.position.y);
	        }
	        ctx.closePath();
	        ctx.fillStyle = this.cropperSettings.cropperDrawSettings.dragIconFillColor;
	        ctx.fill();
	        ctx.lineWidth = this.cropperSettings.cropperDrawSettings.dragIconStrokeWidth;
	        ctx.strokeStyle = this.cropperSettings.cropperDrawSettings.dragIconStrokeColor;
	        ctx.stroke();
	    };
	    DragMarker.prototype.recalculatePosition = function (bounds) {
	        var c = bounds.getCentre();
	        this.setPosition(c.x, c.y);
	        pointPool_1.PointPool.instance.returnPoint(c);
	    };
	    return DragMarker;
	}(handle_1.Handle));
	exports.DragMarker = DragMarker;


/***/ },
/* 110 */
/***/ function(module, exports) {

	"use strict";
	var ImageCropperModel = (function () {
	    function ImageCropperModel() {
	    }
	    return ImageCropperModel;
	}());
	exports.ImageCropperModel = ImageCropperModel;


/***/ },
/* 111 */
/***/ function(module, exports) {

	"use strict";
	var ImageCropperDataShare = (function () {
	    function ImageCropperDataShare() {
	    }
	    ImageCropperDataShare.setPressed = function (canvas) {
	        this.pressed = canvas;
	    };
	    ;
	    ImageCropperDataShare.setReleased = function (canvas) {
	        if (canvas === this.pressed) {
	        }
	    };
	    ;
	    ImageCropperDataShare.setOver = function (canvas) {
	        this.over = canvas;
	    };
	    ;
	    ImageCropperDataShare.setStyle = function (canvas, style) {
	        if (this.pressed !== undefined) {
	            if (this.pressed === canvas) {
	            }
	        }
	        else {
	            if (canvas === this.over) {
	            }
	        }
	    };
	    ;
	    ImageCropperDataShare.share = {};
	    return ImageCropperDataShare;
	}());
	exports.ImageCropperDataShare = ImageCropperDataShare;


/***/ },
/* 112 */
/***/ function(module, exports) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Fraction = (function (_super) {
	    __extends(Fraction, _super);
	    function Fraction() {
	        _super.apply(this, arguments);
	    }
	    return Fraction;
	}(Number));
	exports.Fraction = Fraction;
	// Console debug wrapper that makes code looks a little bit cleaner
	var Debug = (function () {
	    function Debug() {
	    }
	    Debug.log = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i - 0] = arguments[_i];
	        }
	        if (Exif.debug) {
	            console.log(args);
	        }
	    };
	    return Debug;
	}());
	exports.Debug = Debug;
	var Exif = (function () {
	    function Exif() {
	    }
	    Exif.addEvent = function (element, event, handler) {
	        if (element.addEventListener) {
	            element.addEventListener(event, handler, false);
	        }
	        else {
	            // Hello, IE!
	            if (element.attachEvent) {
	                element.attachEvent("on" + event, handler);
	            }
	        }
	    };
	    Exif.imageHasData = function (img) {
	        return !!(img.exifdata);
	    };
	    Exif.base64ToArrayBuffer = function (base64) {
	        base64 = base64.replace(/^data:([^;]+);base64,/gmi, "");
	        var binary = atob(base64);
	        var len = binary.length;
	        var buffer = new ArrayBuffer(len);
	        var view = new Uint8Array(buffer);
	        for (var i = 0; i < len; i++) {
	            view[i] = binary.charCodeAt(i);
	        }
	        return buffer;
	    };
	    Exif.objectURLToBlob = function (url, callback) {
	        var http = new XMLHttpRequest();
	        http.open("GET", url, true);
	        http.responseType = "blob";
	        http.onload = function () {
	            if (http.status === 200 || http.status === 0) {
	                callback(http.response);
	            }
	        };
	        http.send();
	    };
	    Exif.getImageData = function (img, callback) {
	        function handleBinaryFile(binFile) {
	            var data = Exif.findEXIFinJPEG(binFile);
	            var iptcdata = Exif.findIPTCinJPEG(binFile);
	            img.exifdata = data || {};
	            img.iptcdata = iptcdata || {};
	            if (callback) {
	                callback.call(img);
	            }
	        }
	        if ("src" in img && img.src) {
	            if (/^data:/i.test(img.src)) {
	                var arrayBuffer = Exif.base64ToArrayBuffer(img.src);
	                handleBinaryFile(arrayBuffer);
	            }
	            else {
	                if (/^blob:/i.test(img.src)) {
	                    var fileReader_1 = new FileReader();
	                    fileReader_1.onload = function (e) {
	                        handleBinaryFile(e.target.result);
	                    };
	                    Exif.objectURLToBlob(img.src, function (blob) {
	                        fileReader_1.readAsArrayBuffer(blob);
	                    });
	                }
	                else {
	                    var http_1 = new XMLHttpRequest();
	                    http_1.onload = function () {
	                        if (http_1.status === 200 || http_1.status === 0) {
	                            handleBinaryFile(http_1.response);
	                        }
	                        else {
	                            throw "Could not load image";
	                        }
	                    };
	                    http_1.open("GET", img.src, true);
	                    http_1.responseType = "arraybuffer";
	                    http_1.send(null);
	                }
	            }
	        }
	        else {
	            if (FileReader && (img instanceof Blob || img instanceof File)) {
	                var fileReader = new FileReader();
	                fileReader.onload = function (e) {
	                    Debug.log("Got file of length " + e.target.result.byteLength);
	                    handleBinaryFile(e.target.result);
	                };
	                fileReader.readAsArrayBuffer(img);
	            }
	        }
	    };
	    Exif.findEXIFinJPEG = function (file) {
	        var dataView = new DataView(file);
	        Debug.log("Got file of length " + file.byteLength);
	        if ((dataView.getUint8(0) !== 0xFF) || (dataView.getUint8(1) !== 0xD8)) {
	            Debug.log("Not a valid JPEG");
	            return false; // not a valid jpeg
	        }
	        var offset = 2;
	        var length = file.byteLength;
	        var marker;
	        while (offset < length) {
	            if (dataView.getUint8(offset) !== 0xFF) {
	                Debug.log("Not a valid marker at offset " + offset + ", found: " + dataView.getUint8(offset));
	                return false; // not a valid marker, something is wrong
	            }
	            marker = dataView.getUint8(offset + 1);
	            Debug.log(marker);
	            // we could implement handling for other markers here,
	            // but we're only looking for 0xFFE1 for EXIF data
	            if (marker === 225) {
	                Debug.log("Found 0xFFE1 marker");
	                return Exif.readEXIFData(dataView, offset + 4); // , dataView.getUint16(offset + 2) - 2);
	            }
	            else {
	                offset += 2 + dataView.getUint16(offset + 2);
	            }
	        }
	    };
	    Exif.findIPTCinJPEG = function (file) {
	        var dataView = new DataView(file);
	        Debug.log("Got file of length " + file.byteLength);
	        if ((dataView.getUint8(0) !== 0xFF) || (dataView.getUint8(1) !== 0xD8)) {
	            Debug.log("Not a valid JPEG");
	            return false; // not a valid jpeg
	        }
	        var offset = 2;
	        var length = file.byteLength;
	        var isFieldSegmentStart = function (_dataView, _offset) {
	            return (_dataView.getUint8(_offset) === 0x38 && _dataView.getUint8(_offset + 1) === 0x42 && _dataView.getUint8(_offset + 2) === 0x49 && _dataView.getUint8(_offset + 3) === 0x4D && _dataView.getUint8(_offset + 4) === 0x04 && _dataView.getUint8(_offset + 5) === 0x04);
	        };
	        while (offset < length) {
	            if (isFieldSegmentStart(dataView, offset)) {
	                // Get the length of the name header (which is padded to an even number of bytes)
	                var nameHeaderLength = dataView.getUint8(offset + 7);
	                if (nameHeaderLength % 2 !== 0) {
	                    nameHeaderLength += 1;
	                }
	                // Check for pre photoshop 6 format
	                if (nameHeaderLength === 0) {
	                    // Always 4
	                    nameHeaderLength = 4;
	                }
	                var startOffset = offset + 8 + nameHeaderLength;
	                var sectionLength = dataView.getUint16(offset + 6 + nameHeaderLength);
	                return Exif.readIPTCData(file, startOffset, sectionLength);
	            }
	            // Not the marker, continue searching
	            offset++;
	        }
	    };
	    Exif.readIPTCData = function (file, startOffset, sectionLength) {
	        var dataView = new DataView(file);
	        var data = {};
	        var fieldValue, fieldName, dataSize, segmentType, segmentSize;
	        var segmentStartPos = startOffset;
	        while (segmentStartPos < startOffset + sectionLength) {
	            if (dataView.getUint8(segmentStartPos) === 0x1C && dataView.getUint8(segmentStartPos + 1) === 0x02) {
	                segmentType = dataView.getUint8(segmentStartPos + 2);
	                if (segmentType in Exif.IptcFieldMap) {
	                    dataSize = dataView.getInt16(segmentStartPos + 3);
	                    segmentSize = dataSize + 5;
	                    fieldName = Exif.IptcFieldMap[segmentType];
	                    fieldValue = Exif.getStringFromDB(dataView, segmentStartPos + 5, dataSize);
	                    // Check if we already stored a value with this name
	                    if (data.hasOwnProperty(fieldName)) {
	                        // Value already stored with this name, create multivalue field
	                        if (data[fieldName] instanceof Array) {
	                            data[fieldName].push(fieldValue);
	                        }
	                        else {
	                            data[fieldName] = [data[fieldName], fieldValue];
	                        }
	                    }
	                    else {
	                        data[fieldName] = fieldValue;
	                    }
	                }
	            }
	            segmentStartPos++;
	        }
	        return data;
	    };
	    Exif.readTags = function (file, tiffStart, dirStart, strings, bigEnd) {
	        var entries = file.getUint16(dirStart, !bigEnd);
	        var tags = {};
	        var entryOffset;
	        var tag;
	        for (var i = 0; i < entries; i++) {
	            entryOffset = dirStart + i * 12 + 2;
	            tag = strings[file.getUint16(entryOffset, !bigEnd)];
	            if (!tag) {
	                Debug.log("Unknown tag: " + file.getUint16(entryOffset, !bigEnd));
	            }
	            tags[tag] = Exif.readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd);
	        }
	        return tags;
	    };
	    Exif.readTagValue = function (file, entryOffset, tiffStart, dirStart, bigEnd) {
	        var type = file.getUint16(entryOffset + 2, !bigEnd);
	        var numValues = file.getUint32(entryOffset + 4, !bigEnd);
	        var valueOffset = file.getUint32(entryOffset + 8, !bigEnd) + tiffStart;
	        var offset;
	        var vals, val, n;
	        var numerator;
	        var denominator;
	        switch (type) {
	            case 1: // byte, 8-bit unsigned int
	            case 7:
	                if (numValues === 1) {
	                    return file.getUint8(entryOffset + 8, !bigEnd);
	                }
	                else {
	                    offset = numValues > 4 ? valueOffset : (entryOffset + 8);
	                    vals = [];
	                    for (n = 0; n < numValues; n++) {
	                        vals[n] = file.getUint8(offset + n);
	                    }
	                    return vals;
	                }
	            case 2:
	                offset = numValues > 4 ? valueOffset : (entryOffset + 8);
	                return Exif.getStringFromDB(file, offset, numValues - 1);
	            case 3:
	                if (numValues === 1) {
	                    return file.getUint16(entryOffset + 8, !bigEnd);
	                }
	                else {
	                    offset = numValues > 2 ? valueOffset : (entryOffset + 8);
	                    vals = [];
	                    for (n = 0; n < numValues; n++) {
	                        vals[n] = file.getUint16(offset + 2 * n, !bigEnd);
	                    }
	                    return vals;
	                }
	            case 4:
	                if (numValues === 1) {
	                    return file.getUint32(entryOffset + 8, !bigEnd);
	                }
	                else {
	                    vals = [];
	                    for (n = 0; n < numValues; n++) {
	                        vals[n] = file.getUint32(valueOffset + 4 * n, !bigEnd);
	                    }
	                    return vals;
	                }
	            case 5:
	                if (numValues === 1) {
	                    numerator = file.getUint32(valueOffset, !bigEnd);
	                    denominator = file.getUint32(valueOffset + 4, !bigEnd);
	                    val = new Fraction(numerator / denominator);
	                    val.numerator = numerator;
	                    val.denominator = denominator;
	                    return val;
	                }
	                else {
	                    vals = [];
	                    for (n = 0; n < numValues; n++) {
	                        numerator = file.getUint32(valueOffset + 8 * n, !bigEnd);
	                        denominator = file.getUint32(valueOffset + 4 + 8 * n, !bigEnd);
	                        vals[n] = new Fraction(numerator / denominator);
	                        vals[n].numerator = numerator;
	                        vals[n].denominator = denominator;
	                    }
	                    return vals;
	                }
	            case 9:
	                if (numValues === 1) {
	                    return file.getInt32(entryOffset + 8, !bigEnd);
	                }
	                else {
	                    vals = [];
	                    for (n = 0; n < numValues; n++) {
	                        vals[n] = file.getInt32(valueOffset + 4 * n, !bigEnd);
	                    }
	                    return vals;
	                }
	            case 10:
	                if (numValues === 1) {
	                    return file.getInt32(valueOffset, !bigEnd) / file.getInt32(valueOffset + 4, !bigEnd);
	                }
	                else {
	                    vals = [];
	                    for (n = 0; n < numValues; n++) {
	                        vals[n] = file.getInt32(valueOffset + 8 * n, !bigEnd) / file.getInt32(valueOffset + 4 + 8 * n, !bigEnd);
	                    }
	                    return vals;
	                }
	            default:
	                break;
	        }
	    };
	    Exif.getStringFromDB = function (buffer, start, length) {
	        var outstr = "";
	        for (var n = start; n < start + length; n++) {
	            outstr += String.fromCharCode(buffer.getUint8(n));
	        }
	        return outstr;
	    };
	    Exif.readEXIFData = function (file, start) {
	        if (Exif.getStringFromDB(file, start, 4) !== "Exif") {
	            Debug.log("Not valid EXIF data! " + Exif.getStringFromDB(file, start, 4));
	            return false;
	        }
	        var bigEnd, tags, tag, exifData, gpsData, tiffOffset = start + 6;
	        // test for TIFF validity and endianness
	        if (file.getUint16(tiffOffset) === 0x4949) {
	            bigEnd = false;
	        }
	        else {
	            if (file.getUint16(tiffOffset) === 0x4D4D) {
	                bigEnd = true;
	            }
	            else {
	                Debug.log("Not valid TIFF data! (no 0x4949 or 0x4D4D)");
	                return false;
	            }
	        }
	        if (file.getUint16(tiffOffset + 2, !bigEnd) !== 0x002A) {
	            Debug.log("Not valid TIFF data! (no 0x002A)");
	            return false;
	        }
	        var firstIFDOffset = file.getUint32(tiffOffset + 4, !bigEnd);
	        if (firstIFDOffset < 0x00000008) {
	            Debug.log("Not valid TIFF data! (First offset less than 8)", file.getUint32(tiffOffset + 4, !bigEnd));
	            return false;
	        }
	        tags = Exif.readTags(file, tiffOffset, tiffOffset + firstIFDOffset, Exif.TiffTags, bigEnd);
	        if (tags.ExifIFDPointer) {
	            exifData = Exif.readTags(file, tiffOffset, tiffOffset + tags.ExifIFDPointer, Exif.Tags, bigEnd);
	            for (tag in exifData) {
	                if ({}.hasOwnProperty.call(exifData, tag)) {
	                    switch (tag) {
	                        case "LightSource":
	                        case "Flash":
	                        case "MeteringMode":
	                        case "ExposureProgram":
	                        case "SensingMethod":
	                        case "SceneCaptureType":
	                        case "SceneType":
	                        case "CustomRendered":
	                        case "WhiteBalance":
	                        case "GainControl":
	                        case "Contrast":
	                        case "Saturation":
	                        case "Sharpness":
	                        case "SubjectDistanceRange":
	                        case "FileSource":
	                            exifData[tag] = Exif.StringValues[tag][exifData[tag]];
	                            break;
	                        case "ExifVersion":
	                        case "FlashpixVersion":
	                            exifData[tag] = String.fromCharCode(exifData[tag][0], exifData[tag][1], exifData[tag][2], exifData[tag][3]);
	                            break;
	                        case "ComponentsConfiguration":
	                            var compopents = "Components";
	                            exifData[tag] = Exif.StringValues[compopents][exifData[tag][0]] + Exif.StringValues[compopents][exifData[tag][1]] + Exif.StringValues[compopents][exifData[tag][2]] + Exif.StringValues[compopents][exifData[tag][3]];
	                            break;
	                        default:
	                            break;
	                    }
	                    tags[tag] = exifData[tag];
	                }
	            }
	        }
	        if (tags.GPSInfoIFDPointer) {
	            gpsData = Exif.readTags(file, tiffOffset, tiffOffset + tags.GPSInfoIFDPointer, Exif.GPSTags, bigEnd);
	            for (tag in gpsData) {
	                if ({}.hasOwnProperty.call(gpsData, tag)) {
	                    switch (tag) {
	                        case "GPSVersionID":
	                            gpsData[tag] = gpsData[tag][0] + "." + gpsData[tag][1] + "." + gpsData[tag][2] + "." + gpsData[tag][3];
	                            break;
	                        default:
	                            break;
	                    }
	                    tags[tag] = gpsData[tag];
	                }
	            }
	        }
	        return tags;
	    };
	    Exif.getData = function (img, callback) {
	        if ((img instanceof Image || img instanceof HTMLImageElement) && !img.complete) {
	            return false;
	        }
	        if (!Exif.imageHasData(img)) {
	            Exif.getImageData(img, callback);
	        }
	        else {
	            if (callback) {
	                callback.call(img);
	            }
	        }
	        return true;
	    };
	    Exif.getTag = function (img, tag) {
	        if (!Exif.imageHasData(img)) {
	            return;
	        }
	        return img.exifdata[tag];
	    };
	    ;
	    Exif.getAllTags = function (img) {
	        if (!Exif.imageHasData(img)) {
	            return {};
	        }
	        var a, data = img.exifdata, tags = {};
	        for (a in data) {
	            if (data.hasOwnProperty(a)) {
	                tags[a] = data[a];
	            }
	        }
	        return tags;
	    };
	    ;
	    Exif.pretty = function (img) {
	        if (!Exif.imageHasData(img)) {
	            return "";
	        }
	        var a, data = img.exifdata, strPretty = "";
	        for (a in data) {
	            if (data.hasOwnProperty(a)) {
	                if (typeof data[a] === "object") {
	                    if (data[a] instanceof Number) {
	                        strPretty += a + " : " + data[a] + " [" + data[a].numerator + "/" + data[a].denominator + "]\r\n";
	                    }
	                    else {
	                        strPretty += a + " : [" + data[a].length + " values]\r\n";
	                    }
	                }
	                else {
	                    strPretty += a + " : " + data[a] + "\r\n";
	                }
	            }
	        }
	        return strPretty;
	    };
	    Exif.readFromBinaryFile = function (file) {
	        return Exif.findEXIFinJPEG(file);
	    };
	    Exif.debug = false;
	    Exif.IptcFieldMap = {
	        0x78: "caption",
	        0x6E: "credit",
	        0x19: "keywords",
	        0x37: "dateCreated",
	        0x50: "byline",
	        0x55: "bylineTitle",
	        0x7A: "captionWriter",
	        0x69: "headline",
	        0x74: "copyright",
	        0x0F: "category"
	    };
	    Exif.Tags = {
	        // version tags
	        0x9000: "ExifVersion",
	        0xA000: "FlashpixVersion",
	        // colorspace tags
	        0xA001: "ColorSpace",
	        // image configuration
	        0xA002: "PixelXDimension",
	        0xA003: "PixelYDimension",
	        0x9101: "ComponentsConfiguration",
	        0x9102: "CompressedBitsPerPixel",
	        // user information
	        0x927C: "MakerNote",
	        0x9286: "UserComment",
	        // related file
	        0xA004: "RelatedSoundFile",
	        // date and time
	        0x9003: "DateTimeOriginal",
	        0x9004: "DateTimeDigitized",
	        0x9290: "SubsecTime",
	        0x9291: "SubsecTimeOriginal",
	        0x9292: "SubsecTimeDigitized",
	        // picture-taking conditions
	        0x829A: "ExposureTime",
	        0x829D: "FNumber",
	        0x8822: "ExposureProgram",
	        0x8824: "SpectralSensitivity",
	        0x8827: "ISOSpeedRatings",
	        0x8828: "OECF",
	        0x9201: "ShutterSpeedValue",
	        0x9202: "ApertureValue",
	        0x9203: "BrightnessValue",
	        0x9204: "ExposureBias",
	        0x9205: "MaxApertureValue",
	        0x9206: "SubjectDistance",
	        0x9207: "MeteringMode",
	        0x9208: "LightSource",
	        0x9209: "Flash",
	        0x9214: "SubjectArea",
	        0x920A: "FocalLength",
	        0xA20B: "FlashEnergy",
	        0xA20C: "SpatialFrequencyResponse",
	        0xA20E: "FocalPlaneXResolution",
	        0xA20F: "FocalPlaneYResolution",
	        0xA210: "FocalPlaneResolutionUnit",
	        0xA214: "SubjectLocation",
	        0xA215: "ExposureIndex",
	        0xA217: "SensingMethod",
	        0xA300: "FileSource",
	        0xA301: "SceneType",
	        0xA302: "CFAPattern",
	        0xA401: "CustomRendered",
	        0xA402: "ExposureMode",
	        0xA403: "WhiteBalance",
	        0xA404: "DigitalZoomRation",
	        0xA405: "FocalLengthIn35mmFilm",
	        0xA406: "SceneCaptureType",
	        0xA407: "GainControl",
	        0xA408: "Contrast",
	        0xA409: "Saturation",
	        0xA40A: "Sharpness",
	        0xA40B: "DeviceSettingDescription",
	        0xA40C: "SubjectDistanceRange",
	        // other tags
	        0xA005: "InteroperabilityIFDPointer", 0xA420: "ImageUniqueID" // Identifier assigned uniquely to each image
	    };
	    Exif.TiffTags = {
	        0x0100: "ImageWidth",
	        0x0101: "ImageHeight",
	        0x8769: "ExifIFDPointer",
	        0x8825: "GPSInfoIFDPointer",
	        0xA005: "InteroperabilityIFDPointer",
	        0x0102: "BitsPerSample",
	        0x0103: "Compression",
	        0x0106: "PhotometricInterpretation",
	        0x0112: "Orientation",
	        0x0115: "SamplesPerPixel",
	        0x011C: "PlanarConfiguration",
	        0x0212: "YCbCrSubSampling",
	        0x0213: "YCbCrPositioning",
	        0x011A: "XResolution",
	        0x011B: "YResolution",
	        0x0128: "ResolutionUnit",
	        0x0111: "StripOffsets",
	        0x0116: "RowsPerStrip",
	        0x0117: "StripByteCounts",
	        0x0201: "JPEGInterchangeFormat",
	        0x0202: "JPEGInterchangeFormatLength",
	        0x012D: "TransferFunction",
	        0x013E: "WhitePoint",
	        0x013F: "PrimaryChromaticities",
	        0x0211: "YCbCrCoefficients",
	        0x0214: "ReferenceBlackWhite",
	        0x0132: "DateTime",
	        0x010E: "ImageDescription",
	        0x010F: "Make",
	        0x0110: "Model",
	        0x0131: "Software",
	        0x013B: "Artist",
	        0x8298: "Copyright"
	    };
	    Exif.GPSTags = {
	        0x0000: "GPSVersionID",
	        0x0001: "GPSLatitudeRef",
	        0x0002: "GPSLatitude",
	        0x0003: "GPSLongitudeRef",
	        0x0004: "GPSLongitude",
	        0x0005: "GPSAltitudeRef",
	        0x0006: "GPSAltitude",
	        0x0007: "GPSTimeStamp",
	        0x0008: "GPSSatellites",
	        0x0009: "GPSStatus",
	        0x000A: "GPSMeasureMode",
	        0x000B: "GPSDOP",
	        0x000C: "GPSSpeedRef",
	        0x000D: "GPSSpeed",
	        0x000E: "GPSTrackRef",
	        0x000F: "GPSTrack",
	        0x0010: "GPSImgDirectionRef",
	        0x0011: "GPSImgDirection",
	        0x0012: "GPSMapDatum",
	        0x0013: "GPSDestLatitudeRef",
	        0x0014: "GPSDestLatitude",
	        0x0015: "GPSDestLongitudeRef",
	        0x0016: "GPSDestLongitude",
	        0x0017: "GPSDestBearingRef",
	        0x0018: "GPSDestBearing",
	        0x0019: "GPSDestDistanceRef",
	        0x001A: "GPSDestDistance",
	        0x001B: "GPSProcessingMethod",
	        0x001C: "GPSAreaInformation",
	        0x001D: "GPSDateStamp",
	        0x001E: "GPSDifferential"
	    };
	    Exif.StringValues = {
	        ExposureProgram: {
	            0: "Not defined",
	            1: "Manual",
	            2: "Normal program",
	            3: "Aperture priority",
	            4: "Shutter priority",
	            5: "Creative program",
	            6: "Action program",
	            7: "Portrait mode",
	            8: "Landscape mode"
	        }, MeteringMode: {
	            0: "Unknown",
	            1: "Average",
	            2: "CenterWeightedAverage",
	            3: "Spot",
	            4: "MultiSpot",
	            5: "Pattern",
	            6: "Partial",
	            255: "Other"
	        }, LightSource: {
	            0: "Unknown",
	            1: "Daylight",
	            2: "Fluorescent",
	            3: "Tungsten (incandescent light)",
	            4: "Flash",
	            9: "Fine weather",
	            10: "Cloudy weather",
	            11: "Shade",
	            12: "Daylight fluorescent (D 5700 - 7100K)",
	            13: "Day white fluorescent (N 4600 - 5400K)",
	            14: "Cool white fluorescent (W 3900 - 4500K)",
	            15: "White fluorescent (WW 3200 - 3700K)",
	            17: "Standard light A",
	            18: "Standard light B",
	            19: "Standard light C",
	            20: "D55",
	            21: "D65",
	            22: "D75",
	            23: "D50",
	            24: "ISO studio tungsten",
	            255: "Other"
	        }, Flash: {
	            0x0000: "Flash did not fire",
	            0x0001: "Flash fired",
	            0x0005: "Strobe return light not detected",
	            0x0007: "Strobe return light detected",
	            0x0009: "Flash fired, compulsory flash mode",
	            0x000D: "Flash fired, compulsory flash mode, return light not detected",
	            0x000F: "Flash fired, compulsory flash mode, return light detected",
	            0x0010: "Flash did not fire, compulsory flash mode",
	            0x0018: "Flash did not fire, auto mode",
	            0x0019: "Flash fired, auto mode",
	            0x001D: "Flash fired, auto mode, return light not detected",
	            0x001F: "Flash fired, auto mode, return light detected",
	            0x0020: "No flash function",
	            0x0041: "Flash fired, red-eye reduction mode",
	            0x0045: "Flash fired, red-eye reduction mode, return light not detected",
	            0x0047: "Flash fired, red-eye reduction mode, return light detected",
	            0x0049: "Flash fired, compulsory flash mode, red-eye reduction mode",
	            0x004D: "Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected",
	            0x004F: "Flash fired, compulsory flash mode, red-eye reduction mode, return light detected",
	            0x0059: "Flash fired, auto mode, red-eye reduction mode",
	            0x005D: "Flash fired, auto mode, return light not detected, red-eye reduction mode",
	            0x005F: "Flash fired, auto mode, return light detected, red-eye reduction mode"
	        }, SensingMethod: {
	            1: "Not defined",
	            2: "One-chip color area sensor",
	            3: "Two-chip color area sensor",
	            4: "Three-chip color area sensor",
	            5: "Color sequential area sensor",
	            7: "Trilinear sensor",
	            8: "Color sequential linear sensor"
	        }, SceneCaptureType: {
	            0: "Standard", 1: "Landscape", 2: "Portrait", 3: "Night scene"
	        }, SceneType: {
	            1: "Directly photographed"
	        }, CustomRendered: {
	            0: "Normal process", 1: "Custom process"
	        }, WhiteBalance: {
	            0: "Auto white balance", 1: "Manual white balance"
	        }, GainControl: {
	            0: "None", 1: "Low gain up", 2: "High gain up", 3: "Low gain down", 4: "High gain down"
	        }, Contrast: {
	            0: "Normal", 1: "Soft", 2: "Hard"
	        }, Saturation: {
	            0: "Normal", 1: "Low saturation", 2: "High saturation"
	        }, Sharpness: {
	            0: "Normal", 1: "Soft", 2: "Hard"
	        }, SubjectDistanceRange: {
	            0: "Unknown", 1: "Macro", 2: "Close view", 3: "Distant view"
	        }, FileSource: {
	            3: "DSC"
	        },
	        Components: {
	            0: "", 1: "Y", 2: "Cb", 3: "Cr", 4: "R", 5: "G", 6: "B"
	        }
	    };
	    return Exif;
	}());
	exports.Exif = Exif;


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var bounds_1 = __webpack_require__(101);
	var CropPosition = (function () {
	    function CropPosition(x, y, w, h) {
	        if (x === void 0) { x = 0; }
	        if (y === void 0) { y = 0; }
	        if (w === void 0) { w = 0; }
	        if (h === void 0) { h = 0; }
	        this.x = +x;
	        this.y = +y;
	        this.w = +w;
	        this.h = +h;
	    }
	    CropPosition.prototype.toBounds = function () {
	        return new bounds_1.Bounds(this.x, this.y, this.w, this.h);
	    };
	    CropPosition.prototype.isInitialized = function () {
	        return this.x !== 0 && this.y !== 0 && this.w !== 0 && this.h !== 0;
	    };
	    return CropPosition;
	}());
	exports.CropPosition = CropPosition;


/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(30);
	var Observable_1 = __webpack_require__(5);
	var json = __webpack_require__(95);
	var DashboardService = (function () {
	    function DashboardService(http) {
	        this.http = http;
	        this._elementsUrl = '/elementData';
	        this._profileUrl = '/profileData';
	        this.serverURL = json.api_url;
	    }
	    DashboardService.prototype.getElement = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.get(this.serverURL + this._elementsUrl, options)
	            .toPromise()
	            .then(function (res) { return JSON.parse(res.text()).row[0]; }, this.handleError);
	    };
	    DashboardService.prototype.getProfile = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.get(this.serverURL + this._profileUrl, options)
	            .toPromise()
	            .then(function (res) { return JSON.parse(res.text()); }, this.handleError);
	    };
	    DashboardService.prototype.extractData = function (res) {
	        var body = res.json();
	        return body.data || {};
	    };
	    DashboardService.prototype.editElement = function (element) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        return this.http.put(this.serverURL + this._elementsUrl + "/" + element.id, this.serializeObj(element), {
	            headers: authHeader
	        })
	            .subscribe(function (res) { console.log(res); });
	    };
	    DashboardService.prototype.postName = function (name) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        return this.http.put(this.serverURL + this._elementsUrl + "/name", this.serializeObj({ "comercial_name": name }), {
	            headers: authHeader
	        })
	            .subscribe(function (res) { console.log(res); });
	    };
	    DashboardService.prototype.postDescription = function (description) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        return this.http.put(this.serverURL + this._elementsUrl + "/description", this.serializeObj({ "description": description }), {
	            headers: authHeader
	        })
	            .subscribe(function (res) { console.log(res); });
	    };
	    DashboardService.prototype.editWebSite = function (web) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        return this.http.put(this.serverURL + this._elementsUrl + "/web", this.serializeObj({ "web": web }), {
	            headers: authHeader
	        })
	            .subscribe(function (res) { console.log(res); });
	    };
	    DashboardService.prototype.editFacebookSite = function (facebook) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        return this.http.put(this.serverURL + this._elementsUrl + "/facebook", this.serializeObj({ "facebook": facebook }), {
	            headers: authHeader
	        })
	            .subscribe(function (res) { console.log(res); });
	    };
	    DashboardService.prototype.handleError = function (error) {
	        // In a real world app, we might use a remote logging infrastructure
	        // We'd also dig deeper into the error to get a better message
	        var errMsg = (error.message) ? error.message :
	            error.status ? error.status + " - " + error.statusText : 'Server error';
	        console.error(errMsg); // log to console instead
	        return Observable_1.Observable.throw(errMsg);
	    };
	    DashboardService.prototype.serializeObj = function (obj) {
	        var result = [];
	        for (var property in obj)
	            result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));
	        return result.join("&");
	    };
	    DashboardService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], DashboardService);
	    return DashboardService;
	    var _a;
	}());
	exports.DashboardService = DashboardService;


/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(30);
	var Observable_1 = __webpack_require__(5);
	var json = __webpack_require__(95);
	var ImagesService = (function () {
	    function ImagesService(http) {
	        var _this = this;
	        this.http = http;
	        /**
	         * @type {number}
	         */
	        this.progress = 0;
	        this._fileUrl = '/elementData/photos';
	        this._fileUrlEncoded = '/elementData/photosEncoded';
	        this._fileUrlEncodedMain = '/elementData/photosEncodedMain';
	        this._fileUrlMain = '/elementData/photoMain';
	        this._fileUrlPrice = '/elementData/price';
	        this.progress$ = new Observable_1.Observable(function (observer) {
	            _this.progressObserver = observer;
	        });
	        this.serverURL = json.api_url;
	    }
	    ImagesService.prototype.getImages = function (idElement) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.get(this.serverURL + this._fileUrl + "/" + idElement, options)
	            .toPromise()
	            .then(function (res) { console.log(JSON.parse(res.text()).row); return JSON.parse(res.text()).row; });
	    };
	    ImagesService.prototype.editPrice = function (id, price) {
	        console.log(id, price);
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        return this.http.put(this.serverURL + this._fileUrlPrice + "/" + id, this.serializeObj({ 'price': price }), {
	            headers: authHeader
	        })
	            .subscribe(function (res) { console.log(res); });
	    };
	    ImagesService.prototype.getImageMain = function (idElement) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        console.log(this._fileUrlMain + "/" + idElement);
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.get(this.serverURL + this._fileUrlMain + "/" + idElement, options)
	            .toPromise()
	            .then(function (res) { console.log(JSON.parse(res.text()).row); return JSON.parse(res.text()).row[0]; });
	    };
	    ImagesService.prototype.deleteImage = function (idImage) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.delete(this.serverURL + this._fileUrl + "/" + idImage, options);
	    };
	    /**
	     * @returns {Observable<number>}
	     */
	    ImagesService.prototype.getObserver = function () {
	        return this.progress$;
	    };
	    /**
	     * Upload files through XMLHttpRequest
	     *
	     * @param files
	     * @returns {Promise<T>}
	     */
	    ImagesService.prototype.upload = function (file) {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            var token = localStorage.getItem('token');
	            var formData = new FormData(), xhr = new XMLHttpRequest();
	            xhr.open("POST", _this.serverURL + _this._fileUrl, true);
	            xhr.setRequestHeader('Authorization', 'Bearer ' + token);
	            formData.append("file", file);
	            xhr.onreadystatechange = function () {
	                if (xhr.readyState === 4) {
	                    if (xhr.status === 200) {
	                        resolve(JSON.parse(xhr.response));
	                    }
	                    else {
	                        reject(xhr.response);
	                    }
	                }
	            };
	            ImagesService.setUploadUpdateInterval(500);
	            xhr.upload.onprogress = function (event) {
	                _this.progress = Math.round(event.loaded / event.total * 100);
	                _this.progressObserver.next(_this.progress);
	            };
	            xhr.send(formData);
	        });
	    };
	    ImagesService.prototype.uploadMain = function (file) {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            var token = localStorage.getItem('token');
	            var formData = new FormData(), xhr = new XMLHttpRequest();
	            xhr.open("POST", _this.serverURL + _this._fileUrlMain, true);
	            xhr.setRequestHeader('Authorization', 'Bearer ' + token);
	            formData.append("files[0]", file);
	            xhr.onreadystatechange = function () {
	                if (xhr.readyState === 4) {
	                    if (xhr.status === 200) {
	                        resolve(JSON.parse(xhr.response));
	                    }
	                    else {
	                        reject(xhr.response);
	                    }
	                }
	            };
	            ImagesService.setUploadUpdateInterval(500);
	            xhr.upload.onprogress = function (event) {
	                _this.progress = Math.round(event.loaded / event.total * 100);
	                _this.progressObserver.next(_this.progress);
	            };
	            xhr.send(formData);
	        });
	    };
	    ImagesService.prototype.uploadEncodedMain = function (file) {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            var token = localStorage.getItem('token');
	            var formData = new FormData(), xhr = new XMLHttpRequest();
	            xhr.open("POST", _this.serverURL + _this._fileUrlEncodedMain, true);
	            xhr.setRequestHeader('Authorization', 'Bearer ' + token);
	            xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
	            formData.append("image", file.image);
	            xhr.onreadystatechange = function () {
	                if (xhr.readyState === 4) {
	                    if (xhr.status === 200) {
	                        resolve(JSON.parse(xhr.response));
	                    }
	                    else {
	                        reject(xhr.response);
	                    }
	                }
	            };
	            ImagesService.setUploadUpdateInterval(500);
	            xhr.upload.onprogress = function (event) {
	                _this.progress = Math.round(event.loaded / event.total * 100);
	                _this.progressObserver.next(_this.progress);
	                console.log(_this.progress);
	            };
	            xhr.send(formData);
	        });
	    };
	    ImagesService.prototype.uploadEncoded = function (file, price) {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            var token = localStorage.getItem('token');
	            var formData = new FormData(), xhr = new XMLHttpRequest();
	            xhr.open("POST", _this.serverURL + _this._fileUrlEncoded, true);
	            xhr.setRequestHeader('Authorization', 'Bearer ' + token);
	            xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
	            formData.append("price", price);
	            formData.append("image", file.image);
	            xhr.onreadystatechange = function () {
	                if (xhr.readyState === 4) {
	                    if (xhr.status === 200) {
	                        resolve(JSON.parse(xhr.response));
	                    }
	                    else {
	                        reject(xhr.response);
	                    }
	                }
	            };
	            ImagesService.setUploadUpdateInterval(500);
	            xhr.upload.onprogress = function (event) {
	                _this.progress = Math.round(event.loaded / event.total * 100);
	                _this.progressObserver.next(_this.progress);
	                console.log(_this.progress);
	            };
	            xhr.send(formData);
	        });
	    };
	    ImagesService.prototype.serializeObj = function (obj) {
	        var result = [];
	        for (var property in obj)
	            result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));
	        return result.join("&");
	    };
	    /**
	     * Set interval for frequency with which Observable inside Promise will share data with subscribers.
	     *
	     * @param interval
	     */
	    ImagesService.setUploadUpdateInterval = function (interval) {
	        setInterval(function () { }, interval);
	    };
	    ImagesService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], ImagesService);
	    return ImagesService;
	    var _a;
	}());
	exports.ImagesService = ImagesService;


/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(30);
	var Observable_1 = __webpack_require__(5);
	var json = __webpack_require__(95);
	var DayInformationService = (function () {
	    function DayInformationService(http) {
	        this.http = http;
	        this._elementsUrl = '/elementData';
	        this._dayInformationUrl = '/elementData/dayInformation';
	        this._profileUrl = '/profileData';
	        this.serverURL = json.api_url;
	    }
	    DayInformationService.prototype.getDays = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.get(this.serverURL + this._elementsUrl, options)
	            .toPromise()
	            .then(function (res) { return JSON.parse(res.text()).row[0]; }, this.handleError);
	    };
	    DayInformationService.prototype.getDayLocation = function (day) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.get(this.serverURL + this._dayInformationUrl + "/location/" + day.name, options).toPromise().then(function (res) { return JSON.parse(res.text()); }, this.handleError);
	    };
	    DayInformationService.prototype.editDayInformation = function (day) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        return this.http.put(this.serverURL + this._dayInformationUrl + "/" + day.id, this.serializeObj(day), {
	            headers: authHeader
	        }).toPromise().then(function (res) { return JSON.parse(res.text()); }, this.handleError);
	    };
	    DayInformationService.prototype.getProfile = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.get(this.serverURL + this._profileUrl, options).toPromise().then(function (res) { return JSON.parse(res.text()); }, this.handleError);
	    };
	    DayInformationService.prototype.extractData = function (res) {
	        var body = res.json();
	        return body.data || {};
	    };
	    DayInformationService.prototype.editElement = function (element) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        return this.http.put(this.serverURL + this._elementsUrl + "/" + element.id, this.serializeObj(element), {
	            headers: authHeader
	        })
	            .subscribe(function (res) { console.log(res); });
	    };
	    DayInformationService.prototype.handleError = function (error) {
	        // In a real world app, we might use a remote logging infrastructure
	        // We'd also dig deeper into the error to get a better message
	        var errMsg = (error.message) ? error.message :
	            error.status ? error.status + " - " + error.statusText : 'Server error';
	        console.error(errMsg); // log to console instead
	        return Observable_1.Observable.throw(errMsg);
	    };
	    DayInformationService.prototype.serializeObj = function (obj) {
	        var result = [];
	        for (var property in obj)
	            result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));
	        return result.join("&");
	    };
	    DayInformationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], DayInformationService);
	    return DayInformationService;
	    var _a;
	}());
	exports.DayInformationService = DayInformationService;


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var Observable_1 = __webpack_require__(5);
	var GEOLOCATION_ERRORS = {
	    'errors.location.unsupportedBrowser': 'Browser does not support location services',
	    'errors.location.permissionDenied': 'You have rejected access to your location',
	    'errors.location.positionUnavailable': 'Unable to determine your location',
	    'errors.location.timeout': 'Service timeout has been reached'
	};
	var GeolocationService = (function () {
	    function GeolocationService() {
	    }
	    /**
	     * Obtains the geographic position, in terms of latitude and longitude coordinates, of the device.
	     * @param {Object} [opts] An object literal to specify one or more of the following attributes and desired values:
	     *   - enableHighAccuracy: Specify true to obtain the most accurate position possible, or false to optimize in favor of performance and power consumption.
	     *   - timeout: An Integer value that indicates the time, in milliseconds, allowed for obtaining the position.
	     *              If timeout is Infinity, (the default value) the location request will not time out.
	     *              If timeout is zero (0) or negative, the results depend on the behavior of the location provider.
	     *   - maximumAge: An Integer value indicating the maximum age, in milliseconds, of cached position information.
	     *                 If maximumAge is non-zero, and a cached position that is no older than maximumAge is available, the cached position is used instead of obtaining an updated location.
	     *                 If maximumAge is zero (0), watchPosition always tries to obtain an updated position, even if a cached position is already available.
	     *                 If maximumAge is Infinity, any cached position is used, regardless of its age, and watchPosition only tries to obtain an updated position if no cached position data exists.
	     * @returns {Observable} An observable sequence with the geographical location of the device running the client.
	     */
	    GeolocationService.prototype.getLocation = function () {
	        return Observable_1.Observable.create(function (observer) {
	            if (window.navigator && window.navigator.geolocation) {
	                window.navigator.geolocation.getCurrentPosition(function (position) {
	                    observer.next(position);
	                    observer.complete();
	                });
	            }
	        });
	    };
	    GeolocationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], GeolocationService);
	    return GeolocationService;
	}());
	exports.GeolocationService = GeolocationService;


/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(30);
	var Observable_1 = __webpack_require__(5);
	var json = __webpack_require__(95);
	var TagsService = (function () {
	    function TagsService(http) {
	        this.http = http;
	        this._tagsUrl = '/elementTagsData';
	        this.serverURL = json.api_url;
	    }
	    TagsService.prototype.getTagsOfElement = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.get(this.serverURL + this._tagsUrl, options).toPromise().then(function (res) {
	            if (JSON.parse(res.text()).code == 1) {
	                return JSON.parse(res.text()).rows;
	            }
	        }, this.handleError);
	    };
	    TagsService.prototype.getTagsThatElementHaveNot = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.get(this.serverURL + this._tagsUrl + "/addTags", options).toPromise().then(function (res) {
	            if (JSON.parse(res.text()).code == 1) {
	                return JSON.parse(res.text()).rows;
	            }
	        }, this.handleError);
	    };
	    TagsService.prototype.addTags = function (tags) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        return this.http.post(this.serverURL + this._tagsUrl + "/addTags", this.serializeTags(tags), { headers: authHeader }).toPromise().then(function (result) {
	            return JSON.parse(result.text()).code;
	        }).catch(this.handleError);
	    };
	    TagsService.prototype.deleteTag = function (tag_id) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.delete(this.serverURL + this._tagsUrl + "/" + tag_id, options).toPromise().then(function (result) {
	            return JSON.parse(result.text()).code;
	        }).catch(this.handleError);
	    };
	    TagsService.prototype.handleError = function (error) {
	        // In a real world app, we might use a remote logging infrastructure
	        // We'd also dig deeper into the error to get a better message
	        var errMsg = (error.message) ? error.message :
	            error.status ? error.status + " - " + error.statusText : 'Server error';
	        console.error(errMsg); // log to console instead
	        return Observable_1.Observable.throw(errMsg);
	    };
	    TagsService.prototype.serializeObj = function (obj) {
	        var result = [];
	        for (var property in obj)
	            result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));
	        return result.join("&");
	    };
	    TagsService.prototype.serializeTags = function (tags) {
	        var result = [];
	        for (var i = 0; i < tags.length; i++) {
	            result.push("tags[]=" + tags[i].id);
	        }
	        return result.join("&");
	    };
	    TagsService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], TagsService);
	    return TagsService;
	    var _a;
	}());
	exports.TagsService = TagsService;


/***/ },
/* 119 */
/***/ function(module, exports) {

	"use strict";
	exports.CITIES = [
	    {
	        "id": 1,
	        "name": "Alegría-Dulantzi"
	    },
	    {
	        "id": 2,
	        "name": "Abengibre"
	    },
	    {
	        "id": 3,
	        "name": "Adsubia"
	    },
	    {
	        "id": 4,
	        "name": "Abla"
	    },
	    {
	        "id": 5,
	        "name": "Adanero"
	    },
	    {
	        "id": 6,
	        "name": "Acedera"
	    },
	    {
	        "id": 7,
	        "name": "Alaró"
	    },
	    {
	        "id": 8,
	        "name": "Abrera"
	    },
	    {
	        "id": 9,
	        "name": "Abajas"
	    },
	    {
	        "id": 10,
	        "name": "Abadía"
	    },
	    {
	        "id": 11,
	        "name": "Alcalá de los Gazules"
	    },
	    {
	        "id": 12,
	        "name": "Atzeneta del Maestrat"
	    },
	    {
	        "id": 13,
	        "name": "Abenójar"
	    },
	    {
	        "id": 14,
	        "name": "Adamuz"
	    },
	    {
	        "id": 15,
	        "name": "Abegondo"
	    },
	    {
	        "id": 16,
	        "name": "Abia de la Obispalía"
	    },
	    {
	        "id": 17,
	        "name": "Agullana"
	    },
	    {
	        "id": 18,
	        "name": "Agrón"
	    },
	    {
	        "id": 19,
	        "name": "Abánades"
	    },
	    {
	        "id": 20,
	        "name": "Abaltzisketa"
	    },
	    {
	        "id": 21,
	        "name": "Alájar"
	    },
	    {
	        "id": 22,
	        "name": "Abiego"
	    },
	    {
	        "id": 23,
	        "name": "Albanchez de Mágina"
	    },
	    {
	        "id": 24,
	        "name": "Acebedo"
	    },
	    {
	        "id": 25,
	        "name": "Abella de la Conca"
	    },
	    {
	        "id": 26,
	        "name": "Ábalos"
	    },
	    {
	        "id": 27,
	        "name": "Abadín"
	    },
	    {
	        "id": 28,
	        "name": "La Acebeda"
	    },
	    {
	        "id": 29,
	        "name": "Alameda"
	    },
	    {
	        "id": 30,
	        "name": "Abanilla"
	    },
	    {
	        "id": 31,
	        "name": "Abáigar"
	    },
	    {
	        "id": 32,
	        "name": "Allariz"
	    },
	    {
	        "id": 33,
	        "name": "Allande"
	    },
	    {
	        "id": 34,
	        "name": "Abarca de Campos"
	    },
	    {
	        "id": 35,
	        "name": "Agaete"
	    },
	    {
	        "id": 36,
	        "name": "Arbo"
	    },
	    {
	        "id": 37,
	        "name": "Abusejo"
	    },
	    {
	        "id": 38,
	        "name": "Adeje"
	    },
	    {
	        "id": 39,
	        "name": "Alfoz de Lloredo"
	    },
	    {
	        "id": 40,
	        "name": "Abades"
	    },
	    {
	        "id": 41,
	        "name": "Aguadulce"
	    },
	    {
	        "id": 42,
	        "name": "Abejar"
	    },
	    {
	        "id": 43,
	        "name": "Aiguamúrcia"
	    },
	    {
	        "id": 44,
	        "name": "Ababuj"
	    },
	    {
	        "id": 45,
	        "name": "Ajofrín"
	    },
	    {
	        "id": 46,
	        "name": "Ademuz"
	    },
	    {
	        "id": 47,
	        "name": "Adalia"
	    },
	    {
	        "id": 48,
	        "name": "Abadiño"
	    },
	    {
	        "id": 49,
	        "name": "Abanto"
	    },
	    {
	        "id": 50,
	        "name": "Ceuta"
	    },
	    {
	        "id": 51,
	        "name": "Melilla"
	    },
	    {
	        "id": 52,
	        "name": "Amurrio"
	    },
	    {
	        "id": 53,
	        "name": "Alatoz"
	    },
	    {
	        "id": 54,
	        "name": "Agost"
	    },
	    {
	        "id": 55,
	        "name": "Abrucena"
	    },
	    {
	        "id": 56,
	        "name": "La Adrada"
	    },
	    {
	        "id": 57,
	        "name": "Aceuchal"
	    },
	    {
	        "id": 58,
	        "name": "Alaior"
	    },
	    {
	        "id": 59,
	        "name": "Aguilar de Segarra"
	    },
	    {
	        "id": 60,
	        "name": "Abertura"
	    },
	    {
	        "id": 61,
	        "name": "Alcalá del Valle"
	    },
	    {
	        "id": 62,
	        "name": "Aín"
	    },
	    {
	        "id": 63,
	        "name": "Agudo"
	    },
	    {
	        "id": 64,
	        "name": "Aguilar de la Frontera"
	    },
	    {
	        "id": 65,
	        "name": "Ames"
	    },
	    {
	        "id": 66,
	        "name": "El Acebrón"
	    },
	    {
	        "id": 67,
	        "name": "Aiguaviva"
	    },
	    {
	        "id": 68,
	        "name": "Alamedilla"
	    },
	    {
	        "id": 69,
	        "name": "Ablanque"
	    },
	    {
	        "id": 70,
	        "name": "Aduna"
	    },
	    {
	        "id": 71,
	        "name": "Aljaraque"
	    },
	    {
	        "id": 72,
	        "name": "Abizanda"
	    },
	    {
	        "id": 73,
	        "name": "Alcalá la Real"
	    },
	    {
	        "id": 74,
	        "name": "Algadefe"
	    },
	    {
	        "id": 75,
	        "name": "Àger"
	    },
	    {
	        "id": 76,
	        "name": "Agoncillo"
	    },
	    {
	        "id": 77,
	        "name": "Alfoz"
	    },
	    {
	        "id": 78,
	        "name": "Ajalvir"
	    },
	    {
	        "id": 79,
	        "name": "Alcaucín"
	    },
	    {
	        "id": 80,
	        "name": "Abarán"
	    },
	    {
	        "id": 81,
	        "name": "Abárzuza/Abartzuza"
	    },
	    {
	        "id": 82,
	        "name": "Amoeiro"
	    },
	    {
	        "id": 83,
	        "name": "Aller"
	    },
	    {
	        "id": 84,
	        "name": "Agüimes"
	    },
	    {
	        "id": 85,
	        "name": "Barro"
	    },
	    {
	        "id": 86,
	        "name": "Agallas"
	    },
	    {
	        "id": 87,
	        "name": "Agulo"
	    },
	    {
	        "id": 88,
	        "name": "Ampuero"
	    },
	    {
	        "id": 89,
	        "name": "Adrada de Pirón"
	    },
	    {
	        "id": 90,
	        "name": "Alanís"
	    },
	    {
	        "id": 91,
	        "name": "Albinyana"
	    },
	    {
	        "id": 92,
	        "name": "Abejuela"
	    },
	    {
	        "id": 93,
	        "name": "Alameda de la Sagra"
	    },
	    {
	        "id": 94,
	        "name": "Ador"
	    },
	    {
	        "id": 95,
	        "name": "Aguasal"
	    },
	    {
	        "id": 96,
	        "name": "Abanto y Ciérvana-Abanto Zierbena"
	    },
	    {
	        "id": 97,
	        "name": "Abezames"
	    },
	    {
	        "id": 98,
	        "name": "Acered"
	    },
	    {
	        "id": 99,
	        "name": "Aramaio"
	    },
	    {
	        "id": 100,
	        "name": "Albacete"
	    },
	    {
	        "id": 101,
	        "name": "Agres"
	    },
	    {
	        "id": 102,
	        "name": "Adra"
	    },
	    {
	        "id": 103,
	        "name": "Ahillones"
	    },
	    {
	        "id": 104,
	        "name": "Alcúdia"
	    },
	    {
	        "id": 105,
	        "name": "Alella"
	    },
	    {
	        "id": 106,
	        "name": "Adrada de Haza"
	    },
	    {
	        "id": 107,
	        "name": "Acebo"
	    },
	    {
	        "id": 108,
	        "name": "Algar"
	    },
	    {
	        "id": 109,
	        "name": "Albocàsser"
	    },
	    {
	        "id": 110,
	        "name": "Alamillo"
	    },
	    {
	        "id": 111,
	        "name": "Alcaracejos"
	    },
	    {
	        "id": 112,
	        "name": "Aranga"
	    },
	    {
	        "id": 113,
	        "name": "Alarcón"
	    },
	    {
	        "id": 114,
	        "name": "Albanyà"
	    },
	    {
	        "id": 115,
	        "name": "Albolote"
	    },
	    {
	        "id": 116,
	        "name": "Adobes"
	    },
	    {
	        "id": 117,
	        "name": "Aizarnazabal"
	    },
	    {
	        "id": 118,
	        "name": "El Almendro"
	    },
	    {
	        "id": 119,
	        "name": "Adahuesca"
	    },
	    {
	        "id": 120,
	        "name": "Alcaudete"
	    },
	    {
	        "id": 121,
	        "name": "Alija del Infantado"
	    },
	    {
	        "id": 122,
	        "name": "Agramunt"
	    },
	    {
	        "id": 123,
	        "name": "Aguilar del Río Alhama"
	    },
	    {
	        "id": 124,
	        "name": "Antas de Ulla"
	    },
	    {
	        "id": 125,
	        "name": "Alameda del Valle"
	    },
	    {
	        "id": 126,
	        "name": "Alfarnate"
	    },
	    {
	        "id": 127,
	        "name": "Águilas"
	    },
	    {
	        "id": 128,
	        "name": "Abaurregaina/Abaurrea Alta"
	    },
	    {
	        "id": 129,
	        "name": "A Arnoia"
	    },
	    {
	        "id": 130,
	        "name": "Amieva"
	    },
	    {
	        "id": 131,
	        "name": "Abia de las Torres"
	    },
	    {
	        "id": 132,
	        "name": "Antigua"
	    },
	    {
	        "id": 133,
	        "name": "Baiona"
	    },
	    {
	        "id": 134,
	        "name": "Ahigal de los Aceiteros"
	    },
	    {
	        "id": 135,
	        "name": "Alajeró"
	    },
	    {
	        "id": 136,
	        "name": "Anievas"
	    },
	    {
	        "id": 137,
	        "name": "Adrados"
	    },
	    {
	        "id": 138,
	        "name": "Albaida del Aljarafe"
	    },
	    {
	        "id": 139,
	        "name": "Adradas"
	    },
	    {
	        "id": 140,
	        "name": "L'Albiol"
	    },
	    {
	        "id": 141,
	        "name": "Aguatón"
	    },
	    {
	        "id": 142,
	        "name": "Albarreal de Tajo"
	    },
	    {
	        "id": 143,
	        "name": "Atzeneta d'Albaida"
	    },
	    {
	        "id": 144,
	        "name": "Aguilar de Campos"
	    },
	    {
	        "id": 145,
	        "name": "Amorebieta-Etxano"
	    },
	    {
	        "id": 146,
	        "name": "Alcañices"
	    },
	    {
	        "id": 147,
	        "name": "Agón"
	    },
	    {
	        "id": 148,
	        "name": "Artziniega"
	    },
	    {
	        "id": 149,
	        "name": "Albatana"
	    },
	    {
	        "id": 150,
	        "name": "Aigües"
	    },
	    {
	        "id": 151,
	        "name": "Albánchez"
	    },
	    {
	        "id": 152,
	        "name": "Alange"
	    },
	    {
	        "id": 153,
	        "name": "Algaida"
	    },
	    {
	        "id": 154,
	        "name": "Alpens"
	    },
	    {
	        "id": 155,
	        "name": "Acehúche"
	    },
	    {
	        "id": 156,
	        "name": "Algeciras"
	    },
	    {
	        "id": 157,
	        "name": "Alcalà de Xivert"
	    },
	    {
	        "id": 158,
	        "name": "Albaladejo"
	    },
	    {
	        "id": 159,
	        "name": "Almedinilla"
	    },
	    {
	        "id": 160,
	        "name": "Ares"
	    },
	    {
	        "id": 161,
	        "name": "Albaladejo del Cuende"
	    },
	    {
	        "id": 162,
	        "name": "Albons"
	    },
	    {
	        "id": 163,
	        "name": "Albondón"
	    },
	    {
	        "id": 164,
	        "name": "Alaminos"
	    },
	    {
	        "id": 165,
	        "name": "Albiztur"
	    },
	    {
	        "id": 166,
	        "name": "Almonaster la Real"
	    },
	    {
	        "id": 167,
	        "name": "Agüero"
	    },
	    {
	        "id": 168,
	        "name": "Aldeaquemada"
	    },
	    {
	        "id": 169,
	        "name": "Almanza"
	    },
	    {
	        "id": 170,
	        "name": "Els Alamús"
	    },
	    {
	        "id": 171,
	        "name": "Ajamil de Cameros"
	    },
	    {
	        "id": 172,
	        "name": "Baleira"
	    },
	    {
	        "id": 173,
	        "name": "El Álamo"
	    },
	    {
	        "id": 174,
	        "name": "Alfarnatejo"
	    },
	    {
	        "id": 175,
	        "name": "Albudeite"
	    },
	    {
	        "id": 176,
	        "name": "Abaurrepea/Abaurrea Baja"
	    },
	    {
	        "id": 177,
	        "name": "Avión"
	    },
	    {
	        "id": 178,
	        "name": "Avilés"
	    },
	    {
	        "id": 179,
	        "name": "Aguilar de Campoo"
	    },
	    {
	        "id": 180,
	        "name": "Arrecife"
	    },
	    {
	        "id": 181,
	        "name": "Bueu"
	    },
	    {
	        "id": 182,
	        "name": "Ahigal de Villarino"
	    },
	    {
	        "id": 183,
	        "name": "Arafo"
	    },
	    {
	        "id": 184,
	        "name": "Arenas de Iguña"
	    },
	    {
	        "id": 185,
	        "name": "Aguilafuente"
	    },
	    {
	        "id": 186,
	        "name": "Alcalá de Guadaíra"
	    },
	    {
	        "id": 187,
	        "name": "Ágreda"
	    },
	    {
	        "id": 188,
	        "name": "Alcanar"
	    },
	    {
	        "id": 189,
	        "name": "Aguaviva"
	    },
	    {
	        "id": 190,
	        "name": "Alcabón"
	    },
	    {
	        "id": 191,
	        "name": "Agullent"
	    },
	    {
	        "id": 192,
	        "name": "Alaejos"
	    },
	    {
	        "id": 193,
	        "name": "Amoroto"
	    },
	    {
	        "id": 194,
	        "name": "Alcubilla de Nogales"
	    },
	    {
	        "id": 195,
	        "name": "Aguarón"
	    },
	    {
	        "id": 196,
	        "name": "Alborea"
	    },
	    {
	        "id": 197,
	        "name": "Albatera"
	    },
	    {
	        "id": 198,
	        "name": "Alboloduy"
	    },
	    {
	        "id": 199,
	        "name": "Albornos"
	    },
	    {
	        "id": 200,
	        "name": "La Albuera"
	    },
	    {
	        "id": 201,
	        "name": "Andratx"
	    },
	    {
	        "id": 202,
	        "name": "L'Ametlla del Vallès"
	    },
	    {
	        "id": 203,
	        "name": "Aceituna"
	    },
	    {
	        "id": 204,
	        "name": "Algodonales"
	    },
	    {
	        "id": 205,
	        "name": "l'Alcora"
	    },
	    {
	        "id": 206,
	        "name": "Alcázar de San Juan"
	    },
	    {
	        "id": 207,
	        "name": "Almodóvar del Río"
	    },
	    {
	        "id": 208,
	        "name": "Arteixo"
	    },
	    {
	        "id": 209,
	        "name": "Albalate de las Nogueras"
	    },
	    {
	        "id": 210,
	        "name": "El Far d'Empordà"
	    },
	    {
	        "id": 211,
	        "name": "Albuñán"
	    },
	    {
	        "id": 212,
	        "name": "Alarilla"
	    },
	    {
	        "id": 213,
	        "name": "Alegia"
	    },
	    {
	        "id": 214,
	        "name": "Almonte"
	    },
	    {
	        "id": 215,
	        "name": "Andújar"
	    },
	    {
	        "id": 216,
	        "name": "La Antigua"
	    },
	    {
	        "id": 217,
	        "name": "Alàs i Cerc"
	    },
	    {
	        "id": 218,
	        "name": "Albelda de Iregua"
	    },
	    {
	        "id": 219,
	        "name": "Barreiros"
	    },
	    {
	        "id": 220,
	        "name": "Alcalá de Henares"
	    },
	    {
	        "id": 221,
	        "name": "Algarrobo"
	    },
	    {
	        "id": 222,
	        "name": "Alcantarilla"
	    },
	    {
	        "id": 223,
	        "name": "Aberin"
	    },
	    {
	        "id": 224,
	        "name": "Baltar"
	    },
	    {
	        "id": 225,
	        "name": "Belmonte de Miranda"
	    },
	    {
	        "id": 226,
	        "name": "Alar del Rey"
	    },
	    {
	        "id": 227,
	        "name": "Artenara"
	    },
	    {
	        "id": 228,
	        "name": "Caldas de Reis"
	    },
	    {
	        "id": 229,
	        "name": "La Alameda de Gardón"
	    },
	    {
	        "id": 230,
	        "name": "Arico"
	    },
	    {
	        "id": 231,
	        "name": "Argoños"
	    },
	    {
	        "id": 232,
	        "name": "Alconada de Maderuelo"
	    },
	    {
	        "id": 233,
	        "name": "Alcalá del Río"
	    },
	    {
	        "id": 234,
	        "name": "Alcover"
	    },
	    {
	        "id": 235,
	        "name": "Aguilar del Alfambra"
	    },
	    {
	        "id": 236,
	        "name": "Alcañizo"
	    },
	    {
	        "id": 237,
	        "name": "Alaquàs"
	    },
	    {
	        "id": 238,
	        "name": "Alcazarén"
	    },
	    {
	        "id": 239,
	        "name": "Arakaldo"
	    },
	    {
	        "id": 240,
	        "name": "Alfaraz de Sayago"
	    },
	    {
	        "id": 241,
	        "name": "Aguilón"
	    },
	    {
	        "id": 242,
	        "name": "Armiñón"
	    },
	    {
	        "id": 243,
	        "name": "Alcadozo"
	    },
	    {
	        "id": 244,
	        "name": "Alcalalí"
	    },
	    {
	        "id": 245,
	        "name": "Albox"
	    },
	    {
	        "id": 246,
	        "name": "Alburquerque"
	    },
	    {
	        "id": 247,
	        "name": "Artà"
	    },
	    {
	        "id": 248,
	        "name": "Arenys de Mar"
	    },
	    {
	        "id": 249,
	        "name": "Aguas Cándidas"
	    },
	    {
	        "id": 250,
	        "name": "Ahigal"
	    },
	    {
	        "id": 251,
	        "name": "Arcos de la Frontera"
	    },
	    {
	        "id": 252,
	        "name": "Alcudia de Veo"
	    },
	    {
	        "id": 253,
	        "name": "Alcoba"
	    },
	    {
	        "id": 254,
	        "name": "Añora"
	    },
	    {
	        "id": 255,
	        "name": "Arzúa"
	    },
	    {
	        "id": 256,
	        "name": "Albendea"
	    },
	    {
	        "id": 257,
	        "name": "Alp"
	    },
	    {
	        "id": 258,
	        "name": "Albuñol"
	    },
	    {
	        "id": 259,
	        "name": "Albalate de Zorita"
	    },
	    {
	        "id": 260,
	        "name": "Alkiza"
	    },
	    {
	        "id": 261,
	        "name": "Alosno"
	    },
	    {
	        "id": 262,
	        "name": "Aisa"
	    },
	    {
	        "id": 263,
	        "name": "Arjona"
	    },
	    {
	        "id": 264,
	        "name": "Ardón"
	    },
	    {
	        "id": 265,
	        "name": "L'Albagés"
	    },
	    {
	        "id": 266,
	        "name": "Alberite"
	    },
	    {
	        "id": 267,
	        "name": "Becerreá"
	    },
	    {
	        "id": 268,
	        "name": "Alcobendas"
	    },
	    {
	        "id": 269,
	        "name": "Algatocín"
	    },
	    {
	        "id": 270,
	        "name": "Aledo"
	    },
	    {
	        "id": 271,
	        "name": "Ablitas"
	    },
	    {
	        "id": 272,
	        "name": "Bande"
	    },
	    {
	        "id": 273,
	        "name": "Bimenes"
	    },
	    {
	        "id": 274,
	        "name": "Alba de Cerrato"
	    },
	    {
	        "id": 275,
	        "name": "Arucas"
	    },
	    {
	        "id": 276,
	        "name": "Cambados"
	    },
	    {
	        "id": 277,
	        "name": "La Alamedilla"
	    },
	    {
	        "id": 278,
	        "name": "Arona"
	    },
	    {
	        "id": 279,
	        "name": "Arnuero"
	    },
	    {
	        "id": 280,
	        "name": "Aldealcorvo"
	    },
	    {
	        "id": 281,
	        "name": "Alcolea del Río"
	    },
	    {
	        "id": 282,
	        "name": "Alconaba"
	    },
	    {
	        "id": 283,
	        "name": "Aldover"
	    },
	    {
	        "id": 284,
	        "name": "Alacón"
	    },
	    {
	        "id": 285,
	        "name": "Alcaudete de la Jara"
	    },
	    {
	        "id": 286,
	        "name": "Albaida"
	    },
	    {
	        "id": 287,
	        "name": "Aldea de San Miguel"
	    },
	    {
	        "id": 288,
	        "name": "Arantzazu"
	    },
	    {
	        "id": 289,
	        "name": "Algodre"
	    },
	    {
	        "id": 290,
	        "name": "Ainzón"
	    },
	    {
	        "id": 291,
	        "name": "Alcalá del Júcar"
	    },
	    {
	        "id": 292,
	        "name": "Alcocer de Planes"
	    },
	    {
	        "id": 293,
	        "name": "Alcolea"
	    },
	    {
	        "id": 294,
	        "name": "Aldeanueva de Santa Cruz"
	    },
	    {
	        "id": 295,
	        "name": "Alconchel"
	    },
	    {
	        "id": 296,
	        "name": "Banyalbufar"
	    },
	    {
	        "id": 297,
	        "name": "Arenys de Munt"
	    },
	    {
	        "id": 298,
	        "name": "Aguilar de Bureba"
	    },
	    {
	        "id": 299,
	        "name": "Albalá"
	    },
	    {
	        "id": 300,
	        "name": "Barbate"
	    },
	    {
	        "id": 301,
	        "name": "Alfondeguilla"
	    },
	    {
	        "id": 302,
	        "name": "Alcolea de Calatrava"
	    },
	    {
	        "id": 303,
	        "name": "Baena"
	    },
	    {
	        "id": 304,
	        "name": "A Baña"
	    },
	    {
	        "id": 305,
	        "name": "La Alberca de Záncara"
	    },
	    {
	        "id": 306,
	        "name": "Amer"
	    },
	    {
	        "id": 307,
	        "name": "Albuñuelas"
	    },
	    {
	        "id": 308,
	        "name": "Albares"
	    },
	    {
	        "id": 309,
	        "name": "Altzo"
	    },
	    {
	        "id": 310,
	        "name": "Aracena"
	    },
	    {
	        "id": 311,
	        "name": "Albalate de Cinca"
	    },
	    {
	        "id": 312,
	        "name": "Arjonilla"
	    },
	    {
	        "id": 313,
	        "name": "Arganza"
	    },
	    {
	        "id": 314,
	        "name": "Albatàrrec"
	    },
	    {
	        "id": 315,
	        "name": "Alcanadre"
	    },
	    {
	        "id": 316,
	        "name": "Begonte"
	    },
	    {
	        "id": 317,
	        "name": "Alcorcón"
	    },
	    {
	        "id": 318,
	        "name": "Alhaurín de la Torre"
	    },
	    {
	        "id": 319,
	        "name": "Alguazas"
	    },
	    {
	        "id": 320,
	        "name": "Adiós"
	    },
	    {
	        "id": 321,
	        "name": "Baños de Molgas"
	    },
	    {
	        "id": 322,
	        "name": "Boal"
	    },
	    {
	        "id": 323,
	        "name": "Betancuria"
	    },
	    {
	        "id": 324,
	        "name": "Campo Lameiro"
	    },
	    {
	        "id": 325,
	        "name": "Alaraz"
	    },
	    {
	        "id": 326,
	        "name": "Barlovento"
	    },
	    {
	        "id": 327,
	        "name": "Arredondo"
	    },
	    {
	        "id": 328,
	        "name": "Aldealengua de Pedraza"
	    },
	    {
	        "id": 329,
	        "name": "La Algaba"
	    },
	    {
	        "id": 330,
	        "name": "Alcubilla de Avellaneda"
	    },
	    {
	        "id": 331,
	        "name": "L'Aleixar"
	    },
	    {
	        "id": 332,
	        "name": "Alba"
	    },
	    {
	        "id": 333,
	        "name": "Alcolea de Tajo"
	    },
	    {
	        "id": 334,
	        "name": "Albal"
	    },
	    {
	        "id": 335,
	        "name": "Aldeamayor de San Martín"
	    },
	    {
	        "id": 336,
	        "name": "Munitibar-Arbatzegi Gerrikaitz"
	    },
	    {
	        "id": 337,
	        "name": "Almaraz de Duero"
	    },
	    {
	        "id": 338,
	        "name": "Aladrén"
	    },
	    {
	        "id": 339,
	        "name": "Arrazua-Ubarrundia"
	    },
	    {
	        "id": 340,
	        "name": "Alcaraz"
	    },
	    {
	        "id": 341,
	        "name": "Alcoleja"
	    },
	    {
	        "id": 342,
	        "name": "Alcóntar"
	    },
	    {
	        "id": 343,
	        "name": "Aldeaseca"
	    },
	    {
	        "id": 344,
	        "name": "Alconera"
	    },
	    {
	        "id": 345,
	        "name": "Binissalem"
	    },
	    {
	        "id": 346,
	        "name": "Argençola"
	    },
	    {
	        "id": 347,
	        "name": "Alcántara"
	    },
	    {
	        "id": 348,
	        "name": "Los Barrios"
	    },
	    {
	        "id": 349,
	        "name": "Algimia de Almonacid"
	    },
	    {
	        "id": 350,
	        "name": "Alcubillas"
	    },
	    {
	        "id": 351,
	        "name": "Belalcázar"
	    },
	    {
	        "id": 352,
	        "name": "Bergondo"
	    },
	    {
	        "id": 353,
	        "name": "Alcalá de la Vega"
	    },
	    {
	        "id": 354,
	        "name": "Anglès"
	    },
	    {
	        "id": 355,
	        "name": "Albendiego"
	    },
	    {
	        "id": 356,
	        "name": "Amezketa"
	    },
	    {
	        "id": 357,
	        "name": "Aroche"
	    },
	    {
	        "id": 358,
	        "name": "Albalatillo"
	    },
	    {
	        "id": 359,
	        "name": "Arquillos"
	    },
	    {
	        "id": 360,
	        "name": "Astorga"
	    },
	    {
	        "id": 361,
	        "name": "Albesa"
	    },
	    {
	        "id": 362,
	        "name": "Aldeanueva de Ebro"
	    },
	    {
	        "id": 363,
	        "name": "Bóveda"
	    },
	    {
	        "id": 364,
	        "name": "Aldea del Fresno"
	    },
	    {
	        "id": 365,
	        "name": "Alhaurín el Grande"
	    },
	    {
	        "id": 366,
	        "name": "Alhama de Murcia"
	    },
	    {
	        "id": 367,
	        "name": "Aguilar de Codés"
	    },
	    {
	        "id": 368,
	        "name": "Barbadás"
	    },
	    {
	        "id": 369,
	        "name": "Cabrales"
	    },
	    {
	        "id": 370,
	        "name": "Firgas"
	    },
	    {
	        "id": 371,
	        "name": "Cangas"
	    },
	    {
	        "id": 372,
	        "name": "Alba de Tormes"
	    },
	    {
	        "id": 373,
	        "name": "Breña Alta"
	    },
	    {
	        "id": 374,
	        "name": "El Astillero"
	    },
	    {
	        "id": 375,
	        "name": "Aldealengua de Santa María"
	    },
	    {
	        "id": 376,
	        "name": "Algámitas"
	    },
	    {
	        "id": 377,
	        "name": "Alcubilla de las Peñas"
	    },
	    {
	        "id": 378,
	        "name": "Alfara de Carles"
	    },
	    {
	        "id": 379,
	        "name": "Albalate del Arzobispo"
	    },
	    {
	        "id": 380,
	        "name": "Aldea en Cabo"
	    },
	    {
	        "id": 381,
	        "name": "Albalat de la Ribera"
	    },
	    {
	        "id": 382,
	        "name": "Almenara de Adaja"
	    },
	    {
	        "id": 383,
	        "name": "Artzentales"
	    },
	    {
	        "id": 384,
	        "name": "Almeida de Sayago"
	    },
	    {
	        "id": 385,
	        "name": "Alagón"
	    },
	    {
	        "id": 386,
	        "name": "Asparrena"
	    },
	    {
	        "id": 387,
	        "name": "Almansa"
	    },
	    {
	        "id": 388,
	        "name": "Alcoy/Alcoi"
	    },
	    {
	        "id": 389,
	        "name": "Alcudia de Monteagud"
	    },
	    {
	        "id": 390,
	        "name": "Aljucén"
	    },
	    {
	        "id": 391,
	        "name": "Búger"
	    },
	    {
	        "id": 392,
	        "name": "Argentona"
	    },
	    {
	        "id": 393,
	        "name": "Albillos"
	    },
	    {
	        "id": 394,
	        "name": "Alcollarín"
	    },
	    {
	        "id": 395,
	        "name": "Benaocaz"
	    },
	    {
	        "id": 396,
	        "name": "Almazora/Almassora"
	    },
	    {
	        "id": 397,
	        "name": "Aldea del Rey"
	    },
	    {
	        "id": 398,
	        "name": "Belmez"
	    },
	    {
	        "id": 399,
	        "name": "Betanzos"
	    },
	    {
	        "id": 400,
	        "name": "Alcantud"
	    },
	    {
	        "id": 401,
	        "name": "Arbúcies"
	    },
	    {
	        "id": 402,
	        "name": "Alcocer"
	    },
	    {
	        "id": 403,
	        "name": "Andoain"
	    },
	    {
	        "id": 404,
	        "name": "Arroyomolinos de León"
	    },
	    {
	        "id": 405,
	        "name": "Albelda"
	    },
	    {
	        "id": 406,
	        "name": "Baeza"
	    },
	    {
	        "id": 407,
	        "name": "Balboa"
	    },
	    {
	        "id": 408,
	        "name": "L'Albi"
	    },
	    {
	        "id": 409,
	        "name": "Alesanco"
	    },
	    {
	        "id": 410,
	        "name": "Carballedo"
	    },
	    {
	        "id": 411,
	        "name": "Algete"
	    },
	    {
	        "id": 412,
	        "name": "Almáchar"
	    },
	    {
	        "id": 413,
	        "name": "Archena"
	    },
	    {
	        "id": 414,
	        "name": "Aibar/Oibar"
	    },
	    {
	        "id": 415,
	        "name": "O Barco de Valdeorras"
	    },
	    {
	        "id": 416,
	        "name": "Cabranes"
	    },
	    {
	        "id": 417,
	        "name": "Amayuelas de Arriba"
	    },
	    {
	        "id": 418,
	        "name": "Gáldar"
	    },
	    {
	        "id": 419,
	        "name": "A Cañiza"
	    },
	    {
	        "id": 420,
	        "name": "Alba de Yeltes"
	    },
	    {
	        "id": 421,
	        "name": "Breña Baja"
	    },
	    {
	        "id": 422,
	        "name": "Bárcena de Cicero"
	    },
	    {
	        "id": 423,
	        "name": "Aldeanueva de la Serrezuela"
	    },
	    {
	        "id": 424,
	        "name": "Almadén de la Plata"
	    },
	    {
	        "id": 425,
	        "name": "Aldealafuente"
	    },
	    {
	        "id": 426,
	        "name": "Alforja"
	    },
	    {
	        "id": 427,
	        "name": "Albarracín"
	    },
	    {
	        "id": 428,
	        "name": "Aldeanueva de Barbarroya"
	    },
	    {
	        "id": 429,
	        "name": "Albalat dels Sorells"
	    },
	    {
	        "id": 430,
	        "name": "Amusquillo"
	    },
	    {
	        "id": 431,
	        "name": "Arrankudiaga"
	    },
	    {
	        "id": 432,
	        "name": "Andavías"
	    },
	    {
	        "id": 433,
	        "name": "Alarba"
	    },
	    {
	        "id": 434,
	        "name": "Ayala/Aiara"
	    },
	    {
	        "id": 435,
	        "name": "Alpera"
	    },
	    {
	        "id": 436,
	        "name": "Alfafara"
	    },
	    {
	        "id": 437,
	        "name": "Alhabia"
	    },
	    {
	        "id": 438,
	        "name": "La Aldehuela"
	    },
	    {
	        "id": 439,
	        "name": "Almendral"
	    },
	    {
	        "id": 440,
	        "name": "Bunyola"
	    },
	    {
	        "id": 441,
	        "name": "Artés"
	    },
	    {
	        "id": 442,
	        "name": "Alcocero de Mola"
	    },
	    {
	        "id": 443,
	        "name": "Alcuéscar"
	    },
	    {
	        "id": 444,
	        "name": "Bornos"
	    },
	    {
	        "id": 445,
	        "name": "Almedíjar"
	    },
	    {
	        "id": 446,
	        "name": "Alhambra"
	    },
	    {
	        "id": 447,
	        "name": "Benamejí"
	    },
	    {
	        "id": 448,
	        "name": "Boimorto"
	    },
	    {
	        "id": 449,
	        "name": "Alcázar del Rey"
	    },
	    {
	        "id": 450,
	        "name": "Argelaguer"
	    },
	    {
	        "id": 451,
	        "name": "Aldeire"
	    },
	    {
	        "id": 452,
	        "name": "Alcolea de las Peñas"
	    },
	    {
	        "id": 453,
	        "name": "Anoeta"
	    },
	    {
	        "id": 454,
	        "name": "Ayamonte"
	    },
	    {
	        "id": 455,
	        "name": "Bailén"
	    },
	    {
	        "id": 456,
	        "name": "La Bañeza"
	    },
	    {
	        "id": 457,
	        "name": "Alcanó"
	    },
	    {
	        "id": 458,
	        "name": "Alesón"
	    },
	    {
	        "id": 459,
	        "name": "Castro de Rei"
	    },
	    {
	        "id": 460,
	        "name": "Alpedrete"
	    },
	    {
	        "id": 461,
	        "name": "Almargen"
	    },
	    {
	        "id": 462,
	        "name": "Beniel"
	    },
	    {
	        "id": 463,
	        "name": "Altsasu/Alsasua"
	    },
	    {
	        "id": 464,
	        "name": "Beade"
	    },
	    {
	        "id": 465,
	        "name": "Candamo"
	    },
	    {
	        "id": 466,
	        "name": "Ampudia"
	    },
	    {
	        "id": 467,
	        "name": "Haría"
	    },
	    {
	        "id": 468,
	        "name": "Catoira"
	    },
	    {
	        "id": 469,
	        "name": "La Alberca"
	    },
	    {
	        "id": 470,
	        "name": "Buenavista del Norte"
	    },
	    {
	        "id": 471,
	        "name": "Bárcena de Pie de Concha"
	    },
	    {
	        "id": 472,
	        "name": "Aldeanueva del Codonal"
	    },
	    {
	        "id": 473,
	        "name": "Almensilla"
	    },
	    {
	        "id": 474,
	        "name": "Aldealices"
	    },
	    {
	        "id": 475,
	        "name": "Alió"
	    },
	    {
	        "id": 476,
	        "name": "Albentosa"
	    },
	    {
	        "id": 477,
	        "name": "Aldeanueva de San Bartolomé"
	    },
	    {
	        "id": 478,
	        "name": "Albalat dels Tarongers"
	    },
	    {
	        "id": 479,
	        "name": "Arroyo de la Encomienda"
	    },
	    {
	        "id": 480,
	        "name": "Arrieta"
	    },
	    {
	        "id": 481,
	        "name": "Arcenillas"
	    },
	    {
	        "id": 482,
	        "name": "Alberite de San Juan"
	    },
	    {
	        "id": 483,
	        "name": "Baños de Ebro/Mañueta"
	    },
	    {
	        "id": 484,
	        "name": "Ayna"
	    },
	    {
	        "id": 485,
	        "name": "l'Alfàs del Pi"
	    },
	    {
	        "id": 486,
	        "name": "Alhama de Almería"
	    },
	    {
	        "id": 487,
	        "name": "Almendralejo"
	    },
	    {
	        "id": 488,
	        "name": "Calvià"
	    },
	    {
	        "id": 489,
	        "name": "Avià"
	    },
	    {
	        "id": 490,
	        "name": "Alfoz de Bricia"
	    },
	    {
	        "id": 491,
	        "name": "Aldeacentenera"
	    },
	    {
	        "id": 492,
	        "name": "El Bosque"
	    },
	    {
	        "id": 493,
	        "name": "Almenara"
	    },
	    {
	        "id": 494,
	        "name": "Almadén"
	    },
	    {
	        "id": 495,
	        "name": "Los Blázquez"
	    },
	    {
	        "id": 496,
	        "name": "Boiro"
	    },
	    {
	        "id": 497,
	        "name": "Alcohujate"
	    },
	    {
	        "id": 498,
	        "name": "L'Armentera"
	    },
	    {
	        "id": 499,
	        "name": "Alfacar"
	    },
	    {
	        "id": 500,
	        "name": "Alcolea del Pinar"
	    },
	    {
	        "id": 501,
	        "name": "Antzuola"
	    },
	    {
	        "id": 502,
	        "name": "Beas"
	    },
	    {
	        "id": 503,
	        "name": "Albero Alto"
	    },
	    {
	        "id": 504,
	        "name": "Baños de la Encina"
	    },
	    {
	        "id": 505,
	        "name": "Barjas"
	    },
	    {
	        "id": 506,
	        "name": "Alcarràs"
	    },
	    {
	        "id": 507,
	        "name": "Alfaro"
	    },
	    {
	        "id": 508,
	        "name": "Castroverde"
	    },
	    {
	        "id": 509,
	        "name": "Ambite"
	    },
	    {
	        "id": 510,
	        "name": "Almogía"
	    },
	    {
	        "id": 511,
	        "name": "Blanca"
	    },
	    {
	        "id": 512,
	        "name": "Allín/Allin"
	    },
	    {
	        "id": 513,
	        "name": "Beariz"
	    },
	    {
	        "id": 514,
	        "name": "Cangas del Narcea"
	    },
	    {
	        "id": 515,
	        "name": "Amusco"
	    },
	    {
	        "id": 516,
	        "name": "Ingenio"
	    },
	    {
	        "id": 517,
	        "name": "Cerdedo"
	    },
	    {
	        "id": 518,
	        "name": "La Alberguería de Argañán"
	    },
	    {
	        "id": 519,
	        "name": "Candelaria"
	    },
	    {
	        "id": 520,
	        "name": "Bareyo"
	    },
	    {
	        "id": 521,
	        "name": "Arahal"
	    },
	    {
	        "id": 522,
	        "name": "Aldealpozo"
	    },
	    {
	        "id": 523,
	        "name": "Almoster"
	    },
	    {
	        "id": 524,
	        "name": "Alcaine"
	    },
	    {
	        "id": 525,
	        "name": "Almendral de la Cañada"
	    },
	    {
	        "id": 526,
	        "name": "Alberic"
	    },
	    {
	        "id": 527,
	        "name": "Ataquines"
	    },
	    {
	        "id": 528,
	        "name": "Arrigorriaga"
	    },
	    {
	        "id": 529,
	        "name": "Arcos de la Polvorosa"
	    },
	    {
	        "id": 530,
	        "name": "Albeta"
	    },
	    {
	        "id": 531,
	        "name": "Balazote"
	    },
	    {
	        "id": 532,
	        "name": "Algorfa"
	    },
	    {
	        "id": 533,
	        "name": "Alicún"
	    },
	    {
	        "id": 534,
	        "name": "Amavida"
	    },
	    {
	        "id": 535,
	        "name": "Arroyo de San Serván"
	    },
	    {
	        "id": 536,
	        "name": "Campanet"
	    },
	    {
	        "id": 537,
	        "name": "Avinyó"
	    },
	    {
	        "id": 538,
	        "name": "Alfoz de Santa Gadea"
	    },
	    {
	        "id": 539,
	        "name": "Aldea del Cano"
	    },
	    {
	        "id": 540,
	        "name": "Cádiz"
	    },
	    {
	        "id": 541,
	        "name": "Altura"
	    },
	    {
	        "id": 542,
	        "name": "Almadenejos"
	    },
	    {
	        "id": 543,
	        "name": "Bujalance"
	    },
	    {
	        "id": 544,
	        "name": "Boqueixón"
	    },
	    {
	        "id": 545,
	        "name": "Alconchel de la Estrella"
	    },
	    {
	        "id": 546,
	        "name": "Avinyonet de Puigventós"
	    },
	    {
	        "id": 547,
	        "name": "Algarinejo"
	    },
	    {
	        "id": 548,
	        "name": "Arama"
	    },
	    {
	        "id": 549,
	        "name": "Berrocal"
	    },
	    {
	        "id": 550,
	        "name": "Albero Bajo"
	    },
	    {
	        "id": 551,
	        "name": "Beas de Segura"
	    },
	    {
	        "id": 552,
	        "name": "Los Barrios de Luna"
	    },
	    {
	        "id": 553,
	        "name": "Alcoletge"
	    },
	    {
	        "id": 554,
	        "name": "Almarza de Cameros"
	    },
	    {
	        "id": 555,
	        "name": "Cervantes"
	    },
	    {
	        "id": 556,
	        "name": "Anchuelo"
	    },
	    {
	        "id": 557,
	        "name": "Álora"
	    },
	    {
	        "id": 558,
	        "name": "Bullas"
	    },
	    {
	        "id": 559,
	        "name": "Allo"
	    },
	    {
	        "id": 560,
	        "name": "Os Blancos"
	    },
	    {
	        "id": 561,
	        "name": "Cangas de Onís"
	    },
	    {
	        "id": 562,
	        "name": "Antigüedad"
	    },
	    {
	        "id": 563,
	        "name": "Mogán"
	    },
	    {
	        "id": 564,
	        "name": "Cotobade"
	    },
	    {
	        "id": 565,
	        "name": "Alconada"
	    },
	    {
	        "id": 566,
	        "name": "Fasnia"
	    },
	    {
	        "id": 567,
	        "name": "Cabezón de la Sal"
	    },
	    {
	        "id": 568,
	        "name": "Aldea Real"
	    },
	    {
	        "id": 569,
	        "name": "Aznalcázar"
	    },
	    {
	        "id": 570,
	        "name": "Aldealseñor"
	    },
	    {
	        "id": 571,
	        "name": "Altafulla"
	    },
	    {
	        "id": 572,
	        "name": "Alcalá de la Selva"
	    },
	    {
	        "id": 573,
	        "name": "Almonacid de Toledo"
	    },
	    {
	        "id": 574,
	        "name": "Alborache"
	    },
	    {
	        "id": 575,
	        "name": "Bahabón"
	    },
	    {
	        "id": 576,
	        "name": "Bakio"
	    },
	    {
	        "id": 577,
	        "name": "Argañín"
	    },
	    {
	        "id": 578,
	        "name": "Alborge"
	    },
	    {
	        "id": 579,
	        "name": "Barrundia"
	    },
	    {
	        "id": 580,
	        "name": "Balsa de Ves"
	    },
	    {
	        "id": 581,
	        "name": "Algueña"
	    },
	    {
	        "id": 582,
	        "name": "Almería"
	    },
	    {
	        "id": 583,
	        "name": "El Arenal"
	    },
	    {
	        "id": 584,
	        "name": "Atalaya"
	    },
	    {
	        "id": 585,
	        "name": "Campos"
	    },
	    {
	        "id": 586,
	        "name": "Avinyonet del Penedès"
	    },
	    {
	        "id": 587,
	        "name": "Altable"
	    },
	    {
	        "id": 588,
	        "name": "La Aldea del Obispo"
	    },
	    {
	        "id": 589,
	        "name": "Castellar de la Frontera"
	    },
	    {
	        "id": 590,
	        "name": "Arañuel"
	    },
	    {
	        "id": 591,
	        "name": "Almagro"
	    },
	    {
	        "id": 592,
	        "name": "Cabra"
	    },
	    {
	        "id": 593,
	        "name": "Brión"
	    },
	    {
	        "id": 594,
	        "name": "Algarra"
	    },
	    {
	        "id": 595,
	        "name": "Begur"
	    },
	    {
	        "id": 596,
	        "name": "Alhama de Granada"
	    },
	    {
	        "id": 597,
	        "name": "Alcoroches"
	    },
	    {
	        "id": 598,
	        "name": "Aretxabaleta"
	    },
	    {
	        "id": 599,
	        "name": "Bollullos Par del Condado"
	    },
	    {
	        "id": 600,
	        "name": "Alberuela de Tubo"
	    },
	    {
	        "id": 601,
	        "name": "Alfarràs"
	    },
	    {
	        "id": 602,
	        "name": "Anguciana"
	    },
	    {
	        "id": 603,
	        "name": "Cervo"
	    },
	    {
	        "id": 604,
	        "name": "Aranjuez"
	    },
	    {
	        "id": 605,
	        "name": "Alozaina"
	    },
	    {
	        "id": 606,
	        "name": "Calasparra"
	    },
	    {
	        "id": 607,
	        "name": "Améscoa Baja"
	    },
	    {
	        "id": 608,
	        "name": "Boborás"
	    },
	    {
	        "id": 609,
	        "name": "Caravia"
	    },
	    {
	        "id": 610,
	        "name": "Moya"
	    },
	    {
	        "id": 611,
	        "name": "Covelo"
	    },
	    {
	        "id": 612,
	        "name": "Aldeacipreste"
	    },
	    {
	        "id": 613,
	        "name": "Frontera"
	    },
	    {
	        "id": 614,
	        "name": "Cabezón de Liébana"
	    },
	    {
	        "id": 615,
	        "name": "Aldeasoña"
	    },
	    {
	        "id": 616,
	        "name": "Aznalcóllar"
	    },
	    {
	        "id": 617,
	        "name": "Aldehuela de Periáñez"
	    },
	    {
	        "id": 618,
	        "name": "L'Ametlla de Mar"
	    },
	    {
	        "id": 619,
	        "name": "Alcañiz"
	    },
	    {
	        "id": 620,
	        "name": "Almorox"
	    },
	    {
	        "id": 621,
	        "name": "Alboraya"
	    },
	    {
	        "id": 622,
	        "name": "Barcial de la Loma"
	    },
	    {
	        "id": 623,
	        "name": "Barakaldo"
	    },
	    {
	        "id": 624,
	        "name": "Argujillo"
	    },
	    {
	        "id": 625,
	        "name": "Alcalá de Ebro"
	    },
	    {
	        "id": 626,
	        "name": "Berantevilla"
	    },
	    {
	        "id": 627,
	        "name": "El Ballestero"
	    },
	    {
	        "id": 628,
	        "name": "Alicante/Alacant"
	    },
	    {
	        "id": 629,
	        "name": "Almócita"
	    },
	    {
	        "id": 630,
	        "name": "Arenas de San Pedro"
	    },
	    {
	        "id": 631,
	        "name": "Azuaga"
	    },
	    {
	        "id": 632,
	        "name": "Capdepera"
	    },
	    {
	        "id": 633,
	        "name": "Aiguafreda"
	    },
	    {
	        "id": 634,
	        "name": "Los Altos"
	    },
	    {
	        "id": 635,
	        "name": "Aldeanueva de la Vera"
	    },
	    {
	        "id": 636,
	        "name": "Conil de la Frontera"
	    },
	    {
	        "id": 637,
	        "name": "Ares del Maestrat"
	    },
	    {
	        "id": 638,
	        "name": "Almedina"
	    },
	    {
	        "id": 639,
	        "name": "Cañete de las Torres"
	    },
	    {
	        "id": 640,
	        "name": "Cabana de Bergantiños"
	    },
	    {
	        "id": 641,
	        "name": "Aliaguilla"
	    },
	    {
	        "id": 642,
	        "name": "La Vajol"
	    },
	    {
	        "id": 643,
	        "name": "Alhendín"
	    },
	    {
	        "id": 644,
	        "name": "Asteasu"
	    },
	    {
	        "id": 645,
	        "name": "Bonares"
	    },
	    {
	        "id": 646,
	        "name": "Alcalá de Gurrea"
	    },
	    {
	        "id": 647,
	        "name": "Begíjar"
	    },
	    {
	        "id": 648,
	        "name": "Bembibre"
	    },
	    {
	        "id": 649,
	        "name": "Alfés"
	    },
	    {
	        "id": 650,
	        "name": "Anguiano"
	    },
	    {
	        "id": 651,
	        "name": "O Corgo"
	    },
	    {
	        "id": 652,
	        "name": "Arganda del Rey"
	    },
	    {
	        "id": 653,
	        "name": "Alpandeire"
	    },
	    {
	        "id": 654,
	        "name": "Campos del Río"
	    },
	    {
	        "id": 655,
	        "name": "Ancín/Antzin"
	    },
	    {
	        "id": 656,
	        "name": "A Bola"
	    },
	    {
	        "id": 657,
	        "name": "Carreño"
	    },
	    {
	        "id": 658,
	        "name": "La Oliva"
	    },
	    {
	        "id": 659,
	        "name": "Crecente"
	    },
	    {
	        "id": 660,
	        "name": "Aldeadávila de la Ribera"
	    },
	    {
	        "id": 661,
	        "name": "Fuencaliente de la Palma"
	    },
	    {
	        "id": 662,
	        "name": "Cabuérniga"
	    },
	    {
	        "id": 663,
	        "name": "Aldehorno"
	    },
	    {
	        "id": 664,
	        "name": "Badolatosa"
	    },
	    {
	        "id": 665,
	        "name": "Las Aldehuelas"
	    },
	    {
	        "id": 666,
	        "name": "Amposta"
	    },
	    {
	        "id": 667,
	        "name": "Alcorisa"
	    },
	    {
	        "id": 668,
	        "name": "Añover de Tajo"
	    },
	    {
	        "id": 669,
	        "name": "Albuixech"
	    },
	    {
	        "id": 670,
	        "name": "Barruelo del Valle"
	    },
	    {
	        "id": 671,
	        "name": "Barrika"
	    },
	    {
	        "id": 672,
	        "name": "Arquillinos"
	    },
	    {
	        "id": 673,
	        "name": "Alcalá de Moncayo"
	    },
	    {
	        "id": 674,
	        "name": "Barrax"
	    },
	    {
	        "id": 675,
	        "name": "Almoradí"
	    },
	    {
	        "id": 676,
	        "name": "Alsodux"
	    },
	    {
	        "id": 677,
	        "name": "Arevalillo"
	    },
	    {
	        "id": 678,
	        "name": "Badajoz"
	    },
	    {
	        "id": 679,
	        "name": "Ciutadella de Menorca"
	    },
	    {
	        "id": 680,
	        "name": "Badalona"
	    },
	    {
	        "id": 681,
	        "name": "Aldeanueva del Camino"
	    },
	    {
	        "id": 682,
	        "name": "Chiclana de la Frontera"
	    },
	    {
	        "id": 683,
	        "name": "Argelita"
	    },
	    {
	        "id": 684,
	        "name": "Almodóvar del Campo"
	    },
	    {
	        "id": 685,
	        "name": "Carcabuey"
	    },
	    {
	        "id": 686,
	        "name": "Cabanas"
	    },
	    {
	        "id": 687,
	        "name": "La Almarcha"
	    },
	    {
	        "id": 688,
	        "name": "Banyoles"
	    },
	    {
	        "id": 689,
	        "name": "Alicún de Ortega"
	    },
	    {
	        "id": 690,
	        "name": "Aldeanueva de Guadalajara"
	    },
	    {
	        "id": 691,
	        "name": "Ataun"
	    },
	    {
	        "id": 692,
	        "name": "Cabezas Rubias"
	    },
	    {
	        "id": 693,
	        "name": "Alcalá del Obispo"
	    },
	    {
	        "id": 694,
	        "name": "Bélmez de la Moraleda"
	    },
	    {
	        "id": 695,
	        "name": "Benavides"
	    },
	    {
	        "id": 696,
	        "name": "Algerri"
	    },
	    {
	        "id": 697,
	        "name": "Arenzana de Abajo"
	    },
	    {
	        "id": 698,
	        "name": "Cospeito"
	    },
	    {
	        "id": 699,
	        "name": "Arroyomolinos"
	    },
	    {
	        "id": 700,
	        "name": "Antequera"
	    },
	    {
	        "id": 701,
	        "name": "Caravaca de la Cruz"
	    },
	    {
	        "id": 702,
	        "name": "Andosilla"
	    },
	    {
	        "id": 703,
	        "name": "O Bolo"
	    },
	    {
	        "id": 704,
	        "name": "Caso"
	    },
	    {
	        "id": 705,
	        "name": "Arconada"
	    },
	    {
	        "id": 706,
	        "name": "Pájara"
	    },
	    {
	        "id": 707,
	        "name": "Cuntis"
	    },
	    {
	        "id": 708,
	        "name": "Aldea del Obispo"
	    },
	    {
	        "id": 709,
	        "name": "Garachico"
	    },
	    {
	        "id": 710,
	        "name": "Camaleño"
	    },
	    {
	        "id": 711,
	        "name": "Aldehuela del Codonal"
	    },
	    {
	        "id": 712,
	        "name": "Benacazón"
	    },
	    {
	        "id": 713,
	        "name": "Alentisque"
	    },
	    {
	        "id": 714,
	        "name": "Arbolí"
	    },
	    {
	        "id": 715,
	        "name": "Arcicóllar"
	    },
	    {
	        "id": 716,
	        "name": "Alcàsser"
	    },
	    {
	        "id": 717,
	        "name": "Becilla de Valderaduey"
	    },
	    {
	        "id": 718,
	        "name": "Basauri"
	    },
	    {
	        "id": 719,
	        "name": "Arrabalde"
	    },
	    {
	        "id": 720,
	        "name": "Alconchel de Ariza"
	    },
	    {
	        "id": 721,
	        "name": "Bernedo"
	    },
	    {
	        "id": 722,
	        "name": "Bienservida"
	    },
	    {
	        "id": 723,
	        "name": "Almudaina"
	    },
	    {
	        "id": 724,
	        "name": "Antas"
	    },
	    {
	        "id": 725,
	        "name": "Arévalo"
	    },
	    {
	        "id": 726,
	        "name": "Barcarrota"
	    },
	    {
	        "id": 727,
	        "name": "Consell"
	    },
	    {
	        "id": 728,
	        "name": "Bagà"
	    },
	    {
	        "id": 729,
	        "name": "Ameyugo"
	    },
	    {
	        "id": 730,
	        "name": "Aldehuela de Jerte"
	    },
	    {
	        "id": 731,
	        "name": "Chipiona"
	    },
	    {
	        "id": 732,
	        "name": "Artana"
	    },
	    {
	        "id": 733,
	        "name": "Almuradiel"
	    },
	    {
	        "id": 734,
	        "name": "Cardeña"
	    },
	    {
	        "id": 735,
	        "name": "Camariñas"
	    },
	    {
	        "id": 736,
	        "name": "Almendros"
	    },
	    {
	        "id": 737,
	        "name": "Bàscara"
	    },
	    {
	        "id": 738,
	        "name": "Almegíjar"
	    },
	    {
	        "id": 739,
	        "name": "Algar de Mesa"
	    },
	    {
	        "id": 740,
	        "name": "Aia"
	    },
	    {
	        "id": 741,
	        "name": "Cala"
	    },
	    {
	        "id": 742,
	        "name": "Alcampell"
	    },
	    {
	        "id": 743,
	        "name": "Benatae"
	    },
	    {
	        "id": 744,
	        "name": "Benuza"
	    },
	    {
	        "id": 745,
	        "name": "Alguaire"
	    },
	    {
	        "id": 746,
	        "name": "Arenzana de Arriba"
	    },
	    {
	        "id": 747,
	        "name": "Chantada"
	    },
	    {
	        "id": 748,
	        "name": "El Atazar"
	    },
	    {
	        "id": 749,
	        "name": "Árchez"
	    },
	    {
	        "id": 750,
	        "name": "Cartagena"
	    },
	    {
	        "id": 751,
	        "name": "Ansoáin/Antsoain"
	    },
	    {
	        "id": 752,
	        "name": "Calvos de Randín"
	    },
	    {
	        "id": 753,
	        "name": "Castrillón"
	    },
	    {
	        "id": 754,
	        "name": "Las Palmas de Gran Canaria"
	    },
	    {
	        "id": 755,
	        "name": "Dozón"
	    },
	    {
	        "id": 756,
	        "name": "Aldealengua"
	    },
	    {
	        "id": 757,
	        "name": "Garafía"
	    },
	    {
	        "id": 758,
	        "name": "Camargo"
	    },
	    {
	        "id": 759,
	        "name": "Aldeonte"
	    },
	    {
	        "id": 760,
	        "name": "Bollullos de la Mitación"
	    },
	    {
	        "id": 761,
	        "name": "Aliud"
	    },
	    {
	        "id": 762,
	        "name": "L'Arboç"
	    },
	    {
	        "id": 763,
	        "name": "Alfambra"
	    },
	    {
	        "id": 764,
	        "name": "Argés"
	    },
	    {
	        "id": 765,
	        "name": "Alcàntera de Xúquer"
	    },
	    {
	        "id": 766,
	        "name": "Benafarces"
	    },
	    {
	        "id": 767,
	        "name": "Berango"
	    },
	    {
	        "id": 768,
	        "name": "Aspariegos"
	    },
	    {
	        "id": 769,
	        "name": "Aldehuela de Liestos"
	    },
	    {
	        "id": 770,
	        "name": "Campezo/Kanpezu"
	    },
	    {
	        "id": 771,
	        "name": "Bogarra"
	    },
	    {
	        "id": 772,
	        "name": "l'Alqueria d'Asnar"
	    },
	    {
	        "id": 773,
	        "name": "Arboleas"
	    },
	    {
	        "id": 774,
	        "name": "Aveinte"
	    },
	    {
	        "id": 775,
	        "name": "Baterno"
	    },
	    {
	        "id": 776,
	        "name": "Costitx"
	    },
	    {
	        "id": 777,
	        "name": "Balenyà"
	    },
	    {
	        "id": 778,
	        "name": "Anguix"
	    },
	    {
	        "id": 779,
	        "name": "Alía"
	    },
	    {
	        "id": 780,
	        "name": "Espera"
	    },
	    {
	        "id": 781,
	        "name": "Ayódar"
	    },
	    {
	        "id": 782,
	        "name": "Anchuras"
	    },
	    {
	        "id": 783,
	        "name": "La Carlota"
	    },
	    {
	        "id": 784,
	        "name": "Cambre"
	    },
	    {
	        "id": 785,
	        "name": "Almodóvar del Pinar"
	    },
	    {
	        "id": 786,
	        "name": "Almuñécar"
	    },
	    {
	        "id": 787,
	        "name": "Algora"
	    },
	    {
	        "id": 788,
	        "name": "Azkoitia"
	    },
	    {
	        "id": 789,
	        "name": "Calañas"
	    },
	    {
	        "id": 790,
	        "name": "Alcolea de Cinca"
	    },
	    {
	        "id": 791,
	        "name": "Cabra del Santo Cristo"
	    },
	    {
	        "id": 792,
	        "name": "Bercianos del Páramo"
	    },
	    {
	        "id": 793,
	        "name": "Alins"
	    },
	    {
	        "id": 794,
	        "name": "Arnedillo"
	    },
	    {
	        "id": 795,
	        "name": "Folgoso do Courel"
	    },
	    {
	        "id": 796,
	        "name": "Batres"
	    },
	    {
	        "id": 797,
	        "name": "Archidona"
	    },
	    {
	        "id": 798,
	        "name": "Cehegín"
	    },
	    {
	        "id": 799,
	        "name": "Anue"
	    },
	    {
	        "id": 800,
	        "name": "Carballeda de Valdeorras"
	    },
	    {
	        "id": 801,
	        "name": "Castropol"
	    },
	    {
	        "id": 802,
	        "name": "Astudillo"
	    },
	    {
	        "id": 803,
	        "name": "Puerto del Rosario"
	    },
	    {
	        "id": 804,
	        "name": "A Estrada"
	    },
	    {
	        "id": 805,
	        "name": "Aldeanueva de Figueroa"
	    },
	    {
	        "id": 806,
	        "name": "Granadilla de Abona"
	    },
	    {
	        "id": 807,
	        "name": "Campoo de Yuso"
	    },
	    {
	        "id": 808,
	        "name": "Anaya"
	    },
	    {
	        "id": 809,
	        "name": "Bormujos"
	    },
	    {
	        "id": 810,
	        "name": "Almajano"
	    },
	    {
	        "id": 811,
	        "name": "L'Argentera"
	    },
	    {
	        "id": 812,
	        "name": "Aliaga"
	    },
	    {
	        "id": 813,
	        "name": "Azután"
	    },
	    {
	        "id": 814,
	        "name": "Alzira"
	    },
	    {
	        "id": 815,
	        "name": "Bercero"
	    },
	    {
	        "id": 816,
	        "name": "Bermeo"
	    },
	    {
	        "id": 817,
	        "name": "Asturianos"
	    },
	    {
	        "id": 818,
	        "name": "Alfajarín"
	    },
	    {
	        "id": 819,
	        "name": "Zigoitia"
	    },
	    {
	        "id": 820,
	        "name": "Bonete"
	    },
	    {
	        "id": 821,
	        "name": "Altea"
	    },
	    {
	        "id": 822,
	        "name": "Armuña de Almanzora"
	    },
	    {
	        "id": 823,
	        "name": "Avellaneda"
	    },
	    {
	        "id": 824,
	        "name": "Benquerencia de la Serena"
	    },
	    {
	        "id": 825,
	        "name": "Deyá"
	    },
	    {
	        "id": 826,
	        "name": "Balsareny"
	    },
	    {
	        "id": 827,
	        "name": "Aranda de Duero"
	    },
	    {
	        "id": 828,
	        "name": "Aliseda"
	    },
	    {
	        "id": 829,
	        "name": "El Gastor"
	    },
	    {
	        "id": 830,
	        "name": "Azuébar"
	    },
	    {
	        "id": 831,
	        "name": "Arenas de San Juan"
	    },
	    {
	        "id": 832,
	        "name": "El Carpio"
	    },
	    {
	        "id": 833,
	        "name": "A Capela"
	    },
	    {
	        "id": 834,
	        "name": "Almonacid del Marquesado"
	    },
	    {
	        "id": 835,
	        "name": "Bellcaire d'Empordà"
	    },
	    {
	        "id": 836,
	        "name": "Alquife"
	    },
	    {
	        "id": 837,
	        "name": "Alhóndiga"
	    },
	    {
	        "id": 838,
	        "name": "Azpeitia"
	    },
	    {
	        "id": 839,
	        "name": "El Campillo"
	    },
	    {
	        "id": 840,
	        "name": "Alcubierre"
	    },
	    {
	        "id": 841,
	        "name": "Cambil"
	    },
	    {
	        "id": 842,
	        "name": "Bercianos del Real Camino"
	    },
	    {
	        "id": 843,
	        "name": "Arnedo"
	    },
	    {
	        "id": 844,
	        "name": "A Fonsagrada"
	    },
	    {
	        "id": 845,
	        "name": "Becerril de la Sierra"
	    },
	    {
	        "id": 846,
	        "name": "Ardales"
	    },
	    {
	        "id": 847,
	        "name": "Ceutí"
	    },
	    {
	        "id": 848,
	        "name": "Añorbe"
	    },
	    {
	        "id": 849,
	        "name": "Carballeda de Avia"
	    },
	    {
	        "id": 850,
	        "name": "Coaña"
	    },
	    {
	        "id": 851,
	        "name": "Autilla del Pino"
	    },
	    {
	        "id": 852,
	        "name": "San Bartolomé"
	    },
	    {
	        "id": 853,
	        "name": "Forcarei"
	    },
	    {
	        "id": 854,
	        "name": "Aldeanueva de la Sierra"
	    },
	    {
	        "id": 855,
	        "name": "La Guancha"
	    },
	    {
	        "id": 856,
	        "name": "Cartes"
	    },
	    {
	        "id": 857,
	        "name": "Añe"
	    },
	    {
	        "id": 858,
	        "name": "Brenes"
	    },
	    {
	        "id": 859,
	        "name": "Almaluez"
	    },
	    {
	        "id": 860,
	        "name": "Arnes"
	    },
	    {
	        "id": 861,
	        "name": "Almohaja"
	    },
	    {
	        "id": 862,
	        "name": "Barcience"
	    },
	    {
	        "id": 863,
	        "name": "Alcublas"
	    },
	    {
	        "id": 864,
	        "name": "Berceruelo"
	    },
	    {
	        "id": 865,
	        "name": "Berriatua"
	    },
	    {
	        "id": 866,
	        "name": "Ayoó de Vidriales"
	    },
	    {
	        "id": 867,
	        "name": "Alfamén"
	    },
	    {
	        "id": 868,
	        "name": "Kripan"
	    },
	    {
	        "id": 869,
	        "name": "El Bonillo"
	    },
	    {
	        "id": 870,
	        "name": "Aspe"
	    },
	    {
	        "id": 871,
	        "name": "Bacares"
	    },
	    {
	        "id": 872,
	        "name": "Ávila"
	    },
	    {
	        "id": 873,
	        "name": "Berlanga"
	    },
	    {
	        "id": 874,
	        "name": "Escorca"
	    },
	    {
	        "id": 875,
	        "name": "Barcelona"
	    },
	    {
	        "id": 876,
	        "name": "Arandilla"
	    },
	    {
	        "id": 877,
	        "name": "Almaraz"
	    },
	    {
	        "id": 878,
	        "name": "Grazalema"
	    },
	    {
	        "id": 879,
	        "name": "Argamasilla de Alba"
	    },
	    {
	        "id": 880,
	        "name": "Castro del Río"
	    },
	    {
	        "id": 881,
	        "name": "Carballo"
	    },
	    {
	        "id": 882,
	        "name": "Altarejos"
	    },
	    {
	        "id": 883,
	        "name": "Besalú"
	    },
	    {
	        "id": 884,
	        "name": "Alique"
	    },
	    {
	        "id": 885,
	        "name": "Beasain"
	    },
	    {
	        "id": 886,
	        "name": "Campofrío"
	    },
	    {
	        "id": 887,
	        "name": "Alerre"
	    },
	    {
	        "id": 888,
	        "name": "Campillo de Arenas"
	    },
	    {
	        "id": 889,
	        "name": "Berlanga del Bierzo"
	    },
	    {
	        "id": 890,
	        "name": "Almacelles"
	    },
	    {
	        "id": 891,
	        "name": "Arrúbal"
	    },
	    {
	        "id": 892,
	        "name": "Foz"
	    },
	    {
	        "id": 893,
	        "name": "Belmonte de Tajo"
	    },
	    {
	        "id": 894,
	        "name": "Arenas"
	    },
	    {
	        "id": 895,
	        "name": "Cieza"
	    },
	    {
	        "id": 896,
	        "name": "Aoiz/Agoitz"
	    },
	    {
	        "id": 897,
	        "name": "O Carballiño"
	    },
	    {
	        "id": 898,
	        "name": "Colunga"
	    },
	    {
	        "id": 899,
	        "name": "Autillo de Campos"
	    },
	    {
	        "id": 900,
	        "name": "San Bartolomé de Tirajana"
	    },
	    {
	        "id": 901,
	        "name": "Fornelos de Montes"
	    },
	    {
	        "id": 902,
	        "name": "Aldearrodrigo"
	    },
	    {
	        "id": 903,
	        "name": "Guía de Isora"
	    },
	    {
	        "id": 904,
	        "name": "Castañeda"
	    },
	    {
	        "id": 905,
	        "name": "Arahuetes"
	    },
	    {
	        "id": 906,
	        "name": "Burguillos"
	    },
	    {
	        "id": 907,
	        "name": "Almarza"
	    },
	    {
	        "id": 908,
	        "name": "Ascó"
	    },
	    {
	        "id": 909,
	        "name": "Alobras"
	    },
	    {
	        "id": 910,
	        "name": "Bargas"
	    },
	    {
	        "id": 911,
	        "name": "l'Alcúdia"
	    },
	    {
	        "id": 912,
	        "name": "Berrueces"
	    },
	    {
	        "id": 913,
	        "name": "Berriz"
	    },
	    {
	        "id": 914,
	        "name": "Barcial del Barco"
	    },
	    {
	        "id": 915,
	        "name": "Alforque"
	    },
	    {
	        "id": 916,
	        "name": "Kuartango"
	    },
	    {
	        "id": 917,
	        "name": "Carcelén"
	    },
	    {
	        "id": 918,
	        "name": "Balones"
	    },
	    {
	        "id": 919,
	        "name": "Bayárcal"
	    },
	    {
	        "id": 920,
	        "name": "Bienvenida"
	    },
	    {
	        "id": 921,
	        "name": "Esporles"
	    },
	    {
	        "id": 922,
	        "name": "Begues"
	    },
	    {
	        "id": 923,
	        "name": "Arauzo de Miel"
	    },
	    {
	        "id": 924,
	        "name": "Almoharín"
	    },
	    {
	        "id": 925,
	        "name": "Jerez de la Frontera"
	    },
	    {
	        "id": 926,
	        "name": "Barracas"
	    },
	    {
	        "id": 927,
	        "name": "Argamasilla de Calatrava"
	    },
	    {
	        "id": 928,
	        "name": "Conquista"
	    },
	    {
	        "id": 929,
	        "name": "Carnota"
	    },
	    {
	        "id": 930,
	        "name": "Arandilla del Arroyo"
	    },
	    {
	        "id": 931,
	        "name": "Bescanó"
	    },
	    {
	        "id": 932,
	        "name": "Arenas del Rey"
	    },
	    {
	        "id": 933,
	        "name": "Almadrones"
	    },
	    {
	        "id": 934,
	        "name": "Beizama"
	    },
	    {
	        "id": 935,
	        "name": "Cañaveral de León"
	    },
	    {
	        "id": 936,
	        "name": "Alfántega"
	    },
	    {
	        "id": 937,
	        "name": "Canena"
	    },
	    {
	        "id": 938,
	        "name": "Boca de Huérgano"
	    },
	    {
	        "id": 939,
	        "name": "Almatret"
	    },
	    {
	        "id": 940,
	        "name": "Ausejo"
	    },
	    {
	        "id": 941,
	        "name": "Friol"
	    },
	    {
	        "id": 942,
	        "name": "Berzosa del Lozoya"
	    },
	    {
	        "id": 943,
	        "name": "Arriate"
	    },
	    {
	        "id": 944,
	        "name": "Fortuna"
	    },
	    {
	        "id": 945,
	        "name": "Araitz"
	    },
	    {
	        "id": 946,
	        "name": "Cartelle"
	    },
	    {
	        "id": 947,
	        "name": "Corvera de Asturias"
	    },
	    {
	        "id": 948,
	        "name": "Ayuela"
	    },
	    {
	        "id": 949,
	        "name": "La Aldea de San Nicolás"
	    },
	    {
	        "id": 950,
	        "name": "Agolada"
	    },
	    {
	        "id": 951,
	        "name": "Aldearrubia"
	    },
	    {
	        "id": 952,
	        "name": "Güímar"
	    },
	    {
	        "id": 953,
	        "name": "Castro-Urdiales"
	    },
	    {
	        "id": 954,
	        "name": "Arcones"
	    },
	    {
	        "id": 955,
	        "name": "Las Cabezas de San Juan"
	    },
	    {
	        "id": 956,
	        "name": "Almazán"
	    },
	    {
	        "id": 957,
	        "name": "Banyeres del Penedès"
	    },
	    {
	        "id": 958,
	        "name": "Alpeñés"
	    },
	    {
	        "id": 959,
	        "name": "Belvís de la Jara"
	    },
	    {
	        "id": 960,
	        "name": "l'Alcúdia de Crespins"
	    },
	    {
	        "id": 961,
	        "name": "Bobadilla del Campo"
	    },
	    {
	        "id": 962,
	        "name": "Bilbao"
	    },
	    {
	        "id": 963,
	        "name": "Belver de los Montes"
	    },
	    {
	        "id": 964,
	        "name": "Alhama de Aragón"
	    },
	    {
	        "id": 965,
	        "name": "Elburgo/Burgelu"
	    },
	    {
	        "id": 966,
	        "name": "Casas de Juan Núñez"
	    },
	    {
	        "id": 967,
	        "name": "Banyeres de Mariola"
	    },
	    {
	        "id": 968,
	        "name": "Bayarque"
	    },
	    {
	        "id": 969,
	        "name": "El Barco de Ávila"
	    },
	    {
	        "id": 970,
	        "name": "Bodonal de la Sierra"
	    },
	    {
	        "id": 971,
	        "name": "Estellencs"
	    },
	    {
	        "id": 972,
	        "name": "Bellprat"
	    },
	    {
	        "id": 973,
	        "name": "Arauzo de Salce"
	    },
	    {
	        "id": 974,
	        "name": "Arroyo de la Luz"
	    },
	    {
	        "id": 975,
	        "name": "Jimena de la Frontera"
	    },
	    {
	        "id": 976,
	        "name": "Betxí"
	    },
	    {
	        "id": 977,
	        "name": "Arroba de los Montes"
	    },
	    {
	        "id": 978,
	        "name": "Córdoba"
	    },
	    {
	        "id": 979,
	        "name": "Carral"
	    },
	    {
	        "id": 980,
	        "name": "Beuda"
	    },
	    {
	        "id": 981,
	        "name": "Armilla"
	    },
	    {
	        "id": 982,
	        "name": "Almoguera"
	    },
	    {
	        "id": 983,
	        "name": "Belauntza"
	    },
	    {
	        "id": 984,
	        "name": "Cartaya"
	    },
	    {
	        "id": 985,
	        "name": "Almudévar"
	    },
	    {
	        "id": 986,
	        "name": "Carboneros"
	    },
	    {
	        "id": 987,
	        "name": "Boñar"
	    },
	    {
	        "id": 988,
	        "name": "Almenar"
	    },
	    {
	        "id": 989,
	        "name": "Autol"
	    },
	    {
	        "id": 990,
	        "name": "Xermade"
	    },
	    {
	        "id": 991,
	        "name": "El Berrueco"
	    },
	    {
	        "id": 992,
	        "name": "Atajate"
	    },
	    {
	        "id": 993,
	        "name": "Fuente Álamo de Murcia"
	    },
	    {
	        "id": 994,
	        "name": "Aranarache/Aranaratxe"
	    },
	    {
	        "id": 995,
	        "name": "Castrelo do Val"
	    },
	    {
	        "id": 996,
	        "name": "Cudillero"
	    },
	    {
	        "id": 997,
	        "name": "Santa Brígida"
	    },
	    {
	        "id": 998,
	        "name": "Gondomar"
	    },
	    {
	        "id": 999,
	        "name": "Aldeaseca de Alba"
	    },
	    {
	        "id": 1000,
	        "name": "Hermigua"
	    },
	    {
	        "id": 1001,
	        "name": "Cieza"
	    },
	    {
	        "id": 1002,
	        "name": "Arevalillo de Cega"
	    },
	    {
	        "id": 1003,
	        "name": "Camas"
	    },
	    {
	        "id": 1004,
	        "name": "Almazul"
	    },
	    {
	        "id": 1005,
	        "name": "Barberà de la Conca"
	    },
	    {
	        "id": 1006,
	        "name": "Allepuz"
	    },
	    {
	        "id": 1007,
	        "name": "Borox"
	    },
	    {
	        "id": 1008,
	        "name": "Aldaia"
	    },
	    {
	        "id": 1009,
	        "name": "Bocigas"
	    },
	    {
	        "id": 1010,
	        "name": "Busturia"
	    },
	    {
	        "id": 1011,
	        "name": "Benavente"
	    },
	    {
	        "id": 1012,
	        "name": "Almochuel"
	    },
	    {
	        "id": 1013,
	        "name": "Elciego"
	    },
	    {
	        "id": 1014,
	        "name": "Casas de Lázaro"
	    },
	    {
	        "id": 1015,
	        "name": "Benasau"
	    },
	    {
	        "id": 1016,
	        "name": "Bédar"
	    },
	    {
	        "id": 1017,
	        "name": "El Barraco"
	    },
	    {
	        "id": 1018,
	        "name": "Burguillos del Cerro"
	    },
	    {
	        "id": 1019,
	        "name": "Felanitx"
	    },
	    {
	        "id": 1020,
	        "name": "Berga"
	    },
	    {
	        "id": 1021,
	        "name": "Arauzo de Torre"
	    },
	    {
	        "id": 1022,
	        "name": "Arroyomolinos de la Vera"
	    },
	    {
	        "id": 1023,
	        "name": "La Línea de la Concepción"
	    },
	    {
	        "id": 1024,
	        "name": "Bejís"
	    },
	    {
	        "id": 1025,
	        "name": "Ballesteros de Calatrava"
	    },
	    {
	        "id": 1026,
	        "name": "Doña Mencía"
	    },
	    {
	        "id": 1027,
	        "name": "Cedeira"
	    },
	    {
	        "id": 1028,
	        "name": "Arcos de la Sierra"
	    },
	    {
	        "id": 1029,
	        "name": "La Bisbal d'Empordà"
	    },
	    {
	        "id": 1030,
	        "name": "Atarfe"
	    },
	    {
	        "id": 1031,
	        "name": "Almonacid de Zorita"
	    },
	    {
	        "id": 1032,
	        "name": "Berastegi"
	    },
	    {
	        "id": 1033,
	        "name": "Castaño del Robledo"
	    },
	    {
	        "id": 1034,
	        "name": "Almunia de San Juan"
	    },
	    {
	        "id": 1035,
	        "name": "Borrenes"
	    },
	    {
	        "id": 1036,
	        "name": "Alòs de Balaguer"
	    },
	    {
	        "id": 1037,
	        "name": "Azofra"
	    },
	    {
	        "id": 1038,
	        "name": "Guitiriz"
	    },
	    {
	        "id": 1039,
	        "name": "Boadilla del Monte"
	    },
	    {
	        "id": 1040,
	        "name": "Benadalid"
	    },
	    {
	        "id": 1041,
	        "name": "Jumilla"
	    },
	    {
	        "id": 1042,
	        "name": "Arantza"
	    },
	    {
	        "id": 1043,
	        "name": "Castrelo de Miño"
	    },
	    {
	        "id": 1044,
	        "name": "Degaña"
	    },
	    {
	        "id": 1045,
	        "name": "Baltanás"
	    },
	    {
	        "id": 1046,
	        "name": "Santa Lucía de Tirajana"
	    },
	    {
	        "id": 1047,
	        "name": "O Grove"
	    },
	    {
	        "id": 1048,
	        "name": "Aldeaseca de la Frontera"
	    },
	    {
	        "id": 1049,
	        "name": "Icod de los Vinos"
	    },
	    {
	        "id": 1050,
	        "name": "Cillorigo de Liébana"
	    },
	    {
	        "id": 1051,
	        "name": "Armuña"
	    },
	    {
	        "id": 1052,
	        "name": "La Campana"
	    },
	    {
	        "id": 1053,
	        "name": "Almenar de Soria"
	    },
	    {
	        "id": 1054,
	        "name": "Batea"
	    },
	    {
	        "id": 1055,
	        "name": "Alloza"
	    },
	    {
	        "id": 1056,
	        "name": "Buenaventura"
	    },
	    {
	        "id": 1057,
	        "name": "Alfafar"
	    },
	    {
	        "id": 1058,
	        "name": "Bocos de Duero"
	    },
	    {
	        "id": 1059,
	        "name": "Karrantza Harana/Valle de Carranza"
	    },
	    {
	        "id": 1060,
	        "name": "Benegiles"
	    },
	    {
	        "id": 1061,
	        "name": "La Almolda"
	    },
	    {
	        "id": 1062,
	        "name": "Elvillar/Bilar"
	    },
	    {
	        "id": 1063,
	        "name": "Casas de Ves"
	    },
	    {
	        "id": 1064,
	        "name": "Beneixama"
	    },
	    {
	        "id": 1065,
	        "name": "Beires"
	    },
	    {
	        "id": 1066,
	        "name": "Barromán"
	    },
	    {
	        "id": 1067,
	        "name": "Cabeza del Buey"
	    },
	    {
	        "id": 1068,
	        "name": "Ferreries"
	    },
	    {
	        "id": 1069,
	        "name": "Bigues i Riells"
	    },
	    {
	        "id": 1070,
	        "name": "Arcos"
	    },
	    {
	        "id": 1071,
	        "name": "Arroyomolinos"
	    },
	    {
	        "id": 1072,
	        "name": "Medina-Sidonia"
	    },
	    {
	        "id": 1073,
	        "name": "Bolaños de Calatrava"
	    },
	    {
	        "id": 1074,
	        "name": "Dos Torres"
	    },
	    {
	        "id": 1075,
	        "name": "Cee"
	    },
	    {
	        "id": 1076,
	        "name": "Chillarón de Cuenca"
	    },
	    {
	        "id": 1077,
	        "name": "Blanes"
	    },
	    {
	        "id": 1078,
	        "name": "Baza"
	    },
	    {
	        "id": 1079,
	        "name": "Alocén"
	    },
	    {
	        "id": 1080,
	        "name": "Berrobi"
	    },
	    {
	        "id": 1081,
	        "name": "El Cerro de Andévalo"
	    },
	    {
	        "id": 1082,
	        "name": "Almuniente"
	    },
	    {
	        "id": 1083,
	        "name": "Brazuelo"
	    },
	    {
	        "id": 1084,
	        "name": "Alpicat"
	    },
	    {
	        "id": 1085,
	        "name": "Badarán"
	    },
	    {
	        "id": 1086,
	        "name": "Guntín"
	    },
	    {
	        "id": 1087,
	        "name": "El Boalo"
	    },
	    {
	        "id": 1088,
	        "name": "Benahavís"
	    },
	    {
	        "id": 1089,
	        "name": "Librilla"
	    },
	    {
	        "id": 1090,
	        "name": "Aranguren"
	    },
	    {
	        "id": 1091,
	        "name": "Castro Caldelas"
	    },
	    {
	        "id": 1092,
	        "name": "El Franco"
	    },
	    {
	        "id": 1093,
	        "name": "Venta de Baños"
	    },
	    {
	        "id": 1094,
	        "name": "Santa María de Guía de Gran Canaria"
	    },
	    {
	        "id": 1095,
	        "name": "A Guarda"
	    },
	    {
	        "id": 1096,
	        "name": "Aldeatejada"
	    },
	    {
	        "id": 1097,
	        "name": "San Cristóbal de La Laguna"
	    },
	    {
	        "id": 1098,
	        "name": "Colindres"
	    },
	    {
	        "id": 1099,
	        "name": "Cantillana"
	    },
	    {
	        "id": 1100,
	        "name": "Alpanseque"
	    },
	    {
	        "id": 1101,
	        "name": "Bellmunt del Priorat"
	    },
	    {
	        "id": 1102,
	        "name": "Allueva"
	    },
	    {
	        "id": 1103,
	        "name": "Burguillos de Toledo"
	    },
	    {
	        "id": 1104,
	        "name": "Alfauir"
	    },
	    {
	        "id": 1105,
	        "name": "Boecillo"
	    },
	    {
	        "id": 1106,
	        "name": "Artea"
	    },
	    {
	        "id": 1107,
	        "name": "Bermillo de Sayago"
	    },
	    {
	        "id": 1108,
	        "name": "Almonacid de la Cuba"
	    },
	    {
	        "id": 1109,
	        "name": "Casas-Ibáñez"
	    },
	    {
	        "id": 1110,
	        "name": "Benejúzar"
	    },
	    {
	        "id": 1111,
	        "name": "Benahadux"
	    },
	    {
	        "id": 1112,
	        "name": "Becedas"
	    },
	    {
	        "id": 1113,
	        "name": "Cabeza la Vaca"
	    },
	    {
	        "id": 1114,
	        "name": "Formentera"
	    },
	    {
	        "id": 1115,
	        "name": "Borredà"
	    },
	    {
	        "id": 1116,
	        "name": "Arenillas de Riopisuerga"
	    },
	    {
	        "id": 1117,
	        "name": "Baños de Montemayor"
	    },
	    {
	        "id": 1118,
	        "name": "Olvera"
	    },
	    {
	        "id": 1119,
	        "name": "Benafer"
	    },
	    {
	        "id": 1120,
	        "name": "Brazatortas"
	    },
	    {
	        "id": 1121,
	        "name": "Encinas Reales"
	    },
	    {
	        "id": 1122,
	        "name": "Cerceda"
	    },
	    {
	        "id": 1123,
	        "name": "Arguisuelas"
	    },
	    {
	        "id": 1124,
	        "name": "Bolvir"
	    },
	    {
	        "id": 1125,
	        "name": "Beas de Granada"
	    },
	    {
	        "id": 1126,
	        "name": "Alovera"
	    },
	    {
	        "id": 1127,
	        "name": "Bidegoian"
	    },
	    {
	        "id": 1128,
	        "name": "Corteconcepción"
	    },
	    {
	        "id": 1129,
	        "name": "Alquézar"
	    },
	    {
	        "id": 1130,
	        "name": "La Carolina"
	    },
	    {
	        "id": 1131,
	        "name": "El Burgo Ranero"
	    },
	    {
	        "id": 1132,
	        "name": "Alt Àneu"
	    },
	    {
	        "id": 1133,
	        "name": "Bañares"
	    },
	    {
	        "id": 1134,
	        "name": "O Incio"
	    },
	    {
	        "id": 1135,
	        "name": "Braojos"
	    },
	    {
	        "id": 1136,
	        "name": "Benalauría"
	    },
	    {
	        "id": 1137,
	        "name": "Lorca"
	    },
	    {
	        "id": 1138,
	        "name": "Arano"
	    },
	    {
	        "id": 1139,
	        "name": "Celanova"
	    },
	    {
	        "id": 1140,
	        "name": "Gijón"
	    },
	    {
	        "id": 1141,
	        "name": "Baquerín de Campos"
	    },
	    {
	        "id": 1142,
	        "name": "Teguise"
	    },
	    {
	        "id": 1143,
	        "name": "Lalín"
	    },
	    {
	        "id": 1144,
	        "name": "Aldeavieja de Tormes"
	    },
	    {
	        "id": 1145,
	        "name": "Los Llanos de Aridane"
	    },
	    {
	        "id": 1146,
	        "name": "Comillas"
	    },
	    {
	        "id": 1147,
	        "name": "Ayllón"
	    },
	    {
	        "id": 1148,
	        "name": "Carmona"
	    },
	    {
	        "id": 1149,
	        "name": "Arancón"
	    },
	    {
	        "id": 1150,
	        "name": "Bellvei"
	    },
	    {
	        "id": 1151,
	        "name": "Anadón"
	    },
	    {
	        "id": 1152,
	        "name": "Burujón"
	    },
	    {
	        "id": 1153,
	        "name": "Alfara de la Baronia"
	    },
	    {
	        "id": 1154,
	        "name": "Bolaños de Campos"
	    },
	    {
	        "id": 1155,
	        "name": "Zeanuri"
	    },
	    {
	        "id": 1156,
	        "name": "La Bóveda de Toro"
	    },
	    {
	        "id": 1157,
	        "name": "Almonacid de la Sierra"
	    },
	    {
	        "id": 1158,
	        "name": "Caudete"
	    },
	    {
	        "id": 1159,
	        "name": "Benferri"
	    },
	    {
	        "id": 1160,
	        "name": "Becedillas"
	    },
	    {
	        "id": 1161,
	        "name": "Calamonte"
	    },
	    {
	        "id": 1162,
	        "name": "Fornalutx"
	    },
	    {
	        "id": 1163,
	        "name": "El Bruc"
	    },
	    {
	        "id": 1164,
	        "name": "Arija"
	    },
	    {
	        "id": 1165,
	        "name": "Barrado"
	    },
	    {
	        "id": 1166,
	        "name": "Paterna de Rivera"
	    },
	    {
	        "id": 1167,
	        "name": "Benafigos"
	    },
	    {
	        "id": 1168,
	        "name": "Cabezarados"
	    },
	    {
	        "id": 1169,
	        "name": "Espejo"
	    },
	    {
	        "id": 1170,
	        "name": "Cerdido"
	    },
	    {
	        "id": 1171,
	        "name": "Arrancacepas"
	    },
	    {
	        "id": 1172,
	        "name": "Bordils"
	    },
	    {
	        "id": 1173,
	        "name": "Beas de Guadix"
	    },
	    {
	        "id": 1174,
	        "name": "Zegama"
	    },
	    {
	        "id": 1175,
	        "name": "Cortegana"
	    },
	    {
	        "id": 1176,
	        "name": "Altorricón"
	    },
	    {
	        "id": 1177,
	        "name": "Castellar"
	    },
	    {
	        "id": 1178,
	        "name": "Burón"
	    },
	    {
	        "id": 1179,
	        "name": "Naut Aran"
	    },
	    {
	        "id": 1180,
	        "name": "Baños de Rioja"
	    },
	    {
	        "id": 1181,
	        "name": "Xove"
	    },
	    {
	        "id": 1182,
	        "name": "Brea de Tajo"
	    },
	    {
	        "id": 1183,
	        "name": "Benalmádena"
	    },
	    {
	        "id": 1184,
	        "name": "Lorquí"
	    },
	    {
	        "id": 1185,
	        "name": "Arakil"
	    },
	    {
	        "id": 1186,
	        "name": "Cenlle"
	    },
	    {
	        "id": 1187,
	        "name": "Gozón"
	    },
	    {
	        "id": 1188,
	        "name": "Bárcena de Campos"
	    },
	    {
	        "id": 1189,
	        "name": "Tejeda"
	    },
	    {
	        "id": 1190,
	        "name": "A Lama"
	    },
	    {
	        "id": 1191,
	        "name": "Aldehuela de la Bóveda"
	    },
	    {
	        "id": 1192,
	        "name": "La Matanza de Acentejo"
	    },
	    {
	        "id": 1193,
	        "name": "Los Corrales de Buelna"
	    },
	    {
	        "id": 1194,
	        "name": "Barbolla"
	    },
	    {
	        "id": 1195,
	        "name": "Carrión de los Céspedes"
	    },
	    {
	        "id": 1196,
	        "name": "Arcos de Jalón"
	    },
	    {
	        "id": 1197,
	        "name": "Benifallet"
	    },
	    {
	        "id": 1198,
	        "name": "Andorra"
	    },
	    {
	        "id": 1199,
	        "name": "Cabañas de la Sagra"
	    },
	    {
	        "id": 1200,
	        "name": "Alfara del Patriarca"
	    },
	    {
	        "id": 1201,
	        "name": "Brahojos de Medina"
	    },
	    {
	        "id": 1202,
	        "name": "Zeberio"
	    },
	    {
	        "id": 1203,
	        "name": "Bretó"
	    },
	    {
	        "id": 1204,
	        "name": "La Almunia de Doña Godina"
	    },
	    {
	        "id": 1205,
	        "name": "Cenizate"
	    },
	    {
	        "id": 1206,
	        "name": "Beniarbeig"
	    },
	    {
	        "id": 1207,
	        "name": "Benitagla"
	    },
	    {
	        "id": 1208,
	        "name": "Bercial de Zapardiel"
	    },
	    {
	        "id": 1209,
	        "name": "Calera de León"
	    },
	    {
	        "id": 1210,
	        "name": "Eivissa"
	    },
	    {
	        "id": 1211,
	        "name": "El Brull"
	    },
	    {
	        "id": 1212,
	        "name": "Arlanzón"
	    },
	    {
	        "id": 1213,
	        "name": "Belvís de Monroy"
	    },
	    {
	        "id": 1214,
	        "name": "Prado del Rey"
	    },
	    {
	        "id": 1215,
	        "name": "Benasal"
	    },
	    {
	        "id": 1216,
	        "name": "Cabezarrubias del Puerto"
	    },
	    {
	        "id": 1217,
	        "name": "Espiel"
	    },
	    {
	        "id": 1218,
	        "name": "Cesuras"
	    },
	    {
	        "id": 1219,
	        "name": "Atalaya del Cañavate"
	    },
	    {
	        "id": 1220,
	        "name": "Borrassà"
	    },
	    {
	        "id": 1221,
	        "name": "Zerain"
	    },
	    {
	        "id": 1222,
	        "name": "Cortelazor"
	    },
	    {
	        "id": 1223,
	        "name": "Castillo de Locubín"
	    },
	    {
	        "id": 1224,
	        "name": "Bustillo del Páramo"
	    },
	    {
	        "id": 1225,
	        "name": "Baños de Río Tobía"
	    },
	    {
	        "id": 1226,
	        "name": "Láncara"
	    },
	    {
	        "id": 1227,
	        "name": "Brunete"
	    },
	    {
	        "id": 1228,
	        "name": "Benamargosa"
	    },
	    {
	        "id": 1229,
	        "name": "Mazarrón"
	    },
	    {
	        "id": 1230,
	        "name": "Aras"
	    },
	    {
	        "id": 1231,
	        "name": "Coles"
	    },
	    {
	        "id": 1232,
	        "name": "Grado"
	    },
	    {
	        "id": 1233,
	        "name": "Telde"
	    },
	    {
	        "id": 1234,
	        "name": "Marín"
	    },
	    {
	        "id": 1235,
	        "name": "Aldehuela de Yeltes"
	    },
	    {
	        "id": 1236,
	        "name": "La Orotava"
	    },
	    {
	        "id": 1237,
	        "name": "Corvera de Toranzo"
	    },
	    {
	        "id": 1238,
	        "name": "Basardilla"
	    },
	    {
	        "id": 1239,
	        "name": "Casariche"
	    },
	    {
	        "id": 1240,
	        "name": "Arenillas"
	    },
	    {
	        "id": 1241,
	        "name": "Benissanet"
	    },
	    {
	        "id": 1242,
	        "name": "Arcos de las Salinas"
	    },
	    {
	        "id": 1243,
	        "name": "Cabañas de Yepes"
	    },
	    {
	        "id": 1244,
	        "name": "Alfarp"
	    },
	    {
	        "id": 1245,
	        "name": "Bustillo de Chaves"
	    },
	    {
	        "id": 1246,
	        "name": "Dima"
	    },
	    {
	        "id": 1247,
	        "name": "Bretocino"
	    },
	    {
	        "id": 1248,
	        "name": "Alpartir"
	    },
	    {
	        "id": 1249,
	        "name": "Iruraiz-Gauna"
	    },
	    {
	        "id": 1250,
	        "name": "Corral-Rubio"
	    },
	    {
	        "id": 1251,
	        "name": "Beniardá"
	    },
	    {
	        "id": 1252,
	        "name": "Benizalón"
	    },
	    {
	        "id": 1253,
	        "name": "Las Berlanas"
	    },
	    {
	        "id": 1254,
	        "name": "Calzadilla de los Barros"
	    },
	    {
	        "id": 1255,
	        "name": "Inca"
	    },
	    {
	        "id": 1256,
	        "name": "Les Cabanyes"
	    },
	    {
	        "id": 1257,
	        "name": "Arraya de Oca"
	    },
	    {
	        "id": 1258,
	        "name": "Benquerencia"
	    },
	    {
	        "id": 1259,
	        "name": "El Puerto de Santa María"
	    },
	    {
	        "id": 1260,
	        "name": "Benicarló"
	    },
	    {
	        "id": 1261,
	        "name": "Calzada de Calatrava"
	    },
	    {
	        "id": 1262,
	        "name": "Fernán-Núñez"
	    },
	    {
	        "id": 1263,
	        "name": "Coirós"
	    },
	    {
	        "id": 1264,
	        "name": "Barajas de Melo"
	    },
	    {
	        "id": 1265,
	        "name": "Breda"
	    },
	    {
	        "id": 1266,
	        "name": "Benalúa"
	    },
	    {
	        "id": 1267,
	        "name": "Alustante"
	    },
	    {
	        "id": 1268,
	        "name": "Zestoa"
	    },
	    {
	        "id": 1269,
	        "name": "Cumbres de Enmedio"
	    },
	    {
	        "id": 1270,
	        "name": "Angüés"
	    },
	    {
	        "id": 1271,
	        "name": "Cazalilla"
	    },
	    {
	        "id": 1272,
	        "name": "Cabañas Raras"
	    },
	    {
	        "id": 1273,
	        "name": "Anglesola"
	    },
	    {
	        "id": 1274,
	        "name": "Berceo"
	    },
	    {
	        "id": 1275,
	        "name": "Lourenzá"
	    },
	    {
	        "id": 1276,
	        "name": "Buitrago del Lozoya"
	    },
	    {
	        "id": 1277,
	        "name": "Benamocarra"
	    },
	    {
	        "id": 1278,
	        "name": "Molina de Segura"
	    },
	    {
	        "id": 1279,
	        "name": "Arbizu"
	    },
	    {
	        "id": 1280,
	        "name": "Cortegada"
	    },
	    {
	        "id": 1281,
	        "name": "Grandas de Salime"
	    },
	    {
	        "id": 1282,
	        "name": "Barruelo de Santullán"
	    },
	    {
	        "id": 1283,
	        "name": "Teror"
	    },
	    {
	        "id": 1284,
	        "name": "Meaño"
	    },
	    {
	        "id": 1285,
	        "name": "Almenara de Tormes"
	    },
	    {
	        "id": 1286,
	        "name": "El Paso"
	    },
	    {
	        "id": 1287,
	        "name": "Campoo de Enmedio"
	    },
	    {
	        "id": 1288,
	        "name": "Castilblanco de los Arroyos"
	    },
	    {
	        "id": 1289,
	        "name": "Arévalo de la Sierra"
	    },
	    {
	        "id": 1290,
	        "name": "La Bisbal de Falset"
	    },
	    {
	        "id": 1291,
	        "name": "Arens de Lledó"
	    },
	    {
	        "id": 1292,
	        "name": "Cabezamesada"
	    },
	    {
	        "id": 1293,
	        "name": "Alfarrasí"
	    },
	    {
	        "id": 1294,
	        "name": "Cabezón de Pisuerga"
	    },
	    {
	        "id": 1295,
	        "name": "Durango"
	    },
	    {
	        "id": 1296,
	        "name": "Brime de Sog"
	    },
	    {
	        "id": 1297,
	        "name": "Ambel"
	    },
	    {
	        "id": 1298,
	        "name": "Labastida/Bastida"
	    },
	    {
	        "id": 1299,
	        "name": "Cotillas"
	    },
	    {
	        "id": 1300,
	        "name": "Beniarrés"
	    },
	    {
	        "id": 1301,
	        "name": "Bentarique"
	    },
	    {
	        "id": 1302,
	        "name": "Campanario"
	    },
	    {
	        "id": 1303,
	        "name": "Lloret de Vistalegre"
	    },
	    {
	        "id": 1304,
	        "name": "Cabrera d'Anoia"
	    },
	    {
	        "id": 1305,
	        "name": "Berrocalejo"
	    },
	    {
	        "id": 1306,
	        "name": "Puerto Real"
	    },
	    {
	        "id": 1307,
	        "name": "Benicasim/Benicàssim"
	    },
	    {
	        "id": 1308,
	        "name": "Campo de Criptana"
	    },
	    {
	        "id": 1309,
	        "name": "Fuente la Lancha"
	    },
	    {
	        "id": 1310,
	        "name": "Corcubión"
	    },
	    {
	        "id": 1311,
	        "name": "Brunyola"
	    },
	    {
	        "id": 1312,
	        "name": "Benalúa de las Villas"
	    },
	    {
	        "id": 1313,
	        "name": "Zizurkil"
	    },
	    {
	        "id": 1314,
	        "name": "Cumbres de San Bartolomé"
	    },
	    {
	        "id": 1315,
	        "name": "Ansó"
	    },
	    {
	        "id": 1316,
	        "name": "Cazorla"
	    },
	    {
	        "id": 1317,
	        "name": "Cabreros del Río"
	    },
	    {
	        "id": 1318,
	        "name": "Bergasa"
	    },
	    {
	        "id": 1319,
	        "name": "Lugo"
	    },
	    {
	        "id": 1320,
	        "name": "Bustarviejo"
	    },
	    {
	        "id": 1321,
	        "name": "Benaoján"
	    },
	    {
	        "id": 1322,
	        "name": "Moratalla"
	    },
	    {
	        "id": 1323,
	        "name": "Arce/Artzi"
	    },
	    {
	        "id": 1324,
	        "name": "Cualedro"
	    },
	    {
	        "id": 1325,
	        "name": "Ibias"
	    },
	    {
	        "id": 1326,
	        "name": "Báscones de Ojeda"
	    },
	    {
	        "id": 1327,
	        "name": "Tías"
	    },
	    {
	        "id": 1328,
	        "name": "Meis"
	    },
	    {
	        "id": 1329,
	        "name": "Almendra"
	    },
	    {
	        "id": 1330,
	        "name": "Puerto de la Cruz"
	    },
	    {
	        "id": 1331,
	        "name": "Entrambasaguas"
	    },
	    {
	        "id": 1332,
	        "name": "Bercial"
	    },
	    {
	        "id": 1333,
	        "name": "Castilleja de Guzmán"
	    },
	    {
	        "id": 1334,
	        "name": "Ausejo de la Sierra"
	    },
	    {
	        "id": 1335,
	        "name": "La Bisbal del Penedès"
	    },
	    {
	        "id": 1336,
	        "name": "Argente"
	    },
	    {
	        "id": 1337,
	        "name": "Calera y Chozas"
	    },
	    {
	        "id": 1338,
	        "name": "Algar de Palancia"
	    },
	    {
	        "id": 1339,
	        "name": "Cabezón de Valderaduey"
	    },
	    {
	        "id": 1340,
	        "name": "Ea"
	    },
	    {
	        "id": 1341,
	        "name": "Brime de Urz"
	    },
	    {
	        "id": 1342,
	        "name": "Anento"
	    },
	    {
	        "id": 1343,
	        "name": "Chinchilla de Monte-Aragón"
	    },
	    {
	        "id": 1344,
	        "name": "Benigembla"
	    },
	    {
	        "id": 1345,
	        "name": "Berja"
	    },
	    {
	        "id": 1346,
	        "name": "Bernuy-Zapardiel"
	    },
	    {
	        "id": 1347,
	        "name": "Campillo de Llerena"
	    },
	    {
	        "id": 1348,
	        "name": "Lloseta"
	    },
	    {
	        "id": 1349,
	        "name": "Cabrera de Mar"
	    },
	    {
	        "id": 1350,
	        "name": "Atapuerca"
	    },
	    {
	        "id": 1351,
	        "name": "Berzocana"
	    },
	    {
	        "id": 1352,
	        "name": "Puerto Serrano"
	    },
	    {
	        "id": 1353,
	        "name": "Benlloch"
	    },
	    {
	        "id": 1354,
	        "name": "Cañada de Calatrava"
	    },
	    {
	        "id": 1355,
	        "name": "Fuente Obejuna"
	    },
	    {
	        "id": 1356,
	        "name": "Coristanco"
	    },
	    {
	        "id": 1357,
	        "name": "Barchín del Hoyo"
	    },
	    {
	        "id": 1358,
	        "name": "Boadella i les Escaules"
	    },
	    {
	        "id": 1359,
	        "name": "Benamaurel"
	    },
	    {
	        "id": 1360,
	        "name": "Deba"
	    },
	    {
	        "id": 1361,
	        "name": "Cumbres Mayores"
	    },
	    {
	        "id": 1362,
	        "name": "Antillón"
	    },
	    {
	        "id": 1363,
	        "name": "Chiclana de Segura"
	    },
	    {
	        "id": 1364,
	        "name": "Cabrillanes"
	    },
	    {
	        "id": 1365,
	        "name": "Arbeca"
	    },
	    {
	        "id": 1366,
	        "name": "Bergasillas Bajera"
	    },
	    {
	        "id": 1367,
	        "name": "Meira"
	    },
	    {
	        "id": 1368,
	        "name": "Cabanillas de la Sierra"
	    },
	    {
	        "id": 1369,
	        "name": "Benarrabá"
	    },
	    {
	        "id": 1370,
	        "name": "Mula"
	    },
	    {
	        "id": 1371,
	        "name": "Los Arcos"
	    },
	    {
	        "id": 1372,
	        "name": "Chandrexa de Queixa"
	    },
	    {
	        "id": 1373,
	        "name": "Illano"
	    },
	    {
	        "id": 1374,
	        "name": "Becerril de Campos"
	    },
	    {
	        "id": 1375,
	        "name": "Tinajo"
	    },
	    {
	        "id": 1376,
	        "name": "Moaña"
	    },
	    {
	        "id": 1377,
	        "name": "Anaya de Alba"
	    },
	    {
	        "id": 1378,
	        "name": "Puntagorda"
	    },
	    {
	        "id": 1379,
	        "name": "Escalante"
	    },
	    {
	        "id": 1380,
	        "name": "Bercimuel"
	    },
	    {
	        "id": 1381,
	        "name": "Castilleja de la Cuesta"
	    },
	    {
	        "id": 1382,
	        "name": "Baraona"
	    },
	    {
	        "id": 1383,
	        "name": "Blancafort"
	    },
	    {
	        "id": 1384,
	        "name": "Ariño"
	    },
	    {
	        "id": 1385,
	        "name": "Caleruela"
	    },
	    {
	        "id": 1386,
	        "name": "Algemesí"
	    },
	    {
	        "id": 1387,
	        "name": "Cabreros del Monte"
	    },
	    {
	        "id": 1388,
	        "name": "Etxebarri"
	    },
	    {
	        "id": 1389,
	        "name": "Burganes de Valverde"
	    },
	    {
	        "id": 1390,
	        "name": "Aniñón"
	    },
	    {
	        "id": 1391,
	        "name": "Lagrán"
	    },
	    {
	        "id": 1392,
	        "name": "Elche de la Sierra"
	    },
	    {
	        "id": 1393,
	        "name": "Benidoleig"
	    },
	    {
	        "id": 1394,
	        "name": "Canjáyar"
	    },
	    {
	        "id": 1395,
	        "name": "Berrocalejo de Aragona"
	    },
	    {
	        "id": 1396,
	        "name": "Capilla"
	    },
	    {
	        "id": 1397,
	        "name": "Llubí"
	    },
	    {
	        "id": 1398,
	        "name": "Cabrils"
	    },
	    {
	        "id": 1399,
	        "name": "Los Ausines"
	    },
	    {
	        "id": 1400,
	        "name": "Bohonal de Ibor"
	    },
	    {
	        "id": 1401,
	        "name": "Rota"
	    },
	    {
	        "id": 1402,
	        "name": "Caracuel de Calatrava"
	    },
	    {
	        "id": 1403,
	        "name": "Fuente Palmera"
	    },
	    {
	        "id": 1404,
	        "name": "A Coruña"
	    },
	    {
	        "id": 1405,
	        "name": "Bascuñana de San Pedro"
	    },
	    {
	        "id": 1406,
	        "name": "Cabanes"
	    },
	    {
	        "id": 1407,
	        "name": "Bérchules"
	    },
	    {
	        "id": 1408,
	        "name": "Eibar"
	    },
	    {
	        "id": 1409,
	        "name": "Chucena"
	    },
	    {
	        "id": 1410,
	        "name": "Chilluévar"
	    },
	    {
	        "id": 1411,
	        "name": "Cacabelos"
	    },
	    {
	        "id": 1412,
	        "name": "El Pont de Bar"
	    },
	    {
	        "id": 1413,
	        "name": "Bezares"
	    },
	    {
	        "id": 1414,
	        "name": "Mondoñedo"
	    },
	    {
	        "id": 1415,
	        "name": "La Cabrera"
	    },
	    {
	        "id": 1416,
	        "name": "El Borge"
	    },
	    {
	        "id": 1417,
	        "name": "Murcia"
	    },
	    {
	        "id": 1418,
	        "name": "Arellano"
	    },
	    {
	        "id": 1419,
	        "name": "Entrimo"
	    },
	    {
	        "id": 1420,
	        "name": "Illas"
	    },
	    {
	        "id": 1421,
	        "name": "Tuineje"
	    },
	    {
	        "id": 1422,
	        "name": "Mondariz"
	    },
	    {
	        "id": 1423,
	        "name": "Añover de Tormes"
	    },
	    {
	        "id": 1424,
	        "name": "Puntallana"
	    },
	    {
	        "id": 1425,
	        "name": "Guriezo"
	    },
	    {
	        "id": 1426,
	        "name": "Bernardos"
	    },
	    {
	        "id": 1427,
	        "name": "Castilleja del Campo"
	    },
	    {
	        "id": 1428,
	        "name": "Barca"
	    },
	    {
	        "id": 1429,
	        "name": "Bonastre"
	    },
	    {
	        "id": 1430,
	        "name": "Calzada de Oropesa"
	    },
	    {
	        "id": 1431,
	        "name": "Algimia de Alfara"
	    },
	    {
	        "id": 1432,
	        "name": "Campaspero"
	    },
	    {
	        "id": 1433,
	        "name": "Etxebarria"
	    },
	    {
	        "id": 1434,
	        "name": "Bustillo del Oro"
	    },
	    {
	        "id": 1435,
	        "name": "Añón de Moncayo"
	    },
	    {
	        "id": 1436,
	        "name": "Laguardia"
	    },
	    {
	        "id": 1437,
	        "name": "Férez"
	    },
	    {
	        "id": 1438,
	        "name": "Benidorm"
	    },
	    {
	        "id": 1439,
	        "name": "Cantoria"
	    },
	    {
	        "id": 1440,
	        "name": "Carmonita"
	    },
	    {
	        "id": 1441,
	        "name": "Llucmajor"
	    },
	    {
	        "id": 1442,
	        "name": "Calaf"
	    },
	    {
	        "id": 1443,
	        "name": "Botija"
	    },
	    {
	        "id": 1444,
	        "name": "San Fernando"
	    },
	    {
	        "id": 1445,
	        "name": "Borriol"
	    },
	    {
	        "id": 1446,
	        "name": "Carrión de Calatrava"
	    },
	    {
	        "id": 1447,
	        "name": "Fuente-Tójar"
	    },
	    {
	        "id": 1448,
	        "name": "Culleredo"
	    },
	    {
	        "id": 1449,
	        "name": "Beamud"
	    },
	    {
	        "id": 1450,
	        "name": "Cabanelles"
	    },
	    {
	        "id": 1451,
	        "name": "Angón"
	    },
	    {
	        "id": 1452,
	        "name": "Elduain"
	    },
	    {
	        "id": 1453,
	        "name": "Encinasola"
	    },
	    {
	        "id": 1454,
	        "name": "Escañuela"
	    },
	    {
	        "id": 1455,
	        "name": "Calzada del Coto"
	    },
	    {
	        "id": 1456,
	        "name": "Arres"
	    },
	    {
	        "id": 1457,
	        "name": "Bobadilla"
	    },
	    {
	        "id": 1458,
	        "name": "Monforte de Lemos"
	    },
	    {
	        "id": 1459,
	        "name": "Cadalso de los Vidrios"
	    },
	    {
	        "id": 1460,
	        "name": "El Burgo"
	    },
	    {
	        "id": 1461,
	        "name": "Ojós"
	    },
	    {
	        "id": 1462,
	        "name": "Areso"
	    },
	    {
	        "id": 1463,
	        "name": "Esgos"
	    },
	    {
	        "id": 1464,
	        "name": "Langreo"
	    },
	    {
	        "id": 1465,
	        "name": "Belmonte de Campos"
	    },
	    {
	        "id": 1466,
	        "name": "Valsequillo de Gran Canaria"
	    },
	    {
	        "id": 1467,
	        "name": "Mondariz-Balneario"
	    },
	    {
	        "id": 1468,
	        "name": "Arabayona de Mógica"
	    },
	    {
	        "id": 1469,
	        "name": "Los Realejos"
	    },
	    {
	        "id": 1470,
	        "name": "Hazas de Cesto"
	    },
	    {
	        "id": 1471,
	        "name": "Bernuy de Porreros"
	    },
	    {
	        "id": 1472,
	        "name": "El Castillo de las Guardas"
	    },
	    {
	        "id": 1473,
	        "name": "Barcones"
	    },
	    {
	        "id": 1474,
	        "name": "Les Borges del Camp"
	    },
	    {
	        "id": 1475,
	        "name": "Azaila"
	    },
	    {
	        "id": 1476,
	        "name": "Camarena"
	    },
	    {
	        "id": 1477,
	        "name": "Alginet"
	    },
	    {
	        "id": 1478,
	        "name": "El Campillo"
	    },
	    {
	        "id": 1479,
	        "name": "Elantxobe"
	    },
	    {
	        "id": 1480,
	        "name": "Cabañas de Sayago"
	    },
	    {
	        "id": 1481,
	        "name": "Aranda de Moncayo"
	    },
	    {
	        "id": 1482,
	        "name": "Lanciego/Lantziego"
	    },
	    {
	        "id": 1483,
	        "name": "Fuensanta"
	    },
	    {
	        "id": 1484,
	        "name": "Benifallim"
	    },
	    {
	        "id": 1485,
	        "name": "Carboneras"
	    },
	    {
	        "id": 1486,
	        "name": "El Carrascalejo"
	    },
	    {
	        "id": 1487,
	        "name": "Maó"
	    },
	    {
	        "id": 1488,
	        "name": "Caldes d'Estrac"
	    },
	    {
	        "id": 1489,
	        "name": "Avellanosa de Muñó"
	    },
	    {
	        "id": 1490,
	        "name": "Brozas"
	    },
	    {
	        "id": 1491,
	        "name": "Sanlúcar de Barrameda"
	    },
	    {
	        "id": 1492,
	        "name": "Borriana/Burriana"
	    },
	    {
	        "id": 1493,
	        "name": "Carrizosa"
	    },
	    {
	        "id": 1494,
	        "name": "La Granjuela"
	    },
	    {
	        "id": 1495,
	        "name": "Curtis"
	    },
	    {
	        "id": 1496,
	        "name": "Belinchón"
	    },
	    {
	        "id": 1497,
	        "name": "Cadaqués"
	    },
	    {
	        "id": 1498,
	        "name": "Bubión"
	    },
	    {
	        "id": 1499,
	        "name": "Anguita"
	    },
	    {
	        "id": 1500,
	        "name": "Elgoibar"
	    },
	    {
	        "id": 1501,
	        "name": "Escacena del Campo"
	    },
	    {
	        "id": 1502,
	        "name": "Aragüés del Puerto"
	    },
	    {
	        "id": 1503,
	        "name": "Espelúy"
	    },
	    {
	        "id": 1504,
	        "name": "Campazas"
	    },
	    {
	        "id": 1505,
	        "name": "Arsèguel"
	    },
	    {
	        "id": 1506,
	        "name": "Brieva de Cameros"
	    },
	    {
	        "id": 1507,
	        "name": "Monterroso"
	    },
	    {
	        "id": 1508,
	        "name": "Camarma de Esteruelas"
	    },
	    {
	        "id": 1509,
	        "name": "Campillos"
	    },
	    {
	        "id": 1510,
	        "name": "Pliego"
	    },
	    {
	        "id": 1511,
	        "name": "Arguedas"
	    },
	    {
	        "id": 1512,
	        "name": "Xinzo de Limia"
	    },
	    {
	        "id": 1513,
	        "name": "Laviana"
	    },
	    {
	        "id": 1514,
	        "name": "Berzosilla"
	    },
	    {
	        "id": 1515,
	        "name": "Valleseco"
	    },
	    {
	        "id": 1516,
	        "name": "Moraña"
	    },
	    {
	        "id": 1517,
	        "name": "Arapiles"
	    },
	    {
	        "id": 1518,
	        "name": "El Rosario"
	    },
	    {
	        "id": 1519,
	        "name": "Hermandad de Campoo de Suso"
	    },
	    {
	        "id": 1520,
	        "name": "Boceguillas"
	    },
	    {
	        "id": 1521,
	        "name": "Cazalla de la Sierra"
	    },
	    {
	        "id": 1522,
	        "name": "Bayubas de Abajo"
	    },
	    {
	        "id": 1523,
	        "name": "Bot"
	    },
	    {
	        "id": 1524,
	        "name": "Bádenas"
	    },
	    {
	        "id": 1525,
	        "name": "Camarenilla"
	    },
	    {
	        "id": 1526,
	        "name": "Almàssera"
	    },
	    {
	        "id": 1527,
	        "name": "Camporredondo"
	    },
	    {
	        "id": 1528,
	        "name": "Elorrio"
	    },
	    {
	        "id": 1529,
	        "name": "Calzadilla de Tera"
	    },
	    {
	        "id": 1530,
	        "name": "Arándiga"
	    },
	    {
	        "id": 1531,
	        "name": "Lapuebla de Labarca"
	    },
	    {
	        "id": 1532,
	        "name": "Fuente-Álamo"
	    },
	    {
	        "id": 1533,
	        "name": "Benifato"
	    },
	    {
	        "id": 1534,
	        "name": "Castro de Filabres"
	    },
	    {
	        "id": 1535,
	        "name": "Blascomillán"
	    },
	    {
	        "id": 1536,
	        "name": "Casas de Don Pedro"
	    },
	    {
	        "id": 1537,
	        "name": "Manacor"
	    },
	    {
	        "id": 1538,
	        "name": "Caldes de Montbui"
	    },
	    {
	        "id": 1539,
	        "name": "Bahabón de Esgueva"
	    },
	    {
	        "id": 1540,
	        "name": "Cabañas del Castillo"
	    },
	    {
	        "id": 1541,
	        "name": "San Roque"
	    },
	    {
	        "id": 1542,
	        "name": "Cabanes"
	    },
	    {
	        "id": 1543,
	        "name": "Castellar de Santiago"
	    },
	    {
	        "id": 1544,
	        "name": "Guadalcázar"
	    },
	    {
	        "id": 1545,
	        "name": "Dodro"
	    },
	    {
	        "id": 1546,
	        "name": "Belmonte"
	    },
	    {
	        "id": 1547,
	        "name": "Caldes de Malavella"
	    },
	    {
	        "id": 1548,
	        "name": "Busquístar"
	    },
	    {
	        "id": 1549,
	        "name": "Anquela del Ducado"
	    },
	    {
	        "id": 1550,
	        "name": "Elgeta"
	    },
	    {
	        "id": 1551,
	        "name": "Fuenteheridos"
	    },
	    {
	        "id": 1552,
	        "name": "Frailes"
	    },
	    {
	        "id": 1553,
	        "name": "Campo de Villavidel"
	    },
	    {
	        "id": 1554,
	        "name": "Artesa de Lleida"
	    },
	    {
	        "id": 1555,
	        "name": "Briñas"
	    },
	    {
	        "id": 1556,
	        "name": "Muras"
	    },
	    {
	        "id": 1557,
	        "name": "Campo Real"
	    },
	    {
	        "id": 1558,
	        "name": "Canillas de Aceituno"
	    },
	    {
	        "id": 1559,
	        "name": "Puerto Lumbreras"
	    },
	    {
	        "id": 1560,
	        "name": "Aria"
	    },
	    {
	        "id": 1561,
	        "name": "Gomesende"
	    },
	    {
	        "id": 1562,
	        "name": "Lena"
	    },
	    {
	        "id": 1563,
	        "name": "Boada de Campos"
	    },
	    {
	        "id": 1564,
	        "name": "Vega de San Mateo"
	    },
	    {
	        "id": 1565,
	        "name": "Mos"
	    },
	    {
	        "id": 1566,
	        "name": "Arcediano"
	    },
	    {
	        "id": 1567,
	        "name": "San Andrés y Sauces"
	    },
	    {
	        "id": 1568,
	        "name": "Herrerías"
	    },
	    {
	        "id": 1569,
	        "name": "Brieva"
	    },
	    {
	        "id": 1570,
	        "name": "Constantina"
	    },
	    {
	        "id": 1571,
	        "name": "Bayubas de Arriba"
	    },
	    {
	        "id": 1572,
	        "name": "Botarell"
	    },
	    {
	        "id": 1573,
	        "name": "Báguena"
	    },
	    {
	        "id": 1574,
	        "name": "El Campillo de la Jara"
	    },
	    {
	        "id": 1575,
	        "name": "Almiserà"
	    },
	    {
	        "id": 1576,
	        "name": "Canalejas de Peñafiel"
	    },
	    {
	        "id": 1577,
	        "name": "Ereño"
	    },
	    {
	        "id": 1578,
	        "name": "Camarzana de Tera"
	    },
	    {
	        "id": 1579,
	        "name": "Ardisa"
	    },
	    {
	        "id": 1580,
	        "name": "Leza"
	    },
	    {
	        "id": 1581,
	        "name": "Fuentealbilla"
	    },
	    {
	        "id": 1582,
	        "name": "Benijófar"
	    },
	    {
	        "id": 1583,
	        "name": "Cóbdar"
	    },
	    {
	        "id": 1584,
	        "name": "Blasconuño de Matacabras"
	    },
	    {
	        "id": 1585,
	        "name": "Casas de Reina"
	    },
	    {
	        "id": 1586,
	        "name": "Mancor de la Vall"
	    },
	    {
	        "id": 1587,
	        "name": "Calders"
	    },
	    {
	        "id": 1588,
	        "name": "Los Balbases"
	    },
	    {
	        "id": 1589,
	        "name": "Cabezabellosa"
	    },
	    {
	        "id": 1590,
	        "name": "Setenil de las Bodegas"
	    },
	    {
	        "id": 1591,
	        "name": "Càlig"
	    },
	    {
	        "id": 1592,
	        "name": "Ciudad Real"
	    },
	    {
	        "id": 1593,
	        "name": "El Guijo"
	    },
	    {
	        "id": 1594,
	        "name": "Dumbría"
	    },
	    {
	        "id": 1595,
	        "name": "Belmontejo"
	    },
	    {
	        "id": 1596,
	        "name": "Calonge"
	    },
	    {
	        "id": 1597,
	        "name": "Cacín"
	    },
	    {
	        "id": 1598,
	        "name": "Anquela del Pedregal"
	    },
	    {
	        "id": 1599,
	        "name": "Eskoriatza"
	    },
	    {
	        "id": 1600,
	        "name": "Galaroza"
	    },
	    {
	        "id": 1601,
	        "name": "Fuensanta de Martos"
	    },
	    {
	        "id": 1602,
	        "name": "Camponaraya"
	    },
	    {
	        "id": 1603,
	        "name": "Artesa de Segre"
	    },
	    {
	        "id": 1604,
	        "name": "Briones"
	    },
	    {
	        "id": 1605,
	        "name": "Navia de Suarna"
	    },
	    {
	        "id": 1606,
	        "name": "Canencia"
	    },
	    {
	        "id": 1607,
	        "name": "Canillas de Albaida"
	    },
	    {
	        "id": 1608,
	        "name": "Ricote"
	    },
	    {
	        "id": 1609,
	        "name": "Aribe"
	    },
	    {
	        "id": 1610,
	        "name": "A Gudiña"
	    },
	    {
	        "id": 1611,
	        "name": "Valdés"
	    },
	    {
	        "id": 1612,
	        "name": "Boadilla del Camino"
	    },
	    {
	        "id": 1613,
	        "name": "Yaiza"
	    },
	    {
	        "id": 1614,
	        "name": "As Neves"
	    },
	    {
	        "id": 1615,
	        "name": "El Arco"
	    },
	    {
	        "id": 1616,
	        "name": "San Juan de la Rambla"
	    },
	    {
	        "id": 1617,
	        "name": "Lamasón"
	    },
	    {
	        "id": 1618,
	        "name": "Caballar"
	    },
	    {
	        "id": 1619,
	        "name": "Coria del Río"
	    },
	    {
	        "id": 1620,
	        "name": "Beratón"
	    },
	    {
	        "id": 1621,
	        "name": "Bràfim"
	    },
	    {
	        "id": 1622,
	        "name": "Bañón"
	    },
	    {
	        "id": 1623,
	        "name": "Camuñas"
	    },
	    {
	        "id": 1624,
	        "name": "Almoines"
	    },
	    {
	        "id": 1625,
	        "name": "Canillas de Esgueva"
	    },
	    {
	        "id": 1626,
	        "name": "Ermua"
	    },
	    {
	        "id": 1627,
	        "name": "Cañizal"
	    },
	    {
	        "id": 1628,
	        "name": "Ariza"
	    },
	    {
	        "id": 1629,
	        "name": "La Gineta"
	    },
	    {
	        "id": 1630,
	        "name": "Benilloba"
	    },
	    {
	        "id": 1631,
	        "name": "Cuevas del Almanzora"
	    },
	    {
	        "id": 1632,
	        "name": "Blascosancho"
	    },
	    {
	        "id": 1633,
	        "name": "Castilblanco"
	    },
	    {
	        "id": 1634,
	        "name": "Maria de la Salut"
	    },
	    {
	        "id": 1635,
	        "name": "Calella"
	    },
	    {
	        "id": 1636,
	        "name": "Baños de Valdearados"
	    },
	    {
	        "id": 1637,
	        "name": "Cabezuela del Valle"
	    },
	    {
	        "id": 1638,
	        "name": "Tarifa"
	    },
	    {
	        "id": 1639,
	        "name": "Corral de Calatrava"
	    },
	    {
	        "id": 1640,
	        "name": "Hinojosa del Duque"
	    },
	    {
	        "id": 1641,
	        "name": "Fene"
	    },
	    {
	        "id": 1642,
	        "name": "Beteta"
	    },
	    {
	        "id": 1643,
	        "name": "Camós"
	    },
	    {
	        "id": 1644,
	        "name": "Cádiar"
	    },
	    {
	        "id": 1645,
	        "name": "Ezkio-Itsaso"
	    },
	    {
	        "id": 1646,
	        "name": "Gibraleón"
	    },
	    {
	        "id": 1647,
	        "name": "Arén"
	    },
	    {
	        "id": 1648,
	        "name": "Fuerte del Rey"
	    },
	    {
	        "id": 1649,
	        "name": "La Sentiu de Sió"
	    },
	    {
	        "id": 1650,
	        "name": "Cabezón de Cameros"
	    },
	    {
	        "id": 1651,
	        "name": "Negueira de Muñiz"
	    },
	    {
	        "id": 1652,
	        "name": "Carabaña"
	    },
	    {
	        "id": 1653,
	        "name": "Cañete la Real"
	    },
	    {
	        "id": 1654,
	        "name": "San Javier"
	    },
	    {
	        "id": 1655,
	        "name": "Armañanzas"
	    },
	    {
	        "id": 1656,
	        "name": "O Irixo"
	    },
	    {
	        "id": 1657,
	        "name": "Llanera"
	    },
	    {
	        "id": 1658,
	        "name": "Boadilla de Rioseco"
	    },
	    {
	        "id": 1659,
	        "name": "Nigrán"
	    },
	    {
	        "id": 1660,
	        "name": "Armenteros"
	    },
	    {
	        "id": 1661,
	        "name": "San Miguel de Abona"
	    },
	    {
	        "id": 1662,
	        "name": "Laredo"
	    },
	    {
	        "id": 1663,
	        "name": "Cabañas de Polendos"
	    },
	    {
	        "id": 1664,
	        "name": "Coripe"
	    },
	    {
	        "id": 1665,
	        "name": "Berlanga de Duero"
	    },
	    {
	        "id": 1666,
	        "name": "Cabacés"
	    },
	    {
	        "id": 1667,
	        "name": "Barrachina"
	    },
	    {
	        "id": 1668,
	        "name": "Cardiel de los Montes"
	    },
	    {
	        "id": 1669,
	        "name": "Almussafes"
	    },
	    {
	        "id": 1670,
	        "name": "Carpio"
	    },
	    {
	        "id": 1671,
	        "name": "Fruiz"
	    },
	    {
	        "id": 1672,
	        "name": "Cañizo"
	    },
	    {
	        "id": 1673,
	        "name": "Artieda"
	    },
	    {
	        "id": 1674,
	        "name": "Laudio/Llodio"
	    },
	    {
	        "id": 1675,
	        "name": "Golosalvo"
	    },
	    {
	        "id": 1676,
	        "name": "Benillup"
	    },
	    {
	        "id": 1677,
	        "name": "Chercos"
	    },
	    {
	        "id": 1678,
	        "name": "El Bohodón"
	    },
	    {
	        "id": 1679,
	        "name": "Castuera"
	    },
	    {
	        "id": 1680,
	        "name": "Marratxí"
	    },
	    {
	        "id": 1681,
	        "name": "Calonge de Segarra"
	    },
	    {
	        "id": 1682,
	        "name": "Bañuelos de Bureba"
	    },
	    {
	        "id": 1683,
	        "name": "Cabrero"
	    },
	    {
	        "id": 1684,
	        "name": "Torre Alháquime"
	    },
	    {
	        "id": 1685,
	        "name": "Canet lo Roig"
	    },
	    {
	        "id": 1686,
	        "name": "Los Cortijos"
	    },
	    {
	        "id": 1687,
	        "name": "Hornachuelos"
	    },
	    {
	        "id": 1688,
	        "name": "Ferrol"
	    },
	    {
	        "id": 1689,
	        "name": "Boniches"
	    },
	    {
	        "id": 1690,
	        "name": "Campdevànol"
	    },
	    {
	        "id": 1691,
	        "name": "Cájar"
	    },
	    {
	        "id": 1692,
	        "name": "Aranzueque"
	    },
	    {
	        "id": 1693,
	        "name": "Hondarribia"
	    },
	    {
	        "id": 1694,
	        "name": "La Granada de Río-Tinto"
	    },
	    {
	        "id": 1695,
	        "name": "Argavieso"
	    },
	    {
	        "id": 1696,
	        "name": "Candín"
	    },
	    {
	        "id": 1697,
	        "name": "Aspa"
	    },
	    {
	        "id": 1698,
	        "name": "Calahorra"
	    },
	    {
	        "id": 1699,
	        "name": "Casarrubuelos"
	    },
	    {
	        "id": 1700,
	        "name": "Carratraca"
	    },
	    {
	        "id": 1701,
	        "name": "San Pedro del Pinatar"
	    },
	    {
	        "id": 1702,
	        "name": "Arróniz"
	    },
	    {
	        "id": 1703,
	        "name": "Xunqueira de Ambía"
	    },
	    {
	        "id": 1704,
	        "name": "Llanes"
	    },
	    {
	        "id": 1705,
	        "name": "Brañosera"
	    },
	    {
	        "id": 1706,
	        "name": "Oia"
	    },
	    {
	        "id": 1707,
	        "name": "San Miguel del Robledo"
	    },
	    {
	        "id": 1708,
	        "name": "San Sebastián de la Gomera"
	    },
	    {
	        "id": 1709,
	        "name": "Liendo"
	    },
	    {
	        "id": 1710,
	        "name": "Cabezuela"
	    },
	    {
	        "id": 1711,
	        "name": "El Coronil"
	    },
	    {
	        "id": 1712,
	        "name": "Blacos"
	    },
	    {
	        "id": 1713,
	        "name": "Cabra del Camp"
	    },
	    {
	        "id": 1714,
	        "name": "Bea"
	    },
	    {
	        "id": 1715,
	        "name": "Carmena"
	    },
	    {
	        "id": 1716,
	        "name": "Alpuente"
	    },
	    {
	        "id": 1717,
	        "name": "Casasola de Arión"
	    },
	    {
	        "id": 1718,
	        "name": "Galdakao"
	    },
	    {
	        "id": 1719,
	        "name": "Carbajales de Alba"
	    },
	    {
	        "id": 1720,
	        "name": "Asín"
	    },
	    {
	        "id": 1721,
	        "name": "Arraia-Maeztu"
	    },
	    {
	        "id": 1722,
	        "name": "Hellín"
	    },
	    {
	        "id": 1723,
	        "name": "Benimantell"
	    },
	    {
	        "id": 1724,
	        "name": "Chirivel"
	    },
	    {
	        "id": 1725,
	        "name": "Bohoyo"
	    },
	    {
	        "id": 1726,
	        "name": "La Codosera"
	    },
	    {
	        "id": 1727,
	        "name": "Es Mercadal"
	    },
	    {
	        "id": 1728,
	        "name": "Calldetenes"
	    },
	    {
	        "id": 1729,
	        "name": "Barbadillo de Herreros"
	    },
	    {
	        "id": 1730,
	        "name": "Cáceres"
	    },
	    {
	        "id": 1731,
	        "name": "Trebujena"
	    },
	    {
	        "id": 1732,
	        "name": "Castell de Cabres"
	    },
	    {
	        "id": 1733,
	        "name": "Cózar"
	    },
	    {
	        "id": 1734,
	        "name": "Iznájar"
	    },
	    {
	        "id": 1735,
	        "name": "Fisterra"
	    },
	    {
	        "id": 1736,
	        "name": "Campelles"
	    },
	    {
	        "id": 1737,
	        "name": "Calicasas"
	    },
	    {
	        "id": 1738,
	        "name": "Arbancón"
	    },
	    {
	        "id": 1739,
	        "name": "Gaintza"
	    },
	    {
	        "id": 1740,
	        "name": "El Granado"
	    },
	    {
	        "id": 1741,
	        "name": "Arguis"
	    },
	    {
	        "id": 1742,
	        "name": "Génave"
	    },
	    {
	        "id": 1743,
	        "name": "Cármenes"
	    },
	    {
	        "id": 1744,
	        "name": "Les Avellanes i Santa Linya"
	    },
	    {
	        "id": 1745,
	        "name": "Camprovín"
	    },
	    {
	        "id": 1746,
	        "name": "As Nogais"
	    },
	    {
	        "id": 1747,
	        "name": "Cenicientos"
	    },
	    {
	        "id": 1748,
	        "name": "Cartajima"
	    },
	    {
	        "id": 1749,
	        "name": "Torre-Pacheco"
	    },
	    {
	        "id": 1750,
	        "name": "Arruazu"
	    },
	    {
	        "id": 1751,
	        "name": "Xunqueira de Espadanedo"
	    },
	    {
	        "id": 1752,
	        "name": "Mieres"
	    },
	    {
	        "id": 1753,
	        "name": "Buenavista de Valdavia"
	    },
	    {
	        "id": 1754,
	        "name": "Pazos de Borbén"
	    },
	    {
	        "id": 1755,
	        "name": "La Atalaya"
	    },
	    {
	        "id": 1756,
	        "name": "Santa Cruz de la Palma"
	    },
	    {
	        "id": 1757,
	        "name": "Liérganes"
	    },
	    {
	        "id": 1758,
	        "name": "Calabazas de Fuentidueña"
	    },
	    {
	        "id": 1759,
	        "name": "Los Corrales"
	    },
	    {
	        "id": 1760,
	        "name": "Bliecos"
	    },
	    {
	        "id": 1761,
	        "name": "Calafell"
	    },
	    {
	        "id": 1762,
	        "name": "Beceite"
	    },
	    {
	        "id": 1763,
	        "name": "El Carpio de Tajo"
	    },
	    {
	        "id": 1764,
	        "name": "l'Alqueria de la Comtessa"
	    },
	    {
	        "id": 1765,
	        "name": "Castrejón de Trabancos"
	    },
	    {
	        "id": 1766,
	        "name": "Galdames"
	    },
	    {
	        "id": 1767,
	        "name": "Carbellino"
	    },
	    {
	        "id": 1768,
	        "name": "Atea"
	    },
	    {
	        "id": 1769,
	        "name": "La Herrera"
	    },
	    {
	        "id": 1770,
	        "name": "Benimarfull"
	    },
	    {
	        "id": 1771,
	        "name": "Dalías"
	    },
	    {
	        "id": 1772,
	        "name": "Bonilla de la Sierra"
	    },
	    {
	        "id": 1773,
	        "name": "Cordobilla de Lácara"
	    },
	    {
	        "id": 1774,
	        "name": "Montuïri"
	    },
	    {
	        "id": 1775,
	        "name": "Callús"
	    },
	    {
	        "id": 1776,
	        "name": "Barbadillo del Mercado"
	    },
	    {
	        "id": 1777,
	        "name": "Cachorrilla"
	    },
	    {
	        "id": 1778,
	        "name": "Ubrique"
	    },
	    {
	        "id": 1779,
	        "name": "Castellfort"
	    },
	    {
	        "id": 1780,
	        "name": "Chillón"
	    },
	    {
	        "id": 1781,
	        "name": "Lucena"
	    },
	    {
	        "id": 1782,
	        "name": "Frades"
	    },
	    {
	        "id": 1783,
	        "name": "Buciegas"
	    },
	    {
	        "id": 1784,
	        "name": "Campllong"
	    },
	    {
	        "id": 1785,
	        "name": "Campotéjar"
	    },
	    {
	        "id": 1786,
	        "name": "Arbeteta"
	    },
	    {
	        "id": 1787,
	        "name": "Gabiria"
	    },
	    {
	        "id": 1788,
	        "name": "Higuera de la Sierra"
	    },
	    {
	        "id": 1789,
	        "name": "La Guardia de Jaén"
	    },
	    {
	        "id": 1790,
	        "name": "Carracedelo"
	    },
	    {
	        "id": 1791,
	        "name": "Aitona"
	    },
	    {
	        "id": 1792,
	        "name": "Canales de la Sierra"
	    },
	    {
	        "id": 1793,
	        "name": "Ourol"
	    },
	    {
	        "id": 1794,
	        "name": "Cercedilla"
	    },
	    {
	        "id": 1795,
	        "name": "Cártama"
	    },
	    {
	        "id": 1796,
	        "name": "Las Torres de Cotillas"
	    },
	    {
	        "id": 1797,
	        "name": "Artajona"
	    },
	    {
	        "id": 1798,
	        "name": "Larouco"
	    },
	    {
	        "id": 1799,
	        "name": "Morcín"
	    },
	    {
	        "id": 1800,
	        "name": "Bustillo de la Vega"
	    },
	    {
	        "id": 1801,
	        "name": "Pontevedra"
	    },
	    {
	        "id": 1802,
	        "name": "Babilafuente"
	    },
	    {
	        "id": 1803,
	        "name": "Santa Cruz de Tenerife"
	    },
	    {
	        "id": 1804,
	        "name": "Limpias"
	    },
	    {
	        "id": 1805,
	        "name": "Dos Hermanas"
	    },
	    {
	        "id": 1806,
	        "name": "Borjabad"
	    },
	    {
	        "id": 1807,
	        "name": "Cambrils"
	    },
	    {
	        "id": 1808,
	        "name": "Belmonte de San José"
	    },
	    {
	        "id": 1809,
	        "name": "Carranque"
	    },
	    {
	        "id": 1810,
	        "name": "Andilla"
	    },
	    {
	        "id": 1811,
	        "name": "Castrillo de Duero"
	    },
	    {
	        "id": 1812,
	        "name": "Gamiz-Fika"
	    },
	    {
	        "id": 1813,
	        "name": "Casaseca de Campeán"
	    },
	    {
	        "id": 1814,
	        "name": "Ateca"
	    },
	    {
	        "id": 1815,
	        "name": "Moreda de Álava/Moreda Araba"
	    },
	    {
	        "id": 1816,
	        "name": "Higueruela"
	    },
	    {
	        "id": 1817,
	        "name": "Benimassot"
	    },
	    {
	        "id": 1818,
	        "name": "Brabos"
	    },
	    {
	        "id": 1819,
	        "name": "La Coronada"
	    },
	    {
	        "id": 1820,
	        "name": "Muro"
	    },
	    {
	        "id": 1821,
	        "name": "Campins"
	    },
	    {
	        "id": 1822,
	        "name": "Barbadillo del Pez"
	    },
	    {
	        "id": 1823,
	        "name": "Cadalso"
	    },
	    {
	        "id": 1824,
	        "name": "Vejer de la Frontera"
	    },
	    {
	        "id": 1825,
	        "name": "Castellnovo"
	    },
	    {
	        "id": 1826,
	        "name": "Daimiel"
	    },
	    {
	        "id": 1827,
	        "name": "Luque"
	    },
	    {
	        "id": 1828,
	        "name": "Irixoa"
	    },
	    {
	        "id": 1829,
	        "name": "Buenache de Alarcón"
	    },
	    {
	        "id": 1830,
	        "name": "Camprodon"
	    },
	    {
	        "id": 1831,
	        "name": "Caniles"
	    },
	    {
	        "id": 1832,
	        "name": "Argecilla"
	    },
	    {
	        "id": 1833,
	        "name": "Getaria"
	    },
	    {
	        "id": 1834,
	        "name": "Hinojales"
	    },
	    {
	        "id": 1835,
	        "name": "Ayerbe"
	    },
	    {
	        "id": 1836,
	        "name": "Guarromán"
	    },
	    {
	        "id": 1837,
	        "name": "Carrizo"
	    },
	    {
	        "id": 1838,
	        "name": "Baix Pallars"
	    },
	    {
	        "id": 1839,
	        "name": "Canillas de Río Tuerto"
	    },
	    {
	        "id": 1840,
	        "name": "Outeiro de Rei"
	    },
	    {
	        "id": 1841,
	        "name": "Cervera de Buitrago"
	    },
	    {
	        "id": 1842,
	        "name": "Casabermeja"
	    },
	    {
	        "id": 1843,
	        "name": "Totana"
	    },
	    {
	        "id": 1844,
	        "name": "Artazu"
	    },
	    {
	        "id": 1845,
	        "name": "Laza"
	    },
	    {
	        "id": 1846,
	        "name": "Muros de Nalón"
	    },
	    {
	        "id": 1847,
	        "name": "Bustillo del Páramo de Carrión"
	    },
	    {
	        "id": 1848,
	        "name": "O Porriño"
	    },
	    {
	        "id": 1849,
	        "name": "Bañobárez"
	    },
	    {
	        "id": 1850,
	        "name": "Santa Úrsula"
	    },
	    {
	        "id": 1851,
	        "name": "Luena"
	    },
	    {
	        "id": 1852,
	        "name": "Campo de San Pedro"
	    },
	    {
	        "id": 1853,
	        "name": "Écija"
	    },
	    {
	        "id": 1854,
	        "name": "Borobia"
	    },
	    {
	        "id": 1855,
	        "name": "Capafonts"
	    },
	    {
	        "id": 1856,
	        "name": "Bello"
	    },
	    {
	        "id": 1857,
	        "name": "Carriches"
	    },
	    {
	        "id": 1858,
	        "name": "Anna"
	    },
	    {
	        "id": 1859,
	        "name": "Castrillo-Tejeriego"
	    },
	    {
	        "id": 1860,
	        "name": "Garai"
	    },
	    {
	        "id": 1861,
	        "name": "Casaseca de las Chanas"
	    },
	    {
	        "id": 1862,
	        "name": "Azuara"
	    },
	    {
	        "id": 1863,
	        "name": "Hoya-Gonzalo"
	    },
	    {
	        "id": 1864,
	        "name": "Benimeli"
	    },
	    {
	        "id": 1865,
	        "name": "Bularros"
	    },
	    {
	        "id": 1866,
	        "name": "Corte de Peleas"
	    },
	    {
	        "id": 1867,
	        "name": "Palma"
	    },
	    {
	        "id": 1868,
	        "name": "Canet de Mar"
	    },
	    {
	        "id": 1869,
	        "name": "Calzadilla"
	    },
	    {
	        "id": 1870,
	        "name": "Villaluenga del Rosario"
	    },
	    {
	        "id": 1871,
	        "name": "Castellón de la Plana/Castelló de la Plana"
	    },
	    {
	        "id": 1872,
	        "name": "Fernán Caballero"
	    },
	    {
	        "id": 1873,
	        "name": "Montalbán de Córdoba"
	    },
	    {
	        "id": 1874,
	        "name": "Laxe"
	    },
	    {
	        "id": 1875,
	        "name": "Buenache de la Sierra"
	    },
	    {
	        "id": 1876,
	        "name": "Canet d'Adri"
	    },
	    {
	        "id": 1877,
	        "name": "Cáñar"
	    },
	    {
	        "id": 1878,
	        "name": "Armallones"
	    },
	    {
	        "id": 1879,
	        "name": "Hernani"
	    },
	    {
	        "id": 1880,
	        "name": "Hinojos"
	    },
	    {
	        "id": 1881,
	        "name": "Azanuy-Alins"
	    },
	    {
	        "id": 1882,
	        "name": "Lahiguera"
	    },
	    {
	        "id": 1883,
	        "name": "Carrocera"
	    },
	    {
	        "id": 1884,
	        "name": "Balaguer"
	    },
	    {
	        "id": 1885,
	        "name": "Cañas"
	    },
	    {
	        "id": 1886,
	        "name": "Palas de Rei"
	    },
	    {
	        "id": 1887,
	        "name": "Ciempozuelos"
	    },
	    {
	        "id": 1888,
	        "name": "Casarabonela"
	    },
	    {
	        "id": 1889,
	        "name": "Ulea"
	    },
	    {
	        "id": 1890,
	        "name": "Atez"
	    },
	    {
	        "id": 1891,
	        "name": "Leiro"
	    },
	    {
	        "id": 1892,
	        "name": "Nava"
	    },
	    {
	        "id": 1893,
	        "name": "Portas"
	    },
	    {
	        "id": 1894,
	        "name": "Barbadillo"
	    },
	    {
	        "id": 1895,
	        "name": "Santiago del Teide"
	    },
	    {
	        "id": 1896,
	        "name": "Marina de Cudeyo"
	    },
	    {
	        "id": 1897,
	        "name": "Cantalejo"
	    },
	    {
	        "id": 1898,
	        "name": "Espartinas"
	    },
	    {
	        "id": 1899,
	        "name": "Capçanes"
	    },
	    {
	        "id": 1900,
	        "name": "Berge"
	    },
	    {
	        "id": 1901,
	        "name": "El Casar de Escalona"
	    },
	    {
	        "id": 1902,
	        "name": "Antella"
	    },
	    {
	        "id": 1903,
	        "name": "Castrobol"
	    },
	    {
	        "id": 1904,
	        "name": "Gatika"
	    },
	    {
	        "id": 1905,
	        "name": "Castrillo de la Guareña"
	    },
	    {
	        "id": 1906,
	        "name": "Badules"
	    },
	    {
	        "id": 1907,
	        "name": "Navaridas"
	    },
	    {
	        "id": 1908,
	        "name": "Jorquera"
	    },
	    {
	        "id": 1909,
	        "name": "Benissa"
	    },
	    {
	        "id": 1910,
	        "name": "Enix"
	    },
	    {
	        "id": 1911,
	        "name": "Burgohondo"
	    },
	    {
	        "id": 1912,
	        "name": "Cristina"
	    },
	    {
	        "id": 1913,
	        "name": "Petra"
	    },
	    {
	        "id": 1914,
	        "name": "Canovelles"
	    },
	    {
	        "id": 1915,
	        "name": "Barrio de Muñó"
	    },
	    {
	        "id": 1916,
	        "name": "Caminomorisco"
	    },
	    {
	        "id": 1917,
	        "name": "Villamartín"
	    },
	    {
	        "id": 1918,
	        "name": "Castillo de Villamalefa"
	    },
	    {
	        "id": 1919,
	        "name": "Fontanarejo"
	    },
	    {
	        "id": 1920,
	        "name": "Montemayor"
	    },
	    {
	        "id": 1921,
	        "name": "A Laracha"
	    },
	    {
	        "id": 1922,
	        "name": "Buendía"
	    },
	    {
	        "id": 1923,
	        "name": "Cantallops"
	    },
	    {
	        "id": 1924,
	        "name": "Armuña de Tajuña"
	    },
	    {
	        "id": 1925,
	        "name": "Hernialde"
	    },
	    {
	        "id": 1926,
	        "name": "Huelva"
	    },
	    {
	        "id": 1927,
	        "name": "Azara"
	    },
	    {
	        "id": 1928,
	        "name": "Higuera de Calatrava"
	    },
	    {
	        "id": 1929,
	        "name": "Carucedo"
	    },
	    {
	        "id": 1930,
	        "name": "Barbens"
	    },
	    {
	        "id": 1931,
	        "name": "Cárdenas"
	    },
	    {
	        "id": 1932,
	        "name": "Pantón"
	    },
	    {
	        "id": 1933,
	        "name": "Cobeña"
	    },
	    {
	        "id": 1934,
	        "name": "Casares"
	    },
	    {
	        "id": 1935,
	        "name": "La Unión"
	    },
	    {
	        "id": 1936,
	        "name": "Ayegui/Aiegi"
	    },
	    {
	        "id": 1937,
	        "name": "Lobeira"
	    },
	    {
	        "id": 1938,
	        "name": "Navia"
	    },
	    {
	        "id": 1939,
	        "name": "Calahorra de Boedo"
	    },
	    {
	        "id": 1940,
	        "name": "Poio"
	    },
	    {
	        "id": 1941,
	        "name": "Barbalos"
	    },
	    {
	        "id": 1942,
	        "name": "El Sauzal"
	    },
	    {
	        "id": 1943,
	        "name": "Mazcuerras"
	    },
	    {
	        "id": 1944,
	        "name": "Cantimpalos"
	    },
	    {
	        "id": 1945,
	        "name": "Estepa"
	    },
	    {
	        "id": 1946,
	        "name": "Buberos"
	    },
	    {
	        "id": 1947,
	        "name": "Caseres"
	    },
	    {
	        "id": 1948,
	        "name": "Bezas"
	    },
	    {
	        "id": 1949,
	        "name": "Casarrubios del Monte"
	    },
	    {
	        "id": 1950,
	        "name": "Aras de los Olmos"
	    },
	    {
	        "id": 1951,
	        "name": "Castrodeza"
	    },
	    {
	        "id": 1952,
	        "name": "Gautegiz Arteaga"
	    },
	    {
	        "id": 1953,
	        "name": "Castrogonzalo"
	    },
	    {
	        "id": 1954,
	        "name": "Bagüés"
	    },
	    {
	        "id": 1955,
	        "name": "Okondo"
	    },
	    {
	        "id": 1956,
	        "name": "Letur"
	    },
	    {
	        "id": 1957,
	        "name": "el Benitachell/Poble Nou de Benitatxell"
	    },
	    {
	        "id": 1958,
	        "name": "Cabezas de Alambre"
	    },
	    {
	        "id": 1959,
	        "name": "Cheles"
	    },
	    {
	        "id": 1960,
	        "name": "Pollença"
	    },
	    {
	        "id": 1961,
	        "name": "Cànoves i Samalús"
	    },
	    {
	        "id": 1962,
	        "name": "Campillo de Deleitosa"
	    },
	    {
	        "id": 1963,
	        "name": "Zahara"
	    },
	    {
	        "id": 1964,
	        "name": "Catí"
	    },
	    {
	        "id": 1965,
	        "name": "Fuencaliente"
	    },
	    {
	        "id": 1966,
	        "name": "Montilla"
	    },
	    {
	        "id": 1967,
	        "name": "Lousame"
	    },
	    {
	        "id": 1968,
	        "name": "Campillo de Altobuey"
	    },
	    {
	        "id": 1969,
	        "name": "Capmany"
	    },
	    {
	        "id": 1970,
	        "name": "Capileira"
	    },
	    {
	        "id": 1971,
	        "name": "Arroyo de las Fraguas"
	    },
	    {
	        "id": 1972,
	        "name": "Ibarra"
	    },
	    {
	        "id": 1973,
	        "name": "Isla Cristina"
	    },
	    {
	        "id": 1974,
	        "name": "Azlor"
	    },
	    {
	        "id": 1975,
	        "name": "Hinojares"
	    },
	    {
	        "id": 1976,
	        "name": "Castilfalé"
	    },
	    {
	        "id": 1977,
	        "name": "La Baronia de Rialb"
	    },
	    {
	        "id": 1978,
	        "name": "Casalarreina"
	    },
	    {
	        "id": 1979,
	        "name": "Paradela"
	    },
	    {
	        "id": 1980,
	        "name": "Colmenar del Arroyo"
	    },
	    {
	        "id": 1981,
	        "name": "Coín"
	    },
	    {
	        "id": 1982,
	        "name": "Villanueva del Río Segura"
	    },
	    {
	        "id": 1983,
	        "name": "Azagra"
	    },
	    {
	        "id": 1984,
	        "name": "Lobios"
	    },
	    {
	        "id": 1985,
	        "name": "Noreña"
	    },
	    {
	        "id": 1986,
	        "name": "Calzada de los Molinos"
	    },
	    {
	        "id": 1987,
	        "name": "Ponteareas"
	    },
	    {
	        "id": 1988,
	        "name": "Barceo"
	    },
	    {
	        "id": 1989,
	        "name": "Los Silos"
	    },
	    {
	        "id": 1990,
	        "name": "Medio Cudeyo"
	    },
	    {
	        "id": 1991,
	        "name": "Fuentes de Andalucía"
	    },
	    {
	        "id": 1992,
	        "name": "Buitrago"
	    },
	    {
	        "id": 1993,
	        "name": "Castellvell del Camp"
	    },
	    {
	        "id": 1994,
	        "name": "Blancas"
	    },
	    {
	        "id": 1995,
	        "name": "Casasbuenas"
	    },
	    {
	        "id": 1996,
	        "name": "Aielo de Malferit"
	    },
	    {
	        "id": 1997,
	        "name": "Castromembibre"
	    },
	    {
	        "id": 1998,
	        "name": "Gordexola"
	    },
	    {
	        "id": 1999,
	        "name": "Castronuevo"
	    },
	    {
	        "id": 2000,
	        "name": "Balconchán"
	    },
	    {
	        "id": 2001,
	        "name": "Oyón-Oion"
	    },
	    {
	        "id": 2002,
	        "name": "Lezuza"
	    },
	    {
	        "id": 2003,
	        "name": "Biar"
	    },
	    {
	        "id": 2004,
	        "name": "Felix"
	    },
	    {
	        "id": 2005,
	        "name": "Cabezas del Pozo"
	    },
	    {
	        "id": 2006,
	        "name": "Don Álvaro"
	    },
	    {
	        "id": 2007,
	        "name": "Porreres"
	    },
	    {
	        "id": 2008,
	        "name": "Canyelles"
	    },
	    {
	        "id": 2009,
	        "name": "Los Barrios de Bureba"
	    },
	    {
	        "id": 2010,
	        "name": "Campo Lugar"
	    },
	    {
	        "id": 2011,
	        "name": "Caudiel"
	    },
	    {
	        "id": 2012,
	        "name": "Fuenllana"
	    },
	    {
	        "id": 2013,
	        "name": "Montoro"
	    },
	    {
	        "id": 2014,
	        "name": "Malpica de Bergantiños"
	    },
	    {
	        "id": 2015,
	        "name": "Campillos-Paravientos"
	    },
	    {
	        "id": 2016,
	        "name": "Queralbs"
	    },
	    {
	        "id": 2017,
	        "name": "Carataunas"
	    },
	    {
	        "id": 2018,
	        "name": "Atanzón"
	    },
	    {
	        "id": 2019,
	        "name": "Idiazabal"
	    },
	    {
	        "id": 2020,
	        "name": "Jabugo"
	    },
	    {
	        "id": 2021,
	        "name": "Baélls"
	    },
	    {
	        "id": 2022,
	        "name": "Hornos"
	    },
	    {
	        "id": 2023,
	        "name": "Castrillo de Cabrera"
	    },
	    {
	        "id": 2024,
	        "name": "La Vall de Boí"
	    },
	    {
	        "id": 2025,
	        "name": "Castañares de Rioja"
	    },
	    {
	        "id": 2026,
	        "name": "O Páramo"
	    },
	    {
	        "id": 2027,
	        "name": "Colmenar de Oreja"
	    },
	    {
	        "id": 2028,
	        "name": "Colmenar"
	    },
	    {
	        "id": 2029,
	        "name": "Yecla"
	    },
	    {
	        "id": 2030,
	        "name": "Azuelo"
	    },
	    {
	        "id": 2031,
	        "name": "Maceda"
	    },
	    {
	        "id": 2032,
	        "name": "Onís"
	    },
	    {
	        "id": 2033,
	        "name": "Ponte Caldelas"
	    },
	    {
	        "id": 2034,
	        "name": "Tacoronte"
	    },
	    {
	        "id": 2035,
	        "name": "Meruelo"
	    },
	    {
	        "id": 2036,
	        "name": "Carbonero el Mayor"
	    },
	    {
	        "id": 2037,
	        "name": "El Garrobo"
	    },
	    {
	        "id": 2038,
	        "name": "Burgo de Osma-Ciudad de Osma"
	    },
	    {
	        "id": 2039,
	        "name": "El Catllar"
	    },
	    {
	        "id": 2040,
	        "name": "Blesa"
	    },
	    {
	        "id": 2041,
	        "name": "Castillo de Bayuela"
	    },
	    {
	        "id": 2042,
	        "name": "Aielo de Rugat"
	    },
	    {
	        "id": 2043,
	        "name": "Castromonte"
	    },
	    {
	        "id": 2044,
	        "name": "Gorliz"
	    },
	    {
	        "id": 2045,
	        "name": "Castroverde de Campos"
	    },
	    {
	        "id": 2046,
	        "name": "Bárboles"
	    },
	    {
	        "id": 2047,
	        "name": "Peñacerrada-Urizaharra"
	    },
	    {
	        "id": 2048,
	        "name": "Liétor"
	    },
	    {
	        "id": 2049,
	        "name": "Bigastro"
	    },
	    {
	        "id": 2050,
	        "name": "Fines"
	    },
	    {
	        "id": 2051,
	        "name": "Cabezas del Villar"
	    },
	    {
	        "id": 2052,
	        "name": "Don Benito"
	    },
	    {
	        "id": 2053,
	        "name": "Sa Pobla"
	    },
	    {
	        "id": 2054,
	        "name": "Capellades"
	    },
	    {
	        "id": 2055,
	        "name": "Barrios de Colina"
	    },
	    {
	        "id": 2056,
	        "name": "Cañamero"
	    },
	    {
	        "id": 2057,
	        "name": "Cervera del Maestre"
	    },
	    {
	        "id": 2058,
	        "name": "Fuente el Fresno"
	    },
	    {
	        "id": 2059,
	        "name": "Monturque"
	    },
	    {
	        "id": 2060,
	        "name": "Mañón"
	    },
	    {
	        "id": 2061,
	        "name": "Campillos-Sierra"
	    },
	    {
	        "id": 2062,
	        "name": "Cassà de la Selva"
	    },
	    {
	        "id": 2063,
	        "name": "Cástaras"
	    },
	    {
	        "id": 2064,
	        "name": "Atienza"
	    },
	    {
	        "id": 2065,
	        "name": "Ikaztegieta"
	    },
	    {
	        "id": 2066,
	        "name": "Lepe"
	    },
	    {
	        "id": 2067,
	        "name": "Bailo"
	    },
	    {
	        "id": 2068,
	        "name": "Huelma"
	    },
	    {
	        "id": 2069,
	        "name": "Castrillo de la Valduerna"
	    },
	    {
	        "id": 2070,
	        "name": "Bassella"
	    },
	    {
	        "id": 2071,
	        "name": "Castroviejo"
	    },
	    {
	        "id": 2072,
	        "name": "A Pastoriza"
	    },
	    {
	        "id": 2073,
	        "name": "Colmenarejo"
	    },
	    {
	        "id": 2074,
	        "name": "Comares"
	    },
	    {
	        "id": 2075,
	        "name": "Bakaiku"
	    },
	    {
	        "id": 2076,
	        "name": "Manzaneda"
	    },
	    {
	        "id": 2077,
	        "name": "Oviedo"
	    },
	    {
	        "id": 2078,
	        "name": "Pontecesures"
	    },
	    {
	        "id": 2079,
	        "name": "Barruecopardo"
	    },
	    {
	        "id": 2080,
	        "name": "El Tanque"
	    },
	    {
	        "id": 2081,
	        "name": "Miengo"
	    },
	    {
	        "id": 2082,
	        "name": "Carrascal del Río"
	    },
	    {
	        "id": 2083,
	        "name": "Gelves"
	    },
	    {
	        "id": 2084,
	        "name": "Cabrejas del Campo"
	    },
	    {
	        "id": 2085,
	        "name": "La Sénia"
	    },
	    {
	        "id": 2086,
	        "name": "Bordón"
	    },
	    {
	        "id": 2087,
	        "name": "Ayora"
	    },
	    {
	        "id": 2088,
	        "name": "Castronuevo de Esgueva"
	    },
	    {
	        "id": 2089,
	        "name": "Getxo"
	    },
	    {
	        "id": 2090,
	        "name": "Cazurra"
	    },
	    {
	        "id": 2091,
	        "name": "Bardallur"
	    },
	    {
	        "id": 2092,
	        "name": "Madrigueras"
	    },
	    {
	        "id": 2093,
	        "name": "Bolulla"
	    },
	    {
	        "id": 2094,
	        "name": "Fiñana"
	    },
	    {
	        "id": 2095,
	        "name": "Cabizuela"
	    },
	    {
	        "id": 2096,
	        "name": "Entrín Bajo"
	    },
	    {
	        "id": 2097,
	        "name": "Puigpunyent"
	    },
	    {
	        "id": 2098,
	        "name": "Capolat"
	    },
	    {
	        "id": 2099,
	        "name": "Basconcillos del Tozo"
	    },
	    {
	        "id": 2100,
	        "name": "Cañaveral"
	    },
	    {
	        "id": 2101,
	        "name": "Cinctorres"
	    },
	    {
	        "id": 2102,
	        "name": "Granátula de Calatrava"
	    },
	    {
	        "id": 2103,
	        "name": "Moriles"
	    },
	    {
	        "id": 2104,
	        "name": "Mazaricos"
	    },
	    {
	        "id": 2105,
	        "name": "Canalejas del Arroyo"
	    },
	    {
	        "id": 2106,
	        "name": "Castilléjar"
	    },
	    {
	        "id": 2107,
	        "name": "Auñón"
	    },
	    {
	        "id": 2108,
	        "name": "Irun"
	    },
	    {
	        "id": 2109,
	        "name": "Linares de la Sierra"
	    },
	    {
	        "id": 2110,
	        "name": "Baldellou"
	    },
	    {
	        "id": 2111,
	        "name": "Huesa"
	    },
	    {
	        "id": 2112,
	        "name": "Bausen"
	    },
	    {
	        "id": 2113,
	        "name": "Cellorigo"
	    },
	    {
	        "id": 2114,
	        "name": "Pedrafita do Cebreiro"
	    },
	    {
	        "id": 2115,
	        "name": "Colmenar Viejo"
	    },
	    {
	        "id": 2116,
	        "name": "Cómpeta"
	    },
	    {
	        "id": 2117,
	        "name": "Barásoain"
	    },
	    {
	        "id": 2118,
	        "name": "Maside"
	    },
	    {
	        "id": 2119,
	        "name": "Parres"
	    },
	    {
	        "id": 2120,
	        "name": "Capillas"
	    },
	    {
	        "id": 2121,
	        "name": "Redondela"
	    },
	    {
	        "id": 2122,
	        "name": "La Bastida"
	    },
	    {
	        "id": 2123,
	        "name": "Tazacorte"
	    },
	    {
	        "id": 2124,
	        "name": "Miera"
	    },
	    {
	        "id": 2125,
	        "name": "Casla"
	    },
	    {
	        "id": 2126,
	        "name": "Gerena"
	    },
	    {
	        "id": 2127,
	        "name": "Cabrejas del Pinar"
	    },
	    {
	        "id": 2128,
	        "name": "Colldejou"
	    },
	    {
	        "id": 2129,
	        "name": "Bronchales"
	    },
	    {
	        "id": 2130,
	        "name": "Cazalegas"
	    },
	    {
	        "id": 2131,
	        "name": "Barxeta"
	    },
	    {
	        "id": 2132,
	        "name": "Castronuño"
	    },
	    {
	        "id": 2133,
	        "name": "Güeñes"
	    },
	    {
	        "id": 2134,
	        "name": "Belchite"
	    },
	    {
	        "id": 2135,
	        "name": "Erriberagoitia/Ribera Alta"
	    },
	    {
	        "id": 2136,
	        "name": "Mahora"
	    },
	    {
	        "id": 2137,
	        "name": "Busot"
	    },
	    {
	        "id": 2138,
	        "name": "Fondón"
	    },
	    {
	        "id": 2139,
	        "name": "Canales"
	    },
	    {
	        "id": 2140,
	        "name": "Esparragalejo"
	    },
	    {
	        "id": 2141,
	        "name": "Sant Antoni de Portmany"
	    },
	    {
	        "id": 2142,
	        "name": "Cardedeu"
	    },
	    {
	        "id": 2143,
	        "name": "Bascuñana"
	    },
	    {
	        "id": 2144,
	        "name": "Carbajo"
	    },
	    {
	        "id": 2145,
	        "name": "Cirat"
	    },
	    {
	        "id": 2146,
	        "name": "Guadalmez"
	    },
	    {
	        "id": 2147,
	        "name": "Nueva Carteya"
	    },
	    {
	        "id": 2148,
	        "name": "Melide"
	    },
	    {
	        "id": 2149,
	        "name": "Cañada del Hoyo"
	    },
	    {
	        "id": 2150,
	        "name": "Castellfollit de la Roca"
	    },
	    {
	        "id": 2151,
	        "name": "Castril"
	    },
	    {
	        "id": 2152,
	        "name": "Azuqueca de Henares"
	    },
	    {
	        "id": 2153,
	        "name": "Irura"
	    },
	    {
	        "id": 2154,
	        "name": "Lucena del Puerto"
	    },
	    {
	        "id": 2155,
	        "name": "Ballobar"
	    },
	    {
	        "id": 2156,
	        "name": "Ibros"
	    },
	    {
	        "id": 2157,
	        "name": "Castrocalbón"
	    },
	    {
	        "id": 2158,
	        "name": "Belianes"
	    },
	    {
	        "id": 2159,
	        "name": "Cenicero"
	    },
	    {
	        "id": 2160,
	        "name": "Pol"
	    },
	    {
	        "id": 2161,
	        "name": "Collado Mediano"
	    },
	    {
	        "id": 2162,
	        "name": "Cortes de la Frontera"
	    },
	    {
	        "id": 2163,
	        "name": "Barbarin"
	    },
	    {
	        "id": 2164,
	        "name": "Melón"
	    },
	    {
	        "id": 2165,
	        "name": "Peñamellera Alta"
	    },
	    {
	        "id": 2166,
	        "name": "Cardeñosa de Volpejera"
	    },
	    {
	        "id": 2167,
	        "name": "Ribadumia"
	    },
	    {
	        "id": 2168,
	        "name": "Béjar"
	    },
	    {
	        "id": 2169,
	        "name": "Tegueste"
	    },
	    {
	        "id": 2170,
	        "name": "Molledo"
	    },
	    {
	        "id": 2171,
	        "name": "Castillejo de Mesleón"
	    },
	    {
	        "id": 2172,
	        "name": "Gilena"
	    },
	    {
	        "id": 2173,
	        "name": "Calatañazor"
	    },
	    {
	        "id": 2174,
	        "name": "Conesa"
	    },
	    {
	        "id": 2175,
	        "name": "Bueña"
	    },
	    {
	        "id": 2176,
	        "name": "Cebolla"
	    },
	    {
	        "id": 2177,
	        "name": "Barx"
	    },
	    {
	        "id": 2178,
	        "name": "Castroponce"
	    },
	    {
	        "id": 2179,
	        "name": "Gernika-Lumo"
	    },
	    {
	        "id": 2180,
	        "name": "Cerecinos de Campos"
	    },
	    {
	        "id": 2181,
	        "name": "Belmonte de Gracián"
	    },
	    {
	        "id": 2182,
	        "name": "Ribera Baja/Erribera Beitia"
	    },
	    {
	        "id": 2183,
	        "name": "Masegoso"
	    },
	    {
	        "id": 2184,
	        "name": "Calp"
	    },
	    {
	        "id": 2185,
	        "name": "Gádor"
	    },
	    {
	        "id": 2186,
	        "name": "Candeleda"
	    },
	    {
	        "id": 2187,
	        "name": "Esparragosa de la Serena"
	    },
	    {
	        "id": 2188,
	        "name": "Sencelles"
	    },
	    {
	        "id": 2189,
	        "name": "Cardona"
	    },
	    {
	        "id": 2190,
	        "name": "Belbimbre"
	    },
	    {
	        "id": 2191,
	        "name": "Carcaboso"
	    },
	    {
	        "id": 2192,
	        "name": "Herencia"
	    },
	    {
	        "id": 2193,
	        "name": "Obejo"
	    },
	    {
	        "id": 2194,
	        "name": "Mesía"
	    },
	    {
	        "id": 2195,
	        "name": "Cañada Juncosa"
	    },
	    {
	        "id": 2196,
	        "name": "Castelló d'Empúries"
	    },
	    {
	        "id": 2197,
	        "name": "Cenes de la Vega"
	    },
	    {
	        "id": 2198,
	        "name": "Baides"
	    },
	    {
	        "id": 2199,
	        "name": "Itsasondo"
	    },
	    {
	        "id": 2200,
	        "name": "Manzanilla"
	    },
	    {
	        "id": 2201,
	        "name": "Banastás"
	    },
	    {
	        "id": 2202,
	        "name": "La Iruela"
	    },
	    {
	        "id": 2203,
	        "name": "Castrocontrigo"
	    },
	    {
	        "id": 2204,
	        "name": "Bellcaire d'Urgell"
	    },
	    {
	        "id": 2205,
	        "name": "Cervera del Río Alhama"
	    },
	    {
	        "id": 2206,
	        "name": "A Pobra do Brollón"
	    },
	    {
	        "id": 2207,
	        "name": "Collado Villalba"
	    },
	    {
	        "id": 2208,
	        "name": "Cuevas Bajas"
	    },
	    {
	        "id": 2209,
	        "name": "Bargota"
	    },
	    {
	        "id": 2210,
	        "name": "A Merca"
	    },
	    {
	        "id": 2211,
	        "name": "Peñamellera Baja"
	    },
	    {
	        "id": 2212,
	        "name": "Carrión de los Condes"
	    },
	    {
	        "id": 2213,
	        "name": "Rodeiro"
	    },
	    {
	        "id": 2214,
	        "name": "Beleña"
	    },
	    {
	        "id": 2215,
	        "name": "Tijarafe"
	    },
	    {
	        "id": 2216,
	        "name": "Noja"
	    },
	    {
	        "id": 2217,
	        "name": "Castro de Fuentidueña"
	    },
	    {
	        "id": 2218,
	        "name": "Gines"
	    },
	    {
	        "id": 2219,
	        "name": "Constantí"
	    },
	    {
	        "id": 2220,
	        "name": "Burbáguena"
	    },
	    {
	        "id": 2221,
	        "name": "Cedillo del Condado"
	    },
	    {
	        "id": 2222,
	        "name": "Bèlgida"
	    },
	    {
	        "id": 2223,
	        "name": "Castroverde de Cerrato"
	    },
	    {
	        "id": 2224,
	        "name": "Gizaburuaga"
	    },
	    {
	        "id": 2225,
	        "name": "Cerecinos del Carrizal"
	    },
	    {
	        "id": 2226,
	        "name": "Berdejo"
	    },
	    {
	        "id": 2227,
	        "name": "Minaya"
	    },
	    {
	        "id": 2228,
	        "name": "Callosa d'En Sarrià"
	    },
	    {
	        "id": 2229,
	        "name": "Los Gallardos"
	    },
	    {
	        "id": 2230,
	        "name": "Cantiveros"
	    },
	    {
	        "id": 2231,
	        "name": "Esparragosa de Lares"
	    },
	    {
	        "id": 2232,
	        "name": "Sant Josep de sa Talaia"
	    },
	    {
	        "id": 2233,
	        "name": "Carme"
	    },
	    {
	        "id": 2234,
	        "name": "Belorado"
	    },
	    {
	        "id": 2235,
	        "name": "Carrascalejo"
	    },
	    {
	        "id": 2236,
	        "name": "Cortes de Arenoso"
	    },
	    {
	        "id": 2237,
	        "name": "Hinojosas de Calatrava"
	    },
	    {
	        "id": 2238,
	        "name": "Palenciana"
	    },
	    {
	        "id": 2239,
	        "name": "Miño"
	    },
	    {
	        "id": 2240,
	        "name": "Cañamares"
	    },
	    {
	        "id": 2241,
	        "name": "Castell-Platja d'Aro"
	    },
	    {
	        "id": 2242,
	        "name": "Cijuela"
	    },
	    {
	        "id": 2243,
	        "name": "Baños de Tajo"
	    },
	    {
	        "id": 2244,
	        "name": "Larraul"
	    },
	    {
	        "id": 2245,
	        "name": "Los Marines"
	    },
	    {
	        "id": 2246,
	        "name": "Barbastro"
	    },
	    {
	        "id": 2247,
	        "name": "Iznatoraf"
	    },
	    {
	        "id": 2248,
	        "name": "Bell-lloc d'Urgell"
	    },
	    {
	        "id": 2249,
	        "name": "Cidamón"
	    },
	    {
	        "id": 2250,
	        "name": "A Pontenova"
	    },
	    {
	        "id": 2251,
	        "name": "Corpa"
	    },
	    {
	        "id": 2252,
	        "name": "Cuevas del Becerro"
	    },
	    {
	        "id": 2253,
	        "name": "Barillas"
	    },
	    {
	        "id": 2254,
	        "name": "A Mezquita"
	    },
	    {
	        "id": 2255,
	        "name": "Pesoz"
	    },
	    {
	        "id": 2256,
	        "name": "Castil de Vela"
	    },
	    {
	        "id": 2257,
	        "name": "O Rosal"
	    },
	    {
	        "id": 2258,
	        "name": "Valverde"
	    },
	    {
	        "id": 2259,
	        "name": "Penagos"
	    },
	    {
	        "id": 2260,
	        "name": "Castrojimeno"
	    },
	    {
	        "id": 2261,
	        "name": "Guadalcanal"
	    },
	    {
	        "id": 2262,
	        "name": "Caltojar"
	    },
	    {
	        "id": 2263,
	        "name": "Corbera d'Ebre"
	    },
	    {
	        "id": 2264,
	        "name": "Cabra de Mora"
	    },
	    {
	        "id": 2265,
	        "name": "Los Cerralbos"
	    },
	    {
	        "id": 2266,
	        "name": "Bellreguard"
	    },
	    {
	        "id": 2267,
	        "name": "Ceinos de Campos"
	    },
	    {
	        "id": 2268,
	        "name": "Ibarrangelu"
	    },
	    {
	        "id": 2269,
	        "name": "Cernadilla"
	    },
	    {
	        "id": 2270,
	        "name": "Berrueco"
	    },
	    {
	        "id": 2271,
	        "name": "Añana"
	    },
	    {
	        "id": 2272,
	        "name": "Molinicos"
	    },
	    {
	        "id": 2273,
	        "name": "Callosa de Segura"
	    },
	    {
	        "id": 2274,
	        "name": "Garrucha"
	    },
	    {
	        "id": 2275,
	        "name": "Cardeñosa"
	    },
	    {
	        "id": 2276,
	        "name": "Feria"
	    },
	    {
	        "id": 2277,
	        "name": "Sant Joan"
	    },
	    {
	        "id": 2278,
	        "name": "Casserres"
	    },
	    {
	        "id": 2279,
	        "name": "Casar de Cáceres"
	    },
	    {
	        "id": 2280,
	        "name": "Costur"
	    },
	    {
	        "id": 2281,
	        "name": "Horcajo de los Montes"
	    },
	    {
	        "id": 2282,
	        "name": "Palma del Río"
	    },
	    {
	        "id": 2283,
	        "name": "Moeche"
	    },
	    {
	        "id": 2284,
	        "name": "El Cañavate"
	    },
	    {
	        "id": 2285,
	        "name": "Celrà"
	    },
	    {
	        "id": 2286,
	        "name": "Cogollos de Guadix"
	    },
	    {
	        "id": 2287,
	        "name": "Bañuelos"
	    },
	    {
	        "id": 2288,
	        "name": "Lazkao"
	    },
	    {
	        "id": 2289,
	        "name": "Minas de Riotinto"
	    },
	    {
	        "id": 2290,
	        "name": "Barbués"
	    },
	    {
	        "id": 2291,
	        "name": "Jabalquinto"
	    },
	    {
	        "id": 2292,
	        "name": "Castropodame"
	    },
	    {
	        "id": 2293,
	        "name": "Bellmunt d'Urgell"
	    },
	    {
	        "id": 2294,
	        "name": "Cihuri"
	    },
	    {
	        "id": 2295,
	        "name": "Portomarín"
	    },
	    {
	        "id": 2296,
	        "name": "Coslada"
	    },
	    {
	        "id": 2297,
	        "name": "Cuevas de San Marcos"
	    },
	    {
	        "id": 2298,
	        "name": "Basaburua"
	    },
	    {
	        "id": 2299,
	        "name": "Montederramo"
	    },
	    {
	        "id": 2300,
	        "name": "Piloña"
	    },
	    {
	        "id": 2301,
	        "name": "Castrejón de la Peña"
	    },
	    {
	        "id": 2302,
	        "name": "Salceda de Caselas"
	    },
	    {
	        "id": 2303,
	        "name": "Bermellar"
	    },
	    {
	        "id": 2304,
	        "name": "Valle Gran Rey"
	    },
	    {
	        "id": 2305,
	        "name": "Peñarrubia"
	    },
	    {
	        "id": 2306,
	        "name": "Castroserna de Abajo"
	    },
	    {
	        "id": 2307,
	        "name": "Guillena"
	    },
	    {
	        "id": 2308,
	        "name": "Candilichera"
	    },
	    {
	        "id": 2309,
	        "name": "Cornudella de Montsant"
	    },
	    {
	        "id": 2310,
	        "name": "Calaceite"
	    },
	    {
	        "id": 2311,
	        "name": "Cervera de los Montes"
	    },
	    {
	        "id": 2312,
	        "name": "Bellús"
	    },
	    {
	        "id": 2313,
	        "name": "Cervillego de la Cruz"
	    },
	    {
	        "id": 2314,
	        "name": "Ispaster"
	    },
	    {
	        "id": 2315,
	        "name": "Montalvos"
	    },
	    {
	        "id": 2316,
	        "name": "el Campello"
	    },
	    {
	        "id": 2317,
	        "name": "Gérgal"
	    },
	    {
	        "id": 2318,
	        "name": "Fregenal de la Sierra"
	    },
	    {
	        "id": 2319,
	        "name": "Sant Joan de Labritja"
	    },
	    {
	        "id": 2320,
	        "name": "Castellar del Riu"
	    },
	    {
	        "id": 2321,
	        "name": "Berberana"
	    },
	    {
	        "id": 2322,
	        "name": "Casar de Palomero"
	    },
	    {
	        "id": 2323,
	        "name": "les Coves de Vinromà"
	    },
	    {
	        "id": 2324,
	        "name": "Las Labores"
	    },
	    {
	        "id": 2325,
	        "name": "Pedro Abad"
	    },
	    {
	        "id": 2326,
	        "name": "Monfero"
	    },
	    {
	        "id": 2327,
	        "name": "Cañaveras"
	    },
	    {
	        "id": 2328,
	        "name": "Cervià de Ter"
	    },
	    {
	        "id": 2329,
	        "name": "Cogollos de la Vega"
	    },
	    {
	        "id": 2330,
	        "name": "Barriopedro"
	    },
	    {
	        "id": 2331,
	        "name": "Leaburu"
	    },
	    {
	        "id": 2332,
	        "name": "Moguer"
	    },
	    {
	        "id": 2333,
	        "name": "Barbuñales"
	    },
	    {
	        "id": 2334,
	        "name": "Jaén"
	    },
	    {
	        "id": 2335,
	        "name": "Castrotierra de Valmadrigal"
	    },
	    {
	        "id": 2336,
	        "name": "Bellpuig"
	    },
	    {
	        "id": 2337,
	        "name": "Cirueña"
	    },
	    {
	        "id": 2338,
	        "name": "Quiroga"
	    },
	    {
	        "id": 2339,
	        "name": "Cubas de la Sagra"
	    },
	    {
	        "id": 2340,
	        "name": "Cútar"
	    },
	    {
	        "id": 2341,
	        "name": "Baztan"
	    },
	    {
	        "id": 2342,
	        "name": "Monterrei"
	    },
	    {
	        "id": 2343,
	        "name": "Ponga"
	    },
	    {
	        "id": 2344,
	        "name": "Castrillo de Don Juan"
	    },
	    {
	        "id": 2345,
	        "name": "Salvaterra de Miño"
	    },
	    {
	        "id": 2346,
	        "name": "Berrocal de Huebra"
	    },
	    {
	        "id": 2347,
	        "name": "Vallehermoso"
	    },
	    {
	        "id": 2348,
	        "name": "Pesaguero"
	    },
	    {
	        "id": 2349,
	        "name": "Herrera"
	    },
	    {
	        "id": 2350,
	        "name": "Cañamaque"
	    },
	    {
	        "id": 2351,
	        "name": "Creixell"
	    },
	    {
	        "id": 2352,
	        "name": "Calamocha"
	    },
	    {
	        "id": 2353,
	        "name": "Ciruelos"
	    },
	    {
	        "id": 2354,
	        "name": "Benagéber"
	    },
	    {
	        "id": 2355,
	        "name": "Cigales"
	    },
	    {
	        "id": 2356,
	        "name": "Izurtza"
	    },
	    {
	        "id": 2357,
	        "name": "Cobreros"
	    },
	    {
	        "id": 2358,
	        "name": "Bijuesca"
	    },
	    {
	        "id": 2359,
	        "name": "Salvatierra/Agurain"
	    },
	    {
	        "id": 2360,
	        "name": "Montealegre del Castillo"
	    },
	    {
	        "id": 2361,
	        "name": "el Campo de Mirra/Camp de Mirra"
	    },
	    {
	        "id": 2362,
	        "name": "Huécija"
	    },
	    {
	        "id": 2363,
	        "name": "La Carrera"
	    },
	    {
	        "id": 2364,
	        "name": "Fuenlabrada de los Montes"
	    },
	    {
	        "id": 2365,
	        "name": "Sant Llorenç des Cardassar"
	    },
	    {
	        "id": 2366,
	        "name": "Castellar del Vallès"
	    },
	    {
	        "id": 2367,
	        "name": "Berlangas de Roa"
	    },
	    {
	        "id": 2368,
	        "name": "Casares de las Hurdes"
	    },
	    {
	        "id": 2369,
	        "name": "Culla"
	    },
	    {
	        "id": 2370,
	        "name": "Luciana"
	    },
	    {
	        "id": 2371,
	        "name": "Pedroche"
	    },
	    {
	        "id": 2372,
	        "name": "Mugardos"
	    },
	    {
	        "id": 2373,
	        "name": "Cañaveruelas"
	    },
	    {
	        "id": 2374,
	        "name": "Cistella"
	    },
	    {
	        "id": 2375,
	        "name": "Colomera"
	    },
	    {
	        "id": 2376,
	        "name": "Berninches"
	    },
	    {
	        "id": 2377,
	        "name": "Legazpi"
	    },
	    {
	        "id": 2378,
	        "name": "La Nava"
	    },
	    {
	        "id": 2379,
	        "name": "Bárcabo"
	    },
	    {
	        "id": 2380,
	        "name": "Jamilena"
	    },
	    {
	        "id": 2381,
	        "name": "Cea"
	    },
	    {
	        "id": 2382,
	        "name": "Bellver de Cerdanya"
	    },
	    {
	        "id": 2383,
	        "name": "Clavijo"
	    },
	    {
	        "id": 2384,
	        "name": "Ribadeo"
	    },
	    {
	        "id": 2385,
	        "name": "Chapinería"
	    },
	    {
	        "id": 2386,
	        "name": "Estepona"
	    },
	    {
	        "id": 2387,
	        "name": "Beire"
	    },
	    {
	        "id": 2388,
	        "name": "Muíños"
	    },
	    {
	        "id": 2389,
	        "name": "Pravia"
	    },
	    {
	        "id": 2390,
	        "name": "Castrillo de Onielo"
	    },
	    {
	        "id": 2391,
	        "name": "Sanxenxo"
	    },
	    {
	        "id": 2392,
	        "name": "Berrocal de Salvatierra"
	    },
	    {
	        "id": 2393,
	        "name": "La Victoria de Acentejo"
	    },
	    {
	        "id": 2394,
	        "name": "Pesquera"
	    },
	    {
	        "id": 2395,
	        "name": "Castroserracín"
	    },
	    {
	        "id": 2396,
	        "name": "Huévar del Aljarafe"
	    },
	    {
	        "id": 2397,
	        "name": "Carabantes"
	    },
	    {
	        "id": 2398,
	        "name": "Cunit"
	    },
	    {
	        "id": 2399,
	        "name": "Calanda"
	    },
	    {
	        "id": 2400,
	        "name": "Cobeja"
	    },
	    {
	        "id": 2401,
	        "name": "Benaguasil"
	    },
	    {
	        "id": 2402,
	        "name": "Ciguñuela"
	    },
	    {
	        "id": 2403,
	        "name": "Lanestosa"
	    },
	    {
	        "id": 2404,
	        "name": "Biota"
	    },
	    {
	        "id": 2405,
	        "name": "Samaniego"
	    },
	    {
	        "id": 2406,
	        "name": "Motilleja"
	    },
	    {
	        "id": 2407,
	        "name": "Cañada"
	    },
	    {
	        "id": 2408,
	        "name": "Huércal de Almería"
	    },
	    {
	        "id": 2409,
	        "name": "Casas del Puerto"
	    },
	    {
	        "id": 2410,
	        "name": "Fuente de Cantos"
	    },
	    {
	        "id": 2411,
	        "name": "Sant Lluís"
	    },
	    {
	        "id": 2412,
	        "name": "Castellar de n'Hug"
	    },
	    {
	        "id": 2413,
	        "name": "Berzosa de Bureba"
	    },
	    {
	        "id": 2414,
	        "name": "Casas de Don Antonio"
	    },
	    {
	        "id": 2415,
	        "name": "Chert/Xert"
	    },
	    {
	        "id": 2416,
	        "name": "Malagón"
	    },
	    {
	        "id": 2417,
	        "name": "Peñarroya-Pueblonuevo"
	    },
	    {
	        "id": 2418,
	        "name": "Muxía"
	    },
	    {
	        "id": 2419,
	        "name": "Cañete"
	    },
	    {
	        "id": 2420,
	        "name": "Siurana"
	    },
	    {
	        "id": 2421,
	        "name": "La Bodera"
	    },
	    {
	        "id": 2422,
	        "name": "Legorreta"
	    },
	    {
	        "id": 2423,
	        "name": "Nerva"
	    },
	    {
	        "id": 2424,
	        "name": "Belver de Cinca"
	    },
	    {
	        "id": 2425,
	        "name": "Jimena"
	    },
	    {
	        "id": 2426,
	        "name": "Cebanico"
	    },
	    {
	        "id": 2427,
	        "name": "Bellvís"
	    },
	    {
	        "id": 2428,
	        "name": "Cordovín"
	    },
	    {
	        "id": 2429,
	        "name": "Ribas de Sil"
	    },
	    {
	        "id": 2430,
	        "name": "Chinchón"
	    },
	    {
	        "id": 2431,
	        "name": "Faraján"
	    },
	    {
	        "id": 2432,
	        "name": "Belascoáin"
	    },
	    {
	        "id": 2433,
	        "name": "Nogueira de Ramuín"
	    },
	    {
	        "id": 2434,
	        "name": "Proaza"
	    },
	    {
	        "id": 2435,
	        "name": "Castrillo de Villavega"
	    },
	    {
	        "id": 2436,
	        "name": "Silleda"
	    },
	    {
	        "id": 2437,
	        "name": "Boada"
	    },
	    {
	        "id": 2438,
	        "name": "Vilaflor"
	    },
	    {
	        "id": 2439,
	        "name": "Piélagos"
	    },
	    {
	        "id": 2440,
	        "name": "Cedillo de la Torre"
	    },
	    {
	        "id": 2441,
	        "name": "La Lantejuela"
	    },
	    {
	        "id": 2442,
	        "name": "Caracena"
	    },
	    {
	        "id": 2443,
	        "name": "Xerta"
	    },
	    {
	        "id": 2444,
	        "name": "Calomarde"
	    },
	    {
	        "id": 2445,
	        "name": "Cobisa"
	    },
	    {
	        "id": 2446,
	        "name": "Benavites"
	    },
	    {
	        "id": 2447,
	        "name": "Cistérniga"
	    },
	    {
	        "id": 2448,
	        "name": "Larrabetzu"
	    },
	    {
	        "id": 2449,
	        "name": "Coomonte"
	    },
	    {
	        "id": 2450,
	        "name": "Bisimbre"
	    },
	    {
	        "id": 2451,
	        "name": "San Millán/Donemiliaga"
	    },
	    {
	        "id": 2452,
	        "name": "Munera"
	    },
	    {
	        "id": 2453,
	        "name": "Castalla"
	    },
	    {
	        "id": 2454,
	        "name": "Huércal-Overa"
	    },
	    {
	        "id": 2455,
	        "name": "Casasola"
	    },
	    {
	        "id": 2456,
	        "name": "Fuente del Arco"
	    },
	    {
	        "id": 2457,
	        "name": "Santa Eugènia"
	    },
	    {
	        "id": 2458,
	        "name": "Castellbell i el Vilar"
	    },
	    {
	        "id": 2459,
	        "name": "Casas de Don Gómez"
	    },
	    {
	        "id": 2460,
	        "name": "Chilches/Xilxes"
	    },
	    {
	        "id": 2461,
	        "name": "Manzanares"
	    },
	    {
	        "id": 2462,
	        "name": "Posadas"
	    },
	    {
	        "id": 2463,
	        "name": "Muros"
	    },
	    {
	        "id": 2464,
	        "name": "Cañizares"
	    },
	    {
	        "id": 2465,
	        "name": "Cortes de Baza"
	    },
	    {
	        "id": 2466,
	        "name": "Brihuega"
	    },
	    {
	        "id": 2467,
	        "name": "Lezo"
	    },
	    {
	        "id": 2468,
	        "name": "Niebla"
	    },
	    {
	        "id": 2469,
	        "name": "Benabarre"
	    },
	    {
	        "id": 2470,
	        "name": "Jódar"
	    },
	    {
	        "id": 2471,
	        "name": "Cebrones del Río"
	    },
	    {
	        "id": 2472,
	        "name": "Benavent de Segrià"
	    },
	    {
	        "id": 2473,
	        "name": "Corera"
	    },
	    {
	        "id": 2474,
	        "name": "Ribeira de Piquín"
	    },
	    {
	        "id": 2475,
	        "name": "Daganzo de Arriba"
	    },
	    {
	        "id": 2476,
	        "name": "Frigiliana"
	    },
	    {
	        "id": 2477,
	        "name": "Berbinzana"
	    },
	    {
	        "id": 2478,
	        "name": "Oímbra"
	    },
	    {
	        "id": 2479,
	        "name": "Quirós"
	    },
	    {
	        "id": 2480,
	        "name": "Castromocho"
	    },
	    {
	        "id": 2481,
	        "name": "Soutomaior"
	    },
	    {
	        "id": 2482,
	        "name": "Villa de Mazo"
	    },
	    {
	        "id": 2483,
	        "name": "Polaciones"
	    },
	    {
	        "id": 2484,
	        "name": "Cerezo de Abajo"
	    },
	    {
	        "id": 2485,
	        "name": "Lebrija"
	    },
	    {
	        "id": 2486,
	        "name": "Carrascosa de Abajo"
	    },
	    {
	        "id": 2487,
	        "name": "Duesaigües"
	    },
	    {
	        "id": 2488,
	        "name": "Camañas"
	    },
	    {
	        "id": 2489,
	        "name": "Consuegra"
	    },
	    {
	        "id": 2490,
	        "name": "Beneixida"
	    },
	    {
	        "id": 2491,
	        "name": "Cogeces de Íscar"
	    },
	    {
	        "id": 2492,
	        "name": "Laukiz"
	    },
	    {
	        "id": 2493,
	        "name": "Coreses"
	    },
	    {
	        "id": 2494,
	        "name": "Boquiñeni"
	    },
	    {
	        "id": 2495,
	        "name": "Urkabustaiz"
	    },
	    {
	        "id": 2496,
	        "name": "Navas de Jorquera"
	    },
	    {
	        "id": 2497,
	        "name": "Castell de Castells"
	    },
	    {
	        "id": 2498,
	        "name": "Illar"
	    },
	    {
	        "id": 2499,
	        "name": "Casavieja"
	    },
	    {
	        "id": 2500,
	        "name": "Fuente del Maestre"
	    },
	    {
	        "id": 2501,
	        "name": "Santa Eulalia del Río"
	    },
	    {
	        "id": 2502,
	        "name": "Castellbisbal"
	    },
	    {
	        "id": 2503,
	        "name": "Bozoó"
	    },
	    {
	        "id": 2504,
	        "name": "Casas del Castañar"
	    },
	    {
	        "id": 2505,
	        "name": "Membrilla"
	    },
	    {
	        "id": 2506,
	        "name": "Pozoblanco"
	    },
	    {
	        "id": 2507,
	        "name": "Narón"
	    },
	    {
	        "id": 2508,
	        "name": "Colera"
	    },
	    {
	        "id": 2509,
	        "name": "Cortes y Graena"
	    },
	    {
	        "id": 2510,
	        "name": "Budia"
	    },
	    {
	        "id": 2511,
	        "name": "Lizartza"
	    },
	    {
	        "id": 2512,
	        "name": "La Palma del Condado"
	    },
	    {
	        "id": 2513,
	        "name": "Benasque"
	    },
	    {
	        "id": 2514,
	        "name": "Larva"
	    },
	    {
	        "id": 2515,
	        "name": "Cimanes de la Vega"
	    },
	    {
	        "id": 2516,
	        "name": "Cornago"
	    },
	    {
	        "id": 2517,
	        "name": "Riotorto"
	    },
	    {
	        "id": 2518,
	        "name": "El Escorial"
	    },
	    {
	        "id": 2519,
	        "name": "Fuengirola"
	    },
	    {
	        "id": 2520,
	        "name": "Bertizarana"
	    },
	    {
	        "id": 2521,
	        "name": "Ourense"
	    },
	    {
	        "id": 2522,
	        "name": "Las Regueras"
	    },
	    {
	        "id": 2523,
	        "name": "Tomiño"
	    },
	    {
	        "id": 2524,
	        "name": "El Bodón"
	    },
	    {
	        "id": 2525,
	        "name": "Polanco"
	    },
	    {
	        "id": 2526,
	        "name": "Cerezo de Arriba"
	    },
	    {
	        "id": 2527,
	        "name": "Lora de Estepa"
	    },
	    {
	        "id": 2528,
	        "name": "Carrascosa de la Sierra"
	    },
	    {
	        "id": 2529,
	        "name": "L'Espluga de Francolí"
	    },
	    {
	        "id": 2530,
	        "name": "Camarena de la Sierra"
	    },
	    {
	        "id": 2531,
	        "name": "Corral de Almaguer"
	    },
	    {
	        "id": 2532,
	        "name": "Benetússer"
	    },
	    {
	        "id": 2533,
	        "name": "Cogeces del Monte"
	    },
	    {
	        "id": 2534,
	        "name": "Leioa"
	    },
	    {
	        "id": 2535,
	        "name": "Corrales del Vino"
	    },
	    {
	        "id": 2536,
	        "name": "Bordalba"
	    },
	    {
	        "id": 2537,
	        "name": "Valdegovía/Gaubea"
	    },
	    {
	        "id": 2538,
	        "name": "Nerpio"
	    },
	    {
	        "id": 2539,
	        "name": "Catral"
	    },
	    {
	        "id": 2540,
	        "name": "Instinción"
	    },
	    {
	        "id": 2541,
	        "name": "Casillas"
	    },
	    {
	        "id": 2542,
	        "name": "Fuentes de León"
	    },
	    {
	        "id": 2543,
	        "name": "Santa Margalida"
	    },
	    {
	        "id": 2544,
	        "name": "Castellcir"
	    },
	    {
	        "id": 2545,
	        "name": "Brazacorta"
	    },
	    {
	        "id": 2546,
	        "name": "Casas del Monte"
	    },
	    {
	        "id": 2547,
	        "name": "Chodos/Xodos"
	    },
	    {
	        "id": 2548,
	        "name": "Mestanza"
	    },
	    {
	        "id": 2549,
	        "name": "Priego de Córdoba"
	    },
	    {
	        "id": 2550,
	        "name": "Neda"
	    },
	    {
	        "id": 2551,
	        "name": "Carboneras de Guadazaón"
	    },
	    {
	        "id": 2552,
	        "name": "Colomers"
	    },
	    {
	        "id": 2553,
	        "name": "Bujalaro"
	    },
	    {
	        "id": 2554,
	        "name": "Arrasate/Mondragón"
	    },
	    {
	        "id": 2555,
	        "name": "Palos de la Frontera"
	    },
	    {
	        "id": 2556,
	        "name": "Berbegal"
	    },
	    {
	        "id": 2557,
	        "name": "Linares"
	    },
	    {
	        "id": 2558,
	        "name": "Cimanes del Tejar"
	    },
	    {
	        "id": 2559,
	        "name": "Biosca"
	    },
	    {
	        "id": 2560,
	        "name": "Corporales"
	    },
	    {
	        "id": 2561,
	        "name": "Samos"
	    },
	    {
	        "id": 2562,
	        "name": "Estremera"
	    },
	    {
	        "id": 2563,
	        "name": "Fuente de Piedra"
	    },
	    {
	        "id": 2564,
	        "name": "Betelu"
	    },
	    {
	        "id": 2565,
	        "name": "Paderne de Allariz"
	    },
	    {
	        "id": 2566,
	        "name": "Ribadedeva"
	    },
	    {
	        "id": 2567,
	        "name": "Cervatos de la Cueza"
	    },
	    {
	        "id": 2568,
	        "name": "Tui"
	    },
	    {
	        "id": 2569,
	        "name": "Bogajo"
	    },
	    {
	        "id": 2570,
	        "name": "Potes"
	    },
	    {
	        "id": 2571,
	        "name": "Cilleruelo de San Mamés"
	    },
	    {
	        "id": 2572,
	        "name": "Lora del Río"
	    },
	    {
	        "id": 2573,
	        "name": "Casarejos"
	    },
	    {
	        "id": 2574,
	        "name": "Falset"
	    },
	    {
	        "id": 2575,
	        "name": "Camarillas"
	    },
	    {
	        "id": 2576,
	        "name": "Cuerva"
	    },
	    {
	        "id": 2577,
	        "name": "Beniarjó"
	    },
	    {
	        "id": 2578,
	        "name": "Corcos"
	    },
	    {
	        "id": 2579,
	        "name": "Lemoa"
	    },
	    {
	        "id": 2580,
	        "name": "Cotanes del Monte"
	    },
	    {
	        "id": 2581,
	        "name": "Borja"
	    },
	    {
	        "id": 2582,
	        "name": "Harana/Valle de Arana"
	    },
	    {
	        "id": 2583,
	        "name": "Ontur"
	    },
	    {
	        "id": 2584,
	        "name": "Cocentaina"
	    },
	    {
	        "id": 2585,
	        "name": "Laroya"
	    },
	    {
	        "id": 2586,
	        "name": "Castellanos de Zapardiel"
	    },
	    {
	        "id": 2587,
	        "name": "Garbayuela"
	    },
	    {
	        "id": 2588,
	        "name": "Santa María del Camí"
	    },
	    {
	        "id": 2589,
	        "name": "Castelldefels"
	    },
	    {
	        "id": 2590,
	        "name": "Briviesca"
	    },
	    {
	        "id": 2591,
	        "name": "Casas de Millán"
	    },
	    {
	        "id": 2592,
	        "name": "Chóvar"
	    },
	    {
	        "id": 2593,
	        "name": "Miguelturra"
	    },
	    {
	        "id": 2594,
	        "name": "Puente Genil"
	    },
	    {
	        "id": 2595,
	        "name": "Negreira"
	    },
	    {
	        "id": 2596,
	        "name": "Cardenete"
	    },
	    {
	        "id": 2597,
	        "name": "Cornellà del Terri"
	    },
	    {
	        "id": 2598,
	        "name": "Cúllar"
	    },
	    {
	        "id": 2599,
	        "name": "Mutriku"
	    },
	    {
	        "id": 2600,
	        "name": "Paterna del Campo"
	    },
	    {
	        "id": 2601,
	        "name": "Lopera"
	    },
	    {
	        "id": 2602,
	        "name": "Cistierna"
	    },
	    {
	        "id": 2603,
	        "name": "Bovera"
	    },
	    {
	        "id": 2604,
	        "name": "Cuzcurrita de Río Tirón"
	    },
	    {
	        "id": 2605,
	        "name": "Rábade"
	    },
	    {
	        "id": 2606,
	        "name": "Fresnedillas de la Oliva"
	    },
	    {
	        "id": 2607,
	        "name": "Gaucín"
	    },
	    {
	        "id": 2608,
	        "name": "Biurrun-Olcoz"
	    },
	    {
	        "id": 2609,
	        "name": "Padrenda"
	    },
	    {
	        "id": 2610,
	        "name": "Ribadesella"
	    },
	    {
	        "id": 2611,
	        "name": "Cervera de Pisuerga"
	    },
	    {
	        "id": 2612,
	        "name": "Valga"
	    },
	    {
	        "id": 2613,
	        "name": "La Bouza"
	    },
	    {
	        "id": 2614,
	        "name": "Puente Viesgo"
	    },
	    {
	        "id": 2615,
	        "name": "Cobos de Fuentidueña"
	    },
	    {
	        "id": 2616,
	        "name": "La Luisiana"
	    },
	    {
	        "id": 2617,
	        "name": "Castilfrío de la Sierra"
	    },
	    {
	        "id": 2618,
	        "name": "La Fatarella"
	    },
	    {
	        "id": 2619,
	        "name": "Caminreal"
	    },
	    {
	        "id": 2620,
	        "name": "Chozas de Canales"
	    },
	    {
	        "id": 2621,
	        "name": "Beniatjar"
	    },
	    {
	        "id": 2622,
	        "name": "Corrales de Duero"
	    },
	    {
	        "id": 2623,
	        "name": "Lemoiz"
	    },
	    {
	        "id": 2624,
	        "name": "Cubillos"
	    },
	    {
	        "id": 2625,
	        "name": "Botorrita"
	    },
	    {
	        "id": 2626,
	        "name": "Villabuena de Álava/Eskuernaga"
	    },
	    {
	        "id": 2627,
	        "name": "Ossa de Montiel"
	    },
	    {
	        "id": 2628,
	        "name": "Confrides"
	    },
	    {
	        "id": 2629,
	        "name": "Láujar de Andarax"
	    },
	    {
	        "id": 2630,
	        "name": "Cebreros"
	    },
	    {
	        "id": 2631,
	        "name": "Garlitos"
	    },
	    {
	        "id": 2632,
	        "name": "Santanyí"
	    },
	    {
	        "id": 2633,
	        "name": "Castell de l'Areny"
	    },
	    {
	        "id": 2634,
	        "name": "Bugedo"
	    },
	    {
	        "id": 2635,
	        "name": "Casas de Miravete"
	    },
	    {
	        "id": 2636,
	        "name": "Eslida"
	    },
	    {
	        "id": 2637,
	        "name": "Montiel"
	    },
	    {
	        "id": 2638,
	        "name": "La Rambla"
	    },
	    {
	        "id": 2639,
	        "name": "Noia"
	    },
	    {
	        "id": 2640,
	        "name": "Carrascosa"
	    },
	    {
	        "id": 2641,
	        "name": "Corçà"
	    },
	    {
	        "id": 2642,
	        "name": "Cúllar Vega"
	    },
	    {
	        "id": 2643,
	        "name": "Bustares"
	    },
	    {
	        "id": 2644,
	        "name": "Mutiloa"
	    },
	    {
	        "id": 2645,
	        "name": "Paymogo"
	    },
	    {
	        "id": 2646,
	        "name": "Bielsa"
	    },
	    {
	        "id": 2647,
	        "name": "Lupión"
	    },
	    {
	        "id": 2648,
	        "name": "Congosto"
	    },
	    {
	        "id": 2649,
	        "name": "Es Bòrdes"
	    },
	    {
	        "id": 2650,
	        "name": "Daroca de Rioja"
	    },
	    {
	        "id": 2651,
	        "name": "Sarria"
	    },
	    {
	        "id": 2652,
	        "name": "Fresno de Torote"
	    },
	    {
	        "id": 2653,
	        "name": "Genalguacil"
	    },
	    {
	        "id": 2654,
	        "name": "Buñuel"
	    },
	    {
	        "id": 2655,
	        "name": "Parada de Sil"
	    },
	    {
	        "id": 2656,
	        "name": "Ribera de Arriba"
	    },
	    {
	        "id": 2657,
	        "name": "Cevico de la Torre"
	    },
	    {
	        "id": 2658,
	        "name": "Vigo"
	    },
	    {
	        "id": 2659,
	        "name": "Bóveda del Río Almar"
	    },
	    {
	        "id": 2660,
	        "name": "Ramales de la Victoria"
	    },
	    {
	        "id": 2661,
	        "name": "Coca"
	    },
	    {
	        "id": 2662,
	        "name": "El Madroño"
	    },
	    {
	        "id": 2663,
	        "name": "Castilruiz"
	    },
	    {
	        "id": 2664,
	        "name": "La Febró"
	    },
	    {
	        "id": 2665,
	        "name": "Chueca"
	    },
	    {
	        "id": 2666,
	        "name": "Benicolet"
	    },
	    {
	        "id": 2667,
	        "name": "Cubillas de Santa Marta"
	    },
	    {
	        "id": 2668,
	        "name": "Lekeitio"
	    },
	    {
	        "id": 2669,
	        "name": "Cubo de Benavente"
	    },
	    {
	        "id": 2670,
	        "name": "Brea de Aragón"
	    },
	    {
	        "id": 2671,
	        "name": "Legutio"
	    },
	    {
	        "id": 2672,
	        "name": "Paterna del Madera"
	    },
	    {
	        "id": 2673,
	        "name": "Cox"
	    },
	    {
	        "id": 2674,
	        "name": "Líjar"
	    },
	    {
	        "id": 2675,
	        "name": "Cepeda la Mora"
	    },
	    {
	        "id": 2676,
	        "name": "La Garrovilla"
	    },
	    {
	        "id": 2677,
	        "name": "Selva"
	    },
	    {
	        "id": 2678,
	        "name": "Castellet i la Gornal"
	    },
	    {
	        "id": 2679,
	        "name": "Buniel"
	    },
	    {
	        "id": 2680,
	        "name": "Casatejada"
	    },
	    {
	        "id": 2681,
	        "name": "Espadilla"
	    },
	    {
	        "id": 2682,
	        "name": "Moral de Calatrava"
	    },
	    {
	        "id": 2683,
	        "name": "Rute"
	    },
	    {
	        "id": 2684,
	        "name": "Oleiros"
	    },
	    {
	        "id": 2685,
	        "name": "Carrascosa de Haro"
	    },
	    {
	        "id": 2686,
	        "name": "Crespià"
	    },
	    {
	        "id": 2687,
	        "name": "Cabanillas del Campo"
	    },
	    {
	        "id": 2688,
	        "name": "Olaberria"
	    },
	    {
	        "id": 2689,
	        "name": "Puebla de Guzmán"
	    },
	    {
	        "id": 2690,
	        "name": "Bierge"
	    },
	    {
	        "id": 2691,
	        "name": "Mancha Real"
	    },
	    {
	        "id": 2692,
	        "name": "Corbillos de los Oteros"
	    },
	    {
	        "id": 2693,
	        "name": "Les Borges Blanques"
	    },
	    {
	        "id": 2694,
	        "name": "Enciso"
	    },
	    {
	        "id": 2695,
	        "name": "O Saviñao"
	    },
	    {
	        "id": 2696,
	        "name": "Fuenlabrada"
	    },
	    {
	        "id": 2697,
	        "name": "Guaro"
	    },
	    {
	        "id": 2698,
	        "name": "Auritz/Burguete"
	    },
	    {
	        "id": 2699,
	        "name": "O Pereiro de Aguiar"
	    },
	    {
	        "id": 2700,
	        "name": "Riosa"
	    },
	    {
	        "id": 2701,
	        "name": "Cevico Navero"
	    },
	    {
	        "id": 2702,
	        "name": "Vilaboa"
	    },
	    {
	        "id": 2703,
	        "name": "Brincones"
	    },
	    {
	        "id": 2704,
	        "name": "Rasines"
	    },
	    {
	        "id": 2705,
	        "name": "Codorniz"
	    },
	    {
	        "id": 2706,
	        "name": "Mairena del Alcor"
	    },
	    {
	        "id": 2707,
	        "name": "Castillejo de Robledo"
	    },
	    {
	        "id": 2708,
	        "name": "La Figuera"
	    },
	    {
	        "id": 2709,
	        "name": "Domingo Pérez"
	    },
	    {
	        "id": 2710,
	        "name": "Benifairó de les Valls"
	    },
	    {
	        "id": 2711,
	        "name": "Cuenca de Campos"
	    },
	    {
	        "id": 2712,
	        "name": "Mallabia"
	    },
	    {
	        "id": 2713,
	        "name": "El Cubo de Tierra del Vino"
	    },
	    {
	        "id": 2714,
	        "name": "Bubierca"
	    },
	    {
	        "id": 2715,
	        "name": "Vitoria-Gasteiz"
	    },
	    {
	        "id": 2716,
	        "name": "Peñascosa"
	    },
	    {
	        "id": 2717,
	        "name": "Crevillent"
	    },
	    {
	        "id": 2718,
	        "name": "Lubrín"
	    },
	    {
	        "id": 2719,
	        "name": "Cillán"
	    },
	    {
	        "id": 2720,
	        "name": "Granja de Torrehermosa"
	    },
	    {
	        "id": 2721,
	        "name": "Ses Salines"
	    },
	    {
	        "id": 2722,
	        "name": "Castellfollit del Boix"
	    },
	    {
	        "id": 2723,
	        "name": "Burgos"
	    },
	    {
	        "id": 2724,
	        "name": "Casillas de Coria"
	    },
	    {
	        "id": 2725,
	        "name": "Fanzara"
	    },
	    {
	        "id": 2726,
	        "name": "Navalpino"
	    },
	    {
	        "id": 2727,
	        "name": "San Sebastián de los Ballesteros"
	    },
	    {
	        "id": 2728,
	        "name": "Ordes"
	    },
	    {
	        "id": 2729,
	        "name": "Chauchina"
	    },
	    {
	        "id": 2730,
	        "name": "Campillo de Dueñas"
	    },
	    {
	        "id": 2731,
	        "name": "Oñati"
	    },
	    {
	        "id": 2732,
	        "name": "Puerto Moral"
	    },
	    {
	        "id": 2733,
	        "name": "Biescas"
	    },
	    {
	        "id": 2734,
	        "name": "Marmolejo"
	    },
	    {
	        "id": 2735,
	        "name": "Corullón"
	    },
	    {
	        "id": 2736,
	        "name": "Bossòst"
	    },
	    {
	        "id": 2737,
	        "name": "Entrena"
	    },
	    {
	        "id": 2738,
	        "name": "Sober"
	    },
	    {
	        "id": 2739,
	        "name": "Fuente el Saz de Jarama"
	    },
	    {
	        "id": 2740,
	        "name": "Humilladero"
	    },
	    {
	        "id": 2741,
	        "name": "Burgui/Burgi"
	    },
	    {
	        "id": 2742,
	        "name": "A Peroxa"
	    },
	    {
	        "id": 2743,
	        "name": "Salas"
	    },
	    {
	        "id": 2744,
	        "name": "Cisneros"
	    },
	    {
	        "id": 2745,
	        "name": "Vila de Cruces"
	    },
	    {
	        "id": 2746,
	        "name": "Buenamadre"
	    },
	    {
	        "id": 2747,
	        "name": "Reinosa"
	    },
	    {
	        "id": 2748,
	        "name": "Collado Hermoso"
	    },
	    {
	        "id": 2749,
	        "name": "Mairena del Aljarafe"
	    },
	    {
	        "id": 2750,
	        "name": "Centenera de Andaluz"
	    },
	    {
	        "id": 2751,
	        "name": "Figuerola del Camp"
	    },
	    {
	        "id": 2752,
	        "name": "Cantavieja"
	    },
	    {
	        "id": 2753,
	        "name": "Dosbarrios"
	    },
	    {
	        "id": 2754,
	        "name": "Benifairó de la Valldigna"
	    },
	    {
	        "id": 2755,
	        "name": "Curiel de Duero"
	    },
	    {
	        "id": 2756,
	        "name": "Mañaria"
	    },
	    {
	        "id": 2757,
	        "name": "Cuelgamures"
	    },
	    {
	        "id": 2758,
	        "name": "Bujaraloz"
	    },
	    {
	        "id": 2759,
	        "name": "Yécora/Iekora"
	    },
	    {
	        "id": 2760,
	        "name": "Peñas de San Pedro"
	    },
	    {
	        "id": 2761,
	        "name": "Quatretondeta"
	    },
	    {
	        "id": 2762,
	        "name": "Lucainena de las Torres"
	    },
	    {
	        "id": 2763,
	        "name": "Cisla"
	    },
	    {
	        "id": 2764,
	        "name": "Guareña"
	    },
	    {
	        "id": 2765,
	        "name": "Sineu"
	    },
	    {
	        "id": 2766,
	        "name": "Castellfollit de Riubregós"
	    },
	    {
	        "id": 2767,
	        "name": "Busto de Bureba"
	    },
	    {
	        "id": 2768,
	        "name": "Castañar de Ibor"
	    },
	    {
	        "id": 2769,
	        "name": "Figueroles"
	    },
	    {
	        "id": 2770,
	        "name": "Navas de Estena"
	    },
	    {
	        "id": 2771,
	        "name": "Santaella"
	    },
	    {
	        "id": 2772,
	        "name": "Oroso"
	    },
	    {
	        "id": 2773,
	        "name": "Casas de Benítez"
	    },
	    {
	        "id": 2774,
	        "name": "Darnius"
	    },
	    {
	        "id": 2775,
	        "name": "Campillo de Ranas"
	    },
	    {
	        "id": 2776,
	        "name": "Orexa"
	    },
	    {
	        "id": 2777,
	        "name": "Punta Umbría"
	    },
	    {
	        "id": 2778,
	        "name": "Binaced"
	    },
	    {
	        "id": 2779,
	        "name": "Martos"
	    },
	    {
	        "id": 2780,
	        "name": "Crémenes"
	    },
	    {
	        "id": 2781,
	        "name": "Cabanabona"
	    },
	    {
	        "id": 2782,
	        "name": "Estollo"
	    },
	    {
	        "id": 2783,
	        "name": "Taboada"
	    },
	    {
	        "id": 2784,
	        "name": "Fuentidueña de Tajo"
	    },
	    {
	        "id": 2785,
	        "name": "Igualeja"
	    },
	    {
	        "id": 2786,
	        "name": "Burlada/Burlata"
	    },
	    {
	        "id": 2787,
	        "name": "Petín"
	    },
	    {
	        "id": 2788,
	        "name": "San Martín del Rey Aurelio"
	    },
	    {
	        "id": 2789,
	        "name": "Cobos de Cerrato"
	    },
	    {
	        "id": 2790,
	        "name": "Vilagarcía de Arousa"
	    },
	    {
	        "id": 2791,
	        "name": "Buenavista"
	    },
	    {
	        "id": 2792,
	        "name": "Reocín"
	    },
	    {
	        "id": 2793,
	        "name": "Condado de Castilnovo"
	    },
	    {
	        "id": 2794,
	        "name": "Marchena"
	    },
	    {
	        "id": 2795,
	        "name": "Cerbón"
	    },
	    {
	        "id": 2796,
	        "name": "Flix"
	    },
	    {
	        "id": 2797,
	        "name": "Cañada de Benatanduz"
	    },
	    {
	        "id": 2798,
	        "name": "Erustes"
	    },
	    {
	        "id": 2799,
	        "name": "Benifaió"
	    },
	    {
	        "id": 2800,
	        "name": "Encinas de Esgueva"
	    },
	    {
	        "id": 2801,
	        "name": "Markina-Xemein"
	    },
	    {
	        "id": 2802,
	        "name": "Bulbuente"
	    },
	    {
	        "id": 2803,
	        "name": "Zalduondo"
	    },
	    {
	        "id": 2804,
	        "name": "Pétrola"
	    },
	    {
	        "id": 2805,
	        "name": "Daya Nueva"
	    },
	    {
	        "id": 2806,
	        "name": "Lúcar"
	    },
	    {
	        "id": 2807,
	        "name": "La Colilla"
	    },
	    {
	        "id": 2808,
	        "name": "La Haba"
	    },
	    {
	        "id": 2809,
	        "name": "Sóller"
	    },
	    {
	        "id": 2810,
	        "name": "Castellgalí"
	    },
	    {
	        "id": 2811,
	        "name": "Cabañes de Esgueva"
	    },
	    {
	        "id": 2812,
	        "name": "Ceclavín"
	    },
	    {
	        "id": 2813,
	        "name": "Forcall"
	    },
	    {
	        "id": 2814,
	        "name": "Pedro Muñoz"
	    },
	    {
	        "id": 2815,
	        "name": "Santa Eufemia"
	    },
	    {
	        "id": 2816,
	        "name": "Ortigueira"
	    },
	    {
	        "id": 2817,
	        "name": "Casas de Fernando Alonso"
	    },
	    {
	        "id": 2818,
	        "name": "Das"
	    },
	    {
	        "id": 2819,
	        "name": "Chimeneas"
	    },
	    {
	        "id": 2820,
	        "name": "Campisábalos"
	    },
	    {
	        "id": 2821,
	        "name": "Orio"
	    },
	    {
	        "id": 2822,
	        "name": "Rociana del Condado"
	    },
	    {
	        "id": 2823,
	        "name": "Binéfar"
	    },
	    {
	        "id": 2824,
	        "name": "Mengíbar"
	    },
	    {
	        "id": 2825,
	        "name": "Cuadros"
	    },
	    {
	        "id": 2826,
	        "name": "Cabó"
	    },
	    {
	        "id": 2827,
	        "name": "Ezcaray"
	    },
	    {
	        "id": 2828,
	        "name": "Trabada"
	    },
	    {
	        "id": 2829,
	        "name": "Galapagar"
	    },
	    {
	        "id": 2830,
	        "name": "Istán"
	    },
	    {
	        "id": 2831,
	        "name": "El Busto"
	    },
	    {
	        "id": 2832,
	        "name": "Piñor"
	    },
	    {
	        "id": 2833,
	        "name": "San Martín de Oscos"
	    },
	    {
	        "id": 2834,
	        "name": "Collazos de Boedo"
	    },
	    {
	        "id": 2835,
	        "name": "Vilanova de Arousa"
	    },
	    {
	        "id": 2836,
	        "name": "El Cabaco"
	    },
	    {
	        "id": 2837,
	        "name": "Ribamontán al Mar"
	    },
	    {
	        "id": 2838,
	        "name": "Corral de Ayllón"
	    },
	    {
	        "id": 2839,
	        "name": "Marinaleda"
	    },
	    {
	        "id": 2840,
	        "name": "Cidones"
	    },
	    {
	        "id": 2841,
	        "name": "Forès"
	    },
	    {
	        "id": 2842,
	        "name": "La Cañada de Verich"
	    },
	    {
	        "id": 2843,
	        "name": "Escalona"
	    },
	    {
	        "id": 2844,
	        "name": "Beniflá"
	    },
	    {
	        "id": 2845,
	        "name": "Esguevillas de Esgueva"
	    },
	    {
	        "id": 2846,
	        "name": "Maruri-Jatabe"
	    },
	    {
	        "id": 2847,
	        "name": "Entrala"
	    },
	    {
	        "id": 2848,
	        "name": "Bureta"
	    },
	    {
	        "id": 2849,
	        "name": "Zambrana"
	    },
	    {
	        "id": 2850,
	        "name": "Povedilla"
	    },
	    {
	        "id": 2851,
	        "name": "Daya Vieja"
	    },
	    {
	        "id": 2852,
	        "name": "Macael"
	    },
	    {
	        "id": 2853,
	        "name": "Collado de Contreras"
	    },
	    {
	        "id": 2854,
	        "name": "Helechosa de los Montes"
	    },
	    {
	        "id": 2855,
	        "name": "Son Servera"
	    },
	    {
	        "id": 2856,
	        "name": "Castellnou de Bages"
	    },
	    {
	        "id": 2857,
	        "name": "Cabezón de la Sierra"
	    },
	    {
	        "id": 2858,
	        "name": "Cedillo"
	    },
	    {
	        "id": 2859,
	        "name": "Picón"
	    },
	    {
	        "id": 2860,
	        "name": "Torrecampo"
	    },
	    {
	        "id": 2861,
	        "name": "Outes"
	    },
	    {
	        "id": 2862,
	        "name": "Casas de Garcimolina"
	    },
	    {
	        "id": 2863,
	        "name": "L'Escala"
	    },
	    {
	        "id": 2864,
	        "name": "Churriana de la Vega"
	    },
	    {
	        "id": 2865,
	        "name": "Ormaiztegi"
	    },
	    {
	        "id": 2866,
	        "name": "Rosal de la Frontera"
	    },
	    {
	        "id": 2867,
	        "name": "Bisaurri"
	    },
	    {
	        "id": 2868,
	        "name": "Montizón"
	    },
	    {
	        "id": 2869,
	        "name": "Cubillas de los Oteros"
	    },
	    {
	        "id": 2870,
	        "name": "Camarasa"
	    },
	    {
	        "id": 2871,
	        "name": "Foncea"
	    },
	    {
	        "id": 2872,
	        "name": "Triacastela"
	    },
	    {
	        "id": 2873,
	        "name": "Garganta de los Montes"
	    },
	    {
	        "id": 2874,
	        "name": "Iznate"
	    },
	    {
	        "id": 2875,
	        "name": "Cabanillas"
	    },
	    {
	        "id": 2876,
	        "name": "Porqueira"
	    },
	    {
	        "id": 2877,
	        "name": "Santa Eulalia de Oscos"
	    },
	    {
	        "id": 2878,
	        "name": "Congosto de Valdavia"
	    },
	    {
	        "id": 2879,
	        "name": "Cabezabellosa de la Calzada"
	    },
	    {
	        "id": 2880,
	        "name": "Ribamontán al Monte"
	    },
	    {
	        "id": 2881,
	        "name": "Cubillo"
	    },
	    {
	        "id": 2882,
	        "name": "Martín de la Jara"
	    },
	    {
	        "id": 2883,
	        "name": "Cigudosa"
	    },
	    {
	        "id": 2884,
	        "name": "Freginals"
	    },
	    {
	        "id": 2885,
	        "name": "Cañada Vellida"
	    },
	    {
	        "id": 2886,
	        "name": "Escalonilla"
	    },
	    {
	        "id": 2887,
	        "name": "Benigánim"
	    },
	    {
	        "id": 2888,
	        "name": "Fombellida"
	    },
	    {
	        "id": 2889,
	        "name": "Mendata"
	    },
	    {
	        "id": 2890,
	        "name": "Espadañedo"
	    },
	    {
	        "id": 2891,
	        "name": "El Burgo de Ebro"
	    },
	    {
	        "id": 2892,
	        "name": "Zuia"
	    },
	    {
	        "id": 2893,
	        "name": "Pozohondo"
	    },
	    {
	        "id": 2894,
	        "name": "Dénia"
	    },
	    {
	        "id": 2895,
	        "name": "María"
	    },
	    {
	        "id": 2896,
	        "name": "Collado del Mirón"
	    },
	    {
	        "id": 2897,
	        "name": "Herrera del Duque"
	    },
	    {
	        "id": 2898,
	        "name": "Valldemossa"
	    },
	    {
	        "id": 2899,
	        "name": "Castellolí"
	    },
	    {
	        "id": 2900,
	        "name": "Cavia"
	    },
	    {
	        "id": 2901,
	        "name": "Cerezo"
	    },
	    {
	        "id": 2902,
	        "name": "Fuente la Reina"
	    },
	    {
	        "id": 2903,
	        "name": "Piedrabuena"
	    },
	    {
	        "id": 2904,
	        "name": "Valenzuela"
	    },
	    {
	        "id": 2905,
	        "name": "Oza dos Ríos"
	    },
	    {
	        "id": 2906,
	        "name": "Casas de Guijarro"
	    },
	    {
	        "id": 2907,
	        "name": "Espinelves"
	    },
	    {
	        "id": 2908,
	        "name": "Darro"
	    },
	    {
	        "id": 2909,
	        "name": "Oiartzun"
	    },
	    {
	        "id": 2910,
	        "name": "San Bartolomé de la Torre"
	    },
	    {
	        "id": 2911,
	        "name": "Biscarrués"
	    },
	    {
	        "id": 2912,
	        "name": "Navas de San Juan"
	    },
	    {
	        "id": 2913,
	        "name": "Cubillas de Rueda"
	    },
	    {
	        "id": 2914,
	        "name": "Canejan"
	    },
	    {
	        "id": 2915,
	        "name": "Fonzaleche"
	    },
	    {
	        "id": 2916,
	        "name": "O Valadouro"
	    },
	    {
	        "id": 2917,
	        "name": "Gargantilla del Lozoya y Pinilla de Buitrago"
	    },
	    {
	        "id": 2918,
	        "name": "Jimera de Líbar"
	    },
	    {
	        "id": 2919,
	        "name": "Cabredo"
	    },
	    {
	        "id": 2920,
	        "name": "A Pobra de Trives"
	    },
	    {
	        "id": 2921,
	        "name": "San Tirso de Abres"
	    },
	    {
	        "id": 2922,
	        "name": "Cordovilla la Real"
	    },
	    {
	        "id": 2923,
	        "name": "La Cabeza de Béjar"
	    },
	    {
	        "id": 2924,
	        "name": "Rionansa"
	    },
	    {
	        "id": 2925,
	        "name": "Cuéllar"
	    },
	    {
	        "id": 2926,
	        "name": "Los Molares"
	    },
	    {
	        "id": 2927,
	        "name": "Cihuela"
	    },
	    {
	        "id": 2928,
	        "name": "La Galera"
	    },
	    {
	        "id": 2929,
	        "name": "Cañizar del Olivar"
	    },
	    {
	        "id": 2930,
	        "name": "Espinoso del Rey"
	    },
	    {
	        "id": 2931,
	        "name": "Benimodo"
	    },
	    {
	        "id": 2932,
	        "name": "Fompedraza"
	    },
	    {
	        "id": 2933,
	        "name": "Mendexa"
	    },
	    {
	        "id": 2934,
	        "name": "Faramontanos de Tábara"
	    },
	    {
	        "id": 2935,
	        "name": "El Buste"
	    },
	    {
	        "id": 2936,
	        "name": "Pozo-Lorente"
	    },
	    {
	        "id": 2937,
	        "name": "Dolores"
	    },
	    {
	        "id": 2938,
	        "name": "Mojácar"
	    },
	    {
	        "id": 2939,
	        "name": "Constanzana"
	    },
	    {
	        "id": 2940,
	        "name": "Higuera de la Serena"
	    },
	    {
	        "id": 2941,
	        "name": "Es Castell"
	    },
	    {
	        "id": 2942,
	        "name": "Castellterçol"
	    },
	    {
	        "id": 2943,
	        "name": "Caleruega"
	    },
	    {
	        "id": 2944,
	        "name": "Cilleros"
	    },
	    {
	        "id": 2945,
	        "name": "Fuentes de Ayódar"
	    },
	    {
	        "id": 2946,
	        "name": "Poblete"
	    },
	    {
	        "id": 2947,
	        "name": "Valsequillo"
	    },
	    {
	        "id": 2948,
	        "name": "Paderne"
	    },
	    {
	        "id": 2949,
	        "name": "Casas de Haro"
	    },
	    {
	        "id": 2950,
	        "name": "Espolla"
	    },
	    {
	        "id": 2951,
	        "name": "Dehesas de Guadix"
	    },
	    {
	        "id": 2952,
	        "name": "Canredondo"
	    },
	    {
	        "id": 2953,
	        "name": "Pasaia"
	    },
	    {
	        "id": 2954,
	        "name": "San Juan del Puerto"
	    },
	    {
	        "id": 2955,
	        "name": "Blecua y Torres"
	    },
	    {
	        "id": 2956,
	        "name": "Noalejo"
	    },
	    {
	        "id": 2957,
	        "name": "Cubillos del Sil"
	    },
	    {
	        "id": 2958,
	        "name": "Castellar de la Ribera"
	    },
	    {
	        "id": 2959,
	        "name": "Fuenmayor"
	    },
	    {
	        "id": 2960,
	        "name": "O Vicedo"
	    },
	    {
	        "id": 2961,
	        "name": "Gascones"
	    },
	    {
	        "id": 2962,
	        "name": "Jubrique"
	    },
	    {
	        "id": 2963,
	        "name": "Cadreita"
	    },
	    {
	        "id": 2964,
	        "name": "Pontedeva"
	    },
	    {
	        "id": 2965,
	        "name": "Santo Adriano"
	    },
	    {
	        "id": 2966,
	        "name": "Riotuerto"
	    },
	    {
	        "id": 2967,
	        "name": "Montellano"
	    },
	    {
	        "id": 2968,
	        "name": "Ciria"
	    },
	    {
	        "id": 2969,
	        "name": "Gandesa"
	    },
	    {
	        "id": 2970,
	        "name": "Cascante del Río"
	    },
	    {
	        "id": 2971,
	        "name": "Esquivias"
	    },
	    {
	        "id": 2972,
	        "name": "Benimuslem"
	    },
	    {
	        "id": 2973,
	        "name": "Fontihoyuelo"
	    },
	    {
	        "id": 2974,
	        "name": "Meñaka"
	    },
	    {
	        "id": 2975,
	        "name": "Fariza"
	    },
	    {
	        "id": 2976,
	        "name": "Cabañas de Ebro"
	    },
	    {
	        "id": 2977,
	        "name": "Pozuelo"
	    },
	    {
	        "id": 2978,
	        "name": "Elche/Elx"
	    },
	    {
	        "id": 2979,
	        "name": "Nacimiento"
	    },
	    {
	        "id": 2980,
	        "name": "Crespos"
	    },
	    {
	        "id": 2981,
	        "name": "Higuera de Llerena"
	    },
	    {
	        "id": 2982,
	        "name": "Vilafranca de Bonany"
	    },
	    {
	        "id": 2983,
	        "name": "Castellví de la Marca"
	    },
	    {
	        "id": 2984,
	        "name": "Campillo de Aranda"
	    },
	    {
	        "id": 2985,
	        "name": "Collado"
	    },
	    {
	        "id": 2986,
	        "name": "Gaibiel"
	    },
	    {
	        "id": 2987,
	        "name": "Porzuna"
	    },
	    {
	        "id": 2988,
	        "name": "La Victoria"
	    },
	    {
	        "id": 2989,
	        "name": "Padrón"
	    },
	    {
	        "id": 2990,
	        "name": "Casas de los Pinos"
	    },
	    {
	        "id": 2991,
	        "name": "Esponellà"
	    },
	    {
	        "id": 2992,
	        "name": "Cantalojas"
	    },
	    {
	        "id": 2993,
	        "name": "Soraluze/Placencia de las Armas"
	    },
	    {
	        "id": 2994,
	        "name": "Sanlúcar de Guadiana"
	    },
	    {
	        "id": 2995,
	        "name": "Orcera"
	    },
	    {
	        "id": 2996,
	        "name": "Chozas de Abajo"
	    },
	    {
	        "id": 2997,
	        "name": "Galbárruli"
	    },
	    {
	        "id": 2998,
	        "name": "Vilalba"
	    },
	    {
	        "id": 2999,
	        "name": "Getafe"
	    },
	    {
	        "id": 3000,
	        "name": "Júzcar"
	    },
	    {
	        "id": 3001,
	        "name": "Caparroso"
	    },
	    {
	        "id": 3002,
	        "name": "Punxín"
	    },
	    {
	        "id": 3003,
	        "name": "Sariego"
	    },
	    {
	        "id": 3004,
	        "name": "Cabeza del Caballo"
	    },
	    {
	        "id": 3005,
	        "name": "Las Rozas de Valdearroyo"
	    },
	    {
	        "id": 3006,
	        "name": "Chañe"
	    },
	    {
	        "id": 3007,
	        "name": "Morón de la Frontera"
	    },
	    {
	        "id": 3008,
	        "name": "Cirujales del Río"
	    },
	    {
	        "id": 3009,
	        "name": "Garcia"
	    },
	    {
	        "id": 3010,
	        "name": "Castejón de Tornos"
	    },
	    {
	        "id": 3011,
	        "name": "La Estrella"
	    },
	    {
	        "id": 3012,
	        "name": "Beniparrell"
	    },
	    {
	        "id": 3013,
	        "name": "Fresno el Viejo"
	    },
	    {
	        "id": 3014,
	        "name": "Ugao-Miraballes"
	    },
	    {
	        "id": 3015,
	        "name": "Fermoselle"
	    },
	    {
	        "id": 3016,
	        "name": "Cabolafuente"
	    },
	    {
	        "id": 3017,
	        "name": "La Recueja"
	    },
	    {
	        "id": 3018,
	        "name": "Elda"
	    },
	    {
	        "id": 3019,
	        "name": "Níjar"
	    },
	    {
	        "id": 3020,
	        "name": "Cuevas del Valle"
	    },
	    {
	        "id": 3021,
	        "name": "Higuera de Vargas"
	    },
	    {
	        "id": 3022,
	        "name": "Castellví de Rosanes"
	    },
	    {
	        "id": 3023,
	        "name": "Campolara"
	    },
	    {
	        "id": 3024,
	        "name": "Conquista de la Sierra"
	    },
	    {
	        "id": 3025,
	        "name": "Pozuelo de Calatrava"
	    },
	    {
	        "id": 3026,
	        "name": "Villa del Río"
	    },
	    {
	        "id": 3027,
	        "name": "O Pino"
	    },
	    {
	        "id": 3028,
	        "name": "Casasimarro"
	    },
	    {
	        "id": 3029,
	        "name": "Figueres"
	    },
	    {
	        "id": 3030,
	        "name": "Deifontes"
	    },
	    {
	        "id": 3031,
	        "name": "Cañizar"
	    },
	    {
	        "id": 3032,
	        "name": "Errezil"
	    },
	    {
	        "id": 3033,
	        "name": "San Silvestre de Guzmán"
	    },
	    {
	        "id": 3034,
	        "name": "Boltaña"
	    },
	    {
	        "id": 3035,
	        "name": "Peal de Becerro"
	    },
	    {
	        "id": 3036,
	        "name": "Destriana"
	    },
	    {
	        "id": 3037,
	        "name": "Galilea"
	    },
	    {
	        "id": 3038,
	        "name": "Viveiro"
	    },
	    {
	        "id": 3039,
	        "name": "Griñón"
	    },
	    {
	        "id": 3040,
	        "name": "Macharaviaya"
	    },
	    {
	        "id": 3041,
	        "name": "Cárcar"
	    },
	    {
	        "id": 3042,
	        "name": "Quintela de Leirado"
	    },
	    {
	        "id": 3043,
	        "name": "Siero"
	    },
	    {
	        "id": 3044,
	        "name": "Cubillas de Cerrato"
	    },
	    {
	        "id": 3045,
	        "name": "Ruente"
	    },
	    {
	        "id": 3046,
	        "name": "Las Navas de la Concepción"
	    },
	    {
	        "id": 3047,
	        "name": "Els Garidells"
	    },
	    {
	        "id": 3048,
	        "name": "Castel de Cabra"
	    },
	    {
	        "id": 3049,
	        "name": "Fuensalida"
	    },
	    {
	        "id": 3050,
	        "name": "Benirredrà"
	    },
	    {
	        "id": 3051,
	        "name": "Fuensaldaña"
	    },
	    {
	        "id": 3052,
	        "name": "Morga"
	    },
	    {
	        "id": 3053,
	        "name": "Ferreras de Abajo"
	    },
	    {
	        "id": 3054,
	        "name": "Cadrete"
	    },
	    {
	        "id": 3055,
	        "name": "Riópar"
	    },
	    {
	        "id": 3056,
	        "name": "Facheca"
	    },
	    {
	        "id": 3057,
	        "name": "Ohanes"
	    },
	    {
	        "id": 3058,
	        "name": "Chamartín"
	    },
	    {
	        "id": 3059,
	        "name": "Higuera la Real"
	    },
	    {
	        "id": 3060,
	        "name": "Centelles"
	    },
	    {
	        "id": 3061,
	        "name": "Canicosa de la Sierra"
	    },
	    {
	        "id": 3062,
	        "name": "Coria"
	    },
	    {
	        "id": 3063,
	        "name": "Geldo"
	    },
	    {
	        "id": 3064,
	        "name": "Los Pozuelos de Calatrava"
	    },
	    {
	        "id": 3065,
	        "name": "Villafranca de Córdoba"
	    },
	    {
	        "id": 3066,
	        "name": "A Pobra do Caramiñal"
	    },
	    {
	        "id": 3067,
	        "name": "Castejón"
	    },
	    {
	        "id": 3068,
	        "name": "Flaçà"
	    },
	    {
	        "id": 3069,
	        "name": "Diezma"
	    },
	    {
	        "id": 3070,
	        "name": "El Cardoso de la Sierra"
	    },
	    {
	        "id": 3071,
	        "name": "Errenteria"
	    },
	    {
	        "id": 3072,
	        "name": "Santa Ana la Real"
	    },
	    {
	        "id": 3073,
	        "name": "Bonansa"
	    },
	    {
	        "id": 3074,
	        "name": "Pegalajar"
	    },
	    {
	        "id": 3075,
	        "name": "Encinedo"
	    },
	    {
	        "id": 3076,
	        "name": "Castelldans"
	    },
	    {
	        "id": 3077,
	        "name": "Gallinero de Cameros"
	    },
	    {
	        "id": 3078,
	        "name": "Guadalix de la Sierra"
	    },
	    {
	        "id": 3079,
	        "name": "Málaga"
	    },
	    {
	        "id": 3080,
	        "name": "Carcastillo"
	    },
	    {
	        "id": 3081,
	        "name": "Rairiz de Veiga"
	    },
	    {
	        "id": 3082,
	        "name": "Sobrescobio"
	    },
	    {
	        "id": 3083,
	        "name": "Dehesa de Montejo"
	    },
	    {
	        "id": 3084,
	        "name": "Cabrerizos"
	    },
	    {
	        "id": 3085,
	        "name": "Ruesga"
	    },
	    {
	        "id": 3086,
	        "name": "Olivares"
	    },
	    {
	        "id": 3087,
	        "name": "Ginestar"
	    },
	    {
	        "id": 3088,
	        "name": "Castelnou"
	    },
	    {
	        "id": 3089,
	        "name": "Gálvez"
	    },
	    {
	        "id": 3090,
	        "name": "Benisanó"
	    },
	    {
	        "id": 3091,
	        "name": "Fuente el Sol"
	    },
	    {
	        "id": 3092,
	        "name": "Muxika"
	    },
	    {
	        "id": 3093,
	        "name": "Ferreras de Arriba"
	    },
	    {
	        "id": 3094,
	        "name": "Calatayud"
	    },
	    {
	        "id": 3095,
	        "name": "Robledo"
	    },
	    {
	        "id": 3096,
	        "name": "Famorca"
	    },
	    {
	        "id": 3097,
	        "name": "Olula de Castro"
	    },
	    {
	        "id": 3098,
	        "name": "Hinojosa del Valle"
	    },
	    {
	        "id": 3099,
	        "name": "Cervelló"
	    },
	    {
	        "id": 3100,
	        "name": "Cantabrana"
	    },
	    {
	        "id": 3101,
	        "name": "Cuacos de Yuste"
	    },
	    {
	        "id": 3102,
	        "name": "Herbés"
	    },
	    {
	        "id": 3103,
	        "name": "Puebla de Don Rodrigo"
	    },
	    {
	        "id": 3104,
	        "name": "Villaharta"
	    },
	    {
	        "id": 3105,
	        "name": "Ponteceso"
	    },
	    {
	        "id": 3106,
	        "name": "Castillejo de Iniesta"
	    },
	    {
	        "id": 3107,
	        "name": "Foixà"
	    },
	    {
	        "id": 3108,
	        "name": "Dílar"
	    },
	    {
	        "id": 3109,
	        "name": "Leintz-Gatzaga"
	    },
	    {
	        "id": 3110,
	        "name": "Santa Bárbara de Casa"
	    },
	    {
	        "id": 3111,
	        "name": "Borau"
	    },
	    {
	        "id": 3112,
	        "name": "La Ercina"
	    },
	    {
	        "id": 3113,
	        "name": "Castellnou de Seana"
	    },
	    {
	        "id": 3114,
	        "name": "Gimileo"
	    },
	    {
	        "id": 3115,
	        "name": "Guadarrama"
	    },
	    {
	        "id": 3116,
	        "name": "Manilva"
	    },
	    {
	        "id": 3117,
	        "name": "Cascante"
	    },
	    {
	        "id": 3118,
	        "name": "Ramirás"
	    },
	    {
	        "id": 3119,
	        "name": "Somiedo"
	    },
	    {
	        "id": 3120,
	        "name": "Dehesa de Romanos"
	    },
	    {
	        "id": 3121,
	        "name": "Cabrillas"
	    },
	    {
	        "id": 3122,
	        "name": "Ruiloba"
	    },
	    {
	        "id": 3123,
	        "name": "Domingo García"
	    },
	    {
	        "id": 3124,
	        "name": "Osuna"
	    },
	    {
	        "id": 3125,
	        "name": "Coscurita"
	    },
	    {
	        "id": 3126,
	        "name": "Godall"
	    },
	    {
	        "id": 3127,
	        "name": "Castelserás"
	    },
	    {
	        "id": 3128,
	        "name": "Garciotum"
	    },
	    {
	        "id": 3129,
	        "name": "Benissoda"
	    },
	    {
	        "id": 3130,
	        "name": "Fuente-Olmedo"
	    },
	    {
	        "id": 3131,
	        "name": "Mundaka"
	    },
	    {
	        "id": 3132,
	        "name": "Ferreruela"
	    },
	    {
	        "id": 3133,
	        "name": "Calatorao"
	    },
	    {
	        "id": 3134,
	        "name": "La Roda"
	    },
	    {
	        "id": 3135,
	        "name": "Finestrat"
	    },
	    {
	        "id": 3136,
	        "name": "Olula del Río"
	    },
	    {
	        "id": 3137,
	        "name": "Donjimeno"
	    },
	    {
	        "id": 3138,
	        "name": "Hornachos"
	    },
	    {
	        "id": 3139,
	        "name": "Collbató"
	    },
	    {
	        "id": 3140,
	        "name": "La Cumbre"
	    },
	    {
	        "id": 3141,
	        "name": "Higueras"
	    },
	    {
	        "id": 3142,
	        "name": "Puebla del Príncipe"
	    },
	    {
	        "id": 3143,
	        "name": "Villanueva de Córdoba"
	    },
	    {
	        "id": 3144,
	        "name": "Pontedeume"
	    },
	    {
	        "id": 3145,
	        "name": "Fontanals de Cerdanya"
	    },
	    {
	        "id": 3146,
	        "name": "Dólar"
	    },
	    {
	        "id": 3147,
	        "name": "Donostia-San Sebastián"
	    },
	    {
	        "id": 3148,
	        "name": "Santa Olalla del Cala"
	    },
	    {
	        "id": 3149,
	        "name": "Broto"
	    },
	    {
	        "id": 3150,
	        "name": "Porcuna"
	    },
	    {
	        "id": 3151,
	        "name": "Escobar de Campos"
	    },
	    {
	        "id": 3152,
	        "name": "Castelló de Farfanya"
	    },
	    {
	        "id": 3153,
	        "name": "Grañón"
	    },
	    {
	        "id": 3154,
	        "name": "La Hiruela"
	    },
	    {
	        "id": 3155,
	        "name": "Marbella"
	    },
	    {
	        "id": 3156,
	        "name": "Cáseda"
	    },
	    {
	        "id": 3157,
	        "name": "Ribadavia"
	    },
	    {
	        "id": 3158,
	        "name": "Soto del Barco"
	    },
	    {
	        "id": 3159,
	        "name": "Dueñas"
	    },
	    {
	        "id": 3160,
	        "name": "Calvarrasa de Abajo"
	    },
	    {
	        "id": 3161,
	        "name": "San Felices de Buelna"
	    },
	    {
	        "id": 3162,
	        "name": "Donhierro"
	    },
	    {
	        "id": 3163,
	        "name": "Los Palacios y Villafranca"
	    },
	    {
	        "id": 3164,
	        "name": "Covaleda"
	    },
	    {
	        "id": 3165,
	        "name": "Gratallops"
	    },
	    {
	        "id": 3166,
	        "name": "Gerindote"
	    },
	    {
	        "id": 3167,
	        "name": "Benisuera"
	    },
	    {
	        "id": 3168,
	        "name": "Gallegos de Hornija"
	    },
	    {
	        "id": 3169,
	        "name": "Mungia"
	    },
	    {
	        "id": 3170,
	        "name": "Figueruela de Arriba"
	    },
	    {
	        "id": 3171,
	        "name": "Calcena"
	    },
	    {
	        "id": 3172,
	        "name": "Salobre"
	    },
	    {
	        "id": 3173,
	        "name": "Formentera del Segura"
	    },
	    {
	        "id": 3174,
	        "name": "Oria"
	    },
	    {
	        "id": 3175,
	        "name": "Donvidas"
	    },
	    {
	        "id": 3176,
	        "name": "Jerez de los Caballeros"
	    },
	    {
	        "id": 3177,
	        "name": "Collsuspina"
	    },
	    {
	        "id": 3178,
	        "name": "Carazo"
	    },
	    {
	        "id": 3179,
	        "name": "Deleitosa"
	    },
	    {
	        "id": 3180,
	        "name": "la Jana"
	    },
	    {
	        "id": 3181,
	        "name": "Puerto Lápice"
	    },
	    {
	        "id": 3182,
	        "name": "Villanueva del Duque"
	    },
	    {
	        "id": 3183,
	        "name": "As Pontes de García Rodríguez"
	    },
	    {
	        "id": 3184,
	        "name": "Castillejo-Sierra"
	    },
	    {
	        "id": 3185,
	        "name": "Fontanilles"
	    },
	    {
	        "id": 3186,
	        "name": "Dúdar"
	    },
	    {
	        "id": 3187,
	        "name": "Casa de Uceda"
	    },
	    {
	        "id": 3188,
	        "name": "Segura"
	    },
	    {
	        "id": 3189,
	        "name": "Trigueros"
	    },
	    {
	        "id": 3190,
	        "name": "Pozo Alcón"
	    },
	    {
	        "id": 3191,
	        "name": "Fabero"
	    },
	    {
	        "id": 3192,
	        "name": "Castellserà"
	    },
	    {
	        "id": 3193,
	        "name": "Grávalos"
	    },
	    {
	        "id": 3194,
	        "name": "Horcajo de la Sierra-Aoslos"
	    },
	    {
	        "id": 3195,
	        "name": "Mijas"
	    },
	    {
	        "id": 3196,
	        "name": "Castejón"
	    },
	    {
	        "id": 3197,
	        "name": "San Xoán de Río"
	    },
	    {
	        "id": 3198,
	        "name": "Tapia de Casariego"
	    },
	    {
	        "id": 3199,
	        "name": "Espinosa de Cerrato"
	    },
	    {
	        "id": 3200,
	        "name": "Calvarrasa de Arriba"
	    },
	    {
	        "id": 3201,
	        "name": "San Miguel de Aguayo"
	    },
	    {
	        "id": 3202,
	        "name": "Duruelo"
	    },
	    {
	        "id": 3203,
	        "name": "Palomares del Río"
	    },
	    {
	        "id": 3204,
	        "name": "Cubilla"
	    },
	    {
	        "id": 3205,
	        "name": "Els Guiamets"
	    },
	    {
	        "id": 3206,
	        "name": "El Castellar"
	    },
	    {
	        "id": 3207,
	        "name": "Guadamur"
	    },
	    {
	        "id": 3208,
	        "name": "Bétera"
	    },
	    {
	        "id": 3209,
	        "name": "Gatón de Campos"
	    },
	    {
	        "id": 3210,
	        "name": "Aulesti"
	    },
	    {
	        "id": 3211,
	        "name": "Calmarza"
	    },
	    {
	        "id": 3212,
	        "name": "San Pedro"
	    },
	    {
	        "id": 3213,
	        "name": "Gata de Gorgos"
	    },
	    {
	        "id": 3214,
	        "name": "Padules"
	    },
	    {
	        "id": 3215,
	        "name": "La Lapa"
	    },
	    {
	        "id": 3216,
	        "name": "Copons"
	    },
	    {
	        "id": 3217,
	        "name": "Carcedo de Bureba"
	    },
	    {
	        "id": 3218,
	        "name": "Descargamaría"
	    },
	    {
	        "id": 3219,
	        "name": "Jérica"
	    },
	    {
	        "id": 3220,
	        "name": "Puertollano"
	    },
	    {
	        "id": 3221,
	        "name": "Villanueva del Rey"
	    },
	    {
	        "id": 3222,
	        "name": "Porto do Son"
	    },
	    {
	        "id": 3223,
	        "name": "Castillo-Albaráñez"
	    },
	    {
	        "id": 3224,
	        "name": "Fontcoberta"
	    },
	    {
	        "id": 3225,
	        "name": "Dúrcal"
	    },
	    {
	        "id": 3226,
	        "name": "El Casar"
	    },
	    {
	        "id": 3227,
	        "name": "Tolosa"
	    },
	    {
	        "id": 3228,
	        "name": "Valdelarco"
	    },
	    {
	        "id": 3229,
	        "name": "Puente de Génave"
	    },
	    {
	        "id": 3230,
	        "name": "Folgoso de la Ribera"
	    },
	    {
	        "id": 3231,
	        "name": "Cava"
	    },
	    {
	        "id": 3232,
	        "name": "Haro"
	    },
	    {
	        "id": 3233,
	        "name": "Horcajuelo de la Sierra"
	    },
	    {
	        "id": 3234,
	        "name": "Moclinejo"
	    },
	    {
	        "id": 3235,
	        "name": "Castillonuevo"
	    },
	    {
	        "id": 3236,
	        "name": "Riós"
	    },
	    {
	        "id": 3237,
	        "name": "Taramundi"
	    },
	    {
	        "id": 3238,
	        "name": "Espinosa de Villagonzalo"
	    },
	    {
	        "id": 3239,
	        "name": "La Calzada de Béjar"
	    },
	    {
	        "id": 3240,
	        "name": "San Pedro del Romeral"
	    },
	    {
	        "id": 3241,
	        "name": "Encinas"
	    },
	    {
	        "id": 3242,
	        "name": "Paradas"
	    },
	    {
	        "id": 3243,
	        "name": "Cubo de la Solana"
	    },
	    {
	        "id": 3244,
	        "name": "Horta de Sant Joan"
	    },
	    {
	        "id": 3245,
	        "name": "Castellote"
	    },
	    {
	        "id": 3246,
	        "name": "La Guardia"
	    },
	    {
	        "id": 3247,
	        "name": "Bicorp"
	    },
	    {
	        "id": 3248,
	        "name": "Geria"
	    },
	    {
	        "id": 3249,
	        "name": "Muskiz"
	    },
	    {
	        "id": 3250,
	        "name": "Fonfría"
	    },
	    {
	        "id": 3251,
	        "name": "Campillo de Aragón"
	    },
	    {
	        "id": 3252,
	        "name": "Socovos"
	    },
	    {
	        "id": 3253,
	        "name": "Gaianes"
	    },
	    {
	        "id": 3254,
	        "name": "Partaloa"
	    },
	    {
	        "id": 3255,
	        "name": "Espinosa de los Caballeros"
	    },
	    {
	        "id": 3256,
	        "name": "Lobón"
	    },
	    {
	        "id": 3257,
	        "name": "Corbera de Llobregat"
	    },
	    {
	        "id": 3258,
	        "name": "Carcedo de Burgos"
	    },
	    {
	        "id": 3259,
	        "name": "Eljas"
	    },
	    {
	        "id": 3260,
	        "name": "Lucena del Cid"
	    },
	    {
	        "id": 3261,
	        "name": "Retuerta del Bullaque"
	    },
	    {
	        "id": 3262,
	        "name": "Villaralto"
	    },
	    {
	        "id": 3263,
	        "name": "Rianxo"
	    },
	    {
	        "id": 3264,
	        "name": "Castillo de Garcimuñoz"
	    },
	    {
	        "id": 3265,
	        "name": "Escúzar"
	    },
	    {
	        "id": 3266,
	        "name": "Urnieta"
	    },
	    {
	        "id": 3267,
	        "name": "Valverde del Camino"
	    },
	    {
	        "id": 3268,
	        "name": "Caldearenas"
	    },
	    {
	        "id": 3269,
	        "name": "La Puerta de Segura"
	    },
	    {
	        "id": 3270,
	        "name": "Cervera"
	    },
	    {
	        "id": 3271,
	        "name": "Herce"
	    },
	    {
	        "id": 3272,
	        "name": "Hoyo de Manzanares"
	    },
	    {
	        "id": 3273,
	        "name": "Mollina"
	    },
	    {
	        "id": 3274,
	        "name": "Cintruénigo"
	    },
	    {
	        "id": 3275,
	        "name": "A Rúa"
	    },
	    {
	        "id": 3276,
	        "name": "Teverga"
	    },
	    {
	        "id": 3277,
	        "name": "Frechilla"
	    },
	    {
	        "id": 3278,
	        "name": "Calzada de Don Diego"
	    },
	    {
	        "id": 3279,
	        "name": "San Roque de Riomiera"
	    },
	    {
	        "id": 3280,
	        "name": "Encinillas"
	    },
	    {
	        "id": 3281,
	        "name": "Pedrera"
	    },
	    {
	        "id": 3282,
	        "name": "El Lloar"
	    },
	    {
	        "id": 3283,
	        "name": "Las Herencias"
	    },
	    {
	        "id": 3284,
	        "name": "Bocairent"
	    },
	    {
	        "id": 3285,
	        "name": "Otxandio"
	    },
	    {
	        "id": 3286,
	        "name": "Carenas"
	    },
	    {
	        "id": 3287,
	        "name": "Tarazona de la Mancha"
	    },
	    {
	        "id": 3288,
	        "name": "Gorga"
	    },
	    {
	        "id": 3289,
	        "name": "Paterna del Río"
	    },
	    {
	        "id": 3290,
	        "name": "Flores de Ávila"
	    },
	    {
	        "id": 3291,
	        "name": "Llera"
	    },
	    {
	        "id": 3292,
	        "name": "Cornellà de Llobregat"
	    },
	    {
	        "id": 3293,
	        "name": "Cardeñadijo"
	    },
	    {
	        "id": 3294,
	        "name": "Escurial"
	    },
	    {
	        "id": 3295,
	        "name": "Ludiente"
	    },
	    {
	        "id": 3296,
	        "name": "Saceruela"
	    },
	    {
	        "id": 3297,
	        "name": "Villaviciosa de Córdoba"
	    },
	    {
	        "id": 3298,
	        "name": "Ribeira"
	    },
	    {
	        "id": 3299,
	        "name": "Cervera del Llano"
	    },
	    {
	        "id": 3300,
	        "name": "Fornells de la Selva"
	    },
	    {
	        "id": 3301,
	        "name": "Casas de San Galindo"
	    },
	    {
	        "id": 3302,
	        "name": "Usurbil"
	    },
	    {
	        "id": 3303,
	        "name": "Villablanca"
	    },
	    {
	        "id": 3304,
	        "name": "Quesada"
	    },
	    {
	        "id": 3305,
	        "name": "Fresno de la Vega"
	    },
	    {
	        "id": 3306,
	        "name": "Cervià de les Garrigues"
	    },
	    {
	        "id": 3307,
	        "name": "Herramélluri"
	    },
	    {
	        "id": 3308,
	        "name": "Humanes de Madrid"
	    },
	    {
	        "id": 3309,
	        "name": "Monda"
	    },
	    {
	        "id": 3310,
	        "name": "Ziordia"
	    },
	    {
	        "id": 3311,
	        "name": "Rubiá"
	    },
	    {
	        "id": 3312,
	        "name": "Tineo"
	    },
	    {
	        "id": 3313,
	        "name": "Fresno del Río"
	    },
	    {
	        "id": 3314,
	        "name": "Calzada de Valdunciel"
	    },
	    {
	        "id": 3315,
	        "name": "Santa Cruz de Bezana"
	    },
	    {
	        "id": 3316,
	        "name": "Escalona del Prado"
	    },
	    {
	        "id": 3317,
	        "name": "El Pedroso"
	    },
	    {
	        "id": 3318,
	        "name": "Cueva de Ágreda"
	    },
	    {
	        "id": 3319,
	        "name": "Llorac"
	    },
	    {
	        "id": 3320,
	        "name": "Herreruela de Oropesa"
	    },
	    {
	        "id": 3321,
	        "name": "Bolbaite"
	    },
	    {
	        "id": 3322,
	        "name": "Herrín de Campos"
	    },
	    {
	        "id": 3323,
	        "name": "Ondarroa"
	    },
	    {
	        "id": 3324,
	        "name": "Cariñena"
	    },
	    {
	        "id": 3325,
	        "name": "Tobarra"
	    },
	    {
	        "id": 3326,
	        "name": "Granja de Rocamora"
	    },
	    {
	        "id": 3327,
	        "name": "Pechina"
	    },
	    {
	        "id": 3328,
	        "name": "Fontiveros"
	    },
	    {
	        "id": 3329,
	        "name": "Llerena"
	    },
	    {
	        "id": 3330,
	        "name": "Cubelles"
	    },
	    {
	        "id": 3331,
	        "name": "Cardeñajimeno"
	    },
	    {
	        "id": 3332,
	        "name": "la Llosa"
	    },
	    {
	        "id": 3333,
	        "name": "San Carlos del Valle"
	    },
	    {
	        "id": 3334,
	        "name": "El Viso"
	    },
	    {
	        "id": 3335,
	        "name": "Rois"
	    },
	    {
	        "id": 3336,
	        "name": "La Cierva"
	    },
	    {
	        "id": 3337,
	        "name": "Fortià"
	    },
	    {
	        "id": 3338,
	        "name": "Ferreira"
	    },
	    {
	        "id": 3339,
	        "name": "Caspueñas"
	    },
	    {
	        "id": 3340,
	        "name": "Bergara"
	    },
	    {
	        "id": 3341,
	        "name": "Villalba del Alcor"
	    },
	    {
	        "id": 3342,
	        "name": "Campo"
	    },
	    {
	        "id": 3343,
	        "name": "Rus"
	    },
	    {
	        "id": 3344,
	        "name": "Fuentes de Carbajal"
	    },
	    {
	        "id": 3345,
	        "name": "Ciutadilla"
	    },
	    {
	        "id": 3346,
	        "name": "Hervías"
	    },
	    {
	        "id": 3347,
	        "name": "Leganés"
	    },
	    {
	        "id": 3348,
	        "name": "Montejaque"
	    },
	    {
	        "id": 3349,
	        "name": "Cirauqui/Zirauki"
	    },
	    {
	        "id": 3350,
	        "name": "San Amaro"
	    },
	    {
	        "id": 3351,
	        "name": "Vegadeo"
	    },
	    {
	        "id": 3352,
	        "name": "Frómista"
	    },
	    {
	        "id": 3353,
	        "name": "Campillo de Azaba"
	    },
	    {
	        "id": 3354,
	        "name": "Santa María de Cayón"
	    },
	    {
	        "id": 3355,
	        "name": "Escarabajosa de Cabezas"
	    },
	    {
	        "id": 3356,
	        "name": "Peñaflor"
	    },
	    {
	        "id": 3357,
	        "name": "Llorenç del Penedès"
	    },
	    {
	        "id": 3358,
	        "name": "Cedrillas"
	    },
	    {
	        "id": 3359,
	        "name": "Hinojosa de San Vicente"
	    },
	    {
	        "id": 3360,
	        "name": "Bonrepòs i Mirambell"
	    },
	    {
	        "id": 3361,
	        "name": "Hornillos de Eresma"
	    },
	    {
	        "id": 3362,
	        "name": "Urduña/Orduña"
	    },
	    {
	        "id": 3363,
	        "name": "Caspe"
	    },
	    {
	        "id": 3364,
	        "name": "Valdeganga"
	    },
	    {
	        "id": 3365,
	        "name": "el Castell de Guadalest"
	    },
	    {
	        "id": 3366,
	        "name": "Pulpí"
	    },
	    {
	        "id": 3367,
	        "name": "Fresnedilla"
	    },
	    {
	        "id": 3368,
	        "name": "Magacela"
	    },
	    {
	        "id": 3369,
	        "name": "Dosrius"
	    },
	    {
	        "id": 3370,
	        "name": "Cardeñuela Riopico"
	    },
	    {
	        "id": 3371,
	        "name": "Fresnedoso de Ibor"
	    },
	    {
	        "id": 3372,
	        "name": "la Mata de Morella"
	    },
	    {
	        "id": 3373,
	        "name": "San Lorenzo de Calatrava"
	    },
	    {
	        "id": 3374,
	        "name": "Zuheros"
	    },
	    {
	        "id": 3375,
	        "name": "Sada"
	    },
	    {
	        "id": 3376,
	        "name": "Garrigàs"
	    },
	    {
	        "id": 3377,
	        "name": "Castejón de Henares"
	    },
	    {
	        "id": 3378,
	        "name": "Villabona"
	    },
	    {
	        "id": 3379,
	        "name": "Villanueva de las Cruces"
	    },
	    {
	        "id": 3380,
	        "name": "Camporrélls"
	    },
	    {
	        "id": 3381,
	        "name": "Sabiote"
	    },
	    {
	        "id": 3382,
	        "name": "Clariana de Cardener"
	    },
	    {
	        "id": 3383,
	        "name": "Hormilla"
	    },
	    {
	        "id": 3384,
	        "name": "Loeches"
	    },
	    {
	        "id": 3385,
	        "name": "Nerja"
	    },
	    {
	        "id": 3386,
	        "name": "Ciriza/Ziritza"
	    },
	    {
	        "id": 3387,
	        "name": "San Cibrao das Viñas"
	    },
	    {
	        "id": 3388,
	        "name": "Villanueva de Oscos"
	    },
	    {
	        "id": 3389,
	        "name": "Santander"
	    },
	    {
	        "id": 3390,
	        "name": "Escobar de Polendos"
	    },
	    {
	        "id": 3391,
	        "name": "Pilas"
	    },
	    {
	        "id": 3392,
	        "name": "Dévanos"
	    },
	    {
	        "id": 3393,
	        "name": "Margalef"
	    },
	    {
	        "id": 3394,
	        "name": "Celadas"
	    },
	    {
	        "id": 3395,
	        "name": "Hontanar"
	    },
	    {
	        "id": 3396,
	        "name": "Bufali"
	    },
	    {
	        "id": 3397,
	        "name": "Íscar"
	    },
	    {
	        "id": 3398,
	        "name": "Orozko"
	    },
	    {
	        "id": 3399,
	        "name": "Fresno de la Polvorosa"
	    },
	    {
	        "id": 3400,
	        "name": "Castejón de Alarba"
	    },
	    {
	        "id": 3401,
	        "name": "Vianos"
	    },
	    {
	        "id": 3402,
	        "name": "Guardamar del Segura"
	    },
	    {
	        "id": 3403,
	        "name": "Purchena"
	    },
	    {
	        "id": 3404,
	        "name": "El Fresno"
	    },
	    {
	        "id": 3405,
	        "name": "Maguilla"
	    },
	    {
	        "id": 3406,
	        "name": "Esparreguera"
	    },
	    {
	        "id": 3407,
	        "name": "Carrias"
	    },
	    {
	        "id": 3408,
	        "name": "Galisteo"
	    },
	    {
	        "id": 3409,
	        "name": "Matet"
	    },
	    {
	        "id": 3410,
	        "name": "Santa Cruz de los Cáñamos"
	    },
	    {
	        "id": 3411,
	        "name": "San Sadurniño"
	    },
	    {
	        "id": 3412,
	        "name": "Garrigoles"
	    },
	    {
	        "id": 3413,
	        "name": "Fonelas"
	    },
	    {
	        "id": 3414,
	        "name": "Castellar de la Muela"
	    },
	    {
	        "id": 3415,
	        "name": "Ordizia"
	    },
	    {
	        "id": 3416,
	        "name": "Villanueva de los Castillejos"
	    },
	    {
	        "id": 3417,
	        "name": "Canal de Berdún"
	    },
	    {
	        "id": 3418,
	        "name": "Santa Elena"
	    },
	    {
	        "id": 3419,
	        "name": "Garrafe de Torío"
	    },
	    {
	        "id": 3420,
	        "name": "El Cogul"
	    },
	    {
	        "id": 3421,
	        "name": "Hormilleja"
	    },
	    {
	        "id": 3422,
	        "name": "Lozoya"
	    },
	    {
	        "id": 3423,
	        "name": "Ojén"
	    },
	    {
	        "id": 3424,
	        "name": "Cizur"
	    },
	    {
	        "id": 3425,
	        "name": "San Cristovo de Cea"
	    },
	    {
	        "id": 3426,
	        "name": "Villaviciosa"
	    },
	    {
	        "id": 3427,
	        "name": "Fuentes de Nava"
	    },
	    {
	        "id": 3428,
	        "name": "Santillana del Mar"
	    },
	    {
	        "id": 3429,
	        "name": "El Espinar"
	    },
	    {
	        "id": 3430,
	        "name": "Pruna"
	    },
	    {
	        "id": 3431,
	        "name": "Deza"
	    },
	    {
	        "id": 3432,
	        "name": "Marçà"
	    },
	    {
	        "id": 3433,
	        "name": "Cella"
	    },
	    {
	        "id": 3434,
	        "name": "Hormigos"
	    },
	    {
	        "id": 3435,
	        "name": "Bugarra"
	    },
	    {
	        "id": 3436,
	        "name": "Laguna de Duero"
	    },
	    {
	        "id": 3437,
	        "name": "Sukarrieta"
	    },
	    {
	        "id": 3438,
	        "name": "Fresno de la Ribera"
	    },
	    {
	        "id": 3439,
	        "name": "Castejón de las Armas"
	    },
	    {
	        "id": 3440,
	        "name": "Villa de Ves"
	    },
	    {
	        "id": 3441,
	        "name": "el/Hondón de las Nieves Fondó de les Neus"
	    },
	    {
	        "id": 3442,
	        "name": "Rágol"
	    },
	    {
	        "id": 3443,
	        "name": "Fuente el Saúz"
	    },
	    {
	        "id": 3444,
	        "name": "Malcocinado"
	    },
	    {
	        "id": 3445,
	        "name": "Esplugues de Llobregat"
	    },
	    {
	        "id": 3446,
	        "name": "Cascajares de Bureba"
	    },
	    {
	        "id": 3447,
	        "name": "Garciaz"
	    },
	    {
	        "id": 3448,
	        "name": "Moncofa"
	    },
	    {
	        "id": 3449,
	        "name": "Santa Cruz de Mudela"
	    },
	    {
	        "id": 3450,
	        "name": "Santa Comba"
	    },
	    {
	        "id": 3451,
	        "name": "Garriguella"
	    },
	    {
	        "id": 3452,
	        "name": "Urretxu"
	    },
	    {
	        "id": 3453,
	        "name": "Villarrasa"
	    },
	    {
	        "id": 3454,
	        "name": "Candasnos"
	    },
	    {
	        "id": 3455,
	        "name": "Santiago de Calatrava"
	    },
	    {
	        "id": 3456,
	        "name": "Gordaliza del Pino"
	    },
	    {
	        "id": 3457,
	        "name": "Coll de Nargó"
	    },
	    {
	        "id": 3458,
	        "name": "Hornillos de Cameros"
	    },
	    {
	        "id": 3459,
	        "name": "Parauta"
	    },
	    {
	        "id": 3460,
	        "name": "Corella"
	    },
	    {
	        "id": 3461,
	        "name": "Sandiás"
	    },
	    {
	        "id": 3462,
	        "name": "Villayón"
	    },
	    {
	        "id": 3463,
	        "name": "Fuentes de Valdepero"
	    },
	    {
	        "id": 3464,
	        "name": "El Campo de Peñaranda"
	    },
	    {
	        "id": 3465,
	        "name": "Santiurde de Reinosa"
	    },
	    {
	        "id": 3466,
	        "name": "Espirdo"
	    },
	    {
	        "id": 3467,
	        "name": "La Puebla de Cazalla"
	    },
	    {
	        "id": 3468,
	        "name": "Mas de Barberans"
	    },
	    {
	        "id": 3469,
	        "name": "La Cerollera"
	    },
	    {
	        "id": 3470,
	        "name": "Huecas"
	    },
	    {
	        "id": 3471,
	        "name": "Buñol"
	    },
	    {
	        "id": 3472,
	        "name": "Langayo"
	    },
	    {
	        "id": 3473,
	        "name": "Plentzia"
	    },
	    {
	        "id": 3474,
	        "name": "Fresno de Sayago"
	    },
	    {
	        "id": 3475,
	        "name": "Castejón de Valdejasa"
	    },
	    {
	        "id": 3476,
	        "name": "Villalgordo del Júcar"
	    },
	    {
	        "id": 3477,
	        "name": "Hondón de los Frailes"
	    },
	    {
	        "id": 3478,
	        "name": "Rioja"
	    },
	    {
	        "id": 3479,
	        "name": "Fuentes de Año"
	    },
	    {
	        "id": 3480,
	        "name": "Malpartida de la Serena"
	    },
	    {
	        "id": 3481,
	        "name": "L'Espunyola"
	    },
	    {
	        "id": 3482,
	        "name": "Cascajares de la Sierra"
	    },
	    {
	        "id": 3483,
	        "name": "La Garganta"
	    },
	    {
	        "id": 3484,
	        "name": "Montán"
	    },
	    {
	        "id": 3485,
	        "name": "Socuéllamos"
	    },
	    {
	        "id": 3486,
	        "name": "Santiago de Compostela"
	    },
	    {
	        "id": 3487,
	        "name": "Cuenca"
	    },
	    {
	        "id": 3488,
	        "name": "Ger"
	    },
	    {
	        "id": 3489,
	        "name": "Freila"
	    },
	    {
	        "id": 3490,
	        "name": "Castilforte"
	    },
	    {
	        "id": 3491,
	        "name": "Zaldibia"
	    },
	    {
	        "id": 3492,
	        "name": "Zalamea la Real"
	    },
	    {
	        "id": 3493,
	        "name": "Canfranc"
	    },
	    {
	        "id": 3494,
	        "name": "Gordoncillo"
	    },
	    {
	        "id": 3495,
	        "name": "Corbins"
	    },
	    {
	        "id": 3496,
	        "name": "Hornos de Moncalvillo"
	    },
	    {
	        "id": 3497,
	        "name": "Madarcos"
	    },
	    {
	        "id": 3498,
	        "name": "Cortes"
	    },
	    {
	        "id": 3499,
	        "name": "Sarreaus"
	    },
	    {
	        "id": 3500,
	        "name": "Yernes y Tameza"
	    },
	    {
	        "id": 3501,
	        "name": "Candelario"
	    },
	    {
	        "id": 3502,
	        "name": "Santiurde de Toranzo"
	    },
	    {
	        "id": 3503,
	        "name": "Fresneda de Cuéllar"
	    },
	    {
	        "id": 3504,
	        "name": "La Puebla de los Infantes"
	    },
	    {
	        "id": 3505,
	        "name": "Duruelo de la Sierra"
	    },
	    {
	        "id": 3506,
	        "name": "Masdenverge"
	    },
	    {
	        "id": 3507,
	        "name": "Huerta de Valdecarábanos"
	    },
	    {
	        "id": 3508,
	        "name": "Burjassot"
	    },
	    {
	        "id": 3509,
	        "name": "Lomoviejo"
	    },
	    {
	        "id": 3510,
	        "name": "Portugalete"
	    },
	    {
	        "id": 3511,
	        "name": "Friera de Valverde"
	    },
	    {
	        "id": 3512,
	        "name": "Castiliscar"
	    },
	    {
	        "id": 3513,
	        "name": "Villamalea"
	    },
	    {
	        "id": 3514,
	        "name": "Ibi"
	    },
	    {
	        "id": 3515,
	        "name": "Roquetas de Mar"
	    },
	    {
	        "id": 3516,
	        "name": "Gallegos de Altamiros"
	    },
	    {
	        "id": 3517,
	        "name": "Manchita"
	    },
	    {
	        "id": 3518,
	        "name": "L'Estany"
	    },
	    {
	        "id": 3519,
	        "name": "Castellanos de Castro"
	    },
	    {
	        "id": 3520,
	        "name": "Garganta la Olla"
	    },
	    {
	        "id": 3521,
	        "name": "Montanejos"
	    },
	    {
	        "id": 3522,
	        "name": "La Solana"
	    },
	    {
	        "id": 3523,
	        "name": "Santiso"
	    },
	    {
	        "id": 3524,
	        "name": "Cueva del Hierro"
	    },
	    {
	        "id": 3525,
	        "name": "Girona"
	    },
	    {
	        "id": 3526,
	        "name": "Fuente Vaqueros"
	    },
	    {
	        "id": 3527,
	        "name": "Castilnuevo"
	    },
	    {
	        "id": 3528,
	        "name": "Zarautz"
	    },
	    {
	        "id": 3529,
	        "name": "Zufre"
	    },
	    {
	        "id": 3530,
	        "name": "Capdesaso"
	    },
	    {
	        "id": 3531,
	        "name": "Santisteban del Puerto"
	    },
	    {
	        "id": 3532,
	        "name": "Gradefes"
	    },
	    {
	        "id": 3533,
	        "name": "Cubells"
	    },
	    {
	        "id": 3534,
	        "name": "Huércanos"
	    },
	    {
	        "id": 3535,
	        "name": "Madrid"
	    },
	    {
	        "id": 3536,
	        "name": "Periana"
	    },
	    {
	        "id": 3537,
	        "name": "Desojo"
	    },
	    {
	        "id": 3538,
	        "name": "Taboadela"
	    },
	    {
	        "id": 3539,
	        "name": "Grijota"
	    },
	    {
	        "id": 3540,
	        "name": "Canillas de Abajo"
	    },
	    {
	        "id": 3541,
	        "name": "Santoña"
	    },
	    {
	        "id": 3542,
	        "name": "Fresno de Cantespino"
	    },
	    {
	        "id": 3543,
	        "name": "La Puebla del Río"
	    },
	    {
	        "id": 3544,
	        "name": "Escobosa de Almazán"
	    },
	    {
	        "id": 3545,
	        "name": "Masllorenç"
	    },
	    {
	        "id": 3546,
	        "name": "La Iglesuela"
	    },
	    {
	        "id": 3547,
	        "name": "Calles"
	    },
	    {
	        "id": 3548,
	        "name": "Llano de Olmedo"
	    },
	    {
	        "id": 3549,
	        "name": "Errigoiti"
	    },
	    {
	        "id": 3550,
	        "name": "Fuente Encalada"
	    },
	    {
	        "id": 3551,
	        "name": "Cervera de la Cañada"
	    },
	    {
	        "id": 3552,
	        "name": "Villapalacios"
	    },
	    {
	        "id": 3553,
	        "name": "Jacarilla"
	    },
	    {
	        "id": 3554,
	        "name": "Santa Cruz de Marchena"
	    },
	    {
	        "id": 3555,
	        "name": "Gallegos de Sobrinos"
	    },
	    {
	        "id": 3556,
	        "name": "Medellín"
	    },
	    {
	        "id": 3557,
	        "name": "Fígols"
	    },
	    {
	        "id": 3558,
	        "name": "Gargantilla"
	    },
	    {
	        "id": 3559,
	        "name": "Morella"
	    },
	    {
	        "id": 3560,
	        "name": "Solana del Pino"
	    },
	    {
	        "id": 3561,
	        "name": "Sobrado"
	    },
	    {
	        "id": 3562,
	        "name": "Gombrèn"
	    },
	    {
	        "id": 3563,
	        "name": "Cendejas de Enmedio"
	    },
	    {
	        "id": 3564,
	        "name": "Zumarraga"
	    },
	    {
	        "id": 3565,
	        "name": "Capella"
	    },
	    {
	        "id": 3566,
	        "name": "Santo Tomé"
	    },
	    {
	        "id": 3567,
	        "name": "Grajal de Campos"
	    },
	    {
	        "id": 3568,
	        "name": "Igea"
	    },
	    {
	        "id": 3569,
	        "name": "Majadahonda"
	    },
	    {
	        "id": 3570,
	        "name": "Pizarra"
	    },
	    {
	        "id": 3571,
	        "name": "Dicastillo"
	    },
	    {
	        "id": 3572,
	        "name": "A Teixeira"
	    },
	    {
	        "id": 3573,
	        "name": "Guardo"
	    },
	    {
	        "id": 3574,
	        "name": "Cantagallo"
	    },
	    {
	        "id": 3575,
	        "name": "San Vicente de la Barquera"
	    },
	    {
	        "id": 3576,
	        "name": "Fresno de la Fuente"
	    },
	    {
	        "id": 3577,
	        "name": "El Real de la Jara"
	    },
	    {
	        "id": 3578,
	        "name": "Espeja de San Marcelino"
	    },
	    {
	        "id": 3579,
	        "name": "La Masó"
	    },
	    {
	        "id": 3580,
	        "name": "La Codoñera"
	    },
	    {
	        "id": 3581,
	        "name": "Illán de Vacas"
	    },
	    {
	        "id": 3582,
	        "name": "Camporrobles"
	    },
	    {
	        "id": 3583,
	        "name": "Manzanillo"
	    },
	    {
	        "id": 3584,
	        "name": "Valle de Trápaga-Trapagaran"
	    },
	    {
	        "id": 3585,
	        "name": "Fuentelapeña"
	    },
	    {
	        "id": 3586,
	        "name": "Cerveruela"
	    },
	    {
	        "id": 3587,
	        "name": "Villarrobledo"
	    },
	    {
	        "id": 3588,
	        "name": "Xaló"
	    },
	    {
	        "id": 3589,
	        "name": "Santa Fe de Mondújar"
	    },
	    {
	        "id": 3590,
	        "name": "Garganta del Villar"
	    },
	    {
	        "id": 3591,
	        "name": "Medina de las Torres"
	    },
	    {
	        "id": 3592,
	        "name": "Fogars de Montclús"
	    },
	    {
	        "id": 3593,
	        "name": "Gargüera"
	    },
	    {
	        "id": 3594,
	        "name": "Navajas"
	    },
	    {
	        "id": 3595,
	        "name": "Terrinches"
	    },
	    {
	        "id": 3596,
	        "name": "As Somozas"
	    },
	    {
	        "id": 3597,
	        "name": "Chumillas"
	    },
	    {
	        "id": 3598,
	        "name": "Gualta"
	    },
	    {
	        "id": 3599,
	        "name": "Cendejas de la Torre"
	    },
	    {
	        "id": 3600,
	        "name": "Zumaia"
	    },
	    {
	        "id": 3601,
	        "name": "Casbas de Huesca"
	    },
	    {
	        "id": 3602,
	        "name": "Segura de la Sierra"
	    },
	    {
	        "id": 3603,
	        "name": "Gusendos de los Oteros"
	    },
	    {
	        "id": 3604,
	        "name": "L'Espluga Calba"
	    },
	    {
	        "id": 3605,
	        "name": "Jalón de Cameros"
	    },
	    {
	        "id": 3606,
	        "name": "Pujerra"
	    },
	    {
	        "id": 3607,
	        "name": "Donamaria"
	    },
	    {
	        "id": 3608,
	        "name": "Toén"
	    },
	    {
	        "id": 3609,
	        "name": "Guaza de Campos"
	    },
	    {
	        "id": 3610,
	        "name": "Cantalapiedra"
	    },
	    {
	        "id": 3611,
	        "name": "Saro"
	    },
	    {
	        "id": 3612,
	        "name": "Frumales"
	    },
	    {
	        "id": 3613,
	        "name": "La Rinconada"
	    },
	    {
	        "id": 3614,
	        "name": "Espejón"
	    },
	    {
	        "id": 3615,
	        "name": "Maspujols"
	    },
	    {
	        "id": 3616,
	        "name": "Illescas"
	    },
	    {
	        "id": 3617,
	        "name": "Canals"
	    },
	    {
	        "id": 3618,
	        "name": "Marzales"
	    },
	    {
	        "id": 3619,
	        "name": "Lezama"
	    },
	    {
	        "id": 3620,
	        "name": "Fuentesaúco"
	    },
	    {
	        "id": 3621,
	        "name": "Cetina"
	    },
	    {
	        "id": 3622,
	        "name": "Villatoya"
	    },
	    {
	        "id": 3623,
	        "name": "Jávea/Xàbia"
	    },
	    {
	        "id": 3624,
	        "name": "Senés"
	    },
	    {
	        "id": 3625,
	        "name": "Gavilanes"
	    },
	    {
	        "id": 3626,
	        "name": "Mengabril"
	    },
	    {
	        "id": 3627,
	        "name": "Fogars de la Selva"
	    },
	    {
	        "id": 3628,
	        "name": "Castildelgado"
	    },
	    {
	        "id": 3629,
	        "name": "Garrovillas de Alconétar"
	    },
	    {
	        "id": 3630,
	        "name": "Nules"
	    },
	    {
	        "id": 3631,
	        "name": "Tomelloso"
	    },
	    {
	        "id": 3632,
	        "name": "Teo"
	    },
	    {
	        "id": 3633,
	        "name": "Enguídanos"
	    },
	    {
	        "id": 3634,
	        "name": "Guils de Cerdanya"
	    },
	    {
	        "id": 3635,
	        "name": "Galera"
	    },
	    {
	        "id": 3636,
	        "name": "Centenera"
	    },
	    {
	        "id": 3637,
	        "name": "Castejón del Puente"
	    },
	    {
	        "id": 3638,
	        "name": "Siles"
	    },
	    {
	        "id": 3639,
	        "name": "Hospital de Órbigo"
	    },
	    {
	        "id": 3640,
	        "name": "Espot"
	    },
	    {
	        "id": 3641,
	        "name": "Laguna de Cameros"
	    },
	    {
	        "id": 3642,
	        "name": "Manzanares el Real"
	    },
	    {
	        "id": 3643,
	        "name": "Rincón de la Victoria"
	    },
	    {
	        "id": 3644,
	        "name": "Etxalar"
	    },
	    {
	        "id": 3645,
	        "name": "Trasmiras"
	    },
	    {
	        "id": 3646,
	        "name": "Hérmedes de Cerrato"
	    },
	    {
	        "id": 3647,
	        "name": "Cantalpino"
	    },
	    {
	        "id": 3648,
	        "name": "Selaya"
	    },
	    {
	        "id": 3649,
	        "name": "Fuente de Santa Cruz"
	    },
	    {
	        "id": 3650,
	        "name": "La Roda de Andalucía"
	    },
	    {
	        "id": 3651,
	        "name": "Estepa de San Juan"
	    },
	    {
	        "id": 3652,
	        "name": "El Masroig"
	    },
	    {
	        "id": 3653,
	        "name": "Corbalán"
	    },
	    {
	        "id": 3654,
	        "name": "Lagartera"
	    },
	    {
	        "id": 3655,
	        "name": "Canet d'En Berenguer"
	    },
	    {
	        "id": 3656,
	        "name": "Matapozuelos"
	    },
	    {
	        "id": 3657,
	        "name": "Santurtzi"
	    },
	    {
	        "id": 3658,
	        "name": "Fuentes de Ropel"
	    },
	    {
	        "id": 3659,
	        "name": "Cimballa"
	    },
	    {
	        "id": 3660,
	        "name": "Villavaliente"
	    },
	    {
	        "id": 3661,
	        "name": "Jijona/Xixona"
	    },
	    {
	        "id": 3662,
	        "name": "Serón"
	    },
	    {
	        "id": 3663,
	        "name": "Gemuño"
	    },
	    {
	        "id": 3664,
	        "name": "Mérida"
	    },
	    {
	        "id": 3665,
	        "name": "Folgueroles"
	    },
	    {
	        "id": 3666,
	        "name": "Castil de Peones"
	    },
	    {
	        "id": 3667,
	        "name": "Garvín"
	    },
	    {
	        "id": 3668,
	        "name": "Olocau del Rey"
	    },
	    {
	        "id": 3669,
	        "name": "Torralba de Calatrava"
	    },
	    {
	        "id": 3670,
	        "name": "Toques"
	    },
	    {
	        "id": 3671,
	        "name": "Fresneda de Altarejos"
	    },
	    {
	        "id": 3672,
	        "name": "Hostalric"
	    },
	    {
	        "id": 3673,
	        "name": "Gobernador"
	    },
	    {
	        "id": 3674,
	        "name": "Castejón de Monegros"
	    },
	    {
	        "id": 3675,
	        "name": "Igüeña"
	    },
	    {
	        "id": 3676,
	        "name": "Lagunilla del Jubera"
	    },
	    {
	        "id": 3677,
	        "name": "Meco"
	    },
	    {
	        "id": 3678,
	        "name": "Riogordo"
	    },
	    {
	        "id": 3679,
	        "name": "Echarri"
	    },
	    {
	        "id": 3680,
	        "name": "A Veiga"
	    },
	    {
	        "id": 3681,
	        "name": "Herrera de Pisuerga"
	    },
	    {
	        "id": 3682,
	        "name": "Cantaracillo"
	    },
	    {
	        "id": 3683,
	        "name": "Soba"
	    },
	    {
	        "id": 3684,
	        "name": "Fuente el Olmo de Fuentidueña"
	    },
	    {
	        "id": 3685,
	        "name": "El Ronquillo"
	    },
	    {
	        "id": 3686,
	        "name": "Frechilla de Almazán"
	    },
	    {
	        "id": 3687,
	        "name": "El Milà"
	    },
	    {
	        "id": 3688,
	        "name": "Layos"
	    },
	    {
	        "id": 3689,
	        "name": "Carcaixent"
	    },
	    {
	        "id": 3690,
	        "name": "Matilla de los Caños"
	    },
	    {
	        "id": 3691,
	        "name": "Ortuella"
	    },
	    {
	        "id": 3692,
	        "name": "Fuentesecas"
	    },
	    {
	        "id": 3693,
	        "name": "Cinco Olivas"
	    },
	    {
	        "id": 3694,
	        "name": "Villaverde de Guadalimar"
	    },
	    {
	        "id": 3695,
	        "name": "l'Lorcha/Orxa"
	    },
	    {
	        "id": 3696,
	        "name": "Sierro"
	    },
	    {
	        "id": 3697,
	        "name": "Gilbuena"
	    },
	    {
	        "id": 3698,
	        "name": "Mirandilla"
	    },
	    {
	        "id": 3699,
	        "name": "Fonollosa"
	    },
	    {
	        "id": 3700,
	        "name": "Castrillo de la Reina"
	    },
	    {
	        "id": 3701,
	        "name": "Gata"
	    },
	    {
	        "id": 3702,
	        "name": "Onda"
	    },
	    {
	        "id": 3703,
	        "name": "Torre de Juan Abad"
	    },
	    {
	        "id": 3704,
	        "name": "Tordoia"
	    },
	    {
	        "id": 3705,
	        "name": "Fresneda de la Sierra"
	    },
	    {
	        "id": 3706,
	        "name": "Isòvol"
	    },
	    {
	        "id": 3707,
	        "name": "Gójar"
	    },
	    {
	        "id": 3708,
	        "name": "Castejón de Sos"
	    },
	    {
	        "id": 3709,
	        "name": "Sorihuela del Guadalimar"
	    },
	    {
	        "id": 3710,
	        "name": "Izagre"
	    },
	    {
	        "id": 3711,
	        "name": "Lardero"
	    },
	    {
	        "id": 3712,
	        "name": "Mejorada del Campo"
	    },
	    {
	        "id": 3713,
	        "name": "Ronda"
	    },
	    {
	        "id": 3714,
	        "name": "Etxarri-Aranatz"
	    },
	    {
	        "id": 3715,
	        "name": "Verea"
	    },
	    {
	        "id": 3716,
	        "name": "Herrera de Valdecañas"
	    },
	    {
	        "id": 3717,
	        "name": "Solórzano"
	    },
	    {
	        "id": 3718,
	        "name": "Fuente el Olmo de Íscar"
	    },
	    {
	        "id": 3719,
	        "name": "El Rubio"
	    },
	    {
	        "id": 3720,
	        "name": "Fresno de Caracena"
	    },
	    {
	        "id": 3721,
	        "name": "Miravet"
	    },
	    {
	        "id": 3722,
	        "name": "Cortes de Aragón"
	    },
	    {
	        "id": 3723,
	        "name": "Lillo"
	    },
	    {
	        "id": 3724,
	        "name": "Càrcer"
	    },
	    {
	        "id": 3725,
	        "name": "Mayorga"
	    },
	    {
	        "id": 3726,
	        "name": "Sestao"
	    },
	    {
	        "id": 3727,
	        "name": "Fuentespreadas"
	    },
	    {
	        "id": 3728,
	        "name": "Clarés de Ribota"
	    },
	    {
	        "id": 3729,
	        "name": "Viveros"
	    },
	    {
	        "id": 3730,
	        "name": "Llíber"
	    },
	    {
	        "id": 3731,
	        "name": "Somontín"
	    },
	    {
	        "id": 3732,
	        "name": "Gil García"
	    },
	    {
	        "id": 3733,
	        "name": "Monesterio"
	    },
	    {
	        "id": 3734,
	        "name": "Font-rubí"
	    },
	    {
	        "id": 3735,
	        "name": "Castrillo de la Vega"
	    },
	    {
	        "id": 3736,
	        "name": "El Gordo"
	    },
	    {
	        "id": 3737,
	        "name": "Oropesa del Mar/Orpesa"
	    },
	    {
	        "id": 3738,
	        "name": "Torrenueva"
	    },
	    {
	        "id": 3739,
	        "name": "Touro"
	    },
	    {
	        "id": 3740,
	        "name": "La Frontera"
	    },
	    {
	        "id": 3741,
	        "name": "Jafre"
	    },
	    {
	        "id": 3742,
	        "name": "Gor"
	    },
	    {
	        "id": 3743,
	        "name": "Castelflorite"
	    },
	    {
	        "id": 3744,
	        "name": "Torreblascopedro"
	    },
	    {
	        "id": 3745,
	        "name": "Estaràs"
	    },
	    {
	        "id": 3746,
	        "name": "Miraflores de la Sierra"
	    },
	    {
	        "id": 3747,
	        "name": "Salares"
	    },
	    {
	        "id": 3748,
	        "name": "Etxauri"
	    },
	    {
	        "id": 3749,
	        "name": "Verín"
	    },
	    {
	        "id": 3750,
	        "name": "Carbajosa de la Sagrada"
	    },
	    {
	        "id": 3751,
	        "name": "Suances"
	    },
	    {
	        "id": 3752,
	        "name": "Salteras"
	    },
	    {
	        "id": 3753,
	        "name": "Fuentearmegil"
	    },
	    {
	        "id": 3754,
	        "name": "El Molar"
	    },
	    {
	        "id": 3755,
	        "name": "Cosa"
	    },
	    {
	        "id": 3756,
	        "name": "Lominchar"
	    },
	    {
	        "id": 3757,
	        "name": "Carlet"
	    },
	    {
	        "id": 3758,
	        "name": "Medina del Campo"
	    },
	    {
	        "id": 3759,
	        "name": "Sopelana"
	    },
	    {
	        "id": 3760,
	        "name": "Galende"
	    },
	    {
	        "id": 3761,
	        "name": "Codo"
	    },
	    {
	        "id": 3762,
	        "name": "Yeste"
	    },
	    {
	        "id": 3763,
	        "name": "Millena"
	    },
	    {
	        "id": 3764,
	        "name": "Sorbas"
	    },
	    {
	        "id": 3765,
	        "name": "Gimialcón"
	    },
	    {
	        "id": 3766,
	        "name": "Montemolín"
	    },
	    {
	        "id": 3767,
	        "name": "Les Franqueses del Vallès"
	    },
	    {
	        "id": 3768,
	        "name": "Castrillo del Val"
	    },
	    {
	        "id": 3769,
	        "name": "La Granja"
	    },
	    {
	        "id": 3770,
	        "name": "Valdemanco del Esteras"
	    },
	    {
	        "id": 3771,
	        "name": "Trazo"
	    },
	    {
	        "id": 3772,
	        "name": "Fuente de Pedro Naharro"
	    },
	    {
	        "id": 3773,
	        "name": "La Jonquera"
	    },
	    {
	        "id": 3774,
	        "name": "Gorafe"
	    },
	    {
	        "id": 3775,
	        "name": "Cifuentes"
	    },
	    {
	        "id": 3776,
	        "name": "Castiello de Jaca"
	    },
	    {
	        "id": 3777,
	        "name": "Torre del Campo"
	    },
	    {
	        "id": 3778,
	        "name": "Joarilla de las Matas"
	    },
	    {
	        "id": 3779,
	        "name": "Esterri d'Àneu"
	    },
	    {
	        "id": 3780,
	        "name": "Ledesma de la Cogolla"
	    },
	    {
	        "id": 3781,
	        "name": "El Molar"
	    },
	    {
	        "id": 3782,
	        "name": "Sayalonga"
	    },
	    {
	        "id": 3783,
	        "name": "Egüés"
	    },
	    {
	        "id": 3784,
	        "name": "Viana do Bolo"
	    },
	    {
	        "id": 3785,
	        "name": "Hontoria de Cerrato"
	    },
	    {
	        "id": 3786,
	        "name": "Carpio de Azaba"
	    },
	    {
	        "id": 3787,
	        "name": "Los Tojos"
	    },
	    {
	        "id": 3788,
	        "name": "Fuentepelayo"
	    },
	    {
	        "id": 3789,
	        "name": "San Juan de Aznalfarache"
	    },
	    {
	        "id": 3790,
	        "name": "Fuentecambrón"
	    },
	    {
	        "id": 3791,
	        "name": "Montblanc"
	    },
	    {
	        "id": 3792,
	        "name": "Cretas"
	    },
	    {
	        "id": 3793,
	        "name": "Lucillos"
	    },
	    {
	        "id": 3794,
	        "name": "Carrícola"
	    },
	    {
	        "id": 3795,
	        "name": "Medina de Rioseco"
	    },
	    {
	        "id": 3796,
	        "name": "Sopuerta"
	    },
	    {
	        "id": 3797,
	        "name": "Gallegos del Pan"
	    },
	    {
	        "id": 3798,
	        "name": "Codos"
	    },
	    {
	        "id": 3799,
	        "name": "Suflí"
	    },
	    {
	        "id": 3800,
	        "name": "Gotarrendura"
	    },
	    {
	        "id": 3801,
	        "name": "Monterrubio de la Serena"
	    },
	    {
	        "id": 3802,
	        "name": "Gallifa"
	    },
	    {
	        "id": 3803,
	        "name": "Guadalupe"
	    },
	    {
	        "id": 3804,
	        "name": "Palanques"
	    },
	    {
	        "id": 3805,
	        "name": "Valdepeñas"
	    },
	    {
	        "id": 3806,
	        "name": "Valdoviño"
	    },
	    {
	        "id": 3807,
	        "name": "Fuentelespino de Haro"
	    },
	    {
	        "id": 3808,
	        "name": "Juià"
	    },
	    {
	        "id": 3809,
	        "name": "Granada"
	    },
	    {
	        "id": 3810,
	        "name": "Cincovillas"
	    },
	    {
	        "id": 3811,
	        "name": "Castigaleu"
	    },
	    {
	        "id": 3812,
	        "name": "Torredonjimeno"
	    },
	    {
	        "id": 3813,
	        "name": "Laguna Dalga"
	    },
	    {
	        "id": 3814,
	        "name": "Esterri de Cardós"
	    },
	    {
	        "id": 3815,
	        "name": "Leiva"
	    },
	    {
	        "id": 3816,
	        "name": "Los Molinos"
	    },
	    {
	        "id": 3817,
	        "name": "Sedella"
	    },
	    {
	        "id": 3818,
	        "name": "Elgorriaga"
	    },
	    {
	        "id": 3819,
	        "name": "Vilamarín"
	    },
	    {
	        "id": 3820,
	        "name": "Hornillos de Cerrato"
	    },
	    {
	        "id": 3821,
	        "name": "Carrascal de Barregas"
	    },
	    {
	        "id": 3822,
	        "name": "Torrelavega"
	    },
	    {
	        "id": 3823,
	        "name": "Fuentepiñel"
	    },
	    {
	        "id": 3824,
	        "name": "Sanlúcar la Mayor"
	    },
	    {
	        "id": 3825,
	        "name": "Fuentecantos"
	    },
	    {
	        "id": 3826,
	        "name": "Crivillén"
	    },
	    {
	        "id": 3827,
	        "name": "Madridejos"
	    },
	    {
	        "id": 3828,
	        "name": "Casas Altas"
	    },
	    {
	        "id": 3829,
	        "name": "Megeces"
	    },
	    {
	        "id": 3830,
	        "name": "Trucios-Turtzioz"
	    },
	    {
	        "id": 3831,
	        "name": "Gallegos del Río"
	    },
	    {
	        "id": 3832,
	        "name": "Contamina"
	    },
	    {
	        "id": 3833,
	        "name": "Monforte del Cid"
	    },
	    {
	        "id": 3834,
	        "name": "Tabernas"
	    },
	    {
	        "id": 3835,
	        "name": "Grandes y San Martín"
	    },
	    {
	        "id": 3836,
	        "name": "Montijo"
	    },
	    {
	        "id": 3837,
	        "name": "La Garriga"
	    },
	    {
	        "id": 3838,
	        "name": "Castrillo de Riopisuerga"
	    },
	    {
	        "id": 3839,
	        "name": "Guijo de Coria"
	    },
	    {
	        "id": 3840,
	        "name": "Pavías"
	    },
	    {
	        "id": 3841,
	        "name": "Valenzuela de Calatrava"
	    },
	    {
	        "id": 3842,
	        "name": "Val do Dubra"
	    },
	    {
	        "id": 3843,
	        "name": "Fuentelespino de Moya"
	    },
	    {
	        "id": 3844,
	        "name": "Lladó"
	    },
	    {
	        "id": 3845,
	        "name": "Guadahortuna"
	    },
	    {
	        "id": 3846,
	        "name": "Ciruelas"
	    },
	    {
	        "id": 3847,
	        "name": "Castillazuelo"
	    },
	    {
	        "id": 3848,
	        "name": "Torreperogil"
	    },
	    {
	        "id": 3849,
	        "name": "Laguna de Negrillos"
	    },
	    {
	        "id": 3850,
	        "name": "Estamariu"
	    },
	    {
	        "id": 3851,
	        "name": "Leza de Río Leza"
	    },
	    {
	        "id": 3852,
	        "name": "Montejo de la Sierra"
	    },
	    {
	        "id": 3853,
	        "name": "Sierra de Yeguas"
	    },
	    {
	        "id": 3854,
	        "name": "Noáin (Valle de Elorz)/Noain (Elortzibar)"
	    },
	    {
	        "id": 3855,
	        "name": "Vilamartín de Valdeorras"
	    },
	    {
	        "id": 3856,
	        "name": "Husillos"
	    },
	    {
	        "id": 3857,
	        "name": "Carrascal del Obispo"
	    },
	    {
	        "id": 3858,
	        "name": "Tresviso"
	    },
	    {
	        "id": 3859,
	        "name": "Fuenterrebollo"
	    },
	    {
	        "id": 3860,
	        "name": "San Nicolás del Puerto"
	    },
	    {
	        "id": 3861,
	        "name": "Fuentelmonge"
	    },
	    {
	        "id": 3862,
	        "name": "Montbrió del Camp"
	    },
	    {
	        "id": 3863,
	        "name": "La Cuba"
	    },
	    {
	        "id": 3864,
	        "name": "Magán"
	    },
	    {
	        "id": 3865,
	        "name": "Casas Bajas"
	    },
	    {
	        "id": 3866,
	        "name": "Melgar de Abajo"
	    },
	    {
	        "id": 3867,
	        "name": "Ubide"
	    },
	    {
	        "id": 3868,
	        "name": "Gamones"
	    },
	    {
	        "id": 3869,
	        "name": "Cosuenda"
	    },
	    {
	        "id": 3870,
	        "name": "Monóvar/Monòver"
	    },
	    {
	        "id": 3871,
	        "name": "Taberno"
	    },
	    {
	        "id": 3872,
	        "name": "Guisando"
	    },
	    {
	        "id": 3873,
	        "name": "La Morera"
	    },
	    {
	        "id": 3874,
	        "name": "Gavà"
	    },
	    {
	        "id": 3875,
	        "name": "Guijo de Galisteo"
	    },
	    {
	        "id": 3876,
	        "name": "Peníscola/Peñíscola"
	    },
	    {
	        "id": 3877,
	        "name": "Villahermosa"
	    },
	    {
	        "id": 3878,
	        "name": "Vedra"
	    },
	    {
	        "id": 3879,
	        "name": "Fuentes"
	    },
	    {
	        "id": 3880,
	        "name": "Llagostera"
	    },
	    {
	        "id": 3881,
	        "name": "Guadix"
	    },
	    {
	        "id": 3882,
	        "name": "Ciruelos del Pinar"
	    },
	    {
	        "id": 3883,
	        "name": "Castillonroy"
	    },
	    {
	        "id": 3884,
	        "name": "León"
	    },
	    {
	        "id": 3885,
	        "name": "Farrera"
	    },
	    {
	        "id": 3886,
	        "name": "Logroño"
	    },
	    {
	        "id": 3887,
	        "name": "Moraleja de Enmedio"
	    },
	    {
	        "id": 3888,
	        "name": "Teba"
	    },
	    {
	        "id": 3889,
	        "name": "Enériz/Eneritz"
	    },
	    {
	        "id": 3890,
	        "name": "Vilar de Barrio"
	    },
	    {
	        "id": 3891,
	        "name": "Itero de la Vega"
	    },
	    {
	        "id": 3892,
	        "name": "Casafranca"
	    },
	    {
	        "id": 3893,
	        "name": "Tudanca"
	    },
	    {
	        "id": 3894,
	        "name": "Fuentesaúco de Fuentidueña"
	    },
	    {
	        "id": 3895,
	        "name": "Santiponce"
	    },
	    {
	        "id": 3896,
	        "name": "Fuentelsaz de Soria"
	    },
	    {
	        "id": 3897,
	        "name": "Montferri"
	    },
	    {
	        "id": 3898,
	        "name": "Cubla"
	    },
	    {
	        "id": 3899,
	        "name": "Malpica de Tajo"
	    },
	    {
	        "id": 3900,
	        "name": "Casinos"
	    },
	    {
	        "id": 3901,
	        "name": "Melgar de Arriba"
	    },
	    {
	        "id": 3902,
	        "name": "Urduliz"
	    },
	    {
	        "id": 3903,
	        "name": "Cuarte de Huerva"
	    },
	    {
	        "id": 3904,
	        "name": "Mutxamel"
	    },
	    {
	        "id": 3905,
	        "name": "Tahal"
	    },
	    {
	        "id": 3906,
	        "name": "Gutierre-Muñoz"
	    },
	    {
	        "id": 3907,
	        "name": "La Nava de Santiago"
	    },
	    {
	        "id": 3908,
	        "name": "Gaià"
	    },
	    {
	        "id": 3909,
	        "name": "Castrillo Matajudíos"
	    },
	    {
	        "id": 3910,
	        "name": "Guijo de Granadilla"
	    },
	    {
	        "id": 3911,
	        "name": "Pina de Montalgrao"
	    },
	    {
	        "id": 3912,
	        "name": "Villamanrique"
	    },
	    {
	        "id": 3913,
	        "name": "Vilasantar"
	    },
	    {
	        "id": 3914,
	        "name": "Llambilles"
	    },
	    {
	        "id": 3915,
	        "name": "Cobeta"
	    },
	    {
	        "id": 3916,
	        "name": "Colungo"
	    },
	    {
	        "id": 3917,
	        "name": "Torres"
	    },
	    {
	        "id": 3918,
	        "name": "Lucillo"
	    },
	    {
	        "id": 3919,
	        "name": "Moralzarzal"
	    },
	    {
	        "id": 3920,
	        "name": "Tolox"
	    },
	    {
	        "id": 3921,
	        "name": "Eratsun"
	    },
	    {
	        "id": 3922,
	        "name": "Vilar de Santos"
	    },
	    {
	        "id": 3923,
	        "name": "Las Casas del Conde"
	    },
	    {
	        "id": 3924,
	        "name": "Udías"
	    },
	    {
	        "id": 3925,
	        "name": "El Saucejo"
	    },
	    {
	        "id": 3926,
	        "name": "Fuentepinilla"
	    },
	    {
	        "id": 3927,
	        "name": "El Montmell"
	    },
	    {
	        "id": 3928,
	        "name": "Cucalón"
	    },
	    {
	        "id": 3929,
	        "name": "Manzaneque"
	    },
	    {
	        "id": 3930,
	        "name": "Castelló de Rugat"
	    },
	    {
	        "id": 3931,
	        "name": "Mojados"
	    },
	    {
	        "id": 3932,
	        "name": "Balmaseda"
	    },
	    {
	        "id": 3933,
	        "name": "Gema"
	    },
	    {
	        "id": 3934,
	        "name": "Cubel"
	    },
	    {
	        "id": 3935,
	        "name": "Murla"
	    },
	    {
	        "id": 3936,
	        "name": "Terque"
	    },
	    {
	        "id": 3937,
	        "name": "Navalvillar de Pela"
	    },
	    {
	        "id": 3938,
	        "name": "Gelida"
	    },
	    {
	        "id": 3939,
	        "name": "Castrojeriz"
	    },
	    {
	        "id": 3940,
	        "name": "Guijo de Santa Bárbara"
	    },
	    {
	        "id": 3941,
	        "name": "Portell de Morella"
	    },
	    {
	        "id": 3942,
	        "name": "Villamayor de Calatrava"
	    },
	    {
	        "id": 3943,
	        "name": "Vilarmaior"
	    },
	    {
	        "id": 3944,
	        "name": "Fuertescusa"
	    },
	    {
	        "id": 3945,
	        "name": "Llanars"
	    },
	    {
	        "id": 3946,
	        "name": "Cogollor"
	    },
	    {
	        "id": 3947,
	        "name": "Torres de Albánchez"
	    },
	    {
	        "id": 3948,
	        "name": "Luyego"
	    },
	    {
	        "id": 3949,
	        "name": "Lumbreras"
	    },
	    {
	        "id": 3950,
	        "name": "Morata de Tajuña"
	    },
	    {
	        "id": 3951,
	        "name": "Torrox"
	    },
	    {
	        "id": 3952,
	        "name": "Ergoiena"
	    },
	    {
	        "id": 3953,
	        "name": "Vilardevós"
	    },
	    {
	        "id": 3954,
	        "name": "Lagartos"
	    },
	    {
	        "id": 3955,
	        "name": "Casillas de Flores"
	    },
	    {
	        "id": 3956,
	        "name": "Valdáliga"
	    },
	    {
	        "id": 3957,
	        "name": "Fuentesoto"
	    },
	    {
	        "id": 3958,
	        "name": "Sevilla"
	    },
	    {
	        "id": 3959,
	        "name": "Mont-ral"
	    },
	    {
	        "id": 3960,
	        "name": "Maqueda"
	    },
	    {
	        "id": 3961,
	        "name": "Castellonet de la Conquesta"
	    },
	    {
	        "id": 3962,
	        "name": "Monasterio de Vega"
	    },
	    {
	        "id": 3963,
	        "name": "Atxondo"
	    },
	    {
	        "id": 3964,
	        "name": "Granja de Moreruela"
	    },
	    {
	        "id": 3965,
	        "name": "Las Cuerlas"
	    },
	    {
	        "id": 3966,
	        "name": "Muro de Alcoy"
	    },
	    {
	        "id": 3967,
	        "name": "Tíjola"
	    },
	    {
	        "id": 3968,
	        "name": "Hernansancho"
	    },
	    {
	        "id": 3969,
	        "name": "Nogales"
	    },
	    {
	        "id": 3970,
	        "name": "Gironella"
	    },
	    {
	        "id": 3971,
	        "name": "Herguijuela"
	    },
	    {
	        "id": 3972,
	        "name": "Puebla de Arenoso"
	    },
	    {
	        "id": 3973,
	        "name": "Villanueva de la Fuente"
	    },
	    {
	        "id": 3974,
	        "name": "Vimianzo"
	    },
	    {
	        "id": 3975,
	        "name": "Gabaldón"
	    },
	    {
	        "id": 3976,
	        "name": "Llançà"
	    },
	    {
	        "id": 3977,
	        "name": "Cogolludo"
	    },
	    {
	        "id": 3978,
	        "name": "Úbeda"
	    },
	    {
	        "id": 3979,
	        "name": "Llamas de la Ribera"
	    },
	    {
	        "id": 3980,
	        "name": "La Floresta"
	    },
	    {
	        "id": 3981,
	        "name": "Manjarrés"
	    },
	    {
	        "id": 3982,
	        "name": "Móstoles"
	    },
	    {
	        "id": 3983,
	        "name": "Totalán"
	    },
	    {
	        "id": 3984,
	        "name": "Erro"
	    },
	    {
	        "id": 3985,
	        "name": "Vilariño de Conso"
	    },
	    {
	        "id": 3986,
	        "name": "Lantadilla"
	    },
	    {
	        "id": 3987,
	        "name": "Castellanos de Moriscos"
	    },
	    {
	        "id": 3988,
	        "name": "Valdeolea"
	    },
	    {
	        "id": 3989,
	        "name": "Fuentidueña"
	    },
	    {
	        "id": 3990,
	        "name": "Tocina"
	    },
	    {
	        "id": 3991,
	        "name": "Fuentes de Magaña"
	    },
	    {
	        "id": 3992,
	        "name": "Mont-roig del Camp"
	    },
	    {
	        "id": 3993,
	        "name": "El Cuervo"
	    },
	    {
	        "id": 3994,
	        "name": "Marjaliza"
	    },
	    {
	        "id": 3995,
	        "name": "Castielfabib"
	    },
	    {
	        "id": 3996,
	        "name": "Montealegre de Campos"
	    },
	    {
	        "id": 3997,
	        "name": "Bedia"
	    },
	    {
	        "id": 3998,
	        "name": "Granucillo"
	    },
	    {
	        "id": 3999,
	        "name": "Chiprana"
	    },
	    {
	        "id": 4000,
	        "name": "Novelda"
	    },
	    {
	        "id": 4001,
	        "name": "Turre"
	    },
	    {
	        "id": 4002,
	        "name": "Herradón de Pinares"
	    },
	    {
	        "id": 4003,
	        "name": "Oliva de la Frontera"
	    },
	    {
	        "id": 4004,
	        "name": "Gisclareny"
	    },
	    {
	        "id": 4005,
	        "name": "Cayuela"
	    },
	    {
	        "id": 4006,
	        "name": "Hernán-Pérez"
	    },
	    {
	        "id": 4007,
	        "name": "la Pobla de Benifassà"
	    },
	    {
	        "id": 4008,
	        "name": "Villanueva de los Infantes"
	    },
	    {
	        "id": 4009,
	        "name": "Zas"
	    },
	    {
	        "id": 4010,
	        "name": "Garaballa"
	    },
	    {
	        "id": 4011,
	        "name": "Llers"
	    },
	    {
	        "id": 4012,
	        "name": "Gualchos"
	    },
	    {
	        "id": 4013,
	        "name": "Valdepeñas de Jaén"
	    },
	    {
	        "id": 4014,
	        "name": "Magaz de Cepeda"
	    },
	    {
	        "id": 4015,
	        "name": "Fondarella"
	    },
	    {
	        "id": 4016,
	        "name": "Mansilla de la Sierra"
	    },
	    {
	        "id": 4017,
	        "name": "Navacerrada"
	    },
	    {
	        "id": 4018,
	        "name": "Valle de Abdalajís"
	    },
	    {
	        "id": 4019,
	        "name": "Ezcároz/Ezkaroze"
	    },
	    {
	        "id": 4020,
	        "name": "La Vid de Ojeda"
	    },
	    {
	        "id": 4021,
	        "name": "Valdeprado del Río"
	    },
	    {
	        "id": 4022,
	        "name": "Gallegos"
	    },
	    {
	        "id": 4023,
	        "name": "Tomares"
	    },
	    {
	        "id": 4024,
	        "name": "Fuentestrún"
	    },
	    {
	        "id": 4025,
	        "name": "Móra d'Ebre"
	    },
	    {
	        "id": 4026,
	        "name": "Cuevas de Almudén"
	    },
	    {
	        "id": 4027,
	        "name": "Marrupe"
	    },
	    {
	        "id": 4028,
	        "name": "Catadau"
	    },
	    {
	        "id": 4029,
	        "name": "Montemayor de Pililla"
	    },
	    {
	        "id": 4030,
	        "name": "Areatza"
	    },
	    {
	        "id": 4031,
	        "name": "Guarrate"
	    },
	    {
	        "id": 4032,
	        "name": "Chodes"
	    },
	    {
	        "id": 4033,
	        "name": "la Nucia"
	    },
	    {
	        "id": 4034,
	        "name": "Turrillas"
	    },
	    {
	        "id": 4035,
	        "name": "Herreros de Suso"
	    },
	    {
	        "id": 4036,
	        "name": "Oliva de Mérida"
	    },
	    {
	        "id": 4037,
	        "name": "La Granada"
	    },
	    {
	        "id": 4038,
	        "name": "Cebrecos"
	    },
	    {
	        "id": 4039,
	        "name": "Herrera de Alcántara"
	    },
	    {
	        "id": 4040,
	        "name": "la Pobla Tornesa"
	    },
	    {
	        "id": 4041,
	        "name": "Villanueva de San Carlos"
	    },
	    {
	        "id": 4042,
	        "name": "Gascueña"
	    },
	    {
	        "id": 4043,
	        "name": "Llívia"
	    },
	    {
	        "id": 4044,
	        "name": "Güejar Sierra"
	    },
	    {
	        "id": 4045,
	        "name": "Chalamera"
	    },
	    {
	        "id": 4046,
	        "name": "Vilches"
	    },
	    {
	        "id": 4047,
	        "name": "Mansilla de las Mulas"
	    },
	    {
	        "id": 4048,
	        "name": "Foradada"
	    },
	    {
	        "id": 4049,
	        "name": "Manzanares de Rioja"
	    },
	    {
	        "id": 4050,
	        "name": "Navalafuente"
	    },
	    {
	        "id": 4051,
	        "name": "Vélez-Málaga"
	    },
	    {
	        "id": 4052,
	        "name": "Eslava"
	    },
	    {
	        "id": 4053,
	        "name": "Ledigos"
	    },
	    {
	        "id": 4054,
	        "name": "Valderredible"
	    },
	    {
	        "id": 4055,
	        "name": "Garcillán"
	    },
	    {
	        "id": 4056,
	        "name": "Umbrete"
	    },
	    {
	        "id": 4057,
	        "name": "Garray"
	    },
	    {
	        "id": 4058,
	        "name": "Móra la Nova"
	    },
	    {
	        "id": 4059,
	        "name": "Cuevas Labradas"
	    },
	    {
	        "id": 4060,
	        "name": "Mascaraque"
	    },
	    {
	        "id": 4061,
	        "name": "Catarroja"
	    },
	    {
	        "id": 4062,
	        "name": "Moral de la Reina"
	    },
	    {
	        "id": 4063,
	        "name": "Igorre"
	    },
	    {
	        "id": 4064,
	        "name": "Hermisende"
	    },
	    {
	        "id": 4065,
	        "name": "Daroca"
	    },
	    {
	        "id": 4066,
	        "name": "Ondara"
	    },
	    {
	        "id": 4067,
	        "name": "Uleila del Campo"
	    },
	    {
	        "id": 4068,
	        "name": "Higuera de las Dueñas"
	    },
	    {
	        "id": 4069,
	        "name": "Olivenza"
	    },
	    {
	        "id": 4070,
	        "name": "Granera"
	    },
	    {
	        "id": 4071,
	        "name": "Celada del Camino"
	    },
	    {
	        "id": 4072,
	        "name": "Herreruela"
	    },
	    {
	        "id": 4073,
	        "name": "Ribesalbes"
	    },
	    {
	        "id": 4074,
	        "name": "Villar del Pozo"
	    },
	    {
	        "id": 4075,
	        "name": "Graja de Campalbo"
	    },
	    {
	        "id": 4076,
	        "name": "Lloret de Mar"
	    },
	    {
	        "id": 4077,
	        "name": "Güevéjar"
	    },
	    {
	        "id": 4078,
	        "name": "Condemios de Abajo"
	    },
	    {
	        "id": 4079,
	        "name": "Chía"
	    },
	    {
	        "id": 4080,
	        "name": "Villacarrillo"
	    },
	    {
	        "id": 4081,
	        "name": "Mansilla Mayor"
	    },
	    {
	        "id": 4082,
	        "name": "Matute"
	    },
	    {
	        "id": 4083,
	        "name": "Navalagamella"
	    },
	    {
	        "id": 4084,
	        "name": "Villanueva de Algaidas"
	    },
	    {
	        "id": 4085,
	        "name": "Esparza de Salazar/Espartza Zaraitzu"
	    },
	    {
	        "id": 4086,
	        "name": "Val de San Vicente"
	    },
	    {
	        "id": 4087,
	        "name": "Gomezserracín"
	    },
	    {
	        "id": 4088,
	        "name": "Utrera"
	    },
	    {
	        "id": 4089,
	        "name": "Golmayo"
	    },
	    {
	        "id": 4090,
	        "name": "El Morell"
	    },
	    {
	        "id": 4091,
	        "name": "La Mata"
	    },
	    {
	        "id": 4092,
	        "name": "Caudete de las Fuentes"
	    },
	    {
	        "id": 4093,
	        "name": "Moraleja de las Panaderas"
	    },
	    {
	        "id": 4094,
	        "name": "Zaldibar"
	    },
	    {
	        "id": 4095,
	        "name": "La Hiniesta"
	    },
	    {
	        "id": 4096,
	        "name": "Ejea de los Caballeros"
	    },
	    {
	        "id": 4097,
	        "name": "Onil"
	    },
	    {
	        "id": 4098,
	        "name": "Urrácal"
	    },
	    {
	        "id": 4099,
	        "name": "La Hija de Dios"
	    },
	    {
	        "id": 4100,
	        "name": "Orellana de la Sierra"
	    },
	    {
	        "id": 4101,
	        "name": "Granollers"
	    },
	    {
	        "id": 4102,
	        "name": "Hervás"
	    },
	    {
	        "id": 4103,
	        "name": "Rossell"
	    },
	    {
	        "id": 4104,
	        "name": "Villarrubia de los Ojos"
	    },
	    {
	        "id": 4105,
	        "name": "Graja de Iniesta"
	    },
	    {
	        "id": 4106,
	        "name": "Les Llosses"
	    },
	    {
	        "id": 4107,
	        "name": "Huélago"
	    },
	    {
	        "id": 4108,
	        "name": "Condemios de Arriba"
	    },
	    {
	        "id": 4109,
	        "name": "Chimillas"
	    },
	    {
	        "id": 4110,
	        "name": "Villanueva de la Reina"
	    },
	    {
	        "id": 4111,
	        "name": "Maraña"
	    },
	    {
	        "id": 4112,
	        "name": "La Fuliola"
	    },
	    {
	        "id": 4113,
	        "name": "Medrano"
	    },
	    {
	        "id": 4114,
	        "name": "Navalcarnero"
	    },
	    {
	        "id": 4115,
	        "name": "Villanueva del Rosario"
	    },
	    {
	        "id": 4116,
	        "name": "Espronceda"
	    },
	    {
	        "id": 4117,
	        "name": "Lomas"
	    },
	    {
	        "id": 4118,
	        "name": "Castillejo de Martín Viejo"
	    },
	    {
	        "id": 4119,
	        "name": "Vega de Liébana"
	    },
	    {
	        "id": 4120,
	        "name": "Valencina de la Concepción"
	    },
	    {
	        "id": 4121,
	        "name": "Gómara"
	    },
	    {
	        "id": 4122,
	        "name": "La Morera de Montsant"
	    },
	    {
	        "id": 4123,
	        "name": "Ejulve"
	    },
	    {
	        "id": 4124,
	        "name": "Mazarambroz"
	    },
	    {
	        "id": 4125,
	        "name": "Cerdà"
	    },
	    {
	        "id": 4126,
	        "name": "Morales de Campos"
	    },
	    {
	        "id": 4127,
	        "name": "Zalla"
	    },
	    {
	        "id": 4128,
	        "name": "Jambrina"
	    },
	    {
	        "id": 4129,
	        "name": "Embid de Ariza"
	    },
	    {
	        "id": 4130,
	        "name": "Orba"
	    },
	    {
	        "id": 4131,
	        "name": "Velefique"
	    },
	    {
	        "id": 4132,
	        "name": "La Horcajada"
	    },
	    {
	        "id": 4133,
	        "name": "Orellana la Vieja"
	    },
	    {
	        "id": 4134,
	        "name": "Gualba"
	    },
	    {
	        "id": 4135,
	        "name": "Higuera"
	    },
	    {
	        "id": 4136,
	        "name": "Sacañet"
	    },
	    {
	        "id": 4137,
	        "name": "Villarta de San Juan"
	    },
	    {
	        "id": 4138,
	        "name": "Henarejos"
	    },
	    {
	        "id": 4139,
	        "name": "Madremanya"
	    },
	    {
	        "id": 4140,
	        "name": "Huéneja"
	    },
	    {
	        "id": 4141,
	        "name": "Congostrina"
	    },
	    {
	        "id": 4142,
	        "name": "Villanueva del Arzobispo"
	    },
	    {
	        "id": 4143,
	        "name": "Matadeón de los Oteros"
	    },
	    {
	        "id": 4144,
	        "name": "Fulleda"
	    },
	    {
	        "id": 4145,
	        "name": "Navarredonda y San Mamés"
	    },
	    {
	        "id": 4146,
	        "name": "Villanueva del Trabuco"
	    },
	    {
	        "id": 4147,
	        "name": "Estella-Lizarra"
	    },
	    {
	        "id": 4148,
	        "name": "Castraz"
	    },
	    {
	        "id": 4149,
	        "name": "Vega de Pas"
	    },
	    {
	        "id": 4150,
	        "name": "Grajera"
	    },
	    {
	        "id": 4151,
	        "name": "Villamanrique de la Condesa"
	    },
	    {
	        "id": 4152,
	        "name": "Gormaz"
	    },
	    {
	        "id": 4153,
	        "name": "La Nou de Gaià"
	    },
	    {
	        "id": 4154,
	        "name": "Escorihuela"
	    },
	    {
	        "id": 4155,
	        "name": "Mejorada"
	    },
	    {
	        "id": 4156,
	        "name": "Cofrentes"
	    },
	    {
	        "id": 4157,
	        "name": "Mota del Marqués"
	    },
	    {
	        "id": 4158,
	        "name": "Zaratamo"
	    },
	    {
	        "id": 4159,
	        "name": "Justel"
	    },
	    {
	        "id": 4160,
	        "name": "Orxeta"
	    },
	    {
	        "id": 4161,
	        "name": "Vélez-Blanco"
	    },
	    {
	        "id": 4162,
	        "name": "Palomas"
	    },
	    {
	        "id": 4163,
	        "name": "Sant Salvador de Guardiola"
	    },
	    {
	        "id": 4164,
	        "name": "Cerezo de Río Tirón"
	    },
	    {
	        "id": 4165,
	        "name": "Hinojal"
	    },
	    {
	        "id": 4166,
	        "name": "la Salzadella"
	    },
	    {
	        "id": 4167,
	        "name": "Viso del Marqués"
	    },
	    {
	        "id": 4168,
	        "name": "El Herrumblar"
	    },
	    {
	        "id": 4169,
	        "name": "Maià de Montcal"
	    },
	    {
	        "id": 4170,
	        "name": "Huéscar"
	    },
	    {
	        "id": 4171,
	        "name": "Copernal"
	    },
	    {
	        "id": 4172,
	        "name": "Villardompardo"
	    },
	    {
	        "id": 4173,
	        "name": "Matallana de Torío"
	    },
	    {
	        "id": 4174,
	        "name": "Gavet de la Conca"
	    },
	    {
	        "id": 4175,
	        "name": "Munilla"
	    },
	    {
	        "id": 4176,
	        "name": "Villanueva de Tapia"
	    },
	    {
	        "id": 4177,
	        "name": "Esteribar"
	    },
	    {
	        "id": 4178,
	        "name": "Magaz de Pisuerga"
	    },
	    {
	        "id": 4179,
	        "name": "Cepeda"
	    },
	    {
	        "id": 4180,
	        "name": "Villacarriedo"
	    },
	    {
	        "id": 4181,
	        "name": "Villanueva del Ariscal"
	    },
	    {
	        "id": 4182,
	        "name": "Herrera de Soria"
	    },
	    {
	        "id": 4183,
	        "name": "Nulles"
	    },
	    {
	        "id": 4184,
	        "name": "Menasalbas"
	    },
	    {
	        "id": 4185,
	        "name": "Corbera"
	    },
	    {
	        "id": 4186,
	        "name": "Mucientes"
	    },
	    {
	        "id": 4187,
	        "name": "Losacino"
	    },
	    {
	        "id": 4188,
	        "name": "Encinacorba"
	    },
	    {
	        "id": 4189,
	        "name": "Orihuela"
	    },
	    {
	        "id": 4190,
	        "name": "Vélez-Rubio"
	    },
	    {
	        "id": 4191,
	        "name": "Horcajo de las Torres"
	    },
	    {
	        "id": 4192,
	        "name": "La Parra"
	    },
	    {
	        "id": 4193,
	        "name": "Guardiola de Berguedà"
	    },
	    {
	        "id": 4194,
	        "name": "Holguera"
	    },
	    {
	        "id": 4195,
	        "name": "Sant Jordi/San Jorge"
	    },
	    {
	        "id": 4196,
	        "name": "La Hinojosa"
	    },
	    {
	        "id": 4197,
	        "name": "Meranges"
	    },
	    {
	        "id": 4198,
	        "name": "Huétor de Santillán"
	    },
	    {
	        "id": 4199,
	        "name": "Corduente"
	    },
	    {
	        "id": 4200,
	        "name": "Esplús"
	    },
	    {
	        "id": 4201,
	        "name": "Los Villares"
	    },
	    {
	        "id": 4202,
	        "name": "Matanza"
	    },
	    {
	        "id": 4203,
	        "name": "Golmés"
	    },
	    {
	        "id": 4204,
	        "name": "Murillo de Río Leza"
	    },
	    {
	        "id": 4205,
	        "name": "Navas del Rey"
	    },
	    {
	        "id": 4206,
	        "name": "Viñuela"
	    },
	    {
	        "id": 4207,
	        "name": "Etayo"
	    },
	    {
	        "id": 4208,
	        "name": "Manquillos"
	    },
	    {
	        "id": 4209,
	        "name": "Cereceda de la Sierra"
	    },
	    {
	        "id": 4210,
	        "name": "Villaescusa"
	    },
	    {
	        "id": 4211,
	        "name": "Honrubia de la Cuesta"
	    },
	    {
	        "id": 4212,
	        "name": "Villanueva del Río y Minas"
	    },
	    {
	        "id": 4213,
	        "name": "La Palma d'Ebre"
	    },
	    {
	        "id": 4214,
	        "name": "Escucha"
	    },
	    {
	        "id": 4215,
	        "name": "Méntrida"
	    },
	    {
	        "id": 4216,
	        "name": "Cortes de Pallás"
	    },
	    {
	        "id": 4217,
	        "name": "La Mudarra"
	    },
	    {
	        "id": 4218,
	        "name": "Losacio"
	    },
	    {
	        "id": 4219,
	        "name": "Épila"
	    },
	    {
	        "id": 4220,
	        "name": "Parcent"
	    },
	    {
	        "id": 4221,
	        "name": "Vera"
	    },
	    {
	        "id": 4222,
	        "name": "El Hornillo"
	    },
	    {
	        "id": 4223,
	        "name": "Peñalsordo"
	    },
	    {
	        "id": 4224,
	        "name": "Gurb"
	    },
	    {
	        "id": 4225,
	        "name": "Cerratón de Juarros"
	    },
	    {
	        "id": 4226,
	        "name": "Hoyos"
	    },
	    {
	        "id": 4227,
	        "name": "Sant Mateu"
	    },
	    {
	        "id": 4228,
	        "name": "Los Hinojosos"
	    },
	    {
	        "id": 4229,
	        "name": "Masarac"
	    },
	    {
	        "id": 4230,
	        "name": "Huétor Tájar"
	    },
	    {
	        "id": 4231,
	        "name": "Molinaseca"
	    },
	    {
	        "id": 4232,
	        "name": "Gósol"
	    },
	    {
	        "id": 4233,
	        "name": "Muro de Aguas"
	    },
	    {
	        "id": 4234,
	        "name": "Nuevo Baztán"
	    },
	    {
	        "id": 4235,
	        "name": "Yunquera"
	    },
	    {
	        "id": 4236,
	        "name": "Eulate"
	    },
	    {
	        "id": 4237,
	        "name": "Mantinos"
	    },
	    {
	        "id": 4238,
	        "name": "Cerezal de Peñahorcada"
	    },
	    {
	        "id": 4239,
	        "name": "Villafufre"
	    },
	    {
	        "id": 4240,
	        "name": "Hontalbilla"
	    },
	    {
	        "id": 4241,
	        "name": "Villanueva de San Juan"
	    },
	    {
	        "id": 4242,
	        "name": "Hinojosa del Campo"
	    },
	    {
	        "id": 4243,
	        "name": "Els Pallaresos"
	    },
	    {
	        "id": 4244,
	        "name": "Estercuel"
	    },
	    {
	        "id": 4245,
	        "name": "Mesegar de Tajo"
	    },
	    {
	        "id": 4246,
	        "name": "Cotes"
	    },
	    {
	        "id": 4247,
	        "name": "Muriel"
	    },
	    {
	        "id": 4248,
	        "name": "Lubián"
	    },
	    {
	        "id": 4249,
	        "name": "Erla"
	    },
	    {
	        "id": 4250,
	        "name": "Pedreguer"
	    },
	    {
	        "id": 4251,
	        "name": "Viator"
	    },
	    {
	        "id": 4252,
	        "name": "Hoyocasero"
	    },
	    {
	        "id": 4253,
	        "name": "Peraleda del Zaucejo"
	    },
	    {
	        "id": 4254,
	        "name": "L'Hospitalet de Llobregat"
	    },
	    {
	        "id": 4255,
	        "name": "Ciadoncha"
	    },
	    {
	        "id": 4256,
	        "name": "Huélaga"
	    },
	    {
	        "id": 4257,
	        "name": "San Rafael del Río"
	    },
	    {
	        "id": 4258,
	        "name": "El Hito"
	    },
	    {
	        "id": 4259,
	        "name": "Massanes"
	    },
	    {
	        "id": 4260,
	        "name": "Huétor Vega"
	    },
	    {
	        "id": 4261,
	        "name": "Villarrodrigo"
	    },
	    {
	        "id": 4262,
	        "name": "Murias de Paredes"
	    },
	    {
	        "id": 4263,
	        "name": "La Granadella"
	    },
	    {
	        "id": 4264,
	        "name": "Muro en Cameros"
	    },
	    {
	        "id": 4265,
	        "name": "Olmeda de las Fuentes"
	    },
	    {
	        "id": 4266,
	        "name": "Ezcabarte"
	    },
	    {
	        "id": 4267,
	        "name": "Marcilla de Campos"
	    },
	    {
	        "id": 4268,
	        "name": "Cerralbo"
	    },
	    {
	        "id": 4269,
	        "name": "Valle de Villaverde"
	    },
	    {
	        "id": 4270,
	        "name": "Hontanares de Eresma"
	    },
	    {
	        "id": 4271,
	        "name": "Villaverde del Río"
	    },
	    {
	        "id": 4272,
	        "name": "Passanant i Belltall"
	    },
	    {
	        "id": 4273,
	        "name": "Ferreruela de Huerva"
	    },
	    {
	        "id": 4274,
	        "name": "Miguel Esteban"
	    },
	    {
	        "id": 4275,
	        "name": "Quart de les Valls"
	    },
	    {
	        "id": 4276,
	        "name": "Nava del Rey"
	    },
	    {
	        "id": 4277,
	        "name": "Luelmo"
	    },
	    {
	        "id": 4278,
	        "name": "Escatrón"
	    },
	    {
	        "id": 4279,
	        "name": "Pego"
	    },
	    {
	        "id": 4280,
	        "name": "Vícar"
	    },
	    {
	        "id": 4281,
	        "name": "El Hoyo de Pinares"
	    },
	    {
	        "id": 4282,
	        "name": "Puebla de Alcocer"
	    },
	    {
	        "id": 4283,
	        "name": "Igualada"
	    },
	    {
	        "id": 4284,
	        "name": "Cillaperlata"
	    },
	    {
	        "id": 4285,
	        "name": "Ibahernando"
	    },
	    {
	        "id": 4286,
	        "name": "Santa Magdalena de Pulpis"
	    },
	    {
	        "id": 4287,
	        "name": "Honrubia"
	    },
	    {
	        "id": 4288,
	        "name": "Maçanet de Cabrenys"
	    },
	    {
	        "id": 4289,
	        "name": "Illora"
	    },
	    {
	        "id": 4290,
	        "name": "El Cubillo de Uceda"
	    },
	    {
	        "id": 4291,
	        "name": "Estada"
	    },
	    {
	        "id": 4292,
	        "name": "Noceda del Bierzo"
	    },
	    {
	        "id": 4293,
	        "name": "La Granja d'Escarp"
	    },
	    {
	        "id": 4294,
	        "name": "Nájera"
	    },
	    {
	        "id": 4295,
	        "name": "Orusco de Tajuña"
	    },
	    {
	        "id": 4296,
	        "name": "Ezkurra"
	    },
	    {
	        "id": 4297,
	        "name": "Mazariegos"
	    },
	    {
	        "id": 4298,
	        "name": "El Cerro"
	    },
	    {
	        "id": 4299,
	        "name": "Voto"
	    },
	    {
	        "id": 4300,
	        "name": "El Viso del Alcor"
	    },
	    {
	        "id": 4301,
	        "name": "Paüls"
	    },
	    {
	        "id": 4302,
	        "name": "Fonfría"
	    },
	    {
	        "id": 4303,
	        "name": "Mocejón"
	    },
	    {
	        "id": 4304,
	        "name": "Quart de Poblet"
	    },
	    {
	        "id": 4305,
	        "name": "Nueva Villa de las Torres"
	    },
	    {
	        "id": 4306,
	        "name": "El Maderal"
	    },
	    {
	        "id": 4307,
	        "name": "Fabara"
	    },
	    {
	        "id": 4308,
	        "name": "Penàguila"
	    },
	    {
	        "id": 4309,
	        "name": "Zurgena"
	    },
	    {
	        "id": 4310,
	        "name": "Hoyorredondo"
	    },
	    {
	        "id": 4311,
	        "name": "Puebla de la Calzada"
	    },
	    {
	        "id": 4312,
	        "name": "Jorba"
	    },
	    {
	        "id": 4313,
	        "name": "Cilleruelo de Abajo"
	    },
	    {
	        "id": 4314,
	        "name": "Jaraicejo"
	    },
	    {
	        "id": 4315,
	        "name": "Sarratella"
	    },
	    {
	        "id": 4316,
	        "name": "Hontanaya"
	    },
	    {
	        "id": 4317,
	        "name": "Maçanet de la Selva"
	    },
	    {
	        "id": 4318,
	        "name": "Itrabo"
	    },
	    {
	        "id": 4319,
	        "name": "Checa"
	    },
	    {
	        "id": 4320,
	        "name": "Estadilla"
	    },
	    {
	        "id": 4321,
	        "name": "Oencia"
	    },
	    {
	        "id": 4322,
	        "name": "Granyanella"
	    },
	    {
	        "id": 4323,
	        "name": "Nalda"
	    },
	    {
	        "id": 4324,
	        "name": "Ezprogui"
	    },
	    {
	        "id": 4325,
	        "name": "Mazuecos de Valdeginate"
	    },
	    {
	        "id": 4326,
	        "name": "Cespedosa de Tormes"
	    },
	    {
	        "id": 4327,
	        "name": "Los Huertos"
	    },
	    {
	        "id": 4328,
	        "name": "Langa de Duero"
	    },
	    {
	        "id": 4329,
	        "name": "Perafort"
	    },
	    {
	        "id": 4330,
	        "name": "Formiche Alto"
	    },
	    {
	        "id": 4331,
	        "name": "Mohedas de la Jara"
	    },
	    {
	        "id": 4332,
	        "name": "Quartell"
	    },
	    {
	        "id": 4333,
	        "name": "Olivares de Duero"
	    },
	    {
	        "id": 4334,
	        "name": "Madridanos"
	    },
	    {
	        "id": 4335,
	        "name": "Petrer"
	    },
	    {
	        "id": 4336,
	        "name": "Hoyos del Collado"
	    },
	    {
	        "id": 4337,
	        "name": "Puebla de la Reina"
	    },
	    {
	        "id": 4338,
	        "name": "La Llacuna"
	    },
	    {
	        "id": 4339,
	        "name": "Cilleruelo de Arriba"
	    },
	    {
	        "id": 4340,
	        "name": "Jaraíz de la Vera"
	    },
	    {
	        "id": 4341,
	        "name": "Segorbe"
	    },
	    {
	        "id": 4342,
	        "name": "Hontecillas"
	    },
	    {
	        "id": 4343,
	        "name": "Chequilla"
	    },
	    {
	        "id": 4344,
	        "name": "Las Omañas"
	    },
	    {
	        "id": 4345,
	        "name": "Granyena de Segarra"
	    },
	    {
	        "id": 4346,
	        "name": "Navajún"
	    },
	    {
	        "id": 4347,
	        "name": "Paracuellos de Jarama"
	    },
	    {
	        "id": 4348,
	        "name": "Falces"
	    },
	    {
	        "id": 4349,
	        "name": "Melgar de Yuso"
	    },
	    {
	        "id": 4350,
	        "name": "Cilleros de la Bastida"
	    },
	    {
	        "id": 4351,
	        "name": "Ituero y Lama"
	    },
	    {
	        "id": 4352,
	        "name": "El Perelló"
	    },
	    {
	        "id": 4353,
	        "name": "Montearagón"
	    },
	    {
	        "id": 4354,
	        "name": "Quatretonda"
	    },
	    {
	        "id": 4355,
	        "name": "Olmedo"
	    },
	    {
	        "id": 4356,
	        "name": "Mahide"
	    },
	    {
	        "id": 4357,
	        "name": "Farlete"
	    },
	    {
	        "id": 4358,
	        "name": "el/Pinoso Pinós"
	    },
	    {
	        "id": 4359,
	        "name": "Hoyos del Espino"
	    },
	    {
	        "id": 4360,
	        "name": "Puebla del Maestre"
	    },
	    {
	        "id": 4361,
	        "name": "La Llagosta"
	    },
	    {
	        "id": 4362,
	        "name": "Ciruelos de Cervera"
	    },
	    {
	        "id": 4363,
	        "name": "Jarandilla de la Vera"
	    },
	    {
	        "id": 4364,
	        "name": "Sierra Engarcerán"
	    },
	    {
	        "id": 4365,
	        "name": "Mieres"
	    },
	    {
	        "id": 4366,
	        "name": "Iznalloz"
	    },
	    {
	        "id": 4367,
	        "name": "Chiloeches"
	    },
	    {
	        "id": 4368,
	        "name": "Estopiñán del Castillo"
	    },
	    {
	        "id": 4369,
	        "name": "Onzonilla"
	    },
	    {
	        "id": 4370,
	        "name": "Granyena de les Garrigues"
	    },
	    {
	        "id": 4371,
	        "name": "Navarrete"
	    },
	    {
	        "id": 4372,
	        "name": "Fitero"
	    },
	    {
	        "id": 4373,
	        "name": "Juarros de Riomoros"
	    },
	    {
	        "id": 4374,
	        "name": "Liceras"
	    },
	    {
	        "id": 4375,
	        "name": "Les Piles"
	    },
	    {
	        "id": 4376,
	        "name": "Fórnoles"
	    },
	    {
	        "id": 4377,
	        "name": "Montesclaros"
	    },
	    {
	        "id": 4378,
	        "name": "Cullera"
	    },
	    {
	        "id": 4379,
	        "name": "Olmos de Esgueva"
	    },
	    {
	        "id": 4380,
	        "name": "Maire de Castroponce"
	    },
	    {
	        "id": 4381,
	        "name": "Fayón"
	    },
	    {
	        "id": 4382,
	        "name": "Planes"
	    },
	    {
	        "id": 4383,
	        "name": "Hoyos de Miguel Muñoz"
	    },
	    {
	        "id": 4384,
	        "name": "Puebla del Prior"
	    },
	    {
	        "id": 4385,
	        "name": "Llinars del Vallès"
	    },
	    {
	        "id": 4386,
	        "name": "Jarilla"
	    },
	    {
	        "id": 4387,
	        "name": "Soneja"
	    },
	    {
	        "id": 4388,
	        "name": "Horcajo de Santiago"
	    },
	    {
	        "id": 4389,
	        "name": "Mollet de Peralada"
	    },
	    {
	        "id": 4390,
	        "name": "Chillarón del Rey"
	    },
	    {
	        "id": 4391,
	        "name": "Fago"
	    },
	    {
	        "id": 4392,
	        "name": "Oseja de Sajambre"
	    },
	    {
	        "id": 4393,
	        "name": "Nestares"
	    },
	    {
	        "id": 4394,
	        "name": "Parla"
	    },
	    {
	        "id": 4395,
	        "name": "Fontellas"
	    },
	    {
	        "id": 4396,
	        "name": "Meneses de Campos"
	    },
	    {
	        "id": 4397,
	        "name": "Cipérez"
	    },
	    {
	        "id": 4398,
	        "name": "Juarros de Voltoya"
	    },
	    {
	        "id": 4399,
	        "name": "La Losilla"
	    },
	    {
	        "id": 4400,
	        "name": "El Pinell de Brai"
	    },
	    {
	        "id": 4401,
	        "name": "Fortanete"
	    },
	    {
	        "id": 4402,
	        "name": "Mora"
	    },
	    {
	        "id": 4403,
	        "name": "Chelva"
	    },
	    {
	        "id": 4404,
	        "name": "Olmos de Peñafiel"
	    },
	    {
	        "id": 4405,
	        "name": "Los Fayos"
	    },
	    {
	        "id": 4406,
	        "name": "Polop"
	    },
	    {
	        "id": 4407,
	        "name": "Hurtumpascual"
	    },
	    {
	        "id": 4408,
	        "name": "Puebla de Obando"
	    },
	    {
	        "id": 4409,
	        "name": "Lliçà d'Amunt"
	    },
	    {
	        "id": 4410,
	        "name": "Jerte"
	    },
	    {
	        "id": 4411,
	        "name": "Sot de Ferrer"
	    },
	    {
	        "id": 4412,
	        "name": "Huélamo"
	    },
	    {
	        "id": 4413,
	        "name": "Molló"
	    },
	    {
	        "id": 4414,
	        "name": "Jayena"
	    },
	    {
	        "id": 4415,
	        "name": "Driebes"
	    },
	    {
	        "id": 4416,
	        "name": "Fanlo"
	    },
	    {
	        "id": 4417,
	        "name": "Pajares de los Oteros"
	    },
	    {
	        "id": 4418,
	        "name": "Nieva de Cameros"
	    },
	    {
	        "id": 4419,
	        "name": "Patones"
	    },
	    {
	        "id": 4420,
	        "name": "Funes"
	    },
	    {
	        "id": 4421,
	        "name": "Micieces de Ojeda"
	    },
	    {
	        "id": 4422,
	        "name": "Ciudad Rodrigo"
	    },
	    {
	        "id": 4423,
	        "name": "Labajos"
	    },
	    {
	        "id": 4424,
	        "name": "Magaña"
	    },
	    {
	        "id": 4425,
	        "name": "Pira"
	    },
	    {
	        "id": 4426,
	        "name": "Foz-Calanda"
	    },
	    {
	        "id": 4427,
	        "name": "Nambroca"
	    },
	    {
	        "id": 4428,
	        "name": "Chella"
	    },
	    {
	        "id": 4429,
	        "name": "Malva"
	    },
	    {
	        "id": 4430,
	        "name": "Figueruelas"
	    },
	    {
	        "id": 4431,
	        "name": "Junciana"
	    },
	    {
	        "id": 4432,
	        "name": "Puebla de Sancho Pérez"
	    },
	    {
	        "id": 4433,
	        "name": "Lliçà de Vall"
	    },
	    {
	        "id": 4434,
	        "name": "Cogollos"
	    },
	    {
	        "id": 4435,
	        "name": "Ladrillar"
	    },
	    {
	        "id": 4436,
	        "name": "Sueras/Suera"
	    },
	    {
	        "id": 4437,
	        "name": "Huelves"
	    },
	    {
	        "id": 4438,
	        "name": "Jerez del Marquesado"
	    },
	    {
	        "id": 4439,
	        "name": "Durón"
	    },
	    {
	        "id": 4440,
	        "name": "Palacios de la Valduerna"
	    },
	    {
	        "id": 4441,
	        "name": "Ocón"
	    },
	    {
	        "id": 4442,
	        "name": "Pedrezuela"
	    },
	    {
	        "id": 4443,
	        "name": "Fustiñana"
	    },
	    {
	        "id": 4444,
	        "name": "Monzón de Campos"
	    },
	    {
	        "id": 4445,
	        "name": "Coca de Alba"
	    },
	    {
	        "id": 4446,
	        "name": "Laguna de Contreras"
	    },
	    {
	        "id": 4447,
	        "name": "Maján"
	    },
	    {
	        "id": 4448,
	        "name": "El Pla de Santa Maria"
	    },
	    {
	        "id": 4449,
	        "name": "La Fresneda"
	    },
	    {
	        "id": 4450,
	        "name": "La Nava de Ricomalillo"
	    },
	    {
	        "id": 4451,
	        "name": "Chera"
	    },
	    {
	        "id": 4452,
	        "name": "Manganeses de la Lampreana"
	    },
	    {
	        "id": 4453,
	        "name": "Fombuena"
	    },
	    {
	        "id": 4454,
	        "name": "Rafal"
	    },
	    {
	        "id": 4455,
	        "name": "Langa"
	    },
	    {
	        "id": 4456,
	        "name": "Quintana de la Serena"
	    },
	    {
	        "id": 4457,
	        "name": "Lluçà"
	    },
	    {
	        "id": 4458,
	        "name": "Condado de Treviño"
	    },
	    {
	        "id": 4459,
	        "name": "Logrosán"
	    },
	    {
	        "id": 4460,
	        "name": "Tales"
	    },
	    {
	        "id": 4461,
	        "name": "Huérguina"
	    },
	    {
	        "id": 4462,
	        "name": "Montagut i Oix"
	    },
	    {
	        "id": 4463,
	        "name": "Jete"
	    },
	    {
	        "id": 4464,
	        "name": "Embid"
	    },
	    {
	        "id": 4465,
	        "name": "Fiscal"
	    },
	    {
	        "id": 4466,
	        "name": "Palacios del Sil"
	    },
	    {
	        "id": 4467,
	        "name": "Guimerà"
	    },
	    {
	        "id": 4468,
	        "name": "Ochánduri"
	    },
	    {
	        "id": 4469,
	        "name": "Pelayos de la Presa"
	    },
	    {
	        "id": 4470,
	        "name": "Galar"
	    },
	    {
	        "id": 4471,
	        "name": "Moratinos"
	    },
	    {
	        "id": 4472,
	        "name": "Colmenar de Montemayor"
	    },
	    {
	        "id": 4473,
	        "name": "Languilla"
	    },
	    {
	        "id": 4474,
	        "name": "La Pobla de Mafumet"
	    },
	    {
	        "id": 4475,
	        "name": "Frías de Albarracín"
	    },
	    {
	        "id": 4476,
	        "name": "Navahermosa"
	    },
	    {
	        "id": 4477,
	        "name": "Cheste"
	    },
	    {
	        "id": 4478,
	        "name": "Palazuelo de Vedija"
	    },
	    {
	        "id": 4479,
	        "name": "Manganeses de la Polvorosa"
	    },
	    {
	        "id": 4480,
	        "name": "El Frago"
	    },
	    {
	        "id": 4481,
	        "name": "El Ràfol d'Almúnia"
	    },
	    {
	        "id": 4482,
	        "name": "Lanzahíta"
	    },
	    {
	        "id": 4483,
	        "name": "Reina"
	    },
	    {
	        "id": 4484,
	        "name": "Malgrat de Mar"
	    },
	    {
	        "id": 4485,
	        "name": "Contreras"
	    },
	    {
	        "id": 4486,
	        "name": "Losar de la Vera"
	    },
	    {
	        "id": 4487,
	        "name": "Teresa"
	    },
	    {
	        "id": 4488,
	        "name": "Huerta de la Obispalía"
	    },
	    {
	        "id": 4489,
	        "name": "Mont-ras"
	    },
	    {
	        "id": 4490,
	        "name": "Escamilla"
	    },
	    {
	        "id": 4491,
	        "name": "Fonz"
	    },
	    {
	        "id": 4492,
	        "name": "Páramo del Sil"
	    },
	    {
	        "id": 4493,
	        "name": "Guissona"
	    },
	    {
	        "id": 4494,
	        "name": "Ojacastro"
	    },
	    {
	        "id": 4495,
	        "name": "Perales de Tajuña"
	    },
	    {
	        "id": 4496,
	        "name": "Gallipienzo/Galipentzu"
	    },
	    {
	        "id": 4497,
	        "name": "Mudá"
	    },
	    {
	        "id": 4498,
	        "name": "Cordovilla"
	    },
	    {
	        "id": 4499,
	        "name": "Lastras de Cuéllar"
	    },
	    {
	        "id": 4500,
	        "name": "Matalebreras"
	    },
	    {
	        "id": 4501,
	        "name": "La Pobla de Massaluca"
	    },
	    {
	        "id": 4502,
	        "name": "Fuenferrada"
	    },
	    {
	        "id": 4503,
	        "name": "Navalcán"
	    },
	    {
	        "id": 4504,
	        "name": "Xirivella"
	    },
	    {
	        "id": 4505,
	        "name": "La Parrilla"
	    },
	    {
	        "id": 4506,
	        "name": "Manzanal de Arriba"
	    },
	    {
	        "id": 4507,
	        "name": "El Frasno"
	    },
	    {
	        "id": 4508,
	        "name": "Redován"
	    },
	    {
	        "id": 4509,
	        "name": "Rena"
	    },
	    {
	        "id": 4510,
	        "name": "Malla"
	    },
	    {
	        "id": 4511,
	        "name": "Madrigal de la Vera"
	    },
	    {
	        "id": 4512,
	        "name": "Tírig"
	    },
	    {
	        "id": 4513,
	        "name": "Huerta del Marquesado"
	    },
	    {
	        "id": 4514,
	        "name": "Navata"
	    },
	    {
	        "id": 4515,
	        "name": "Jun"
	    },
	    {
	        "id": 4516,
	        "name": "Escariche"
	    },
	    {
	        "id": 4517,
	        "name": "Foradada del Toscar"
	    },
	    {
	        "id": 4518,
	        "name": "Guixers"
	    },
	    {
	        "id": 4519,
	        "name": "Ollauri"
	    },
	    {
	        "id": 4520,
	        "name": "Pezuela de las Torres"
	    },
	    {
	        "id": 4521,
	        "name": "Gallués/Galoze"
	    },
	    {
	        "id": 4522,
	        "name": "Lastras del Pozo"
	    },
	    {
	        "id": 4523,
	        "name": "Matamala de Almazán"
	    },
	    {
	        "id": 4524,
	        "name": "La Pobla de Montornès"
	    },
	    {
	        "id": 4525,
	        "name": "Fuentes Calientes"
	    },
	    {
	        "id": 4526,
	        "name": "Navalmoralejo"
	    },
	    {
	        "id": 4527,
	        "name": "Chiva"
	    },
	    {
	        "id": 4528,
	        "name": "La Pedraja de Portillo"
	    },
	    {
	        "id": 4529,
	        "name": "Manzanal del Barco"
	    },
	    {
	        "id": 4530,
	        "name": "Fréscano"
	    },
	    {
	        "id": 4531,
	        "name": "Relleu"
	    },
	    {
	        "id": 4532,
	        "name": "El Losar del Barco"
	    },
	    {
	        "id": 4533,
	        "name": "Retamal de Llerena"
	    },
	    {
	        "id": 4534,
	        "name": "Manlleu"
	    },
	    {
	        "id": 4535,
	        "name": "Coruña del Conde"
	    },
	    {
	        "id": 4536,
	        "name": "Madrigalejo"
	    },
	    {
	        "id": 4537,
	        "name": "Todolella"
	    },
	    {
	        "id": 4538,
	        "name": "Huete"
	    },
	    {
	        "id": 4539,
	        "name": "Ogassa"
	    },
	    {
	        "id": 4540,
	        "name": "Juviles"
	    },
	    {
	        "id": 4541,
	        "name": "Escopete"
	    },
	    {
	        "id": 4542,
	        "name": "Fraga"
	    },
	    {
	        "id": 4543,
	        "name": "Peranzanes"
	    },
	    {
	        "id": 4544,
	        "name": "Ivars de Noguera"
	    },
	    {
	        "id": 4545,
	        "name": "Ortigosa de Cameros"
	    },
	    {
	        "id": 4546,
	        "name": "Pinilla del Valle"
	    },
	    {
	        "id": 4547,
	        "name": "Garaioa"
	    },
	    {
	        "id": 4548,
	        "name": "Nogal de las Huertas"
	    },
	    {
	        "id": 4549,
	        "name": "Cristóbal"
	    },
	    {
	        "id": 4550,
	        "name": "La Lastrilla"
	    },
	    {
	        "id": 4551,
	        "name": "Poboleda"
	    },
	    {
	        "id": 4552,
	        "name": "Fuentes Claras"
	    },
	    {
	        "id": 4553,
	        "name": "Los Navalmorales"
	    },
	    {
	        "id": 4554,
	        "name": "Chulilla"
	    },
	    {
	        "id": 4555,
	        "name": "Pedrajas de San Esteban"
	    },
	    {
	        "id": 4556,
	        "name": "Manzanal de los Infantes"
	    },
	    {
	        "id": 4557,
	        "name": "Rojales"
	    },
	    {
	        "id": 4558,
	        "name": "Los Llanos de Tormes"
	    },
	    {
	        "id": 4559,
	        "name": "Ribera del Fresno"
	    },
	    {
	        "id": 4560,
	        "name": "Manresa"
	    },
	    {
	        "id": 4561,
	        "name": "Covarrubias"
	    },
	    {
	        "id": 4562,
	        "name": "Madroñera"
	    },
	    {
	        "id": 4563,
	        "name": "Toga"
	    },
	    {
	        "id": 4564,
	        "name": "Iniesta"
	    },
	    {
	        "id": 4565,
	        "name": "Espinosa de Henares"
	    },
	    {
	        "id": 4566,
	        "name": "La Fueva"
	    },
	    {
	        "id": 4567,
	        "name": "Pobladura de Pelayo García"
	    },
	    {
	        "id": 4568,
	        "name": "Ivars d'Urgell"
	    },
	    {
	        "id": 4569,
	        "name": "Pazuengos"
	    },
	    {
	        "id": 4570,
	        "name": "Pinto"
	    },
	    {
	        "id": 4571,
	        "name": "Garde"
	    },
	    {
	        "id": 4572,
	        "name": "Olea de Boedo"
	    },
	    {
	        "id": 4573,
	        "name": "El Cubo de Don Sancho"
	    },
	    {
	        "id": 4574,
	        "name": "La Losa"
	    },
	    {
	        "id": 4575,
	        "name": "Medinaceli"
	    },
	    {
	        "id": 4576,
	        "name": "El Pont d'Armentera"
	    },
	    {
	        "id": 4577,
	        "name": "Fuentes de Rubielos"
	    },
	    {
	        "id": 4578,
	        "name": "Los Navalucillos"
	    },
	    {
	        "id": 4579,
	        "name": "Daimús"
	    },
	    {
	        "id": 4580,
	        "name": "Pedrosa del Rey"
	    },
	    {
	        "id": 4581,
	        "name": "Matilla de Arzón"
	    },
	    {
	        "id": 4582,
	        "name": "Fuendejalón"
	    },
	    {
	        "id": 4583,
	        "name": "la Romana"
	    },
	    {
	        "id": 4584,
	        "name": "Madrigal de las Altas Torres"
	    },
	    {
	        "id": 4585,
	        "name": "Risco"
	    },
	    {
	        "id": 4586,
	        "name": "Martorell"
	    },
	    {
	        "id": 4587,
	        "name": "Cubillo del Campo"
	    },
	    {
	        "id": 4588,
	        "name": "Majadas"
	    },
	    {
	        "id": 4589,
	        "name": "Torás"
	    },
	    {
	        "id": 4590,
	        "name": "Olot"
	    },
	    {
	        "id": 4591,
	        "name": "La Calahorra"
	    },
	    {
	        "id": 4592,
	        "name": "Esplegares"
	    },
	    {
	        "id": 4593,
	        "name": "Gistaín"
	    },
	    {
	        "id": 4594,
	        "name": "La Pola de Gordón"
	    },
	    {
	        "id": 4595,
	        "name": "Ivorra"
	    },
	    {
	        "id": 4596,
	        "name": "Pedroso"
	    },
	    {
	        "id": 4597,
	        "name": "Piñuécar-Gandullas"
	    },
	    {
	        "id": 4598,
	        "name": "Garínoain"
	    },
	    {
	        "id": 4599,
	        "name": "Olmos de Ojeda"
	    },
	    {
	        "id": 4600,
	        "name": "Chagarcía Medianero"
	    },
	    {
	        "id": 4601,
	        "name": "Porrera"
	    },
	    {
	        "id": 4602,
	        "name": "Fuentespalda"
	    },
	    {
	        "id": 4603,
	        "name": "Navamorcuende"
	    },
	    {
	        "id": 4604,
	        "name": "Domeño"
	    },
	    {
	        "id": 4605,
	        "name": "Peñafiel"
	    },
	    {
	        "id": 4606,
	        "name": "Matilla la Seca"
	    },
	    {
	        "id": 4607,
	        "name": "Fuendetodos"
	    },
	    {
	        "id": 4608,
	        "name": "Sagra"
	    },
	    {
	        "id": 4609,
	        "name": "Maello"
	    },
	    {
	        "id": 4610,
	        "name": "La Roca de la Sierra"
	    },
	    {
	        "id": 4611,
	        "name": "Martorelles"
	    },
	    {
	        "id": 4612,
	        "name": "Cubo de Bureba"
	    },
	    {
	        "id": 4613,
	        "name": "Malpartida de Cáceres"
	    },
	    {
	        "id": 4614,
	        "name": "El Toro"
	    },
	    {
	        "id": 4615,
	        "name": "Laguna del Marquesado"
	    },
	    {
	        "id": 4616,
	        "name": "Ordis"
	    },
	    {
	        "id": 4617,
	        "name": "Láchar"
	    },
	    {
	        "id": 4618,
	        "name": "Establés"
	    },
	    {
	        "id": 4619,
	        "name": "El Grado"
	    },
	    {
	        "id": 4620,
	        "name": "Ponferrada"
	    },
	    {
	        "id": 4621,
	        "name": "Isona i Conca Dellà"
	    },
	    {
	        "id": 4622,
	        "name": "Pinillos"
	    },
	    {
	        "id": 4623,
	        "name": "Pozuelo de Alarcón"
	    },
	    {
	        "id": 4624,
	        "name": "Garralda"
	    },
	    {
	        "id": 4625,
	        "name": "Dios le Guarde"
	    },
	    {
	        "id": 4626,
	        "name": "Maderuelo"
	    },
	    {
	        "id": 4627,
	        "name": "Miño de Medinaceli"
	    },
	    {
	        "id": 4628,
	        "name": "Pradell de la Teixeta"
	    },
	    {
	        "id": 4629,
	        "name": "Galve"
	    },
	    {
	        "id": 4630,
	        "name": "Noblejas"
	    },
	    {
	        "id": 4631,
	        "name": "Dos Aguas"
	    },
	    {
	        "id": 4632,
	        "name": "Peñaflor de Hornija"
	    },
	    {
	        "id": 4633,
	        "name": "Mayalde"
	    },
	    {
	        "id": 4634,
	        "name": "Fuentes de Ebro"
	    },
	    {
	        "id": 4635,
	        "name": "Salinas"
	    },
	    {
	        "id": 4636,
	        "name": "Malpartida de Corneja"
	    },
	    {
	        "id": 4637,
	        "name": "Salvaleón"
	    },
	    {
	        "id": 4638,
	        "name": "Les Masies de Roda"
	    },
	    {
	        "id": 4639,
	        "name": "Malpartida de Plasencia"
	    },
	    {
	        "id": 4640,
	        "name": "Torralba del Pinar"
	    },
	    {
	        "id": 4641,
	        "name": "Lagunaseca"
	    },
	    {
	        "id": 4642,
	        "name": "Osor"
	    },
	    {
	        "id": 4643,
	        "name": "Lanjarón"
	    },
	    {
	        "id": 4644,
	        "name": "Estriégana"
	    },
	    {
	        "id": 4645,
	        "name": "Grañén"
	    },
	    {
	        "id": 4646,
	        "name": "Posada de Valdeón"
	    },
	    {
	        "id": 4647,
	        "name": "Pozuelo del Rey"
	    },
	    {
	        "id": 4648,
	        "name": "Genevilla"
	    },
	    {
	        "id": 4649,
	        "name": "Osornillo"
	    },
	    {
	        "id": 4650,
	        "name": "Doñinos de Ledesma"
	    },
	    {
	        "id": 4651,
	        "name": "Miño de San Esteban"
	    },
	    {
	        "id": 4652,
	        "name": "Prades"
	    },
	    {
	        "id": 4653,
	        "name": "Gargallo"
	    },
	    {
	        "id": 4654,
	        "name": "Noez"
	    },
	    {
	        "id": 4655,
	        "name": "l'Eliana"
	    },
	    {
	        "id": 4656,
	        "name": "Pesquera de Duero"
	    },
	    {
	        "id": 4657,
	        "name": "Melgar de Tera"
	    },
	    {
	        "id": 4658,
	        "name": "Fuentes de Jiloca"
	    },
	    {
	        "id": 4659,
	        "name": "Sanet y Negrals"
	    },
	    {
	        "id": 4660,
	        "name": "Mamblas"
	    },
	    {
	        "id": 4661,
	        "name": "Salvatierra de los Barros"
	    },
	    {
	        "id": 4662,
	        "name": "Les Masies de Voltregà"
	    },
	    {
	        "id": 4663,
	        "name": "La Cueva de Roa"
	    },
	    {
	        "id": 4664,
	        "name": "Marchagaz"
	    },
	    {
	        "id": 4665,
	        "name": "Torreblanca"
	    },
	    {
	        "id": 4666,
	        "name": "Landete"
	    },
	    {
	        "id": 4667,
	        "name": "Palafrugell"
	    },
	    {
	        "id": 4668,
	        "name": "Lanteira"
	    },
	    {
	        "id": 4669,
	        "name": "Fontanar"
	    },
	    {
	        "id": 4670,
	        "name": "Graus"
	    },
	    {
	        "id": 4671,
	        "name": "Pozuelo del Páramo"
	    },
	    {
	        "id": 4672,
	        "name": "Pradejón"
	    },
	    {
	        "id": 4673,
	        "name": "Prádena del Rincón"
	    },
	    {
	        "id": 4674,
	        "name": "Goizueta"
	    },
	    {
	        "id": 4675,
	        "name": "Doñinos de Salamanca"
	    },
	    {
	        "id": 4676,
	        "name": "Molinos de Duero"
	    },
	    {
	        "id": 4677,
	        "name": "Prat de Comte"
	    },
	    {
	        "id": 4678,
	        "name": "Gea de Albarracín"
	    },
	    {
	        "id": 4679,
	        "name": "Nombela"
	    },
	    {
	        "id": 4680,
	        "name": "Emperador"
	    },
	    {
	        "id": 4681,
	        "name": "Piña de Esgueva"
	    },
	    {
	        "id": 4682,
	        "name": "Micereces de Tera"
	    },
	    {
	        "id": 4683,
	        "name": "Gallocanta"
	    },
	    {
	        "id": 4684,
	        "name": "San Fulgencio"
	    },
	    {
	        "id": 4685,
	        "name": "Mancera de Arriba"
	    },
	    {
	        "id": 4686,
	        "name": "Sancti-Spíritus"
	    },
	    {
	        "id": 4687,
	        "name": "El Masnou"
	    },
	    {
	        "id": 4688,
	        "name": "Mata de Alcántara"
	    },
	    {
	        "id": 4689,
	        "name": "Torrechiva"
	    },
	    {
	        "id": 4690,
	        "name": "Ledaña"
	    },
	    {
	        "id": 4691,
	        "name": "Palamós"
	    },
	    {
	        "id": 4692,
	        "name": "Fuembellida"
	    },
	    {
	        "id": 4693,
	        "name": "Prado de la Guzpeña"
	    },
	    {
	        "id": 4694,
	        "name": "Juncosa"
	    },
	    {
	        "id": 4695,
	        "name": "Pradillo"
	    },
	    {
	        "id": 4696,
	        "name": "Puebla de la Sierra"
	    },
	    {
	        "id": 4697,
	        "name": "Goñi"
	    },
	    {
	        "id": 4698,
	        "name": "Ejeme"
	    },
	    {
	        "id": 4699,
	        "name": "Marazuela"
	    },
	    {
	        "id": 4700,
	        "name": "Momblona"
	    },
	    {
	        "id": 4701,
	        "name": "Pratdip"
	    },
	    {
	        "id": 4702,
	        "name": "La Ginebrosa"
	    },
	    {
	        "id": 4703,
	        "name": "Novés"
	    },
	    {
	        "id": 4704,
	        "name": "Enguera"
	    },
	    {
	        "id": 4705,
	        "name": "Piñel de Abajo"
	    },
	    {
	        "id": 4706,
	        "name": "Milles de la Polvorosa"
	    },
	    {
	        "id": 4707,
	        "name": "Gallur"
	    },
	    {
	        "id": 4708,
	        "name": "Sant Joan d'Alacant"
	    },
	    {
	        "id": 4709,
	        "name": "Manjabálago"
	    },
	    {
	        "id": 4710,
	        "name": "San Pedro de Mérida"
	    },
	    {
	        "id": 4711,
	        "name": "Masquefa"
	    },
	    {
	        "id": 4712,
	        "name": "Cuevas de San Clemente"
	    },
	    {
	        "id": 4713,
	        "name": "Membrío"
	    },
	    {
	        "id": 4714,
	        "name": "la Torre d'En Besora"
	    },
	    {
	        "id": 4715,
	        "name": "Leganiel"
	    },
	    {
	        "id": 4716,
	        "name": "Palau de Santa Eulàlia"
	    },
	    {
	        "id": 4717,
	        "name": "Lecrín"
	    },
	    {
	        "id": 4718,
	        "name": "Fuencemillán"
	    },
	    {
	        "id": 4719,
	        "name": "Gurrea de Gállego"
	    },
	    {
	        "id": 4720,
	        "name": "Priaranza del Bierzo"
	    },
	    {
	        "id": 4721,
	        "name": "Juneda"
	    },
	    {
	        "id": 4722,
	        "name": "Préjano"
	    },
	    {
	        "id": 4723,
	        "name": "Quijorna"
	    },
	    {
	        "id": 4724,
	        "name": "Güesa/Gorza"
	    },
	    {
	        "id": 4725,
	        "name": "La Encina"
	    },
	    {
	        "id": 4726,
	        "name": "Martín Miguel"
	    },
	    {
	        "id": 4727,
	        "name": "Monteagudo de las Vicarías"
	    },
	    {
	        "id": 4728,
	        "name": "Puigpelat"
	    },
	    {
	        "id": 4729,
	        "name": "Griegos"
	    },
	    {
	        "id": 4730,
	        "name": "Numancia de la Sagra"
	    },
	    {
	        "id": 4731,
	        "name": "l'Ènova"
	    },
	    {
	        "id": 4732,
	        "name": "Piñel de Arriba"
	    },
	    {
	        "id": 4733,
	        "name": "Molacillos"
	    },
	    {
	        "id": 4734,
	        "name": "Gelsa"
	    },
	    {
	        "id": 4735,
	        "name": "San Miguel de Salinas"
	    },
	    {
	        "id": 4736,
	        "name": "Marlín"
	    },
	    {
	        "id": 4737,
	        "name": "Santa Amalia"
	    },
	    {
	        "id": 4738,
	        "name": "Matadepera"
	    },
	    {
	        "id": 4739,
	        "name": "Encío"
	    },
	    {
	        "id": 4740,
	        "name": "Mesas de Ibor"
	    },
	    {
	        "id": 4741,
	        "name": "la Torre d'en Doménec"
	    },
	    {
	        "id": 4742,
	        "name": "Palau-saverdera"
	    },
	    {
	        "id": 4743,
	        "name": "Lentegí"
	    },
	    {
	        "id": 4744,
	        "name": "Fuentelahiguera de Albatages"
	    },
	    {
	        "id": 4745,
	        "name": "Prioro"
	    },
	    {
	        "id": 4746,
	        "name": "Lleida"
	    },
	    {
	        "id": 4747,
	        "name": "Quel"
	    },
	    {
	        "id": 4748,
	        "name": "Rascafría"
	    },
	    {
	        "id": 4749,
	        "name": "Guesálaz/Gesalatz"
	    },
	    {
	        "id": 4750,
	        "name": "Palencia"
	    },
	    {
	        "id": 4751,
	        "name": "Encina de San Silvestre"
	    },
	    {
	        "id": 4752,
	        "name": "Martín Muñoz de la Dehesa"
	    },
	    {
	        "id": 4753,
	        "name": "Montejo de Tiermes"
	    },
	    {
	        "id": 4754,
	        "name": "Querol"
	    },
	    {
	        "id": 4755,
	        "name": "Guadalaviar"
	    },
	    {
	        "id": 4756,
	        "name": "Nuño Gómez"
	    },
	    {
	        "id": 4757,
	        "name": "Estivella"
	    },
	    {
	        "id": 4758,
	        "name": "Molezuelas de la Carballeda"
	    },
	    {
	        "id": 4759,
	        "name": "Godojos"
	    },
	    {
	        "id": 4760,
	        "name": "Santa Pola"
	    },
	    {
	        "id": 4761,
	        "name": "Martiherrero"
	    },
	    {
	        "id": 4762,
	        "name": "Santa Marta"
	    },
	    {
	        "id": 4763,
	        "name": "Mataró"
	    },
	    {
	        "id": 4764,
	        "name": "Miajadas"
	    },
	    {
	        "id": 4765,
	        "name": "Traiguera"
	    },
	    {
	        "id": 4766,
	        "name": "Las Majadas"
	    },
	    {
	        "id": 4767,
	        "name": "Palau-sator"
	    },
	    {
	        "id": 4768,
	        "name": "Lobras"
	    },
	    {
	        "id": 4769,
	        "name": "Fuentelencina"
	    },
	    {
	        "id": 4770,
	        "name": "Puebla de Lillo"
	    },
	    {
	        "id": 4771,
	        "name": "Les"
	    },
	    {
	        "id": 4772,
	        "name": "Rabanera"
	    },
	    {
	        "id": 4773,
	        "name": "Redueña"
	    },
	    {
	        "id": 4774,
	        "name": "Guirguillano"
	    },
	    {
	        "id": 4775,
	        "name": "Palenzuela"
	    },
	    {
	        "id": 4776,
	        "name": "Encinas de Abajo"
	    },
	    {
	        "id": 4777,
	        "name": "Martín Muñoz de las Posadas"
	    },
	    {
	        "id": 4778,
	        "name": "Montenegro de Cameros"
	    },
	    {
	        "id": 4779,
	        "name": "Rasquera"
	    },
	    {
	        "id": 4780,
	        "name": "Gúdar"
	    },
	    {
	        "id": 4781,
	        "name": "Ocaña"
	    },
	    {
	        "id": 4782,
	        "name": "Estubeny"
	    },
	    {
	        "id": 4783,
	        "name": "Pollos"
	    },
	    {
	        "id": 4784,
	        "name": "Mombuey"
	    },
	    {
	        "id": 4785,
	        "name": "Gotor"
	    },
	    {
	        "id": 4786,
	        "name": "San Vicente del Raspeig/Sant Vicent del Raspeig"
	    },
	    {
	        "id": 4787,
	        "name": "Martínez"
	    },
	    {
	        "id": 4788,
	        "name": "Los Santos de Maimona"
	    },
	    {
	        "id": 4789,
	        "name": "Mediona"
	    },
	    {
	        "id": 4790,
	        "name": "Espinosa de Cervera"
	    },
	    {
	        "id": 4791,
	        "name": "Millanes"
	    },
	    {
	        "id": 4792,
	        "name": "les Useras/Useres"
	    },
	    {
	        "id": 4793,
	        "name": "Mariana"
	    },
	    {
	        "id": 4794,
	        "name": "Loja"
	    },
	    {
	        "id": 4795,
	        "name": "Fuentelsaz"
	    },
	    {
	        "id": 4796,
	        "name": "Hoz de Jaca"
	    },
	    {
	        "id": 4797,
	        "name": "Puente de Domingo Flórez"
	    },
	    {
	        "id": 4798,
	        "name": "Linyola"
	    },
	    {
	        "id": 4799,
	        "name": "El Rasillo de Cameros"
	    },
	    {
	        "id": 4800,
	        "name": "Ribatejada"
	    },
	    {
	        "id": 4801,
	        "name": "Huarte/Uharte"
	    },
	    {
	        "id": 4802,
	        "name": "Páramo de Boedo"
	    },
	    {
	        "id": 4803,
	        "name": "Encinas de Arriba"
	    },
	    {
	        "id": 4804,
	        "name": "Marugán"
	    },
	    {
	        "id": 4805,
	        "name": "Renau"
	    },
	    {
	        "id": 4806,
	        "name": "Híjar"
	    },
	    {
	        "id": 4807,
	        "name": "Olías del Rey"
	    },
	    {
	        "id": 4808,
	        "name": "Faura"
	    },
	    {
	        "id": 4809,
	        "name": "Portillo"
	    },
	    {
	        "id": 4810,
	        "name": "Monfarracinos"
	    },
	    {
	        "id": 4811,
	        "name": "Grisel"
	    },
	    {
	        "id": 4812,
	        "name": "Sax"
	    },
	    {
	        "id": 4813,
	        "name": "Mediana de Voltoya"
	    },
	    {
	        "id": 4814,
	        "name": "San Vicente de Alcántara"
	    },
	    {
	        "id": 4815,
	        "name": "Molins de Rei"
	    },
	    {
	        "id": 4816,
	        "name": "Espinosa del Camino"
	    },
	    {
	        "id": 4817,
	        "name": "Mirabel"
	    },
	    {
	        "id": 4818,
	        "name": "Vallat"
	    },
	    {
	        "id": 4819,
	        "name": "Masegosa"
	    },
	    {
	        "id": 4820,
	        "name": "Palol de Revardit"
	    },
	    {
	        "id": 4821,
	        "name": "Lugros"
	    },
	    {
	        "id": 4822,
	        "name": "Fuentelviejo"
	    },
	    {
	        "id": 4823,
	        "name": "Quintana del Castillo"
	    },
	    {
	        "id": 4824,
	        "name": "Lladorre"
	    },
	    {
	        "id": 4825,
	        "name": "El Redal"
	    },
	    {
	        "id": 4826,
	        "name": "Rivas-Vaciamadrid"
	    },
	    {
	        "id": 4827,
	        "name": "Uharte-Arakil"
	    },
	    {
	        "id": 4828,
	        "name": "Paredes de Nava"
	    },
	    {
	        "id": 4829,
	        "name": "Encinasola de los Comendadores"
	    },
	    {
	        "id": 4830,
	        "name": "Matabuena"
	    },
	    {
	        "id": 4831,
	        "name": "Morón de Almazán"
	    },
	    {
	        "id": 4832,
	        "name": "Reus"
	    },
	    {
	        "id": 4833,
	        "name": "Hinojosa de Jarque"
	    },
	    {
	        "id": 4834,
	        "name": "Ontígola"
	    },
	    {
	        "id": 4835,
	        "name": "Favara"
	    },
	    {
	        "id": 4836,
	        "name": "Pozal de Gallinas"
	    },
	    {
	        "id": 4837,
	        "name": "Montamarta"
	    },
	    {
	        "id": 4838,
	        "name": "Grisén"
	    },
	    {
	        "id": 4839,
	        "name": "Sella"
	    },
	    {
	        "id": 4840,
	        "name": "Medinilla"
	    },
	    {
	        "id": 4841,
	        "name": "Segura de León"
	    },
	    {
	        "id": 4842,
	        "name": "Mollet del Vallès"
	    },
	    {
	        "id": 4843,
	        "name": "Espinosa de los Monteros"
	    },
	    {
	        "id": 4844,
	        "name": "Mohedas de Granadilla"
	    },
	    {
	        "id": 4845,
	        "name": "Vall d'Alba"
	    },
	    {
	        "id": 4846,
	        "name": "Las Mesas"
	    },
	    {
	        "id": 4847,
	        "name": "Pals"
	    },
	    {
	        "id": 4848,
	        "name": "Lújar"
	    },
	    {
	        "id": 4849,
	        "name": "Fuentenovilla"
	    },
	    {
	        "id": 4850,
	        "name": "Huerto"
	    },
	    {
	        "id": 4851,
	        "name": "Quintana del Marco"
	    },
	    {
	        "id": 4852,
	        "name": "Lladurs"
	    },
	    {
	        "id": 4853,
	        "name": "Ribafrecha"
	    },
	    {
	        "id": 4854,
	        "name": "Robledillo de la Jara"
	    },
	    {
	        "id": 4855,
	        "name": "Ibargoiti"
	    },
	    {
	        "id": 4856,
	        "name": "Payo de Ojeda"
	    },
	    {
	        "id": 4857,
	        "name": "Endrinal"
	    },
	    {
	        "id": 4858,
	        "name": "Mata de Cuéllar"
	    },
	    {
	        "id": 4859,
	        "name": "Muriel de la Fuente"
	    },
	    {
	        "id": 4860,
	        "name": "La Riba"
	    },
	    {
	        "id": 4861,
	        "name": "La Hoz de la Vieja"
	    },
	    {
	        "id": 4862,
	        "name": "Orgaz"
	    },
	    {
	        "id": 4863,
	        "name": "Fontanars dels Alforins"
	    },
	    {
	        "id": 4864,
	        "name": "Pozaldez"
	    },
	    {
	        "id": 4865,
	        "name": "Moral de Sayago"
	    },
	    {
	        "id": 4866,
	        "name": "Herrera de los Navarros"
	    },
	    {
	        "id": 4867,
	        "name": "Senija"
	    },
	    {
	        "id": 4868,
	        "name": "Mengamuñoz"
	    },
	    {
	        "id": 4869,
	        "name": "Siruela"
	    },
	    {
	        "id": 4870,
	        "name": "Montcada i Reixac"
	    },
	    {
	        "id": 4871,
	        "name": "Estépar"
	    },
	    {
	        "id": 4872,
	        "name": "Monroy"
	    },
	    {
	        "id": 4873,
	        "name": "Vall de Almonacid"
	    },
	    {
	        "id": 4874,
	        "name": "Minglanilla"
	    },
	    {
	        "id": 4875,
	        "name": "Pardines"
	    },
	    {
	        "id": 4876,
	        "name": "Gajanejos"
	    },
	    {
	        "id": 4877,
	        "name": "Huesca"
	    },
	    {
	        "id": 4878,
	        "name": "Quintana y Congosto"
	    },
	    {
	        "id": 4879,
	        "name": "Llardecans"
	    },
	    {
	        "id": 4880,
	        "name": "Rincón de Soto"
	    },
	    {
	        "id": 4881,
	        "name": "Robledo de Chavela"
	    },
	    {
	        "id": 4882,
	        "name": "Igúzquiza"
	    },
	    {
	        "id": 4883,
	        "name": "Pedraza de Campos"
	    },
	    {
	        "id": 4884,
	        "name": "Escurial de la Sierra"
	    },
	    {
	        "id": 4885,
	        "name": "La Matilla"
	    },
	    {
	        "id": 4886,
	        "name": "Muriel Viejo"
	    },
	    {
	        "id": 4887,
	        "name": "Riba-roja d'Ebre"
	    },
	    {
	        "id": 4888,
	        "name": "Huesa del Común"
	    },
	    {
	        "id": 4889,
	        "name": "Oropesa"
	    },
	    {
	        "id": 4890,
	        "name": "Fortaleny"
	    },
	    {
	        "id": 4891,
	        "name": "Pozuelo de la Orden"
	    },
	    {
	        "id": 4892,
	        "name": "Moraleja del Vino"
	    },
	    {
	        "id": 4893,
	        "name": "Ibdes"
	    },
	    {
	        "id": 4894,
	        "name": "Mesegar de Corneja"
	    },
	    {
	        "id": 4895,
	        "name": "Solana de los Barros"
	    },
	    {
	        "id": 4896,
	        "name": "Montgat"
	    },
	    {
	        "id": 4897,
	        "name": "Montánchez"
	    },
	    {
	        "id": 4898,
	        "name": "la Vall d'Uixó"
	    },
	    {
	        "id": 4899,
	        "name": "Mira"
	    },
	    {
	        "id": 4900,
	        "name": "Parlavà"
	    },
	    {
	        "id": 4901,
	        "name": "La Malahá"
	    },
	    {
	        "id": 4902,
	        "name": "Galápagos"
	    },
	    {
	        "id": 4903,
	        "name": "Ibieca"
	    },
	    {
	        "id": 4904,
	        "name": "Llavorsí"
	    },
	    {
	        "id": 4905,
	        "name": "Robres del Castillo"
	    },
	    {
	        "id": 4906,
	        "name": "Robregordo"
	    },
	    {
	        "id": 4907,
	        "name": "Imotz"
	    },
	    {
	        "id": 4908,
	        "name": "Pedrosa de la Vega"
	    },
	    {
	        "id": 4909,
	        "name": "Espadaña"
	    },
	    {
	        "id": 4910,
	        "name": "Melque de Cercos"
	    },
	    {
	        "id": 4911,
	        "name": "La Riera de Gaià"
	    },
	    {
	        "id": 4912,
	        "name": "La Iglesuela del Cid"
	    },
	    {
	        "id": 4913,
	        "name": "Otero"
	    },
	    {
	        "id": 4914,
	        "name": "Foios"
	    },
	    {
	        "id": 4915,
	        "name": "Puras"
	    },
	    {
	        "id": 4916,
	        "name": "Moraleja de Sayago"
	    },
	    {
	        "id": 4917,
	        "name": "Illueca"
	    },
	    {
	        "id": 4918,
	        "name": "Tàrbena"
	    },
	    {
	        "id": 4919,
	        "name": "Mijares"
	    },
	    {
	        "id": 4920,
	        "name": "Talarrubias"
	    },
	    {
	        "id": 4921,
	        "name": "Monistrol de Montserrat"
	    },
	    {
	        "id": 4922,
	        "name": "Fontioso"
	    },
	    {
	        "id": 4923,
	        "name": "Montehermoso"
	    },
	    {
	        "id": 4924,
	        "name": "Vallibona"
	    },
	    {
	        "id": 4925,
	        "name": "Maracena"
	    },
	    {
	        "id": 4926,
	        "name": "Galve de Sorbe"
	    },
	    {
	        "id": 4927,
	        "name": "Igriés"
	    },
	    {
	        "id": 4928,
	        "name": "Regueras de Arriba"
	    },
	    {
	        "id": 4929,
	        "name": "Lles de Cerdanya"
	    },
	    {
	        "id": 4930,
	        "name": "Rodezno"
	    },
	    {
	        "id": 4931,
	        "name": "Las Rozas de Madrid"
	    },
	    {
	        "id": 4932,
	        "name": "Irañeta"
	    },
	    {
	        "id": 4933,
	        "name": "Perales"
	    },
	    {
	        "id": 4934,
	        "name": "Espeja"
	    },
	    {
	        "id": 4935,
	        "name": "Membibre de la Hoz"
	    },
	    {
	        "id": 4936,
	        "name": "Nafría de Ucero"
	    },
	    {
	        "id": 4937,
	        "name": "Riudecanyes"
	    },
	    {
	        "id": 4938,
	        "name": "Jabaloyas"
	    },
	    {
	        "id": 4939,
	        "name": "Palomeque"
	    },
	    {
	        "id": 4940,
	        "name": "la Font d'En Carròs"
	    },
	    {
	        "id": 4941,
	        "name": "Quintanilla de Arriba"
	    },
	    {
	        "id": 4942,
	        "name": "Morales del Vino"
	    },
	    {
	        "id": 4943,
	        "name": "Teulada"
	    },
	    {
	        "id": 4944,
	        "name": "Mingorría"
	    },
	    {
	        "id": 4945,
	        "name": "Talavera la Real"
	    },
	    {
	        "id": 4946,
	        "name": "Monistrol de Calders"
	    },
	    {
	        "id": 4947,
	        "name": "Frandovínez"
	    },
	    {
	        "id": 4948,
	        "name": "Moraleja"
	    },
	    {
	        "id": 4949,
	        "name": "Vilafamés"
	    },
	    {
	        "id": 4950,
	        "name": "Monreal del Llano"
	    },
	    {
	        "id": 4951,
	        "name": "Pau"
	    },
	    {
	        "id": 4952,
	        "name": "Marchal"
	    },
	    {
	        "id": 4953,
	        "name": "Ilche"
	    },
	    {
	        "id": 4954,
	        "name": "Llimiana"
	    },
	    {
	        "id": 4955,
	        "name": "Sajazarra"
	    },
	    {
	        "id": 4956,
	        "name": "Rozas de Puerto Real"
	    },
	    {
	        "id": 4957,
	        "name": "Isaba/Izaba"
	    },
	    {
	        "id": 4958,
	        "name": "Espino de la Orbada"
	    },
	    {
	        "id": 4959,
	        "name": "Migueláñez"
	    },
	    {
	        "id": 4960,
	        "name": "Narros"
	    },
	    {
	        "id": 4961,
	        "name": "Riudecols"
	    },
	    {
	        "id": 4962,
	        "name": "Jarque de la Val"
	    },
	    {
	        "id": 4963,
	        "name": "Pantoja"
	    },
	    {
	        "id": 4964,
	        "name": "la Font de la Figuera"
	    },
	    {
	        "id": 4965,
	        "name": "Quintanilla del Molar"
	    },
	    {
	        "id": 4966,
	        "name": "Morales de Rey"
	    },
	    {
	        "id": 4967,
	        "name": "Isuerre"
	    },
	    {
	        "id": 4968,
	        "name": "Tibi"
	    },
	    {
	        "id": 4969,
	        "name": "El Mirón"
	    },
	    {
	        "id": 4970,
	        "name": "Táliga"
	    },
	    {
	        "id": 4971,
	        "name": "Muntanyola"
	    },
	    {
	        "id": 4972,
	        "name": "Fresneda de la Sierra Tirón"
	    },
	    {
	        "id": 4973,
	        "name": "Morcillo"
	    },
	    {
	        "id": 4974,
	        "name": "Villafranca del Cid/Vilafranca"
	    },
	    {
	        "id": 4975,
	        "name": "Montalbanejo"
	    },
	    {
	        "id": 4976,
	        "name": "Pedret i Marzà"
	    },
	    {
	        "id": 4977,
	        "name": "Gascueña de Bornova"
	    },
	    {
	        "id": 4978,
	        "name": "Isábena"
	    },
	    {
	        "id": 4979,
	        "name": "Reyero"
	    },
	    {
	        "id": 4980,
	        "name": "Llobera"
	    },
	    {
	        "id": 4981,
	        "name": "San Asensio"
	    },
	    {
	        "id": 4982,
	        "name": "San Agustín del Guadalix"
	    },
	    {
	        "id": 4983,
	        "name": "Ituren"
	    },
	    {
	        "id": 4984,
	        "name": "Pino del Río"
	    },
	    {
	        "id": 4985,
	        "name": "Florida de Liébana"
	    },
	    {
	        "id": 4986,
	        "name": "Montejo de Arévalo"
	    },
	    {
	        "id": 4987,
	        "name": "Navaleno"
	    },
	    {
	        "id": 4988,
	        "name": "Riudoms"
	    },
	    {
	        "id": 4989,
	        "name": "Jatiel"
	    },
	    {
	        "id": 4990,
	        "name": "Paredes de Escalona"
	    },
	    {
	        "id": 4991,
	        "name": "Fuenterrobles"
	    },
	    {
	        "id": 4992,
	        "name": "Quintanilla de Onésimo"
	    },
	    {
	        "id": 4993,
	        "name": "Morales de Toro"
	    },
	    {
	        "id": 4994,
	        "name": "Jaraba"
	    },
	    {
	        "id": 4995,
	        "name": "Tollos"
	    },
	    {
	        "id": 4996,
	        "name": "Mironcillo"
	    },
	    {
	        "id": 4997,
	        "name": "Tamurejo"
	    },
	    {
	        "id": 4998,
	        "name": "Montclar"
	    },
	    {
	        "id": 4999,
	        "name": "Fresneña"
	    },
	    {
	        "id": 5000,
	        "name": "Navaconcejo"
	    },
	    {
	        "id": 5001,
	        "name": "Villahermosa del Río"
	    },
	    {
	        "id": 5002,
	        "name": "Montalbo"
	    },
	    {
	        "id": 5003,
	        "name": "La Pera"
	    },
	    {
	        "id": 5004,
	        "name": "Guadalajara"
	    },
	    {
	        "id": 5005,
	        "name": "Jaca"
	    },
	    {
	        "id": 5006,
	        "name": "Riaño"
	    },
	    {
	        "id": 5007,
	        "name": "Maldà"
	    },
	    {
	        "id": 5008,
	        "name": "San Millán de la Cogolla"
	    },
	    {
	        "id": 5009,
	        "name": "San Fernando de Henares"
	    },
	    {
	        "id": 5010,
	        "name": "Iturmendi"
	    },
	    {
	        "id": 5011,
	        "name": "Piña de Campos"
	    },
	    {
	        "id": 5012,
	        "name": "Forfoleda"
	    },
	    {
	        "id": 5013,
	        "name": "Montejo de la Vega de la Serrezuela"
	    },
	    {
	        "id": 5014,
	        "name": "Nepas"
	    },
	    {
	        "id": 5015,
	        "name": "Rocafort de Queralt"
	    },
	    {
	        "id": 5016,
	        "name": "Jorcas"
	    },
	    {
	        "id": 5017,
	        "name": "Parrillas"
	    },
	    {
	        "id": 5018,
	        "name": "Gavarda"
	    },
	    {
	        "id": 5019,
	        "name": "Quintanilla de Trigueros"
	    },
	    {
	        "id": 5020,
	        "name": "Morales de Valverde"
	    },
	    {
	        "id": 5021,
	        "name": "Jarque"
	    },
	    {
	        "id": 5022,
	        "name": "Tormos"
	    },
	    {
	        "id": 5023,
	        "name": "Mirueña de los Infanzones"
	    },
	    {
	        "id": 5024,
	        "name": "Torre de Miguel Sesmero"
	    },
	    {
	        "id": 5025,
	        "name": "Montesquiu"
	    },
	    {
	        "id": 5026,
	        "name": "Fresnillo de las Dueñas"
	    },
	    {
	        "id": 5027,
	        "name": "Navalmoral de la Mata"
	    },
	    {
	        "id": 5028,
	        "name": "Villamalur"
	    },
	    {
	        "id": 5029,
	        "name": "Monteagudo de las Salinas"
	    },
	    {
	        "id": 5030,
	        "name": "Jasa"
	    },
	    {
	        "id": 5031,
	        "name": "Riego de la Vega"
	    },
	    {
	        "id": 5032,
	        "name": "Massalcoreig"
	    },
	    {
	        "id": 5033,
	        "name": "San Millán de Yécora"
	    },
	    {
	        "id": 5034,
	        "name": "San Lorenzo de El Escorial"
	    },
	    {
	        "id": 5035,
	        "name": "Iza/Itza"
	    },
	    {
	        "id": 5036,
	        "name": "Población de Arroyo"
	    },
	    {
	        "id": 5037,
	        "name": "Frades de la Sierra"
	    },
	    {
	        "id": 5038,
	        "name": "Monterrubio"
	    },
	    {
	        "id": 5039,
	        "name": "Nolay"
	    },
	    {
	        "id": 5040,
	        "name": "Roda de Barà"
	    },
	    {
	        "id": 5041,
	        "name": "Josa"
	    },
	    {
	        "id": 5042,
	        "name": "Pelahustán"
	    },
	    {
	        "id": 5043,
	        "name": "Gandia"
	    },
	    {
	        "id": 5044,
	        "name": "Rábano"
	    },
	    {
	        "id": 5045,
	        "name": "Moralina"
	    },
	    {
	        "id": 5046,
	        "name": "Jaulín"
	    },
	    {
	        "id": 5047,
	        "name": "la Torremanzanas/Torre de les Maçanes"
	    },
	    {
	        "id": 5048,
	        "name": "Mombeltrán"
	    },
	    {
	        "id": 5049,
	        "name": "Torremayor"
	    },
	    {
	        "id": 5050,
	        "name": "Montmajor"
	    },
	    {
	        "id": 5051,
	        "name": "Fresno de Río Tirón"
	    },
	    {
	        "id": 5052,
	        "name": "Navalvillar de Ibor"
	    },
	    {
	        "id": 5053,
	        "name": "Vilanova d'Alcolea"
	    },
	    {
	        "id": 5054,
	        "name": "Mota de Altarejos"
	    },
	    {
	        "id": 5055,
	        "name": "Peralada"
	    },
	    {
	        "id": 5056,
	        "name": "Moclín"
	    },
	    {
	        "id": 5057,
	        "name": "Henche"
	    },
	    {
	        "id": 5058,
	        "name": "Riello"
	    },
	    {
	        "id": 5059,
	        "name": "Massoteres"
	    },
	    {
	        "id": 5060,
	        "name": "San Román de Cameros"
	    },
	    {
	        "id": 5061,
	        "name": "San Martín de la Vega"
	    },
	    {
	        "id": 5062,
	        "name": "Izagaondoa"
	    },
	    {
	        "id": 5063,
	        "name": "Población de Campos"
	    },
	    {
	        "id": 5064,
	        "name": "La Fregeneda"
	    },
	    {
	        "id": 5065,
	        "name": "Moral de Hornuez"
	    },
	    {
	        "id": 5066,
	        "name": "Noviercas"
	    },
	    {
	        "id": 5067,
	        "name": "Rodonyà"
	    },
	    {
	        "id": 5068,
	        "name": "Lagueruela"
	    },
	    {
	        "id": 5069,
	        "name": "Pepino"
	    },
	    {
	        "id": 5070,
	        "name": "Genovés"
	    },
	    {
	        "id": 5071,
	        "name": "Ramiro"
	    },
	    {
	        "id": 5072,
	        "name": "Moreruela de los Infanzones"
	    },
	    {
	        "id": 5073,
	        "name": "La Joyosa"
	    },
	    {
	        "id": 5074,
	        "name": "Torrevieja"
	    },
	    {
	        "id": 5075,
	        "name": "Monsalupe"
	    },
	    {
	        "id": 5076,
	        "name": "Torremejía"
	    },
	    {
	        "id": 5077,
	        "name": "Montmaneu"
	    },
	    {
	        "id": 5078,
	        "name": "Fresno de Rodilla"
	    },
	    {
	        "id": 5079,
	        "name": "Navas del Madroño"
	    },
	    {
	        "id": 5080,
	        "name": "Villanueva de Viver"
	    },
	    {
	        "id": 5081,
	        "name": "Mota del Cuervo"
	    },
	    {
	        "id": 5082,
	        "name": "Les Planes d'Hostoles"
	    },
	    {
	        "id": 5083,
	        "name": "Molvízar"
	    },
	    {
	        "id": 5084,
	        "name": "Heras de Ayuso"
	    },
	    {
	        "id": 5085,
	        "name": "Labuerda"
	    },
	    {
	        "id": 5086,
	        "name": "Rioseco de Tapia"
	    },
	    {
	        "id": 5087,
	        "name": "Maials"
	    },
	    {
	        "id": 5088,
	        "name": "San Martín de Valdeiglesias"
	    },
	    {
	        "id": 5089,
	        "name": "Izalzu/Itzaltzu"
	    },
	    {
	        "id": 5090,
	        "name": "Población de Cerrato"
	    },
	    {
	        "id": 5091,
	        "name": "Fresnedoso"
	    },
	    {
	        "id": 5092,
	        "name": "Roquetes"
	    },
	    {
	        "id": 5093,
	        "name": "Lanzuela"
	    },
	    {
	        "id": 5094,
	        "name": "Polán"
	    },
	    {
	        "id": 5095,
	        "name": "Gestalgar"
	    },
	    {
	        "id": 5096,
	        "name": "Renedo de Esgueva"
	    },
	    {
	        "id": 5097,
	        "name": "Moreruela de Tábara"
	    },
	    {
	        "id": 5098,
	        "name": "Lagata"
	    },
	    {
	        "id": 5099,
	        "name": "la Vall d'Alcalà"
	    },
	    {
	        "id": 5100,
	        "name": "Moraleja de Matacabras"
	    },
	    {
	        "id": 5101,
	        "name": "Trasierra"
	    },
	    {
	        "id": 5102,
	        "name": "Figaró-Montmany"
	    },
	    {
	        "id": 5103,
	        "name": "Frías"
	    },
	    {
	        "id": 5104,
	        "name": "Navezuelas"
	    },
	    {
	        "id": 5105,
	        "name": "Vilar de Canes"
	    },
	    {
	        "id": 5106,
	        "name": "Motilla del Palancar"
	    },
	    {
	        "id": 5107,
	        "name": "Planoles"
	    },
	    {
	        "id": 5108,
	        "name": "Monachil"
	    },
	    {
	        "id": 5109,
	        "name": "Herrería"
	    },
	    {
	        "id": 5110,
	        "name": "La Robla"
	    },
	    {
	        "id": 5111,
	        "name": "Menàrguens"
	    },
	    {
	        "id": 5112,
	        "name": "Santa Coloma"
	    },
	    {
	        "id": 5113,
	        "name": "San Sebastián de los Reyes"
	    },
	    {
	        "id": 5114,
	        "name": "Jaurrieta"
	    },
	    {
	        "id": 5115,
	        "name": "Polentinos"
	    },
	    {
	        "id": 5116,
	        "name": "Fresno Alhándiga"
	    },
	    {
	        "id": 5117,
	        "name": "Mozoncillo"
	    },
	    {
	        "id": 5118,
	        "name": "Ólvega"
	    },
	    {
	        "id": 5119,
	        "name": "El Rourell"
	    },
	    {
	        "id": 5120,
	        "name": "Portillo de Toledo"
	    },
	    {
	        "id": 5121,
	        "name": "Gilet"
	    },
	    {
	        "id": 5122,
	        "name": "Roales de Campos"
	    },
	    {
	        "id": 5123,
	        "name": "Muelas de los Caballeros"
	    },
	    {
	        "id": 5124,
	        "name": "Langa del Castillo"
	    },
	    {
	        "id": 5125,
	        "name": "la Vall d'Ebo"
	    },
	    {
	        "id": 5126,
	        "name": "Muñana"
	    },
	    {
	        "id": 5127,
	        "name": "Trujillanos"
	    },
	    {
	        "id": 5128,
	        "name": "Montmeló"
	    },
	    {
	        "id": 5129,
	        "name": "Fuentebureba"
	    },
	    {
	        "id": 5130,
	        "name": "Nuñomoral"
	    },
	    {
	        "id": 5131,
	        "name": "Vila-real"
	    },
	    {
	        "id": 5132,
	        "name": "Moya"
	    },
	    {
	        "id": 5133,
	        "name": "Pont de Molins"
	    },
	    {
	        "id": 5134,
	        "name": "Montefrío"
	    },
	    {
	        "id": 5135,
	        "name": "Hiendelaencina"
	    },
	    {
	        "id": 5136,
	        "name": "Laluenga"
	    },
	    {
	        "id": 5137,
	        "name": "Miralcamp"
	    },
	    {
	        "id": 5138,
	        "name": "Santa Engracia del Jubera"
	    },
	    {
	        "id": 5139,
	        "name": "Santa María de la Alameda"
	    },
	    {
	        "id": 5140,
	        "name": "Javier"
	    },
	    {
	        "id": 5141,
	        "name": "Pomar de Valdivia"
	    },
	    {
	        "id": 5142,
	        "name": "La Fuente de San Esteban"
	    },
	    {
	        "id": 5143,
	        "name": "Muñopedro"
	    },
	    {
	        "id": 5144,
	        "name": "Oncala"
	    },
	    {
	        "id": 5145,
	        "name": "Salomó"
	    },
	    {
	        "id": 5146,
	        "name": "Libros"
	    },
	    {
	        "id": 5147,
	        "name": "La Puebla de Almoradiel"
	    },
	    {
	        "id": 5148,
	        "name": "Godella"
	    },
	    {
	        "id": 5149,
	        "name": "Robladillo"
	    },
	    {
	        "id": 5150,
	        "name": "Muelas del Pan"
	    },
	    {
	        "id": 5151,
	        "name": "Layana"
	    },
	    {
	        "id": 5152,
	        "name": "Vall de Gallinera"
	    },
	    {
	        "id": 5153,
	        "name": "Muñico"
	    },
	    {
	        "id": 5154,
	        "name": "Usagre"
	    },
	    {
	        "id": 5155,
	        "name": "Montornès del Vallès"
	    },
	    {
	        "id": 5156,
	        "name": "Fuentecén"
	    },
	    {
	        "id": 5157,
	        "name": "Oliva de Plasencia"
	    },
	    {
	        "id": 5158,
	        "name": "la Vilavella"
	    },
	    {
	        "id": 5159,
	        "name": "Pontós"
	    },
	    {
	        "id": 5160,
	        "name": "Montejícar"
	    },
	    {
	        "id": 5161,
	        "name": "Hijes"
	    },
	    {
	        "id": 5162,
	        "name": "Lalueza"
	    },
	    {
	        "id": 5163,
	        "name": "Roperuelos del Páramo"
	    },
	    {
	        "id": 5164,
	        "name": "La Molsosa"
	    },
	    {
	        "id": 5165,
	        "name": "Santa Eulalia Bajera"
	    },
	    {
	        "id": 5166,
	        "name": "Santorcaz"
	    },
	    {
	        "id": 5167,
	        "name": "Juslapeña"
	    },
	    {
	        "id": 5168,
	        "name": "Poza de la Vega"
	    },
	    {
	        "id": 5169,
	        "name": "Fuenteguinaldo"
	    },
	    {
	        "id": 5170,
	        "name": "Muñoveros"
	    },
	    {
	        "id": 5171,
	        "name": "Sant Carles de la Ràpita"
	    },
	    {
	        "id": 5172,
	        "name": "Lidón"
	    },
	    {
	        "id": 5173,
	        "name": "La Puebla de Montalbán"
	    },
	    {
	        "id": 5174,
	        "name": "Godelleta"
	    },
	    {
	        "id": 5175,
	        "name": "Muga de Sayago"
	    },
	    {
	        "id": 5176,
	        "name": "Lécera"
	    },
	    {
	        "id": 5177,
	        "name": "la Vall de Laguar"
	    },
	    {
	        "id": 5178,
	        "name": "Valdecaballeros"
	    },
	    {
	        "id": 5179,
	        "name": "Montseny"
	    },
	    {
	        "id": 5180,
	        "name": "Fuentelcésped"
	    },
	    {
	        "id": 5181,
	        "name": "Palomero"
	    },
	    {
	        "id": 5182,
	        "name": "Villores"
	    },
	    {
	        "id": 5183,
	        "name": "Narboneta"
	    },
	    {
	        "id": 5184,
	        "name": "Porqueres"
	    },
	    {
	        "id": 5185,
	        "name": "Montillana"
	    },
	    {
	        "id": 5186,
	        "name": "Lanaja"
	    },
	    {
	        "id": 5187,
	        "name": "Sabero"
	    },
	    {
	        "id": 5188,
	        "name": "Mollerussa"
	    },
	    {
	        "id": 5189,
	        "name": "Los Santos de la Humosa"
	    },
	    {
	        "id": 5190,
	        "name": "Beintza-Labaien"
	    },
	    {
	        "id": 5191,
	        "name": "Pozo de Urama"
	    },
	    {
	        "id": 5192,
	        "name": "Fuenteliante"
	    },
	    {
	        "id": 5193,
	        "name": "Sant Jaume dels Domenys"
	    },
	    {
	        "id": 5194,
	        "name": "Linares de Mora"
	    },
	    {
	        "id": 5195,
	        "name": "La Pueblanueva"
	    },
	    {
	        "id": 5196,
	        "name": "la Granja de la Costera"
	    },
	    {
	        "id": 5197,
	        "name": "Roturas"
	    },
	    {
	        "id": 5198,
	        "name": "Navianos de Valverde"
	    },
	    {
	        "id": 5199,
	        "name": "Leciñena"
	    },
	    {
	        "id": 5200,
	        "name": "el Verger"
	    },
	    {
	        "id": 5201,
	        "name": "Muñogalindo"
	    },
	    {
	        "id": 5202,
	        "name": "Valdetorres"
	    },
	    {
	        "id": 5203,
	        "name": "Moià"
	    },
	    {
	        "id": 5204,
	        "name": "Fuentelisendo"
	    },
	    {
	        "id": 5205,
	        "name": "Pasarón de la Vera"
	    },
	    {
	        "id": 5206,
	        "name": "Vinaròs"
	    },
	    {
	        "id": 5207,
	        "name": "Portbou"
	    },
	    {
	        "id": 5208,
	        "name": "Moraleda de Zafayona"
	    },
	    {
	        "id": 5209,
	        "name": "Hita"
	    },
	    {
	        "id": 5210,
	        "name": "Montgai"
	    },
	    {
	        "id": 5211,
	        "name": "Santo Domingo de la Calzada"
	    },
	    {
	        "id": 5212,
	        "name": "La Serna del Monte"
	    },
	    {
	        "id": 5213,
	        "name": "Lakuntza"
	    },
	    {
	        "id": 5214,
	        "name": "Fuenterroble de Salvatierra"
	    },
	    {
	        "id": 5215,
	        "name": "Nava de la Asunción"
	    },
	    {
	        "id": 5216,
	        "name": "Santa Bàrbara"
	    },
	    {
	        "id": 5217,
	        "name": "Loscos"
	    },
	    {
	        "id": 5218,
	        "name": "El Puente del Arzobispo"
	    },
	    {
	        "id": 5219,
	        "name": "Guadasséquies"
	    },
	    {
	        "id": 5220,
	        "name": "Rubí de Bracamonte"
	    },
	    {
	        "id": 5221,
	        "name": "Olmillos de Castro"
	    },
	    {
	        "id": 5222,
	        "name": "Lechón"
	    },
	    {
	        "id": 5223,
	        "name": "la Villajoyosa/Vila Joiosa"
	    },
	    {
	        "id": 5224,
	        "name": "Muñogrande"
	    },
	    {
	        "id": 5225,
	        "name": "Valencia de las Torres"
	    },
	    {
	        "id": 5226,
	        "name": "Mura"
	    },
	    {
	        "id": 5227,
	        "name": "Fuentemolinos"
	    },
	    {
	        "id": 5228,
	        "name": "Pedroso de Acim"
	    },
	    {
	        "id": 5229,
	        "name": "Vistabella del Maestrazgo"
	    },
	    {
	        "id": 5230,
	        "name": "Olivares de Júcar"
	    },
	    {
	        "id": 5231,
	        "name": "Les Preses"
	    },
	    {
	        "id": 5232,
	        "name": "Hombrados"
	    },
	    {
	        "id": 5233,
	        "name": "Laperdiguera"
	    },
	    {
	        "id": 5234,
	        "name": "Sahagún"
	    },
	    {
	        "id": 5235,
	        "name": "Montellà i Martinet"
	    },
	    {
	        "id": 5236,
	        "name": "San Torcuato"
	    },
	    {
	        "id": 5237,
	        "name": "Lana"
	    },
	    {
	        "id": 5238,
	        "name": "Prádanos de Ojeda"
	    },
	    {
	        "id": 5239,
	        "name": "Fuentes de Béjar"
	    },
	    {
	        "id": 5240,
	        "name": "Navafría"
	    },
	    {
	        "id": 5241,
	        "name": "Pinilla del Campo"
	    },
	    {
	        "id": 5242,
	        "name": "Santa Coloma de Queralt"
	    },
	    {
	        "id": 5243,
	        "name": "Puerto de San Vicente"
	    },
	    {
	        "id": 5244,
	        "name": "Guadassuar"
	    },
	    {
	        "id": 5245,
	        "name": "Rueda"
	    },
	    {
	        "id": 5246,
	        "name": "Otero de Bodas"
	    },
	    {
	        "id": 5247,
	        "name": "Letux"
	    },
	    {
	        "id": 5248,
	        "name": "Villena"
	    },
	    {
	        "id": 5249,
	        "name": "Muñomer del Peco"
	    },
	    {
	        "id": 5250,
	        "name": "Valencia del Mombuey"
	    },
	    {
	        "id": 5251,
	        "name": "Navarcles"
	    },
	    {
	        "id": 5252,
	        "name": "Fuentenebro"
	    },
	    {
	        "id": 5253,
	        "name": "Peraleda de la Mata"
	    },
	    {
	        "id": 5254,
	        "name": "Viver"
	    },
	    {
	        "id": 5255,
	        "name": "Olmeda de la Cuesta"
	    },
	    {
	        "id": 5256,
	        "name": "El Port de la Selva"
	    },
	    {
	        "id": 5257,
	        "name": "Motril"
	    },
	    {
	        "id": 5258,
	        "name": "Montferrer i Castellbò"
	    },
	    {
	        "id": 5259,
	        "name": "Santurde de Rioja"
	    },
	    {
	        "id": 5260,
	        "name": "Serranillos del Valle"
	    },
	    {
	        "id": 5261,
	        "name": "Lantz"
	    },
	    {
	        "id": 5262,
	        "name": "La Puebla de Valdavia"
	    },
	    {
	        "id": 5263,
	        "name": "Fuentes de Oñoro"
	    },
	    {
	        "id": 5264,
	        "name": "Navalilla"
	    },
	    {
	        "id": 5265,
	        "name": "Portillo de Soria"
	    },
	    {
	        "id": 5266,
	        "name": "Santa Oliva"
	    },
	    {
	        "id": 5267,
	        "name": "Pulgar"
	    },
	    {
	        "id": 5268,
	        "name": "Guardamar de la Safor"
	    },
	    {
	        "id": 5269,
	        "name": "Saelices de Mayorga"
	    },
	    {
	        "id": 5270,
	        "name": "Litago"
	    },
	    {
	        "id": 5271,
	        "name": "Muñopepe"
	    },
	    {
	        "id": 5272,
	        "name": "Valencia del Ventoso"
	    },
	    {
	        "id": 5273,
	        "name": "Navàs"
	    },
	    {
	        "id": 5274,
	        "name": "Fuentespina"
	    },
	    {
	        "id": 5275,
	        "name": "Peraleda de San Román"
	    },
	    {
	        "id": 5276,
	        "name": "Zorita del Maestrazgo"
	    },
	    {
	        "id": 5277,
	        "name": "Olmeda del Rey"
	    },
	    {
	        "id": 5278,
	        "name": "Puigcerdà"
	    },
	    {
	        "id": 5279,
	        "name": "Murtas"
	    },
	    {
	        "id": 5280,
	        "name": "Lascellas-Ponzano"
	    },
	    {
	        "id": 5281,
	        "name": "San Adrián del Valle"
	    },
	    {
	        "id": 5282,
	        "name": "Montoliu de Segarra"
	    },
	    {
	        "id": 5283,
	        "name": "Santurdejo"
	    },
	    {
	        "id": 5284,
	        "name": "Sevilla la Nueva"
	    },
	    {
	        "id": 5285,
	        "name": "Lapoblación"
	    },
	    {
	        "id": 5286,
	        "name": "Quintana del Puente"
	    },
	    {
	        "id": 5287,
	        "name": "Gajates"
	    },
	    {
	        "id": 5288,
	        "name": "Navalmanzano"
	    },
	    {
	        "id": 5289,
	        "name": "La Póveda de Soria"
	    },
	    {
	        "id": 5290,
	        "name": "Pontils"
	    },
	    {
	        "id": 5291,
	        "name": "Lledó"
	    },
	    {
	        "id": 5292,
	        "name": "Quero"
	    },
	    {
	        "id": 5293,
	        "name": "Higueruelas"
	    },
	    {
	        "id": 5294,
	        "name": "Salvador de Zapardiel"
	    },
	    {
	        "id": 5295,
	        "name": "Pajares de la Lampreana"
	    },
	    {
	        "id": 5296,
	        "name": "Lituénigo"
	    },
	    {
	        "id": 5297,
	        "name": "Muñosancho"
	    },
	    {
	        "id": 5298,
	        "name": "Valverde de Burguillos"
	    },
	    {
	        "id": 5299,
	        "name": "La Nou de Berguedà"
	    },
	    {
	        "id": 5300,
	        "name": "Perales del Puerto"
	    },
	    {
	        "id": 5301,
	        "name": "Zucaina"
	    },
	    {
	        "id": 5302,
	        "name": "Olmedilla de Alarcón"
	    },
	    {
	        "id": 5303,
	        "name": "Quart"
	    },
	    {
	        "id": 5304,
	        "name": "Hontoba"
	    },
	    {
	        "id": 5305,
	        "name": "Lascuarre"
	    },
	    {
	        "id": 5306,
	        "name": "San Andrés del Rabanedo"
	    },
	    {
	        "id": 5307,
	        "name": "Montoliu de Lleida"
	    },
	    {
	        "id": 5308,
	        "name": "San Vicente de la Sonsierra"
	    },
	    {
	        "id": 5309,
	        "name": "Larraga"
	    },
	    {
	        "id": 5310,
	        "name": "Galindo y Perahuy"
	    },
	    {
	        "id": 5311,
	        "name": "Navares de Ayuso"
	    },
	    {
	        "id": 5312,
	        "name": "Pozalmuro"
	    },
	    {
	        "id": 5313,
	        "name": "Sarral"
	    },
	    {
	        "id": 5314,
	        "name": "Maicas"
	    },
	    {
	        "id": 5315,
	        "name": "Quintanar de la Orden"
	    },
	    {
	        "id": 5316,
	        "name": "Jalance"
	    },
	    {
	        "id": 5317,
	        "name": "San Cebrián de Mazote"
	    },
	    {
	        "id": 5318,
	        "name": "Palacios del Pan"
	    },
	    {
	        "id": 5319,
	        "name": "Lobera de Onsella"
	    },
	    {
	        "id": 5320,
	        "name": "Muñotello"
	    },
	    {
	        "id": 5321,
	        "name": "Valverde de Leganés"
	    },
	    {
	        "id": 5322,
	        "name": "Òdena"
	    },
	    {
	        "id": 5323,
	        "name": "Galbarros"
	    },
	    {
	        "id": 5324,
	        "name": "Pescueza"
	    },
	    {
	        "id": 5325,
	        "name": "Olmedilla de Eliz"
	    },
	    {
	        "id": 5326,
	        "name": "Rabós"
	    },
	    {
	        "id": 5327,
	        "name": "Nigüelas"
	    },
	    {
	        "id": 5328,
	        "name": "Horche"
	    },
	    {
	        "id": 5329,
	        "name": "Laspaúles"
	    },
	    {
	        "id": 5330,
	        "name": "Sancedo"
	    },
	    {
	        "id": 5331,
	        "name": "Montornès de Segarra"
	    },
	    {
	        "id": 5332,
	        "name": "Sojuela"
	    },
	    {
	        "id": 5333,
	        "name": "Somosierra"
	    },
	    {
	        "id": 5334,
	        "name": "Larraona"
	    },
	    {
	        "id": 5335,
	        "name": "Quintanilla de Onsoña"
	    },
	    {
	        "id": 5336,
	        "name": "Galinduste"
	    },
	    {
	        "id": 5337,
	        "name": "Navares de Enmedio"
	    },
	    {
	        "id": 5338,
	        "name": "Savallà del Comtat"
	    },
	    {
	        "id": 5339,
	        "name": "Manzanera"
	    },
	    {
	        "id": 5340,
	        "name": "Quismondo"
	    },
	    {
	        "id": 5341,
	        "name": "Xeraco"
	    },
	    {
	        "id": 5342,
	        "name": "San Llorente"
	    },
	    {
	        "id": 5343,
	        "name": "Palacios de Sanabria"
	    },
	    {
	        "id": 5344,
	        "name": "Longares"
	    },
	    {
	        "id": 5345,
	        "name": "Narrillos del Álamo"
	    },
	    {
	        "id": 5346,
	        "name": "Valverde de Llerena"
	    },
	    {
	        "id": 5347,
	        "name": "Olvan"
	    },
	    {
	        "id": 5348,
	        "name": "La Gallega"
	    },
	    {
	        "id": 5349,
	        "name": "La Pesga"
	    },
	    {
	        "id": 5350,
	        "name": "Regencós"
	    },
	    {
	        "id": 5351,
	        "name": "Nívar"
	    },
	    {
	        "id": 5352,
	        "name": "Laspuña"
	    },
	    {
	        "id": 5353,
	        "name": "San Cristóbal de la Polantera"
	    },
	    {
	        "id": 5354,
	        "name": "Sorzano"
	    },
	    {
	        "id": 5355,
	        "name": "Soto del Real"
	    },
	    {
	        "id": 5356,
	        "name": "Larraun"
	    },
	    {
	        "id": 5357,
	        "name": "Galisancho"
	    },
	    {
	        "id": 5358,
	        "name": "Navares de las Cuevas"
	    },
	    {
	        "id": 5359,
	        "name": "Quintana Redonda"
	    },
	    {
	        "id": 5360,
	        "name": "La Secuita"
	    },
	    {
	        "id": 5361,
	        "name": "Martín del Río"
	    },
	    {
	        "id": 5362,
	        "name": "El Real de San Vicente"
	    },
	    {
	        "id": 5363,
	        "name": "Jarafuel"
	    },
	    {
	        "id": 5364,
	        "name": "San Martín de Valvení"
	    },
	    {
	        "id": 5365,
	        "name": "Longás"
	    },
	    {
	        "id": 5366,
	        "name": "Narrillos del Rebollar"
	    },
	    {
	        "id": 5367,
	        "name": "Valverde de Mérida"
	    },
	    {
	        "id": 5368,
	        "name": "Olèrdola"
	    },
	    {
	        "id": 5369,
	        "name": "Piedras Albas"
	    },
	    {
	        "id": 5370,
	        "name": "Osa de la Vega"
	    },
	    {
	        "id": 5371,
	        "name": "Ribes de Freser"
	    },
	    {
	        "id": 5372,
	        "name": "Ogíjares"
	    },
	    {
	        "id": 5373,
	        "name": "Hortezuela de Océn"
	    },
	    {
	        "id": 5374,
	        "name": "San Emiliano"
	    },
	    {
	        "id": 5375,
	        "name": "Nalec"
	    },
	    {
	        "id": 5376,
	        "name": "Sotés"
	    },
	    {
	        "id": 5377,
	        "name": "Talamanca de Jarama"
	    },
	    {
	        "id": 5378,
	        "name": "Lazagurría"
	    },
	    {
	        "id": 5379,
	        "name": "Gallegos de Argañán"
	    },
	    {
	        "id": 5380,
	        "name": "Navas de Oro"
	    },
	    {
	        "id": 5381,
	        "name": "Quintanas de Gormaz"
	    },
	    {
	        "id": 5382,
	        "name": "La Selva del Camp"
	    },
	    {
	        "id": 5383,
	        "name": "Mas de las Matas"
	    },
	    {
	        "id": 5384,
	        "name": "Recas"
	    },
	    {
	        "id": 5385,
	        "name": "Xàtiva"
	    },
	    {
	        "id": 5386,
	        "name": "San Miguel del Arroyo"
	    },
	    {
	        "id": 5387,
	        "name": "Pedralba de la Pradería"
	    },
	    {
	        "id": 5388,
	        "name": "Valle de la Serena"
	    },
	    {
	        "id": 5389,
	        "name": "Olesa de Bonesvalls"
	    },
	    {
	        "id": 5390,
	        "name": "Pinofranqueado"
	    },
	    {
	        "id": 5391,
	        "name": "Pajarón"
	    },
	    {
	        "id": 5392,
	        "name": "Riells i Viabrea"
	    },
	    {
	        "id": 5393,
	        "name": "Orce"
	    },
	    {
	        "id": 5394,
	        "name": "La Huerce"
	    },
	    {
	        "id": 5395,
	        "name": "San Esteban de Nogales"
	    },
	    {
	        "id": 5396,
	        "name": "Navès"
	    },
	    {
	        "id": 5397,
	        "name": "Soto en Cameros"
	    },
	    {
	        "id": 5398,
	        "name": "Tielmes"
	    },
	    {
	        "id": 5399,
	        "name": "Leache"
	    },
	    {
	        "id": 5400,
	        "name": "Reinoso de Cerrato"
	    },
	    {
	        "id": 5401,
	        "name": "Gallegos de Solmirón"
	    },
	    {
	        "id": 5402,
	        "name": "Navas de San Antonio"
	    },
	    {
	        "id": 5403,
	        "name": "Senan"
	    },
	    {
	        "id": 5404,
	        "name": "La Mata de los Olmos"
	    },
	    {
	        "id": 5405,
	        "name": "Retamoso de la Jara"
	    },
	    {
	        "id": 5406,
	        "name": "Xeresa"
	    },
	    {
	        "id": 5407,
	        "name": "San Miguel del Pino"
	    },
	    {
	        "id": 5408,
	        "name": "El Pego"
	    },
	    {
	        "id": 5409,
	        "name": "Lucena de Jalón"
	    },
	    {
	        "id": 5410,
	        "name": "Narros del Castillo"
	    },
	    {
	        "id": 5411,
	        "name": "Valle de Matamoros"
	    },
	    {
	        "id": 5412,
	        "name": "Olesa de Montserrat"
	    },
	    {
	        "id": 5413,
	        "name": "Piornal"
	    },
	    {
	        "id": 5414,
	        "name": "Pajaroncillo"
	    },
	    {
	        "id": 5415,
	        "name": "Ripoll"
	    },
	    {
	        "id": 5416,
	        "name": "Órgiva"
	    },
	    {
	        "id": 5417,
	        "name": "Huérmeces del Cerro"
	    },
	    {
	        "id": 5418,
	        "name": "Terroba"
	    },
	    {
	        "id": 5419,
	        "name": "Titulcia"
	    },
	    {
	        "id": 5420,
	        "name": "Legarda"
	    },
	    {
	        "id": 5421,
	        "name": "Renedo de la Vega"
	    },
	    {
	        "id": 5422,
	        "name": "Garcibuey"
	    },
	    {
	        "id": 5423,
	        "name": "Solivella"
	    },
	    {
	        "id": 5424,
	        "name": "Mazaleón"
	    },
	    {
	        "id": 5425,
	        "name": "Rielves"
	    },
	    {
	        "id": 5426,
	        "name": "Llíria"
	    },
	    {
	        "id": 5427,
	        "name": "San Pablo de la Moraleja"
	    },
	    {
	        "id": 5428,
	        "name": "Peleagonzalo"
	    },
	    {
	        "id": 5429,
	        "name": "Luceni"
	    },
	    {
	        "id": 5430,
	        "name": "Narros del Puerto"
	    },
	    {
	        "id": 5431,
	        "name": "Valle de Santa Ana"
	    },
	    {
	        "id": 5432,
	        "name": "Olivella"
	    },
	    {
	        "id": 5433,
	        "name": "Grijalba"
	    },
	    {
	        "id": 5434,
	        "name": "Plasencia"
	    },
	    {
	        "id": 5435,
	        "name": "Palomares del Campo"
	    },
	    {
	        "id": 5436,
	        "name": "Riudarenes"
	    },
	    {
	        "id": 5437,
	        "name": "Otívar"
	    },
	    {
	        "id": 5438,
	        "name": "Huertahernando"
	    },
	    {
	        "id": 5439,
	        "name": "San Justo de la Vega"
	    },
	    {
	        "id": 5440,
	        "name": "Odèn"
	    },
	    {
	        "id": 5441,
	        "name": "Tirgo"
	    },
	    {
	        "id": 5442,
	        "name": "Torrejón de Ardoz"
	    },
	    {
	        "id": 5443,
	        "name": "Legaria"
	    },
	    {
	        "id": 5444,
	        "name": "Garcihernández"
	    },
	    {
	        "id": 5445,
	        "name": "Nieva"
	    },
	    {
	        "id": 5446,
	        "name": "Quiñonería"
	    },
	    {
	        "id": 5447,
	        "name": "Tarragona"
	    },
	    {
	        "id": 5448,
	        "name": "Mezquita de Jarque"
	    },
	    {
	        "id": 5449,
	        "name": "Robledo del Mazo"
	    },
	    {
	        "id": 5450,
	        "name": "Loriguilla"
	    },
	    {
	        "id": 5451,
	        "name": "San Pedro de Latarce"
	    },
	    {
	        "id": 5452,
	        "name": "Peleas de Abajo"
	    },
	    {
	        "id": 5453,
	        "name": "Luesia"
	    },
	    {
	        "id": 5454,
	        "name": "Narros de Saldueña"
	    },
	    {
	        "id": 5455,
	        "name": "Villafranca de los Barros"
	    },
	    {
	        "id": 5456,
	        "name": "Olost"
	    },
	    {
	        "id": 5457,
	        "name": "Grisaleña"
	    },
	    {
	        "id": 5458,
	        "name": "Plasenzuela"
	    },
	    {
	        "id": 5459,
	        "name": "Palomera"
	    },
	    {
	        "id": 5460,
	        "name": "Riudaura"
	    },
	    {
	        "id": 5461,
	        "name": "Otura"
	    },
	    {
	        "id": 5462,
	        "name": "Loarre"
	    },
	    {
	        "id": 5463,
	        "name": "San Millán de los Caballeros"
	    },
	    {
	        "id": 5464,
	        "name": "Oliana"
	    },
	    {
	        "id": 5465,
	        "name": "Tobía"
	    },
	    {
	        "id": 5466,
	        "name": "Torrejón de la Calzada"
	    },
	    {
	        "id": 5467,
	        "name": "Leitza"
	    },
	    {
	        "id": 5468,
	        "name": "Requena de Campos"
	    },
	    {
	        "id": 5469,
	        "name": "Garcirrey"
	    },
	    {
	        "id": 5470,
	        "name": "Olombrada"
	    },
	    {
	        "id": 5471,
	        "name": "Los Rábanos"
	    },
	    {
	        "id": 5472,
	        "name": "Tivenys"
	    },
	    {
	        "id": 5473,
	        "name": "Mirambel"
	    },
	    {
	        "id": 5474,
	        "name": "El Romeral"
	    },
	    {
	        "id": 5475,
	        "name": "Losa del Obispo"
	    },
	    {
	        "id": 5476,
	        "name": "San Pelayo"
	    },
	    {
	        "id": 5477,
	        "name": "Peñausende"
	    },
	    {
	        "id": 5478,
	        "name": "Luesma"
	    },
	    {
	        "id": 5479,
	        "name": "Villagarcía de la Torre"
	    },
	    {
	        "id": 5480,
	        "name": "Orís"
	    },
	    {
	        "id": 5481,
	        "name": "Portaje"
	    },
	    {
	        "id": 5482,
	        "name": "Paracuellos"
	    },
	    {
	        "id": 5483,
	        "name": "Riudellots de la Selva"
	    },
	    {
	        "id": 5484,
	        "name": "Padul"
	    },
	    {
	        "id": 5485,
	        "name": "Hueva"
	    },
	    {
	        "id": 5486,
	        "name": "Loporzano"
	    },
	    {
	        "id": 5487,
	        "name": "San Pedro Bercianos"
	    },
	    {
	        "id": 5488,
	        "name": "Oliola"
	    },
	    {
	        "id": 5489,
	        "name": "Tormantos"
	    },
	    {
	        "id": 5490,
	        "name": "Torrejón de Velasco"
	    },
	    {
	        "id": 5491,
	        "name": "Leoz/Leotz"
	    },
	    {
	        "id": 5492,
	        "name": "Gejuelo del Barro"
	    },
	    {
	        "id": 5493,
	        "name": "Orejana"
	    },
	    {
	        "id": 5494,
	        "name": "Tivissa"
	    },
	    {
	        "id": 5495,
	        "name": "Miravete de la Sierra"
	    },
	    {
	        "id": 5496,
	        "name": "San Bartolomé de las Abiertas"
	    },
	    {
	        "id": 5497,
	        "name": "Llutxent"
	    },
	    {
	        "id": 5498,
	        "name": "San Román de Hornija"
	    },
	    {
	        "id": 5499,
	        "name": "Peque"
	    },
	    {
	        "id": 5500,
	        "name": "Lumpiaque"
	    },
	    {
	        "id": 5501,
	        "name": "Navacepedilla de Corneja"
	    },
	    {
	        "id": 5502,
	        "name": "Villagonzalo"
	    },
	    {
	        "id": 5503,
	        "name": "Oristà"
	    },
	    {
	        "id": 5504,
	        "name": "Gumiel de Izán"
	    },
	    {
	        "id": 5505,
	        "name": "Portezuelo"
	    },
	    {
	        "id": 5506,
	        "name": "Paredes"
	    },
	    {
	        "id": 5507,
	        "name": "Riumors"
	    },
	    {
	        "id": 5508,
	        "name": "Pampaneira"
	    },
	    {
	        "id": 5509,
	        "name": "Humanes"
	    },
	    {
	        "id": 5510,
	        "name": "Loscorrales"
	    },
	    {
	        "id": 5511,
	        "name": "Santa Colomba de Curueño"
	    },
	    {
	        "id": 5512,
	        "name": "Olius"
	    },
	    {
	        "id": 5513,
	        "name": "Torrecilla en Cameros"
	    },
	    {
	        "id": 5514,
	        "name": "Torrelaguna"
	    },
	    {
	        "id": 5515,
	        "name": "Lerga"
	    },
	    {
	        "id": 5516,
	        "name": "Respenda de la Peña"
	    },
	    {
	        "id": 5517,
	        "name": "Golpejas"
	    },
	    {
	        "id": 5518,
	        "name": "Ortigosa de Pestaño"
	    },
	    {
	        "id": 5519,
	        "name": "Rebollar"
	    },
	    {
	        "id": 5520,
	        "name": "La Torre de Fontaubella"
	    },
	    {
	        "id": 5521,
	        "name": "Molinos"
	    },
	    {
	        "id": 5522,
	        "name": "San Martín de Montalbán"
	    },
	    {
	        "id": 5523,
	        "name": "Llocnou d'En Fenollet"
	    },
	    {
	        "id": 5524,
	        "name": "San Salvador"
	    },
	    {
	        "id": 5525,
	        "name": "El Perdigón"
	    },
	    {
	        "id": 5526,
	        "name": "Luna"
	    },
	    {
	        "id": 5527,
	        "name": "Nava de Arévalo"
	    },
	    {
	        "id": 5528,
	        "name": "Villalba de los Barros"
	    },
	    {
	        "id": 5529,
	        "name": "Orpí"
	    },
	    {
	        "id": 5530,
	        "name": "Gumiel de Mercado"
	    },
	    {
	        "id": 5531,
	        "name": "Pozuelo de Zarzón"
	    },
	    {
	        "id": 5532,
	        "name": "La Parra de las Vegas"
	    },
	    {
	        "id": 5533,
	        "name": "Roses"
	    },
	    {
	        "id": 5534,
	        "name": "Pedro Martínez"
	    },
	    {
	        "id": 5535,
	        "name": "Illana"
	    },
	    {
	        "id": 5536,
	        "name": "Santa Colomba de Somoza"
	    },
	    {
	        "id": 5537,
	        "name": "Les Oluges"
	    },
	    {
	        "id": 5538,
	        "name": "Torrecilla sobre Alesanco"
	    },
	    {
	        "id": 5539,
	        "name": "Torrelodones"
	    },
	    {
	        "id": 5540,
	        "name": "Lerín"
	    },
	    {
	        "id": 5541,
	        "name": "Revenga de Campos"
	    },
	    {
	        "id": 5542,
	        "name": "Gomecello"
	    },
	    {
	        "id": 5543,
	        "name": "Otero de Herreros"
	    },
	    {
	        "id": 5544,
	        "name": "Recuerda"
	    },
	    {
	        "id": 5545,
	        "name": "La Torre de l'Espanyol"
	    },
	    {
	        "id": 5546,
	        "name": "Monforte de Moyuela"
	    },
	    {
	        "id": 5547,
	        "name": "San Martín de Pusa"
	    },
	    {
	        "id": 5548,
	        "name": "Llocnou de la Corona"
	    },
	    {
	        "id": 5549,
	        "name": "Santa Eufemia del Arroyo"
	    },
	    {
	        "id": 5550,
	        "name": "Pereruela"
	    },
	    {
	        "id": 5551,
	        "name": "Maella"
	    },
	    {
	        "id": 5552,
	        "name": "Nava del Barco"
	    },
	    {
	        "id": 5553,
	        "name": "Villanueva de la Serena"
	    },
	    {
	        "id": 5554,
	        "name": "Òrrius"
	    },
	    {
	        "id": 5555,
	        "name": "Puerto de Santa Cruz"
	    },
	    {
	        "id": 5556,
	        "name": "El Pedernoso"
	    },
	    {
	        "id": 5557,
	        "name": "Rupià"
	    },
	    {
	        "id": 5558,
	        "name": "Peligros"
	    },
	    {
	        "id": 5559,
	        "name": "Iniéstola"
	    },
	    {
	        "id": 5560,
	        "name": "Santa Cristina de Valmadrigal"
	    },
	    {
	        "id": 5561,
	        "name": "Els Omellons"
	    },
	    {
	        "id": 5562,
	        "name": "Torre en Cameros"
	    },
	    {
	        "id": 5563,
	        "name": "Torremocha de Jarama"
	    },
	    {
	        "id": 5564,
	        "name": "Lesaka"
	    },
	    {
	        "id": 5565,
	        "name": "Rello"
	    },
	    {
	        "id": 5566,
	        "name": "Torredembarra"
	    },
	    {
	        "id": 5567,
	        "name": "Monreal del Campo"
	    },
	    {
	        "id": 5568,
	        "name": "San Pablo de los Montes"
	    },
	    {
	        "id": 5569,
	        "name": "Llocnou de Sant Jeroni"
	    },
	    {
	        "id": 5570,
	        "name": "Santervás de Campos"
	    },
	    {
	        "id": 5571,
	        "name": "Perilla de Castro"
	    },
	    {
	        "id": 5572,
	        "name": "Magallón"
	    },
	    {
	        "id": 5573,
	        "name": "Navadijos"
	    },
	    {
	        "id": 5574,
	        "name": "Villanueva del Fresno"
	    },
	    {
	        "id": 5575,
	        "name": "Pacs del Penedès"
	    },
	    {
	        "id": 5576,
	        "name": "Hacinas"
	    },
	    {
	        "id": 5577,
	        "name": "Rebollar"
	    },
	    {
	        "id": 5578,
	        "name": "Las Pedroñeras"
	    },
	    {
	        "id": 5579,
	        "name": "Sales de Llierca"
	    },
	    {
	        "id": 5580,
	        "name": "La Peza"
	    },
	    {
	        "id": 5581,
	        "name": "Las Inviernas"
	    },
	    {
	        "id": 5582,
	        "name": "Santa Elena de Jamuz"
	    },
	    {
	        "id": 5583,
	        "name": "Els Omells de na Gaia"
	    },
	    {
	        "id": 5584,
	        "name": "Torremontalbo"
	    },
	    {
	        "id": 5585,
	        "name": "Torres de la Alameda"
	    },
	    {
	        "id": 5586,
	        "name": "Lezáun"
	    },
	    {
	        "id": 5587,
	        "name": "Revilla de Collazos"
	    },
	    {
	        "id": 5588,
	        "name": "Guadramiro"
	    },
	    {
	        "id": 5589,
	        "name": "Pajarejos"
	    },
	    {
	        "id": 5590,
	        "name": "Renieblas"
	    },
	    {
	        "id": 5591,
	        "name": "Torroja del Priorat"
	    },
	    {
	        "id": 5592,
	        "name": "Monroyo"
	    },
	    {
	        "id": 5593,
	        "name": "San Román de los Montes"
	    },
	    {
	        "id": 5594,
	        "name": "Llanera de Ranes"
	    },
	    {
	        "id": 5595,
	        "name": "Santibáñez de Valcorba"
	    },
	    {
	        "id": 5596,
	        "name": "Pías"
	    },
	    {
	        "id": 5597,
	        "name": "Mainar"
	    },
	    {
	        "id": 5598,
	        "name": "Navaescurial"
	    },
	    {
	        "id": 5599,
	        "name": "Villar del Rey"
	    },
	    {
	        "id": 5600,
	        "name": "Palafolls"
	    },
	    {
	        "id": 5601,
	        "name": "Haza"
	    },
	    {
	        "id": 5602,
	        "name": "Riolobos"
	    },
	    {
	        "id": 5603,
	        "name": "El Peral"
	    },
	    {
	        "id": 5604,
	        "name": "Salt"
	    },
	    {
	        "id": 5605,
	        "name": "Irueste"
	    },
	    {
	        "id": 5606,
	        "name": "Monesma y Cajigar"
	    },
	    {
	        "id": 5607,
	        "name": "Santa María de la Isla"
	    },
	    {
	        "id": 5608,
	        "name": "Organyà"
	    },
	    {
	        "id": 5609,
	        "name": "Treviana"
	    },
	    {
	        "id": 5610,
	        "name": "Valdaracete"
	    },
	    {
	        "id": 5611,
	        "name": "Liédena"
	    },
	    {
	        "id": 5612,
	        "name": "Ribas de Campos"
	    },
	    {
	        "id": 5613,
	        "name": "Guijo de Ávila"
	    },
	    {
	        "id": 5614,
	        "name": "Palazuelos de Eresma"
	    },
	    {
	        "id": 5615,
	        "name": "Retortillo de Soria"
	    },
	    {
	        "id": 5616,
	        "name": "Tortosa"
	    },
	    {
	        "id": 5617,
	        "name": "Montalbán"
	    },
	    {
	        "id": 5618,
	        "name": "Santa Ana de Pusa"
	    },
	    {
	        "id": 5619,
	        "name": "Llaurí"
	    },
	    {
	        "id": 5620,
	        "name": "Santovenia de Pisuerga"
	    },
	    {
	        "id": 5621,
	        "name": "Piedrahita de Castro"
	    },
	    {
	        "id": 5622,
	        "name": "Malanquilla"
	    },
	    {
	        "id": 5623,
	        "name": "Navahondilla"
	    },
	    {
	        "id": 5624,
	        "name": "Villar de Rena"
	    },
	    {
	        "id": 5625,
	        "name": "Palau-solità i Plegamans"
	    },
	    {
	        "id": 5626,
	        "name": "Robledillo de Gata"
	    },
	    {
	        "id": 5627,
	        "name": "La Peraleja"
	    },
	    {
	        "id": 5628,
	        "name": "Jadraque"
	    },
	    {
	        "id": 5629,
	        "name": "Monflorite-Lascasas"
	    },
	    {
	        "id": 5630,
	        "name": "Santa María del Monte de Cea"
	    },
	    {
	        "id": 5631,
	        "name": "Os de Balaguer"
	    },
	    {
	        "id": 5632,
	        "name": "Valdeavero"
	    },
	    {
	        "id": 5633,
	        "name": "Lizoáin-Arriasgoiti"
	    },
	    {
	        "id": 5634,
	        "name": "Riberos de la Cueza"
	    },
	    {
	        "id": 5635,
	        "name": "Guijuelo"
	    },
	    {
	        "id": 5636,
	        "name": "Pedraza"
	    },
	    {
	        "id": 5637,
	        "name": "Reznos"
	    },
	    {
	        "id": 5638,
	        "name": "Ulldecona"
	    },
	    {
	        "id": 5639,
	        "name": "Monteagudo del Castillo"
	    },
	    {
	        "id": 5640,
	        "name": "Santa Cruz de la Zarza"
	    },
	    {
	        "id": 5641,
	        "name": "Llombai"
	    },
	    {
	        "id": 5642,
	        "name": "San Vicente del Palacio"
	    },
	    {
	        "id": 5643,
	        "name": "Pinilla de Toro"
	    },
	    {
	        "id": 5644,
	        "name": "Maleján"
	    },
	    {
	        "id": 5645,
	        "name": "Navalacruz"
	    },
	    {
	        "id": 5646,
	        "name": "Villarta de los Montes"
	    },
	    {
	        "id": 5647,
	        "name": "Pallejà"
	    },
	    {
	        "id": 5648,
	        "name": "Robledillo de la Vera"
	    },
	    {
	        "id": 5649,
	        "name": "La Pesquera"
	    },
	    {
	        "id": 5650,
	        "name": "Sant Andreu Salou"
	    },
	    {
	        "id": 5651,
	        "name": "Pinos Genil"
	    },
	    {
	        "id": 5652,
	        "name": "Jirueque"
	    },
	    {
	        "id": 5653,
	        "name": "Montanuy"
	    },
	    {
	        "id": 5654,
	        "name": "Santa María del Páramo"
	    },
	    {
	        "id": 5655,
	        "name": "Ossó de Sió"
	    },
	    {
	        "id": 5656,
	        "name": "Tricio"
	    },
	    {
	        "id": 5657,
	        "name": "Valdelaguna"
	    },
	    {
	        "id": 5658,
	        "name": "Lodosa"
	    },
	    {
	        "id": 5659,
	        "name": "Saldaña"
	    },
	    {
	        "id": 5660,
	        "name": "Herguijuela de Ciudad Rodrigo"
	    },
	    {
	        "id": 5661,
	        "name": "Pelayos del Arroyo"
	    },
	    {
	        "id": 5662,
	        "name": "La Riba de Escalote"
	    },
	    {
	        "id": 5663,
	        "name": "Ulldemolins"
	    },
	    {
	        "id": 5664,
	        "name": "Monterde de Albarracín"
	    },
	    {
	        "id": 5665,
	        "name": "Santa Cruz del Retamar"
	    },
	    {
	        "id": 5666,
	        "name": "la Llosa de Ranes"
	    },
	    {
	        "id": 5667,
	        "name": "Sardón de Duero"
	    },
	    {
	        "id": 5668,
	        "name": "Pino del Oro"
	    },
	    {
	        "id": 5669,
	        "name": "Malón"
	    },
	    {
	        "id": 5670,
	        "name": "Navalmoral"
	    },
	    {
	        "id": 5671,
	        "name": "Zafra"
	    },
	    {
	        "id": 5672,
	        "name": "El Papiol"
	    },
	    {
	        "id": 5673,
	        "name": "Robledillo de Trujillo"
	    },
	    {
	        "id": 5674,
	        "name": "El Picazo"
	    },
	    {
	        "id": 5675,
	        "name": "Sant Climent Sescebes"
	    },
	    {
	        "id": 5676,
	        "name": "Pinos Puente"
	    },
	    {
	        "id": 5677,
	        "name": "Monzón"
	    },
	    {
	        "id": 5678,
	        "name": "Santa María de Ordás"
	    },
	    {
	        "id": 5679,
	        "name": "El Palau d'Anglesola"
	    },
	    {
	        "id": 5680,
	        "name": "Tudelilla"
	    },
	    {
	        "id": 5681,
	        "name": "Valdemanco"
	    },
	    {
	        "id": 5682,
	        "name": "Lónguida/Longida"
	    },
	    {
	        "id": 5683,
	        "name": "Salinas de Pisuerga"
	    },
	    {
	        "id": 5684,
	        "name": "Herguijuela de la Sierra"
	    },
	    {
	        "id": 5685,
	        "name": "Perosillo"
	    },
	    {
	        "id": 5686,
	        "name": "Rioseco de Soria"
	    },
	    {
	        "id": 5687,
	        "name": "Vallclara"
	    },
	    {
	        "id": 5688,
	        "name": "Mora de Rubielos"
	    },
	    {
	        "id": 5689,
	        "name": "Santa Olalla"
	    },
	    {
	        "id": 5690,
	        "name": "Macastre"
	    },
	    {
	        "id": 5691,
	        "name": "La Seca"
	    },
	    {
	        "id": 5692,
	        "name": "El Piñero"
	    },
	    {
	        "id": 5693,
	        "name": "Navalonguilla"
	    },
	    {
	        "id": 5694,
	        "name": "Zahínos"
	    },
	    {
	        "id": 5695,
	        "name": "Parets del Vallès"
	    },
	    {
	        "id": 5696,
	        "name": "Hontanas"
	    },
	    {
	        "id": 5697,
	        "name": "Robledollano"
	    },
	    {
	        "id": 5698,
	        "name": "Pinarejo"
	    },
	    {
	        "id": 5699,
	        "name": "Sant Feliu de Buixalleu"
	    },
	    {
	        "id": 5700,
	        "name": "Píñar"
	    },
	    {
	        "id": 5701,
	        "name": "Ledanca"
	    },
	    {
	        "id": 5702,
	        "name": "Santa Marina del Rey"
	    },
	    {
	        "id": 5703,
	        "name": "Valdemaqueda"
	    },
	    {
	        "id": 5704,
	        "name": "Lumbier"
	    },
	    {
	        "id": 5705,
	        "name": "San Cebrián de Campos"
	    },
	    {
	        "id": 5706,
	        "name": "Herguijuela del Campo"
	    },
	    {
	        "id": 5707,
	        "name": "Pinarejos"
	    },
	    {
	        "id": 5708,
	        "name": "Rollamienta"
	    },
	    {
	        "id": 5709,
	        "name": "Vallfogona de Riucorb"
	    },
	    {
	        "id": 5710,
	        "name": "Moscardón"
	    },
	    {
	        "id": 5711,
	        "name": "Sartajada"
	    },
	    {
	        "id": 5712,
	        "name": "Manises"
	    },
	    {
	        "id": 5713,
	        "name": "Serrada"
	    },
	    {
	        "id": 5714,
	        "name": "Pobladura del Valle"
	    },
	    {
	        "id": 5715,
	        "name": "Maluenda"
	    },
	    {
	        "id": 5716,
	        "name": "Navalosa"
	    },
	    {
	        "id": 5717,
	        "name": "Zalamea de la Serena"
	    },
	    {
	        "id": 5718,
	        "name": "Perafita"
	    },
	    {
	        "id": 5719,
	        "name": "Hontangas"
	    },
	    {
	        "id": 5720,
	        "name": "Romangordo"
	    },
	    {
	        "id": 5721,
	        "name": "Pineda de Gigüela"
	    },
	    {
	        "id": 5722,
	        "name": "Sant Feliu de Guíxols"
	    },
	    {
	        "id": 5723,
	        "name": "Loranca de Tajuña"
	    },
	    {
	        "id": 5724,
	        "name": "Naval"
	    },
	    {
	        "id": 5725,
	        "name": "Santas Martas"
	    },
	    {
	        "id": 5726,
	        "name": "Uruñuela"
	    },
	    {
	        "id": 5727,
	        "name": "Valdemorillo"
	    },
	    {
	        "id": 5728,
	        "name": "Luquin"
	    },
	    {
	        "id": 5729,
	        "name": "San Cebrián de Mudá"
	    },
	    {
	        "id": 5730,
	        "name": "Hinojosa de Duero"
	    },
	    {
	        "id": 5731,
	        "name": "Pinarnegrillo"
	    },
	    {
	        "id": 5732,
	        "name": "El Royo"
	    },
	    {
	        "id": 5733,
	        "name": "Vallmoll"
	    },
	    {
	        "id": 5734,
	        "name": "Mosqueruela"
	    },
	    {
	        "id": 5735,
	        "name": "Segurilla"
	    },
	    {
	        "id": 5736,
	        "name": "Manuel"
	    },
	    {
	        "id": 5737,
	        "name": "Siete Iglesias de Trabancos"
	    },
	    {
	        "id": 5738,
	        "name": "Pobladura de Valderaduey"
	    },
	    {
	        "id": 5739,
	        "name": "Mallén"
	    },
	    {
	        "id": 5740,
	        "name": "Navalperal de Pinares"
	    },
	    {
	        "id": 5741,
	        "name": "Zarza-Capilla"
	    },
	    {
	        "id": 5742,
	        "name": "Piera"
	    },
	    {
	        "id": 5743,
	        "name": "Ruanes"
	    },
	    {
	        "id": 5744,
	        "name": "Piqueras del Castillo"
	    },
	    {
	        "id": 5745,
	        "name": "Sant Feliu de Pallerols"
	    },
	    {
	        "id": 5746,
	        "name": "Polícar"
	    },
	    {
	        "id": 5747,
	        "name": "Lupiana"
	    },
	    {
	        "id": 5748,
	        "name": "Santiago Millas"
	    },
	    {
	        "id": 5749,
	        "name": "Conca de Dalt"
	    },
	    {
	        "id": 5750,
	        "name": "Valdemadera"
	    },
	    {
	        "id": 5751,
	        "name": "Valdemoro"
	    },
	    {
	        "id": 5752,
	        "name": "Mañeru"
	    },
	    {
	        "id": 5753,
	        "name": "San Cristóbal de Boedo"
	    },
	    {
	        "id": 5754,
	        "name": "Horcajo de Montemayor"
	    },
	    {
	        "id": 5755,
	        "name": "Pradales"
	    },
	    {
	        "id": 5756,
	        "name": "Salduero"
	    },
	    {
	        "id": 5757,
	        "name": "Valls"
	    },
	    {
	        "id": 5758,
	        "name": "Muniesa"
	    },
	    {
	        "id": 5759,
	        "name": "Seseña"
	    },
	    {
	        "id": 5760,
	        "name": "Marines"
	    },
	    {
	        "id": 5761,
	        "name": "Simancas"
	    },
	    {
	        "id": 5762,
	        "name": "Manchones"
	    },
	    {
	        "id": 5763,
	        "name": "Navalperal de Tormes"
	    },
	    {
	        "id": 5764,
	        "name": "La Zarza"
	    },
	    {
	        "id": 5765,
	        "name": "Els Hostalets de Pierola"
	    },
	    {
	        "id": 5766,
	        "name": "Hontoria de la Cantera"
	    },
	    {
	        "id": 5767,
	        "name": "Salorino"
	    },
	    {
	        "id": 5768,
	        "name": "Portalrubio de Guadamejud"
	    },
	    {
	        "id": 5769,
	        "name": "Sant Ferriol"
	    },
	    {
	        "id": 5770,
	        "name": "Polopos"
	    },
	    {
	        "id": 5771,
	        "name": "Luzaga"
	    },
	    {
	        "id": 5772,
	        "name": "Novales"
	    },
	    {
	        "id": 5773,
	        "name": "Santovenia de la Valdoncina"
	    },
	    {
	        "id": 5774,
	        "name": "Valgañón"
	    },
	    {
	        "id": 5775,
	        "name": "Valdeolmos-Alalpardo"
	    },
	    {
	        "id": 5776,
	        "name": "Marañón"
	    },
	    {
	        "id": 5777,
	        "name": "Horcajo Medianero"
	    },
	    {
	        "id": 5778,
	        "name": "Prádena"
	    },
	    {
	        "id": 5779,
	        "name": "San Esteban de Gormaz"
	    },
	    {
	        "id": 5780,
	        "name": "Vandellòs i l'Hospitalet de l'Infant"
	    },
	    {
	        "id": 5781,
	        "name": "Sevilleja de la Jara"
	    },
	    {
	        "id": 5782,
	        "name": "Massalavés"
	    },
	    {
	        "id": 5783,
	        "name": "Tamariz de Campos"
	    },
	    {
	        "id": 5784,
	        "name": "Porto"
	    },
	    {
	        "id": 5785,
	        "name": "Mara"
	    },
	    {
	        "id": 5786,
	        "name": "Navaluenga"
	    },
	    {
	        "id": 5787,
	        "name": "Pineda de Mar"
	    },
	    {
	        "id": 5788,
	        "name": "Hontoria del Pinar"
	    },
	    {
	        "id": 5789,
	        "name": "Salvatierra de Santiago"
	    },
	    {
	        "id": 5790,
	        "name": "Portilla"
	    },
	    {
	        "id": 5791,
	        "name": "Sant Gregori"
	    },
	    {
	        "id": 5792,
	        "name": "Pórtugos"
	    },
	    {
	        "id": 5793,
	        "name": "Luzón"
	    },
	    {
	        "id": 5794,
	        "name": "Nueno"
	    },
	    {
	        "id": 5795,
	        "name": "Sariegos"
	    },
	    {
	        "id": 5796,
	        "name": "La Coma i la Pedra"
	    },
	    {
	        "id": 5797,
	        "name": "Ventosa"
	    },
	    {
	        "id": 5798,
	        "name": "Valdepiélagos"
	    },
	    {
	        "id": 5799,
	        "name": "Marcilla"
	    },
	    {
	        "id": 5800,
	        "name": "San Mamés de Campos"
	    },
	    {
	        "id": 5801,
	        "name": "La Hoya"
	    },
	    {
	        "id": 5802,
	        "name": "Puebla de Pedraza"
	    },
	    {
	        "id": 5803,
	        "name": "San Felices"
	    },
	    {
	        "id": 5804,
	        "name": "El Vendrell"
	    },
	    {
	        "id": 5805,
	        "name": "Noguera de Albarracín"
	    },
	    {
	        "id": 5806,
	        "name": "Sonseca"
	    },
	    {
	        "id": 5807,
	        "name": "Massalfassar"
	    },
	    {
	        "id": 5808,
	        "name": "Tiedra"
	    },
	    {
	        "id": 5809,
	        "name": "Pozoantiguo"
	    },
	    {
	        "id": 5810,
	        "name": "María de Huerva"
	    },
	    {
	        "id": 5811,
	        "name": "Navaquesera"
	    },
	    {
	        "id": 5812,
	        "name": "El Pla del Penedès"
	    },
	    {
	        "id": 5813,
	        "name": "Hontoria de Valdearados"
	    },
	    {
	        "id": 5814,
	        "name": "San Martín de Trevejo"
	    },
	    {
	        "id": 5815,
	        "name": "Sant Hilari Sacalm"
	    },
	    {
	        "id": 5816,
	        "name": "Puebla de Don Fadrique"
	    },
	    {
	        "id": 5817,
	        "name": "Olvena"
	    },
	    {
	        "id": 5818,
	        "name": "Sena de Luna"
	    },
	    {
	        "id": 5819,
	        "name": "Penelles"
	    },
	    {
	        "id": 5820,
	        "name": "Ventrosa"
	    },
	    {
	        "id": 5821,
	        "name": "Valdetorres de Jarama"
	    },
	    {
	        "id": 5822,
	        "name": "Mélida"
	    },
	    {
	        "id": 5823,
	        "name": "Huerta"
	    },
	    {
	        "id": 5824,
	        "name": "Rapariegos"
	    },
	    {
	        "id": 5825,
	        "name": "San Leonardo de Yagüe"
	    },
	    {
	        "id": 5826,
	        "name": "Vespella de Gaià"
	    },
	    {
	        "id": 5827,
	        "name": "Nogueras"
	    },
	    {
	        "id": 5828,
	        "name": "Sotillo de las Palomas"
	    },
	    {
	        "id": 5829,
	        "name": "Massamagrell"
	    },
	    {
	        "id": 5830,
	        "name": "Tordehumos"
	    },
	    {
	        "id": 5831,
	        "name": "Pozuelo de Tábara"
	    },
	    {
	        "id": 5832,
	        "name": "Mediana de Aragón"
	    },
	    {
	        "id": 5833,
	        "name": "Navarredonda de Gredos"
	    },
	    {
	        "id": 5834,
	        "name": "La Pobla de Claramunt"
	    },
	    {
	        "id": 5835,
	        "name": "Santa Ana"
	    },
	    {
	        "id": 5836,
	        "name": "Poyatos"
	    },
	    {
	        "id": 5837,
	        "name": "Sant Jaume de Llierca"
	    },
	    {
	        "id": 5838,
	        "name": "Pulianas"
	    },
	    {
	        "id": 5839,
	        "name": "Majaelrayo"
	    },
	    {
	        "id": 5840,
	        "name": "Ontiñena"
	    },
	    {
	        "id": 5841,
	        "name": "Sobrado"
	    },
	    {
	        "id": 5842,
	        "name": "Peramola"
	    },
	    {
	        "id": 5843,
	        "name": "Viguera"
	    },
	    {
	        "id": 5844,
	        "name": "Valdilecha"
	    },
	    {
	        "id": 5845,
	        "name": "Mendavia"
	    },
	    {
	        "id": 5846,
	        "name": "San Román de la Cuba"
	    },
	    {
	        "id": 5847,
	        "name": "Iruelos"
	    },
	    {
	        "id": 5848,
	        "name": "Rebollo"
	    },
	    {
	        "id": 5849,
	        "name": "San Pedro Manrique"
	    },
	    {
	        "id": 5850,
	        "name": "Vilabella"
	    },
	    {
	        "id": 5851,
	        "name": "Nogueruelas"
	    },
	    {
	        "id": 5852,
	        "name": "Talavera de la Reina"
	    },
	    {
	        "id": 5853,
	        "name": "Massanassa"
	    },
	    {
	        "id": 5854,
	        "name": "Tordesillas"
	    },
	    {
	        "id": 5855,
	        "name": "Prado"
	    },
	    {
	        "id": 5856,
	        "name": "Mequinenza"
	    },
	    {
	        "id": 5857,
	        "name": "Navarredondilla"
	    },
	    {
	        "id": 5858,
	        "name": "La Pobla de Lillet"
	    },
	    {
	        "id": 5859,
	        "name": "Las Hormazas"
	    },
	    {
	        "id": 5860,
	        "name": "Santa Cruz de la Sierra"
	    },
	    {
	        "id": 5861,
	        "name": "Pozoamargo"
	    },
	    {
	        "id": 5862,
	        "name": "Sant Jordi Desvalls"
	    },
	    {
	        "id": 5863,
	        "name": "Málaga del Fresno"
	    },
	    {
	        "id": 5864,
	        "name": "Soto de la Vega"
	    },
	    {
	        "id": 5865,
	        "name": "Pinell de Solsonès"
	    },
	    {
	        "id": 5866,
	        "name": "Villalba de Rioja"
	    },
	    {
	        "id": 5867,
	        "name": "Valverde de Alcalá"
	    },
	    {
	        "id": 5868,
	        "name": "Mendaza"
	    },
	    {
	        "id": 5869,
	        "name": "Ituero de Azaba"
	    },
	    {
	        "id": 5870,
	        "name": "Remondo"
	    },
	    {
	        "id": 5871,
	        "name": "Santa Cruz de Yanguas"
	    },
	    {
	        "id": 5872,
	        "name": "Vilallonga del Camp"
	    },
	    {
	        "id": 5873,
	        "name": "Tembleque"
	    },
	    {
	        "id": 5874,
	        "name": "Meliana"
	    },
	    {
	        "id": 5875,
	        "name": "Torrecilla de la Abadesa"
	    },
	    {
	        "id": 5876,
	        "name": "Puebla de Sanabria"
	    },
	    {
	        "id": 5877,
	        "name": "Mesones de Isuela"
	    },
	    {
	        "id": 5878,
	        "name": "Navarrevisca"
	    },
	    {
	        "id": 5879,
	        "name": "Polinyà"
	    },
	    {
	        "id": 5880,
	        "name": "Hornillos del Camino"
	    },
	    {
	        "id": 5881,
	        "name": "Santa Cruz de Paniagua"
	    },
	    {
	        "id": 5882,
	        "name": "Pozorrubio"
	    },
	    {
	        "id": 5883,
	        "name": "Sant Joan de les Abadesses"
	    },
	    {
	        "id": 5884,
	        "name": "Purullena"
	    },
	    {
	        "id": 5885,
	        "name": "Malaguilla"
	    },
	    {
	        "id": 5886,
	        "name": "Osso de Cinca"
	    },
	    {
	        "id": 5887,
	        "name": "Soto y Amío"
	    },
	    {
	        "id": 5888,
	        "name": "Pinós"
	    },
	    {
	        "id": 5889,
	        "name": "Villalobar de Rioja"
	    },
	    {
	        "id": 5890,
	        "name": "Velilla de San Antonio"
	    },
	    {
	        "id": 5891,
	        "name": "Mendigorría"
	    },
	    {
	        "id": 5892,
	        "name": "Santa Cecilia del Alcor"
	    },
	    {
	        "id": 5893,
	        "name": "Juzbado"
	    },
	    {
	        "id": 5894,
	        "name": "Santa María de Huerta"
	    },
	    {
	        "id": 5895,
	        "name": "Vilanova d'Escornalbou"
	    },
	    {
	        "id": 5896,
	        "name": "Obón"
	    },
	    {
	        "id": 5897,
	        "name": "El Toboso"
	    },
	    {
	        "id": 5898,
	        "name": "Millares"
	    },
	    {
	        "id": 5899,
	        "name": "Torrecilla de la Orden"
	    },
	    {
	        "id": 5900,
	        "name": "Pueblica de Valverde"
	    },
	    {
	        "id": 5901,
	        "name": "Mezalocha"
	    },
	    {
	        "id": 5902,
	        "name": "Las Navas del Marqués"
	    },
	    {
	        "id": 5903,
	        "name": "Pontons"
	    },
	    {
	        "id": 5904,
	        "name": "La Horra"
	    },
	    {
	        "id": 5905,
	        "name": "Santa Marta de Magasca"
	    },
	    {
	        "id": 5906,
	        "name": "Sant Joan de Mollet"
	    },
	    {
	        "id": 5907,
	        "name": "Quéntar"
	    },
	    {
	        "id": 5908,
	        "name": "Mandayona"
	    },
	    {
	        "id": 5909,
	        "name": "Palo"
	    },
	    {
	        "id": 5910,
	        "name": "Toral de los Guzmanes"
	    },
	    {
	        "id": 5911,
	        "name": "El Poal"
	    },
	    {
	        "id": 5912,
	        "name": "Villamediana de Iregua"
	    },
	    {
	        "id": 5913,
	        "name": "El Vellón"
	    },
	    {
	        "id": 5914,
	        "name": "Metauten"
	    },
	    {
	        "id": 5915,
	        "name": "Santa Cruz de Boedo"
	    },
	    {
	        "id": 5916,
	        "name": "Lagunilla"
	    },
	    {
	        "id": 5917,
	        "name": "Riaguas de San Bartolomé"
	    },
	    {
	        "id": 5918,
	        "name": "Santa María de las Hoyas"
	    },
	    {
	        "id": 5919,
	        "name": "Vilanova de Prades"
	    },
	    {
	        "id": 5920,
	        "name": "Odón"
	    },
	    {
	        "id": 5921,
	        "name": "Toledo"
	    },
	    {
	        "id": 5922,
	        "name": "Miramar"
	    },
	    {
	        "id": 5923,
	        "name": "Torrecilla de la Torre"
	    },
	    {
	        "id": 5924,
	        "name": "Quintanilla del Monte"
	    },
	    {
	        "id": 5925,
	        "name": "Mianos"
	    },
	    {
	        "id": 5926,
	        "name": "Navatalgordo"
	    },
	    {
	        "id": 5927,
	        "name": "El Prat de Llobregat"
	    },
	    {
	        "id": 5928,
	        "name": "Hortigüela"
	    },
	    {
	        "id": 5929,
	        "name": "Santiago de Alcántara"
	    },
	    {
	        "id": 5930,
	        "name": "El Pozuelo"
	    },
	    {
	        "id": 5931,
	        "name": "Sant Julià de Ramis"
	    },
	    {
	        "id": 5932,
	        "name": "Mantiel"
	    },
	    {
	        "id": 5933,
	        "name": "Toreno"
	    },
	    {
	        "id": 5934,
	        "name": "La Pobla de Cérvoles"
	    },
	    {
	        "id": 5935,
	        "name": "Villanueva de Cameros"
	    },
	    {
	        "id": 5936,
	        "name": "Venturada"
	    },
	    {
	        "id": 5937,
	        "name": "Milagro"
	    },
	    {
	        "id": 5938,
	        "name": "Santervás de la Vega"
	    },
	    {
	        "id": 5939,
	        "name": "Larrodrigo"
	    },
	    {
	        "id": 5940,
	        "name": "Vilaplana"
	    },
	    {
	        "id": 5941,
	        "name": "Ojos Negros"
	    },
	    {
	        "id": 5942,
	        "name": "Torralba de Oropesa"
	    },
	    {
	        "id": 5943,
	        "name": "Mislata"
	    },
	    {
	        "id": 5944,
	        "name": "Torre de Esgueva"
	    },
	    {
	        "id": 5945,
	        "name": "Quintanilla del Olmo"
	    },
	    {
	        "id": 5946,
	        "name": "Miedes de Aragón"
	    },
	    {
	        "id": 5947,
	        "name": "Navatejares"
	    },
	    {
	        "id": 5948,
	        "name": "Els Prats de Rei"
	    },
	    {
	        "id": 5949,
	        "name": "Hoyales de Roa"
	    },
	    {
	        "id": 5950,
	        "name": "Santiago del Campo"
	    },
	    {
	        "id": 5951,
	        "name": "Priego"
	    },
	    {
	        "id": 5952,
	        "name": "Vallfogona de Ripollès"
	    },
	    {
	        "id": 5953,
	        "name": "Rubite"
	    },
	    {
	        "id": 5954,
	        "name": "Maranchón"
	    },
	    {
	        "id": 5955,
	        "name": "Panticosa"
	    },
	    {
	        "id": 5956,
	        "name": "Torre del Bierzo"
	    },
	    {
	        "id": 5957,
	        "name": "Bellaguarda"
	    },
	    {
	        "id": 5958,
	        "name": "El Villar de Arnedo"
	    },
	    {
	        "id": 5959,
	        "name": "Villaconejos"
	    },
	    {
	        "id": 5960,
	        "name": "Mirafuentes"
	    },
	    {
	        "id": 5961,
	        "name": "Santibáñez de Ecla"
	    },
	    {
	        "id": 5962,
	        "name": "Ledesma"
	    },
	    {
	        "id": 5963,
	        "name": "Riaza"
	    },
	    {
	        "id": 5964,
	        "name": "Vila-rodona"
	    },
	    {
	        "id": 5965,
	        "name": "Torrecilla de la Jara"
	    },
	    {
	        "id": 5966,
	        "name": "Mogente/Moixent"
	    },
	    {
	        "id": 5967,
	        "name": "Torre de Peñafiel"
	    },
	    {
	        "id": 5968,
	        "name": "Quintanilla de Urz"
	    },
	    {
	        "id": 5969,
	        "name": "Monegrillo"
	    },
	    {
	        "id": 5970,
	        "name": "Neila de San Miguel"
	    },
	    {
	        "id": 5971,
	        "name": "Prats de Lluçanès"
	    },
	    {
	        "id": 5972,
	        "name": "Santibáñez el Alto"
	    },
	    {
	        "id": 5973,
	        "name": "El Provencio"
	    },
	    {
	        "id": 5974,
	        "name": "Sant Llorenç de la Muga"
	    },
	    {
	        "id": 5975,
	        "name": "Salar"
	    },
	    {
	        "id": 5976,
	        "name": "Marchamalo"
	    },
	    {
	        "id": 5977,
	        "name": "Trabadelo"
	    },
	    {
	        "id": 5978,
	        "name": "La Pobla de Segur"
	    },
	    {
	        "id": 5979,
	        "name": "Villar de Torre"
	    },
	    {
	        "id": 5980,
	        "name": "Villa del Prado"
	    },
	    {
	        "id": 5981,
	        "name": "Miranda de Arga"
	    },
	    {
	        "id": 5982,
	        "name": "Santibáñez de la Peña"
	    },
	    {
	        "id": 5983,
	        "name": "Ledrada"
	    },
	    {
	        "id": 5984,
	        "name": "Ribota"
	    },
	    {
	        "id": 5985,
	        "name": "Serón de Nágima"
	    },
	    {
	        "id": 5986,
	        "name": "Vila-seca"
	    },
	    {
	        "id": 5987,
	        "name": "Olba"
	    },
	    {
	        "id": 5988,
	        "name": "La Torre de Esteban Hambrán"
	    },
	    {
	        "id": 5989,
	        "name": "Moncada"
	    },
	    {
	        "id": 5990,
	        "name": "Torrelobatón"
	    },
	    {
	        "id": 5991,
	        "name": "Quiruelas de Vidriales"
	    },
	    {
	        "id": 5992,
	        "name": "Moneva"
	    },
	    {
	        "id": 5993,
	        "name": "Niharra"
	    },
	    {
	        "id": 5994,
	        "name": "Premià de Mar"
	    },
	    {
	        "id": 5995,
	        "name": "Huérmeces"
	    },
	    {
	        "id": 5996,
	        "name": "Santibáñez el Bajo"
	    },
	    {
	        "id": 5997,
	        "name": "Puebla de Almenara"
	    },
	    {
	        "id": 5998,
	        "name": "Sant Martí de Llémena"
	    },
	    {
	        "id": 5999,
	        "name": "Masegoso de Tajuña"
	    },
	    {
	        "id": 6000,
	        "name": "Peñalba"
	    },
	    {
	        "id": 6001,
	        "name": "Truchas"
	    },
	    {
	        "id": 6002,
	        "name": "Ponts"
	    },
	    {
	        "id": 6003,
	        "name": "Villarejo"
	    },
	    {
	        "id": 6004,
	        "name": "Villalbilla"
	    },
	    {
	        "id": 6005,
	        "name": "Monreal/Elo"
	    },
	    {
	        "id": 6006,
	        "name": "Linares de Riofrío"
	    },
	    {
	        "id": 6007,
	        "name": "Riofrío de Riaza"
	    },
	    {
	        "id": 6008,
	        "name": "Soliedra"
	    },
	    {
	        "id": 6009,
	        "name": "Vilaverd"
	    },
	    {
	        "id": 6010,
	        "name": "Oliete"
	    },
	    {
	        "id": 6011,
	        "name": "Torrico"
	    },
	    {
	        "id": 6012,
	        "name": "Montserrat"
	    },
	    {
	        "id": 6013,
	        "name": "Torrescárcela"
	    },
	    {
	        "id": 6014,
	        "name": "Rabanales"
	    },
	    {
	        "id": 6015,
	        "name": "Monreal de Ariza"
	    },
	    {
	        "id": 6016,
	        "name": "Ojos-Albos"
	    },
	    {
	        "id": 6017,
	        "name": "Huerta de Arriba"
	    },
	    {
	        "id": 6018,
	        "name": "Saucedilla"
	    },
	    {
	        "id": 6019,
	        "name": "El Valle de Altomira"
	    },
	    {
	        "id": 6020,
	        "name": "Sant Martí Vell"
	    },
	    {
	        "id": 6021,
	        "name": "Salobreña"
	    },
	    {
	        "id": 6022,
	        "name": "Matarrubia"
	    },
	    {
	        "id": 6023,
	        "name": "Las Peñas de Riglos"
	    },
	    {
	        "id": 6024,
	        "name": "Turcia"
	    },
	    {
	        "id": 6025,
	        "name": "El Pont de Suert"
	    },
	    {
	        "id": 6026,
	        "name": "Villarroya"
	    },
	    {
	        "id": 6027,
	        "name": "Villamanrique de Tajo"
	    },
	    {
	        "id": 6028,
	        "name": "Monteagudo"
	    },
	    {
	        "id": 6029,
	        "name": "Lumbrales"
	    },
	    {
	        "id": 6030,
	        "name": "Roda de Eresma"
	    },
	    {
	        "id": 6031,
	        "name": "Soria"
	    },
	    {
	        "id": 6032,
	        "name": "La Vilella Alta"
	    },
	    {
	        "id": 6033,
	        "name": "Los Olmos"
	    },
	    {
	        "id": 6034,
	        "name": "Torrijos"
	    },
	    {
	        "id": 6035,
	        "name": "Montaverner"
	    },
	    {
	        "id": 6036,
	        "name": "Traspinedo"
	    },
	    {
	        "id": 6037,
	        "name": "Rábano de Aliste"
	    },
	    {
	        "id": 6038,
	        "name": "Monterde"
	    },
	    {
	        "id": 6039,
	        "name": "Orbita"
	    },
	    {
	        "id": 6040,
	        "name": "Puigdàlber"
	    },
	    {
	        "id": 6041,
	        "name": "Huerta de Rey"
	    },
	    {
	        "id": 6042,
	        "name": "Segura de Toro"
	    },
	    {
	        "id": 6043,
	        "name": "Puebla del Salvador"
	    },
	    {
	        "id": 6044,
	        "name": "Sant Miquel de Campmajor"
	    },
	    {
	        "id": 6045,
	        "name": "Santa Cruz del Comercio"
	    },
	    {
	        "id": 6046,
	        "name": "Matillas"
	    },
	    {
	        "id": 6047,
	        "name": "Peralta de Alcofea"
	    },
	    {
	        "id": 6048,
	        "name": "Urdiales del Páramo"
	    },
	    {
	        "id": 6049,
	        "name": "La Portella"
	    },
	    {
	        "id": 6050,
	        "name": "Villarta-Quintana"
	    },
	    {
	        "id": 6051,
	        "name": "Villamanta"
	    },
	    {
	        "id": 6052,
	        "name": "Morentin"
	    },
	    {
	        "id": 6053,
	        "name": "Santoyo"
	    },
	    {
	        "id": 6054,
	        "name": "Macotera"
	    },
	    {
	        "id": 6055,
	        "name": "Sacramenia"
	    },
	    {
	        "id": 6056,
	        "name": "Sotillo del Rincón"
	    },
	    {
	        "id": 6057,
	        "name": "La Vilella Baixa"
	    },
	    {
	        "id": 6058,
	        "name": "Orihuela del Tremedal"
	    },
	    {
	        "id": 6059,
	        "name": "Totanés"
	    },
	    {
	        "id": 6060,
	        "name": "Montesa"
	    },
	    {
	        "id": 6061,
	        "name": "Trigueros del Valle"
	    },
	    {
	        "id": 6062,
	        "name": "Requejo"
	    },
	    {
	        "id": 6063,
	        "name": "Montón"
	    },
	    {
	        "id": 6064,
	        "name": "El Oso"
	    },
	    {
	        "id": 6065,
	        "name": "Puig-reig"
	    },
	    {
	        "id": 6066,
	        "name": "Humada"
	    },
	    {
	        "id": 6067,
	        "name": "Serradilla"
	    },
	    {
	        "id": 6068,
	        "name": "Quintanar del Rey"
	    },
	    {
	        "id": 6069,
	        "name": "Sant Miquel de Fluvià"
	    },
	    {
	        "id": 6070,
	        "name": "Santa Fe"
	    },
	    {
	        "id": 6071,
	        "name": "Mazarete"
	    },
	    {
	        "id": 6072,
	        "name": "Peralta de Calasanz"
	    },
	    {
	        "id": 6073,
	        "name": "Valdefresno"
	    },
	    {
	        "id": 6074,
	        "name": "Prats i Sansor"
	    },
	    {
	        "id": 6075,
	        "name": "Villavelayo"
	    },
	    {
	        "id": 6076,
	        "name": "Villamantilla"
	    },
	    {
	        "id": 6077,
	        "name": "Mues"
	    },
	    {
	        "id": 6078,
	        "name": "La Serna"
	    },
	    {
	        "id": 6079,
	        "name": "Machacón"
	    },
	    {
	        "id": 6080,
	        "name": "Suellacabras"
	    },
	    {
	        "id": 6081,
	        "name": "Vilalba dels Arcs"
	    },
	    {
	        "id": 6082,
	        "name": "Orrios"
	    },
	    {
	        "id": 6083,
	        "name": "Turleque"
	    },
	    {
	        "id": 6084,
	        "name": "Montitxelvo/Montichelvo"
	    },
	    {
	        "id": 6085,
	        "name": "Tudela de Duero"
	    },
	    {
	        "id": 6086,
	        "name": "Revellinos"
	    },
	    {
	        "id": 6087,
	        "name": "Morata de Jalón"
	    },
	    {
	        "id": 6088,
	        "name": "Padiernos"
	    },
	    {
	        "id": 6089,
	        "name": "Pujalt"
	    },
	    {
	        "id": 6090,
	        "name": "Hurones"
	    },
	    {
	        "id": 6091,
	        "name": "Serrejón"
	    },
	    {
	        "id": 6092,
	        "name": "Rada de Haro"
	    },
	    {
	        "id": 6093,
	        "name": "Sant Mori"
	    },
	    {
	        "id": 6094,
	        "name": "Soportújar"
	    },
	    {
	        "id": 6095,
	        "name": "Mazuecos"
	    },
	    {
	        "id": 6096,
	        "name": "Peraltilla"
	    },
	    {
	        "id": 6097,
	        "name": "Valdefuentes del Páramo"
	    },
	    {
	        "id": 6098,
	        "name": "Preixana"
	    },
	    {
	        "id": 6099,
	        "name": "Villaverde de Rioja"
	    },
	    {
	        "id": 6100,
	        "name": "Villanueva de la Cañada"
	    },
	    {
	        "id": 6101,
	        "name": "Murchante"
	    },
	    {
	        "id": 6102,
	        "name": "Sotobañado y Priorato"
	    },
	    {
	        "id": 6103,
	        "name": "Madroñal"
	    },
	    {
	        "id": 6104,
	        "name": "Samboal"
	    },
	    {
	        "id": 6105,
	        "name": "Tajahuerce"
	    },
	    {
	        "id": 6106,
	        "name": "Vimbodí i Poblet"
	    },
	    {
	        "id": 6107,
	        "name": "Palomar de Arroyos"
	    },
	    {
	        "id": 6108,
	        "name": "Ugena"
	    },
	    {
	        "id": 6109,
	        "name": "Montroy"
	    },
	    {
	        "id": 6110,
	        "name": "La Unión de Campos"
	    },
	    {
	        "id": 6111,
	        "name": "Riofrío de Aliste"
	    },
	    {
	        "id": 6112,
	        "name": "Morata de Jiloca"
	    },
	    {
	        "id": 6113,
	        "name": "Pajares de Adaja"
	    },
	    {
	        "id": 6114,
	        "name": "La Quar"
	    },
	    {
	        "id": 6115,
	        "name": "Ibeas de Juarros"
	    },
	    {
	        "id": 6116,
	        "name": "Sierra de Fuentes"
	    },
	    {
	        "id": 6117,
	        "name": "Reíllo"
	    },
	    {
	        "id": 6118,
	        "name": "Sant Pau de Segúries"
	    },
	    {
	        "id": 6119,
	        "name": "Sorvilán"
	    },
	    {
	        "id": 6120,
	        "name": "Medranda"
	    },
	    {
	        "id": 6121,
	        "name": "Perarrúa"
	    },
	    {
	        "id": 6122,
	        "name": "Valdelugueros"
	    },
	    {
	        "id": 6123,
	        "name": "Preixens"
	    },
	    {
	        "id": 6124,
	        "name": "Villoslada de Cameros"
	    },
	    {
	        "id": 6125,
	        "name": "Villanueva del Pardillo"
	    },
	    {
	        "id": 6126,
	        "name": "Murieta"
	    },
	    {
	        "id": 6127,
	        "name": "Soto de Cerrato"
	    },
	    {
	        "id": 6128,
	        "name": "El Maíllo"
	    },
	    {
	        "id": 6129,
	        "name": "San Cristóbal de Cuéllar"
	    },
	    {
	        "id": 6130,
	        "name": "Tajueco"
	    },
	    {
	        "id": 6131,
	        "name": "Vinebre"
	    },
	    {
	        "id": 6132,
	        "name": "Pancrudo"
	    },
	    {
	        "id": 6133,
	        "name": "Urda"
	    },
	    {
	        "id": 6134,
	        "name": "Museros"
	    },
	    {
	        "id": 6135,
	        "name": "Urones de Castroponce"
	    },
	    {
	        "id": 6136,
	        "name": "Rionegro del Puente"
	    },
	    {
	        "id": 6137,
	        "name": "Morés"
	    },
	    {
	        "id": 6138,
	        "name": "Palacios de Goda"
	    },
	    {
	        "id": 6139,
	        "name": "Rajadell"
	    },
	    {
	        "id": 6140,
	        "name": "Ibrillos"
	    },
	    {
	        "id": 6141,
	        "name": "Talaván"
	    },
	    {
	        "id": 6142,
	        "name": "Sant Pere Pescador"
	    },
	    {
	        "id": 6143,
	        "name": "Torre-Cardela"
	    },
	    {
	        "id": 6144,
	        "name": "Megina"
	    },
	    {
	        "id": 6145,
	        "name": "Pertusa"
	    },
	    {
	        "id": 6146,
	        "name": "Valdemora"
	    },
	    {
	        "id": 6147,
	        "name": "Viniegra de Abajo"
	    },
	    {
	        "id": 6148,
	        "name": "Villanueva de Perales"
	    },
	    {
	        "id": 6149,
	        "name": "Murillo el Cuende"
	    },
	    {
	        "id": 6150,
	        "name": "Tabanera de Cerrato"
	    },
	    {
	        "id": 6151,
	        "name": "Malpartida"
	    },
	    {
	        "id": 6152,
	        "name": "San Cristóbal de la Vega"
	    },
	    {
	        "id": 6153,
	        "name": "Talveila"
	    },
	    {
	        "id": 6154,
	        "name": "Vinyols i els Arcs"
	    },
	    {
	        "id": 6155,
	        "name": "Las Parras de Castellote"
	    },
	    {
	        "id": 6156,
	        "name": "Náquera"
	    },
	    {
	        "id": 6157,
	        "name": "Urueña"
	    },
	    {
	        "id": 6158,
	        "name": "Roales"
	    },
	    {
	        "id": 6159,
	        "name": "Moros"
	    },
	    {
	        "id": 6160,
	        "name": "Papatrigo"
	    },
	    {
	        "id": 6161,
	        "name": "Rellinars"
	    },
	    {
	        "id": 6162,
	        "name": "Iglesiarrubia"
	    },
	    {
	        "id": 6163,
	        "name": "Talaveruela de la Vera"
	    },
	    {
	        "id": 6164,
	        "name": "Torvizcón"
	    },
	    {
	        "id": 6165,
	        "name": "Membrillera"
	    },
	    {
	        "id": 6166,
	        "name": "Valdepiélago"
	    },
	    {
	        "id": 6167,
	        "name": "Prullans"
	    },
	    {
	        "id": 6168,
	        "name": "Viniegra de Arriba"
	    },
	    {
	        "id": 6169,
	        "name": "Villar del Olmo"
	    },
	    {
	        "id": 6170,
	        "name": "Murillo el Fruto"
	    },
	    {
	        "id": 6171,
	        "name": "Tabanera de Valdavia"
	    },
	    {
	        "id": 6172,
	        "name": "Mancera de Abajo"
	    },
	    {
	        "id": 6173,
	        "name": "Sanchonuño"
	    },
	    {
	        "id": 6174,
	        "name": "Peñarroya de Tastavins"
	    },
	    {
	        "id": 6175,
	        "name": "Valdeverdeja"
	    },
	    {
	        "id": 6176,
	        "name": "Navarrés"
	    },
	    {
	        "id": 6177,
	        "name": "Valbuena de Duero"
	    },
	    {
	        "id": 6178,
	        "name": "Robleda-Cervantes"
	    },
	    {
	        "id": 6179,
	        "name": "Moyuela"
	    },
	    {
	        "id": 6180,
	        "name": "El Parral"
	    },
	    {
	        "id": 6181,
	        "name": "Ripollet"
	    },
	    {
	        "id": 6182,
	        "name": "Iglesias"
	    },
	    {
	        "id": 6183,
	        "name": "Talayuela"
	    },
	    {
	        "id": 6184,
	        "name": "Santa Coloma de Farners"
	    },
	    {
	        "id": 6185,
	        "name": "Trevélez"
	    },
	    {
	        "id": 6186,
	        "name": "Valdepolo"
	    },
	    {
	        "id": 6187,
	        "name": "Puiggròs"
	    },
	    {
	        "id": 6188,
	        "name": "Zarratón"
	    },
	    {
	        "id": 6189,
	        "name": "Villarejo de Salvanés"
	    },
	    {
	        "id": 6190,
	        "name": "Muruzábal"
	    },
	    {
	        "id": 6191,
	        "name": "Támara de Campos"
	    },
	    {
	        "id": 6192,
	        "name": "El Manzano"
	    },
	    {
	        "id": 6193,
	        "name": "Sangarcía"
	    },
	    {
	        "id": 6194,
	        "name": "Peracense"
	    },
	    {
	        "id": 6195,
	        "name": "Valmojado"
	    },
	    {
	        "id": 6196,
	        "name": "Novelé/Novetlè"
	    },
	    {
	        "id": 6197,
	        "name": "Valdearcos de la Vega"
	    },
	    {
	        "id": 6198,
	        "name": "Roelos de Sayago"
	    },
	    {
	        "id": 6199,
	        "name": "Mozota"
	    },
	    {
	        "id": 6200,
	        "name": "Pascualcobo"
	    },
	    {
	        "id": 6201,
	        "name": "La Roca del Vallès"
	    },
	    {
	        "id": 6202,
	        "name": "Isar"
	    },
	    {
	        "id": 6203,
	        "name": "Tejeda de Tiétar"
	    },
	    {
	        "id": 6204,
	        "name": "Rozalén del Monte"
	    },
	    {
	        "id": 6205,
	        "name": "Santa Cristina d'Aro"
	    },
	    {
	        "id": 6206,
	        "name": "Turón"
	    },
	    {
	        "id": 6207,
	        "name": "Miedes de Atienza"
	    },
	    {
	        "id": 6208,
	        "name": "Piracés"
	    },
	    {
	        "id": 6209,
	        "name": "Valderas"
	    },
	    {
	        "id": 6210,
	        "name": "Puigverd d'Agramunt"
	    },
	    {
	        "id": 6211,
	        "name": "Zarzosa"
	    },
	    {
	        "id": 6212,
	        "name": "Villaviciosa de Odón"
	    },
	    {
	        "id": 6213,
	        "name": "Navascués/Nabaskoze"
	    },
	    {
	        "id": 6214,
	        "name": "Tariego de Cerrato"
	    },
	    {
	        "id": 6215,
	        "name": "Martiago"
	    },
	    {
	        "id": 6216,
	        "name": "Real Sitio de San Ildefonso"
	    },
	    {
	        "id": 6217,
	        "name": "Tardelcuende"
	    },
	    {
	        "id": 6218,
	        "name": "Peralejos"
	    },
	    {
	        "id": 6219,
	        "name": "Velada"
	    },
	    {
	        "id": 6220,
	        "name": "Oliva"
	    },
	    {
	        "id": 6221,
	        "name": "Valdenebro de los Valles"
	    },
	    {
	        "id": 6222,
	        "name": "Rosinos de la Requejada"
	    },
	    {
	        "id": 6223,
	        "name": "Muel"
	    },
	    {
	        "id": 6224,
	        "name": "Pedro Bernardo"
	    },
	    {
	        "id": 6225,
	        "name": "El Pont de Vilomara i Rocafort"
	    },
	    {
	        "id": 6226,
	        "name": "Itero del Castillo"
	    },
	    {
	        "id": 6227,
	        "name": "Toril"
	    },
	    {
	        "id": 6228,
	        "name": "Santa Llogaia d'Àlguema"
	    },
	    {
	        "id": 6229,
	        "name": "Ugíjar"
	    },
	    {
	        "id": 6230,
	        "name": "La Mierla"
	    },
	    {
	        "id": 6231,
	        "name": "Plan"
	    },
	    {
	        "id": 6232,
	        "name": "Valderrey"
	    },
	    {
	        "id": 6233,
	        "name": "Puigverd de Lleida"
	    },
	    {
	        "id": 6234,
	        "name": "Villavieja del Lozoya"
	    },
	    {
	        "id": 6235,
	        "name": "Nazar"
	    },
	    {
	        "id": 6236,
	        "name": "Torquemada"
	    },
	    {
	        "id": 6237,
	        "name": "Martinamor"
	    },
	    {
	        "id": 6238,
	        "name": "San Martín y Mudrián"
	    },
	    {
	        "id": 6239,
	        "name": "Taroda"
	    },
	    {
	        "id": 6240,
	        "name": "Perales del Alfambra"
	    },
	    {
	        "id": 6241,
	        "name": "Las Ventas con Peña Aguilera"
	    },
	    {
	        "id": 6242,
	        "name": "Olocau"
	    },
	    {
	        "id": 6243,
	        "name": "Valdestillas"
	    },
	    {
	        "id": 6244,
	        "name": "La Muela"
	    },
	    {
	        "id": 6245,
	        "name": "Pedro-Rodríguez"
	    },
	    {
	        "id": 6246,
	        "name": "Roda de Ter"
	    },
	    {
	        "id": 6247,
	        "name": "Jaramillo de la Fuente"
	    },
	    {
	        "id": 6248,
	        "name": "Tornavacas"
	    },
	    {
	        "id": 6249,
	        "name": "Sant Aniol de Finestres"
	    },
	    {
	        "id": 6250,
	        "name": "Válor"
	    },
	    {
	        "id": 6251,
	        "name": "Milmarcos"
	    },
	    {
	        "id": 6252,
	        "name": "Valderrueda"
	    },
	    {
	        "id": 6253,
	        "name": "Rialp"
	    },
	    {
	        "id": 6254,
	        "name": "Zorraquín"
	    },
	    {
	        "id": 6255,
	        "name": "Zarzalejo"
	    },
	    {
	        "id": 6256,
	        "name": "Obanos"
	    },
	    {
	        "id": 6257,
	        "name": "Martín de Yeltes"
	    },
	    {
	        "id": 6258,
	        "name": "San Miguel de Bernuy"
	    },
	    {
	        "id": 6259,
	        "name": "Tejado"
	    },
	    {
	        "id": 6260,
	        "name": "Pitarque"
	    },
	    {
	        "id": 6261,
	        "name": "Las Ventas de Retamosa"
	    },
	    {
	        "id": 6262,
	        "name": "l'Olleria"
	    },
	    {
	        "id": 6263,
	        "name": "Valdunquillo"
	    },
	    {
	        "id": 6264,
	        "name": "Salce"
	    },
	    {
	        "id": 6265,
	        "name": "Munébrega"
	    },
	    {
	        "id": 6266,
	        "name": "Peguerinos"
	    },
	    {
	        "id": 6267,
	        "name": "Rubí"
	    },
	    {
	        "id": 6268,
	        "name": "Jaramillo Quemado"
	    },
	    {
	        "id": 6269,
	        "name": "El Torno"
	    },
	    {
	        "id": 6270,
	        "name": "Santa Pau"
	    },
	    {
	        "id": 6271,
	        "name": "Vélez de Benaudalla"
	    },
	    {
	        "id": 6272,
	        "name": "Millana"
	    },
	    {
	        "id": 6273,
	        "name": "Poleñino"
	    },
	    {
	        "id": 6274,
	        "name": "Valdesamario"
	    },
	    {
	        "id": 6275,
	        "name": "Oco"
	    },
	    {
	        "id": 6276,
	        "name": "Torremormojón"
	    },
	    {
	        "id": 6277,
	        "name": "Masueco"
	    },
	    {
	        "id": 6278,
	        "name": "San Pedro de Gaíllos"
	    },
	    {
	        "id": 6279,
	        "name": "Torlengua"
	    },
	    {
	        "id": 6280,
	        "name": "Plou"
	    },
	    {
	        "id": 6281,
	        "name": "Las Ventas de San Julián"
	    },
	    {
	        "id": 6282,
	        "name": "Ontinyent"
	    },
	    {
	        "id": 6283,
	        "name": "Valoria la Buena"
	    },
	    {
	        "id": 6284,
	        "name": "Samir de los Caños"
	    },
	    {
	        "id": 6285,
	        "name": "Murero"
	    },
	    {
	        "id": 6286,
	        "name": "Peñalba de Ávila"
	    },
	    {
	        "id": 6287,
	        "name": "Rubió"
	    },
	    {
	        "id": 6288,
	        "name": "Torrecilla de los Ángeles"
	    },
	    {
	        "id": 6289,
	        "name": "Saceda-Trasierra"
	    },
	    {
	        "id": 6290,
	        "name": "Sant Joan les Fonts"
	    },
	    {
	        "id": 6291,
	        "name": "Ventas de Huelma"
	    },
	    {
	        "id": 6292,
	        "name": "La Miñosa"
	    },
	    {
	        "id": 6293,
	        "name": "Val de San Lorenzo"
	    },
	    {
	        "id": 6294,
	        "name": "Ribera d'Urgellet"
	    },
	    {
	        "id": 6295,
	        "name": "Ochagavía/Otsagabia"
	    },
	    {
	        "id": 6296,
	        "name": "Triollo"
	    },
	    {
	        "id": 6297,
	        "name": "Castellanos de Villiquera"
	    },
	    {
	        "id": 6298,
	        "name": "Santa María la Real de Nieva"
	    },
	    {
	        "id": 6299,
	        "name": "Torreblacos"
	    },
	    {
	        "id": 6300,
	        "name": "El Pobo"
	    },
	    {
	        "id": 6301,
	        "name": "Villacañas"
	    },
	    {
	        "id": 6302,
	        "name": "Otos"
	    },
	    {
	        "id": 6303,
	        "name": "Valverde de Campos"
	    },
	    {
	        "id": 6304,
	        "name": "San Agustín del Pozo"
	    },
	    {
	        "id": 6305,
	        "name": "Murillo de Gállego"
	    },
	    {
	        "id": 6306,
	        "name": "Piedrahíta"
	    },
	    {
	        "id": 6307,
	        "name": "Torrecillas de la Tiesa"
	    },
	    {
	        "id": 6308,
	        "name": "Saelices"
	    },
	    {
	        "id": 6309,
	        "name": "Sarrià de Ter"
	    },
	    {
	        "id": 6310,
	        "name": "Mirabueno"
	    },
	    {
	        "id": 6311,
	        "name": "Pozán de Vero"
	    },
	    {
	        "id": 6312,
	        "name": "Riner"
	    },
	    {
	        "id": 6313,
	        "name": "Odieta"
	    },
	    {
	        "id": 6314,
	        "name": "Valbuena de Pisuerga"
	    },
	    {
	        "id": 6315,
	        "name": "La Mata de Ledesma"
	    },
	    {
	        "id": 6316,
	        "name": "Santa Marta del Cerro"
	    },
	    {
	        "id": 6317,
	        "name": "La Villa de Don Fadrique"
	    },
	    {
	        "id": 6318,
	        "name": "Paiporta"
	    },
	    {
	        "id": 6319,
	        "name": "Valladolid"
	    },
	    {
	        "id": 6320,
	        "name": "San Cebrián de Castro"
	    },
	    {
	        "id": 6321,
	        "name": "Navardún"
	    },
	    {
	        "id": 6322,
	        "name": "Piedralaves"
	    },
	    {
	        "id": 6323,
	        "name": "Sabadell"
	    },
	    {
	        "id": 6324,
	        "name": "Torre de Don Miguel"
	    },
	    {
	        "id": 6325,
	        "name": "Salinas del Manzano"
	    },
	    {
	        "id": 6326,
	        "name": "Saus,  Camallera i Llampaies"
	    },
	    {
	        "id": 6327,
	        "name": "Villanueva de las Torres"
	    },
	    {
	        "id": 6328,
	        "name": "Miralrío"
	    },
	    {
	        "id": 6329,
	        "name": "La Puebla de Castro"
	    },
	    {
	        "id": 6330,
	        "name": "Valdevimbre"
	    },
	    {
	        "id": 6331,
	        "name": "Oitz"
	    },
	    {
	        "id": 6332,
	        "name": "Matilla de los Caños del Río"
	    },
	    {
	        "id": 6333,
	        "name": "Torrubia de Soria"
	    },
	    {
	        "id": 6334,
	        "name": "La Portellada"
	    },
	    {
	        "id": 6335,
	        "name": "Villafranca de los Caballeros"
	    },
	    {
	        "id": 6336,
	        "name": "Palma de Gandía"
	    },
	    {
	        "id": 6337,
	        "name": "Vega de Ruiponce"
	    },
	    {
	        "id": 6338,
	        "name": "San Cristóbal de Entreviñas"
	    },
	    {
	        "id": 6339,
	        "name": "Nigüella"
	    },
	    {
	        "id": 6340,
	        "name": "Poveda"
	    },
	    {
	        "id": 6341,
	        "name": "Sagàs"
	    },
	    {
	        "id": 6342,
	        "name": "Torre de Santa María"
	    },
	    {
	        "id": 6343,
	        "name": "Salmeroncillos"
	    },
	    {
	        "id": 6344,
	        "name": "La Selva de Mar"
	    },
	    {
	        "id": 6345,
	        "name": "Villanueva Mesía"
	    },
	    {
	        "id": 6346,
	        "name": "Mochales"
	    },
	    {
	        "id": 6347,
	        "name": "Puente de Montañana"
	    },
	    {
	        "id": 6348,
	        "name": "Valencia de Don Juan"
	    },
	    {
	        "id": 6349,
	        "name": "Olaibar"
	    },
	    {
	        "id": 6350,
	        "name": "La Maya"
	    },
	    {
	        "id": 6351,
	        "name": "Santiuste de Pedraza"
	    },
	    {
	        "id": 6352,
	        "name": "Trévago"
	    },
	    {
	        "id": 6353,
	        "name": "Villaluenga de la Sagra"
	    },
	    {
	        "id": 6354,
	        "name": "Palmera"
	    },
	    {
	        "id": 6355,
	        "name": "Vega de Valdetronco"
	    },
	    {
	        "id": 6356,
	        "name": "San Esteban del Molar"
	    },
	    {
	        "id": 6357,
	        "name": "Nombrevilla"
	    },
	    {
	        "id": 6358,
	        "name": "Poyales del Hoyo"
	    },
	    {
	        "id": 6359,
	        "name": "Sant Pere Sallavinera"
	    },
	    {
	        "id": 6360,
	        "name": "Junta de Traslaloma"
	    },
	    {
	        "id": 6361,
	        "name": "Torrejoncillo"
	    },
	    {
	        "id": 6362,
	        "name": "Salvacañete"
	    },
	    {
	        "id": 6363,
	        "name": "La Cellera de Ter"
	    },
	    {
	        "id": 6364,
	        "name": "Víznar"
	    },
	    {
	        "id": 6365,
	        "name": "Mohernando"
	    },
	    {
	        "id": 6366,
	        "name": "Puértolas"
	    },
	    {
	        "id": 6367,
	        "name": "Valverde de la Virgen"
	    },
	    {
	        "id": 6368,
	        "name": "Rosselló"
	    },
	    {
	        "id": 6369,
	        "name": "Olazti/Olazagutía"
	    },
	    {
	        "id": 6370,
	        "name": "Valdeolmillos"
	    },
	    {
	        "id": 6371,
	        "name": "Membribe de la Sierra"
	    },
	    {
	        "id": 6372,
	        "name": "Santiuste de San Juan Bautista"
	    },
	    {
	        "id": 6373,
	        "name": "Ucero"
	    },
	    {
	        "id": 6374,
	        "name": "Pozondón"
	    },
	    {
	        "id": 6375,
	        "name": "Villamiel de Toledo"
	    },
	    {
	        "id": 6376,
	        "name": "el Palomar"
	    },
	    {
	        "id": 6377,
	        "name": "Velascálvaro"
	    },
	    {
	        "id": 6378,
	        "name": "San Justo"
	    },
	    {
	        "id": 6379,
	        "name": "Nonaspe"
	    },
	    {
	        "id": 6380,
	        "name": "Pozanco"
	    },
	    {
	        "id": 6381,
	        "name": "Saldes"
	    },
	    {
	        "id": 6382,
	        "name": "Junta de Villalba de Losa"
	    },
	    {
	        "id": 6383,
	        "name": "Torrejón el Rubio"
	    },
	    {
	        "id": 6384,
	        "name": "San Clemente"
	    },
	    {
	        "id": 6385,
	        "name": "Serinyà"
	    },
	    {
	        "id": 6386,
	        "name": "Molina de Aragón"
	    },
	    {
	        "id": 6387,
	        "name": "El Pueyo de Araguás"
	    },
	    {
	        "id": 6388,
	        "name": "Valverde-Enrique"
	    },
	    {
	        "id": 6389,
	        "name": "Salàs de Pallars"
	    },
	    {
	        "id": 6390,
	        "name": "Olejua"
	    },
	    {
	        "id": 6391,
	        "name": "Valderrábano"
	    },
	    {
	        "id": 6392,
	        "name": "Mieza"
	    },
	    {
	        "id": 6393,
	        "name": "Santo Domingo de Pirón"
	    },
	    {
	        "id": 6394,
	        "name": "Vadillo"
	    },
	    {
	        "id": 6395,
	        "name": "Pozuel del Campo"
	    },
	    {
	        "id": 6396,
	        "name": "Villaminaya"
	    },
	    {
	        "id": 6397,
	        "name": "Paterna"
	    },
	    {
	        "id": 6398,
	        "name": "Velilla"
	    },
	    {
	        "id": 6399,
	        "name": "San Martín de Valderaduey"
	    },
	    {
	        "id": 6400,
	        "name": "Novallas"
	    },
	    {
	        "id": 6401,
	        "name": "Pradosegar"
	    },
	    {
	        "id": 6402,
	        "name": "Sallent"
	    },
	    {
	        "id": 6403,
	        "name": "Jurisdicción de Lara"
	    },
	    {
	        "id": 6404,
	        "name": "Torremenga"
	    },
	    {
	        "id": 6405,
	        "name": "San Lorenzo de la Parrilla"
	    },
	    {
	        "id": 6406,
	        "name": "Serra de Daró"
	    },
	    {
	        "id": 6407,
	        "name": "Monasterio"
	    },
	    {
	        "id": 6408,
	        "name": "Vallecillo"
	    },
	    {
	        "id": 6409,
	        "name": "Sanaüja"
	    },
	    {
	        "id": 6410,
	        "name": "Olite/Erriberri"
	    },
	    {
	        "id": 6411,
	        "name": "El Milano"
	    },
	    {
	        "id": 6412,
	        "name": "Santo Tomé del Puerto"
	    },
	    {
	        "id": 6413,
	        "name": "Valdeavellano de Tera"
	    },
	    {
	        "id": 6414,
	        "name": "La Puebla de Híjar"
	    },
	    {
	        "id": 6415,
	        "name": "Villamuelas"
	    },
	    {
	        "id": 6416,
	        "name": "Pedralba"
	    },
	    {
	        "id": 6417,
	        "name": "Velliza"
	    },
	    {
	        "id": 6418,
	        "name": "San Miguel de la Ribera"
	    },
	    {
	        "id": 6419,
	        "name": "Novillas"
	    },
	    {
	        "id": 6420,
	        "name": "Puerto Castilla"
	    },
	    {
	        "id": 6421,
	        "name": "Santpedor"
	    },
	    {
	        "id": 6422,
	        "name": "Jurisdicción de San Zadornil"
	    },
	    {
	        "id": 6423,
	        "name": "Torremocha"
	    },
	    {
	        "id": 6424,
	        "name": "San Martín de Boniches"
	    },
	    {
	        "id": 6425,
	        "name": "Setcases"
	    },
	    {
	        "id": 6426,
	        "name": "Zafarraya"
	    },
	    {
	        "id": 6427,
	        "name": "Mondéjar"
	    },
	    {
	        "id": 6428,
	        "name": "Sant Guim de Freixenet"
	    },
	    {
	        "id": 6429,
	        "name": "Olóriz/Oloritz"
	    },
	    {
	        "id": 6430,
	        "name": "Valde-Ucieza"
	    },
	    {
	        "id": 6431,
	        "name": "Miranda de Azán"
	    },
	    {
	        "id": 6432,
	        "name": "Sauquillo de Cabezas"
	    },
	    {
	        "id": 6433,
	        "name": "Valdegeña"
	    },
	    {
	        "id": 6434,
	        "name": "La Puebla de Valverde"
	    },
	    {
	        "id": 6435,
	        "name": "Villanueva de Alcardete"
	    },
	    {
	        "id": 6436,
	        "name": "Petrés"
	    },
	    {
	        "id": 6437,
	        "name": "Ventosa de la Cuesta"
	    },
	    {
	        "id": 6438,
	        "name": "San Miguel del Valle"
	    },
	    {
	        "id": 6439,
	        "name": "Nuévalos"
	    },
	    {
	        "id": 6440,
	        "name": "Rasueros"
	    },
	    {
	        "id": 6441,
	        "name": "Sant Iscle de Vallalta"
	    },
	    {
	        "id": 6442,
	        "name": "Torreorgaz"
	    },
	    {
	        "id": 6443,
	        "name": "San Pedro Palmiches"
	    },
	    {
	        "id": 6444,
	        "name": "Sils"
	    },
	    {
	        "id": 6445,
	        "name": "La Zubia"
	    },
	    {
	        "id": 6446,
	        "name": "Montarrón"
	    },
	    {
	        "id": 6447,
	        "name": "Pueyo de Santa Cruz"
	    },
	    {
	        "id": 6448,
	        "name": "La Vecilla"
	    },
	    {
	        "id": 6449,
	        "name": "Sant Llorenç de Morunys"
	    },
	    {
	        "id": 6450,
	        "name": "Cendea de Olza/Oltza Zendea"
	    },
	    {
	        "id": 6451,
	        "name": "Miranda del Castañar"
	    },
	    {
	        "id": 6452,
	        "name": "Sebúlcor"
	    },
	    {
	        "id": 6453,
	        "name": "Valdelagua del Cerro"
	    },
	    {
	        "id": 6454,
	        "name": "Puertomingalvo"
	    },
	    {
	        "id": 6455,
	        "name": "Villanueva de Bogas"
	    },
	    {
	        "id": 6456,
	        "name": "Picanya"
	    },
	    {
	        "id": 6457,
	        "name": "Viana de Cega"
	    },
	    {
	        "id": 6458,
	        "name": "San Pedro de Ceque"
	    },
	    {
	        "id": 6459,
	        "name": "Nuez de Ebro"
	    },
	    {
	        "id": 6460,
	        "name": "Riocabado"
	    },
	    {
	        "id": 6461,
	        "name": "Sant Adrià de Besòs"
	    },
	    {
	        "id": 6462,
	        "name": "Lerma"
	    },
	    {
	        "id": 6463,
	        "name": "Torrequemada"
	    },
	    {
	        "id": 6464,
	        "name": "Santa Cruz de Moya"
	    },
	    {
	        "id": 6465,
	        "name": "Susqueda"
	    },
	    {
	        "id": 6466,
	        "name": "Zújar"
	    },
	    {
	        "id": 6467,
	        "name": "Moratilla de los Meleros"
	    },
	    {
	        "id": 6468,
	        "name": "Vegacervera"
	    },
	    {
	        "id": 6469,
	        "name": "Sant Ramon"
	    },
	    {
	        "id": 6470,
	        "name": "Ollo"
	    },
	    {
	        "id": 6471,
	        "name": "Mogarraz"
	    },
	    {
	        "id": 6472,
	        "name": "Segovia"
	    },
	    {
	        "id": 6473,
	        "name": "Valdemaluque"
	    },
	    {
	        "id": 6474,
	        "name": "Ráfales"
	    },
	    {
	        "id": 6475,
	        "name": "Villarejo de Montalbán"
	    },
	    {
	        "id": 6476,
	        "name": "Picassent"
	    },
	    {
	        "id": 6477,
	        "name": "Viloria"
	    },
	    {
	        "id": 6478,
	        "name": "San Pedro de la Nave-Almendra"
	    },
	    {
	        "id": 6479,
	        "name": "Olvés"
	    },
	    {
	        "id": 6480,
	        "name": "Riofrío"
	    },
	    {
	        "id": 6481,
	        "name": "Sant Agustí de Lluçanès"
	    },
	    {
	        "id": 6482,
	        "name": "Llano de Bureba"
	    },
	    {
	        "id": 6483,
	        "name": "Trujillo"
	    },
	    {
	        "id": 6484,
	        "name": "Santa María del Campo Rus"
	    },
	    {
	        "id": 6485,
	        "name": "La Tallada d'Empordà"
	    },
	    {
	        "id": 6486,
	        "name": "Morenilla"
	    },
	    {
	        "id": 6487,
	        "name": "Quicena"
	    },
	    {
	        "id": 6488,
	        "name": "Orbaizeta"
	    },
	    {
	        "id": 6489,
	        "name": "Molinillo"
	    },
	    {
	        "id": 6490,
	        "name": "Sepúlveda"
	    },
	    {
	        "id": 6491,
	        "name": "Valdenebro"
	    },
	    {
	        "id": 6492,
	        "name": "Rillo"
	    },
	    {
	        "id": 6493,
	        "name": "Villarrubia de Santiago"
	    },
	    {
	        "id": 6494,
	        "name": "Piles"
	    },
	    {
	        "id": 6495,
	        "name": "Villabáñez"
	    },
	    {
	        "id": 6496,
	        "name": "Orcajo"
	    },
	    {
	        "id": 6497,
	        "name": "Rivilla de Barajas"
	    },
	    {
	        "id": 6498,
	        "name": "Sant Andreu de la Barca"
	    },
	    {
	        "id": 6499,
	        "name": "Madrigal del Monte"
	    },
	    {
	        "id": 6500,
	        "name": "Valdastillas"
	    },
	    {
	        "id": 6501,
	        "name": "Santa María de los Llanos"
	    },
	    {
	        "id": 6502,
	        "name": "Terrades"
	    },
	    {
	        "id": 6503,
	        "name": "Muduex"
	    },
	    {
	        "id": 6504,
	        "name": "Vega de Espinareda"
	    },
	    {
	        "id": 6505,
	        "name": "Sant Esteve de la Sarga"
	    },
	    {
	        "id": 6506,
	        "name": "Orbara"
	    },
	    {
	        "id": 6507,
	        "name": "Valle de Cerrato"
	    },
	    {
	        "id": 6508,
	        "name": "Monforte de la Sierra"
	    },
	    {
	        "id": 6509,
	        "name": "Sequera de Fresno"
	    },
	    {
	        "id": 6510,
	        "name": "Valdeprado"
	    },
	    {
	        "id": 6511,
	        "name": "Riodeva"
	    },
	    {
	        "id": 6512,
	        "name": "Villaseca de la Sagra"
	    },
	    {
	        "id": 6513,
	        "name": "Pinet"
	    },
	    {
	        "id": 6514,
	        "name": "Villabaruz de Campos"
	    },
	    {
	        "id": 6515,
	        "name": "Orera"
	    },
	    {
	        "id": 6516,
	        "name": "Salobral"
	    },
	    {
	        "id": 6517,
	        "name": "Sant Andreu de Llavaneres"
	    },
	    {
	        "id": 6518,
	        "name": "Madrigalejo del Monte"
	    },
	    {
	        "id": 6519,
	        "name": "Valdecañas de Tajo"
	    },
	    {
	        "id": 6520,
	        "name": "Santa María del Val"
	    },
	    {
	        "id": 6521,
	        "name": "Torrent"
	    },
	    {
	        "id": 6522,
	        "name": "Las Navas de Jadraque"
	    },
	    {
	        "id": 6523,
	        "name": "Robres"
	    },
	    {
	        "id": 6524,
	        "name": "Vega de Infanzones"
	    },
	    {
	        "id": 6525,
	        "name": "Sant Guim de la Plana"
	    },
	    {
	        "id": 6526,
	        "name": "Orísoain"
	    },
	    {
	        "id": 6527,
	        "name": "Monleón"
	    },
	    {
	        "id": 6528,
	        "name": "Valderrodilla"
	    },
	    {
	        "id": 6529,
	        "name": "Ródenas"
	    },
	    {
	        "id": 6530,
	        "name": "Villasequilla"
	    },
	    {
	        "id": 6531,
	        "name": "Polinyà de Xúquer"
	    },
	    {
	        "id": 6532,
	        "name": "Villabrágima"
	    },
	    {
	        "id": 6533,
	        "name": "Santa Clara de Avedillo"
	    },
	    {
	        "id": 6534,
	        "name": "Orés"
	    },
	    {
	        "id": 6535,
	        "name": "Salvadiós"
	    },
	    {
	        "id": 6536,
	        "name": "Sant Antoni de Vilamajor"
	    },
	    {
	        "id": 6537,
	        "name": "Mahamud"
	    },
	    {
	        "id": 6538,
	        "name": "Valdefuentes"
	    },
	    {
	        "id": 6539,
	        "name": "Sisante"
	    },
	    {
	        "id": 6540,
	        "name": "Torroella de Fluvià"
	    },
	    {
	        "id": 6541,
	        "name": "Negredo"
	    },
	    {
	        "id": 6542,
	        "name": "Vega de Valcarce"
	    },
	    {
	        "id": 6543,
	        "name": "Oronz/Orontze"
	    },
	    {
	        "id": 6544,
	        "name": "Monleras"
	    },
	    {
	        "id": 6545,
	        "name": "Sotillo"
	    },
	    {
	        "id": 6546,
	        "name": "Valtajeros"
	    },
	    {
	        "id": 6547,
	        "name": "Royuela"
	    },
	    {
	        "id": 6548,
	        "name": "Villatobas"
	    },
	    {
	        "id": 6549,
	        "name": "Potríes"
	    },
	    {
	        "id": 6550,
	        "name": "Villacarralón"
	    },
	    {
	        "id": 6551,
	        "name": "Oseja"
	    },
	    {
	        "id": 6552,
	        "name": "San Bartolomé de Béjar"
	    },
	    {
	        "id": 6553,
	        "name": "Sant Bartomeu del Grau"
	    },
	    {
	        "id": 6554,
	        "name": "Mambrilla de Castrejón"
	    },
	    {
	        "id": 6555,
	        "name": "Valdehúncar"
	    },
	    {
	        "id": 6556,
	        "name": "Solera de Gabaldón"
	    },
	    {
	        "id": 6557,
	        "name": "Torroella de Montgrí"
	    },
	    {
	        "id": 6558,
	        "name": "Ocentejo"
	    },
	    {
	        "id": 6559,
	        "name": "Sabiñánigo"
	    },
	    {
	        "id": 6560,
	        "name": "Vegaquemada"
	    },
	    {
	        "id": 6561,
	        "name": "Oroz-Betelu/Orotz-Betelu"
	    },
	    {
	        "id": 6562,
	        "name": "Velilla del Río Carrión"
	    },
	    {
	        "id": 6563,
	        "name": "Monsagro"
	    },
	    {
	        "id": 6564,
	        "name": "Sotosalbos"
	    },
	    {
	        "id": 6565,
	        "name": "Rubiales"
	    },
	    {
	        "id": 6566,
	        "name": "El Viso de San Juan"
	    },
	    {
	        "id": 6567,
	        "name": "la Pobla de Farnals"
	    },
	    {
	        "id": 6568,
	        "name": "Villacid de Campos"
	    },
	    {
	        "id": 6569,
	        "name": "Santa Colomba de las Monjas"
	    },
	    {
	        "id": 6570,
	        "name": "Osera de Ebro"
	    },
	    {
	        "id": 6571,
	        "name": "San Bartolomé de Corneja"
	    },
	    {
	        "id": 6572,
	        "name": "Sant Boi de Llobregat"
	    },
	    {
	        "id": 6573,
	        "name": "Mambrillas de Lara"
	    },
	    {
	        "id": 6574,
	        "name": "Valdelacasa de Tajo"
	    },
	    {
	        "id": 6575,
	        "name": "Tortellà"
	    },
	    {
	        "id": 6576,
	        "name": "El Olivar"
	    },
	    {
	        "id": 6577,
	        "name": "Sahún"
	    },
	    {
	        "id": 6578,
	        "name": "Sarroca de Lleida"
	    },
	    {
	        "id": 6579,
	        "name": "Oteiza"
	    },
	    {
	        "id": 6580,
	        "name": "Montejo"
	    },
	    {
	        "id": 6581,
	        "name": "Tabanera la Luenga"
	    },
	    {
	        "id": 6582,
	        "name": "Velamazán"
	    },
	    {
	        "id": 6583,
	        "name": "Rubielos de la Cérida"
	    },
	    {
	        "id": 6584,
	        "name": "Los Yébenes"
	    },
	    {
	        "id": 6585,
	        "name": "la Pobla del Duc"
	    },
	    {
	        "id": 6586,
	        "name": "Villaco"
	    },
	    {
	        "id": 6587,
	        "name": "Santa Cristina de la Polvorosa"
	    },
	    {
	        "id": 6588,
	        "name": "Paniza"
	    },
	    {
	        "id": 6589,
	        "name": "San Bartolomé de Pinares"
	    },
	    {
	        "id": 6590,
	        "name": "Sant Boi de Lluçanès"
	    },
	    {
	        "id": 6591,
	        "name": "Mamolar"
	    },
	    {
	        "id": 6592,
	        "name": "Valdemorales"
	    },
	    {
	        "id": 6593,
	        "name": "Toses"
	    },
	    {
	        "id": 6594,
	        "name": "Olmeda de Cobeta"
	    },
	    {
	        "id": 6595,
	        "name": "Salas Altas"
	    },
	    {
	        "id": 6596,
	        "name": "Vegas del Condado"
	    },
	    {
	        "id": 6597,
	        "name": "Sarroca de Bellera"
	    },
	    {
	        "id": 6598,
	        "name": "Pamplona/Iruña"
	    },
	    {
	        "id": 6599,
	        "name": "Vertavillo"
	    },
	    {
	        "id": 6600,
	        "name": "Montemayor del Río"
	    },
	    {
	        "id": 6601,
	        "name": "Tolocirio"
	    },
	    {
	        "id": 6602,
	        "name": "Velilla de la Sierra"
	    },
	    {
	        "id": 6603,
	        "name": "Rubielos de Mora"
	    },
	    {
	        "id": 6604,
	        "name": "Yeles"
	    },
	    {
	        "id": 6605,
	        "name": "Puebla de San Miguel"
	    },
	    {
	        "id": 6606,
	        "name": "Santa Croya de Tera"
	    },
	    {
	        "id": 6607,
	        "name": "Paracuellos de Jiloca"
	    },
	    {
	        "id": 6608,
	        "name": "Sant Celoni"
	    },
	    {
	        "id": 6609,
	        "name": "Manciles"
	    },
	    {
	        "id": 6610,
	        "name": "Valdeobispo"
	    },
	    {
	        "id": 6611,
	        "name": "Talayuelas"
	    },
	    {
	        "id": 6612,
	        "name": "Tossa de Mar"
	    },
	    {
	        "id": 6613,
	        "name": "La Olmeda de Jadraque"
	    },
	    {
	        "id": 6614,
	        "name": "Salas Bajas"
	    },
	    {
	        "id": 6615,
	        "name": "Villablino"
	    },
	    {
	        "id": 6616,
	        "name": "Senterada"
	    },
	    {
	        "id": 6617,
	        "name": "Peralta/Azkoien"
	    },
	    {
	        "id": 6618,
	        "name": "Villabasta de Valdavia"
	    },
	    {
	        "id": 6619,
	        "name": "Monterrubio de Armuña"
	    },
	    {
	        "id": 6620,
	        "name": "Torreadrada"
	    },
	    {
	        "id": 6621,
	        "name": "Velilla de los Ajos"
	    },
	    {
	        "id": 6622,
	        "name": "Yepes"
	    },
	    {
	        "id": 6623,
	        "name": "la Pobla de Vallbona"
	    },
	    {
	        "id": 6624,
	        "name": "Santa Eufemia del Barco"
	    },
	    {
	        "id": 6625,
	        "name": "Paracuellos de la Ribera"
	    },
	    {
	        "id": 6626,
	        "name": "Sant Cebrià de Vallalta"
	    },
	    {
	        "id": 6627,
	        "name": "Valencia de Alcántara"
	    },
	    {
	        "id": 6628,
	        "name": "Tarancón"
	    },
	    {
	        "id": 6629,
	        "name": "Ultramort"
	    },
	    {
	        "id": 6630,
	        "name": "El Ordial"
	    },
	    {
	        "id": 6631,
	        "name": "Salillas"
	    },
	    {
	        "id": 6632,
	        "name": "Villabraz"
	    },
	    {
	        "id": 6633,
	        "name": "La Seu d'Urgell"
	    },
	    {
	        "id": 6634,
	        "name": "Petilla de Aragón"
	    },
	    {
	        "id": 6635,
	        "name": "Monterrubio de la Sierra"
	    },
	    {
	        "id": 6636,
	        "name": "Torrecaballeros"
	    },
	    {
	        "id": 6637,
	        "name": "Salcedillo"
	    },
	    {
	        "id": 6638,
	        "name": "Yuncler"
	    },
	    {
	        "id": 6639,
	        "name": "la Pobla Llarga"
	    },
	    {
	        "id": 6640,
	        "name": "Villafrades de Campos"
	    },
	    {
	        "id": 6641,
	        "name": "Santa María de la Vega"
	    },
	    {
	        "id": 6642,
	        "name": "Pastriz"
	    },
	    {
	        "id": 6643,
	        "name": "Sanchidrián"
	    },
	    {
	        "id": 6644,
	        "name": "Sant Climent de Llobregat"
	    },
	    {
	        "id": 6645,
	        "name": "Valverde de la Vera"
	    },
	    {
	        "id": 6646,
	        "name": "Tébar"
	    },
	    {
	        "id": 6647,
	        "name": "Ullà"
	    },
	    {
	        "id": 6648,
	        "name": "Orea"
	    },
	    {
	        "id": 6649,
	        "name": "Sallent de Gállego"
	    },
	    {
	        "id": 6650,
	        "name": "Seròs"
	    },
	    {
	        "id": 6651,
	        "name": "Piedramillera"
	    },
	    {
	        "id": 6652,
	        "name": "Villacidaler"
	    },
	    {
	        "id": 6653,
	        "name": "Morasverdes"
	    },
	    {
	        "id": 6654,
	        "name": "Torrecilla del Pinar"
	    },
	    {
	        "id": 6655,
	        "name": "Viana de Duero"
	    },
	    {
	        "id": 6656,
	        "name": "Saldón"
	    },
	    {
	        "id": 6657,
	        "name": "Yunclillos"
	    },
	    {
	        "id": 6658,
	        "name": "Puig"
	    },
	    {
	        "id": 6659,
	        "name": "Villafranca de Duero"
	    },
	    {
	        "id": 6660,
	        "name": "Santa María de Valverde"
	    },
	    {
	        "id": 6661,
	        "name": "Pedrola"
	    },
	    {
	        "id": 6662,
	        "name": "Sanchorreja"
	    },
	    {
	        "id": 6663,
	        "name": "Sant Cugat del Vallès"
	    },
	    {
	        "id": 6664,
	        "name": "Valverde del Fresno"
	    },
	    {
	        "id": 6665,
	        "name": "Tejadillos"
	    },
	    {
	        "id": 6666,
	        "name": "Ullastret"
	    },
	    {
	        "id": 6667,
	        "name": "San Esteban de Litera"
	    },
	    {
	        "id": 6668,
	        "name": "Villadangos del Páramo"
	    },
	    {
	        "id": 6669,
	        "name": "Sidamon"
	    },
	    {
	        "id": 6670,
	        "name": "Pitillas"
	    },
	    {
	        "id": 6671,
	        "name": "Villaconancio"
	    },
	    {
	        "id": 6672,
	        "name": "Morille"
	    },
	    {
	        "id": 6673,
	        "name": "Torreiglesias"
	    },
	    {
	        "id": 6674,
	        "name": "Villaciervos"
	    },
	    {
	        "id": 6675,
	        "name": "Samper de Calanda"
	    },
	    {
	        "id": 6676,
	        "name": "Yuncos"
	    },
	    {
	        "id": 6677,
	        "name": "Puçol"
	    },
	    {
	        "id": 6678,
	        "name": "Villafrechós"
	    },
	    {
	        "id": 6679,
	        "name": "Santibáñez de Tera"
	    },
	    {
	        "id": 6680,
	        "name": "Las Pedrosas"
	    },
	    {
	        "id": 6681,
	        "name": "San Esteban de los Patos"
	    },
	    {
	        "id": 6682,
	        "name": "Sant Cugat Sesgarrigues"
	    },
	    {
	        "id": 6683,
	        "name": "Mazuela"
	    },
	    {
	        "id": 6684,
	        "name": "Viandar de la Vera"
	    },
	    {
	        "id": 6685,
	        "name": "Tinajas"
	    },
	    {
	        "id": 6686,
	        "name": "Urús"
	    },
	    {
	        "id": 6687,
	        "name": "Sangarrén"
	    },
	    {
	        "id": 6688,
	        "name": "Toral de los Vados"
	    },
	    {
	        "id": 6689,
	        "name": "El Soleràs"
	    },
	    {
	        "id": 6690,
	        "name": "Puente la Reina/Gares"
	    },
	    {
	        "id": 6691,
	        "name": "Villada"
	    },
	    {
	        "id": 6692,
	        "name": "Moríñigo"
	    },
	    {
	        "id": 6693,
	        "name": "Torre Val de San Pedro"
	    },
	    {
	        "id": 6694,
	        "name": "Villanueva de Gormaz"
	    },
	    {
	        "id": 6695,
	        "name": "San Agustín"
	    },
	    {
	        "id": 6696,
	        "name": "Quesa"
	    },
	    {
	        "id": 6697,
	        "name": "Villafuerte"
	    },
	    {
	        "id": 6698,
	        "name": "Santibáñez de Vidriales"
	    },
	    {
	        "id": 6699,
	        "name": "Perdiguera"
	    },
	    {
	        "id": 6700,
	        "name": "San Esteban del Valle"
	    },
	    {
	        "id": 6701,
	        "name": "Sant Esteve de Palautordera"
	    },
	    {
	        "id": 6702,
	        "name": "Villa del Campo"
	    },
	    {
	        "id": 6703,
	        "name": "La Vall d'en Bas"
	    },
	    {
	        "id": 6704,
	        "name": "San Juan de Plan"
	    },
	    {
	        "id": 6705,
	        "name": "Villademor de la Vega"
	    },
	    {
	        "id": 6706,
	        "name": "Solsona"
	    },
	    {
	        "id": 6707,
	        "name": "Pueyo"
	    },
	    {
	        "id": 6708,
	        "name": "Moriscos"
	    },
	    {
	        "id": 6709,
	        "name": "Trescasas"
	    },
	    {
	        "id": 6710,
	        "name": "Villar del Ala"
	    },
	    {
	        "id": 6711,
	        "name": "San Martín del Río"
	    },
	    {
	        "id": 6712,
	        "name": "Rafelbuñol/Rafelbunyol"
	    },
	    {
	        "id": 6713,
	        "name": "Villagarcía de Campos"
	    },
	    {
	        "id": 6714,
	        "name": "Santovenia"
	    },
	    {
	        "id": 6715,
	        "name": "Piedratajada"
	    },
	    {
	        "id": 6716,
	        "name": "San Esteban de Zapardiel"
	    },
	    {
	        "id": 6717,
	        "name": "Sant Esteve Sesrovires"
	    },
	    {
	        "id": 6718,
	        "name": "Mecerreyes"
	    },
	    {
	        "id": 6719,
	        "name": "Villa del Rey"
	    },
	    {
	        "id": 6720,
	        "name": "La Vall de Bianya"
	    },
	    {
	        "id": 6721,
	        "name": "Pálmaces de Jadraque"
	    },
	    {
	        "id": 6722,
	        "name": "Santa Cilia"
	    },
	    {
	        "id": 6723,
	        "name": "Soriguera"
	    },
	    {
	        "id": 6724,
	        "name": "Ribaforada"
	    },
	    {
	        "id": 6725,
	        "name": "Villaeles de Valdavia"
	    },
	    {
	        "id": 6726,
	        "name": "Moronta"
	    },
	    {
	        "id": 6727,
	        "name": "Turégano"
	    },
	    {
	        "id": 6728,
	        "name": "Villar del Campo"
	    },
	    {
	        "id": 6729,
	        "name": "Santa Cruz de Nogueras"
	    },
	    {
	        "id": 6730,
	        "name": "Rafelcofer"
	    },
	    {
	        "id": 6731,
	        "name": "Villagómez la Nueva"
	    },
	    {
	        "id": 6732,
	        "name": "San Vicente de la Cabeza"
	    },
	    {
	        "id": 6733,
	        "name": "Pina de Ebro"
	    },
	    {
	        "id": 6734,
	        "name": "San García de Ingelmos"
	    },
	    {
	        "id": 6735,
	        "name": "Sant Fost de Campsentelles"
	    },
	    {
	        "id": 6736,
	        "name": "Medina de Pomar"
	    },
	    {
	        "id": 6737,
	        "name": "Villamesías"
	    },
	    {
	        "id": 6738,
	        "name": "Torralba"
	    },
	    {
	        "id": 6739,
	        "name": "Vall-llobrega"
	    },
	    {
	        "id": 6740,
	        "name": "Pardos"
	    },
	    {
	        "id": 6741,
	        "name": "Santa Cruz de la Serós"
	    },
	    {
	        "id": 6742,
	        "name": "Villafranca del Bierzo"
	    },
	    {
	        "id": 6743,
	        "name": "Sort"
	    },
	    {
	        "id": 6744,
	        "name": "Romanzado"
	    },
	    {
	        "id": 6745,
	        "name": "Mozárbez"
	    },
	    {
	        "id": 6746,
	        "name": "Villar del Río"
	    },
	    {
	        "id": 6747,
	        "name": "Santa Eulalia"
	    },
	    {
	        "id": 6748,
	        "name": "Rafelguaraf"
	    },
	    {
	        "id": 6749,
	        "name": "Villalán de Campos"
	    },
	    {
	        "id": 6750,
	        "name": "San Vitero"
	    },
	    {
	        "id": 6751,
	        "name": "Pinseque"
	    },
	    {
	        "id": 6752,
	        "name": "San Juan de la Encinilla"
	    },
	    {
	        "id": 6753,
	        "name": "Sant Feliu de Codines"
	    },
	    {
	        "id": 6754,
	        "name": "Villamiel"
	    },
	    {
	        "id": 6755,
	        "name": "Ventalló"
	    },
	    {
	        "id": 6756,
	        "name": "Paredes de Sigüenza"
	    },
	    {
	        "id": 6757,
	        "name": "Villagatón"
	    },
	    {
	        "id": 6758,
	        "name": "Soses"
	    },
	    {
	        "id": 6759,
	        "name": "Roncal/Erronkari"
	    },
	    {
	        "id": 6760,
	        "name": "Villahán"
	    },
	    {
	        "id": 6761,
	        "name": "Urueñas"
	    },
	    {
	        "id": 6762,
	        "name": "Sarrión"
	    },
	    {
	        "id": 6763,
	        "name": "Ráfol de Salem"
	    },
	    {
	        "id": 6764,
	        "name": "Villalar de los Comuneros"
	    },
	    {
	        "id": 6765,
	        "name": "Sanzoles"
	    },
	    {
	        "id": 6766,
	        "name": "Los Pintanos"
	    },
	    {
	        "id": 6767,
	        "name": "San Juan de la Nava"
	    },
	    {
	        "id": 6768,
	        "name": "Sant Feliu de Llobregat"
	    },
	    {
	        "id": 6769,
	        "name": "Melgar de Fernamental"
	    },
	    {
	        "id": 6770,
	        "name": "Villanueva de la Sierra"
	    },
	    {
	        "id": 6771,
	        "name": "Torrejoncillo del Rey"
	    },
	    {
	        "id": 6772,
	        "name": "Verges"
	    },
	    {
	        "id": 6773,
	        "name": "Pareja"
	    },
	    {
	        "id": 6774,
	        "name": "Villamandos"
	    },
	    {
	        "id": 6775,
	        "name": "Sudanell"
	    },
	    {
	        "id": 6776,
	        "name": "Orreaga/Roncesvalles"
	    },
	    {
	        "id": 6777,
	        "name": "Villaherreros"
	    },
	    {
	        "id": 6778,
	        "name": "Narros de Matalayegua"
	    },
	    {
	        "id": 6779,
	        "name": "Valdeprados"
	    },
	    {
	        "id": 6780,
	        "name": "Los Villares de Soria"
	    },
	    {
	        "id": 6781,
	        "name": "Segura de los Baños"
	    },
	    {
	        "id": 6782,
	        "name": "Real de Gandía"
	    },
	    {
	        "id": 6783,
	        "name": "Villalba de la Loma"
	    },
	    {
	        "id": 6784,
	        "name": "Plasencia de Jalón"
	    },
	    {
	        "id": 6785,
	        "name": "San Juan del Molinillo"
	    },
	    {
	        "id": 6786,
	        "name": "Sant Feliu Sasserra"
	    },
	    {
	        "id": 6787,
	        "name": "Villanueva de la Vera"
	    },
	    {
	        "id": 6788,
	        "name": "Torrubia del Campo"
	    },
	    {
	        "id": 6789,
	        "name": "Vidrà"
	    },
	    {
	        "id": 6790,
	        "name": "Pastrana"
	    },
	    {
	        "id": 6791,
	        "name": "Santaliestra y San Quílez"
	    },
	    {
	        "id": 6792,
	        "name": "Villamañán"
	    },
	    {
	        "id": 6793,
	        "name": "Sunyer"
	    },
	    {
	        "id": 6794,
	        "name": "Sada"
	    },
	    {
	        "id": 6795,
	        "name": "Navacarros"
	    },
	    {
	        "id": 6796,
	        "name": "Valdevacas de Montejo"
	    },
	    {
	        "id": 6797,
	        "name": "Villasayas"
	    },
	    {
	        "id": 6798,
	        "name": "Seno"
	    },
	    {
	        "id": 6799,
	        "name": "Real"
	    },
	    {
	        "id": 6800,
	        "name": "Villalba de los Alcores"
	    },
	    {
	        "id": 6801,
	        "name": "Pleitas"
	    },
	    {
	        "id": 6802,
	        "name": "San Juan del Olmo"
	    },
	    {
	        "id": 6803,
	        "name": "Sant Fruitós de Bages"
	    },
	    {
	        "id": 6804,
	        "name": "Merindad de Cuesta-Urria"
	    },
	    {
	        "id": 6805,
	        "name": "Villar del Pedroso"
	    },
	    {
	        "id": 6806,
	        "name": "Torrubia del Castillo"
	    },
	    {
	        "id": 6807,
	        "name": "Vidreres"
	    },
	    {
	        "id": 6808,
	        "name": "El Pedregal"
	    },
	    {
	        "id": 6809,
	        "name": "Sariñena"
	    },
	    {
	        "id": 6810,
	        "name": "Villamartín de Don Sancho"
	    },
	    {
	        "id": 6811,
	        "name": "Saldías"
	    },
	    {
	        "id": 6812,
	        "name": "Villalaco"
	    },
	    {
	        "id": 6813,
	        "name": "Nava de Béjar"
	    },
	    {
	        "id": 6814,
	        "name": "Valdevacas y Guijar"
	    },
	    {
	        "id": 6815,
	        "name": "Villaseca de Arciel"
	    },
	    {
	        "id": 6816,
	        "name": "Singra"
	    },
	    {
	        "id": 6817,
	        "name": "Requena"
	    },
	    {
	        "id": 6818,
	        "name": "Villalbarba"
	    },
	    {
	        "id": 6819,
	        "name": "Plenas"
	    },
	    {
	        "id": 6820,
	        "name": "San Lorenzo de Tormes"
	    },
	    {
	        "id": 6821,
	        "name": "Vilassar de Dalt"
	    },
	    {
	        "id": 6822,
	        "name": "Merindad de Montija"
	    },
	    {
	        "id": 6823,
	        "name": "Villar de Plasencia"
	    },
	    {
	        "id": 6824,
	        "name": "Vilabertran"
	    },
	    {
	        "id": 6825,
	        "name": "Peñalén"
	    },
	    {
	        "id": 6826,
	        "name": "Secastilla"
	    },
	    {
	        "id": 6827,
	        "name": "Villamejil"
	    },
	    {
	        "id": 6828,
	        "name": "Salinas de Oro/Jaitz"
	    },
	    {
	        "id": 6829,
	        "name": "Villalba de Guardo"
	    },
	    {
	        "id": 6830,
	        "name": "Nava de Francia"
	    },
	    {
	        "id": 6831,
	        "name": "Valseca"
	    },
	    {
	        "id": 6832,
	        "name": "Riba-roja de Túria"
	    },
	    {
	        "id": 6833,
	        "name": "Villalón de Campos"
	    },
	    {
	        "id": 6834,
	        "name": "Tábara"
	    },
	    {
	        "id": 6835,
	        "name": "Pomer"
	    },
	    {
	        "id": 6836,
	        "name": "San Martín de la Vega del Alberche"
	    },
	    {
	        "id": 6837,
	        "name": "Sant Hipòlit de Voltregà"
	    },
	    {
	        "id": 6838,
	        "name": "Merindad de Sotoscueva"
	    },
	    {
	        "id": 6839,
	        "name": "Villasbuenas de Gata"
	    },
	    {
	        "id": 6840,
	        "name": "Tragacete"
	    },
	    {
	        "id": 6841,
	        "name": "Vilablareix"
	    },
	    {
	        "id": 6842,
	        "name": "Peñalver"
	    },
	    {
	        "id": 6843,
	        "name": "Seira"
	    },
	    {
	        "id": 6844,
	        "name": "Villamol"
	    },
	    {
	        "id": 6845,
	        "name": "Talarn"
	    },
	    {
	        "id": 6846,
	        "name": "San Adrián"
	    },
	    {
	        "id": 6847,
	        "name": "Villalcázar de Sirga"
	    },
	    {
	        "id": 6848,
	        "name": "Nava de Sotrobal"
	    },
	    {
	        "id": 6849,
	        "name": "Valtiendas"
	    },
	    {
	        "id": 6850,
	        "name": "Vinuesa"
	    },
	    {
	        "id": 6851,
	        "name": "Terriente"
	    },
	    {
	        "id": 6852,
	        "name": "Riola"
	    },
	    {
	        "id": 6853,
	        "name": "Villamuriel de Campos"
	    },
	    {
	        "id": 6854,
	        "name": "Pozuel de Ariza"
	    },
	    {
	        "id": 6855,
	        "name": "San Martín del Pimpollar"
	    },
	    {
	        "id": 6856,
	        "name": "Sant Jaume de Frontanyà"
	    },
	    {
	        "id": 6857,
	        "name": "Merindad de Valdeporres"
	    },
	    {
	        "id": 6858,
	        "name": "Zarza de Granadilla"
	    },
	    {
	        "id": 6859,
	        "name": "Tresjuncos"
	    },
	    {
	        "id": 6860,
	        "name": "Viladasens"
	    },
	    {
	        "id": 6861,
	        "name": "Peralejos de las Truchas"
	    },
	    {
	        "id": 6862,
	        "name": "Villamontán de la Valduerna"
	    },
	    {
	        "id": 6863,
	        "name": "Talavera"
	    },
	    {
	        "id": 6864,
	        "name": "Sangüesa/Zangoza"
	    },
	    {
	        "id": 6865,
	        "name": "Villalcón"
	    },
	    {
	        "id": 6866,
	        "name": "Navales"
	    },
	    {
	        "id": 6867,
	        "name": "Valverde del Majano"
	    },
	    {
	        "id": 6868,
	        "name": "Vizmanos"
	    },
	    {
	        "id": 6869,
	        "name": "Teruel"
	    },
	    {
	        "id": 6870,
	        "name": "Rocafort"
	    },
	    {
	        "id": 6871,
	        "name": "Villán de Tordesillas"
	    },
	    {
	        "id": 6872,
	        "name": "Tapioles"
	    },
	    {
	        "id": 6873,
	        "name": "Pozuelo de Aragón"
	    },
	    {
	        "id": 6874,
	        "name": "San Miguel de Corneja"
	    },
	    {
	        "id": 6875,
	        "name": "Sant Joan Despí"
	    },
	    {
	        "id": 6876,
	        "name": "Merindad de Valdivielso"
	    },
	    {
	        "id": 6877,
	        "name": "Zarza de Montánchez"
	    },
	    {
	        "id": 6878,
	        "name": "Tribaldos"
	    },
	    {
	        "id": 6879,
	        "name": "Viladamat"
	    },
	    {
	        "id": 6880,
	        "name": "Peralveche"
	    },
	    {
	        "id": 6881,
	        "name": "Sena"
	    },
	    {
	        "id": 6882,
	        "name": "Villamoratiel de las Matas"
	    },
	    {
	        "id": 6883,
	        "name": "Tàrrega"
	    },
	    {
	        "id": 6884,
	        "name": "San Martín de Unx"
	    },
	    {
	        "id": 6885,
	        "name": "Villalobón"
	    },
	    {
	        "id": 6886,
	        "name": "Navalmoral de Béjar"
	    },
	    {
	        "id": 6887,
	        "name": "Vozmediano"
	    },
	    {
	        "id": 6888,
	        "name": "Toril y Masegoso"
	    },
	    {
	        "id": 6889,
	        "name": "Rotglà i Corberà"
	    },
	    {
	        "id": 6890,
	        "name": "Villanubla"
	    },
	    {
	        "id": 6891,
	        "name": "Pradilla de Ebro"
	    },
	    {
	        "id": 6892,
	        "name": "San Miguel de Serrezuela"
	    },
	    {
	        "id": 6893,
	        "name": "Sant Joan de Vilatorrada"
	    },
	    {
	        "id": 6894,
	        "name": "Milagros"
	    },
	    {
	        "id": 6895,
	        "name": "Zarza la Mayor"
	    },
	    {
	        "id": 6896,
	        "name": "Uclés"
	    },
	    {
	        "id": 6897,
	        "name": "Vilademuls"
	    },
	    {
	        "id": 6898,
	        "name": "Pinilla de Jadraque"
	    },
	    {
	        "id": 6899,
	        "name": "Senés de Alcubierre"
	    },
	    {
	        "id": 6900,
	        "name": "Villanueva de las Manzanas"
	    },
	    {
	        "id": 6901,
	        "name": "Tarrés"
	    },
	    {
	        "id": 6902,
	        "name": "Villaluenga de la Vega"
	    },
	    {
	        "id": 6903,
	        "name": "Navamorales"
	    },
	    {
	        "id": 6904,
	        "name": "Valle de Tabladillo"
	    },
	    {
	        "id": 6905,
	        "name": "Yanguas"
	    },
	    {
	        "id": 6906,
	        "name": "Tormón"
	    },
	    {
	        "id": 6907,
	        "name": "Rótova"
	    },
	    {
	        "id": 6908,
	        "name": "Villanueva de Duero"
	    },
	    {
	        "id": 6909,
	        "name": "Puebla de Albortón"
	    },
	    {
	        "id": 6910,
	        "name": "San Pascual"
	    },
	    {
	        "id": 6911,
	        "name": "Vilassar de Mar"
	    },
	    {
	        "id": 6912,
	        "name": "Miranda de Ebro"
	    },
	    {
	        "id": 6913,
	        "name": "Zorita"
	    },
	    {
	        "id": 6914,
	        "name": "Uña"
	    },
	    {
	        "id": 6915,
	        "name": "Pinilla de Molina"
	    },
	    {
	        "id": 6916,
	        "name": "Villaobispo de Otero"
	    },
	    {
	        "id": 6917,
	        "name": "Tarroja de Segarra"
	    },
	    {
	        "id": 6918,
	        "name": "Sansol"
	    },
	    {
	        "id": 6919,
	        "name": "Navarredonda de la Rinconada"
	    },
	    {
	        "id": 6920,
	        "name": "Vallelado"
	    },
	    {
	        "id": 6921,
	        "name": "Yelo"
	    },
	    {
	        "id": 6922,
	        "name": "Tornos"
	    },
	    {
	        "id": 6923,
	        "name": "Rugat"
	    },
	    {
	        "id": 6924,
	        "name": "Villanueva de la Condesa"
	    },
	    {
	        "id": 6925,
	        "name": "Toro"
	    },
	    {
	        "id": 6926,
	        "name": "La Puebla de Alfindén"
	    },
	    {
	        "id": 6927,
	        "name": "San Pedro del Arroyo"
	    },
	    {
	        "id": 6928,
	        "name": "Sant Julià de Vilatorta"
	    },
	    {
	        "id": 6929,
	        "name": "Miraveche"
	    },
	    {
	        "id": 6930,
	        "name": "Viladrau"
	    },
	    {
	        "id": 6931,
	        "name": "Pioz"
	    },
	    {
	        "id": 6932,
	        "name": "Sesa"
	    },
	    {
	        "id": 6933,
	        "name": "Térmens"
	    },
	    {
	        "id": 6934,
	        "name": "Santacara"
	    },
	    {
	        "id": 6935,
	        "name": "Villamartín de Campos"
	    },
	    {
	        "id": 6936,
	        "name": "Valleruela de Pedraza"
	    },
	    {
	        "id": 6937,
	        "name": "Torralba de los Sisones"
	    },
	    {
	        "id": 6938,
	        "name": "Sagunto/Sagunt"
	    },
	    {
	        "id": 6939,
	        "name": "Villanueva de los Caballeros"
	    },
	    {
	        "id": 6940,
	        "name": "La Torre del Valle"
	    },
	    {
	        "id": 6941,
	        "name": "Puendeluna"
	    },
	    {
	        "id": 6942,
	        "name": "Santa Cruz del Valle"
	    },
	    {
	        "id": 6943,
	        "name": "Sant Just Desvern"
	    },
	    {
	        "id": 6944,
	        "name": "Modúbar de la Emparedada"
	    },
	    {
	        "id": 6945,
	        "name": "Vilafant"
	    },
	    {
	        "id": 6946,
	        "name": "Piqueras"
	    },
	    {
	        "id": 6947,
	        "name": "Sesué"
	    },
	    {
	        "id": 6948,
	        "name": "Villaquejida"
	    },
	    {
	        "id": 6949,
	        "name": "Tírvia"
	    },
	    {
	        "id": 6950,
	        "name": "Doneztebe/Santesteban"
	    },
	    {
	        "id": 6951,
	        "name": "Villamediana"
	    },
	    {
	        "id": 6952,
	        "name": "Navasfrías"
	    },
	    {
	        "id": 6953,
	        "name": "Valleruela de Sepúlveda"
	    },
	    {
	        "id": 6954,
	        "name": "Torrecilla de Alcañiz"
	    },
	    {
	        "id": 6955,
	        "name": "Salem"
	    },
	    {
	        "id": 6956,
	        "name": "Villanueva de los Infantes"
	    },
	    {
	        "id": 6957,
	        "name": "Torregamones"
	    },
	    {
	        "id": 6958,
	        "name": "Purujosa"
	    },
	    {
	        "id": 6959,
	        "name": "Santa Cruz de Pinares"
	    },
	    {
	        "id": 6960,
	        "name": "Sant Llorenç d'Hortons"
	    },
	    {
	        "id": 6961,
	        "name": "Vilaür"
	    },
	    {
	        "id": 6962,
	        "name": "El Pobo de Dueñas"
	    },
	    {
	        "id": 6963,
	        "name": "Siétamo"
	    },
	    {
	        "id": 6964,
	        "name": "Villaquilambre"
	    },
	    {
	        "id": 6965,
	        "name": "Tiurana"
	    },
	    {
	        "id": 6966,
	        "name": "Sarriés/Sartze"
	    },
	    {
	        "id": 6967,
	        "name": "Villameriel"
	    },
	    {
	        "id": 6968,
	        "name": "Negrilla de Palencia"
	    },
	    {
	        "id": 6969,
	        "name": "Veganzones"
	    },
	    {
	        "id": 6970,
	        "name": "Torrecilla del Rebollar"
	    },
	    {
	        "id": 6971,
	        "name": "Sant Joanet"
	    },
	    {
	        "id": 6972,
	        "name": "Villanueva de San Mancio"
	    },
	    {
	        "id": 6973,
	        "name": "Torres del Carrizal"
	    },
	    {
	        "id": 6974,
	        "name": "Quinto"
	    },
	    {
	        "id": 6975,
	        "name": "Sant Llorenç Savall"
	    },
	    {
	        "id": 6976,
	        "name": "Monasterio de la Sierra"
	    },
	    {
	        "id": 6977,
	        "name": "Vilajuïga"
	    },
	    {
	        "id": 6978,
	        "name": "Poveda de la Sierra"
	    },
	    {
	        "id": 6979,
	        "name": "Sopeira"
	    },
	    {
	        "id": 6980,
	        "name": "Villarejo de Órbigo"
	    },
	    {
	        "id": 6981,
	        "name": "Torà"
	    },
	    {
	        "id": 6982,
	        "name": "Sartaguda"
	    },
	    {
	        "id": 6983,
	        "name": "Villamoronta"
	    },
	    {
	        "id": 6984,
	        "name": "Olmedo de Camaces"
	    },
	    {
	        "id": 6985,
	        "name": "Vegas de Matute"
	    },
	    {
	        "id": 6986,
	        "name": "Torre de Arcas"
	    },
	    {
	        "id": 6987,
	        "name": "Sedaví"
	    },
	    {
	        "id": 6988,
	        "name": "Villardefrades"
	    },
	    {
	        "id": 6989,
	        "name": "Trabazos"
	    },
	    {
	        "id": 6990,
	        "name": "Remolinos"
	    },
	    {
	        "id": 6991,
	        "name": "Santa María del Arroyo"
	    },
	    {
	        "id": 6992,
	        "name": "Sant Martí de Centelles"
	    },
	    {
	        "id": 6993,
	        "name": "Monasterio de Rodilla"
	    },
	    {
	        "id": 6994,
	        "name": "Valdemeca"
	    },
	    {
	        "id": 6995,
	        "name": "Vilallonga de Ter"
	    },
	    {
	        "id": 6996,
	        "name": "Pozo de Almoguera"
	    },
	    {
	        "id": 6997,
	        "name": "Villares de Órbigo"
	    },
	    {
	        "id": 6998,
	        "name": "Els Torms"
	    },
	    {
	        "id": 6999,
	        "name": "Sesma"
	    },
	    {
	        "id": 7000,
	        "name": "Villamuera de la Cueza"
	    },
	    {
	        "id": 7001,
	        "name": "La Orbada"
	    },
	    {
	        "id": 7002,
	        "name": "Ventosilla y Tejadilla"
	    },
	    {
	        "id": 7003,
	        "name": "Torre de las Arcas"
	    },
	    {
	        "id": 7004,
	        "name": "Segart"
	    },
	    {
	        "id": 7005,
	        "name": "Villarmentero de Esgueva"
	    },
	    {
	        "id": 7006,
	        "name": "Trefacio"
	    },
	    {
	        "id": 7007,
	        "name": "Retascón"
	    },
	    {
	        "id": 7008,
	        "name": "Santa María del Berrocal"
	    },
	    {
	        "id": 7009,
	        "name": "Sant Martí d'Albars"
	    },
	    {
	        "id": 7010,
	        "name": "Moncalvillo"
	    },
	    {
	        "id": 7011,
	        "name": "Valdemorillo de la Sierra"
	    },
	    {
	        "id": 7012,
	        "name": "Vilamacolum"
	    },
	    {
	        "id": 7013,
	        "name": "Pozo de Guadalajara"
	    },
	    {
	        "id": 7014,
	        "name": "Tamarite de Litera"
	    },
	    {
	        "id": 7015,
	        "name": "Villasabariego"
	    },
	    {
	        "id": 7016,
	        "name": "Tornabous"
	    },
	    {
	        "id": 7017,
	        "name": "Sorlada"
	    },
	    {
	        "id": 7018,
	        "name": "Villamuriel de Cerrato"
	    },
	    {
	        "id": 7019,
	        "name": "Pajares de la Laguna"
	    },
	    {
	        "id": 7020,
	        "name": "Villacastín"
	    },
	    {
	        "id": 7021,
	        "name": "Torre del Compte"
	    },
	    {
	        "id": 7022,
	        "name": "Sellent"
	    },
	    {
	        "id": 7023,
	        "name": "Villasexmir"
	    },
	    {
	        "id": 7024,
	        "name": "Uña de Quintana"
	    },
	    {
	        "id": 7025,
	        "name": "Ricla"
	    },
	    {
	        "id": 7026,
	        "name": "Santa María de los Caballeros"
	    },
	    {
	        "id": 7027,
	        "name": "Sant Martí de Tous"
	    },
	    {
	        "id": 7028,
	        "name": "Monterrubio de la Demanda"
	    },
	    {
	        "id": 7029,
	        "name": "Vilamalla"
	    },
	    {
	        "id": 7030,
	        "name": "Prádena de Atienza"
	    },
	    {
	        "id": 7031,
	        "name": "Tardienta"
	    },
	    {
	        "id": 7032,
	        "name": "Villaselán"
	    },
	    {
	        "id": 7033,
	        "name": "Torrebesses"
	    },
	    {
	        "id": 7034,
	        "name": "Sunbilla"
	    },
	    {
	        "id": 7035,
	        "name": "Palacios del Arzobispo"
	    },
	    {
	        "id": 7036,
	        "name": "Torrelacárcel"
	    },
	    {
	        "id": 7037,
	        "name": "Sempere"
	    },
	    {
	        "id": 7038,
	        "name": "Villavaquerín"
	    },
	    {
	        "id": 7039,
	        "name": "Vadillo de la Guareña"
	    },
	    {
	        "id": 7040,
	        "name": "Santa María del Tiétar"
	    },
	    {
	        "id": 7041,
	        "name": "Sant Martí Sarroca"
	    },
	    {
	        "id": 7042,
	        "name": "Montorio"
	    },
	    {
	        "id": 7043,
	        "name": "Valdemoro-Sierra"
	    },
	    {
	        "id": 7044,
	        "name": "Vilamaniscle"
	    },
	    {
	        "id": 7045,
	        "name": "Prados Redondos"
	    },
	    {
	        "id": 7046,
	        "name": "Tella-Sin"
	    },
	    {
	        "id": 7047,
	        "name": "Villaturiel"
	    },
	    {
	        "id": 7048,
	        "name": "La Torre de Cabdella"
	    },
	    {
	        "id": 7049,
	        "name": "Tafalla"
	    },
	    {
	        "id": 7050,
	        "name": "Villanueva del Rebollar"
	    },
	    {
	        "id": 7051,
	        "name": "Torre los Negros"
	    },
	    {
	        "id": 7052,
	        "name": "Senyera"
	    },
	    {
	        "id": 7053,
	        "name": "Villavellid"
	    },
	    {
	        "id": 7054,
	        "name": "Valcabado"
	    },
	    {
	        "id": 7055,
	        "name": "Romanos"
	    },
	    {
	        "id": 7056,
	        "name": "Santiago del Collado"
	    },
	    {
	        "id": 7057,
	        "name": "Sant Martí Sesgueioles"
	    },
	    {
	        "id": 7058,
	        "name": "Moradillo de Roa"
	    },
	    {
	        "id": 7059,
	        "name": "Valdeolivas"
	    },
	    {
	        "id": 7060,
	        "name": "Vilanant"
	    },
	    {
	        "id": 7061,
	        "name": "Puebla de Beleña"
	    },
	    {
	        "id": 7062,
	        "name": "Tierz"
	    },
	    {
	        "id": 7063,
	        "name": "Villazala"
	    },
	    {
	        "id": 7064,
	        "name": "Torrefarrera"
	    },
	    {
	        "id": 7065,
	        "name": "Tiebas-Muruarte de Reta"
	    },
	    {
	        "id": 7066,
	        "name": "Villanuño de Valdavia"
	    },
	    {
	        "id": 7067,
	        "name": "Palaciosrubios"
	    },
	    {
	        "id": 7068,
	        "name": "Villaverde de Íscar"
	    },
	    {
	        "id": 7069,
	        "name": "Torremocha de Jiloca"
	    },
	    {
	        "id": 7070,
	        "name": "Serra"
	    },
	    {
	        "id": 7071,
	        "name": "Villaverde de Medina"
	    },
	    {
	        "id": 7072,
	        "name": "Valdefinjas"
	    },
	    {
	        "id": 7073,
	        "name": "Rueda de Jalón"
	    },
	    {
	        "id": 7074,
	        "name": "Santo Domingo de las Posadas"
	    },
	    {
	        "id": 7075,
	        "name": "Sant Mateu de Bages"
	    },
	    {
	        "id": 7076,
	        "name": "Nava de Roa"
	    },
	    {
	        "id": 7077,
	        "name": "Puebla de Valles"
	    },
	    {
	        "id": 7078,
	        "name": "Tolva"
	    },
	    {
	        "id": 7079,
	        "name": "Villazanzo de Valderaduey"
	    },
	    {
	        "id": 7080,
	        "name": "Tirapu"
	    },
	    {
	        "id": 7081,
	        "name": "Villaprovedo"
	    },
	    {
	        "id": 7082,
	        "name": "Palencia de Negrilla"
	    },
	    {
	        "id": 7083,
	        "name": "Villaverde de Montejo"
	    },
	    {
	        "id": 7084,
	        "name": "Torres de Albarracín"
	    },
	    {
	        "id": 7085,
	        "name": "Siete Aguas"
	    },
	    {
	        "id": 7086,
	        "name": "Villavicencio de los Caballeros"
	    },
	    {
	        "id": 7087,
	        "name": "Valdescorriel"
	    },
	    {
	        "id": 7088,
	        "name": "Ruesca"
	    },
	    {
	        "id": 7089,
	        "name": "Santo Tomé de Zabarcos"
	    },
	    {
	        "id": 7090,
	        "name": "Premià de Dalt"
	    },
	    {
	        "id": 7091,
	        "name": "Navas de Bureba"
	    },
	    {
	        "id": 7092,
	        "name": "Vila-sacra"
	    },
	    {
	        "id": 7093,
	        "name": "Quer"
	    },
	    {
	        "id": 7094,
	        "name": "Torla"
	    },
	    {
	        "id": 7095,
	        "name": "Zotes del Páramo"
	    },
	    {
	        "id": 7096,
	        "name": "Torregrossa"
	    },
	    {
	        "id": 7097,
	        "name": "Torralba del Río"
	    },
	    {
	        "id": 7098,
	        "name": "Villarmentero de Campos"
	    },
	    {
	        "id": 7099,
	        "name": "Parada de Arriba"
	    },
	    {
	        "id": 7100,
	        "name": "Villeguillo"
	    },
	    {
	        "id": 7101,
	        "name": "Torrevelilla"
	    },
	    {
	        "id": 7102,
	        "name": "Silla"
	    },
	    {
	        "id": 7103,
	        "name": "Wamba"
	    },
	    {
	        "id": 7104,
	        "name": "Vallesa de la Guareña"
	    },
	    {
	        "id": 7105,
	        "name": "Sádaba"
	    },
	    {
	        "id": 7106,
	        "name": "San Vicente de Arévalo"
	    },
	    {
	        "id": 7107,
	        "name": "Sant Pere de Ribes"
	    },
	    {
	        "id": 7108,
	        "name": "Nebreda"
	    },
	    {
	        "id": 7109,
	        "name": "Valhermoso de la Fuente"
	    },
	    {
	        "id": 7110,
	        "name": "Rebollosa de Jadraque"
	    },
	    {
	        "id": 7111,
	        "name": "Torrelameu"
	    },
	    {
	        "id": 7112,
	        "name": "Torres del Río"
	    },
	    {
	        "id": 7113,
	        "name": "Villarrabé"
	    },
	    {
	        "id": 7114,
	        "name": "Parada de Rubiales"
	    },
	    {
	        "id": 7115,
	        "name": "Yanguas de Eresma"
	    },
	    {
	        "id": 7116,
	        "name": "Torrijas"
	    },
	    {
	        "id": 7117,
	        "name": "Simat de la Valldigna"
	    },
	    {
	        "id": 7118,
	        "name": "Zaratán"
	    },
	    {
	        "id": 7119,
	        "name": "Vega de Tera"
	    },
	    {
	        "id": 7120,
	        "name": "Salillas de Jalón"
	    },
	    {
	        "id": 7121,
	        "name": "La Serrada"
	    },
	    {
	        "id": 7122,
	        "name": "Sant Pere de Riudebitlles"
	    },
	    {
	        "id": 7123,
	        "name": "Neila"
	    },
	    {
	        "id": 7124,
	        "name": "Vilopriu"
	    },
	    {
	        "id": 7125,
	        "name": "El Recuenco"
	    },
	    {
	        "id": 7126,
	        "name": "Torralba de Aragón"
	    },
	    {
	        "id": 7127,
	        "name": "Torres de Segre"
	    },
	    {
	        "id": 7128,
	        "name": "Tudela"
	    },
	    {
	        "id": 7129,
	        "name": "Villarramiel"
	    },
	    {
	        "id": 7130,
	        "name": "Paradinas de San Juan"
	    },
	    {
	        "id": 7131,
	        "name": "Torrijo del Campo"
	    },
	    {
	        "id": 7132,
	        "name": "Sinarcas"
	    },
	    {
	        "id": 7133,
	        "name": "La Zarza"
	    },
	    {
	        "id": 7134,
	        "name": "Vega de Villalobos"
	    },
	    {
	        "id": 7135,
	        "name": "Salvatierra de Esca"
	    },
	    {
	        "id": 7136,
	        "name": "Serranillos"
	    },
	    {
	        "id": 7137,
	        "name": "Sant Pere de Torelló"
	    },
	    {
	        "id": 7138,
	        "name": "Vilobí d'Onyar"
	    },
	    {
	        "id": 7139,
	        "name": "Renera"
	    },
	    {
	        "id": 7140,
	        "name": "Torre la Ribera"
	    },
	    {
	        "id": 7141,
	        "name": "Torre-serona"
	    },
	    {
	        "id": 7142,
	        "name": "Tulebras"
	    },
	    {
	        "id": 7143,
	        "name": "Villasarracino"
	    },
	    {
	        "id": 7144,
	        "name": "Pastores"
	    },
	    {
	        "id": 7145,
	        "name": "Zarzuela del Monte"
	    },
	    {
	        "id": 7146,
	        "name": "Sollana"
	    },
	    {
	        "id": 7147,
	        "name": "Vegalatrave"
	    },
	    {
	        "id": 7148,
	        "name": "Samper del Salz"
	    },
	    {
	        "id": 7149,
	        "name": "Sigeres"
	    },
	    {
	        "id": 7150,
	        "name": "Sant Pere de Vilamajor"
	    },
	    {
	        "id": 7151,
	        "name": "Valsalobre"
	    },
	    {
	        "id": 7152,
	        "name": "Biure"
	    },
	    {
	        "id": 7153,
	        "name": "Retiendas"
	    },
	    {
	        "id": 7154,
	        "name": "Torrente de Cinca"
	    },
	    {
	        "id": 7155,
	        "name": "Tremp"
	    },
	    {
	        "id": 7156,
	        "name": "Ucar"
	    },
	    {
	        "id": 7157,
	        "name": "Villasila de Valdavia"
	    },
	    {
	        "id": 7158,
	        "name": "El Payo"
	    },
	    {
	        "id": 7159,
	        "name": "Zarzuela del Pinar"
	    },
	    {
	        "id": 7160,
	        "name": "Tramacastiel"
	    },
	    {
	        "id": 7161,
	        "name": "Sot de Chera"
	    },
	    {
	        "id": 7162,
	        "name": "Venialbo"
	    },
	    {
	        "id": 7163,
	        "name": "San Martín de la Virgen de Moncayo"
	    },
	    {
	        "id": 7164,
	        "name": "Sinlabajos"
	    },
	    {
	        "id": 7165,
	        "name": "Sant Pol de Mar"
	    },
	    {
	        "id": 7166,
	        "name": "Olmedillo de Roa"
	    },
	    {
	        "id": 7167,
	        "name": "Riba de Saelices"
	    },
	    {
	        "id": 7168,
	        "name": "Torres de Alcanadre"
	    },
	    {
	        "id": 7169,
	        "name": "Ujué"
	    },
	    {
	        "id": 7170,
	        "name": "Pedraza de Alba"
	    },
	    {
	        "id": 7171,
	        "name": "Tramacastilla"
	    },
	    {
	        "id": 7172,
	        "name": "Sueca"
	    },
	    {
	        "id": 7173,
	        "name": "Vezdemarbán"
	    },
	    {
	        "id": 7174,
	        "name": "San Mateo de Gállego"
	    },
	    {
	        "id": 7175,
	        "name": "Solana de Ávila"
	    },
	    {
	        "id": 7176,
	        "name": "Sant Quintí de Mediona"
	    },
	    {
	        "id": 7177,
	        "name": "Olmillos de Muñó"
	    },
	    {
	        "id": 7178,
	        "name": "Valverde de Júcar"
	    },
	    {
	        "id": 7179,
	        "name": "Torres de Barbués"
	    },
	    {
	        "id": 7180,
	        "name": "Ultzama"
	    },
	    {
	        "id": 7181,
	        "name": "Villaturde"
	    },
	    {
	        "id": 7182,
	        "name": "Pedrosillo de Alba"
	    },
	    {
	        "id": 7183,
	        "name": "Tronchón"
	    },
	    {
	        "id": 7184,
	        "name": "Sumacàrcer"
	    },
	    {
	        "id": 7185,
	        "name": "Vidayanes"
	    },
	    {
	        "id": 7186,
	        "name": "Santa Cruz de Grío"
	    },
	    {
	        "id": 7187,
	        "name": "Solana de Rioalmar"
	    },
	    {
	        "id": 7188,
	        "name": "Sant Quirze de Besora"
	    },
	    {
	        "id": 7189,
	        "name": "Valverdejo"
	    },
	    {
	        "id": 7190,
	        "name": "Rillo de Gallo"
	    },
	    {
	        "id": 7191,
	        "name": "Unciti"
	    },
	    {
	        "id": 7192,
	        "name": "Villaumbrales"
	    },
	    {
	        "id": 7193,
	        "name": "Pedrosillo de los Aires"
	    },
	    {
	        "id": 7194,
	        "name": "Urrea de Gaén"
	    },
	    {
	        "id": 7195,
	        "name": "Tavernes Blanques"
	    },
	    {
	        "id": 7196,
	        "name": "Videmala"
	    },
	    {
	        "id": 7197,
	        "name": "Santa Cruz de Moncayo"
	    },
	    {
	        "id": 7198,
	        "name": "Solosancho"
	    },
	    {
	        "id": 7199,
	        "name": "Sant Quirze del Vallès"
	    },
	    {
	        "id": 7200,
	        "name": "Oña"
	    },
	    {
	        "id": 7201,
	        "name": "Vara de Rey"
	    },
	    {
	        "id": 7202,
	        "name": "Riofrío del Llano"
	    },
	    {
	        "id": 7203,
	        "name": "Vallbona de les Monges"
	    },
	    {
	        "id": 7204,
	        "name": "Unzué/Untzue"
	    },
	    {
	        "id": 7205,
	        "name": "Villaviudas"
	    },
	    {
	        "id": 7206,
	        "name": "Pedrosillo el Ralo"
	    },
	    {
	        "id": 7207,
	        "name": "Utrillas"
	    },
	    {
	        "id": 7208,
	        "name": "Tavernes de la Valldigna"
	    },
	    {
	        "id": 7209,
	        "name": "Villabrázaro"
	    },
	    {
	        "id": 7210,
	        "name": "Santa Eulalia de Gállego"
	    },
	    {
	        "id": 7211,
	        "name": "Sotalbo"
	    },
	    {
	        "id": 7212,
	        "name": "Sant Quirze Safaja"
	    },
	    {
	        "id": 7213,
	        "name": "Oquillas"
	    },
	    {
	        "id": 7214,
	        "name": "Vega del Codorno"
	    },
	    {
	        "id": 7215,
	        "name": "Robledillo de Mohernando"
	    },
	    {
	        "id": 7216,
	        "name": "Tramaced"
	    },
	    {
	        "id": 7217,
	        "name": "Les Valls de Valira"
	    },
	    {
	        "id": 7218,
	        "name": "Urdazubi/Urdax"
	    },
	    {
	        "id": 7219,
	        "name": "El Pedroso de la Armuña"
	    },
	    {
	        "id": 7220,
	        "name": "Valacloche"
	    },
	    {
	        "id": 7221,
	        "name": "Teresa de Cofrentes"
	    },
	    {
	        "id": 7222,
	        "name": "Villabuena del Puente"
	    },
	    {
	        "id": 7223,
	        "name": "Santed"
	    },
	    {
	        "id": 7224,
	        "name": "Sotillo de la Adrada"
	    },
	    {
	        "id": 7225,
	        "name": "Sant Sadurní d'Anoia"
	    },
	    {
	        "id": 7226,
	        "name": "Vellisca"
	    },
	    {
	        "id": 7227,
	        "name": "Robledo de Corpes"
	    },
	    {
	        "id": 7228,
	        "name": "Vallfogona de Balaguer"
	    },
	    {
	        "id": 7229,
	        "name": "Urdiain"
	    },
	    {
	        "id": 7230,
	        "name": "Villerías de Campos"
	    },
	    {
	        "id": 7231,
	        "name": "Pelabravo"
	    },
	    {
	        "id": 7232,
	        "name": "Valbona"
	    },
	    {
	        "id": 7233,
	        "name": "Terrateig"
	    },
	    {
	        "id": 7234,
	        "name": "Villadepera"
	    },
	    {
	        "id": 7235,
	        "name": "Sástago"
	    },
	    {
	        "id": 7236,
	        "name": "El Tiemblo"
	    },
	    {
	        "id": 7237,
	        "name": "Sant Sadurní d'Osormort"
	    },
	    {
	        "id": 7238,
	        "name": "Orbaneja Riopico"
	    },
	    {
	        "id": 7239,
	        "name": "Romanillos de Atienza"
	    },
	    {
	        "id": 7240,
	        "name": "Urraul Alto"
	    },
	    {
	        "id": 7241,
	        "name": "Villodre"
	    },
	    {
	        "id": 7242,
	        "name": "Pelarrodríguez"
	    },
	    {
	        "id": 7243,
	        "name": "Valdealgorfa"
	    },
	    {
	        "id": 7244,
	        "name": "Titaguas"
	    },
	    {
	        "id": 7245,
	        "name": "Villaescusa"
	    },
	    {
	        "id": 7246,
	        "name": "Sabiñán"
	    },
	    {
	        "id": 7247,
	        "name": "Tiñosillos"
	    },
	    {
	        "id": 7248,
	        "name": "Marganell"
	    },
	    {
	        "id": 7249,
	        "name": "Padilla de Abajo"
	    },
	    {
	        "id": 7250,
	        "name": "Villaconejos de Trabaque"
	    },
	    {
	        "id": 7251,
	        "name": "Romanones"
	    },
	    {
	        "id": 7252,
	        "name": "Valfarta"
	    },
	    {
	        "id": 7253,
	        "name": "Verdú"
	    },
	    {
	        "id": 7254,
	        "name": "Urraul Bajo"
	    },
	    {
	        "id": 7255,
	        "name": "Villodrigo"
	    },
	    {
	        "id": 7256,
	        "name": "Pelayos"
	    },
	    {
	        "id": 7257,
	        "name": "Torrebaja"
	    },
	    {
	        "id": 7258,
	        "name": "Villafáfila"
	    },
	    {
	        "id": 7259,
	        "name": "Sediles"
	    },
	    {
	        "id": 7260,
	        "name": "Tolbaños"
	    },
	    {
	        "id": 7261,
	        "name": "Santa Cecília de Voltregà"
	    },
	    {
	        "id": 7262,
	        "name": "Padilla de Arriba"
	    },
	    {
	        "id": 7263,
	        "name": "Villaescusa de Haro"
	    },
	    {
	        "id": 7264,
	        "name": "Rueda de la Sierra"
	    },
	    {
	        "id": 7265,
	        "name": "Valle de Bardají"
	    },
	    {
	        "id": 7266,
	        "name": "Vielha e Mijaran"
	    },
	    {
	        "id": 7267,
	        "name": "Urroz-Villa"
	    },
	    {
	        "id": 7268,
	        "name": "Villoldo"
	    },
	    {
	        "id": 7269,
	        "name": "La Peña"
	    },
	    {
	        "id": 7270,
	        "name": "Valdecuenca"
	    },
	    {
	        "id": 7271,
	        "name": "Torrella"
	    },
	    {
	        "id": 7272,
	        "name": "Villaferrueña"
	    },
	    {
	        "id": 7273,
	        "name": "Sestrica"
	    },
	    {
	        "id": 7274,
	        "name": "Tormellas"
	    },
	    {
	        "id": 7275,
	        "name": "Santa Coloma de Cervelló"
	    },
	    {
	        "id": 7276,
	        "name": "Padrones de Bureba"
	    },
	    {
	        "id": 7277,
	        "name": "Villagarcía del Llano"
	    },
	    {
	        "id": 7278,
	        "name": "Sacecorbo"
	    },
	    {
	        "id": 7279,
	        "name": "Valle de Lierp"
	    },
	    {
	        "id": 7280,
	        "name": "Vilagrassa"
	    },
	    {
	        "id": 7281,
	        "name": "Urrotz"
	    },
	    {
	        "id": 7282,
	        "name": "Peñacaballera"
	    },
	    {
	        "id": 7283,
	        "name": "Valdelinares"
	    },
	    {
	        "id": 7284,
	        "name": "Torrent"
	    },
	    {
	        "id": 7285,
	        "name": "Villageriz"
	    },
	    {
	        "id": 7286,
	        "name": "Sierra de Luna"
	    },
	    {
	        "id": 7287,
	        "name": "Tornadizos de Ávila"
	    },
	    {
	        "id": 7288,
	        "name": "Santa Coloma de Gramenet"
	    },
	    {
	        "id": 7289,
	        "name": "Villalba de la Sierra"
	    },
	    {
	        "id": 7290,
	        "name": "Sacedón"
	    },
	    {
	        "id": 7291,
	        "name": "Velilla de Cinca"
	    },
	    {
	        "id": 7292,
	        "name": "Vilaller"
	    },
	    {
	        "id": 7293,
	        "name": "Urzainqui/Urzainki"
	    },
	    {
	        "id": 7294,
	        "name": "Villota del Páramo"
	    },
	    {
	        "id": 7295,
	        "name": "Peñaparda"
	    },
	    {
	        "id": 7296,
	        "name": "Valdeltormo"
	    },
	    {
	        "id": 7297,
	        "name": "Torres Torres"
	    },
	    {
	        "id": 7298,
	        "name": "Villalazán"
	    },
	    {
	        "id": 7299,
	        "name": "Sigüés"
	    },
	    {
	        "id": 7300,
	        "name": "Tórtoles"
	    },
	    {
	        "id": 7301,
	        "name": "Santa Eugènia de Berga"
	    },
	    {
	        "id": 7302,
	        "name": "Palacios de la Sierra"
	    },
	    {
	        "id": 7303,
	        "name": "Villalba del Rey"
	    },
	    {
	        "id": 7304,
	        "name": "Saelices de la Sal"
	    },
	    {
	        "id": 7305,
	        "name": "Beranuy"
	    },
	    {
	        "id": 7306,
	        "name": "Uterga"
	    },
	    {
	        "id": 7307,
	        "name": "Villovieco"
	    },
	    {
	        "id": 7308,
	        "name": "Peñaranda de Bracamonte"
	    },
	    {
	        "id": 7309,
	        "name": "Valderrobres"
	    },
	    {
	        "id": 7310,
	        "name": "Tous"
	    },
	    {
	        "id": 7311,
	        "name": "Villalba de la Lampreana"
	    },
	    {
	        "id": 7312,
	        "name": "Sisamón"
	    },
	    {
	        "id": 7313,
	        "name": "La Torre"
	    },
	    {
	        "id": 7314,
	        "name": "Santa Eulàlia de Riuprimer"
	    },
	    {
	        "id": 7315,
	        "name": "Palacios de Riopisuerga"
	    },
	    {
	        "id": 7316,
	        "name": "Villalgordo del Marquesado"
	    },
	    {
	        "id": 7317,
	        "name": "Salmerón"
	    },
	    {
	        "id": 7318,
	        "name": "Viacamp y Litera"
	    },
	    {
	        "id": 7319,
	        "name": "Vilamòs"
	    },
	    {
	        "id": 7320,
	        "name": "Uztárroz/Uztarroze"
	    },
	    {
	        "id": 7321,
	        "name": "Peñarandilla"
	    },
	    {
	        "id": 7322,
	        "name": "Valjunquera"
	    },
	    {
	        "id": 7323,
	        "name": "Tuéjar"
	    },
	    {
	        "id": 7324,
	        "name": "Villalcampo"
	    },
	    {
	        "id": 7325,
	        "name": "Sobradiel"
	    },
	    {
	        "id": 7326,
	        "name": "Santa Eulàlia de Ronçana"
	    },
	    {
	        "id": 7327,
	        "name": "Palazuelos de la Sierra"
	    },
	    {
	        "id": 7328,
	        "name": "Villalpardo"
	    },
	    {
	        "id": 7329,
	        "name": "San Andrés del Congosto"
	    },
	    {
	        "id": 7330,
	        "name": "Vicién"
	    },
	    {
	        "id": 7331,
	        "name": "Vilanova de Bellpuig"
	    },
	    {
	        "id": 7332,
	        "name": "Luzaide/Valcarlos"
	    },
	    {
	        "id": 7333,
	        "name": "Peralejos de Abajo"
	    },
	    {
	        "id": 7334,
	        "name": "Turís"
	    },
	    {
	        "id": 7335,
	        "name": "Villalobos"
	    },
	    {
	        "id": 7336,
	        "name": "Sos del Rey Católico"
	    },
	    {
	        "id": 7337,
	        "name": "Umbrías"
	    },
	    {
	        "id": 7338,
	        "name": "Santa Fe del Penedès"
	    },
	    {
	        "id": 7339,
	        "name": "Palazuelos de Muñó"
	    },
	    {
	        "id": 7340,
	        "name": "Villamayor de Santiago"
	    },
	    {
	        "id": 7341,
	        "name": "San Andrés del Rey"
	    },
	    {
	        "id": 7342,
	        "name": "Villanova"
	    },
	    {
	        "id": 7343,
	        "name": "Vilanova de l'Aguda"
	    },
	    {
	        "id": 7344,
	        "name": "Valtierra"
	    },
	    {
	        "id": 7345,
	        "name": "Peralejos de Arriba"
	    },
	    {
	        "id": 7346,
	        "name": "El Vallecillo"
	    },
	    {
	        "id": 7347,
	        "name": "Utiel"
	    },
	    {
	        "id": 7348,
	        "name": "Villalonso"
	    },
	    {
	        "id": 7349,
	        "name": "Tabuenca"
	    },
	    {
	        "id": 7350,
	        "name": "Santa Margarida de Montbui"
	    },
	    {
	        "id": 7351,
	        "name": "Pampliega"
	    },
	    {
	        "id": 7352,
	        "name": "Villanueva de Guadamejud"
	    },
	    {
	        "id": 7353,
	        "name": "Santiuste"
	    },
	    {
	        "id": 7354,
	        "name": "Villanúa"
	    },
	    {
	        "id": 7355,
	        "name": "Vilanova de Meià"
	    },
	    {
	        "id": 7356,
	        "name": "Bera"
	    },
	    {
	        "id": 7357,
	        "name": "Pereña de la Ribera"
	    },
	    {
	        "id": 7358,
	        "name": "Veguillas de la Sierra"
	    },
	    {
	        "id": 7359,
	        "name": "Valencia"
	    },
	    {
	        "id": 7360,
	        "name": "Villalpando"
	    },
	    {
	        "id": 7361,
	        "name": "Talamantes"
	    },
	    {
	        "id": 7362,
	        "name": "Vadillo de la Sierra"
	    },
	    {
	        "id": 7363,
	        "name": "Santa Margarida i els Monjos"
	    },
	    {
	        "id": 7364,
	        "name": "Pancorbo"
	    },
	    {
	        "id": 7365,
	        "name": "Villanueva de la Jara"
	    },
	    {
	        "id": 7366,
	        "name": "Saúca"
	    },
	    {
	        "id": 7367,
	        "name": "Villanueva de Sigena"
	    },
	    {
	        "id": 7368,
	        "name": "Vilanova de Segrià"
	    },
	    {
	        "id": 7369,
	        "name": "Viana"
	    },
	    {
	        "id": 7370,
	        "name": "Peromingo"
	    },
	    {
	        "id": 7371,
	        "name": "Villafranca del Campo"
	    },
	    {
	        "id": 7372,
	        "name": "Vallada"
	    },
	    {
	        "id": 7373,
	        "name": "Villalube"
	    },
	    {
	        "id": 7374,
	        "name": "Tarazona"
	    },
	    {
	        "id": 7375,
	        "name": "Valdecasa"
	    },
	    {
	        "id": 7376,
	        "name": "Barberà del Vallès"
	    },
	    {
	        "id": 7377,
	        "name": "Sayatón"
	    },
	    {
	        "id": 7378,
	        "name": "Yebra de Basa"
	    },
	    {
	        "id": 7379,
	        "name": "Vila-sana"
	    },
	    {
	        "id": 7380,
	        "name": "Vidángoz/Bidankoze"
	    },
	    {
	        "id": 7381,
	        "name": "Pinedas"
	    },
	    {
	        "id": 7382,
	        "name": "Villahermosa del Campo"
	    },
	    {
	        "id": 7383,
	        "name": "Vallanca"
	    },
	    {
	        "id": 7384,
	        "name": "Villamayor de Campos"
	    },
	    {
	        "id": 7385,
	        "name": "Tauste"
	    },
	    {
	        "id": 7386,
	        "name": "Vega de Santa María"
	    },
	    {
	        "id": 7387,
	        "name": "Santa Maria de Besora"
	    },
	    {
	        "id": 7388,
	        "name": "Pardilla"
	    },
	    {
	        "id": 7389,
	        "name": "Villar de Cañas"
	    },
	    {
	        "id": 7390,
	        "name": "Yésero"
	    },
	    {
	        "id": 7391,
	        "name": "El Vilosell"
	    },
	    {
	        "id": 7392,
	        "name": "Bidaurreta"
	    },
	    {
	        "id": 7393,
	        "name": "El Pino de Tormes"
	    },
	    {
	        "id": 7394,
	        "name": "Vallés"
	    },
	    {
	        "id": 7395,
	        "name": "Terrer"
	    },
	    {
	        "id": 7396,
	        "name": "Velayos"
	    },
	    {
	        "id": 7397,
	        "name": "Santa Maria de Corcó"
	    },
	    {
	        "id": 7398,
	        "name": "Villar de Domingo García"
	    },
	    {
	        "id": 7399,
	        "name": "Selas"
	    },
	    {
	        "id": 7400,
	        "name": "Zaidín"
	    },
	    {
	        "id": 7401,
	        "name": "Vilanova de la Barca"
	    },
	    {
	        "id": 7402,
	        "name": "Villafranca"
	    },
	    {
	        "id": 7403,
	        "name": "Pitiegua"
	    },
	    {
	        "id": 7404,
	        "name": "Venta del Moro"
	    },
	    {
	        "id": 7405,
	        "name": "Tierga"
	    },
	    {
	        "id": 7406,
	        "name": "Santa Maria de Merlès"
	    },
	    {
	        "id": 7407,
	        "name": "Partido de la Sierra en Tobalina"
	    },
	    {
	        "id": 7408,
	        "name": "Villar de la Encina"
	    },
	    {
	        "id": 7409,
	        "name": "Setiles"
	    },
	    {
	        "id": 7410,
	        "name": "Vinaixa"
	    },
	    {
	        "id": 7411,
	        "name": "Villamayor de Monjardín"
	    },
	    {
	        "id": 7412,
	        "name": "Pizarral"
	    },
	    {
	        "id": 7413,
	        "name": "Villalonga"
	    },
	    {
	        "id": 7414,
	        "name": "Villamor de los Escuderos"
	    },
	    {
	        "id": 7415,
	        "name": "Tobed"
	    },
	    {
	        "id": 7416,
	        "name": "Villaflor"
	    },
	    {
	        "id": 7417,
	        "name": "Santa Maria de Martorelles"
	    },
	    {
	        "id": 7418,
	        "name": "Pedrosa de Duero"
	    },
	    {
	        "id": 7419,
	        "name": "Sienes"
	    },
	    {
	        "id": 7420,
	        "name": "Hiriberri/Villanueva de Aezkoa"
	    },
	    {
	        "id": 7421,
	        "name": "Poveda de las Cintas"
	    },
	    {
	        "id": 7422,
	        "name": "Villanueva del Rebollar de la Sierra"
	    },
	    {
	        "id": 7423,
	        "name": "Vilamarxant"
	    },
	    {
	        "id": 7424,
	        "name": "Villanázar"
	    },
	    {
	        "id": 7425,
	        "name": "Torralba de los Frailes"
	    },
	    {
	        "id": 7426,
	        "name": "Villafranca de la Sierra"
	    },
	    {
	        "id": 7427,
	        "name": "Santa Maria de Miralles"
	    },
	    {
	        "id": 7428,
	        "name": "Pedrosa del Páramo"
	    },
	    {
	        "id": 7429,
	        "name": "Sigüenza"
	    },
	    {
	        "id": 7430,
	        "name": "Villatuerta"
	    },
	    {
	        "id": 7431,
	        "name": "Pozos de Hinojo"
	    },
	    {
	        "id": 7432,
	        "name": "Villar del Cobo"
	    },
	    {
	        "id": 7433,
	        "name": "Villanueva de Castellón"
	    },
	    {
	        "id": 7434,
	        "name": "Villanueva de Azoague"
	    },
	    {
	        "id": 7435,
	        "name": "Torralba de Ribota"
	    },
	    {
	        "id": 7436,
	        "name": "Villanueva de Gómez"
	    },
	    {
	        "id": 7437,
	        "name": "Santa Maria d'Oló"
	    },
	    {
	        "id": 7438,
	        "name": "Pedrosa del Príncipe"
	    },
	    {
	        "id": 7439,
	        "name": "Villar del Humo"
	    },
	    {
	        "id": 7440,
	        "name": "Solanillos del Extremo"
	    },
	    {
	        "id": 7441,
	        "name": "Villava/Atarrabia"
	    },
	    {
	        "id": 7442,
	        "name": "Puebla de Azaba"
	    },
	    {
	        "id": 7443,
	        "name": "Villar del Salz"
	    },
	    {
	        "id": 7444,
	        "name": "Villar del Arzobispo"
	    },
	    {
	        "id": 7445,
	        "name": "Villanueva de Campeán"
	    },
	    {
	        "id": 7446,
	        "name": "Torralbilla"
	    },
	    {
	        "id": 7447,
	        "name": "Villanueva del Aceral"
	    },
	    {
	        "id": 7448,
	        "name": "Santa Maria de Palautordera"
	    },
	    {
	        "id": 7449,
	        "name": "Pedrosa de Río Úrbel"
	    },
	    {
	        "id": 7450,
	        "name": "Villar del Infantado"
	    },
	    {
	        "id": 7451,
	        "name": "Somolinos"
	    },
	    {
	        "id": 7452,
	        "name": "Igantzi"
	    },
	    {
	        "id": 7453,
	        "name": "Puebla de San Medel"
	    },
	    {
	        "id": 7454,
	        "name": "Villargordo del Cabriel"
	    },
	    {
	        "id": 7455,
	        "name": "Villanueva de las Peras"
	    },
	    {
	        "id": 7456,
	        "name": "Torrehermosa"
	    },
	    {
	        "id": 7457,
	        "name": "Villanueva del Campillo"
	    },
	    {
	        "id": 7458,
	        "name": "Santa Perpètua de Mogoda"
	    },
	    {
	        "id": 7459,
	        "name": "El Sotillo"
	    },
	    {
	        "id": 7460,
	        "name": "Valle de Yerri/Deierri"
	    },
	    {
	        "id": 7461,
	        "name": "Puebla de Yeltes"
	    },
	    {
	        "id": 7462,
	        "name": "Villarluengo"
	    },
	    {
	        "id": 7463,
	        "name": "Vinalesa"
	    },
	    {
	        "id": 7464,
	        "name": "Villanueva del Campo"
	    },
	    {
	        "id": 7465,
	        "name": "Torrelapaja"
	    },
	    {
	        "id": 7466,
	        "name": "Villar de Corneja"
	    },
	    {
	        "id": 7467,
	        "name": "Santa Susanna"
	    },
	    {
	        "id": 7468,
	        "name": "Peñaranda de Duero"
	    },
	    {
	        "id": 7469,
	        "name": "Sotodosos"
	    },
	    {
	        "id": 7470,
	        "name": "Yesa"
	    },
	    {
	        "id": 7471,
	        "name": "Puente del Congosto"
	    },
	    {
	        "id": 7472,
	        "name": "Villarquemado"
	    },
	    {
	        "id": 7473,
	        "name": "Yátova"
	    },
	    {
	        "id": 7474,
	        "name": "Villaralbo"
	    },
	    {
	        "id": 7475,
	        "name": "Torrellas"
	    },
	    {
	        "id": 7476,
	        "name": "Villarejo del Valle"
	    },
	    {
	        "id": 7477,
	        "name": "Sant Vicenç de Castellet"
	    },
	    {
	        "id": 7478,
	        "name": "Peral de Arlanza"
	    },
	    {
	        "id": 7479,
	        "name": "Tamajón"
	    },
	    {
	        "id": 7480,
	        "name": "Zabalza/Zabaltza"
	    },
	    {
	        "id": 7481,
	        "name": "Puertas"
	    },
	    {
	        "id": 7482,
	        "name": "Villarroya de los Pinares"
	    },
	    {
	        "id": 7483,
	        "name": "La Yesa"
	    },
	    {
	        "id": 7484,
	        "name": "Villardeciervos"
	    },
	    {
	        "id": 7485,
	        "name": "Torres de Berrellén"
	    },
	    {
	        "id": 7486,
	        "name": "Villatoro"
	    },
	    {
	        "id": 7487,
	        "name": "Sant Vicenç dels Horts"
	    },
	    {
	        "id": 7488,
	        "name": "Villar de Olalla"
	    },
	    {
	        "id": 7489,
	        "name": "Taragudo"
	    },
	    {
	        "id": 7490,
	        "name": "Zubieta"
	    },
	    {
	        "id": 7491,
	        "name": "Puerto de Béjar"
	    },
	    {
	        "id": 7492,
	        "name": "Villastar"
	    },
	    {
	        "id": 7493,
	        "name": "Zarra"
	    },
	    {
	        "id": 7494,
	        "name": "Villar de Fallaves"
	    },
	    {
	        "id": 7495,
	        "name": "Torrijo de la Cañada"
	    },
	    {
	        "id": 7496,
	        "name": "Viñegra de Moraña"
	    },
	    {
	        "id": 7497,
	        "name": "Sant Vicenç de Montalt"
	    },
	    {
	        "id": 7498,
	        "name": "Villarejo de Fuentes"
	    },
	    {
	        "id": 7499,
	        "name": "Taravilla"
	    },
	    {
	        "id": 7500,
	        "name": "Zugarramurdi"
	    },
	    {
	        "id": 7501,
	        "name": "Puerto Seguro"
	    },
	    {
	        "id": 7502,
	        "name": "Villel"
	    },
	    {
	        "id": 7503,
	        "name": "Villar del Buey"
	    },
	    {
	        "id": 7504,
	        "name": "Tosos"
	    },
	    {
	        "id": 7505,
	        "name": "Vita"
	    },
	    {
	        "id": 7506,
	        "name": "Sant Vicenç de Torelló"
	    },
	    {
	        "id": 7507,
	        "name": "Piérnigas"
	    },
	    {
	        "id": 7508,
	        "name": "Villarejo de la Peñuela"
	    },
	    {
	        "id": 7509,
	        "name": "Tartanedo"
	    },
	    {
	        "id": 7510,
	        "name": "Zúñiga"
	    },
	    {
	        "id": 7511,
	        "name": "Rágama"
	    },
	    {
	        "id": 7512,
	        "name": "Vinaceite"
	    },
	    {
	        "id": 7513,
	        "name": "Villardiegua de la Ribera"
	    },
	    {
	        "id": 7514,
	        "name": "Trasmoz"
	    },
	    {
	        "id": 7515,
	        "name": "Zapardiel de la Cañada"
	    },
	    {
	        "id": 7516,
	        "name": "Cerdanyola del Vallès"
	    },
	    {
	        "id": 7517,
	        "name": "Pineda de la Sierra"
	    },
	    {
	        "id": 7518,
	        "name": "Villarejo-Periesteban"
	    },
	    {
	        "id": 7519,
	        "name": "Tendilla"
	    },
	    {
	        "id": 7520,
	        "name": "La Redonda"
	    },
	    {
	        "id": 7521,
	        "name": "Visiedo"
	    },
	    {
	        "id": 7522,
	        "name": "Villárdiga"
	    },
	    {
	        "id": 7523,
	        "name": "Trasobares"
	    },
	    {
	        "id": 7524,
	        "name": "Zapardiel de la Ribera"
	    },
	    {
	        "id": 7525,
	        "name": "Sentmenat"
	    },
	    {
	        "id": 7526,
	        "name": "Pineda Trasmonte"
	    },
	    {
	        "id": 7527,
	        "name": "Terzaga"
	    },
	    {
	        "id": 7528,
	        "name": "Retortillo"
	    },
	    {
	        "id": 7529,
	        "name": "Vivel del Río Martín"
	    },
	    {
	        "id": 7530,
	        "name": "Villardondiego"
	    },
	    {
	        "id": 7531,
	        "name": "Uncastillo"
	    },
	    {
	        "id": 7532,
	        "name": "Cercs"
	    },
	    {
	        "id": 7533,
	        "name": "Pinilla de los Barruecos"
	    },
	    {
	        "id": 7534,
	        "name": "Tierzo"
	    },
	    {
	        "id": 7535,
	        "name": "La Rinconada de la Sierra"
	    },
	    {
	        "id": 7536,
	        "name": "La Zoma"
	    },
	    {
	        "id": 7537,
	        "name": "Villarrín de Campos"
	    },
	    {
	        "id": 7538,
	        "name": "Undués de Lerda"
	    },
	    {
	        "id": 7539,
	        "name": "Seva"
	    },
	    {
	        "id": 7540,
	        "name": "Pinilla de los Moros"
	    },
	    {
	        "id": 7541,
	        "name": "Villares del Saz"
	    },
	    {
	        "id": 7542,
	        "name": "La Toba"
	    },
	    {
	        "id": 7543,
	        "name": "Robleda"
	    },
	    {
	        "id": 7544,
	        "name": "Villaseco del Pan"
	    },
	    {
	        "id": 7545,
	        "name": "Urrea de Jalón"
	    },
	    {
	        "id": 7546,
	        "name": "Sitges"
	    },
	    {
	        "id": 7547,
	        "name": "Pinilla Trasmonte"
	    },
	    {
	        "id": 7548,
	        "name": "Villarrubio"
	    },
	    {
	        "id": 7549,
	        "name": "Tordelrábano"
	    },
	    {
	        "id": 7550,
	        "name": "Robliza de Cojos"
	    },
	    {
	        "id": 7551,
	        "name": "Villavendimio"
	    },
	    {
	        "id": 7552,
	        "name": "Urriés"
	    },
	    {
	        "id": 7553,
	        "name": "Sobremunt"
	    },
	    {
	        "id": 7554,
	        "name": "Villarta"
	    },
	    {
	        "id": 7555,
	        "name": "Tordellego"
	    },
	    {
	        "id": 7556,
	        "name": "Rollán"
	    },
	    {
	        "id": 7557,
	        "name": "Villaveza del Agua"
	    },
	    {
	        "id": 7558,
	        "name": "Used"
	    },
	    {
	        "id": 7559,
	        "name": "Sora"
	    },
	    {
	        "id": 7560,
	        "name": "Poza de la Sal"
	    },
	    {
	        "id": 7561,
	        "name": "Villas de la Ventosa"
	    },
	    {
	        "id": 7562,
	        "name": "Tordesilos"
	    },
	    {
	        "id": 7563,
	        "name": "Saelices el Chico"
	    },
	    {
	        "id": 7564,
	        "name": "Villaveza de Valverde"
	    },
	    {
	        "id": 7565,
	        "name": "Utebo"
	    },
	    {
	        "id": 7566,
	        "name": "Subirats"
	    },
	    {
	        "id": 7567,
	        "name": "Prádanos de Bureba"
	    },
	    {
	        "id": 7568,
	        "name": "Villaverde y Pasaconsol"
	    },
	    {
	        "id": 7569,
	        "name": "La Sagrada"
	    },
	    {
	        "id": 7570,
	        "name": "Viñas"
	    },
	    {
	        "id": 7571,
	        "name": "Valdehorna"
	    },
	    {
	        "id": 7572,
	        "name": "Súria"
	    },
	    {
	        "id": 7573,
	        "name": "Pradoluengo"
	    },
	    {
	        "id": 7574,
	        "name": "Víllora"
	    },
	    {
	        "id": 7575,
	        "name": "Torija"
	    },
	    {
	        "id": 7576,
	        "name": "Salamanca"
	    },
	    {
	        "id": 7577,
	        "name": "Val de San Martín"
	    },
	    {
	        "id": 7578,
	        "name": "Tavèrnoles"
	    },
	    {
	        "id": 7579,
	        "name": "Presencio"
	    },
	    {
	        "id": 7580,
	        "name": "Vindel"
	    },
	    {
	        "id": 7581,
	        "name": "Saldeana"
	    },
	    {
	        "id": 7582,
	        "name": "Zamora"
	    },
	    {
	        "id": 7583,
	        "name": "Valmadrid"
	    },
	    {
	        "id": 7584,
	        "name": "Tagamanent"
	    },
	    {
	        "id": 7585,
	        "name": "La Puebla de Arganzón"
	    },
	    {
	        "id": 7586,
	        "name": "Yémeda"
	    },
	    {
	        "id": 7587,
	        "name": "Salmoral"
	    },
	    {
	        "id": 7588,
	        "name": "Valpalmas"
	    },
	    {
	        "id": 7589,
	        "name": "Talamanca"
	    },
	    {
	        "id": 7590,
	        "name": "Puentedura"
	    },
	    {
	        "id": 7591,
	        "name": "Zafra de Záncara"
	    },
	    {
	        "id": 7592,
	        "name": "Torrecuadrada de Molina"
	    },
	    {
	        "id": 7593,
	        "name": "Salvatierra de Tormes"
	    },
	    {
	        "id": 7594,
	        "name": "Valtorres"
	    },
	    {
	        "id": 7595,
	        "name": "Taradell"
	    },
	    {
	        "id": 7596,
	        "name": "Zafrilla"
	    },
	    {
	        "id": 7597,
	        "name": "Torrecuadradilla"
	    },
	    {
	        "id": 7598,
	        "name": "San Cristóbal de la Cuesta"
	    },
	    {
	        "id": 7599,
	        "name": "Velilla de Ebro"
	    },
	    {
	        "id": 7600,
	        "name": "Terrassa"
	    },
	    {
	        "id": 7601,
	        "name": "Quemada"
	    },
	    {
	        "id": 7602,
	        "name": "Zarza de Tajo"
	    },
	    {
	        "id": 7603,
	        "name": "Torre del Burgo"
	    },
	    {
	        "id": 7604,
	        "name": "Sancti-Spíritus"
	    },
	    {
	        "id": 7605,
	        "name": "Velilla de Jiloca"
	    },
	    {
	        "id": 7606,
	        "name": "Tavertet"
	    },
	    {
	        "id": 7607,
	        "name": "Quintanabureba"
	    },
	    {
	        "id": 7608,
	        "name": "Zarzuela"
	    },
	    {
	        "id": 7609,
	        "name": "Torrejón del Rey"
	    },
	    {
	        "id": 7610,
	        "name": "Sanchón de la Ribera"
	    },
	    {
	        "id": 7611,
	        "name": "Vera de Moncayo"
	    },
	    {
	        "id": 7612,
	        "name": "Teià"
	    },
	    {
	        "id": 7613,
	        "name": "Quintana del Pidio"
	    },
	    {
	        "id": 7614,
	        "name": "Torremocha de Jadraque"
	    },
	    {
	        "id": 7615,
	        "name": "Sanchón de la Sagrada"
	    },
	    {
	        "id": 7616,
	        "name": "Vierlas"
	    },
	    {
	        "id": 7617,
	        "name": "Tiana"
	    },
	    {
	        "id": 7618,
	        "name": "Torremocha del Campo"
	    },
	    {
	        "id": 7619,
	        "name": "Sanchotello"
	    },
	    {
	        "id": 7620,
	        "name": "La Vilueña"
	    },
	    {
	        "id": 7621,
	        "name": "Tona"
	    },
	    {
	        "id": 7622,
	        "name": "Quintanaélez"
	    },
	    {
	        "id": 7623,
	        "name": "Torremocha del Pinar"
	    },
	    {
	        "id": 7624,
	        "name": "Sando"
	    },
	    {
	        "id": 7625,
	        "name": "Villadoz"
	    },
	    {
	        "id": 7626,
	        "name": "Tordera"
	    },
	    {
	        "id": 7627,
	        "name": "Torremochuela"
	    },
	    {
	        "id": 7628,
	        "name": "San Esteban de la Sierra"
	    },
	    {
	        "id": 7629,
	        "name": "Villafeliche"
	    },
	    {
	        "id": 7630,
	        "name": "Torelló"
	    },
	    {
	        "id": 7631,
	        "name": "Torrubia"
	    },
	    {
	        "id": 7632,
	        "name": "San Felices de los Gallegos"
	    },
	    {
	        "id": 7633,
	        "name": "Villafranca de Ebro"
	    },
	    {
	        "id": 7634,
	        "name": "La Torre de Claramunt"
	    },
	    {
	        "id": 7635,
	        "name": "Tórtola de Henares"
	    },
	    {
	        "id": 7636,
	        "name": "San Martín del Castañar"
	    },
	    {
	        "id": 7637,
	        "name": "Villalba de Perejil"
	    },
	    {
	        "id": 7638,
	        "name": "Torrelavit"
	    },
	    {
	        "id": 7639,
	        "name": "Quintanaortuño"
	    },
	    {
	        "id": 7640,
	        "name": "Tortuera"
	    },
	    {
	        "id": 7641,
	        "name": "San Miguel de Valero"
	    },
	    {
	        "id": 7642,
	        "name": "Villalengua"
	    },
	    {
	        "id": 7643,
	        "name": "Torrelles de Foix"
	    },
	    {
	        "id": 7644,
	        "name": "Quintanapalla"
	    },
	    {
	        "id": 7645,
	        "name": "Tortuero"
	    },
	    {
	        "id": 7646,
	        "name": "San Morales"
	    },
	    {
	        "id": 7647,
	        "name": "Villanueva de Gállego"
	    },
	    {
	        "id": 7648,
	        "name": "Torrelles de Llobregat"
	    },
	    {
	        "id": 7649,
	        "name": "Quintanar de la Sierra"
	    },
	    {
	        "id": 7650,
	        "name": "Traíd"
	    },
	    {
	        "id": 7651,
	        "name": "San Muñoz"
	    },
	    {
	        "id": 7652,
	        "name": "Villanueva de Jiloca"
	    },
	    {
	        "id": 7653,
	        "name": "Ullastrell"
	    },
	    {
	        "id": 7654,
	        "name": "Trijueque"
	    },
	    {
	        "id": 7655,
	        "name": "San Pedro del Valle"
	    },
	    {
	        "id": 7656,
	        "name": "Villanueva de Huerva"
	    },
	    {
	        "id": 7657,
	        "name": "Vacarisses"
	    },
	    {
	        "id": 7658,
	        "name": "Trillo"
	    },
	    {
	        "id": 7659,
	        "name": "San Pedro de Rozados"
	    },
	    {
	        "id": 7660,
	        "name": "Villar de los Navarros"
	    },
	    {
	        "id": 7661,
	        "name": "Vallbona d'Anoia"
	    },
	    {
	        "id": 7662,
	        "name": "Quintanavides"
	    },
	    {
	        "id": 7663,
	        "name": "San Pelayo de Guareña"
	    },
	    {
	        "id": 7664,
	        "name": "Villarreal de Huerva"
	    },
	    {
	        "id": 7665,
	        "name": "Vallcebre"
	    },
	    {
	        "id": 7666,
	        "name": "Uceda"
	    },
	    {
	        "id": 7667,
	        "name": "Santa María de Sando"
	    },
	    {
	        "id": 7668,
	        "name": "Villarroya de la Sierra"
	    },
	    {
	        "id": 7669,
	        "name": "Vallgorguina"
	    },
	    {
	        "id": 7670,
	        "name": "Quintanilla de la Mata"
	    },
	    {
	        "id": 7671,
	        "name": "Ujados"
	    },
	    {
	        "id": 7672,
	        "name": "Santa Marta de Tormes"
	    },
	    {
	        "id": 7673,
	        "name": "Villarroya del Campo"
	    },
	    {
	        "id": 7674,
	        "name": "Vallirana"
	    },
	    {
	        "id": 7675,
	        "name": "Quintanilla del Coco"
	    },
	    {
	        "id": 7676,
	        "name": "Vistabella"
	    },
	    {
	        "id": 7677,
	        "name": "Vallromanes"
	    },
	    {
	        "id": 7678,
	        "name": "Utande"
	    },
	    {
	        "id": 7679,
	        "name": "Santiago de la Puebla"
	    },
	    {
	        "id": 7680,
	        "name": "La Zaida"
	    },
	    {
	        "id": 7681,
	        "name": "Veciana"
	    },
	    {
	        "id": 7682,
	        "name": "Las Quintanillas"
	    },
	    {
	        "id": 7683,
	        "name": "Valdarachas"
	    },
	    {
	        "id": 7684,
	        "name": "Santibáñez de Béjar"
	    },
	    {
	        "id": 7685,
	        "name": "Zaragoza"
	    },
	    {
	        "id": 7686,
	        "name": "Vic"
	    },
	    {
	        "id": 7687,
	        "name": "Quintanilla San García"
	    },
	    {
	        "id": 7688,
	        "name": "Valdearenas"
	    },
	    {
	        "id": 7689,
	        "name": "Santibáñez de la Sierra"
	    },
	    {
	        "id": 7690,
	        "name": "Zuera"
	    },
	    {
	        "id": 7691,
	        "name": "Vilada"
	    },
	    {
	        "id": 7692,
	        "name": "Valdeavellano"
	    },
	    {
	        "id": 7693,
	        "name": "Santiz"
	    },
	    {
	        "id": 7694,
	        "name": "Viladecavalls"
	    },
	    {
	        "id": 7695,
	        "name": "Valdeaveruelo"
	    },
	    {
	        "id": 7696,
	        "name": "Los Santos"
	    },
	    {
	        "id": 7697,
	        "name": "Viladecans"
	    },
	    {
	        "id": 7698,
	        "name": "Quintanilla Vivar"
	    },
	    {
	        "id": 7699,
	        "name": "Valdeconcha"
	    },
	    {
	        "id": 7700,
	        "name": "Sardón de los Frailes"
	    },
	    {
	        "id": 7701,
	        "name": "Vilanova del Camí"
	    },
	    {
	        "id": 7702,
	        "name": "Rabanera del Pinar"
	    },
	    {
	        "id": 7703,
	        "name": "Valdegrudas"
	    },
	    {
	        "id": 7704,
	        "name": "Saucelle"
	    },
	    {
	        "id": 7705,
	        "name": "Vilanova de Sau"
	    },
	    {
	        "id": 7706,
	        "name": "Rábanos"
	    },
	    {
	        "id": 7707,
	        "name": "Valdelcubo"
	    },
	    {
	        "id": 7708,
	        "name": "El Sahugo"
	    },
	    {
	        "id": 7709,
	        "name": "Vilobí del Penedès"
	    },
	    {
	        "id": 7710,
	        "name": "Rabé de las Calzadas"
	    },
	    {
	        "id": 7711,
	        "name": "Valdenuño Fernández"
	    },
	    {
	        "id": 7712,
	        "name": "Sepulcro-Hilario"
	    },
	    {
	        "id": 7713,
	        "name": "Vilafranca del Penedès"
	    },
	    {
	        "id": 7714,
	        "name": "Valdepeñas de la Sierra"
	    },
	    {
	        "id": 7715,
	        "name": "Sequeros"
	    },
	    {
	        "id": 7716,
	        "name": "Vilalba Sasserra"
	    },
	    {
	        "id": 7717,
	        "name": "Rebolledo de la Torre"
	    },
	    {
	        "id": 7718,
	        "name": "Valderrebollo"
	    },
	    {
	        "id": 7719,
	        "name": "Serradilla del Arroyo"
	    },
	    {
	        "id": 7720,
	        "name": "Vilanova i la Geltrú"
	    },
	    {
	        "id": 7721,
	        "name": "Redecilla del Camino"
	    },
	    {
	        "id": 7722,
	        "name": "Valdesotos"
	    },
	    {
	        "id": 7723,
	        "name": "Serradilla del Llano"
	    },
	    {
	        "id": 7724,
	        "name": "Viver i Serrateix"
	    },
	    {
	        "id": 7725,
	        "name": "Redecilla del Campo"
	    },
	    {
	        "id": 7726,
	        "name": "Valfermoso de Tajuña"
	    },
	    {
	        "id": 7727,
	        "name": "Regumiel de la Sierra"
	    },
	    {
	        "id": 7728,
	        "name": "Valhermoso"
	    },
	    {
	        "id": 7729,
	        "name": "La Sierpe"
	    },
	    {
	        "id": 7730,
	        "name": "Reinoso"
	    },
	    {
	        "id": 7731,
	        "name": "Valtablado del Río"
	    },
	    {
	        "id": 7732,
	        "name": "Sieteiglesias de Tormes"
	    },
	    {
	        "id": 7733,
	        "name": "Retuerta"
	    },
	    {
	        "id": 7734,
	        "name": "Valverde de los Arroyos"
	    },
	    {
	        "id": 7735,
	        "name": "Sobradillo"
	    },
	    {
	        "id": 7736,
	        "name": "La Revilla y Ahedo"
	    },
	    {
	        "id": 7737,
	        "name": "Sorihuela"
	    },
	    {
	        "id": 7738,
	        "name": "Sotoserrano"
	    },
	    {
	        "id": 7739,
	        "name": "Revilla del Campo"
	    },
	    {
	        "id": 7740,
	        "name": "Viana de Jadraque"
	    },
	    {
	        "id": 7741,
	        "name": "Tabera de Abajo"
	    },
	    {
	        "id": 7742,
	        "name": "Revillarruz"
	    },
	    {
	        "id": 7743,
	        "name": "La Tala"
	    },
	    {
	        "id": 7744,
	        "name": "Revilla Vallejera"
	    },
	    {
	        "id": 7745,
	        "name": "Tamames"
	    },
	    {
	        "id": 7746,
	        "name": "Rezmondo"
	    },
	    {
	        "id": 7747,
	        "name": "Villanueva de Alcorón"
	    },
	    {
	        "id": 7748,
	        "name": "Tarazona de Guareña"
	    },
	    {
	        "id": 7749,
	        "name": "Riocavado de la Sierra"
	    },
	    {
	        "id": 7750,
	        "name": "Villanueva de Argecilla"
	    },
	    {
	        "id": 7751,
	        "name": "Tardáguila"
	    },
	    {
	        "id": 7752,
	        "name": "Villanueva de la Torre"
	    },
	    {
	        "id": 7753,
	        "name": "El Tejado"
	    },
	    {
	        "id": 7754,
	        "name": "Tejeda y Segoyuela"
	    },
	    {
	        "id": 7755,
	        "name": "Roa"
	    },
	    {
	        "id": 7756,
	        "name": "Villares de Jadraque"
	    },
	    {
	        "id": 7757,
	        "name": "Tenebrón"
	    },
	    {
	        "id": 7758,
	        "name": "Villaseca de Henares"
	    },
	    {
	        "id": 7759,
	        "name": "Terradillos"
	    },
	    {
	        "id": 7760,
	        "name": "Rojas"
	    },
	    {
	        "id": 7761,
	        "name": "Villaseca de Uceda"
	    },
	    {
	        "id": 7762,
	        "name": "Topas"
	    },
	    {
	        "id": 7763,
	        "name": "Villel de Mesa"
	    },
	    {
	        "id": 7764,
	        "name": "Tordillos"
	    },
	    {
	        "id": 7765,
	        "name": "Royuela de Río Franco"
	    },
	    {
	        "id": 7766,
	        "name": "Viñuelas"
	    },
	    {
	        "id": 7767,
	        "name": "El Tornadizo"
	    },
	    {
	        "id": 7768,
	        "name": "Rubena"
	    },
	    {
	        "id": 7769,
	        "name": "Yebes"
	    },
	    {
	        "id": 7770,
	        "name": "Rublacedo de Abajo"
	    },
	    {
	        "id": 7771,
	        "name": "Yebra"
	    },
	    {
	        "id": 7772,
	        "name": "Torresmenudas"
	    },
	    {
	        "id": 7773,
	        "name": "Rucandio"
	    },
	    {
	        "id": 7774,
	        "name": "Trabanca"
	    },
	    {
	        "id": 7775,
	        "name": "Salas de Bureba"
	    },
	    {
	        "id": 7776,
	        "name": "Yélamos de Abajo"
	    },
	    {
	        "id": 7777,
	        "name": "Tremedal de Tormes"
	    },
	    {
	        "id": 7778,
	        "name": "Salas de los Infantes"
	    },
	    {
	        "id": 7779,
	        "name": "Yélamos de Arriba"
	    },
	    {
	        "id": 7780,
	        "name": "Valdecarros"
	    },
	    {
	        "id": 7781,
	        "name": "Yunquera de Henares"
	    },
	    {
	        "id": 7782,
	        "name": "Valdefuentes de Sangusín"
	    },
	    {
	        "id": 7783,
	        "name": "Saldaña de Burgos"
	    },
	    {
	        "id": 7784,
	        "name": "La Yunta"
	    },
	    {
	        "id": 7785,
	        "name": "Valdehijaderos"
	    },
	    {
	        "id": 7786,
	        "name": "Zaorejas"
	    },
	    {
	        "id": 7787,
	        "name": "Valdelacasa"
	    },
	    {
	        "id": 7788,
	        "name": "Salinillas de Bureba"
	    },
	    {
	        "id": 7789,
	        "name": "Zarzuela de Jadraque"
	    },
	    {
	        "id": 7790,
	        "name": "Valdelageve"
	    },
	    {
	        "id": 7791,
	        "name": "San Adrián de Juarros"
	    },
	    {
	        "id": 7792,
	        "name": "Zorita de los Canes"
	    },
	    {
	        "id": 7793,
	        "name": "Valdelosa"
	    },
	    {
	        "id": 7794,
	        "name": "Valdemierque"
	    },
	    {
	        "id": 7795,
	        "name": "San Juan del Monte"
	    },
	    {
	        "id": 7796,
	        "name": "Valderrodrigo"
	    },
	    {
	        "id": 7797,
	        "name": "San Mamés de Burgos"
	    },
	    {
	        "id": 7798,
	        "name": "Valdunciel"
	    },
	    {
	        "id": 7799,
	        "name": "San Martín de Rubiales"
	    },
	    {
	        "id": 7800,
	        "name": "Valero"
	    },
	    {
	        "id": 7801,
	        "name": "San Millán de Lara"
	    },
	    {
	        "id": 7802,
	        "name": "Valsalabroso"
	    },
	    {
	        "id": 7803,
	        "name": "Valverde de Valdelacasa"
	    },
	    {
	        "id": 7804,
	        "name": "Valverdón"
	    },
	    {
	        "id": 7805,
	        "name": "Santa Cecilia"
	    },
	    {
	        "id": 7806,
	        "name": "Vallejera de Riofrío"
	    },
	    {
	        "id": 7807,
	        "name": "Vecinos"
	    },
	    {
	        "id": 7808,
	        "name": "Santa Cruz de la Salceda"
	    },
	    {
	        "id": 7809,
	        "name": "Vega de Tirados"
	    },
	    {
	        "id": 7810,
	        "name": "Santa Cruz del Valle Urbión"
	    },
	    {
	        "id": 7811,
	        "name": "Las Veguillas"
	    },
	    {
	        "id": 7812,
	        "name": "Santa Gadea del Cid"
	    },
	    {
	        "id": 7813,
	        "name": "La Vellés"
	    },
	    {
	        "id": 7814,
	        "name": "Santa Inés"
	    },
	    {
	        "id": 7815,
	        "name": "Ventosa del Río Almar"
	    },
	    {
	        "id": 7816,
	        "name": "La Vídola"
	    },
	    {
	        "id": 7817,
	        "name": "Santa María del Campo"
	    },
	    {
	        "id": 7818,
	        "name": "Vilvestre"
	    },
	    {
	        "id": 7819,
	        "name": "Santa María del Invierno"
	    },
	    {
	        "id": 7820,
	        "name": "Villaflores"
	    },
	    {
	        "id": 7821,
	        "name": "Santa María del Mercadillo"
	    },
	    {
	        "id": 7822,
	        "name": "Villagonzalo de Tormes"
	    },
	    {
	        "id": 7823,
	        "name": "Santa María Rivarredonda"
	    },
	    {
	        "id": 7824,
	        "name": "Villalba de los Llanos"
	    },
	    {
	        "id": 7825,
	        "name": "Santa Olalla de Bureba"
	    },
	    {
	        "id": 7826,
	        "name": "Villamayor"
	    },
	    {
	        "id": 7827,
	        "name": "Santibáñez de Esgueva"
	    },
	    {
	        "id": 7828,
	        "name": "Villanueva del Conde"
	    },
	    {
	        "id": 7829,
	        "name": "Santibáñez del Val"
	    },
	    {
	        "id": 7830,
	        "name": "Villar de Argañán"
	    },
	    {
	        "id": 7831,
	        "name": "Villar de Ciervo"
	    },
	    {
	        "id": 7832,
	        "name": "Santo Domingo de Silos"
	    },
	    {
	        "id": 7833,
	        "name": "Villar de Gallimazo"
	    },
	    {
	        "id": 7834,
	        "name": "Villar de la Yegua"
	    },
	    {
	        "id": 7835,
	        "name": "San Vicente del Valle"
	    },
	    {
	        "id": 7836,
	        "name": "Villar de Peralonso"
	    },
	    {
	        "id": 7837,
	        "name": "Sargentes de la Lora"
	    },
	    {
	        "id": 7838,
	        "name": "Villar de Samaniego"
	    },
	    {
	        "id": 7839,
	        "name": "Sarracín"
	    },
	    {
	        "id": 7840,
	        "name": "Villares de la Reina"
	    },
	    {
	        "id": 7841,
	        "name": "Sasamón"
	    },
	    {
	        "id": 7842,
	        "name": "Villares de Yeltes"
	    },
	    {
	        "id": 7843,
	        "name": "Villarino de los Aires"
	    },
	    {
	        "id": 7844,
	        "name": "La Sequera de Haza"
	    },
	    {
	        "id": 7845,
	        "name": "Villarmayor"
	    },
	    {
	        "id": 7846,
	        "name": "Solarana"
	    },
	    {
	        "id": 7847,
	        "name": "Villarmuerto"
	    },
	    {
	        "id": 7848,
	        "name": "Villasbuenas"
	    },
	    {
	        "id": 7849,
	        "name": "Sordillos"
	    },
	    {
	        "id": 7850,
	        "name": "Villasdardo"
	    },
	    {
	        "id": 7851,
	        "name": "Sotillo de la Ribera"
	    },
	    {
	        "id": 7852,
	        "name": "Villaseco de los Gamitos"
	    },
	    {
	        "id": 7853,
	        "name": "Villaseco de los Reyes"
	    },
	    {
	        "id": 7854,
	        "name": "Villasrubias"
	    },
	    {
	        "id": 7855,
	        "name": "Sotragero"
	    },
	    {
	        "id": 7856,
	        "name": "Villaverde de Guareña"
	    },
	    {
	        "id": 7857,
	        "name": "Sotresgudo"
	    },
	    {
	        "id": 7858,
	        "name": "Villavieja de Yeltes"
	    },
	    {
	        "id": 7859,
	        "name": "Susinos del Páramo"
	    },
	    {
	        "id": 7860,
	        "name": "Villoria"
	    },
	    {
	        "id": 7861,
	        "name": "Tamarón"
	    },
	    {
	        "id": 7862,
	        "name": "Villoruela"
	    },
	    {
	        "id": 7863,
	        "name": "Vitigudino"
	    },
	    {
	        "id": 7864,
	        "name": "Tardajos"
	    },
	    {
	        "id": 7865,
	        "name": "Yecla de Yeltes"
	    },
	    {
	        "id": 7866,
	        "name": "Tejada"
	    },
	    {
	        "id": 7867,
	        "name": "Zamarra"
	    },
	    {
	        "id": 7868,
	        "name": "Zamayón"
	    },
	    {
	        "id": 7869,
	        "name": "Terradillos de Esgueva"
	    },
	    {
	        "id": 7870,
	        "name": "Zarapicos"
	    },
	    {
	        "id": 7871,
	        "name": "Tinieblas de la Sierra"
	    },
	    {
	        "id": 7872,
	        "name": "La Zarza de Pumareda"
	    },
	    {
	        "id": 7873,
	        "name": "Tobar"
	    },
	    {
	        "id": 7874,
	        "name": "Zorita de la Frontera"
	    },
	    {
	        "id": 7875,
	        "name": "Tordómar"
	    },
	    {
	        "id": 7876,
	        "name": "Torrecilla del Monte"
	    },
	    {
	        "id": 7877,
	        "name": "Torregalindo"
	    },
	    {
	        "id": 7878,
	        "name": "Torrelara"
	    },
	    {
	        "id": 7879,
	        "name": "Torrepadre"
	    },
	    {
	        "id": 7880,
	        "name": "Torresandino"
	    },
	    {
	        "id": 7881,
	        "name": "Tórtoles de Esgueva"
	    },
	    {
	        "id": 7882,
	        "name": "Tosantos"
	    },
	    {
	        "id": 7883,
	        "name": "Trespaderne"
	    },
	    {
	        "id": 7884,
	        "name": "Tubilla del Agua"
	    },
	    {
	        "id": 7885,
	        "name": "Tubilla del Lago"
	    },
	    {
	        "id": 7886,
	        "name": "Úrbel del Castillo"
	    },
	    {
	        "id": 7887,
	        "name": "Vadocondes"
	    },
	    {
	        "id": 7888,
	        "name": "Valdeande"
	    },
	    {
	        "id": 7889,
	        "name": "Valdezate"
	    },
	    {
	        "id": 7890,
	        "name": "Valdorros"
	    },
	    {
	        "id": 7891,
	        "name": "Valmala"
	    },
	    {
	        "id": 7892,
	        "name": "Vallarta de Bureba"
	    },
	    {
	        "id": 7893,
	        "name": "Valle de Manzanedo"
	    },
	    {
	        "id": 7894,
	        "name": "Valle de Mena"
	    },
	    {
	        "id": 7895,
	        "name": "Valle de Oca"
	    },
	    {
	        "id": 7896,
	        "name": "Valle de Tobalina"
	    },
	    {
	        "id": 7897,
	        "name": "Valle de Valdebezana"
	    },
	    {
	        "id": 7898,
	        "name": "Valle de Valdelaguna"
	    },
	    {
	        "id": 7899,
	        "name": "Valle de Valdelucio"
	    },
	    {
	        "id": 7900,
	        "name": "Valle de Zamanzas"
	    },
	    {
	        "id": 7901,
	        "name": "Vallejera"
	    },
	    {
	        "id": 7902,
	        "name": "Valles de Palenzuela"
	    },
	    {
	        "id": 7903,
	        "name": "Valluércanes"
	    },
	    {
	        "id": 7904,
	        "name": "La Vid y Barrios"
	    },
	    {
	        "id": 7905,
	        "name": "La Vid de Bureba"
	    },
	    {
	        "id": 7906,
	        "name": "Vileña"
	    },
	    {
	        "id": 7907,
	        "name": "Viloria de Rioja"
	    },
	    {
	        "id": 7908,
	        "name": "Vilviestre del Pinar"
	    },
	    {
	        "id": 7909,
	        "name": "Villadiego"
	    },
	    {
	        "id": 7910,
	        "name": "Villaescusa de Roa"
	    },
	    {
	        "id": 7911,
	        "name": "Villaescusa la Sombría"
	    },
	    {
	        "id": 7912,
	        "name": "Villaespasa"
	    },
	    {
	        "id": 7913,
	        "name": "Villafranca Montes de Oca"
	    },
	    {
	        "id": 7914,
	        "name": "Villafruela"
	    },
	    {
	        "id": 7915,
	        "name": "Villagalijo"
	    },
	    {
	        "id": 7916,
	        "name": "Villagonzalo Pedernales"
	    },
	    {
	        "id": 7917,
	        "name": "Villahoz"
	    },
	    {
	        "id": 7918,
	        "name": "Villalba de Duero"
	    },
	    {
	        "id": 7919,
	        "name": "Villalbilla de Burgos"
	    },
	    {
	        "id": 7920,
	        "name": "Villalbilla de Gumiel"
	    },
	    {
	        "id": 7921,
	        "name": "Villaldemiro"
	    },
	    {
	        "id": 7922,
	        "name": "Villalmanzo"
	    },
	    {
	        "id": 7923,
	        "name": "Villamayor de los Montes"
	    },
	    {
	        "id": 7924,
	        "name": "Villamayor de Treviño"
	    },
	    {
	        "id": 7925,
	        "name": "Villambistia"
	    },
	    {
	        "id": 7926,
	        "name": "Villamedianilla"
	    },
	    {
	        "id": 7927,
	        "name": "Villamiel de la Sierra"
	    },
	    {
	        "id": 7928,
	        "name": "Villangómez"
	    },
	    {
	        "id": 7929,
	        "name": "Villanueva de Argaño"
	    },
	    {
	        "id": 7930,
	        "name": "Villanueva de Carazo"
	    },
	    {
	        "id": 7931,
	        "name": "Villanueva de Gumiel"
	    },
	    {
	        "id": 7932,
	        "name": "Villanueva de Teba"
	    },
	    {
	        "id": 7933,
	        "name": "Villaquirán de la Puebla"
	    },
	    {
	        "id": 7934,
	        "name": "Villaquirán de los Infantes"
	    },
	    {
	        "id": 7935,
	        "name": "Villariezo"
	    },
	    {
	        "id": 7936,
	        "name": "Villasandino"
	    },
	    {
	        "id": 7937,
	        "name": "Villasur de Herreros"
	    },
	    {
	        "id": 7938,
	        "name": "Villatuelda"
	    },
	    {
	        "id": 7939,
	        "name": "Villaverde del Monte"
	    },
	    {
	        "id": 7940,
	        "name": "Villaverde-Mogina"
	    },
	    {
	        "id": 7941,
	        "name": "Villayerno Morquillas"
	    },
	    {
	        "id": 7942,
	        "name": "Villazopeque"
	    },
	    {
	        "id": 7943,
	        "name": "Villegas"
	    },
	    {
	        "id": 7944,
	        "name": "Villoruebo"
	    },
	    {
	        "id": 7945,
	        "name": "Vizcaínos"
	    },
	    {
	        "id": 7946,
	        "name": "Zael"
	    },
	    {
	        "id": 7947,
	        "name": "Zarzosa de Río Pisuerga"
	    },
	    {
	        "id": 7948,
	        "name": "Zazuar"
	    },
	    {
	        "id": 7949,
	        "name": "Zuñeda"
	    },
	    {
	        "id": 7950,
	        "name": "Iruña Oka/Iruña de Oca"
	    },
	    {
	        "id": 7951,
	        "name": "Pozo Cañada"
	    },
	    {
	        "id": 7952,
	        "name": "els Poblets"
	    },
	    {
	        "id": 7953,
	        "name": "Las Tres Villas"
	    },
	    {
	        "id": 7954,
	        "name": "San Juan de Gredos"
	    },
	    {
	        "id": 7955,
	        "name": "Valdelacalzada"
	    },
	    {
	        "id": 7956,
	        "name": "Ariany"
	    },
	    {
	        "id": 7957,
	        "name": "Rupit i Pruit"
	    },
	    {
	        "id": 7958,
	        "name": "Quintanilla del Agua y Tordueles"
	    },
	    {
	        "id": 7959,
	        "name": "Rosalejo"
	    },
	    {
	        "id": 7960,
	        "name": "Benalup-Casas Viejas"
	    },
	    {
	        "id": 7961,
	        "name": "Alquerías del Niño Perdido"
	    },
	    {
	        "id": 7962,
	        "name": "El Robledo"
	    },
	    {
	        "id": 7963,
	        "name": "Cariño"
	    },
	    {
	        "id": 7964,
	        "name": "Campos del Paraíso"
	    },
	    {
	        "id": 7965,
	        "name": "Cruïlles,  Monells i Sant Sadurní de l'Heura"
	    },
	    {
	        "id": 7966,
	        "name": "La Taha"
	    },
	    {
	        "id": 7967,
	        "name": "Semillas"
	    },
	    {
	        "id": 7968,
	        "name": "Mendaro"
	    },
	    {
	        "id": 7969,
	        "name": "Valle de Hecho"
	    },
	    {
	        "id": 7970,
	        "name": "Cárcheles"
	    },
	    {
	        "id": 7971,
	        "name": "Villamanín"
	    },
	    {
	        "id": 7972,
	        "name": "Vall de Cardós"
	    },
	    {
	        "id": 7973,
	        "name": "Baralla"
	    },
	    {
	        "id": 7974,
	        "name": "Lozoyuela-Navas-Sieteiglesias"
	    },
	    {
	        "id": 7975,
	        "name": "Torremolinos"
	    },
	    {
	        "id": 7976,
	        "name": "Santomera"
	    },
	    {
	        "id": 7977,
	        "name": "Barañain"
	    },
	    {
	        "id": 7978,
	        "name": "Osorno la Mayor"
	    },
	    {
	        "id": 7979,
	        "name": "A Illa de Arousa"
	    },
	    {
	        "id": 7980,
	        "name": "El Pinar de El Hierro"
	    },
	    {
	        "id": 7981,
	        "name": "Ortigosa del Monte"
	    },
	    {
	        "id": 7982,
	        "name": "Cañada Rosal"
	    },
	    {
	        "id": 7983,
	        "name": "Deltebre"
	    },
	    {
	        "id": 7984,
	        "name": "Santo Domingo-Caudilla"
	    },
	    {
	        "id": 7985,
	        "name": "Derio"
	    },
	    {
	        "id": 7986,
	        "name": "Biel"
	    },
	    {
	        "id": 7987,
	        "name": "Lantarón"
	    },
	    {
	        "id": 7988,
	        "name": "Pilar de la Horadada"
	    },
	    {
	        "id": 7989,
	        "name": "El Ejido"
	    },
	    {
	        "id": 7990,
	        "name": "Santa María del Cubillo"
	    },
	    {
	        "id": 7991,
	        "name": "Pueblonuevo del Guadiana"
	    },
	    {
	        "id": 7992,
	        "name": "Es Migjorn Gran"
	    },
	    {
	        "id": 7993,
	        "name": "Vilanova del Vallès"
	    },
	    {
	        "id": 7994,
	        "name": "Valle de Santibáñez"
	    },
	    {
	        "id": 7995,
	        "name": "Vegaviana"
	    },
	    {
	        "id": 7996,
	        "name": "San José del Valle"
	    },
	    {
	        "id": 7997,
	        "name": "Sant Joan de Moró"
	    },
	    {
	        "id": 7998,
	        "name": "Ruidera"
	    },
	    {
	        "id": 7999,
	        "name": "Valdetórtola"
	    },
	    {
	        "id": 8000,
	        "name": "Forallac"
	    },
	    {
	        "id": 8001,
	        "name": "El Valle"
	    },
	    {
	        "id": 8002,
	        "name": "Lasarte-Oria"
	    },
	    {
	        "id": 8003,
	        "name": "Puente la Reina de Jaca"
	    },
	    {
	        "id": 8004,
	        "name": "Bedmar y Garcíez"
	    },
	    {
	        "id": 8005,
	        "name": "Villaornate y Castro"
	    },
	    {
	        "id": 8006,
	        "name": "Sant Martí de Riucorb"
	    },
	    {
	        "id": 8007,
	        "name": "Burela"
	    },
	    {
	        "id": 8008,
	        "name": "Puentes Viejas"
	    },
	    {
	        "id": 8009,
	        "name": "Villanueva de la Concepción"
	    },
	    {
	        "id": 8010,
	        "name": "Los Alcázares"
	    },
	    {
	        "id": 8011,
	        "name": "Berrioplano/Berriobeiti"
	    },
	    {
	        "id": 8012,
	        "name": "Valle del Retortillo"
	    },
	    {
	        "id": 8013,
	        "name": "Cozuelos de Fuentidueña"
	    },
	    {
	        "id": 8014,
	        "name": "Isla Mayor"
	    },
	    {
	        "id": 8015,
	        "name": "Sant Jaume d'Enveja"
	    },
	    {
	        "id": 8016,
	        "name": "Gátova"
	    },
	    {
	        "id": 8017,
	        "name": "Erandio"
	    },
	    {
	        "id": 8018,
	        "name": "Marracos"
	    },
	    {
	        "id": 8019,
	        "name": "Los Montesinos"
	    },
	    {
	        "id": 8020,
	        "name": "La Mojonera"
	    },
	    {
	        "id": 8021,
	        "name": "Diego del Carpio"
	    },
	    {
	        "id": 8022,
	        "name": "Sant Julià de Cerdanyola"
	    },
	    {
	        "id": 8023,
	        "name": "Villarcayo de Merindad de Castilla la Vieja"
	    },
	    {
	        "id": 8024,
	        "name": "Alagón del Río"
	    },
	    {
	        "id": 8025,
	        "name": "Arenales de San Gregorio"
	    },
	    {
	        "id": 8026,
	        "name": "Las Valeras"
	    },
	    {
	        "id": 8027,
	        "name": "Sant Julià del Llor i Bonmatí"
	    },
	    {
	        "id": 8028,
	        "name": "Nevada"
	    },
	    {
	        "id": 8029,
	        "name": "Astigarraga"
	    },
	    {
	        "id": 8030,
	        "name": "San Miguel del Cinca"
	    },
	    {
	        "id": 8031,
	        "name": "Villatorres"
	    },
	    {
	        "id": 8032,
	        "name": "La Guingueta d'Àneu"
	    },
	    {
	        "id": 8033,
	        "name": "Tres Cantos"
	    },
	    {
	        "id": 8034,
	        "name": "Berriozar"
	    },
	    {
	        "id": 8035,
	        "name": "Loma de Ucieza"
	    },
	    {
	        "id": 8036,
	        "name": "Marazoleja"
	    },
	    {
	        "id": 8037,
	        "name": "El Cuervo de Sevilla"
	    },
	    {
	        "id": 8038,
	        "name": "Camarles"
	    },
	    {
	        "id": 8039,
	        "name": "San Antonio de Benagéber"
	    },
	    {
	        "id": 8040,
	        "name": "Loiu"
	    },
	    {
	        "id": 8041,
	        "name": "Villamayor de Gállego"
	    },
	    {
	        "id": 8042,
	        "name": "San Isidro"
	    },
	    {
	        "id": 8043,
	        "name": "Santiago del Tormes"
	    },
	    {
	        "id": 8044,
	        "name": "Badia del Vallès"
	    },
	    {
	        "id": 8045,
	        "name": "Valle de las Navas"
	    },
	    {
	        "id": 8046,
	        "name": "Llanos del Caudillo"
	    },
	    {
	        "id": 8047,
	        "name": "Fuentenava de Jábaga"
	    },
	    {
	        "id": 8048,
	        "name": "Alpujarra de la Sierra"
	    },
	    {
	        "id": 8049,
	        "name": "Baliarrain"
	    },
	    {
	        "id": 8050,
	        "name": "La Sotonera"
	    },
	    {
	        "id": 8051,
	        "name": "Santiago-Pontones"
	    },
	    {
	        "id": 8052,
	        "name": "Castell de Mur"
	    },
	    {
	        "id": 8053,
	        "name": "Irurtzun"
	    },
	    {
	        "id": 8054,
	        "name": "La Pernía"
	    },
	    {
	        "id": 8055,
	        "name": "Navas de Riofrío"
	    },
	    {
	        "id": 8056,
	        "name": "L'Aldea"
	    },
	    {
	        "id": 8057,
	        "name": "Benicull de Xúquer"
	    },
	    {
	        "id": 8058,
	        "name": "Sondika"
	    },
	    {
	        "id": 8059,
	        "name": "Villanueva de Ávila"
	    },
	    {
	        "id": 8060,
	        "name": "La Palma de Cervelló"
	    },
	    {
	        "id": 8061,
	        "name": "Valle de Sedano"
	    },
	    {
	        "id": 8062,
	        "name": "Arcas del Villar"
	    },
	    {
	        "id": 8063,
	        "name": "Las Gabias"
	    },
	    {
	        "id": 8064,
	        "name": "Orendain"
	    },
	    {
	        "id": 8065,
	        "name": "Lupiñén-Ortilla"
	    },
	    {
	        "id": 8066,
	        "name": "Arroyo del Ojanco"
	    },
	    {
	        "id": 8067,
	        "name": "Ribera d'Ondara"
	    },
	    {
	        "id": 8068,
	        "name": "Beriáin"
	    },
	    {
	        "id": 8069,
	        "name": "Cuevas de Provanco"
	    },
	    {
	        "id": 8070,
	        "name": "Salou"
	    },
	    {
	        "id": 8071,
	        "name": "Zamudio"
	    },
	    {
	        "id": 8072,
	        "name": "Merindad de Río Ubierna"
	    },
	    {
	        "id": 8073,
	        "name": "Los Valdecolmenas"
	    },
	    {
	        "id": 8074,
	        "name": "Los Guajares"
	    },
	    {
	        "id": 8075,
	        "name": "Altzaga"
	    },
	    {
	        "id": 8076,
	        "name": "Santa María de Dulcis"
	    },
	    {
	        "id": 8077,
	        "name": "Les Valls d'Aguilar"
	    },
	    {
	        "id": 8078,
	        "name": "Orkoien"
	    },
	    {
	        "id": 8079,
	        "name": "San Cristóbal de Segovia"
	    },
	    {
	        "id": 8080,
	        "name": "L'Ampolla"
	    },
	    {
	        "id": 8081,
	        "name": "Forua"
	    },
	    {
	        "id": 8082,
	        "name": "Alfoz de Quintanadueñas"
	    },
	    {
	        "id": 8083,
	        "name": "Valle del Zalabí"
	    },
	    {
	        "id": 8084,
	        "name": "Gaztelu"
	    },
	    {
	        "id": 8085,
	        "name": "Aínsa-Sobrarbe"
	    },
	    {
	        "id": 8086,
	        "name": "Torrefeta i Florejacs"
	    },
	    {
	        "id": 8087,
	        "name": "Zizur Mayor/Zizur Nagusia"
	    },
	    {
	        "id": 8088,
	        "name": "La Canonja"
	    },
	    {
	        "id": 8089,
	        "name": "Kortezubi"
	    },
	    {
	        "id": 8090,
	        "name": "Valle de Losa"
	    },
	    {
	        "id": 8091,
	        "name": "Pozorrubielos de la Mancha"
	    },
	    {
	        "id": 8092,
	        "name": "Villamena"
	    },
	    {
	        "id": 8093,
	        "name": "Hoz y Costean"
	    },
	    {
	        "id": 8094,
	        "name": "Fígols i Alinyà"
	    },
	    {
	        "id": 8095,
	        "name": "Lekunberri"
	    },
	    {
	        "id": 8096,
	        "name": "Murueta"
	    },
	    {
	        "id": 8097,
	        "name": "Sotorribas"
	    },
	    {
	        "id": 8098,
	        "name": "Morelábor"
	    },
	    {
	        "id": 8099,
	        "name": "Vencillón"
	    },
	    {
	        "id": 8100,
	        "name": "La Vansa i Fórnols"
	    },
	    {
	        "id": 8101,
	        "name": "Nabarniz"
	    },
	    {
	        "id": 8102,
	        "name": "Villar y Velasco"
	    },
	    {
	        "id": 8103,
	        "name": "El Pinar"
	    },
	    {
	        "id": 8104,
	        "name": "Josa i Tuixén"
	    },
	    {
	        "id": 8105,
	        "name": "Iurreta"
	    },
	    {
	        "id": 8106,
	        "name": "Vegas del Genil"
	    },
	    {
	        "id": 8107,
	        "name": "Els Plans de Sió"
	    },
	    {
	        "id": 8108,
	        "name": "Ajangiz"
	    },
	    {
	        "id": 8109,
	        "name": "Cuevas del Campo"
	    },
	    {
	        "id": 8110,
	        "name": "Gimenells i el Pla de la Font"
	    },
	    {
	        "id": 8111,
	        "name": "Alonsotegi"
	    },
	    {
	        "id": 8112,
	        "name": "Zagra"
	    },
	    {
	        "id": 8113,
	        "name": "Riu de Cerdanya"
	    },
	    {
	        "id": 8114,
	        "name": "Zierbena"
	    },
	    {
	        "id": 8115,
	        "name": "Arratzu"
	    },
	    {
	        "id": 8116,
	        "name": "Ziortza-Bolibar"
	    }
	];


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"col-xs-12 col-md-12 main\">\n\t<div class=\"col-xs-12\">\n\t\t<div class=\"col-xs-12\" style=\"border-bottom: 1px solid #396e8a; padding-bottom: 2em; background: white;\">\n\t\t\t<!--photo profile -->\n\t\t\t<div class=\"col-md-3 col-xs-12 col-sm-8 change-main-image-div\" style=\"display: inline-block; vertical-align: top; padding-right: 0em;\">\n\t\t\t\t<label for=\"profileImage\" class=\"clickable\" on-mouseover='overMainF()' on-mouseout='outMain()' style=\"width: 100%;\">\n\t\t\t\t\t<div style=\"position: relative;\">\n                    \t<img src=\"{{element?.mainImage}}\" class=\"logo-stand\" style=\"padding-top: 1em;\" />\n                    \t<div class=\"change-main-image\" [ngClass]=\"{visible: overMain}\"><span style=\"line-height: 1.9em;\">{{'CHANGE_PICTURE' | translate }}</span></div>\n                \t</div>\n\t\t\t\t</label>\n\t\t\t\t<img-cropper [image]=\"data2\" [settings]=\"cropperSettings2\" (onCrop)=\"cropped2($event)\"></img-cropper>\n\t\t\t\t<div>\n\t\t\t\t\t<label style=\"display: inline-block;\n                vertical-align: middle;\n                margin-top: 1.2em;\n                margin-left: 1em;\" *ngIf=\"code === 120\">{{ 'UPLOADING' | translate }}: {{uploadProgress}}%</label>\n\t\t\t\t\t<label style=\"display: inline-block;\n                vertical-align: middle;\n                margin-top: 1.2em;\n                margin-left: 1em;\" *ngIf=\"code === 121\" class=\"login-error-msg\">{{ 'WRONG_FILE_EXTENSION' | translate }}</label>\n\t\t\t\t\t<label style=\"display: inline-block;\n                vertical-align: middle;\n                margin-top: 1.2em;\n                margin-left: 1em;\" *ngIf=\"code === 122\" class=\"login-error-msg\">{{ 'FILE_CANNOT_BE_LARGER_THAN_2MB' | translate }}</label>\n\t\t\t\t\t<label style=\"display: inline-block;\n                vertical-align: middle;\n                margin-top: 1.2em;\n                margin-left: 1em;\" *ngIf=\"code === 123\" class=\"login-error-msg\">{{ 'PICTURES_LIMIT_IS_10' | translate }}</label>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!--name && description -->\n\t\t\t<div class=\"col-xs-12 col-md-9\" style=\"margin-left: 0em; padding-left: 0em; margin-top: 1em;\">\n\t\t\t\t<h1 class=\"header-stand clickable\" (click)=\"editNameF()\">\n\t\t\t\t\t<span *ngIf=\"!editName\">{{element?.comercial_name}}</span>\n\t\t\t\t\t<span *ngIf=\"!editName && !element?.comercial_name\">{{ 'WRITE_MARKET_NAME' | translate }}</span>\n\t\t\t\t\t<input *ngIf=\"editName\" class=\"input-title-dayInformation\" [(ngModel)]=\"element.comercial_name\" placeholder=\"Nom de la botiga\"\n\t\t\t\t\t maxlength=\"45\" (keyup.enter)=\"postName(true)\" />\n\t\t\t\t\t<span class=\"glyphicon glyphicon-play white big-glyphicon\" *ngIf=\"editName\" (click)=\"postName(false)\"></span>\n\t\t\t\t\t<label style=\"width:100%; font-weight: 100; font-size: 0.8em;\">{{element?.id_visible}}</label>\n\t\t\t\t</h1>\n\t\t\t\t<h4 class=\"description-stand clickable\" (click)=\"editDescriptionF();\">\n\t\t\t\t\t<span *ngIf=\"!editDescription\">{{element?.description}}</span>\n\t\t\t\t\t<span *ngIf=\"!editDescription && !element?.description\">{{ 'WRITE_DESCRIPTION' | translate }}</span>\n\t\t\t\t\t<textarea maxlength=\"400\" *ngIf=\"editDescription\" class=\"textarea-description-dayInformation\" placeholder=\"Descripció de la botiga\"\n\t\t\t\t\t [(ngModel)]=\"element.description\"></textarea>\n\t\t\t\t\t<button class=\"day-information-small-button\" *ngIf=\"editDescription\" (click)=\"postDescription();\"><span class=\"glyphicon glyphicon-play white big-glyphicon\"></span>  {{ 'SAVE_DESCRIPTION' | translate }}</button>\n\t\t\t\t</h4>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!--Links-->\n\t\t<div class=\"col-xs-12\" style=\"border-bottom: 1px solid #396e8a; padding-bottom: 2em; background: white; padding-top: 1em;\">\n\t\t\t<h2 *ngIf=\"!editWeb\" class=\"col-xs-12 clickable\" (click)=\"editWebSite()\">\n\t\t\t\t<img style=\"height: 1.1em; width: auto;\" class=\"logo col-xs-1\" src=\"" + __webpack_require__(121) + "\" />\n\t\t\t\t<input *ngIf=\"element?.web_site == ''\" class=\"col-xs-11\" type=\"text\" placeholder=\"{{ 'WEB_SITE' | translate }}\" style=\"border: 0px;\"/>\n\t\t\t\t<input *ngIf=\"element?.web_site != ''\" class=\"col-xs-11\" type=\"text\" placeholder=\"{{element?.web_site}}\" style=\"border: 0px;\"/>\n\t\t\t</h2>\n\t\t\t<div *ngIf=\"editWeb\" class=\"col-xs-12\">\n\t\t\t\t<h2 class=\"col-xs-12\">\n\t\t\t\t\t<img style=\"height: 1.1em; width: auto;\" class=\"logo col-xs-1 clickable\" (click)=\"editWebSite()\" src=\"" + __webpack_require__(121) + "\" />\n\t\t\t\t\t<input #web class=\"col-xs-11\" type=\"text\" (keyup.enter)=\"saveWebSite(web.value)\"/>\n\t\t\t\t</h2>\n\t\t\t\t<span *ngIf=\"web_errorCode === 1\" class=\"login-error-msg col-xs-11 col-xs-offset-1\">{{ 'WEB_SITE_EMPTY' | translate }}</span>\n\t\t\t\t<span *ngIf=\"web_errorCode === 2\" class=\"login-error-msg col-xs-11 col-xs-offset-1\">{{ 'WEB_SITE_WRONG' | translate }}</span>\n\t\t\t\t<button class=\"day-information-small-button col-xs-offset-1\" (click)=\"saveWebSite(web.value);\"><span class=\"glyphicon glyphicon-play white big-glyphcion\"></span> {{ 'SAVE_WEB_SITE' | translate }}</button>\n\t\t\t</div>\n\t\t\t<h2 *ngIf=\"!editFacebook\" class=\"col-xs-12 clickable\" (click)=\"editFacebookSite()\">\n\t\t\t\t<img style=\"height: 1.1em; width: auto;\" class=\"logo col-xs-1\" src=\"" + __webpack_require__(122) + "\" />\n\t\t\t\t<input *ngIf=\"element?.facebook_site == ''\" class=\"col-xs-11\" type=\"text\" placeholder=\"{{ 'FACEBOOK_SITE' | translate }}\" style=\"border: 0px;\"/>\n\t\t\t\t<input *ngIf=\"element?.facebook_site != ''\" class=\"col-xs-11\" type=\"text\" placeholder=\"{{element?.facebook_site}}\" style=\"border: 0px;\"/>\n\t\t\t</h2>\n\t\t\t<div *ngIf=\"editFacebook\" class=\"col-xs-12\">\n\t\t\t\t<h2 class=\"col-xs-12\">\n\t\t\t\t\t<img style=\"height: 1.1em; width: auto;\" class=\"logo col-xs-1 clickable\" (click)=\"editFacebookSite()\" src=\"" + __webpack_require__(122) + "\" />\n\t\t\t\t\t<input #facebook class=\"col-xs-11\" type=\"text\" (keyup.enter)=\"saveFacebookSite(facebook.value)\"/>\n\t\t\t\t</h2>\n\t\t\t\t<span *ngIf=\"facebook_errorCode === 1\" class=\"login-error-msg col-xs-11 col-xs-offset-1\">{{ 'FACEBOOK_SITE_EMPTY' | translate }}</span>\n\t\t\t\t<span *ngIf=\"facebook_errorCode === 2\" class=\"login-error-msg col-xs-11 col-xs-offset-1\">{{ 'FACEBOOK_SITE_WRONG' | translate }}</span>\n\t\t\t\t<button class=\"day-information-small-button col-xs-offset-1\" (click)=\"saveFacebookSite(facebook.value);\"><span class=\"glyphicon glyphicon-play white big-glyphcion\"></span> {{ 'SAVE_FACEBOOK_SITE' | translate }}</button>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!--tags-->\n\t\t<div class=\"col-xs-12\" style=\"border-bottom: 1px solid #396e8a; padding-bottom: 2em; padding-top: 1em; padding-left: 0em; background: white;\">\n\t\t\t<div *ngFor=\"let tag of tags\" (mouseenter)=\"mouseOverTag(tag.id)\" (mouseleave)=\"mouseLeaveTag()\" (click)=\"selectTagMain(tag.id)\"\n\t\t\t style=\"display: flex; margin-bottom: 1em; float: left; margin-right: 2em;\">\n\t\t\t\t<label class=\"tag\">{{tag.name}}</label>\n\t\t\t\t<span *ngIf=\"!overTag(tag.id)\" style=\"margin-left: -1.4em; margin-top: 0.9em; z-index: 999; position: relative; color: white;\">●</span>\n\t\t\t\t<span *ngIf=\"overTag(tag.id)\" class=\"clickable\" style=\"margin-left: -1.4em; margin-top: 0.9em; z-index: 999; position: relative; color: white; font-weight: bold;\"\n\t\t\t\t (click)=\"deleteTag(tag.id)\">X</span>\n\t\t\t</div>\n\t\t\t<div class=\"col-xs-12\">\n\t\t\t\t<label class=\"day-information-button\" (click)=\"addTag($event)\">+ {{ 'ADD_TAGS' | translate }}</label>\n\t\t\t</div>\n\t\t</div>\n\t\t<div>\n\t\t\t<label style=\"display: inline-block; vertical-align: middle; margin-top: 1.2em; margin-left: 1em;\" *ngIf=\"reachedLimitTags\"\n\t\t\t class=\"login-error-msg\">{{ 'TAGS_LIMIT_IS' | translate }}{{limitTags}}</label>\n\t\t</div>\n\n\t\t<!--photos-->\n\t\t<div class=\"col-xs-12\" style=\"border-bottom: 1px solid #396e8a; padding-bottom: 2em; padding-top: 1em; background: white; \">\n\t\t\t<div *ngFor=\"let image of photos\" style=\"display: inline-block; position: relative; margin-top: 1em; margin-right: 1em; vertical-align: top; text-align: center; width: 12em;\">\n\t\t\t\t<img on-mouseover='over(image.id)' on-mouseout='out(image.id)' [class.selected]=\"selected==image.id\" src=\"{{image.url}}\"\n\t\t\t\t class=\"element-image clickable\" (click)=\"selectImage(image.id)\" style=\"width: 100%;\" />\n\t\t\t\t<span on-mouseover='over(image.id)' on-mouseout='out(image.id)' (click)=\"deleteImage(image.id);\" class=\"glyphicon glyphicon-remove\"\n\t\t\t\t style=\"font-size: 1.3em; color: #666666; position: absolute; cursor: pointer; right: 0; top: 2;\" aria-hidden=\"true\"></span>\n\t\t\t\t<span *ngIf=\"!image.edit && (image.price=='' || image.price==NULL)\" style=\"display: block; background: #6fb3cb; font-size: 1.3em; color: white;\"\n\t\t\t\t (click)=\"image.edit=true\">0.00 {{'COIN_TYPE' | translate}}</span>\n\t\t\t\t<span *ngIf=\"!image.edit && image.price!='' && image.price!=NULL\" style=\"display: block; background: #6fb3cb; font-size: 1.3em; color: white;\"\n\t\t\t\t (click)=\"image.edit=true\">{{image.price}} {{'COIN_TYPE' | translate}}</span>\n\t\t\t\t<input *ngIf=\"image.edit\" type=\"text\" maxlength=\"30\" style=\"padding-left: 1em; border: none; display: block; background: #6fb3cb; font-size: 1.3em; color: white; width: 100%;\"\n\t\t\t\t value=\"{{image.price}}\" (keydown)=\"editImagePriceKey($event, image)\" [(ngModel)]=\"image.price\" (focusout)=\"editImagePrice(image)\"\n\t\t\t\t/>\n\t\t\t</div>\n\t\t\t<div class=\"col-xs-12\" style=\"padding-left: 0em;\">\n\t\t\t\t<img-cropper [image]=\"data1\" [settings]=\"cropperSettings1\" [productMode]=\"true\" (onCrop)=\"cropped($event)\"></img-cropper>\n\t\t\t\t<label for=\"addImage\" class=\"day-information-button\">{{ 'ADD_PICTURE' | translate }}</label>\n\t\t\t</div>\n\t\t</div>\n\t\t<div>\n\t\t\t<label style=\"display: inline-block; vertical-align: middle; margin-top: 1.2em; margin-left: 1em;\" *ngIf=\"code === 20\">{{ 'UPLOADING' | translate }}: {{uploadProgress}}%</label>\n\t\t\t<label style=\"display: inline-block; vertical-align: middle; margin-top: 1.2em; margin-left: 1em;\" *ngIf=\"code === 21\" class=\"login-error-msg\">{{ 'WRONG_FILE_EXTENSION' | translate }}</label>\n\t\t\t<label style=\"display: inline-block; vertical-align: middle; margin-top: 1.2em; margin-left: 1em;\" *ngIf=\"code === 22\" class=\"login-error-msg\">{{ 'FILE_CANNOT_BE_LARGER_THAN_2MB' | translate }}</label>\n\t\t\t<label style=\"display: inline-block; vertical-align: middle; margin-top: 1.2em; margin-left: 1em;\" *ngIf=\"code === 23\" class=\"login-error-msg\">{{ 'PICTURES_LIMIT_IS' | translate }}{{limitPhotos}}</label>\n\t\t</div>\n\t\t<!--<button *ngIf=\"!addingPhoto\" (click)=\"addPhoto()\" style=\"margin-top: 1em;\">+ Afegir foto</button>\n        <div *ngIf=\"addingPhoto\">\n            <dashboard-add-photo [element-obj]=\"element\"></dashboard-add-photo>\n        </div>-->\n\t\t<!--photo dayInformation -->\n\t\t<div *ngIf=\"user.subrole != 8 && user.subrole != 9\" class=\"col-xs-12\" style=\"margin-top: 1em; margin-left: 1.4em; padding-top: 1em; background-color: white; padding-right: 0em; \">\n\t\t\t<div class=\"col-xs-12\" *ngFor=\"let day of dayInformation; let i = index\" style=\" background-color: #6fb3cb; padding-left: 0em; padding-right: 0em; margin-bottom: 2em;\">\n\t\t\t\t<div class=\"day-information-div\">\n\t\t\t\t\t<label class=\"clickable day-information-day col-xs-12 col-md-10\" (click)=\"editDay(day.id)\">{{ days[day.id-1].name | translate }}\n                        <span *ngIf=\"isEditDay(day.id)\" style=\"float: right;\">&times;</span>\n                        <span *ngIf=\"!isEditDay(day.id)\" style=\"float: right;\"><span style=\"font-size: 0.9em; margin-top: 0.2em;\" class=\"glyphicon glyphicon-pencil\"></span></span>\n                    </label>\n\t\t\t\t\t<span class=\"day-information-span col-xs-12 col-md-12\" style=\"padding-top: 0.4em\">\n                        <span *ngIf=\"!isEditDay(day.id)\">{{ day.name | translate }}</span>\n\t\t\t\t\t<ng2-completer style=\"font-size: 1em; padding-bottom: 0em; width: 50%;\" class=\"col-xs-8 col-xs-6\" *ngIf=\"isEditDay(day.id)\"\n\t\t\t\t\t [(ngModel)]=\"day.name\" [ngModelOptions]=\"{standalone: true}\" [datasource]=\"dataService\" [minSearchLength]=\"2\" [placeholder]=\"('SEARCH_CITY' | translate)\"\n\t\t\t\t\t [textNoResults]=\"('CITY_NOT_FOUND' | translate)\" [autoMatch]=\"true\" (selected)=\"onCitySelected($event)\"></ng2-completer>\n\t\t\t\t\t<label *ngIf=\"isEditDay(day.id)\" class=\"col-xs-4 col-xs-6 clickable\" (click)=\"ubicateCity(day)\" style=\"font-weight: 100; font-size: 0.8em; margin-bottom: 0em; margin-top: 0.4em;font-style: italic;\">({{ 'UBICATE_CITY' | translate }})</label>\n\t\t\t\t\t<label *ngIf=\"day.id == selectedDay && cityNotFound\" style=\"font-size: 0.7em; margin-top: 0.2em; margin-left: 0.5em; width: 100%; padding-left: 0.8em; color: white; font-weight: bold;\">\n                            <span style=\"font-size: 0.9em; margin-top: 0.2em;\" class=\"glyphicon glyphicon-exclamation-sign\"></span>\n                            {{ 'CITY_NOT_FOUND' | translate }}</label>\n\t\t\t\t\t<label *ngIf=\"day.id == selectedDay && cityNotIntroduced\" style=\"font-size: 0.7em; margin-top: 0.2em; margin-left: 0.5em; width: 100%; padding-left: 0.8em; color: white; font-weight: bold;\">\n                            <span style=\"font-size: 0.9em; margin-top: 0.2em;\" class=\"glyphicon glyphicon-exclamation-sign\"></span>\n                            {{ 'EMPTY_CITY' | translate }}</label>\n\t\t\t\t\t</span>\n\t\t\t\t\t<span class=\"day-information-span col-xs-12\" style=\"padding-top: 0.5em; padding-left: 1.7em; font-size: 1.3em;\">\n                        <span *ngIf=\"!isEditDay(day.id)\">{{day.information}}</span>\n\t\t\t\t\t<input *ngIf=\"isEditDay(day.id)\" style=\"font-size: 1.1em;\" [(ngModel)]=\"day.information\" class=\"col-xs-12 col-md-7\" placeholder=\"{{ 'ADDITIONAL_INFORMATION' | translate }}\"\n\t\t\t\t\t/>\n\t\t\t\t\t</span>\n\t\t\t\t</div>\n\t\t\t\t<div *ngIf=\"!isEditDay(day.id)\" class=\"day-information-span col-xs-12 col-md-12 pull-right\" style=\"text-align: right;\">\n\t\t\t\t\t<img class=\"font-diff\" *ngIf=\"day.latitude!='' && day.latitude!=null\" style=\"width: 1.2em; vertical-align: top; margin-right: 0.5em; margin-top: 0.1em;\"\n\t\t\t\t\t src=\"" + __webpack_require__(123) + "\" />\n\t\t\t\t\t<label class=\"font-diff\" style=\"padding-left: 0.5em; padding-right: 0.5em; font-weight: 100; text-align: right; font-size: 0.8em;\">{{day.latitude}}</label>\n\t\t\t\t\t<label class=\"font-diff\" style=\"padding-left: 0.5em; padding-right: 0.5em; font-weight: 100; text-align: right; font-size: 0.8em;\">{{day.longitude}}</label>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-xs-12\" *ngIf=\"isEditDay(day.id)\" style=\"padding-top: 0.9em; padding-left: 2.2em; padding-right: 2.2em;\">\n\t\t\t\t\t<h1 style=\"padding-top: 0em; margin-top: 0em; font-size: 1.2em; color: white; margin-bottom: 0.2em;\">{{ 'UBICATE_MARKET' | translate }}</h1>\n\t\t\t\t\t<sebm-google-map [latitude]=\"40.1825402\" [longitude]=\"-3.1386127\" [zoom]=\"5\" (mapClick)=\"mapClicked($event)\">\n\t\t\t\t\t\t<sebm-google-map-marker *ngIf='marker.lat!=0 && marker.lat !=\"\"' [latitude]=\"marker.lat\" [longitude]=\"marker.lng\" [markerDraggable]=\"draggable\"\n\t\t\t\t\t\t (dragEnd)=\"mapClicked($event)\"></sebm-google-map-marker>\n\t\t\t\t\t</sebm-google-map>\n\t\t\t\t\t<div *ngIf=\"isEditDay(day.id)\" class=\"day-information-span col-xs-12 col-md-12 pull-right\" style=\"text-align: right; padding-right: 0em;\">\n\t\t\t\t\t\t<label class=\"font-diff\" style=\"padding-left: 0.5em; padding-right: 0.5em; font-weight: 100; font-size: 0.7em; text-align: right;  padding-right: 0em;\">{{day.latitude}}</label>\n\t\t\t\t\t\t<label class=\"font-diff\" style=\"padding-left: 0.5em; padding-right: 0.5em; font-weight: 100; font-size: 0.7em; text-align: right;  padding-right: 0em;\">{{day.longitude}}</label>\n\t\t\t\t\t</div>\n\t\t\t\t\t<button style=\"margin-bottom: 1em;\" class=\"day-information-small-button\" *ngIf=\"isEditDay(day.id)\" (click)=\"postDayInformation(day);\"> {{ 'SAVE_INFORMATION' | translate }}</button>\n\t\t\t\t\t<button style=\"margin-bottom: 1em; margin-left: 1em;\" class=\"day-information-small-button\" *ngIf=\"isEditDay(day.id)\" (click)=\"deleteDayInformation(day);\">{{ 'DELETE' | translate }}</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\t<div [ngClass]=\"classMapModal\" role=\"dialog\">\n\t\t<div class=\"modal-dialog\">\n\t\t\t<!-- Modal content-->\n\t\t\t<div class=\"modal-content\">\n\t\t\t\t<div class=\"modal-header\" *ngIf=\"imageDelete!=-1\">\n\t\t\t\t\t<button type=\"button\" class=\"close\" (click)=\"closeModal()\">&times;</button>\n\t\t\t\t\t<h4 class=\"modal-title\">{{ 'DELETE_IMAGE' | translate }}</h4>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"modal-body\" style=\"text-align: center\" [ngClass]=\"{padding2bottom: imageDelete==-1}\">\n\t\t\t\t\t<button *ngIf=\"imageDelete==-1\" type=\"button\" class=\"close\" (click)=\"closeModal()\">&times;</button>\n\t\t\t\t\t<img style=\"width: 60%;\" src=\"{{imageSelected}}\" [ngClass]=\"{padding2top: imageDelete==-1}\" />\n\t\t\t\t</div>\n\t\t\t\t<div class=\"modal-footer\">\n\t\t\t\t\t<button type=\"button\" class=\"btn\" (click)=\"closeModal()\">{{ 'CLOSE' | translate }}</button>\n\t\t\t\t\t<button *ngIf=\"imageDelete!=-1\" type=\"button\" class=\"btn btn-default\" (click)=\"deleteConfirm()\">{{ 'DELETE' | translate }}</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div [ngClass]=\"classTagsModal\" role=\"dialog\">\n\t\t<div class=\"modal-dialog\" style=\"width:90%;\">\n\t\t\t<!-- Modal content-->\n\t\t\t<div class=\"modal-content\">\n\t\t\t\t<div class=\"modal-header\">\n\t\t\t\t\t<button type=\"button\" class=\"close\" (click)=\"closeTagsModal()\">&times;</button>\n\t\t\t\t\t<div class=\"form-group has-feedback col-xs-11\" style=\"margin-bottom: 0;\">\n\t\t\t\t\t\t<label class=\"modal-title col-xs-5\" style=\"padding-left: 0px; font-size: 18px; font-weight: normal;\">{{ 'ADD_TAGS' | translate}}</label>\n\t\t\t\t\t\t<div class=\"col-xs-12 col-md-6\">\n\t\t\t\t\t\t\t<input type=\"text\" [(ngModel)]=\"tagsModalFilter\" (ngModelChange)=\"tagsModalFilterChanged()\" class=\"form-control col-xs-4\"\n\t\t\t\t\t\t\t placeholder=\"Buscar...\" />\n\t\t\t\t\t\t\t<span class=\"glyphicon glyphicon-search form-control-feedback\" style=\"margin-right: 1em;\"></span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"modal-body\" style=\"overflow-y: scroll; height: 30em;\">\n\t\t\t\t\t<div *ngFor=\"let tag of modalTags\" style=\"margin-bottom: 1em; display: inline; padding-right: 1em;\">\n\t\t\t\t\t\t<!--<button class=\"col-lg-12 col-xs-12\" [style.background-color]=\"getColor(tag)\" (click)=\"selectTag(tag)\">{{tag.name}}</button>-->\n\t\t\t\t\t\t<label class=\"clickable\" [ngClass]=\"{tag: !isTagSelected(tag), tagSelected: isTagSelected(tag)}\" (click)=\"selectTag(tag)\">{{tag.name}}</label>\n\t\t\t\t\t\t<label *ngIf=\"!overTag(tag.id)\" style=\"margin-left: -1.4em; z-index: 999; position: relative; color: white;\">●</label>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"modal-footer\" style=\"margin-top: 2em;\">\n\t\t\t\t\t<label *ngIf=\"reachedLimitTagsOnModal\" style=\"display: inline-block; vertical-align: middle; margin-top: 1.2em; margin-left: 1em;\"\n\t\t\t\t\t class=\"login-error-msg\" style=\"float: left;\">{{ 'TAGS_LIMIT_IS' | translate }}{{limitTags}}</label>\n\t\t\t\t\t<button type=\"button\" class=\"btn\" (click)=\"closeTagsModal()\">{{ 'CLOSE' | translate }}</button>\n\t\t\t\t\t<button type=\"button\" class=\"btn btn-default\" (click)=\"saveTagsModal()\">{{ 'SAVE' | translate }}</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>";

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/web_small.c6db70cd007e6a056fbb61057c19b202.png";

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/facebook_small.af6b81219e3b75acd13a1e35fc240c6e.png";

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/place-min.b6cf7783201cd64d00bdb3a77c3f6bb7.png";

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(76);
	var messages_service_1 = __webpack_require__(125);
	var SuperUserMessagesComponent = (function () {
	    function SuperUserMessagesComponent(_messagesService, _parentRouter) {
	        this._messagesService = _messagesService;
	        this.parentMessages = [];
	        this.readMessages = [];
	        this.unreadMessages = [];
	        this.sendedMessages = [];
	        this.user_id = -1;
	        this.showReceivedMessages = true;
	        this.showSendedMessages = false;
	        this.router = _parentRouter;
	    }
	    SuperUserMessagesComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._messagesService.getParentMessages().then(function (res) {
	            if (res != null) {
	                _this.parentMessages = res.rows;
	                _this.user_id = res.user_id;
	                _this.organizeMessages();
	            }
	        });
	    };
	    SuperUserMessagesComponent.prototype.organizeMessages = function () {
	        var _this = this;
	        for (var i = 0; i < this.parentMessages.length; i++) {
	            this._messagesService.getMessageWithChilds(this.parentMessages[i]).then(function (result) {
	                var message = result[0];
	                message.total_messages_conversation = 1;
	                message.selected = false;
	                _this.setMessageDateFormat(message);
	                //El missatge és rebut
	                if (message.user_receiver_id == _this.user_id) {
	                    if (message.childs.length == 0) {
	                        if (message.read) {
	                            _this.readMessages.push(message);
	                        }
	                        else {
	                            _this.unreadMessages.push(message);
	                        }
	                    }
	                    else {
	                        _this.organizeMessage(message);
	                    }
	                }
	                else if (message.user_sender_id == _this.user_id) {
	                    if (message.childs.length == 0) {
	                        _this.sendedMessages.push(message);
	                    }
	                    else {
	                        _this.organizeMessage(message);
	                    }
	                }
	            });
	        }
	    };
	    SuperUserMessagesComponent.prototype.setMessageDateFormat = function (message) {
	        var messageDate = new Date(message.creation_date);
	        var day = messageDate.getDate().toString();
	        if (day.length < 2) {
	            day = "0" + day;
	        }
	        var month = (messageDate.getMonth() + 1).toString();
	        if (month.length < 2) {
	            month = "0" + month;
	        }
	        var year = messageDate.getFullYear().toString();
	        var hour = messageDate.getHours().toString();
	        if (hour.length < 2) {
	            hour = "0" + hour;
	        }
	        var minute = messageDate.getMinutes().toString();
	        if (minute.length < 2) {
	            minute = "0" + minute;
	        }
	        var seconds = messageDate.getSeconds().toString();
	        if (seconds.length < 2) {
	            seconds = "0" + seconds;
	        }
	        message.date_to_show = day + "/" + month + "/" + year + " - " + hour + ":" + minute + ":" + seconds;
	    };
	    SuperUserMessagesComponent.prototype.organizeMessage = function (message) {
	        var messagesReceived = this.getMessagesReceivedChilds(message);
	        var messagesSended = this.getMessagesSendedChilds(message);
	        message.total_messages_conversation += messagesReceived.length + messagesSended.length;
	        if (messagesReceived.length == 0 && message.user_receiver_id == this.user_id) {
	            if (message.read) {
	                this.readMessages.push(message);
	            }
	            else {
	                this.unreadMessages.push(message);
	            }
	        }
	        else if (messagesReceived.length > 0) {
	            this.sortArrayByMessageDate(messagesReceived);
	            //Aquesta instrucció no serà necessària ja que ens encarregarem que al insertar un missatge fill nou a la base de dades automàticament tingui el title del pare
	            messagesReceived[0].title = message.title;
	            messagesReceived[0].total_messages_conversation = message.total_messages_conversation;
	            if (message.user_sender_id == this.user_id) {
	                messagesReceived[0].user_sender_name = message.user_receiver_name;
	            }
	            else if (message.user_receiver_id == this.user_id) {
	                messagesReceived[0].user_sender_name = message.user_sender_name;
	            }
	            this.setMessageDateFormat(messagesReceived[0]);
	            if (messagesReceived[0].read) {
	                this.readMessages.push(messagesReceived[0]);
	            }
	            else {
	                this.unreadMessages.push(messagesReceived[0]);
	            }
	        }
	        if (messagesSended.length == 0 && message.user_sender_id == this.user_id) {
	            this.sendedMessages.push(message);
	        }
	        else if (messagesSended.length > 0) {
	            this.sortArrayByMessageDate(messagesSended);
	            //Aquesta instrucció no serà necessària ja que ens encarregarem que al insertar un missatge fill nou a la base de dades automàticament tingui el title del pare
	            messagesSended[0].title = message.title;
	            messagesSended[0].total_messages_conversation = message.total_messages_conversation;
	            if (message.user_sender_id == this.user_id) {
	                messagesSended[0].user_receiver_name = message.user_receiver_name;
	            }
	            else if (message.user_receiver_id == this.user_id) {
	                messagesSended[0].user_receiver_name = message.user_sender_name;
	            }
	            this.setMessageDateFormat(messagesSended[0]);
	            this.sendedMessages.push(messagesSended[0]);
	        }
	    };
	    SuperUserMessagesComponent.prototype.getMessagesReceivedChilds = function (message) {
	        var messageChilds = [];
	        for (var i = 0; i < message.childs.length; i++) {
	            message.childs[i].selected = false;
	            if (message.childs[i].user_receiver_id == this.user_id) {
	                messageChilds.push(message.childs[i]);
	            }
	            if (message.childs[i].childs.length > 0) {
	                messageChilds = messageChilds.concat(this.getMessagesReceivedChilds(message.childs[i]));
	            }
	        }
	        return messageChilds;
	    };
	    SuperUserMessagesComponent.prototype.getMessagesSendedChilds = function (message) {
	        var messageChilds = [];
	        for (var i = 0; i < message.childs.length; i++) {
	            message.childs[i].selected = false;
	            if (message.childs[i].user_sender_id == this.user_id) {
	                messageChilds.push(message.childs[i]);
	            }
	            if (message.childs[i].childs.length > 0) {
	                messageChilds = messageChilds.concat(this.getMessagesSendedChilds(message.childs[i]));
	            }
	        }
	        return messageChilds;
	    };
	    SuperUserMessagesComponent.prototype.sortArrayByMessageDate = function (array) {
	        array.sort(function (a, b) {
	            return new Date(b.creation_date).getTime() - new Date(a.creation_date).getTime();
	        });
	    };
	    SuperUserMessagesComponent.prototype.changeToReceivedMessages = function () {
	        this.showReceivedMessages = true;
	        this.showSendedMessages = false;
	    };
	    SuperUserMessagesComponent.prototype.changeToSendedMessages = function () {
	        this.showReceivedMessages = false;
	        this.showSendedMessages = true;
	    };
	    //Section 0: Read Message
	    //Section 1: Unread Message
	    //Section 2: Sended Message
	    SuperUserMessagesComponent.prototype.messageClicked = function (message, message_section) {
	        this.router.navigate(['/superuser', 'message', { mainId: message.main_parent_id, section: message_section }]);
	    };
	    SuperUserMessagesComponent = __decorate([
	        core_1.Component({
	            selector: 'messages',
	            template: __webpack_require__(126),
	            providers: [messages_service_1.MessagesService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof messages_service_1.MessagesService !== 'undefined' && messages_service_1.MessagesService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object])
	    ], SuperUserMessagesComponent);
	    return SuperUserMessagesComponent;
	    var _a, _b;
	}());
	exports.SuperUserMessagesComponent = SuperUserMessagesComponent;


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(30);
	var Observable_1 = __webpack_require__(5);
	var json = __webpack_require__(95);
	var MessagesService = (function () {
	    function MessagesService(http) {
	        this.http = http;
	        this._messagesUrl = '/messagesData';
	        this.serverURL = json.api_url;
	    }
	    MessagesService.prototype.getParentMessages = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.get(this.serverURL + this._messagesUrl + "/parents", options).toPromise().then(function (res) {
	            if (JSON.parse(res.text()).code == 1) {
	                return JSON.parse(res.text());
	            }
	            else {
	                return null;
	            }
	        }, this.handleError);
	    };
	    MessagesService.prototype.getMessageWithChilds = function (message) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        var url = this._messagesUrl + "/" + message.id;
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.get(this.serverURL + url, options).toPromise().then(function (result) {
	            if (JSON.parse(result.text()).code == 1) {
	                return JSON.parse(result.text()).rows;
	            }
	        }).catch(this.handleError);
	    };
	    MessagesService.prototype.getMessageById = function (id) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        var url = this._messagesUrl + "/parent/" + id;
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.get(this.serverURL + url, options).toPromise().then(function (result) {
	            if (JSON.parse(result.text()).code == 1) {
	                return JSON.parse(result.text()).rows;
	            }
	        }).catch(this.handleError);
	    };
	    MessagesService.prototype.putMessagesRead = function (message) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        var url = this._messagesUrl + "/" + message.id;
	        return this.http.put(this.serverURL + url, this.serializeObj(message), { headers: authHeader }).toPromise().then(function (result) {
	            if (JSON.parse(result.text()).code == 1) {
	                return JSON.parse(result.text()).code;
	            }
	        }).catch(this.handleError);
	    };
	    MessagesService.prototype.postMessage = function (message) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        return this.http.post(this.serverURL + this._messagesUrl, this.serializeObj(message), { headers: authHeader }).toPromise().then(function (result) {
	            return JSON.parse(result.text());
	        }).catch(this.handleError);
	    };
	    MessagesService.prototype.handleError = function (error) {
	        // In a real world app, we might use a remote logging infrastructure
	        // We'd also dig deeper into the error to get a better message
	        var errMsg = (error.message) ? error.message : error.status ? error.status + " - " + error.statusText : 'Server error';
	        console.error(errMsg); // log to console instead
	        return Observable_1.Observable.throw(errMsg);
	    };
	    MessagesService.prototype.serializeObj = function (obj) {
	        var result = [];
	        for (var property in obj) {
	            result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));
	        }
	        return result.join("&");
	    };
	    MessagesService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], MessagesService);
	    return MessagesService;
	    var _a;
	}());
	exports.MessagesService = MessagesService;


/***/ },
/* 126 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-xs-12 col-sm-9 col-sm-offset-3 col-md-9 col-md-offset-2 main\">\n        <div class=\"col-xs-12\">\n            <div class=\"col-xs-6\">\n                <!--<button class=\"selectedButton\">{{'SEND'|translate}}</button>-->\n                <button [ngClass]=\"{selectedButton: showReceivedMessages, notSelectedButton: !showReceivedMessages}\" (click)=\"changeToReceivedMessages()\">{{'RECEIVEDS'|translate}}</button>\n                <button [ngClass]=\"{selectedButton: showSendedMessages, notSelectedButton: !showSendedMessages}\" (click)=\"changeToSendedMessages()\">{{'SENDS'|translate}}</button>\n            </div>\n            <div class=\"col-xs-6\" style=\"text-align: right\">\n                \n            </div>\n        </div>\n\n        <div *ngIf=\"showReceivedMessages\" class=\"col-xs-12 messageBlock\">\n            <div class=\"messageBlockHead col-xs-12\" style=\"padding: 0;\">\n                <div class=\"messageBlockHeadColor col-xs-6 col-xs-offset-6\">\n                    <h4 class=\"messageBlockHeadColorTitle\" style=\"display: inline; font-size: 1.2em;\">{{ 'NO_READS' | translate }}</h4>\n                </div>\n            </div>\n            <div *ngFor=\"let message of unreadMessages\" class=\"col-xs-12 messageBlockBodyRead clickable\" style=\"padding: 0;\" (click)=\"messageClicked(message, 0)\">\n                <div class=\"col-xs-12\" style=\"padding: 0;\">\n                    <div class=\"col-xs-6\" style=\"text-align: left;\">\n                        <label class=\"messageBlockLabelNormal\">{{message.user_sender_name}}</label>\n                    </div>\n                    <div class=\"col-xs-6\" style=\"text-align: right;\">\n                        <label class=\"messageBlockLabelSmall\">{{message.date_to_show}}</label>\n                    </div>\n                </div>\n                <div class=\"col-xs-12\" style=\"padding-left: 3em;\">\n                    <div style=\"float: left; padding-right: 1em;\">\n                        <label class=\"messageBlockLabelNormal\" *ngIf=\"message.total_messages_conversation > 1\">&nbsp;({{message.total_messages_conversation}})</label>\n                        <label class=\"messageBlockLabelHigh\">{{message.title}}</label>\n                    </div>\n                    <div style=\"float: left\">\n                        <label class=\"messageBlockLabelNormal\" *ngIf=\"message.content.length > 30\">{{message.content.substr(0,30)}}...</label>\n                        <label class=\"messageBlockLabelNormal\" *ngIf=\"message.content.length <= 30\">{{message.content}}</label>\n                    </div>\n\n                </div>\n            </div>\n        </div>\n\n        <div *ngIf=\"showReceivedMessages\" class=\"col-xs-12 messageBlock\" style=\"margin-top: 2em;\">\n            <div class=\"messageBlockHead col-xs-12\" style=\"padding: 0;\">\n                <div class=\"messageBlockHeadColor col-xs-6 col-xs-offset-6\">\n                    <h4 class=\"messageBlockHeadColorTitle\" style=\"display: inline; font-size: 1.2em;\">{{ 'READS' | translate }}</h4>\n                </div>\n            </div>\n            <div *ngFor=\"let message of readMessages\" class=\"col-xs-12 messageBlockBody clickable\" style=\"padding: 0;\" (click)=\"messageClicked(message, 0)\">\n                <div class=\"col-xs-12\" style=\"padding: 0;\">\n                    <div class=\"col-xs-6\" style=\"text-align: left;\">\n                        <label class=\"messageBlockLabelNormal\">{{message.user_sender_name}}</label>\n                    </div>\n                    <div class=\"col-xs-6\" style=\"text-align: right;\">\n                        <label class=\"messageBlockLabelSmall\">{{message.date_to_show}}</label>\n                    </div>\n                </div>\n                <div class=\"col-xs-12\" style=\"padding-left: 3em;\">\n                    <div style=\"float: left; padding-right: 1em;\">\n                        <label class=\"messageBlockLabelNormal\" *ngIf=\"message.total_messages_conversation > 1\">&nbsp;({{message.total_messages_conversation}})</label>\n                        <label class=\"messageBlockLabelHigh\">{{message.title}}</label>\n                    </div>\n                    <div style=\"float: left\">\n                        <label class=\"messageBlockLabelNormal\" *ngIf=\"message.content.length > 30\">{{message.content.substr(0,30)}}...</label>\n                        <label class=\"messageBlockLabelNormal\" *ngIf=\"message.content.length <= 30\">{{message.content}}</label>\n                    </div>\n\n                </div>\n            </div>\n        </div>\n\n        <div *ngIf=\"showSendedMessages\" class=\"col-xs-12 messageBlock\">\n            <div class=\"messageBlockHead col-xs-12\" style=\"padding: 0;\">\n                <div class=\"messageBlockHeadColor col-xs-6 col-xs-offset-6\">\n                    <h4 class=\"messageBlockHeadColorTitle\" style=\"display: inline; font-size: 1.2em;\">{{ 'NO_READS' | translate }}</h4>\n                </div>\n            </div>\n            <div *ngFor=\"let message of sendedMessages\" class=\"col-xs-12 messageBlockBodyRead clickable\" style=\"padding: 0;\" (click)=\"messageClicked(message, 0)\">\n                <div class=\"col-xs-12\" style=\"padding: 0;\">\n                    <div class=\"col-xs-6\" style=\"text-align: left;\">\n                        <label class=\"messageBlockLabelNormal\">{{message.user_receiver_name}}</label>\n                    </div>\n                    <div class=\"col-xs-6\" style=\"text-align: right;\">\n                        <label class=\"messageBlockLabelSmall\">{{message.date_to_show}}</label>\n                    </div>\n                </div>\n                <div class=\"col-xs-12\" style=\"padding-left: 3em;\">\n                    <div style=\"float: left; padding-right: 1em;\">\n                        <label class=\"messageBlockLabelNormal\" *ngIf=\"message.total_messages_conversation > 1\">&nbsp;({{message.total_messages_conversation}})</label>\n                        <label class=\"messageBlockLabelHigh\">{{message.title}}</label>\n                    </div>\n                    <div style=\"float: left\">\n                        <label class=\"messageBlockLabelNormal\" *ngIf=\"message.content.length > 30\">{{message.content.substr(0,30)}}...</label>\n                        <label class=\"messageBlockLabelNormal\" *ngIf=\"message.content.length <= 30\">{{message.content}}</label>\n                    </div>\n\n                </div>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(76);
	var messages_service_1 = __webpack_require__(125);
	__webpack_require__(128);
	var SuperUserMessageDetailComponent = (function () {
	    function SuperUserMessageDetailComponent(_messagesService, _parentRouter, route) {
	        this._messagesService = _messagesService;
	        this.route = route;
	        this.main_message = { "id": Number(route.snapshot.params['mainId']), "title": "", "content": "", "creation_date": "", "date_to_show": "", "read": false, "user_sender_id": 0,
	            "user_sender_name": "", "user_receiver_id": 0, "user_receiver_name": "", "message_parent_id": 0, "childs": [], "total_messages_conversation": 0,
	            "main_parent_id": 0, "selected": false };
	        this.messages = [];
	        this.iluminatedMessages = [];
	        this.section = Number(route.snapshot.params['section']);
	        this.user_id = Number(localStorage.getItem("idUser"));
	        this.router = _parentRouter;
	    }
	    SuperUserMessageDetailComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._messagesService.getMessageWithChilds(this.main_message).then(function (result) {
	            _this.main_message = result[0];
	            _this.organizeMessages(_this.main_message);
	            _this.sortArrayByMessageId(_this.messages);
	            _this.organizeSection(_this.section);
	        });
	    };
	    SuperUserMessageDetailComponent.prototype.organizeMessages = function (message) {
	        this.setMessageDateFormat(message);
	        message.selected = false;
	        this.messages.push(message);
	        if (message.childs.length > 0) {
	            for (var i = 0; i < message.childs.length; i++) {
	                this.organizeMessages(message.childs[i]);
	            }
	        }
	    };
	    SuperUserMessageDetailComponent.prototype.setMessageDateFormat = function (message) {
	        var messageDate = new Date(message.creation_date);
	        var day = messageDate.getDate().toString();
	        if (day.length < 2) {
	            day = "0" + day;
	        }
	        var month = (messageDate.getMonth() + 1).toString();
	        if (month.length < 2) {
	            month = "0" + month;
	        }
	        var year = messageDate.getFullYear().toString();
	        var hour = messageDate.getHours().toString();
	        if (hour.length < 2) {
	            hour = "0" + hour;
	        }
	        var minute = messageDate.getMinutes().toString();
	        if (minute.length < 2) {
	            minute = "0" + minute;
	        }
	        var seconds = messageDate.getSeconds().toString();
	        if (seconds.length < 2) {
	            seconds = "0" + seconds;
	        }
	        message.date_to_show = day + "/" + month + "/" + year + " - " + hour + ":" + minute + ":" + seconds;
	    };
	    SuperUserMessageDetailComponent.prototype.sortArrayByMessageId = function (array) {
	        array.sort(function (a, b) {
	            return a.id - b.id;
	        });
	    };
	    SuperUserMessageDetailComponent.prototype.organizeSection = function (section) {
	        var _this = this;
	        //Read messages
	        if (section == 0) {
	            this.messages[this.messages.length - 1].selected = true;
	        }
	        else if (section == 1) {
	            for (var i = 0; i < this.messages.length; i++) {
	                if (this.messages[i].user_receiver_id == this.user_id && !this.messages[i].read) {
	                    this.messages[i].selected = true;
	                }
	            }
	            this._messagesService.putMessagesRead(this.main_message).then(function (result) {
	                if (result == 1) {
	                    _this.putMessagesRead(_this.messages);
	                }
	            });
	        }
	        else if (section == 2) {
	            for (var i = 0; i < this.messages.length; i++) {
	                if (this.messages[i].user_sender_id == this.user_id) {
	                    this.messages[i].selected = true;
	                }
	            }
	        }
	    };
	    SuperUserMessageDetailComponent.prototype.putMessagesRead = function (messages) {
	        for (var i = 0; i < messages.length; i++) {
	            if (messages[i].user_receiver_id == this.user_id && !messages[i].read) {
	                messages[i].read = true;
	                this.iluminatedMessages.push(messages[i]);
	            }
	        }
	    };
	    SuperUserMessageDetailComponent.prototype.goBack = function () {
	        this.router.navigate(['/superuser', 'messages']);
	    };
	    SuperUserMessageDetailComponent.prototype.getColor = function (message) {
	        if (this.arrayContains(this.iluminatedMessages, message)) {
	            return "#6fb3cb";
	        }
	    };
	    SuperUserMessageDetailComponent.prototype.arrayContains = function (array, object) {
	        for (var i = 0; i < array.length; i++) {
	            if (array[i] == object) {
	                return true;
	            }
	        }
	        return false;
	    };
	    SuperUserMessageDetailComponent.prototype.messageClicked = function (message) {
	        if (message.selected) {
	            message.selected = false;
	        }
	        else {
	            message.selected = true;
	        }
	        if (this.arrayContains(this.iluminatedMessages, message)) {
	            var index = this.iluminatedMessages.indexOf(message);
	            this.iluminatedMessages.splice(index, 1);
	        }
	    };
	    SuperUserMessageDetailComponent.prototype.sendMessage = function () {
	        var _this = this;
	        if (!this.isTextEmpty(this.textAreaContent)) {
	            if (this.user_id == this.main_message.user_sender_id) {
	                var userSenderId = this.main_message.user_sender_id;
	                var userReceiverId = this.main_message.user_receiver_id;
	                var userSenderName = this.main_message.user_sender_name;
	                var userReceiverName = this.main_message.user_receiver_name;
	            }
	            else {
	                var userSenderId = this.main_message.user_receiver_id;
	                var userReceiverId = this.main_message.user_sender_id;
	                var userSenderName = this.main_message.user_receiver_name;
	                var userReceiverName = this.main_message.user_sender_name;
	            }
	            var message = { "id": 0, "title": this.main_message.title, "content": this.textAreaContent, "creation_date": "", "date_to_show": "", "read": false,
	                "user_sender_id": userSenderId, "user_sender_name": userSenderName, "user_receiver_id": userReceiverId, "user_receiver_name": userReceiverName,
	                "message_parent_id": 0, "childs": [], "total_messages_conversation": 0, "main_parent_id": this.main_message.id, "selected": false };
	            this._messagesService.postMessage(message).then(function (result) {
	                if (result.code == 1) {
	                    _this.addMessage(result.insertId).then(function (data_void) {
	                        _this.sortArrayByMessageId(_this.messages);
	                        _this.textAreaContent = "";
	                    });
	                }
	            });
	        }
	    };
	    SuperUserMessageDetailComponent.prototype.isTextEmpty = function (text) {
	        if (text == null || text == undefined || text == "") {
	            return true;
	        }
	        else {
	            var trim = text.replace(/ /g, "");
	            var trim = trim.replace(/\n/g, "");
	            if (trim == "") {
	                return true;
	            }
	            else {
	                return false;
	            }
	        }
	    };
	    SuperUserMessageDetailComponent.prototype.addMessage = function (id) {
	        var _this = this;
	        return this._messagesService.getMessageById(id).then(function (result) {
	            var message = result[0];
	            _this.setMessageDateFormat(message);
	            message.selected = false;
	            message.childs = [];
	            _this.messages.push(message);
	        });
	    };
	    SuperUserMessageDetailComponent = __decorate([
	        core_1.Component({
	            selector: 'message',
	            template: __webpack_require__(130),
	            providers: [messages_service_1.MessagesService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof messages_service_1.MessagesService !== 'undefined' && messages_service_1.MessagesService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object])
	    ], SuperUserMessageDetailComponent);
	    return SuperUserMessageDetailComponent;
	    var _a, _b, _c;
	}());
	exports.SuperUserMessageDetailComponent = SuperUserMessageDetailComponent;


/***/ },
/* 128 */,
/* 129 */,
/* 130 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\" col-xs-12 col-sm-9 col-sm-offset-3 col-md-9 col-md-offset-2 main\">       \n        <div class=\"col-xs-12\" style=\"padding-left: 1em;\">\n            <div style=\"margin-bottom: 1em\">\n                <button class=\"selectedButton\" (click)=\"goBack()\">{{'BACK'|translate}}</button>\n            </div>\n            <div class=\"messageBlockHead col-xs-12\" style=\"padding: 0;\">\n                <div class=\"messageBlockHeadColor col-xs-6\">\n                    <h4 class=\"messageBlockHeadColorTitle\" style=\"display: inline; font-size: 1.2em;\">{{main_message.title}}</h4>\n                </div>\n            </div>\n             <div *ngFor=\"let message of messages\" [ngClass]=\"{messageSelected: message.selected}\" class=\"col-xs-12 message clickable\" (click)=\"messageClicked(message)\">\n                <div *ngIf=\"!message.selected\" class=\"clickable\">                    \n                    <div class=\"col-xs-12\" style=\"padding: 0;\">\n                        <div class=\"col-xs-6\" style=\"text-align: left;\">\n                            <span *ngIf=\"message.user_sender_id == user_id\" class=\"glyphicon glyphicon-menu-up big-glyphicon\" style=\"color: red; float: left; width: 1em; margin-top: 0.17em;\"></span>\n                            <span *ngIf=\"message.user_receiver_id == user_id\" class=\"glyphicon glyphicon-menu-down big-glyphicon\" style=\"color: green; float: left; width: 1em; margin-top: 0.17em;\"></span>\n                            <label class=\"messageBlockLabelNormal\" style=\"margin-left: 0.7em;\">{{message.user_sender_name}}</label>\n                        </div>\n                        <div class=\"col-xs-6\" style=\"text-align: right;\">\n                            <label class=\"messageBlockLabelSmall\">{{message.date_to_show}}</label>\n                        </div>\n                    </div>\n                    <div class=\"col-xs-12\" style=\"padding-left: 3em;\">\n                        <div>\n                            <label class=\"messageBlockLabelNormal\" *ngIf=\"message.content.length > 30\">{{message.content.substr(0,30)}}...</label>\n                            <label class=\"messageBlockLabelNormal\" *ngIf=\"message.content.length <= 30\">{{message.content}}</label>\n                        </div>\n\n                    </div>  \n                </div> \n\n                <div *ngIf=\"message.selected\" class=\"clickable\">                    \n                    <div class=\"col-xs-12\" style=\"padding: 0;\">\n                        <div class=\"col-xs-6\" style=\"text-align: left;\">\n                            <span *ngIf=\"message.user_sender_id == user_id\" class=\"glyphicon glyphicon-menu-up big-glyphicon\" style=\"color: red; float: left; width: 1em; margin-top: 0.17em;\"></span>\n                            <span *ngIf=\"message.user_receiver_id == user_id\" class=\"glyphicon glyphicon-menu-down big-glyphicon\" style=\"color: green; float: left; width: 1em; margin-top: 0.17em;\"></span>\n                            <label class=\"messageBlockLabelNormal\" style=\"margin-left: 0.7em;\">{{message.user_sender_name}}</label>\n                        </div>\n                        <div class=\"col-xs-6\" style=\"text-align: right;\">\n                            <label class=\"messageBlockLabelSmall\">{{message.date_to_show}}</label>\n                        </div>\n                    </div>\n                    <div class=\"col-xs-12\" style=\"padding-left: 3em;\">\n                        <div>\n                            <label class=\"messageBlockLabelNormal\">{{message.content}}</label>\n                        </div>\n                    </div>\n                </div>     \n            </div>   \n            <textarea maxlength=\"1000\" class=\"col-xs-12\" style=\"margin-top: 1em; margin-bottom: 0.5em; height: 8em; resize: none; color: grey;\" [(ngModel)]=\"textAreaContent\"></textarea>\n            <div class=\"col-xs-12\" style=\"margin-bottom: 1em; text-align: left; padding-left: 0em;\">\n                <button class=\"selectedButton\" (click)=\"sendMessage()\">{{'SEND'|translate}}</button>\n            </div>                          \n        </div>\n    </div>\n</div>";

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var profile_service_1 = __webpack_require__(132);
	var cities_1 = __webpack_require__(119);
	var SuperUserProfileComponent = (function () {
	    function SuperUserProfileComponent(_profileService) {
	        this._profileService = _profileService;
	        this.classMapModal = { 'model': true, 'show': false, 'hide': true };
	        this.classTermsModal = { 'model': true, 'show': false, 'hide': true };
	        this.editingProfile = false;
	        this.changingEmail = false;
	        this.changingPassword = false;
	        this.changingEmailPassword = false;
	        this.changingCategory = false;
	        this.changingLanguage = false;
	        this.changingSubrole = false;
	        this.invalidChangeEmail = false;
	        this.invalidLengthEmail = false;
	        this.invalidExistsEmail = false;
	        this.wrongPassword = false;
	        this.invalidUserPasswordToChangeEmail = false;
	        this.wrongName = false;
	        this.wrongNif = false;
	        this.wrongPhone = false;
	        this.wrongCity = false;
	        this.wrongAddress = false;
	        this.wrongZip = false;
	        this.emptyOldUserPassword = false;
	        this.emptyOrShortNewUserPassword = false;
	        this.modalTitle = "";
	        this.oldUserPassword = "";
	        this.newUserPassword = "";
	        this.userPasswordToChangeEmail = "";
	        this.emailSend = false;
	    }
	    SuperUserProfileComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._profileService.getProfile().then(function (profile) {
	            _this.userProfile = profile.row;
	            _this.userProfileClean = profile.row[0];
	            var cities = cities_1.CITIES.filter(function (city) { return city.id === profile.row[0].city_id; });
	            _this.userProfile[0].city_name = cities[0].name;
	            _this.userProfileClean.city_name = cities[0].name;
	        });
	        this._profileService.getUserLanguage().then(function (lang) {
	            if (lang == 1) {
	                _this.userLanguage = "CATALAN";
	            }
	            else if (lang == 2) {
	                _this.userLanguage = "SPANISH";
	            }
	        });
	    };
	    SuperUserProfileComponent.prototype.editProfile = function () {
	        this.changingEmail = false;
	        this.changingSubrole = false;
	        this.editingProfile = true;
	        this.changingCategory = false;
	        this.changingLanguage = false;
	        this.changingPassword = false;
	        this.changingEmailPassword = false;
	        this.classMapModal.show = true;
	        this.classMapModal.hide = false;
	        this.modalTitle = "EDIT_PROFILE";
	    };
	    SuperUserProfileComponent.prototype.changePassword = function () {
	        this.changingEmail = false;
	        this.changingSubrole = false;
	        this.changingPassword = true;
	        this.changingLanguage = false;
	        this.editingProfile = false;
	        this.changingEmailPassword = false;
	        this.changingCategory = false;
	        this.classMapModal.show = true;
	        this.classMapModal.hide = false;
	        this.modalTitle = "CHANGE_PASSWORD";
	    };
	    SuperUserProfileComponent.prototype.changeSubrole = function () {
	        this.changingEmail = false;
	        this.changingPassword = false;
	        this.editingProfile = false;
	        this.changingLanguage = false;
	        this.changingEmailPassword = false;
	        this.changingCategory = false;
	        this.changingSubrole = true;
	        this.classMapModal.show = true;
	        this.classMapModal.hide = false;
	        this.modalTitle = "CHANGE_SUBROLE";
	    };
	    SuperUserProfileComponent.prototype.changeEmailPassword = function () {
	        this.changingEmail = false;
	        this.changingPassword = false;
	        this.editingProfile = false;
	        this.changingEmailPassword = true;
	        this.changingCategory = false;
	        this.changingLanguage = false;
	        this.classMapModal.show = true;
	        this.changingSubrole = false;
	        this.classMapModal.hide = false;
	        this.modalTitle = "CHANGE_EMAIL";
	    };
	    SuperUserProfileComponent.prototype.changeEmail = function () {
	        this.changingPassword = false;
	        this.changingLanguage = false;
	        this.editingProfile = false;
	        this.changingSubrole = false;
	        this.changingEmailPassword = false;
	        this.changingEmail = true;
	        this.changingCategory = false;
	        this.classMapModal.show = true;
	        this.classMapModal.hide = false;
	        this.modalTitle = "CHANGE_EMAIL";
	    };
	    SuperUserProfileComponent.prototype.sendEmail = function () {
	        var _this = this;
	        this._profileService.sendEmail().then(function (result) {
	            _this.emailSend = true;
	        });
	    };
	    SuperUserProfileComponent.prototype.close = function (savedUser) {
	        this.editingProfile = false;
	        this.changingPassword = false;
	        this.changingEmailPassword = false;
	        this.changingLanguage = false;
	        this.changingCategory = false;
	        this.changingSubrole = false;
	        this.changingEmail = false;
	        if (savedUser) {
	            console.log("savedUser");
	        }
	    };
	    SuperUserProfileComponent.prototype.closeModal = function () {
	        this.classMapModal.show = false;
	        this.classMapModal.hide = true;
	    };
	    SuperUserProfileComponent.prototype.saveModel = function () {
	        var _this = this;
	        if (this.editingProfile) {
	            this.checkUserFields();
	            if (this.wrongName || this.wrongNif || this.wrongPhone || this.wrongCity || this.wrongAddress || this.wrongZip) {
	                this.closeModal();
	                this.editProfile();
	            }
	            else {
	                var city = cities_1.CITIES.filter(function (city) { return city.name.toLowerCase() === _this.userProfileClean.city_name.toLowerCase(); });
	                this._profileService.editProfileInfo(this.userProfileClean, city[0].id);
	                this.editingProfile = false;
	                this.closeModal();
	            }
	        }
	        else if (this.changingCategory) {
	            this._profileService.changeCategory(this.categoryUpdatedV).subscribe(function (result) {
	                console.log(result);
	                if (result != -1) {
	                    _this.userProfileClean.subrole = result;
	                    _this.closeModal();
	                }
	                else {
	                    _this.closeModal();
	                }
	            }, function () { });
	        }
	        else if (this.changingLanguage) {
	            console.log(this.userLanguage);
	            this._profileService.getUserLanguage().then(function (lang) {
	                console.log(lang);
	                if (lang == 1) {
	                    var language = "CATALAN";
	                }
	                else if (lang == 2) {
	                    var language = "SPANISH";
	                }
	                if (language != _this.userLanguage) {
	                    _this._profileService.changeLanguage(_this.userLanguage).subscribe(function (res) {
	                        if (res.code = 1) {
	                            _this.closeModal();
	                            if (_this.userLanguage == "CATALAN") {
	                                localStorage.setItem("language", "cat");
	                            }
	                            else if (_this.userLanguage == "SPANISH") {
	                                localStorage.setItem("language", "esp");
	                            }
	                            location.reload();
	                        }
	                    });
	                }
	                else {
	                    _this.closeModal();
	                }
	            });
	        }
	        else if (this.changingPassword) {
	            if (!this.oldUserPassword) {
	                this.emptyOldUserPassword = true;
	            }
	            else {
	                this.emptyOldUserPassword = false;
	            }
	            if (!this.newUserPassword || this.newUserPassword.length < 4) {
	                this.emptyOrShortNewUserPassword = true;
	            }
	            else {
	                this.emptyOrShortNewUserPassword = false;
	            }
	            if (this.emptyOldUserPassword || this.emptyOrShortNewUserPassword) {
	                this.wrongPassword = false;
	                this.closeModal();
	                this.changePassword();
	            }
	            else {
	                this._profileService.verifyPassword(this.oldUserPassword).then(function (result) {
	                    if (result) {
	                        _this._profileService.changePassword(_this.newUserPassword).then(function (result) {
	                            _this.wrongPassword = false;
	                            _this.closeModal();
	                        });
	                    }
	                    else {
	                        _this.closeModal();
	                        _this.wrongPassword = true;
	                        _this.changePassword();
	                    }
	                });
	            }
	        }
	        else if (this.changingEmailPassword) {
	            this._profileService.verifyPassword(this.userPasswordToChangeEmail).then(function (result) {
	                if (result) {
	                    _this.invalidUserPasswordToChangeEmail = false;
	                    _this.closeModal();
	                    _this.changeEmail();
	                }
	                else {
	                    _this.closeModal();
	                    _this.invalidUserPasswordToChangeEmail = true;
	                    _this.changeEmailPassword();
	                }
	            });
	        }
	        else if (this.changingEmail) {
	            if (this.userEmailChange.length == 0 || this.userEmailChange.length > 50) {
	                this.invalidLengthEmail = true;
	            }
	            else {
	                this.invalidLengthEmail = false;
	                if (!this.validateEmail(this.userEmailChange)) {
	                    this.invalidChangeEmail = true;
	                }
	                else {
	                    this.invalidChangeEmail = false;
	                }
	            }
	            if (this.invalidChangeEmail || this.invalidLengthEmail) {
	                this.closeModal();
	                this.changeEmail();
	            }
	            else {
	                this._profileService.existsEmail(this.userEmailChange).then(function (res) {
	                    if (!res) {
	                        _this._profileService.changeEmail(_this.userEmailChange).then(function (result) {
	                            if (result = "1") {
	                                _this.closeModal();
	                                _this.userProfile[0].email = _this.userEmailChange;
	                                _this.userProfileClean.email_active = false;
	                            }
	                            else {
	                            }
	                        });
	                    }
	                    else {
	                        _this.invalidExistsEmail = true;
	                        _this.closeModal();
	                        _this.changeEmail();
	                    }
	                });
	            }
	        }
	    };
	    SuperUserProfileComponent.prototype.checkUserFields = function () {
	        this.checkName();
	        this.checkNif();
	        this.checkPhone();
	        this.checkCity();
	        this.checkAddress();
	        this.checkZip();
	    };
	    SuperUserProfileComponent.prototype.checkName = function () {
	        if (this.userName.length == 0 || this.userName.length < 2 || this.userName.length > 60) {
	            this.wrongName = true;
	        }
	        else {
	            this.wrongName = false;
	        }
	    };
	    SuperUserProfileComponent.prototype.checkNif = function () {
	        if (this.userNif.length == 0 || !this.validateNIF(this.userNif)) {
	            this.wrongNif = true;
	        }
	        else {
	            this.wrongNif = false;
	        }
	    };
	    SuperUserProfileComponent.prototype.checkPhone = function () {
	        if (this.userPhone.length == 0 || !this.validPhone(this.userPhone)) {
	            this.wrongPhone = true;
	        }
	        else {
	            this.wrongPhone = false;
	        }
	    };
	    SuperUserProfileComponent.prototype.checkCity = function () {
	        var _this = this;
	        var cities = cities_1.CITIES.filter(function (city) { return city.name.toLowerCase() == _this.userCity.toLowerCase(); });
	        if (cities.length != 0 && cities[0] !== undefined && cities[0] !== null) {
	            this.userCity = cities[0].name;
	            this.userProfile[0].city_name = cities[0].name;
	            this.wrongCity = false;
	        }
	        else {
	            this.wrongCity = true;
	        }
	    };
	    SuperUserProfileComponent.prototype.checkAddress = function () {
	        if (this.userAddress.length < 5 || this.userAddress.length > 120) {
	            this.wrongAddress = true;
	        }
	        else {
	            this.wrongAddress = false;
	        }
	    };
	    SuperUserProfileComponent.prototype.checkZip = function () {
	        if (this.userZip.length == 0 || !this.validZip(this.userZip)) {
	            this.wrongZip = true;
	        }
	        else {
	            this.wrongZip = false;
	        }
	    };
	    SuperUserProfileComponent.prototype.userNameFunction = function (event) {
	        this.userName = event.value;
	    };
	    SuperUserProfileComponent.prototype.userNifFunction = function (event) {
	        this.userNif = event.value;
	    };
	    SuperUserProfileComponent.prototype.userPhoneFunction = function (event) {
	        this.userPhone = event.value;
	    };
	    SuperUserProfileComponent.prototype.userCityFunction = function (event) {
	        this.userCity = event.value;
	    };
	    SuperUserProfileComponent.prototype.userAddressFunction = function (event) {
	        this.userAddress = event.value;
	    };
	    SuperUserProfileComponent.prototype.userZipFunction = function (event) {
	        this.userZip = event.value;
	    };
	    SuperUserProfileComponent.prototype.oldUserPasswordFunction = function (event) {
	        this.oldUserPassword = event.value;
	    };
	    SuperUserProfileComponent.prototype.newUserPasswordFunction = function (event) {
	        this.newUserPassword = event.value;
	    };
	    SuperUserProfileComponent.prototype.userPasswordToChangeEmailFunction = function (event) {
	        this.userPasswordToChangeEmail = event.value;
	    };
	    SuperUserProfileComponent.prototype.userChangeEmailFunction = function (event) {
	        this.userEmailChange = event.value;
	    };
	    SuperUserProfileComponent.prototype.validateNIF = function (value) {
	        var validChars = 'TRWAGMYFPDXBNJZSQVHLCKET';
	        var nifRexp = /^[0-9]{8}(-?)[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i;
	        var nieRexp = /^[XYZ]{1}[0-9]{7}(-?)[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i;
	        var str = value.toString().toUpperCase();
	        if (!nifRexp.test(str) && !nieRexp.test(str))
	            return false;
	        var nie = str
	            .replace(/^[X]/, '0')
	            .replace(/^[Y]/, '1')
	            .replace(/^[Z]/, '2');
	        var letter = str.substr(-1);
	        var charIndex = parseInt(nie.substr(0, 8)) % 23;
	        if (validChars.charAt(charIndex) === letter)
	            return true;
	        return false;
	    };
	    SuperUserProfileComponent.prototype.validPhone = function (phone) {
	        var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{3,6}$/im;
	        var re2 = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{2}[-\s\.]?[0-9]{2}[-\s\.]?[0-9]{2}$/im;
	        return re.test(phone) || re2.test(phone);
	    };
	    SuperUserProfileComponent.prototype.validZip = function (zip) {
	        var re = /^[\+]?[(]?[0-9]{5}$/im;
	        return re.test(zip);
	    };
	    SuperUserProfileComponent.prototype.validateEmail = function (email) {
	        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	        return re.test(email);
	    };
	    SuperUserProfileComponent.prototype.showTerms = function () {
	        this.classTermsModal.show = true;
	        this.classTermsModal.hide = false;
	    };
	    SuperUserProfileComponent.prototype.closeTermsModal = function () {
	        this.classTermsModal.show = false;
	        this.classTermsModal.hide = true;
	    };
	    SuperUserProfileComponent.prototype.getSubrole = function () {
	        if (this.userProfileClean.subrole == 1 || this.userProfileClean.subrole == 3) {
	            return "PROFESIONAL";
	        }
	        else if (this.userProfileClean.subrole == 2 || this.userProfileClean.subrole == 4) {
	            return "TRADITIONAL";
	        }
	        else if (this.userProfileClean.subrole == 8 || this.userProfileClean.subrole == 9) {
	            return "STANDARD";
	        }
	        else {
	            return "UNDEFINED";
	        }
	    };
	    SuperUserProfileComponent.prototype.subroleUpdatedAnswer = function (event) {
	        var _this = this;
	        this.closeModal();
	        if (event.value) {
	            this._profileService.getProfile().then(function (profile) {
	                _this.userProfile = profile.row;
	                _this.userProfileClean = profile.row[0];
	                var cities = cities_1.CITIES.filter(function (city) { return city.id === profile.row[0].city_id; });
	                _this.userProfile[0].city_name = cities[0].name;
	                _this.userProfileClean.city_name = cities[0].name;
	            });
	        }
	    };
	    SuperUserProfileComponent.prototype.getCategory = function () {
	        if (this.userProfileClean.subrole == 1 || this.userProfileClean.subrole == 2 || this.userProfileClean.subrole == 8) {
	            return "CATEGORY_1";
	        }
	        else if (this.userProfileClean.subrole == 3 || this.userProfileClean.subrole == 4 || this.userProfileClean.subrole == 9) {
	            return "CATEGORY_2";
	        }
	    };
	    SuperUserProfileComponent.prototype.changeCategory = function () {
	        this.changingEmail = false;
	        this.changingPassword = false;
	        this.editingProfile = false;
	        this.changingEmailPassword = false;
	        this.changingSubrole = false;
	        this.changingLanguage = false;
	        this.changingCategory = true;
	        this.classMapModal.show = true;
	        this.classMapModal.hide = false;
	        this.modalTitle = "CHANGE_CATEGORY";
	    };
	    SuperUserProfileComponent.prototype.categoryUpdated = function (event) {
	        console.log("category " + event.value);
	        this.categoryUpdatedV = event.value;
	    };
	    SuperUserProfileComponent.prototype.languageUpdatedFunction = function (event) {
	        this.userLanguage = event.value;
	    };
	    SuperUserProfileComponent.prototype.changeLanguage = function () {
	        this.changingEmail = false;
	        this.changingPassword = false;
	        this.editingProfile = false;
	        this.changingEmailPassword = false;
	        this.changingSubrole = false;
	        this.changingCategory = false;
	        this.changingLanguage = true;
	        this.classMapModal.show = true;
	        this.classMapModal.hide = false;
	        this.modalTitle = "CHANGE_LANGUAGE";
	    };
	    SuperUserProfileComponent = __decorate([
	        core_1.Component({
	            selector: 'profile',
	            template: __webpack_require__(133),
	            providers: [profile_service_1.ProfileService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof profile_service_1.ProfileService !== 'undefined' && profile_service_1.ProfileService) === 'function' && _a) || Object])
	    ], SuperUserProfileComponent);
	    return SuperUserProfileComponent;
	    var _a;
	}());
	exports.SuperUserProfileComponent = SuperUserProfileComponent;


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(30);
	var json = __webpack_require__(95);
	var ProfileService = (function () {
	    function ProfileService(http) {
	        this.http = http;
	        this._profileUrl = '/profileData';
	        this.serverURL = json.api_url;
	    }
	    ProfileService.prototype.getProfile = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.get(this.serverURL + this._profileUrl, options)
	            .toPromise()
	            .then(function (res) { return JSON.parse(res.text()); }, this.handleError);
	    };
	    ProfileService.prototype.editProfile = function (profile) {
	        console.log("editing profile");
	        console.log(profile);
	        console.log("petition " + this._profileUrl + "/" + profile.id);
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        return this.http.put(this.serverURL + this._profileUrl, this.serializeObj(profile), { headers: authHeader }).toPromise().then(function (res) {
	            console.log("USER RESULT:");
	            console.log(res);
	            return res;
	        });
	    };
	    ProfileService.prototype.editProfileInfo = function (profile, city_id) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        var url = this._profileUrl + "/" + city_id;
	        return this.http.put(this.serverURL + url, this.serializeObj(profile), { headers: authHeader }).toPromise().then(function (res) {
	            if (JSON.parse(res.text()).code == 1) {
	                localStorage.setItem('userName', JSON.parse(res.text()).user_name);
	            }
	        });
	    };
	    ProfileService.prototype.sendEmail = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        authHeader.append('Authorization', 'Bearer ' + token);
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.get(this.serverURL + '/emailData/sendEmailProfile', options)
	            .toPromise()
	            .then(function (res) {
	            if (JSON.parse(res.text()).code == -1) {
	                return JSON.parse(res.text()).active != 2;
	            }
	            else {
	                return false;
	            }
	        });
	    };
	    ProfileService.prototype.verifyPassword = function (password) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        return this.http.post(this.serverURL + this._profileUrl, this.serializeObj({ "password": password }), { headers: authHeader }).toPromise().then(function (result) {
	            return JSON.parse(result.text()).isMatch;
	        }).catch(this.handleError);
	    };
	    ProfileService.prototype.changePassword = function (password) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        return this.http.put(this.serverURL + this._profileUrl, this.serializeObj({ "password": password }), { headers: authHeader }).toPromise().then(function (result) {
	            return JSON.parse(result.text()).code;
	        }).catch(this.handleError);
	    };
	    ProfileService.prototype.changeCategory = function (cat) {
	        console.log(cat);
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        authHeader.append('Authorization', 'Bearer ' + token);
	        return this.http.post(this.serverURL + '/elementData/changeCategory', this.serializeObj({ "category": cat }), {
	            headers: authHeader
	        }).map(function (res) {
	            var data = res.json();
	            return data.subrole;
	        });
	    };
	    ProfileService.prototype.changeEmail = function (email) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        var url = this._profileUrl + "/" + "email";
	        console.log(url);
	        return this.http.put(this.serverURL + url, this.serializeObj({ "email": email }), { headers: authHeader }).toPromise().then(function (result) {
	            return JSON.parse(result.text()).code;
	        }).catch(this.handleError);
	    };
	    ProfileService.prototype.existsEmail = function (email) {
	        return this.http.get(this.serverURL + '/usersData/existsEmail/' + email).toPromise()
	            .then(function (res) {
	            if (JSON.parse(res.text()).code == 1) {
	                return true;
	            }
	            else {
	                return false;
	            }
	        }, this.handleError);
	    };
	    ProfileService.prototype.createTransaction = function (accountType, method) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        authHeader.append('Authorization', 'Bearer ' + token);
	        return this.http.post(this.serverURL + '/transactions/createTransaction', this.serializeObj({ "accountType": accountType, "method": method }), {
	            headers: authHeader
	        })
	            .toPromise()
	            .then(function (res) {
	            if (JSON.parse(res.text()).code == 1) {
	                return JSON.parse(res.text());
	            }
	            else {
	                return JSON.parse(res.text());
	            }
	        });
	    };
	    ProfileService.prototype.updateTransaction = function (id, method) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        authHeader.append('Authorization', 'Bearer ' + token);
	        return this.http.post(this.serverURL + '/transactions/updateTransaction', this.serializeObj({ "method": method, "id": id }), {
	            headers: authHeader
	        })
	            .toPromise()
	            .then(function (res) {
	            if (JSON.parse(res.text()).code == 1) {
	                return JSON.parse(res.text());
	            }
	            else {
	                return JSON.parse(res.text());
	            }
	        });
	    };
	    ProfileService.prototype.registerFree = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        authHeader.append('Authorization', 'Bearer ' + token);
	        return this.http.post(this.serverURL + '/transactions/registerFree', {}, {
	            headers: authHeader
	        })
	            .map(function (res) {
	            var data = res.json();
	            return data.code;
	        });
	    };
	    ProfileService.prototype.changeLanguage = function (lang) {
	        console.log(lang);
	        var language = 0;
	        if (lang == "CATALAN") {
	            language = 1;
	        }
	        else if (lang == "SPANISH") {
	            language = 2;
	        }
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        authHeader.append('Authorization', 'Bearer ' + token);
	        return this.http.post(this.serverURL + this._profileUrl + "/language", this.serializeObj({ "language": language }), { headers: authHeader }).map(function (res) {
	            var data = res.json();
	            return data;
	        });
	    };
	    ProfileService.prototype.getUserLanguage = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token != null && token != "") {
	            authHeader.append('Authorization', 'Bearer ' + token);
	            var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	            return this.http.get(this.serverURL + "/mainData" + "/language", options).toPromise().then(function (res) {
	                if (JSON.parse(res.text()).code == 1) {
	                    return JSON.parse(res.text()).language;
	                }
	            }).catch(this.handleError);
	        }
	    };
	    ProfileService.prototype.handleError = function (error) {
	        // In a real world app, we might use a remote logging infrastructure
	        // We'd also dig deeper into the error to get a better message
	        var errMsg = (error.message) ? error.message :
	            error.status ? error.status + " - " + error.statusText : 'Server error';
	        console.error(errMsg); // log to console instead
	        return Promise.reject(errMsg);
	    };
	    ProfileService.prototype.serializeObj = function (obj) {
	        var result = [];
	        for (var property in obj)
	            result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));
	        return result.join("&");
	    };
	    ProfileService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], ProfileService);
	    return ProfileService;
	    var _a;
	}());
	exports.ProfileService = ProfileService;


/***/ },
/* 133 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row\">\n\n    <div class=\"col-sm-9 col-sm-offset-3 col-md-9 col-md-offset-2 main\">\n        <div style=\"    border-bottom: 1px solid grey; padding-bottom: 0.5em; padding-top: 0.5em;\">\n            <span class=\"glyphicon glyphicon-user big-glyphicon\"></span>\n            <h2 style=\"display: inline; font-size: 1.4em; padding-left: 1.5em;\">{{ 'USER_PROFILE' | translate }}</h2>\n        </div>\n        <div style=\"border-bottom: 1px solid grey; margin-top: 1em; border-top: 1px solid grey; padding-top: 0.4em; padding-left: 1em;\">\n            <h4 class=\"subtitle\" style=\"display: inline; font-size: 1.2em;\">{{ 'USER_DATA' | translate }}</h4><label class=\"clickable\" style=\"font-size: 0.8em; margin-left: 3em;\" (click)=\"editProfile()\">{{ 'EDIT_PROFILE' | translate }}</label>\n        </div>\n        <div style=\"padding-left: 1em; padding-top: 1em;\" *ngFor=\"let profile of userProfile\">\n            <label>{{ 'NAME' | translate }}:</label> <label style=\"font-weight:100\">{{profile.name}}</label><br/>\n            <label>{{ 'DNI' | translate }}:</label> <label style=\"font-weight:100\">{{profile.nif}}</label><br/>\n            <label>{{ 'PHONE' | translate }}:</label> <label style=\"font-weight:100\">{{profile.phone}}</label><br/>\n            <label>{{ 'CITY_FIELD' | translate }}:</label> <label style=\"font-weight:100\">{{profile.city_name}}</label><br/>\n            <label>{{ 'ADDRESS_FIELD' | translate }}:</label> <label style=\"font-weight:100\">{{profile.address}}</label><br/>\n            <label>{{ 'ZIP_FIELD' | translate }}:</label> <label style=\"font-weight:100\">{{profile.zip}}</label><br/>\n        </div>\n\n        <br/>\n        <div style=\"border-bottom: 1px solid grey; margin-top: 1em; border-top: 1px solid grey; padding-top: 0.4em; padding-left: 1em;\">\n            <h4 class=\"subtitle\" style=\"display: inline; font-size: 1.2em;\">{{ 'EMAIL' | translate }}</h4><label class=\"clickable\" style=\"font-size: 0.8em; margin-left: 3em;\" (click)=\"changeEmailPassword()\">{{ 'CHANGE_EMAIL' | translate }}</label>\n        </div>\n        <div style=\"padding-left: 1em; padding-top: 1em;\" *ngFor=\"let profile of userProfile\">\n            <label>{{profile.email}}</label>\n            <div *ngIf=\"!userProfileClean.email_active\">\n                <label style=\"font-size: 1em; font-weight: 100;\">{{ 'EMAIL_NOT_VALIDATED' | translate }}!</label>\n                <label *ngIf=\"!emailSend\" style=\"font-size: 0.8em; margin-left: 2em;\" class=\"clickable\" (click)=\"sendEmail()\">{{ 'VALIDATE_EMAIL_1' | translate }}</label>\n                <label *ngIf=\"emailSend\" style=\"font-size: 0.8em; margin-left: 2em;\">{{ 'EMAIL_SEND' | translate }}</label>\n            </div>\n        </div>\n        <br/>\n        <div style=\"border-bottom: 1px solid grey; margin-top: 1em; border-top: 1px solid grey; padding-top: 0.4em; padding-left: 1em;\">\n            <h4 class=\"subtitle\" style=\"display: inline; font-size: 1.2em;\">{{ 'PASSWORD' | translate }}</h4><label class=\"clickable\" style=\"font-size: 0.8em; margin-left: 3em;\" (click)=\"changePassword()\">{{ 'CHANGE_PASSWORD' | translate }}</label>\n        </div>\n        <div style=\"padding-left: 1em; padding-top: 1em;\" *ngFor=\"let profile of userProfile\">\n            <label style=\"font-size: 1em;\">********</label>\n        </div>\n        <div *ngIf=\"userProfileClean!=undefined && userProfileClean.role == 3\" style=\"border-bottom: 1px solid grey; margin-top: 1em; border-top: 1px solid grey; padding-top:0.4em; padding-left: 1em\">\n            <h4 class=\"subtitle\" style=\"display: inline; font-size: 1.2em;\">{{ 'SUBROLE' | translate }}</h4><label *ngIf=\"userProfileClean.subrole != 1 && userProfileClean.subrole != 3\"\n                class=\"clickable\" style=\"font-size: 0.8em; margin-left: 3em;\" (click)=\"changeSubrole()\">{{ 'CHANGE_SUBROLE' | translate}}</label>\n        </div>\n        <div *ngIf=\"userProfileClean!=undefined && userProfileClean.role == 3\" style=\"padding-left: 1em; padding-top: 1em;\">\n            <label style=\"font-size: 1em;\">{{getSubrole() | translate}}</label>\n        </div>\n        <div *ngIf=\"userProfileClean!=undefined && userProfileClean.role == 3\" style=\"border-bottom: 1px solid grey; margin-top: 1em; border-top: 1px solid grey; padding-top:0.4em; padding-left: 1em\">\n            <h4 class=\"subtitle\" style=\"display: inline; font-size: 1.2em;\">{{ 'CATEGORY' | translate }}</h4><label class=\"clickable\" style=\"font-size: 0.8em; margin-left: 3em;\" (click)=\"changeCategory()\">{{ 'CHANGE_CATEGORY' | translate}}</label>\n        </div>\n        <div *ngIf=\"userProfileClean!=undefined && userProfileClean.role == 3\" style=\"padding-left: 1em; padding-top: 1em;\">\n            <label style=\"font-size: 1em;\">{{getCategory() | translate}}</label>\n        </div>\n        <div style=\"border-bottom: 1px solid grey; margin-top: 1em; border-top: 1px solid grey; padding-top: 0.4em; padding-left: 1em;\">\n            <h4 class=\"subtitle\" style=\"display: inline; font-size: 1.2em;\">{{ 'LANGUAGE' | translate }}</h4><label class=\"clickable\" style=\"font-size: 0.8em; margin-left: 3em;\" (click)=\"changeLanguage()\">{{ 'CHANGE_LANGUAGE' | translate }}</label>\n        </div>\n        <div style=\"padding-left: 1em; padding-top: 1em;\">\n            <label style=\"font-size: 1em;\">{{ userLanguage | translate }}</label>\n        </div>\n        <br/>\n        <div style=\"padding-left: 1em; margin-top: 3em;\">\n            <a (click)=\"showTerms()\">{{'CONDITIONS_3' | translate}}</a>\n        </div>\n    </div>\n</div>\n<div [ngClass]=\"classMapModal\" role=\"dialog\">\n    <div class=\"modal-dialog\">\n        <!-- Modal content-->\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" (click)=\"closeModal()\">&times;</button>\n                <h4 class=\"modal-title\">{{ modalTitle | translate }}</h4>\n            </div>\n            <div class=\"modal-body\" style=\"overflow-y: scroll; height: 33em;\">\n                <div *ngIf=\"editingProfile\">\n                    <profile-edit [profile-obj]=\"userProfileClean\" [isNameWrong]=\"wrongName\" (nameWrong)=\"userNameFunction($event)\" [isNifWrong]=\"wrongNif\"\n                        (nifWrong)=\"userNifFunction($event)\" [isPhoneWrong]=\"wrongPhone\" (phoneWrong)=\"userPhoneFunction($event)\"\n                        [isCityWrong]=\"wrongCity\" (cityWrong)=\"userCityFunction($event)\" [isAddressWrong]=\"wrongAddress\" (addressWrong)=\"userAddressFunction($event)\"\n                        [isZipWrong]=\"wrongZip\" (zipWrong)=\"userZipFunction($event)\" (close)=\"close($event)\"></profile-edit>\n                </div>\n                <div *ngIf=\"changingPassword\">\n                    <profile-change-password [is-wrong-password]=\"wrongPassword\" [isOldPasswordEmpty]=\"emptyOldUserPassword\" [isNewPasswordEmptyOrShort]=\"emptyOrShortNewUserPassword\"\n                        (oldUserPassword)=\"oldUserPasswordFunction($event)\" (newUserPassword)=\"newUserPasswordFunction($event)\"\n                        (close)=\"close($event)\"></profile-change-password>\n                </div>\n                <div *ngIf=\"changingEmailPassword\">\n                    <profile-change-email-password [invalidPasswordToChangeEmail]=\"invalidUserPasswordToChangeEmail\" (userPassword)=\"userPasswordToChangeEmailFunction($event)\"\n                        (close)=\"close($event)\"></profile-change-email-password>\n                </div>\n                <div *ngIf=\"changingEmail\">\n                    <profile-change-email [invalidEmail]=\"invalidChangeEmail\" [invalidEmailLength]=\"invalidLengthEmail\" [invalidEmailExists]=\"invalidExistsEmail\"\n                        (userEmail)=\"userChangeEmailFunction($event)\" (close)=\"close($event)\"></profile-change-email>\n                </div>\n                <div *ngIf=\"changingSubrole\">\n                    <profile-change-subrole [subrole]=\"userProfileClean.subrole\" (subroleUpdated)=\"subroleUpdatedAnswer($event)\"></profile-change-subrole>\n                </div>\n                <div *ngIf=\"changingCategory\">\n                    <profile-change-category [subroleCat]=\"userProfileClean.subrole\" (subroleUpdatedCat)=\"categoryUpdated($event)\"></profile-change-category>\n                </div>\n                <div *ngIf=\"changingLanguage\">\n                    <profile-change-language [language]=\"userLanguage\" (languageUpdated)=\"languageUpdatedFunction($event)\"></profile-change-language>\n                </div>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn\" (click)=\"closeModal()\">{{ 'CLOSE' | translate }}</button>\n                <button type=\"button\" class=\"btn btn-default\" (click)=\"saveModel()\" *ngIf=\"!changingSubrole\">{{ 'SAVE' | translate }}</button>\n            </div>\n        </div>\n    </div>\n</div>\n<div [ngClass]=\"classTermsModal\" role=\"dialog\">\n    <div class=\"modal-dialog\" style=\"width: 700px; z-index: 99999;\">\n        <!-- Modal content-->\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" (click)=\"closeTermsModal()\">&times;</button>\n                <h4 class=\"modal-title\"><b>{{ 'TERMS_AND_CONDITIONS' | translate }}</b></h4>\n            </div>\n            <div class=\"modal-body\" style=\"text-align: center; overflow-y: scroll; height: 45em;\" [ngClass]=\"{padding2bottom: imageDelete==0}\">\n                <button *ngIf=\"imageDelete==0\" type=\"button\" class=\"close\" (click)=\"closeTermsModal()\">&times;</button>\n                <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_1' | translate }}</p>\n                <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_2' | translate }}</p>\n                <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_4' | translate }}</p>\n                <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_5' | translate }}</p>\n                <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_6' | translate }}</p>\n                <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_7' | translate }}</p>\n                <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_8' | translate }}</p>\n                <p style=\"text-align: left\"><b>{{ 'TERMS_AND_CONDITIONS_9' | translate }}</b></p>\n                <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_10' | translate }}</p>\n                <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_11' | translate }}</p>\n                <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_12' | translate }}</p>\n                <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_13' | translate }}</p>\n                <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_14' | translate }}</p>\n                <p style=\"text-align: left\"><b>{{ 'TERMS_AND_CONDITIONS_15' | translate }}</b></p>\n                <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_16' | translate }}</p>\n                <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_17' | translate }}</p>\n                <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_18' | translate }}</p>\n                <p style=\"text-align: left\"><b>{{ 'TERMS_AND_CONDITIONS_19' | translate }}</b></p>\n                <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_20' | translate }}</p>\n                <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_21' | translate }}</p>\n                <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_22' | translate }}</p>\n                <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_23' | translate }}</p>\n                <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_24' | translate }}</p>\n                <p style=\"text-align: left\"><b>{{ 'TERMS_AND_CONDITIONS_25' | translate }}</b></p>\n                <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_26' | translate }}</p>\n                <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_27' | translate }}</p>\n                <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_28' | translate }}</p>\n                <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_29' | translate }}</p>\n                <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_30' | translate }}</p>\n                <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_31' | translate }}</p>\n                <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_32' | translate }}</p>\n                <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_33' | translate }}</p>\n                <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_34' | translate }}</p>\n                <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_35' | translate }}</p>\n                <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_36' | translate }}</p>\n                <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_37' | translate }}</p>\n                <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_38' | translate }}</p>\n                <p style=\"text-align: left\"><b>{{ 'TERMS_AND_CONDITIONS_39' | translate }}</b></p>\n                <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_40' | translate }}</p>\n                <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_41' | translate }}</p>\n                <p style=\"text-align: left\"><b>{{ 'TERMS_AND_CONDITIONS_42' | translate }}</b></p>\n                <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_43' | translate }}</p>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var SuperUserProfileChangeEmailComponent = (function () {
	    function SuperUserProfileChangeEmailComponent() {
	        this.userEmail = new core_1.EventEmitter();
	        this.email = "";
	    }
	    SuperUserProfileChangeEmailComponent.prototype.ngOnInit = function () {
	    };
	    SuperUserProfileChangeEmailComponent.prototype.ngDoCheck = function () {
	        this.userEmail.emit({
	            value: this.email
	        });
	    };
	    SuperUserProfileChangeEmailComponent.prototype.goBack = function () {
	        window.history.back();
	    };
	    __decorate([
	        core_1.Input('invalidEmail'), 
	        __metadata('design:type', Boolean)
	    ], SuperUserProfileChangeEmailComponent.prototype, "wrongEmailChange", void 0);
	    __decorate([
	        core_1.Input('invalidEmailLength'), 
	        __metadata('design:type', Boolean)
	    ], SuperUserProfileChangeEmailComponent.prototype, "wrongEmailLength", void 0);
	    __decorate([
	        core_1.Input('invalidEmailExists'), 
	        __metadata('design:type', Boolean)
	    ], SuperUserProfileChangeEmailComponent.prototype, "wrongEmailExists", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], SuperUserProfileChangeEmailComponent.prototype, "userEmail", void 0);
	    SuperUserProfileChangeEmailComponent = __decorate([
	        core_1.Component({
	            selector: 'profile-change-email',
	            template: __webpack_require__(135)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], SuperUserProfileChangeEmailComponent);
	    return SuperUserProfileChangeEmailComponent;
	}());
	exports.SuperUserProfileChangeEmailComponent = SuperUserProfileChangeEmailComponent;


/***/ },
/* 135 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <div class=\"form-group\">\n        <label for=\"userEmail\">{{ 'EMAIL' | translate }}</label>\n        <input type=\"text\" class=\"form-control\" id=\"userEmail\" [(ngModel)]=\"email\">        \n    </div>    \n    <div *ngIf=\"wrongEmailChange\" class=\"form-group\">\n        <span class=\"login-error-msg\">{{ 'WRONG_EMAIL' | translate }}</span>\n    </div>\n    <div *ngIf=\"wrongEmailLength\" class=\"form-group\">\n        <span class=\"login-error-msg\">{{ 'WRONG_EMAIL_LENGTH' | translate }}</span>\n    </div>\n    <div *ngIf=\"wrongEmailExists\" class=\"form-group\">\n        <span class=\"login-error-msg\">{{ 'WRONG_EMAIL_EXISTS' | translate }}</span>\n    </div>\n</div>";

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var SuperUserProfileChangeEmailPasswordComponent = (function () {
	    function SuperUserProfileChangeEmailPasswordComponent() {
	        this.userPassword = new core_1.EventEmitter();
	        this.passwordType = "password";
	        this.password = "";
	    }
	    SuperUserProfileChangeEmailPasswordComponent.prototype.ngOnInit = function () {
	    };
	    SuperUserProfileChangeEmailPasswordComponent.prototype.ngDoCheck = function () {
	        this.userPassword.emit({
	            value: this.password
	        });
	    };
	    SuperUserProfileChangeEmailPasswordComponent.prototype.onChange = function (flag) {
	        if (!flag) {
	            this.passwordType = "password";
	        }
	        else {
	            this.passwordType = "text";
	        }
	    };
	    SuperUserProfileChangeEmailPasswordComponent.prototype.goBack = function () {
	        window.history.back();
	    };
	    __decorate([
	        core_1.Input('invalidPasswordToChangeEmail'), 
	        __metadata('design:type', Boolean)
	    ], SuperUserProfileChangeEmailPasswordComponent.prototype, "wrongPassword", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], SuperUserProfileChangeEmailPasswordComponent.prototype, "userPassword", void 0);
	    SuperUserProfileChangeEmailPasswordComponent = __decorate([
	        core_1.Component({
	            selector: 'profile-change-email-password',
	            template: __webpack_require__(137)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], SuperUserProfileChangeEmailPasswordComponent);
	    return SuperUserProfileChangeEmailPasswordComponent;
	}());
	exports.SuperUserProfileChangeEmailPasswordComponent = SuperUserProfileChangeEmailPasswordComponent;


/***/ },
/* 137 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <div class=\"form-group\">\n        <label for=\"userPassword\">{{ 'PASSWORD' | translate }}</label>\n        <input [attr.type]=\"passwordType\" class=\"form-control\" id=\"userPassword\" [(ngModel)]=\"password\">\n        <input type=\"checkbox\" #cvPassword [checked]=\"false\" (change)=\"onChange(cvPassword.checked)\" id=\"viewPassword\"/>&nbsp;<label>{{ 'SHOW_PASSWORD' | translate }}</label>\n    </div>    \n    <div *ngIf=\"wrongPassword\" class=\"form-group\">\n        <span class=\"login-error-msg\">{{ 'WRONG_PASSWORD' | translate }}</span>\n    </div>\n</div>";

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var SuperUserProfileChangePasswordComponent = (function () {
	    function SuperUserProfileChangePasswordComponent() {
	        this.oldUserPassword = new core_1.EventEmitter();
	        this.newUserPassword = new core_1.EventEmitter();
	        this.newPasswordType = "password";
	        this.actualPassword = "";
	        this.newPassword = "";
	    }
	    SuperUserProfileChangePasswordComponent.prototype.ngOnInit = function () {
	    };
	    SuperUserProfileChangePasswordComponent.prototype.ngDoCheck = function () {
	        this.oldUserPassword.emit({
	            value: this.actualPassword
	        });
	        this.newUserPassword.emit({
	            value: this.newPassword
	        });
	    };
	    SuperUserProfileChangePasswordComponent.prototype.onChangeNew = function (flag) {
	        if (!flag) {
	            this.newPasswordType = "password";
	        }
	        else {
	            this.newPasswordType = "text";
	        }
	    };
	    SuperUserProfileChangePasswordComponent.prototype.goBack = function () {
	        window.history.back();
	    };
	    __decorate([
	        core_1.Input('is-wrong-password'), 
	        __metadata('design:type', Boolean)
	    ], SuperUserProfileChangePasswordComponent.prototype, "wrongPassword", void 0);
	    __decorate([
	        core_1.Input('isOldPasswordEmpty'), 
	        __metadata('design:type', Boolean)
	    ], SuperUserProfileChangePasswordComponent.prototype, "oldPasswordEmpty", void 0);
	    __decorate([
	        core_1.Input('isNewPasswordEmptyOrShort'), 
	        __metadata('design:type', Boolean)
	    ], SuperUserProfileChangePasswordComponent.prototype, "newPasswordEmptyOrShort", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], SuperUserProfileChangePasswordComponent.prototype, "oldUserPassword", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], SuperUserProfileChangePasswordComponent.prototype, "newUserPassword", void 0);
	    SuperUserProfileChangePasswordComponent = __decorate([
	        core_1.Component({
	            selector: 'profile-change-password',
	            template: __webpack_require__(139)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], SuperUserProfileChangePasswordComponent);
	    return SuperUserProfileChangePasswordComponent;
	}());
	exports.SuperUserProfileChangePasswordComponent = SuperUserProfileChangePasswordComponent;


/***/ },
/* 139 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <div class=\"form-group\">\n        <label for=\"actualUserPassword\">{{ 'ENTER_ACTUAL_PASSWORD' | translate }}</label>\n        <input type=\"password\" class=\"form-control\" id=\"actualUserPassword\" [(ngModel)]=\"actualPassword\">        \n    </div>\n    <div *ngIf=\"wrongPassword\" class=\"form-group\">\n        <span class=\"login-error-msg\">{{ 'WRONG_ACTUAL_PASSWORD' | translate }}</span>\n    </div>\n    <div *ngIf=\"oldPasswordEmpty\" class=\"form-group\">\n        <span class=\"login-error-msg\">{{ 'EMPTY_ACTUAL_PASSWORD' | translate }}</span>\n    </div>\n    <div class=\"form-group\">\n        <label for=\"newUserPassword\">{{ 'ENTER_NEW_PASSWORD' | translate }}</label>\n        <input [attr.type]=\"newPasswordType\" class=\"form-control\" id=\"newUserPassword\" [(ngModel)]=\"newPassword\">\n        <input type=\"checkbox\" #cvNew [checked]=\"false\" (change)=\"onChangeNew(cvNew.checked)\" id=\"viewNewPassword\"/>&nbsp;<label>{{ 'SHOW_PASSWORD' | translate }}</label>\n    </div>    \n    <div *ngIf=\"newPasswordEmptyOrShort\" class=\"form-group\">\n        <span class=\"login-error-msg\">{{ 'EMPTY_OR_SHORT_NEW_PASSWORD' | translate }}</span>\n    </div>\n</div>";

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var profile_service_1 = __webpack_require__(132);
	var SuperUserProfileChangeSubroleComponent = (function () {
	    function SuperUserProfileChangeSubroleComponent(_profileService) {
	        this._profileService = _profileService;
	        this.subroleUpdated = new core_1.EventEmitter();
	        this.paymentParams = {
	            "parameters": "",
	            "signature": "",
	            "signatureVersion": "",
	            "id": 0,
	            "code": "",
	            "amount": ""
	        };
	        this.accountType = 0;
	        this.paymentMethod = 0;
	        this.paymentPosted = false;
	        this.printMode = false;
	    }
	    SuperUserProfileChangeSubroleComponent.prototype.ngOnInit = function () {
	    };
	    SuperUserProfileChangeSubroleComponent.prototype.changeAccountType = function (type) {
	        this.accountType = type;
	    };
	    SuperUserProfileChangeSubroleComponent.prototype.submitPayment = function () {
	        if (this.paymentMethod == 1) {
	            this.paymentPosted = true;
	        }
	        else if (this.paymentMethod == 2) {
	        }
	        else {
	        }
	    };
	    SuperUserProfileChangeSubroleComponent.prototype.changePaymentMethod = function (method) {
	        var _this = this;
	        if (this.paymentMethod == 0) {
	            this._profileService.createTransaction(this.accountType, method).then(function (res) {
	                _this.paymentParams.parameters = res.PARAMS;
	                _this.paymentParams.signature = res.SIGNATURE;
	                _this.paymentParams.signatureVersion = res.VERSION;
	                _this.paymentParams.code = res.TRANSACTION_CODE;
	                _this.paymentParams.id = res.TRANSACTION_ID;
	                _this.paymentParams.amount = res.TRANSACTION_AMOUNT;
	                _this.paymentMethod = method;
	            });
	        }
	        else if (method == this.paymentMethod) { }
	        else {
	            this._profileService.updateTransaction(this.paymentParams.id, method).then(function (res) {
	                _this.paymentMethod = method;
	                _this.paymentPosted = false;
	            });
	        }
	    };
	    SuperUserProfileChangeSubroleComponent.prototype.printBankTransfer = function () {
	        this.printMode = !this.printMode;
	    };
	    SuperUserProfileChangeSubroleComponent.prototype.registerFree = function () {
	        var _this = this;
	        this._profileService.registerFree().subscribe(function (result) {
	            if (result == 1) {
	                _this.subroleUpdated.emit({
	                    value: true
	                });
	            }
	            else {
	                _this.subroleUpdated.emit({
	                    value: false
	                });
	            }
	        }, function () { });
	    };
	    SuperUserProfileChangeSubroleComponent.prototype.changeSubscription = function () {
	        this.accountType = 0;
	        this.paymentMethod = 0;
	        this.paymentPosted = false;
	    };
	    __decorate([
	        core_1.Input('subrole'), 
	        __metadata('design:type', Number)
	    ], SuperUserProfileChangeSubroleComponent.prototype, "userSubrole", void 0);
	    __decorate([
	        core_1.Output('subroleUpdated'), 
	        __metadata('design:type', Object)
	    ], SuperUserProfileChangeSubroleComponent.prototype, "subroleUpdated", void 0);
	    SuperUserProfileChangeSubroleComponent = __decorate([
	        core_1.Component({
	            selector: 'profile-change-subrole',
	            template: __webpack_require__(141),
	            providers: [profile_service_1.ProfileService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof profile_service_1.ProfileService !== 'undefined' && profile_service_1.ProfileService) === 'function' && _a) || Object])
	    ], SuperUserProfileChangeSubroleComponent);
	    return SuperUserProfileChangeSubroleComponent;
	    var _a;
	}());
	exports.SuperUserProfileChangeSubroleComponent = SuperUserProfileChangeSubroleComponent;


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"col-xs-12\" style=\"padding-right: 0em;\">\n    <div class=\"col-xs-12\" style=\"padding-right: 0em;\">\n        <div *ngIf=\"accountType==0\">\n            <div class=\"col-xs-12\" style=\"padding-bottom: 1.5em; padding-left: 0em; padding-right: 0em;\">\n                <div class=\"col-xs-12 col-md-12\" style=\"text-align: left; padding: 0; padding-top: 1em;\">\n                    <div class=\"col-xs-12\" style=\"padding: 0; padding-right: 0.33em;\">\n                        <div class=\"col-xs-12 account-type-header\">\n                            <h3>{{ 'FREE' | translate }}</h3>\n                        </div>\n                        <div class=\"col-xs-12 account-type-properties\">\n                            <div style=\"padding-top: 1em; padding-bottom: 1em;\">\n                                <h3 class=\"account-type-properties-h3-big\">{{ 'PRICE_0' | translate }}</h3>\n                            </div>\n                            <div><img src=\"" + __webpack_require__(142) + "\"><span>{{ 'PAYMENT_INFORMATION_1_1' | translate }}</span></div>\n                            <div><img src=\"" + __webpack_require__(142) + "\"><span style=\"color: #888888;\">{{ 'PAYMENT_INFORMATION_1_3_0' | translate }}</span></div>\n                            <div><img src=\"" + __webpack_require__(142) + "\" style=\"visibility: hidden\"><span style=\"color: #888888;\">{{ 'PAYMENT_INFORMATION_1_2' | translate }}</span></div>\n                            <div><img src=\"" + __webpack_require__(142) + "\" style=\"visibility: hidden\"><span style=\"color: #888888;\">{{ 'PAYMENT_INFORMATION_1_4' | translate }}</span></div>\n                            <div><img src=\"" + __webpack_require__(142) + "\" style=\"visibility: hidden\"><span style=\"color: #888888;\">{{ 'PAYMENT_INFORMATION_1_5' | translate }}</span></div>\n                            <div><img src=\"" + __webpack_require__(142) + "\" style=\"visibility: hidden\"><span style=\"color: #888888;\">{{ 'PAYMENT_INFORMATION_1_6' | translate }}</span></div>\n                            <button *ngIf=\"userSubrole != 8 && userSubrole != 9\" (click)=\"changeAccountType(3)\">{{ 'SELECT' | translate }}</button>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"col-xs-12 col-md-12\" style=\"text-align: left; padding: 0;  padding-top: 1em;\">\n                    <div class=\"col-xs-12\" style=\"padding: 0; padding-left: 0.33em; padding-right: 0.33em;\">\n                        <div class=\"col-xs-12 account-type-2-header\">\n                            <h3>{{ 'TRADITIONAL' | translate }}</h3>\n                        </div>\n                        <div class=\"col-xs-12 account-type-2-properties\">\n                            <div style=\"padding-top: 1em; padding-bottom: 1em;\">\n                                <h3 class=\"account-type-properties-h3-big\">{{ 'PRICE_1' | translate }}</h3>\n                                <h3 class=\"account-type-2-properties-h3-small\">{{ '/ YEAR' | translate }}</h3>\n                            </div>\n                            <div><img src=\"" + __webpack_require__(142) + "\"><span>{{ 'PAYMENT_INFORMATION_1_1' | translate }}</span></div>\n                            <div><img src=\"" + __webpack_require__(142) + "\"><span>{{ 'PAYMENT_INFORMATION_1_3_1' | translate }}</span></div>\n                            <div><img src=\"" + __webpack_require__(142) + "\"><span>{{ 'PAYMENT_INFORMATION_1_2' | translate }}</span></div>\n                            <div><img src=\"" + __webpack_require__(142) + "\"><span>{{ 'PAYMENT_INFORMATION_1_4' | translate }}</span></div>\n                            <div><img src=\"" + __webpack_require__(142) + "\" style=\"visibility: hidden\"><span style=\"color: #888888;\">{{ 'PAYMENT_INFORMATION_1_5' | translate }}</span></div>\n                            <div><img src=\"" + __webpack_require__(142) + "\" style=\"visibility: hidden\"><span style=\"color: #888888;\">{{ 'PAYMENT_INFORMATION_1_6' | translate }}</span></div>\n                            <button *ngIf=\"userSubrole != 4 && userSubrole != 2\" (click)=\"changeAccountType(1)\">{{ 'SELECT' | translate }}</button>\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"col-xs-12 col-md-12\" style=\"text-align: left; padding: 0; padding-top: 1em;\">\n                    <div class=\"col-xs-12\" style=\"padding: 0; padding-left: 0.33em; \">\n                        <div class=\"col-xs-12 account-type-3-header\">\n                            <h3>{{ 'PROFESIONAL' | translate }}</h3>\n                        </div>\n                        <div class=\"col-xs-12 account-type-3-properties\">\n                            <div style=\"padding-top: 1em; padding-bottom: 1em;\">\n                                <h3 class=\"account-type-properties-h3-big\">{{ 'PRICE_2' | translate }}</h3>\n                                <h3 class=\"account-type-3-properties-h3-small\">{{ '/ FOREVER' | translate }}</h3>\n                            </div>\n                            <div><img src=\"" + __webpack_require__(142) + "\"><span>{{ 'PAYMENT_INFORMATION_1_1' | translate }}</span></div>\n                            <div><img src=\"" + __webpack_require__(142) + "\"><span>{{ 'PAYMENT_INFORMATION_1_3_2' | translate }}</span></div>\n                            <div><img src=\"" + __webpack_require__(142) + "\"><span>{{ 'PAYMENT_INFORMATION_1_2' | translate }}</span></div>\n                            <div><img src=\"" + __webpack_require__(142) + "\"><span>{{ 'PAYMENT_INFORMATION_1_4' | translate }}</span></div>\n                            <div><img src=\"" + __webpack_require__(142) + "\"><span>{{ 'PAYMENT_INFORMATION_1_5' | translate }}</span></div>\n                            <div><img src=\"" + __webpack_require__(142) + "\"><span>{{ 'PAYMENT_INFORMATION_1_6' | translate }}</span></div>\n                            <button *ngIf=\"userSubrole != 1 && userSubrole != 3\" (click)=\"changeAccountType(2)\">{{ 'SELECT' | translate }}</button>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"col-xs-12\" *ngIf=\"accountType!=0 && accountType!=3\" style=\"padding-right: 0em;\">\n            <div class=\"col-xs-12\">\n                <p *ngIf=\"accountType==1\">{{ 'TRADITIONAL_SUBSCRIPTION' | translate }} {{ 'PRICE_1' | translate }}<a *ngIf=\"accountType==1\" (click)=\"changeSubscription()\">{{ 'CHANGE_SUBSCRIPTION' | translate }}</a></p>\n                <p *ngIf=\"accountType==2\">{{ 'PROFESSIONAL_SUBSCRIPTION' | translate }} {{ 'PRICE_2' | translate }}<a *ngIf=\"accountType==2\" (click)=\"changeSubscription()\">{{ 'CHANGE_SUBSCRIPTION' | translate }}</a></p>\n\n            </div>\n\n            <div *ngIf=\"!paymentPosted\" class=\"col-xs-12 col-md-12\" style=\"text-align: center\">\n                <img src=\"" + __webpack_require__(143) + "\" style=\"width: 14em;\" />\n                <div class=\"radio\">\n                    <label style=\"padding-left: 0.5em; font-size: 1.3em; color: #555555;\"> <input (change)=\"changePaymentMethod(1)\" type=\"radio\" name=\"role\" value=\"superuser\" />{{'BANK_TRANSFER' | translate}}</label>\n                </div>\n            </div>\n            <div *ngIf=\"!paymentPosted\" class=\"col-xs-12 col-md-12\" style=\"text-align: center\">\n                <img src=\"" + __webpack_require__(144) + "\" style=\"width: 14em;\" />\n                <div class=\"radio\">\n                    <label style=\"padding-left: 0.5em; font-size: 1.3em; color: #555555;\"> <input (change)=\"changePaymentMethod(2)\" type=\"radio\" name=\"role\" value=\"superuser\" />{{'CREDIT_CARD' | translate}}</label>\n                </div>\n            </div>\n            <div *ngIf=\"paymentMethod==1 && !paymentPosted\" class=\"col-xs-12\" style=\"padding-right: 0em;\">\n                <button (click)=\"submitPayment()\" class=\"start-button col-xs-12 col-md-2\" type=\"submit\">{{'DO_PAYMENT' | translate}}</button>\n            </div>\n            <div *ngIf=\"paymentMethod==2 && !paymentPosted\" class=\"col-xs-12\" style=\"padding-right: 0em;\">\n                <form ngNoForm action=\"https://sis.redsys.es/sis/realizarPago\" method=\"POST\" name=\"frm\" target=\"_blank\">\n                    <input name=\"Ds_MerchantParameters\" type=\"hidden\" value=\"{{paymentParams.parameters}}\" />\n                    <input name=\"Ds_Signature\" type=\"hidden\" value=\"{{paymentParams.signature}}\" />\n                    <input name=\"Ds_SignatureVersion\" type=\"hidden\" value=\"{{paymentParams.signatureVersion}}\" />\n                    <button class=\"start-button col-xs-12 col-md-2\" type=\"submit\">{{'DO_PAYMENT' | translate}}</button>\n                </form>\n            </div>\n            <div *ngIf=\"paymentMethod==1 && paymentPosted\" class=\"col-xs-12\" [ngClass]=\"{printMode: printMode}\">\n                <div id=\"bankTransfer\" class=\"bankTransfer col-xs-12 col-md-4\">\n                    <div *ngIf=\"!printMode\" style=\"text-align: right\"><span class=\"glyphicon glyphicon-print clickable\" (click)=\"printBankTransfer();\"></span></div>\n                    <span>{{'BANK_TRANSFER_INFO_1' | translate}}<b>{{'BANK' | translate}}</b> {{'BANK_TRANSFER_INFO_2' | translate}}  <b>{{'ENTERPRISE' | translate}} </b></span><br/>\n                    <span>{{'BANK_TRANSFER_INFO_3' | translate}}<b>{{'CC' | translate}}</b></span><br/>\n                    <span>{{'BANK_TRANSFER_INFO_4' | translate}}<b>{{'BANK_TRANSFER_CONCEPT' | translate}} {{paymentParams.code}}</b></span><br/>\n                    <span>{{'BANK_TRANSFER_INFO_5' | translate}}<b>{{paymentParams.amount}} {{'COIN' | translate}}</b></span><br/>\n                </div>\n                <div class=\"bankTransferInformation col-xs-12\">\n                    <span>{{'BANK_TRANSFER_INFO_6' | translate}}</span><br/>\n                    <span>{{'BANK_TRANSFER_INFO_7' | translate}}                         \n                        <a type=\"submit\" (click)=\"changePaymentMethod(2)\">{{'BANK_TRANSFER_INFO_8' | translate}}</a>                        \n                    </span>\n                </div>\n                <div *ngIf=\"printMode\" class=\"clickable col-xs-12\" (click)=\"printBankTransfer()\">\n                    << {{ 'BACK' | translate}} \n                </div>\n            </div>\n        </div>\n        <div *ngIf=\"accountType==3\">\n            <div class=\"col-xs-12\">\n                <p>{{ 'FREE_SUBSCRIPTION' | translate }} {{ 'PRICE_0' | translate }} <a (click)=\"changeSubscription()\">({{ 'CHANGE_SUBSCRIPTION' | translate }})</a></p>\n            </div>\n\n            <div class=\"col-xs-12\" style=\"padding-right: 0;\">\n                <button class=\"start-button col-xs-12 col-md-2\" (click)=\"registerFree()\">{{ 'VALIDATE_SUBSCRIPTION' | translate }}</button>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/tick.c45ab3d93a26e5f175e92bb56a4cfe0d.png";

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/bankTransfer.4ca378a1ca0f94e5baf65df86f06072e.png";

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/creditCard.fa70a0124a890de4035df9d55fa366bd.jpg";

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var ng2_completer_1 = __webpack_require__(61);
	var User_1 = __webpack_require__(146);
	var profile_service_1 = __webpack_require__(132);
	var cities_1 = __webpack_require__(119);
	var SuperUserProfileEditComponent = (function () {
	    function SuperUserProfileEditComponent(_profileService, _completerService) {
	        this._profileService = _profileService;
	        this._completerService = _completerService;
	        this.submitProfile = new core_1.EventEmitter();
	        this.nameWrong = new core_1.EventEmitter();
	        this.nifWrong = new core_1.EventEmitter();
	        this.phoneWrong = new core_1.EventEmitter();
	        this.cityWrong = new core_1.EventEmitter();
	        this.addressWrong = new core_1.EventEmitter();
	        this.zipWrong = new core_1.EventEmitter();
	        this.dataService = this._completerService.local(cities_1.CITIES, 'name', 'name');
	    }
	    SuperUserProfileEditComponent.prototype.ngOnInit = function () {
	        this.copyUser(this.user);
	    };
	    SuperUserProfileEditComponent.prototype.ngDoCheck = function () {
	        if (!this.userEquals(this.user, this.previousUser)) {
	            // inputSettings changed
	            // some logic here to react to the change
	            this.copyUser(this.user);
	            this.submitProfile.emit({
	                value: this.user
	            });
	        }
	        this.nameWrong.emit({
	            value: this.user.name
	        });
	        this.nifWrong.emit({
	            value: this.user.nif
	        });
	        this.phoneWrong.emit({
	            value: this.user.phone
	        });
	        this.cityWrong.emit({
	            value: this.user.city_name
	        });
	        this.addressWrong.emit({
	            value: this.user.address
	        });
	        this.zipWrong.emit({
	            value: this.user.zip
	        });
	    };
	    SuperUserProfileEditComponent.prototype.goBack = function () {
	        window.history.back();
	    };
	    SuperUserProfileEditComponent.prototype.onCitySelected = function (selected) {
	    };
	    SuperUserProfileEditComponent.prototype.copyUser = function (user) {
	        this.previousUser = Object.assign({}, this.user);
	        /* this.previousUser.id = user.id;
	         this.previousUser.name = user.name;
	         this.previousUser.nif = user.nif;
	         this.previousUser.phone = user.phone;*/
	    };
	    SuperUserProfileEditComponent.prototype.userEquals = function (user1, user2) {
	        return user1.email == user2.email &&
	            user1.name == user2.name &&
	            user1.nif == user2.nif &&
	            user1.phone == user2.phone;
	    };
	    __decorate([
	        core_1.Input('profile-obj'), 
	        __metadata('design:type', (typeof (_a = typeof User_1.User !== 'undefined' && User_1.User) === 'function' && _a) || Object)
	    ], SuperUserProfileEditComponent.prototype, "user", void 0);
	    __decorate([
	        core_1.Input('isNameWrong'), 
	        __metadata('design:type', Boolean)
	    ], SuperUserProfileEditComponent.prototype, "isNameWrong", void 0);
	    __decorate([
	        core_1.Input('isNifWrong'), 
	        __metadata('design:type', Boolean)
	    ], SuperUserProfileEditComponent.prototype, "isNifWrong", void 0);
	    __decorate([
	        core_1.Input('isPhoneWrong'), 
	        __metadata('design:type', Boolean)
	    ], SuperUserProfileEditComponent.prototype, "isPhoneWrong", void 0);
	    __decorate([
	        core_1.Input('isCityWrong'), 
	        __metadata('design:type', Boolean)
	    ], SuperUserProfileEditComponent.prototype, "isCityWrong", void 0);
	    __decorate([
	        core_1.Input('isAddressWrong'), 
	        __metadata('design:type', Boolean)
	    ], SuperUserProfileEditComponent.prototype, "isAddressWrong", void 0);
	    __decorate([
	        core_1.Input('isZipWrong'), 
	        __metadata('design:type', Boolean)
	    ], SuperUserProfileEditComponent.prototype, "isZipWrong", void 0);
	    __decorate([
	        core_1.Output('submit-profile'), 
	        __metadata('design:type', Object)
	    ], SuperUserProfileEditComponent.prototype, "submitProfile", void 0);
	    __decorate([
	        core_1.Output('nameWrong'), 
	        __metadata('design:type', Object)
	    ], SuperUserProfileEditComponent.prototype, "nameWrong", void 0);
	    __decorate([
	        core_1.Output('nifWrong'), 
	        __metadata('design:type', Object)
	    ], SuperUserProfileEditComponent.prototype, "nifWrong", void 0);
	    __decorate([
	        core_1.Output('phoneWrong'), 
	        __metadata('design:type', Object)
	    ], SuperUserProfileEditComponent.prototype, "phoneWrong", void 0);
	    __decorate([
	        core_1.Output('cityWrong'), 
	        __metadata('design:type', Object)
	    ], SuperUserProfileEditComponent.prototype, "cityWrong", void 0);
	    __decorate([
	        core_1.Output('addressWrong'), 
	        __metadata('design:type', Object)
	    ], SuperUserProfileEditComponent.prototype, "addressWrong", void 0);
	    __decorate([
	        core_1.Output('zipWrong'), 
	        __metadata('design:type', Object)
	    ], SuperUserProfileEditComponent.prototype, "zipWrong", void 0);
	    SuperUserProfileEditComponent = __decorate([
	        core_1.Component({
	            selector: 'profile-edit',
	            template: __webpack_require__(147),
	            providers: [profile_service_1.ProfileService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof profile_service_1.ProfileService !== 'undefined' && profile_service_1.ProfileService) === 'function' && _b) || Object, (typeof (_c = typeof ng2_completer_1.CompleterService !== 'undefined' && ng2_completer_1.CompleterService) === 'function' && _c) || Object])
	    ], SuperUserProfileEditComponent);
	    return SuperUserProfileEditComponent;
	    var _a, _b, _c;
	}());
	exports.SuperUserProfileEditComponent = SuperUserProfileEditComponent;


/***/ },
/* 146 */
/***/ function(module, exports) {

	"use strict";


/***/ },
/* 147 */
/***/ function(module, exports) {

	module.exports = "<div *ngIf=\"user\">\n    <div class=\"form-group\">\n        <label for=\"userName\">{{ 'USER_NAME' | translate }}</label>\n        <input type=\"text\" class=\"form-control\" id=\"userName\" [(ngModel)]=\"user.name\" (ngModelChange)=\"user.name\">\n    </div>    \n    <div *ngIf=\"isNameWrong\" class=\"form-group\">\n        <span class=\"login-error-msg\">{{ 'WRONG_NAME' | translate }}</span>\n    </div>\n    <div class=\"form-group\">\n        <label for=\"userNif\">{{ 'DNI' | translate }}</label>\n        <input type=\"text\" class=\"form-control\" id=\"userNif\" [(ngModel)]=\"user.nif\" (ngModelChange)=\"user.nif\">\n    </div>\n    <div *ngIf=\"isNifWrong\" class=\"form-group\">\n        <span class=\"login-error-msg\">{{ 'WRONG_NIF' | translate }}</span>\n    </div>\n    <div class=\"form-group\">\n        <label for=\"userPhone\">{{ 'PHONE' | translate }}</label>\n        <input type=\"text\" class=\"form-control\" id=\"userPhone\" [(ngModel)]=\"user.phone\" (ngModelChange)=\"user.phone\">\n    </div>\n    <div *ngIf=\"isPhoneWrong\" class=\"form-group\">\n        <span class=\"login-error-msg\">{{ 'WRONG_PHONE' | translate }}</span>\n    </div>\n    <div class=\"form-group\">\n        <label for=\"userCity\">{{ 'CITY_FIELD' | translate }}</label>\n        <ng2-completer [(ngModel)]=\"user.city_name\" [datasource]=\"dataService\" [minSearchLength]=\"2\"></ng2-completer>`\n        <!--<ng2-completer [(ngModel)]=\"user.city_name\" (ngModelChange)=\"user.city_name\" [ngModelOptions]=\"{standalone: true}\" [dataService]=\"dataService\" (selected)=\"onCitySelected($event)\"\n                            [minSearchLength]=\"2\" [placeholder]=\"('CITY_FIELD' | translate)\" [textNoResults]=\"('CITY_NOT_FOUND' | translate)\" [autoMatch]=\"true\"></ng2-completer>-->\n        <!--<input type=\"text\" class=\"form-control\" id=\"userCity\" [(ngModel)]=\"user.city_name\" (ngModelChange)=\"user.city_name\">-->\n    </div>\n    <div *ngIf=\"isCityWrong\" class=\"form-group\">\n        <span class=\"login-error-msg\">{{ 'WRONG_CITY' | translate }}</span>\n    </div>\n    <div class=\"form-group\">\n        <label for=\"userAddress\">{{ 'ADDRESS_FIELD' | translate }}</label>\n        <input type=\"text\" class=\"form-control\" id=\"userAddress\" [(ngModel)]=\"user.address\" (ngModelChange)=\"user.address\">\n    </div>\n    <div *ngIf=\"isAddressWrong\" class=\"form-group\">\n        <span class=\"login-error-msg\">{{ 'WRONG_ADDRESS' | translate }}</span>\n    </div>\n    <div class=\"form-group\">\n        <label for=\"userZip\">{{ 'ZIP_FIELD' | translate }}</label>\n        <input type=\"text\" class=\"form-control\" id=\"userZip\" [(ngModel)]=\"user.zip\" (ngModelChange)=\"user.zip\">\n    </div>\n    <div *ngIf=\"isZipWrong\" class=\"form-group\">\n        <span class=\"login-error-msg\">{{ 'WRONG_ZIP' | translate }}</span>\n    </div>\n</div>";

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(76);
	var notifications_service_1 = __webpack_require__(149);
	var SuperUserNotificationsComponent = (function () {
	    function SuperUserNotificationsComponent(_notificationsService, route) {
	        this._notificationsService = _notificationsService;
	        this.route = route;
	        this.notificationSelected = Number(route.snapshot.params['notificationId']);
	    }
	    SuperUserNotificationsComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._notificationsService.getNotifications().then(function (res) {
	            if (res != null) {
	                _this.notifications = res;
	                _this.setNotificationsDateFormat();
	            }
	        });
	    };
	    SuperUserNotificationsComponent.prototype.setNotificationsDateFormat = function () {
	        for (var i = 0; i < this.notifications.length; i++) {
	            var date;
	            date = this.notifications[i].creation_date;
	            date = date.substr(0, 10);
	            date = date.substr(8, 2) + "/" + date.substr(5, 2) + "/" + date.substr(0, 4);
	            this.notifications[i].creation_date = date;
	        }
	    };
	    SuperUserNotificationsComponent.prototype.notificationSelect = function (notification) {
	        if (notification.id != this.notificationSelected)
	            this.notificationSelected = notification.id;
	        else
	            this.notificationSelected = 0;
	    };
	    SuperUserNotificationsComponent.prototype.isSelected = function (notification) {
	        return notification.id == this.notificationSelected;
	    };
	    SuperUserNotificationsComponent.prototype.getColor = function (notification) {
	        if (notification.id == this.notificationSelected) {
	            return "#97D685";
	        }
	        else {
	            return "white";
	        }
	    };
	    SuperUserNotificationsComponent = __decorate([
	        core_1.Component({
	            selector: 'notifications',
	            template: __webpack_require__(150),
	            providers: [notifications_service_1.NotificationsService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof notifications_service_1.NotificationsService !== 'undefined' && notifications_service_1.NotificationsService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _b) || Object])
	    ], SuperUserNotificationsComponent);
	    return SuperUserNotificationsComponent;
	    var _a, _b;
	}());
	exports.SuperUserNotificationsComponent = SuperUserNotificationsComponent;


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(30);
	var Observable_1 = __webpack_require__(5);
	var json = __webpack_require__(95);
	var NotificationsService = (function () {
	    function NotificationsService(http) {
	        this.http = http;
	        this._notificationsUrl = '/notificationData/actives';
	        this.serverURL = json.api_url;
	    }
	    NotificationsService.prototype.getNotifications = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.get(this.serverURL + this._notificationsUrl, options).toPromise().then(function (res) {
	            if (JSON.parse(res.text()).code == 1) {
	                return JSON.parse(res.text()).rows;
	            }
	            else {
	                return null;
	            }
	        }, this.handleError);
	    };
	    NotificationsService.prototype.handleError = function (error) {
	        // In a real world app, we might use a remote logging infrastructure
	        // We'd also dig deeper into the error to get a better message
	        var errMsg = (error.message) ? error.message :
	            error.status ? error.status + " - " + error.statusText : 'Server error';
	        console.error(errMsg); // log to console instead
	        return Observable_1.Observable.throw(errMsg);
	    };
	    NotificationsService.prototype.serializeObj = function (obj) {
	        var result = [];
	        for (var property in obj)
	            result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));
	        return result.join("&");
	    };
	    NotificationsService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], NotificationsService);
	    return NotificationsService;
	    var _a;
	}());
	exports.NotificationsService = NotificationsService;


/***/ },
/* 150 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-sm-9 col-sm-offset-3 col-md-9 col-md-offset-2 main\">\n        <div *ngFor=\"let notification of notifications\" class=\"col-xs-12 clickable\" style=\"border-bottom: 1px solid #dddddd; border-top: 1px solid #dddddd;\" (click)=\"notificationSelect(notification)\"  [ngClass]=\"{selectedNotification: isSelected(notification)}\">            \n            <div class=\"col-xs-12 clickable\" *ngIf=\"!isSelected(notification)\">            \n                <label style=\"float:left; font-weight: 600; color: #333333\" class=\"clickable\">{{notification.title}}</label>\n                <label style=\"float:right;  font-weight: 100; color: #333333\" class=\"clickable\">{{notification.creation_date}}</label>                                \n            </div>\n            <div class=\"col-xs-12 clickable\" *ngIf=\"isSelected(notification)\">            \n                <label style=\"font-weight: 600; color: #333333; font-size: 1.2em;\" class=\"clickable col-xs-12\">{{notification.title}}</label>\n                <label style=\"font-weight: 100; color: #333333; font-size: 0.9em;\" class=\"clickable col-xs-12\">{{notification.creation_date}}</label>                                \n            </div>\n            <div class=\"col-xs-12 clickable\">\n                <label class=\"clickable\" style=\"font-weight: 100; color: #333333\" *ngIf=\"!isSelected(notification)\">{{notification.short_text}}</label>\n                <label class=\"clickable col-xs-12\" style=\"font-weight: 100; padding-top: 1em; color: #333333\" *ngIf=\"isSelected(notification)\">{{notification.long_text}}</label>                \n            </div>                                    \n        </div>\n    </div>\n</div>";

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(76);
	var favorites_service_1 = __webpack_require__(152);
	var SuperUserFavoritesComponent = (function () {
	    function SuperUserFavoritesComponent(_favoritesService, _parentRouter) {
	        this._favoritesService = _favoritesService;
	        this.router = _parentRouter;
	    }
	    SuperUserFavoritesComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._favoritesService.getFavoritesSellersByUser().then(function (result) {
	            _this.sellers = result;
	        });
	        this._favoritesService.getFavoritesArtisansByUser().then(function (result) {
	            _this.artisans = result;
	        });
	    };
	    SuperUserFavoritesComponent.prototype.backClicked = function () {
	        window.history.back();
	    };
	    SuperUserFavoritesComponent = __decorate([
	        core_1.Component({
	            selector: 'favorites',
	            providers: [favorites_service_1.FavoritesService],
	            template: __webpack_require__(153),
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof favorites_service_1.FavoritesService !== 'undefined' && favorites_service_1.FavoritesService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object])
	    ], SuperUserFavoritesComponent);
	    return SuperUserFavoritesComponent;
	    var _a, _b;
	}());
	exports.SuperUserFavoritesComponent = SuperUserFavoritesComponent;


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(30);
	var Observable_1 = __webpack_require__(5);
	var json = __webpack_require__(95);
	var FavoritesService = (function () {
	    function FavoritesService(http) {
	        this.http = http;
	        this._favoritesUrl = '/favoritesData';
	        this.serverURL = json.api_url;
	    }
	    FavoritesService.prototype.getFavoritesSellersByUser = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.get(this.serverURL + this._favoritesUrl + "/sellers", options).toPromise().then(function (res) {
	            if (JSON.parse(res.text()).code == 1) {
	                return JSON.parse(res.text()).rows;
	            }
	            else {
	                return null;
	            }
	        }, this.handleError);
	    };
	    FavoritesService.prototype.getFavoritesArtisansByUser = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.get(this.serverURL + this._favoritesUrl + "/artesans", options).toPromise().then(function (res) {
	            if (JSON.parse(res.text()).code == 1) {
	                return JSON.parse(res.text()).rows;
	            }
	            else {
	                return null;
	            }
	        }, this.handleError);
	    };
	    FavoritesService.prototype.handleError = function (error) {
	        console.error(error);
	        return Observable_1.Observable.throw(error.json().error || 'Server error');
	    };
	    FavoritesService.prototype.serializeObj = function (obj) {
	        var result = [];
	        for (var property in obj)
	            result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));
	        return result.join("&");
	    };
	    FavoritesService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], FavoritesService);
	    return FavoritesService;
	    var _a;
	}());
	exports.FavoritesService = FavoritesService;


/***/ },
/* 153 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-xs-12 col-sm-9 col-sm-offset-3 col-md-9 col-md-offset-2 main\">        \n                <div class=\"col-xs-12\">\n                    <div class=\"col-xs-6\">\n                        <!--<button class=\"selectedButton\">{{'SEND'|translate}}</button>-->\n                        <!--<button [ngClass]=\"selectedButton\" (click)=\"backClicked()\">{{'BACK'|translate}}</button>-->\n                        \n                    </div>\n                    <div class=\"col-xs-6\" style=\"text-align: right\">\n                        \n                    </div>\n                </div>\n            <!--Venedors-->\n            <div class=\"col-xs-12 col-md-12\" style=\" padding-bottom: 2em;\">\n                <div class=\"messageBlockHead col-xs-12\" style=\"padding: 0;\">\n                        <div class=\"messageBlockHeadColor col-xs-6 col-xs-offset-6\">\n                            <h4 class=\"messageBlockHeadColorTitle\" style=\"display: inline; font-size: 1.2em;\">{{ 'SELLERS' | translate }}</h4>\n                        </div>\n                    </div>\n                    <div *ngFor=\"let seller of sellers\" class=\"col-xs-12 messageBlockBody clickable\" style=\"padding: 0;\" [routerLink]=\"['/main', 'elementdetail',  { categoryType: null, sellerType: null, citiesFilter: null, tagsFilter: null, elementId: seller.id, scroll: null, scrollHeight: null, loadedPage: null }]\">\n                        <div class=\"col-xs-12\" style=\"padding-left: 3em;\">\n                            <div style=\"float: left; padding-right: 1em;\">\n                                <label class=\"messageBlockLabelNormal\" style=\"padding-right: 1.3em\">{{seller.id_visible}}</label>\n                                <label class=\"messageBlockLabelHigh\">{{seller.comercial_name}}</label>\n                            </div>\n                            <div style=\"float: left\" *ngIf=\"seller.description\">\n                                <label class=\"messageBlockLabelNormal\" *ngIf=\"seller.description.length > 50\">{{seller.description.substr(0,50)}}...</label>\n                                <label class=\"messageBlockLabelNormal\" *ngIf=\"seller.description.length <= 50\">{{seller.description}}</label>\n                            </div>\n\n                        </div>\n                    </div>\n            </div>\n            <!--artisans-->    \n            <div class=\"col-xs-12 col-md-12\">\n                <div class=\"messageBlockHead col-xs-12\" style=\"padding: 0;\">\n                        <div class=\"messageBlockHeadColor col-xs-6 col-xs-offset-6\">\n                            <h4 class=\"messageBlockHeadColorTitle\" style=\"display: inline; font-size: 1.2em;\">{{ 'ARTISANS' | translate }}</h4>\n                        </div>\n                    </div>\n                    <div *ngFor=\"let artisan of artisans\" class=\"col-xs-12 messageBlockBody clickable\" style=\"padding: 0;\" [routerLink]=\"['/main', 'elementdetail',  { categoryType: null, sellerType: null, citiesFilter: null, tagsFilter: null, elementId: artisan.id, scroll: null, scrollHeight: null, loadedPage: null }]\">\n                        <div class=\"col-xs-12\" style=\"padding-left: 3em;\">\n                            <div style=\"float: left; padding-right: 1em;\">\n                                <label class=\"messageBlockLabelNormal\" style=\"padding-right: 1.3em\">{{artisan.id_visible}}</label>\n                                <label class=\"messageBlockLabelHigh\">{{artisan.comercial_name}}</label>\n                            </div>\n                            <div style=\"float: left\" *ngIf=\"artisan.description\">\n                                <label class=\"messageBlockLabelNormal\" *ngIf=\"artisan.description.length > 50\">{{artisan.description.substr(0,50)}}...</label>\n                                <label class=\"messageBlockLabelNormal\" *ngIf=\"artisan.description.length <= 50\">{{artisan.description}}</label>\n                            </div>\n                        </div>\n                </div>\n            </div>         \n    </div>\n</div>";

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	// main modules
	__export(__webpack_require__(155));
	__export(__webpack_require__(172));
	// Google Maps types
	// core module
	// we explicitly export the module here to prevent this Ionic 2 bug:
	// http://stevemichelotti.com/integrate-angular-2-google-maps-into-ionic-2/
	var core_module_1 = __webpack_require__(176);
	exports.AgmCoreModule = core_module_1.AgmCoreModule;
	//# sourceMappingURL=index.js.map

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var google_map_1 = __webpack_require__(156);
	exports.SebmGoogleMap = google_map_1.SebmGoogleMap;
	var google_map_circle_1 = __webpack_require__(165);
	exports.SebmGoogleMapCircle = google_map_circle_1.SebmGoogleMapCircle;
	var google_map_info_window_1 = __webpack_require__(166);
	exports.SebmGoogleMapInfoWindow = google_map_info_window_1.SebmGoogleMapInfoWindow;
	var google_map_kml_layer_1 = __webpack_require__(167);
	exports.SebmGoogleMapKmlLayer = google_map_kml_layer_1.SebmGoogleMapKmlLayer;
	var google_map_marker_1 = __webpack_require__(168);
	exports.SebmGoogleMapMarker = google_map_marker_1.SebmGoogleMapMarker;
	var google_map_polygon_1 = __webpack_require__(169);
	exports.SebmGoogleMapPolygon = google_map_polygon_1.SebmGoogleMapPolygon;
	var google_map_polyline_1 = __webpack_require__(170);
	exports.SebmGoogleMapPolyline = google_map_polyline_1.SebmGoogleMapPolyline;
	var google_map_polyline_point_1 = __webpack_require__(171);
	exports.SebmGoogleMapPolylinePoint = google_map_polyline_point_1.SebmGoogleMapPolylinePoint;
	//# sourceMappingURL=directives.js.map

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var google_maps_api_wrapper_1 = __webpack_require__(157);
	var circle_manager_1 = __webpack_require__(159);
	var info_window_manager_1 = __webpack_require__(160);
	var marker_manager_1 = __webpack_require__(161);
	var polygon_manager_1 = __webpack_require__(162);
	var polyline_manager_1 = __webpack_require__(163);
	var kml_layer_manager_1 = __webpack_require__(164);
	/**
	 * SebMGoogleMap renders a Google Map.
	 * **Important note**: To be able see a map in the browser, you have to define a height for the CSS
	 * class `sebm-google-map-container`.
	 *
	 * ### Example
	 * ```typescript
	 * import { Component } from '@angular/core';
	 * import { SebmGoogleMap } from 'angular2-google-maps/core';
	 *
	 * @Component({
	 *  selector: 'my-map-cmp',
	 *  directives: [SebmGoogleMap],
	 *  styles: [`
	 *    .sebm-google-map-container {
	 *      height: 300px;
	 *    }
	 * `],
	 *  template: `
	 *    <sebm-google-map [latitude]="lat" [longitude]="lng" [zoom]="zoom">
	 *    </sebm-google-map>
	 *  `
	 * })
	 * ```
	 */
	var SebmGoogleMap = (function () {
	    function SebmGoogleMap(_elem, _mapsWrapper) {
	        this._elem = _elem;
	        this._mapsWrapper = _mapsWrapper;
	        /**
	         * The longitude that defines the center of the map.
	         */
	        this.longitude = 0;
	        /**
	         * The latitude that defines the center of the map.
	         */
	        this.latitude = 0;
	        /**
	         * The zoom level of the map. The default zoom level is 8.
	         */
	        this.zoom = 8;
	        /**
	         * Enables/disables if map is draggable.
	         */
	        this.draggable = true;
	        /**
	         * Enables/disables zoom and center on double click. Enabled by default.
	         */
	        this.disableDoubleClickZoom = false;
	        /**
	         * Enables/disables all default UI of the Google map. Please note: When the map is created, this
	         * value cannot get updated.
	         */
	        this.disableDefaultUI = false;
	        /**
	         * If false, disables scrollwheel zooming on the map. The scrollwheel is enabled by default.
	         */
	        this.scrollwheel = true;
	        /**
	         * If false, prevents the map from being controlled by the keyboard. Keyboard shortcuts are
	         * enabled by default.
	         */
	        this.keyboardShortcuts = true;
	        /**
	         * The enabled/disabled state of the Zoom control.
	         */
	        this.zoomControl = true;
	        /**
	         * Styles to apply to each of the default map types. Note that for Satellite/Hybrid and Terrain
	         * modes, these styles will only apply to labels and geometry.
	         */
	        this.styles = [];
	        /**
	         * When true and the latitude and/or longitude values changes, the Google Maps panTo method is
	         * used to
	         * center the map. See: https://developers.google.com/maps/documentation/javascript/reference#Map
	         */
	        this.usePanning = false;
	        /**
	         * The initial enabled/disabled state of the Street View Pegman control.
	         * This control is part of the default UI, and should be set to false when displaying a map type
	         * on which the Street View road overlay should not appear (e.g. a non-Earth map type).
	         */
	        this.streetViewControl = true;
	        /**
	         * Sets the viewport to contain the given bounds.
	         */
	        this.fitBounds = null;
	        /**
	         * The initial enabled/disabled state of the Scale control. This is disabled by default.
	         */
	        this.scaleControl = false;
	        /**
	         * The initial enabled/disabled state of the Map type control.
	         */
	        this.mapTypeControl = false;
	        this._observableSubscriptions = [];
	        /**
	         * This event emitter gets emitted when the user clicks on the map (but not when they click on a
	         * marker or infoWindow).
	         */
	        this.mapClick = new core_1.EventEmitter();
	        /**
	         * This event emitter gets emitted when the user right-clicks on the map (but not when they click
	         * on a marker or infoWindow).
	         */
	        this.mapRightClick = new core_1.EventEmitter();
	        /**
	         * This event emitter gets emitted when the user double-clicks on the map (but not when they click
	         * on a marker or infoWindow).
	         */
	        this.mapDblClick = new core_1.EventEmitter();
	        /**
	         * This event emitter is fired when the map center changes.
	         */
	        this.centerChange = new core_1.EventEmitter();
	        /**
	         * This event is fired when the viewport bounds have changed.
	         */
	        this.boundsChange = new core_1.EventEmitter();
	        /**
	         * This event is fired when the map becomes idle after panning or zooming.
	         */
	        this.idle = new core_1.EventEmitter();
	        /**
	         * This event is fired when the zoom level has changed.
	         */
	        this.zoomChange = new core_1.EventEmitter();
	    }
	    /** @internal */
	    SebmGoogleMap.prototype.ngOnInit = function () {
	        // todo: this should be solved with a new component and a viewChild decorator
	        var container = this._elem.nativeElement.querySelector('.sebm-google-map-container-inner');
	        this._initMapInstance(container);
	    };
	    SebmGoogleMap.prototype._initMapInstance = function (el) {
	        this._mapsWrapper.createMap(el, {
	            center: { lat: this.latitude || 0, lng: this.longitude || 0 },
	            zoom: this.zoom,
	            minZoom: this.minZoom,
	            maxZoom: this.maxZoom,
	            disableDefaultUI: this.disableDefaultUI,
	            backgroundColor: this.backgroundColor,
	            draggable: this.draggable,
	            draggableCursor: this.draggableCursor,
	            draggingCursor: this.draggingCursor,
	            keyboardShortcuts: this.keyboardShortcuts,
	            zoomControl: this.zoomControl,
	            styles: this.styles,
	            streetViewControl: this.streetViewControl,
	            scaleControl: this.scaleControl,
	            mapTypeControl: this.mapTypeControl
	        });
	        // register event listeners
	        this._handleMapCenterChange();
	        this._handleMapZoomChange();
	        this._handleMapMouseEvents();
	        this._handleBoundsChange();
	        this._handleIdleEvent();
	    };
	    /** @internal */
	    SebmGoogleMap.prototype.ngOnDestroy = function () {
	        // unsubscribe all registered observable subscriptions
	        this._observableSubscriptions.forEach(function (s) { return s.unsubscribe(); });
	    };
	    /* @internal */
	    SebmGoogleMap.prototype.ngOnChanges = function (changes) {
	        this._updateMapOptionsChanges(changes);
	        this._updatePosition(changes);
	    };
	    SebmGoogleMap.prototype._updateMapOptionsChanges = function (changes) {
	        var options = {};
	        var optionKeys = Object.keys(changes).filter(function (k) { return SebmGoogleMap._mapOptionsAttributes.indexOf(k) !== -1; });
	        optionKeys.forEach(function (k) { options[k] = changes[k].currentValue; });
	        this._mapsWrapper.setMapOptions(options);
	    };
	    /**
	     * Triggers a resize event on the google map instance.
	     * Returns a promise that gets resolved after the event was triggered.
	     */
	    SebmGoogleMap.prototype.triggerResize = function () {
	        var _this = this;
	        // Note: When we would trigger the resize event and show the map in the same turn (which is a
	        // common case for triggering a resize event), then the resize event would not
	        // work (to show the map), so we trigger the event in a timeout.
	        return new Promise(function (resolve) {
	            setTimeout(function () { return _this._mapsWrapper.triggerMapEvent('resize').then(function () { return resolve(); }); });
	        });
	    };
	    SebmGoogleMap.prototype._updatePosition = function (changes) {
	        if (changes['latitude'] == null && changes['longitude'] == null &&
	            changes['fitBounds'] == null) {
	            // no position update needed
	            return;
	        }
	        // we prefer fitBounds in changes
	        if (changes['fitBounds'] && this.fitBounds != null) {
	            this._fitBounds();
	            return;
	        }
	        if (typeof this.latitude !== 'number' || typeof this.longitude !== 'number') {
	            return;
	        }
	        var newCenter = {
	            lat: this.latitude,
	            lng: this.longitude,
	        };
	        if (this.usePanning) {
	            this._mapsWrapper.panTo(newCenter);
	        }
	        else {
	            this._mapsWrapper.setCenter(newCenter);
	        }
	    };
	    SebmGoogleMap.prototype._fitBounds = function () {
	        if (this.usePanning) {
	            this._mapsWrapper.panToBounds(this.fitBounds);
	            return;
	        }
	        this._mapsWrapper.fitBounds(this.fitBounds);
	    };
	    SebmGoogleMap.prototype._handleMapCenterChange = function () {
	        var _this = this;
	        var s = this._mapsWrapper.subscribeToMapEvent('center_changed').subscribe(function () {
	            _this._mapsWrapper.getCenter().then(function (center) {
	                _this.latitude = center.lat();
	                _this.longitude = center.lng();
	                _this.centerChange.emit({ lat: _this.latitude, lng: _this.longitude });
	            });
	        });
	        this._observableSubscriptions.push(s);
	    };
	    SebmGoogleMap.prototype._handleBoundsChange = function () {
	        var _this = this;
	        var s = this._mapsWrapper.subscribeToMapEvent('bounds_changed').subscribe(function () {
	            _this._mapsWrapper.getBounds().then(function (bounds) { _this.boundsChange.emit(bounds); });
	        });
	        this._observableSubscriptions.push(s);
	    };
	    SebmGoogleMap.prototype._handleMapZoomChange = function () {
	        var _this = this;
	        var s = this._mapsWrapper.subscribeToMapEvent('zoom_changed').subscribe(function () {
	            _this._mapsWrapper.getZoom().then(function (z) {
	                _this.zoom = z;
	                _this.zoomChange.emit(z);
	            });
	        });
	        this._observableSubscriptions.push(s);
	    };
	    SebmGoogleMap.prototype._handleIdleEvent = function () {
	        var _this = this;
	        var s = this._mapsWrapper.subscribeToMapEvent('idle').subscribe(function () { _this.idle.emit(void 0); });
	        this._observableSubscriptions.push(s);
	    };
	    SebmGoogleMap.prototype._handleMapMouseEvents = function () {
	        var _this = this;
	        var events = [
	            { name: 'click', emitter: this.mapClick },
	            { name: 'rightclick', emitter: this.mapRightClick },
	        ];
	        events.forEach(function (e) {
	            var s = _this._mapsWrapper.subscribeToMapEvent(e.name).subscribe(function (event) {
	                var value = { coords: { lat: event.latLng.lat(), lng: event.latLng.lng() } };
	                e.emitter.emit(value);
	            });
	            _this._observableSubscriptions.push(s);
	        });
	    };
	    /**
	     * Map option attributes that can change over time
	     */
	    SebmGoogleMap._mapOptionsAttributes = [
	        'disableDoubleClickZoom', 'scrollwheel', 'draggable', 'draggableCursor', 'draggingCursor',
	        'keyboardShortcuts', 'zoomControl', 'styles', 'streetViewControl', 'zoom', 'mapTypeControl',
	        'minZoom', 'maxZoom'
	    ];
	    SebmGoogleMap.decorators = [
	        { type: core_1.Component, args: [{
	                    selector: 'sebm-google-map',
	                    providers: [
	                        google_maps_api_wrapper_1.GoogleMapsAPIWrapper, marker_manager_1.MarkerManager, info_window_manager_1.InfoWindowManager, circle_manager_1.CircleManager, polyline_manager_1.PolylineManager,
	                        polygon_manager_1.PolygonManager, kml_layer_manager_1.KmlLayerManager
	                    ],
	                    inputs: [
	                        'longitude', 'latitude', 'zoom', 'minZoom', 'maxZoom', 'draggable: mapDraggable',
	                        'disableDoubleClickZoom', 'disableDefaultUI', 'scrollwheel', 'backgroundColor', 'draggableCursor',
	                        'draggingCursor', 'keyboardShortcuts', 'zoomControl', 'styles', 'usePanning', 'streetViewControl',
	                        'fitBounds', 'scaleControl', 'mapTypeControl'
	                    ],
	                    outputs: [
	                        'mapClick', 'mapRightClick', 'mapDblClick', 'centerChange', 'idle', 'boundsChange', 'zoomChange'
	                    ],
	                    host: { '[class.sebm-google-map-container]': 'true' },
	                    styles: ["\n    .sebm-google-map-container-inner {\n      width: inherit;\n      height: inherit;\n    }\n    .sebm-google-map-content {\n      display:none;\n    }\n  "],
	                    template: "\n    <div class='sebm-google-map-container-inner'></div>\n    <div class='sebm-google-map-content'>\n      <ng-content></ng-content>\n    </div>\n  "
	                },] },
	    ];
	    /** @nocollapse */
	    SebmGoogleMap.ctorParameters = function () { return [
	        { type: core_1.ElementRef, },
	        { type: google_maps_api_wrapper_1.GoogleMapsAPIWrapper, },
	    ]; };
	    return SebmGoogleMap;
	}());
	exports.SebmGoogleMap = SebmGoogleMap;
	//# sourceMappingURL=google-map.js.map

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var Observable_1 = __webpack_require__(5);
	var maps_api_loader_1 = __webpack_require__(158);
	/**
	 * Wrapper class that handles the communication with the Google Maps Javascript
	 * API v3
	 */
	var GoogleMapsAPIWrapper = (function () {
	    function GoogleMapsAPIWrapper(_loader, _zone) {
	        var _this = this;
	        this._loader = _loader;
	        this._zone = _zone;
	        this._map =
	            new Promise(function (resolve) { _this._mapResolver = resolve; });
	    }
	    GoogleMapsAPIWrapper.prototype.createMap = function (el, mapOptions) {
	        var _this = this;
	        return this._loader.load().then(function () {
	            var map = new google.maps.Map(el, mapOptions);
	            _this._mapResolver(map);
	            return;
	        });
	    };
	    GoogleMapsAPIWrapper.prototype.setMapOptions = function (options) {
	        this._map.then(function (m) { m.setOptions(options); });
	    };
	    /**
	     * Creates a google map marker with the map context
	     */
	    GoogleMapsAPIWrapper.prototype.createMarker = function (options) {
	        if (options === void 0) { options = {}; }
	        return this._map.then(function (map) {
	            options.map = map;
	            return new google.maps.Marker(options);
	        });
	    };
	    GoogleMapsAPIWrapper.prototype.createInfoWindow = function (options) {
	        return this._map.then(function () { return new google.maps.InfoWindow(options); });
	    };
	    /**
	     * Creates a google.map.Circle for the current map.
	     */
	    GoogleMapsAPIWrapper.prototype.createCircle = function (options) {
	        return this._map.then(function (map) {
	            options.map = map;
	            return new google.maps.Circle(options);
	        });
	    };
	    GoogleMapsAPIWrapper.prototype.createPolyline = function (options) {
	        return this.getNativeMap().then(function (map) {
	            var line = new google.maps.Polyline(options);
	            line.setMap(map);
	            return line;
	        });
	    };
	    GoogleMapsAPIWrapper.prototype.createPolygon = function (options) {
	        return this.getNativeMap().then(function (map) {
	            var polygon = new google.maps.Polygon(options);
	            polygon.setMap(map);
	            return polygon;
	        });
	    };
	    /**
	     * Determines if given coordinates are insite a Polygon path.
	     */
	    GoogleMapsAPIWrapper.prototype.containsLocation = function (latLng, polygon) {
	        return google.maps.geometry.poly.containsLocation(latLng, polygon);
	    };
	    GoogleMapsAPIWrapper.prototype.subscribeToMapEvent = function (eventName) {
	        var _this = this;
	        return Observable_1.Observable.create(function (observer) {
	            _this._map.then(function (m) {
	                m.addListener(eventName, function (arg) { _this._zone.run(function () { return observer.next(arg); }); });
	            });
	        });
	    };
	    GoogleMapsAPIWrapper.prototype.setCenter = function (latLng) {
	        return this._map.then(function (map) { return map.setCenter(latLng); });
	    };
	    GoogleMapsAPIWrapper.prototype.getZoom = function () { return this._map.then(function (map) { return map.getZoom(); }); };
	    GoogleMapsAPIWrapper.prototype.getBounds = function () {
	        return this._map.then(function (map) { return map.getBounds(); });
	    };
	    GoogleMapsAPIWrapper.prototype.setZoom = function (zoom) {
	        return this._map.then(function (map) { return map.setZoom(zoom); });
	    };
	    GoogleMapsAPIWrapper.prototype.getCenter = function () {
	        return this._map.then(function (map) { return map.getCenter(); });
	    };
	    GoogleMapsAPIWrapper.prototype.panTo = function (latLng) {
	        return this._map.then(function (map) { return map.panTo(latLng); });
	    };
	    GoogleMapsAPIWrapper.prototype.fitBounds = function (latLng) {
	        return this._map.then(function (map) { return map.fitBounds(latLng); });
	    };
	    GoogleMapsAPIWrapper.prototype.panToBounds = function (latLng) {
	        return this._map.then(function (map) { return map.panToBounds(latLng); });
	    };
	    /**
	     * Returns the native Google Maps Map instance. Be careful when using this instance directly.
	     */
	    GoogleMapsAPIWrapper.prototype.getNativeMap = function () { return this._map; };
	    /**
	     * Triggers the given event name on the map instance.
	     */
	    GoogleMapsAPIWrapper.prototype.triggerMapEvent = function (eventName) {
	        return this._map.then(function (m) { return google.maps.event.trigger(m, eventName); });
	    };
	    GoogleMapsAPIWrapper.decorators = [
	        { type: core_1.Injectable },
	    ];
	    /** @nocollapse */
	    GoogleMapsAPIWrapper.ctorParameters = function () { return [
	        { type: maps_api_loader_1.MapsAPILoader, },
	        { type: core_1.NgZone, },
	    ]; };
	    return GoogleMapsAPIWrapper;
	}());
	exports.GoogleMapsAPIWrapper = GoogleMapsAPIWrapper;
	//# sourceMappingURL=google-maps-api-wrapper.js.map

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var MapsAPILoader = (function () {
	    function MapsAPILoader() {
	    }
	    MapsAPILoader.decorators = [
	        { type: core_1.Injectable },
	    ];
	    /** @nocollapse */
	    MapsAPILoader.ctorParameters = function () { return []; };
	    return MapsAPILoader;
	}());
	exports.MapsAPILoader = MapsAPILoader;
	//# sourceMappingURL=maps-api-loader.js.map

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var Observable_1 = __webpack_require__(5);
	var google_maps_api_wrapper_1 = __webpack_require__(157);
	var CircleManager = (function () {
	    function CircleManager(_apiWrapper, _zone) {
	        this._apiWrapper = _apiWrapper;
	        this._zone = _zone;
	        this._circles = new Map();
	    }
	    CircleManager.prototype.addCircle = function (circle) {
	        this._circles.set(circle, this._apiWrapper.createCircle({
	            center: { lat: circle.latitude, lng: circle.longitude },
	            clickable: circle.clickable,
	            draggable: circle.draggable,
	            editable: circle.editable,
	            fillColor: circle.fillColor,
	            fillOpacity: circle.fillOpacity,
	            radius: circle.radius,
	            strokeColor: circle.strokeColor,
	            strokeOpacity: circle.strokeOpacity,
	            strokePosition: circle.strokePosition,
	            strokeWeight: circle.strokeWeight,
	            visible: circle.visible,
	            zIndex: circle.zIndex
	        }));
	    };
	    ;
	    /**
	     * Removes the given circle from the map.
	     */
	    CircleManager.prototype.removeCircle = function (circle) {
	        var _this = this;
	        return this._circles.get(circle).then(function (c) {
	            c.setMap(null);
	            _this._circles.delete(circle);
	        });
	    };
	    CircleManager.prototype.setOptions = function (circle, options) {
	        return this._circles.get(circle).then(function (c) { return c.setOptions(options); });
	    };
	    ;
	    CircleManager.prototype.getBounds = function (circle) {
	        return this._circles.get(circle).then(function (c) { return c.getBounds(); });
	    };
	    ;
	    CircleManager.prototype.getCenter = function (circle) {
	        return this._circles.get(circle).then(function (c) { return c.getCenter(); });
	    };
	    ;
	    CircleManager.prototype.getRadius = function (circle) {
	        return this._circles.get(circle).then(function (c) { return c.getRadius(); });
	    };
	    CircleManager.prototype.setCenter = function (circle) {
	        return this._circles.get(circle).then(function (c) { return c.setCenter({ lat: circle.latitude, lng: circle.longitude }); });
	    };
	    ;
	    CircleManager.prototype.setEditable = function (circle) {
	        return this._circles.get(circle).then(function (c) { return c.setEditable(circle.editable); });
	    };
	    ;
	    CircleManager.prototype.setDraggable = function (circle) {
	        return this._circles.get(circle).then(function (c) { return c.setDraggable(circle.draggable); });
	    };
	    ;
	    CircleManager.prototype.setVisible = function (circle) {
	        return this._circles.get(circle).then(function (c) { return c.setVisible(circle.visible); });
	    };
	    ;
	    CircleManager.prototype.setRadius = function (circle) {
	        return this._circles.get(circle).then(function (c) { return c.setRadius(circle.radius); });
	    };
	    ;
	    CircleManager.prototype.createEventObservable = function (eventName, circle) {
	        var _this = this;
	        return Observable_1.Observable.create(function (observer) {
	            var listener = null;
	            _this._circles.get(circle).then(function (c) {
	                listener = c.addListener(eventName, function (e) { return _this._zone.run(function () { return observer.next(e); }); });
	            });
	            return function () {
	                if (listener !== null) {
	                    listener.remove();
	                }
	            };
	        });
	    };
	    CircleManager.decorators = [
	        { type: core_1.Injectable },
	    ];
	    /** @nocollapse */
	    CircleManager.ctorParameters = function () { return [
	        { type: google_maps_api_wrapper_1.GoogleMapsAPIWrapper, },
	        { type: core_1.NgZone, },
	    ]; };
	    return CircleManager;
	}());
	exports.CircleManager = CircleManager;
	//# sourceMappingURL=circle-manager.js.map

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(5);
	var core_1 = __webpack_require__(3);
	var google_maps_api_wrapper_1 = __webpack_require__(157);
	var marker_manager_1 = __webpack_require__(161);
	var InfoWindowManager = (function () {
	    function InfoWindowManager(_mapsWrapper, _zone, _markerManager) {
	        this._mapsWrapper = _mapsWrapper;
	        this._zone = _zone;
	        this._markerManager = _markerManager;
	        this._infoWindows = new Map();
	    }
	    InfoWindowManager.prototype.deleteInfoWindow = function (infoWindow) {
	        var _this = this;
	        var iWindow = this._infoWindows.get(infoWindow);
	        if (iWindow == null) {
	            // info window already deleted
	            return Promise.resolve();
	        }
	        return iWindow.then(function (i) {
	            return _this._zone.run(function () {
	                i.close();
	                _this._infoWindows.delete(infoWindow);
	            });
	        });
	    };
	    InfoWindowManager.prototype.setPosition = function (infoWindow) {
	        return this._infoWindows.get(infoWindow).then(function (i) { return i.setPosition({
	            lat: infoWindow.latitude,
	            lng: infoWindow.longitude
	        }); });
	    };
	    InfoWindowManager.prototype.setZIndex = function (infoWindow) {
	        return this._infoWindows.get(infoWindow)
	            .then(function (i) { return i.setZIndex(infoWindow.zIndex); });
	    };
	    InfoWindowManager.prototype.open = function (infoWindow) {
	        var _this = this;
	        return this._infoWindows.get(infoWindow).then(function (w) {
	            if (infoWindow.hostMarker != null) {
	                return _this._markerManager.getNativeMarker(infoWindow.hostMarker).then(function (marker) {
	                    return _this._mapsWrapper.getNativeMap().then(function (map) { return w.open(map, marker); });
	                });
	            }
	            return _this._mapsWrapper.getNativeMap().then(function (map) { return w.open(map); });
	        });
	    };
	    InfoWindowManager.prototype.close = function (infoWindow) {
	        return this._infoWindows.get(infoWindow).then(function (w) { return w.close(); });
	    };
	    InfoWindowManager.prototype.setOptions = function (infoWindow, options) {
	        return this._infoWindows.get(infoWindow).then(function (i) { return i.setOptions(options); });
	    };
	    InfoWindowManager.prototype.addInfoWindow = function (infoWindow) {
	        var options = {
	            content: infoWindow.content,
	            maxWidth: infoWindow.maxWidth,
	            zIndex: infoWindow.zIndex,
	        };
	        if (typeof infoWindow.latitude === 'number' && typeof infoWindow.longitude === 'number') {
	            options.position = { lat: infoWindow.latitude, lng: infoWindow.longitude };
	        }
	        var infoWindowPromise = this._mapsWrapper.createInfoWindow(options);
	        this._infoWindows.set(infoWindow, infoWindowPromise);
	    };
	    /**
	     * Creates a Google Maps event listener for the given InfoWindow as an Observable
	     */
	    InfoWindowManager.prototype.createEventObservable = function (eventName, infoWindow) {
	        var _this = this;
	        return Observable_1.Observable.create(function (observer) {
	            _this._infoWindows.get(infoWindow).then(function (i) {
	                i.addListener(eventName, function (e) { return _this._zone.run(function () { return observer.next(e); }); });
	            });
	        });
	    };
	    InfoWindowManager.decorators = [
	        { type: core_1.Injectable },
	    ];
	    /** @nocollapse */
	    InfoWindowManager.ctorParameters = function () { return [
	        { type: google_maps_api_wrapper_1.GoogleMapsAPIWrapper, },
	        { type: core_1.NgZone, },
	        { type: marker_manager_1.MarkerManager, },
	    ]; };
	    return InfoWindowManager;
	}());
	exports.InfoWindowManager = InfoWindowManager;
	//# sourceMappingURL=info-window-manager.js.map

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var Observable_1 = __webpack_require__(5);
	var google_maps_api_wrapper_1 = __webpack_require__(157);
	var MarkerManager = (function () {
	    function MarkerManager(_mapsWrapper, _zone) {
	        this._mapsWrapper = _mapsWrapper;
	        this._zone = _zone;
	        this._markers = new Map();
	    }
	    MarkerManager.prototype.deleteMarker = function (marker) {
	        var _this = this;
	        var m = this._markers.get(marker);
	        if (m == null) {
	            // marker already deleted
	            return Promise.resolve();
	        }
	        return m.then(function (m) {
	            return _this._zone.run(function () {
	                m.setMap(null);
	                _this._markers.delete(marker);
	            });
	        });
	    };
	    MarkerManager.prototype.updateMarkerPosition = function (marker) {
	        return this._markers.get(marker).then(function (m) { return m.setPosition({ lat: marker.latitude, lng: marker.longitude }); });
	    };
	    MarkerManager.prototype.updateTitle = function (marker) {
	        return this._markers.get(marker).then(function (m) { return m.setTitle(marker.title); });
	    };
	    MarkerManager.prototype.updateLabel = function (marker) {
	        return this._markers.get(marker).then(function (m) { m.setLabel(marker.label); });
	    };
	    MarkerManager.prototype.updateDraggable = function (marker) {
	        return this._markers.get(marker).then(function (m) { return m.setDraggable(marker.draggable); });
	    };
	    MarkerManager.prototype.updateIcon = function (marker) {
	        return this._markers.get(marker).then(function (m) { return m.setIcon(marker.iconUrl); });
	    };
	    MarkerManager.prototype.updateOpacity = function (marker) {
	        return this._markers.get(marker).then(function (m) { return m.setOpacity(marker.opacity); });
	    };
	    MarkerManager.prototype.updateVisible = function (marker) {
	        return this._markers.get(marker).then(function (m) { return m.setVisible(marker.visible); });
	    };
	    MarkerManager.prototype.updateZIndex = function (marker) {
	        return this._markers.get(marker).then(function (m) { return m.setZIndex(marker.zIndex); });
	    };
	    MarkerManager.prototype.addMarker = function (marker) {
	        var markerPromise = this._mapsWrapper.createMarker({
	            position: { lat: marker.latitude, lng: marker.longitude },
	            label: marker.label,
	            draggable: marker.draggable,
	            icon: marker.iconUrl,
	            opacity: marker.opacity,
	            visible: marker.visible,
	            zIndex: marker.zIndex,
	            title: marker.title
	        });
	        this._markers.set(marker, markerPromise);
	    };
	    MarkerManager.prototype.getNativeMarker = function (marker) {
	        return this._markers.get(marker);
	    };
	    MarkerManager.prototype.createEventObservable = function (eventName, marker) {
	        var _this = this;
	        return Observable_1.Observable.create(function (observer) {
	            _this._markers.get(marker).then(function (m) {
	                m.addListener(eventName, function (e) { return _this._zone.run(function () { return observer.next(e); }); });
	            });
	        });
	    };
	    MarkerManager.decorators = [
	        { type: core_1.Injectable },
	    ];
	    /** @nocollapse */
	    MarkerManager.ctorParameters = function () { return [
	        { type: google_maps_api_wrapper_1.GoogleMapsAPIWrapper, },
	        { type: core_1.NgZone, },
	    ]; };
	    return MarkerManager;
	}());
	exports.MarkerManager = MarkerManager;
	//# sourceMappingURL=marker-manager.js.map

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var Observable_1 = __webpack_require__(5);
	var google_maps_api_wrapper_1 = __webpack_require__(157);
	var PolygonManager = (function () {
	    function PolygonManager(_mapsWrapper, _zone) {
	        this._mapsWrapper = _mapsWrapper;
	        this._zone = _zone;
	        this._polygons = new Map();
	    }
	    PolygonManager.prototype.addPolygon = function (path) {
	        var polygonPromise = this._mapsWrapper.createPolygon({
	            clickable: path.clickable,
	            draggable: path.draggable,
	            editable: path.editable,
	            fillColor: path.fillColor,
	            fillOpacity: path.fillOpacity,
	            geodesic: path.geodesic,
	            paths: path.paths,
	            strokeColor: path.strokeColor,
	            strokeOpacity: path.strokeOpacity,
	            strokeWeight: path.strokeWeight,
	            visible: path.visible,
	            zIndex: path.zIndex,
	        });
	        this._polygons.set(path, polygonPromise);
	    };
	    PolygonManager.prototype.updatePolygon = function (polygon) {
	        var _this = this;
	        var m = this._polygons.get(polygon);
	        if (m == null) {
	            return Promise.resolve();
	        }
	        return m.then(function (l) { return _this._zone.run(function () { l.setPaths(polygon.paths); }); });
	    };
	    PolygonManager.prototype.setPolygonOptions = function (path, options) {
	        return this._polygons.get(path).then(function (l) { l.setOptions(options); });
	    };
	    PolygonManager.prototype.deletePolygon = function (paths) {
	        var _this = this;
	        var m = this._polygons.get(paths);
	        if (m == null) {
	            return Promise.resolve();
	        }
	        return m.then(function (l) {
	            return _this._zone.run(function () {
	                l.setMap(null);
	                _this._polygons.delete(paths);
	            });
	        });
	    };
	    PolygonManager.prototype.createEventObservable = function (eventName, path) {
	        var _this = this;
	        return Observable_1.Observable.create(function (observer) {
	            _this._polygons.get(path).then(function (l) {
	                l.addListener(eventName, function (e) { return _this._zone.run(function () { return observer.next(e); }); });
	            });
	        });
	    };
	    PolygonManager.decorators = [
	        { type: core_1.Injectable },
	    ];
	    /** @nocollapse */
	    PolygonManager.ctorParameters = function () { return [
	        { type: google_maps_api_wrapper_1.GoogleMapsAPIWrapper, },
	        { type: core_1.NgZone, },
	    ]; };
	    return PolygonManager;
	}());
	exports.PolygonManager = PolygonManager;
	//# sourceMappingURL=polygon-manager.js.map

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var Observable_1 = __webpack_require__(5);
	var google_maps_api_wrapper_1 = __webpack_require__(157);
	var PolylineManager = (function () {
	    function PolylineManager(_mapsWrapper, _zone) {
	        this._mapsWrapper = _mapsWrapper;
	        this._zone = _zone;
	        this._polylines = new Map();
	    }
	    PolylineManager._convertPoints = function (line) {
	        var path = line._getPoints().map(function (point) {
	            return { lat: point.latitude, lng: point.longitude };
	        });
	        return path;
	    };
	    PolylineManager.prototype.addPolyline = function (line) {
	        var path = PolylineManager._convertPoints(line);
	        var polylinePromise = this._mapsWrapper.createPolyline({
	            clickable: line.clickable,
	            draggable: line.draggable,
	            editable: line.editable,
	            geodesic: line.geodesic,
	            strokeColor: line.strokeColor,
	            strokeOpacity: line.strokeOpacity,
	            strokeWeight: line.strokeWeight,
	            visible: line.visible,
	            zIndex: line.zIndex,
	            path: path
	        });
	        this._polylines.set(line, polylinePromise);
	    };
	    PolylineManager.prototype.updatePolylinePoints = function (line) {
	        var _this = this;
	        var path = PolylineManager._convertPoints(line);
	        var m = this._polylines.get(line);
	        if (m == null) {
	            return Promise.resolve();
	        }
	        return m.then(function (l) { return _this._zone.run(function () { l.setPath(path); }); });
	    };
	    PolylineManager.prototype.setPolylineOptions = function (line, options) {
	        return this._polylines.get(line).then(function (l) { l.setOptions(options); });
	    };
	    PolylineManager.prototype.deletePolyline = function (line) {
	        var _this = this;
	        var m = this._polylines.get(line);
	        if (m == null) {
	            return Promise.resolve();
	        }
	        return m.then(function (l) {
	            return _this._zone.run(function () {
	                l.setMap(null);
	                _this._polylines.delete(line);
	            });
	        });
	    };
	    PolylineManager.prototype.createEventObservable = function (eventName, line) {
	        var _this = this;
	        return Observable_1.Observable.create(function (observer) {
	            _this._polylines.get(line).then(function (l) {
	                l.addListener(eventName, function (e) { return _this._zone.run(function () { return observer.next(e); }); });
	            });
	        });
	    };
	    PolylineManager.decorators = [
	        { type: core_1.Injectable },
	    ];
	    /** @nocollapse */
	    PolylineManager.ctorParameters = function () { return [
	        { type: google_maps_api_wrapper_1.GoogleMapsAPIWrapper, },
	        { type: core_1.NgZone, },
	    ]; };
	    return PolylineManager;
	}());
	exports.PolylineManager = PolylineManager;
	//# sourceMappingURL=polyline-manager.js.map

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var Observable_1 = __webpack_require__(5);
	var google_maps_api_wrapper_1 = __webpack_require__(157);
	/**
	 * Manages all KML Layers for a Google Map instance.
	 */
	var KmlLayerManager = (function () {
	    function KmlLayerManager(_wrapper, _zone) {
	        this._wrapper = _wrapper;
	        this._zone = _zone;
	        this._layers = new Map();
	    }
	    /**
	     * Adds a new KML Layer to the map.
	     */
	    KmlLayerManager.prototype.addKmlLayer = function (layer) {
	        var newLayer = this._wrapper.getNativeMap().then(function (m) {
	            return new google.maps.KmlLayer({
	                clickable: layer.clickable,
	                map: m,
	                preserveViewport: layer.preserveViewport,
	                screenOverlays: layer.screenOverlays,
	                suppressInfoWindows: layer.suppressInfoWindows,
	                url: layer.url,
	                zIndex: layer.zIndex
	            });
	        });
	        this._layers.set(layer, newLayer);
	    };
	    KmlLayerManager.prototype.setOptions = function (layer, options) {
	        this._layers.get(layer).then(function (l) { return l.setOptions(options); });
	    };
	    KmlLayerManager.prototype.deleteKmlLayer = function (layer) {
	        var _this = this;
	        this._layers.get(layer).then(function (l) {
	            l.setMap(null);
	            _this._layers.delete(layer);
	        });
	    };
	    /**
	     * Creates a Google Maps event listener for the given KmlLayer as an Observable
	     */
	    KmlLayerManager.prototype.createEventObservable = function (eventName, layer) {
	        var _this = this;
	        return Observable_1.Observable.create(function (observer) {
	            _this._layers.get(layer).then(function (m) {
	                m.addListener(eventName, function (e) { return _this._zone.run(function () { return observer.next(e); }); });
	            });
	        });
	    };
	    KmlLayerManager.decorators = [
	        { type: core_1.Injectable },
	    ];
	    /** @nocollapse */
	    KmlLayerManager.ctorParameters = function () { return [
	        { type: google_maps_api_wrapper_1.GoogleMapsAPIWrapper, },
	        { type: core_1.NgZone, },
	    ]; };
	    return KmlLayerManager;
	}());
	exports.KmlLayerManager = KmlLayerManager;
	//# sourceMappingURL=kml-layer-manager.js.map

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var circle_manager_1 = __webpack_require__(159);
	var SebmGoogleMapCircle = (function () {
	    function SebmGoogleMapCircle(_manager) {
	        this._manager = _manager;
	        /**
	         * Indicates whether this Circle handles mouse events. Defaults to true.
	         */
	        this.clickable = true;
	        /**
	         * If set to true, the user can drag this circle over the map. Defaults to false.
	         */
	        this.draggable = false;
	        /**
	         * If set to true, the user can edit this circle by dragging the control points shown at
	         * the center and around the circumference of the circle. Defaults to false.
	         */
	        this.editable = false;
	        /**
	         * The radius in meters on the Earth's surface.
	         */
	        this.radius = 0;
	        /**
	         * The stroke position. Defaults to CENTER.
	         * This property is not supported on Internet Explorer 8 and earlier.
	         */
	        this.strokePosition = 'CENTER';
	        /**
	         * The stroke width in pixels.
	         */
	        this.strokeWeight = 0;
	        /**
	         * Whether this circle is visible on the map. Defaults to true.
	         */
	        this.visible = true;
	        /**
	         * This event is fired when the circle's center is changed.
	         */
	        this.centerChange = new core_1.EventEmitter();
	        /**
	         * This event emitter gets emitted when the user clicks on the circle.
	         */
	        this.circleClick = new core_1.EventEmitter();
	        /**
	         * This event emitter gets emitted when the user clicks on the circle.
	         */
	        this.circleDblClick = new core_1.EventEmitter();
	        /**
	         * This event is repeatedly fired while the user drags the circle.
	         */
	        this.drag = new core_1.EventEmitter();
	        /**
	         * This event is fired when the user stops dragging the circle.
	         */
	        this.dragEnd = new core_1.EventEmitter();
	        /**
	         * This event is fired when the user starts dragging the circle.
	         */
	        this.dragStart = new core_1.EventEmitter();
	        /**
	         * This event is fired when the DOM mousedown event is fired on the circle.
	         */
	        this.mouseDown = new core_1.EventEmitter();
	        /**
	         * This event is fired when the DOM mousemove event is fired on the circle.
	         */
	        this.mouseMove = new core_1.EventEmitter();
	        /**
	         * This event is fired on circle mouseout.
	         */
	        this.mouseOut = new core_1.EventEmitter();
	        /**
	         * This event is fired on circle mouseover.
	         */
	        this.mouseOver = new core_1.EventEmitter();
	        /**
	         * This event is fired when the DOM mouseup event is fired on the circle.
	         */
	        this.mouseUp = new core_1.EventEmitter();
	        /**
	         * This event is fired when the circle's radius is changed.
	         */
	        this.radiusChange = new core_1.EventEmitter();
	        /**
	         * This event is fired when the circle is right-clicked on.
	         */
	        this.rightClick = new core_1.EventEmitter();
	        this._circleAddedToManager = false;
	        this._eventSubscriptions = [];
	    }
	    /** @internal */
	    SebmGoogleMapCircle.prototype.ngOnInit = function () {
	        this._manager.addCircle(this);
	        this._circleAddedToManager = true;
	        this._registerEventListeners();
	    };
	    /** @internal */
	    SebmGoogleMapCircle.prototype.ngOnChanges = function (changes) {
	        if (!this._circleAddedToManager) {
	            return;
	        }
	        if (changes['latitude'] || changes['longitude']) {
	            this._manager.setCenter(this);
	        }
	        if (changes['editable']) {
	            this._manager.setEditable(this);
	        }
	        if (changes['draggable']) {
	            this._manager.setDraggable(this);
	        }
	        if (changes['visible']) {
	            this._manager.setVisible(this);
	        }
	        if (changes['radius']) {
	            this._manager.setRadius(this);
	        }
	        this._updateCircleOptionsChanges(changes);
	    };
	    SebmGoogleMapCircle.prototype._updateCircleOptionsChanges = function (changes) {
	        var options = {};
	        var optionKeys = Object.keys(changes).filter(function (k) { return SebmGoogleMapCircle._mapOptions.indexOf(k) !== -1; });
	        optionKeys.forEach(function (k) { options[k] = changes[k].currentValue; });
	        if (optionKeys.length > 0) {
	            this._manager.setOptions(this, options);
	        }
	    };
	    SebmGoogleMapCircle.prototype._registerEventListeners = function () {
	        var _this = this;
	        var events = new Map();
	        events.set('center_changed', this.centerChange);
	        events.set('click', this.circleClick);
	        events.set('dblclick', this.circleDblClick);
	        events.set('drag', this.drag);
	        events.set('dragend', this.dragEnd);
	        events.set('dragStart', this.dragStart);
	        events.set('mousedown', this.mouseDown);
	        events.set('mousemove', this.mouseMove);
	        events.set('mouseout', this.mouseOut);
	        events.set('mouseover', this.mouseOver);
	        events.set('mouseup', this.mouseUp);
	        events.set('radius_changed', this.radiusChange);
	        events.set('rightclick', this.rightClick);
	        events.forEach(function (eventEmitter, eventName) {
	            _this._eventSubscriptions.push(_this._manager.createEventObservable(eventName, _this).subscribe(function (value) {
	                switch (eventName) {
	                    case 'radius_changed':
	                        _this._manager.getRadius(_this).then(function (radius) { return eventEmitter.emit(radius); });
	                        break;
	                    case 'center_changed':
	                        _this._manager.getCenter(_this).then(function (center) {
	                            return eventEmitter.emit({ lat: center.lat(), lng: center.lng() });
	                        });
	                        break;
	                    default:
	                        eventEmitter.emit({ coords: { lat: value.latLng.lat(), lng: value.latLng.lng() } });
	                }
	            }));
	        });
	    };
	    /** @internal */
	    SebmGoogleMapCircle.prototype.ngOnDestroy = function () {
	        this._eventSubscriptions.forEach(function (s) { s.unsubscribe(); });
	        this._eventSubscriptions = null;
	        this._manager.removeCircle(this);
	    };
	    /**
	     * Gets the LatLngBounds of this Circle.
	     */
	    SebmGoogleMapCircle.prototype.getBounds = function () { return this._manager.getBounds(this); };
	    SebmGoogleMapCircle.prototype.getCenter = function () { return this._manager.getCenter(this); };
	    SebmGoogleMapCircle._mapOptions = [
	        'fillColor', 'fillOpacity', 'strokeColor', 'strokeOpacity', 'strokePosition', 'strokeWeight',
	        'visible', 'zIndex'
	    ];
	    SebmGoogleMapCircle.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: 'sebm-google-map-circle',
	                    inputs: [
	                        'latitude', 'longitude', 'clickable', 'draggable: circleDraggable', 'editable', 'fillColor',
	                        'fillOpacity', 'radius', 'strokeColor', 'strokeOpacity', 'strokePosition', 'strokeWeight',
	                        'visible', 'zIndex'
	                    ],
	                    outputs: [
	                        'centerChange', 'circleClick', 'circleDblClick', 'drag', 'dragEnd', 'dragStart', 'mouseDown',
	                        'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'radiusChange', 'rightClick'
	                    ]
	                },] },
	    ];
	    /** @nocollapse */
	    SebmGoogleMapCircle.ctorParameters = function () { return [
	        { type: circle_manager_1.CircleManager, },
	    ]; };
	    return SebmGoogleMapCircle;
	}());
	exports.SebmGoogleMapCircle = SebmGoogleMapCircle;
	//# sourceMappingURL=google-map-circle.js.map

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var info_window_manager_1 = __webpack_require__(160);
	var infoWindowId = 0;
	/**
	 * SebmGoogleMapInfoWindow renders a info window inside a {@link SebmGoogleMapMarker} or standalone.
	 *
	 * ### Example
	 * ```typescript
	 * import { Component } from 'angular2/core';
	 * import { SebmGoogleMap, SebmGoogleMapMarker, SebmGoogleMapInfoWindow } from
	 * 'angular2-google-maps/core';
	 *
	 * @Component({
	 *  selector: 'my-map-cmp',
	 *  directives: [SebmGoogleMap, SebmGoogleMapMarker, SebmGoogleMapInfoWindow],
	 *  styles: [`
	 *    .sebm-google-map-container {
	 *      height: 300px;
	 *    }
	 * `],
	 *  template: `
	 *    <sebm-google-map [latitude]="lat" [longitude]="lng" [zoom]="zoom">
	 *      <sebm-google-map-marker [latitude]="lat" [longitude]="lng" [label]="'M'">
	 *        <sebm-google-map-info-window [disableAutoPan]="true">
	 *          Hi, this is the content of the <strong>info window</strong>
	 *        </sebm-google-map-info-window>
	 *      </sebm-google-map-marker>
	 *    </sebm-google-map>
	 *  `
	 * })
	 * ```
	 */
	var SebmGoogleMapInfoWindow = (function () {
	    function SebmGoogleMapInfoWindow(_infoWindowManager, _el) {
	        this._infoWindowManager = _infoWindowManager;
	        this._el = _el;
	        /**
	         * Sets the open state for the InfoWindow. You can also call the open() and close() methods.
	         */
	        this.isOpen = false;
	        /**
	         * Emits an event when the info window is closed.
	         */
	        this.infoWindowClose = new core_1.EventEmitter();
	        this._infoWindowAddedToManager = false;
	        this._id = (infoWindowId++).toString();
	    }
	    SebmGoogleMapInfoWindow.prototype.ngOnInit = function () {
	        this.content = this._el.nativeElement.querySelector('.sebm-google-map-info-window-content');
	        this._infoWindowManager.addInfoWindow(this);
	        this._infoWindowAddedToManager = true;
	        this._updateOpenState();
	        this._registerEventListeners();
	    };
	    /** @internal */
	    SebmGoogleMapInfoWindow.prototype.ngOnChanges = function (changes) {
	        if (!this._infoWindowAddedToManager) {
	            return;
	        }
	        if ((changes['latitude'] || changes['longitude']) && typeof this.latitude === 'number' &&
	            typeof this.longitude === 'number') {
	            this._infoWindowManager.setPosition(this);
	        }
	        if (changes['zIndex']) {
	            this._infoWindowManager.setZIndex(this);
	        }
	        if (changes['isOpen']) {
	            this._updateOpenState();
	        }
	        this._setInfoWindowOptions(changes);
	    };
	    SebmGoogleMapInfoWindow.prototype._registerEventListeners = function () {
	        var _this = this;
	        this._infoWindowManager.createEventObservable('closeclick', this).subscribe(function () {
	            _this.isOpen = false;
	            _this.infoWindowClose.emit();
	        });
	    };
	    SebmGoogleMapInfoWindow.prototype._updateOpenState = function () {
	        this.isOpen ? this.open() : this.close();
	    };
	    SebmGoogleMapInfoWindow.prototype._setInfoWindowOptions = function (changes) {
	        var options = {};
	        var optionKeys = Object.keys(changes).filter(function (k) { return SebmGoogleMapInfoWindow._infoWindowOptionsInputs.indexOf(k) !== -1; });
	        optionKeys.forEach(function (k) { options[k] = changes[k].currentValue; });
	        this._infoWindowManager.setOptions(this, options);
	    };
	    /**
	     * Opens the info window.
	     */
	    SebmGoogleMapInfoWindow.prototype.open = function () { return this._infoWindowManager.open(this); };
	    /**
	     * Closes the info window.
	     */
	    SebmGoogleMapInfoWindow.prototype.close = function () {
	        var _this = this;
	        return this._infoWindowManager.close(this).then(function () { _this.infoWindowClose.emit(); });
	    };
	    /** @internal */
	    SebmGoogleMapInfoWindow.prototype.id = function () { return this._id; };
	    /** @internal */
	    SebmGoogleMapInfoWindow.prototype.toString = function () { return 'SebmGoogleMapInfoWindow-' + this._id.toString(); };
	    /** @internal */
	    SebmGoogleMapInfoWindow.prototype.ngOnDestroy = function () { this._infoWindowManager.deleteInfoWindow(this); };
	    SebmGoogleMapInfoWindow._infoWindowOptionsInputs = ['disableAutoPan', 'maxWidth'];
	    SebmGoogleMapInfoWindow.decorators = [
	        { type: core_1.Component, args: [{
	                    selector: 'sebm-google-map-info-window',
	                    inputs: ['latitude', 'longitude', 'disableAutoPan', 'isOpen', 'zIndex', 'maxWidth'],
	                    outputs: ['infoWindowClose'],
	                    template: "<div class='sebm-google-map-info-window-content'>\n      <ng-content></ng-content>\n    </div>\n  "
	                },] },
	    ];
	    /** @nocollapse */
	    SebmGoogleMapInfoWindow.ctorParameters = function () { return [
	        { type: info_window_manager_1.InfoWindowManager, },
	        { type: core_1.ElementRef, },
	    ]; };
	    return SebmGoogleMapInfoWindow;
	}());
	exports.SebmGoogleMapInfoWindow = SebmGoogleMapInfoWindow;
	//# sourceMappingURL=google-map-info-window.js.map

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var kml_layer_manager_1 = __webpack_require__(164);
	var layerId = 0;
	var SebmGoogleMapKmlLayer = (function () {
	    function SebmGoogleMapKmlLayer(_manager) {
	        this._manager = _manager;
	        this._addedToManager = false;
	        this._id = (layerId++).toString();
	        this._subscriptions = [];
	        /**
	         * If true, the layer receives mouse events. Default value is true.
	         */
	        this.clickable = true;
	        /**
	         * By default, the input map is centered and zoomed to the bounding box of the contents of the
	         * layer.
	         * If this option is set to true, the viewport is left unchanged, unless the map's center and zoom
	         * were never set.
	         */
	        this.preserveViewport = false;
	        /**
	         * Whether to render the screen overlays. Default true.
	         */
	        this.screenOverlays = true;
	        /**
	         * Suppress the rendering of info windows when layer features are clicked.
	         */
	        this.suppressInfoWindows = false;
	        /**
	         * The URL of the KML document to display.
	         */
	        this.url = null;
	        /**
	         * The z-index of the layer.
	         */
	        this.zIndex = null;
	        /**
	         * This event is fired when a feature in the layer is clicked.
	         */
	        this.layerClick = new core_1.EventEmitter();
	        /**
	         * This event is fired when the KML layers default viewport has changed.
	         */
	        this.defaultViewportChange = new core_1.EventEmitter();
	        /**
	         * This event is fired when the KML layer has finished loading.
	         * At this point it is safe to read the status property to determine if the layer loaded
	         * successfully.
	         */
	        this.statusChange = new core_1.EventEmitter();
	    }
	    SebmGoogleMapKmlLayer.prototype.ngOnInit = function () {
	        if (this._addedToManager) {
	            return;
	        }
	        this._manager.addKmlLayer(this);
	        this._addedToManager = true;
	        this._addEventListeners();
	    };
	    SebmGoogleMapKmlLayer.prototype.ngOnChanges = function (changes) {
	        if (!this._addedToManager) {
	            return;
	        }
	        this._updatePolygonOptions(changes);
	    };
	    SebmGoogleMapKmlLayer.prototype._updatePolygonOptions = function (changes) {
	        var options = Object.keys(changes)
	            .filter(function (k) { return SebmGoogleMapKmlLayer._kmlLayerOptions.indexOf(k) !== -1; })
	            .reduce(function (obj, k) {
	            obj[k] = changes[k].currentValue;
	            return obj;
	        }, {});
	        if (Object.keys(options).length > 0) {
	            this._manager.setOptions(this, options);
	        }
	    };
	    SebmGoogleMapKmlLayer.prototype._addEventListeners = function () {
	        var _this = this;
	        var listeners = [
	            { name: 'click', handler: function (ev) { return _this.layerClick.emit(ev); } },
	            { name: 'defaultviewport_changed', handler: function () { return _this.defaultViewportChange.emit(); } },
	            { name: 'status_changed', handler: function () { return _this.statusChange.emit(); } },
	        ];
	        listeners.forEach(function (obj) {
	            var os = _this._manager.createEventObservable(obj.name, _this).subscribe(obj.handler);
	            _this._subscriptions.push(os);
	        });
	    };
	    /** @internal */
	    SebmGoogleMapKmlLayer.prototype.id = function () { return this._id; };
	    /** @internal */
	    SebmGoogleMapKmlLayer.prototype.toString = function () { return "SebmGoogleMapKmlLayer-" + this._id.toString(); };
	    /** @internal */
	    SebmGoogleMapKmlLayer.prototype.ngOnDestroy = function () {
	        this._manager.deleteKmlLayer(this);
	        // unsubscribe all registered observable subscriptions
	        this._subscriptions.forEach(function (s) { return s.unsubscribe(); });
	    };
	    SebmGoogleMapKmlLayer._kmlLayerOptions = ['clickable', 'preserveViewport', 'screenOverlays', 'suppressInfoWindows', 'url', 'zIndex'];
	    SebmGoogleMapKmlLayer.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: 'sebm-google-map-kml-layer',
	                    inputs: ['clickable', 'preserveViewport', 'screenOverlays', 'suppressInfoWindows', 'url', 'zIndex'],
	                    outputs: ['layerClick', 'defaultViewportChange', 'statusChange']
	                },] },
	    ];
	    /** @nocollapse */
	    SebmGoogleMapKmlLayer.ctorParameters = function () { return [
	        { type: kml_layer_manager_1.KmlLayerManager, },
	    ]; };
	    return SebmGoogleMapKmlLayer;
	}());
	exports.SebmGoogleMapKmlLayer = SebmGoogleMapKmlLayer;
	//# sourceMappingURL=google-map-kml-layer.js.map

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var marker_manager_1 = __webpack_require__(161);
	var google_map_info_window_1 = __webpack_require__(166);
	var markerId = 0;
	/**
	 * SebmGoogleMapMarker renders a map marker inside a {@link SebmGoogleMap}.
	 *
	 * ### Example
	 * ```typescript
	 * import { Component } from 'angular2/core';
	 * import { SebmGoogleMap, SebmGoogleMapMarker } from 'angular2-google-maps/core';
	 *
	 * @Component({
	 *  selector: 'my-map-cmp',
	 *  directives: [SebmGoogleMap, SebmGoogleMapMarker],
	 *  styles: [`
	 *    .sebm-google-map-container {
	 *      height: 300px;
	 *    }
	 * `],
	 *  template: `
	 *    <sebm-google-map [latitude]="lat" [longitude]="lng" [zoom]="zoom">
	 *      <sebm-google-map-marker [latitude]="lat" [longitude]="lng" [label]="'M'">
	 *      </sebm-google-map-marker>
	 *    </sebm-google-map>
	 *  `
	 * })
	 * ```
	 */
	var SebmGoogleMapMarker = (function () {
	    function SebmGoogleMapMarker(_markerManager) {
	        this._markerManager = _markerManager;
	        /**
	         * If true, the marker can be dragged. Default value is false.
	         */
	        this.draggable = false;
	        /**
	         * If true, the marker is visible
	         */
	        this.visible = true;
	        /**
	         * Whether to automatically open the child info window when the marker is clicked.
	         */
	        this.openInfoWindow = true;
	        /**
	         * The marker's opacity between 0.0 and 1.0.
	         */
	        this.opacity = 1;
	        /**
	         * All markers are displayed on the map in order of their zIndex, with higher values displaying in
	         * front of markers with lower values. By default, markers are displayed according to their
	         * vertical position on screen, with lower markers appearing in front of markers further up the
	         * screen.
	         */
	        this.zIndex = 1;
	        /**
	         * This event emitter gets emitted when the user clicks on the marker.
	         */
	        this.markerClick = new core_1.EventEmitter();
	        /**
	         * This event is fired when the user stops dragging the marker.
	         */
	        this.dragEnd = new core_1.EventEmitter();
	        /**
	         * This event is fired when the user mouses over the marker.
	         */
	        this.mouseOver = new core_1.EventEmitter();
	        /**
	         * This event is fired when the user mouses outside the marker.
	         */
	        this.mouseOut = new core_1.EventEmitter();
	        this._markerAddedToManger = false;
	        this._observableSubscriptions = [];
	        this._id = (markerId++).toString();
	    }
	    /* @internal */
	    SebmGoogleMapMarker.prototype.ngAfterContentInit = function () {
	        if (this.infoWindow != null) {
	            this.infoWindow.hostMarker = this;
	        }
	    };
	    /** @internal */
	    SebmGoogleMapMarker.prototype.ngOnChanges = function (changes) {
	        if (typeof this.latitude !== 'number' || typeof this.longitude !== 'number') {
	            return;
	        }
	        if (!this._markerAddedToManger) {
	            this._markerManager.addMarker(this);
	            this._markerAddedToManger = true;
	            this._addEventListeners();
	            return;
	        }
	        if (changes['latitude'] || changes['longitude']) {
	            this._markerManager.updateMarkerPosition(this);
	        }
	        if (changes['title']) {
	            this._markerManager.updateTitle(this);
	        }
	        if (changes['label']) {
	            this._markerManager.updateLabel(this);
	        }
	        if (changes['draggable']) {
	            this._markerManager.updateDraggable(this);
	        }
	        if (changes['iconUrl']) {
	            this._markerManager.updateIcon(this);
	        }
	        if (changes['opacity']) {
	            this._markerManager.updateOpacity(this);
	        }
	        if (changes['visible']) {
	            this._markerManager.updateVisible(this);
	        }
	        if (changes['zIndex']) {
	            this._markerManager.updateZIndex(this);
	        }
	    };
	    SebmGoogleMapMarker.prototype._addEventListeners = function () {
	        var _this = this;
	        var cs = this._markerManager.createEventObservable('click', this).subscribe(function () {
	            if (_this.openInfoWindow && _this.infoWindow != null) {
	                _this.infoWindow.open();
	            }
	            _this.markerClick.emit(null);
	        });
	        this._observableSubscriptions.push(cs);
	        var ds = this._markerManager.createEventObservable('dragend', this)
	            .subscribe(function (e) {
	            _this.dragEnd.emit({ coords: { lat: e.latLng.lat(), lng: e.latLng.lng() } });
	        });
	        this._observableSubscriptions.push(ds);
	        var mover = this._markerManager.createEventObservable('mouseover', this)
	            .subscribe(function (e) {
	            _this.mouseOver.emit({ coords: { lat: e.latLng.lat(), lng: e.latLng.lng() } });
	        });
	        this._observableSubscriptions.push(mover);
	        var mout = this._markerManager.createEventObservable('mouseout', this)
	            .subscribe(function (e) {
	            _this.mouseOut.emit({ coords: { lat: e.latLng.lat(), lng: e.latLng.lng() } });
	        });
	        this._observableSubscriptions.push(mout);
	    };
	    /** @internal */
	    SebmGoogleMapMarker.prototype.id = function () { return this._id; };
	    /** @internal */
	    SebmGoogleMapMarker.prototype.toString = function () { return 'SebmGoogleMapMarker-' + this._id.toString(); };
	    /** @internal */
	    SebmGoogleMapMarker.prototype.ngOnDestroy = function () {
	        this._markerManager.deleteMarker(this);
	        // unsubscribe all registered observable subscriptions
	        this._observableSubscriptions.forEach(function (s) { return s.unsubscribe(); });
	    };
	    SebmGoogleMapMarker.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: 'sebm-google-map-marker',
	                    inputs: [
	                        'latitude', 'longitude', 'title', 'label', 'draggable: markerDraggable', 'iconUrl',
	                        'openInfoWindow', 'opacity', 'visible', 'zIndex'
	                    ],
	                    outputs: ['markerClick', 'dragEnd', 'mouseOver', 'mouseOut']
	                },] },
	    ];
	    /** @nocollapse */
	    SebmGoogleMapMarker.ctorParameters = function () { return [
	        { type: marker_manager_1.MarkerManager, },
	    ]; };
	    SebmGoogleMapMarker.propDecorators = {
	        'infoWindow': [{ type: core_1.ContentChild, args: [google_map_info_window_1.SebmGoogleMapInfoWindow,] },],
	    };
	    return SebmGoogleMapMarker;
	}());
	exports.SebmGoogleMapMarker = SebmGoogleMapMarker;
	//# sourceMappingURL=google-map-marker.js.map

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var polygon_manager_1 = __webpack_require__(162);
	/**
	 * SebmGoogleMapPolygon renders a polygon on a {@link SebmGoogleMap}
	 *
	 * ### Example
	 * ```typescript
	 * import { Component } from '@angular/core';
	 * import { SebmGoogleMap, SebmGooglePolygon, LatLngLiteral } from 'angular2-maps/core';
	 *
	 * @Component({
	 *  selector: 'my-map-cmp',
	 *  styles: [`
	 *    .semb-map-container {
	 *      height: 300px;
	 *    }
	 * `],
	 *  template: `
	 *    <semb-map [latitude]="lat" [longitude]="lng" [zoom]="zoom">
	 *      <semb-map-polygon [paths]="paths">
	 *      </semb-map-polygon>
	 *    </semb-map>
	 *  `
	 * })
	 * export class MyMapCmp {
	 *   lat: number = 0;
	 *   lng: number = 0;
	 *   zoom: number = 10;
	 *   paths: Array<LatLngLiteral> = [
	 *     { lat: 0,  lng: 10 },
	 *     { lat: 0,  lng: 20 },
	 *     { lat: 10, lng: 20 },
	 *     { lat: 10, lng: 10 },
	 *     { lat: 0,  lng: 10 }
	 *   ]
	 *   // Nesting paths will create a hole where they overlap;
	 *   nestedPaths: Array<Array<LatLngLiteral>> = [[
	 *     { lat: 0,  lng: 10 },
	 *     { lat: 0,  lng: 20 },
	 *     { lat: 10, lng: 20 },
	 *     { lat: 10, lng: 10 },
	 *     { lat: 0,  lng: 10 }
	 *   ], [
	 *     { lat: 0, lng: 15 },
	 *     { lat: 0, lng: 20 },
	 *     { lat: 5, lng: 20 },
	 *     { lat: 5, lng: 15 },
	 *     { lat: 0, lng: 15 }
	 *   ]]
	 * }
	 * ```
	 */
	var SebmGoogleMapPolygon = (function () {
	    function SebmGoogleMapPolygon(_polygonManager) {
	        this._polygonManager = _polygonManager;
	        /**
	         * Indicates whether this Polygon handles mouse events. Defaults to true.
	         */
	        this.clickable = true;
	        /**
	         * If set to true, the user can drag this shape over the map. The geodesic
	         * property defines the mode of dragging. Defaults to false.
	         */
	        this.draggable = false;
	        /**
	         * If set to true, the user can edit this shape by dragging the control
	         * points shown at the vertices and on each segment. Defaults to false.
	         */
	        this.editable = false;
	        /**
	         * When true, edges of the polygon are interpreted as geodesic and will
	         * follow the curvature of the Earth. When false, edges of the polygon are
	         * rendered as straight lines in screen space. Note that the shape of a
	         * geodesic polygon may appear to change when dragged, as the dimensions
	         * are maintained relative to the surface of the earth. Defaults to false.
	         */
	        this.geodesic = false;
	        /**
	         * The ordered sequence of coordinates that designates a closed loop.
	         * Unlike polylines, a polygon may consist of one or more paths.
	         *  As a result, the paths property may specify one or more arrays of
	         * LatLng coordinates. Paths are closed automatically; do not repeat the
	         * first vertex of the path as the last vertex. Simple polygons may be
	         * defined using a single array of LatLngs. More complex polygons may
	         * specify an array of arrays. Any simple arrays are converted into Arrays.
	         * Inserting or removing LatLngs from the Array will automatically update
	         * the polygon on the map.
	         */
	        this.paths = [];
	        /**
	         * This event is fired when the DOM click event is fired on the Polygon.
	         */
	        this.polyClick = new core_1.EventEmitter();
	        /**
	         * This event is fired when the DOM dblclick event is fired on the Polygon.
	         */
	        this.polyDblClick = new core_1.EventEmitter();
	        /**
	         * This event is repeatedly fired while the user drags the polygon.
	         */
	        this.polyDrag = new core_1.EventEmitter();
	        /**
	         * This event is fired when the user stops dragging the polygon.
	         */
	        this.polyDragEnd = new core_1.EventEmitter();
	        /**
	         * This event is fired when the user starts dragging the polygon.
	         */
	        this.polyDragStart = new core_1.EventEmitter();
	        /**
	         * This event is fired when the DOM mousedown event is fired on the Polygon.
	         */
	        this.polyMouseDown = new core_1.EventEmitter();
	        /**
	         * This event is fired when the DOM mousemove event is fired on the Polygon.
	         */
	        this.polyMouseMove = new core_1.EventEmitter();
	        /**
	         * This event is fired on Polygon mouseout.
	         */
	        this.polyMouseOut = new core_1.EventEmitter();
	        /**
	         * This event is fired on Polygon mouseover.
	         */
	        this.polyMouseOver = new core_1.EventEmitter();
	        /**
	         * This event is fired whe the DOM mouseup event is fired on the Polygon
	         */
	        this.polyMouseUp = new core_1.EventEmitter();
	        /**
	         * This even is fired when the Polygon is right-clicked on.
	         */
	        this.polyRightClick = new core_1.EventEmitter();
	        this._polygonAddedToManager = false;
	        this._subscriptions = [];
	    }
	    /** @internal */
	    SebmGoogleMapPolygon.prototype.ngAfterContentInit = function () {
	        if (!this._polygonAddedToManager) {
	            this._init();
	        }
	    };
	    SebmGoogleMapPolygon.prototype.ngOnChanges = function (changes) {
	        if (!this._polygonAddedToManager) {
	            this._init();
	            return;
	        }
	        this._polygonManager.setPolygonOptions(this, this._updatePolygonOptions(changes));
	    };
	    SebmGoogleMapPolygon.prototype._init = function () {
	        this._polygonManager.addPolygon(this);
	        this._polygonAddedToManager = true;
	        this._addEventListeners();
	    };
	    SebmGoogleMapPolygon.prototype._addEventListeners = function () {
	        var _this = this;
	        var handlers = [
	            { name: 'click', handler: function (ev) { return _this.polyClick.emit(ev); } },
	            { name: 'dbclick', handler: function (ev) { return _this.polyDblClick.emit(ev); } },
	            { name: 'drag', handler: function (ev) { return _this.polyDrag.emit(ev); } },
	            { name: 'dragend', handler: function (ev) { return _this.polyDragEnd.emit(ev); } },
	            { name: 'dragstart', handler: function (ev) { return _this.polyDragStart.emit(ev); } },
	            { name: 'mousedown', handler: function (ev) { return _this.polyMouseDown.emit(ev); } },
	            { name: 'mousemove', handler: function (ev) { return _this.polyMouseMove.emit(ev); } },
	            { name: 'mouseout', handler: function (ev) { return _this.polyMouseOut.emit(ev); } },
	            { name: 'mouseover', handler: function (ev) { return _this.polyMouseOver.emit(ev); } },
	            { name: 'mouseup', handler: function (ev) { return _this.polyMouseUp.emit(ev); } },
	            { name: 'rightclick', handler: function (ev) { return _this.polyRightClick.emit(ev); } },
	        ];
	        handlers.forEach(function (obj) {
	            var os = _this._polygonManager.createEventObservable(obj.name, _this).subscribe(obj.handler);
	            _this._subscriptions.push(os);
	        });
	    };
	    SebmGoogleMapPolygon.prototype._updatePolygonOptions = function (changes) {
	        return Object.keys(changes)
	            .filter(function (k) { return SebmGoogleMapPolygon._polygonOptionsAttributes.indexOf(k) !== -1; })
	            .reduce(function (obj, k) {
	            obj[k] = changes[k].currentValue;
	            return obj;
	        }, {});
	    };
	    /** @internal */
	    SebmGoogleMapPolygon.prototype.id = function () { return this._id; };
	    /** @internal */
	    SebmGoogleMapPolygon.prototype.ngOnDestroy = function () {
	        this._polygonManager.deletePolygon(this);
	        // unsubscribe all registered observable subscriptions
	        this._subscriptions.forEach(function (s) { return s.unsubscribe(); });
	    };
	    SebmGoogleMapPolygon._polygonOptionsAttributes = [
	        'clickable', 'draggable', 'editable', 'fillColor', 'fillOpacity', 'geodesic', 'icon', 'map',
	        'paths', 'strokeColor', 'strokeOpacity', 'strokeWeight', 'visible', 'zIndex', 'draggable',
	        'editable', 'visible'
	    ];
	    SebmGoogleMapPolygon.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: 'sebm-map-polygon',
	                    inputs: [
	                        'clickable',
	                        'draggable: polyDraggable',
	                        'editable',
	                        'fillColor',
	                        'fillOpacity',
	                        'geodesic',
	                        'paths',
	                        'strokeColor',
	                        'strokeOpacity',
	                        'strokeWeight',
	                        'visible',
	                        'zIndex',
	                    ],
	                    outputs: [
	                        'polyClick', 'polyDblClick', 'polyDrag', 'polyDragEnd', 'polyMouseDown', 'polyMouseMove',
	                        'polyMouseOut', 'polyMouseOver', 'polyMouseUp', 'polyRightClick'
	                    ]
	                },] },
	    ];
	    /** @nocollapse */
	    SebmGoogleMapPolygon.ctorParameters = function () { return [
	        { type: polygon_manager_1.PolygonManager, },
	    ]; };
	    return SebmGoogleMapPolygon;
	}());
	exports.SebmGoogleMapPolygon = SebmGoogleMapPolygon;
	//# sourceMappingURL=google-map-polygon.js.map

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var polyline_manager_1 = __webpack_require__(163);
	var google_map_polyline_point_1 = __webpack_require__(171);
	var polylineId = 0;
	/**
	 * SebmGoogleMapPolyline renders a polyline on a {@link SebmGoogleMap}
	 *
	 * ### Example
	 * ```typescript
	 * import { Component } from 'angular2/core';
	 * import { SebmGoogleMap, SebmGooglePolyline, SebmGooglePolylinePoint } from
	 * 'angular2-google-maps/core';
	 *
	 * @Component({
	 *  selector: 'my-map-cmp',
	 *  directives: [SebmGoogleMap, SebmGooglePolyline, SebmGooglePolylinePoint],
	 *  styles: [`
	 *    .sebm-google-map-container {
	 *      height: 300px;
	 *    }
	 * `],
	 *  template: `
	 *    <sebm-google-map [latitude]="lat" [longitude]="lng" [zoom]="zoom">
	 *      <sebm-google-map-polyline>
	 *          <sebm-google-map-polyline-point [latitude]="latA" [longitude]="lngA">
	 *          </sebm-google-map-polyline-point>
	 *          <sebm-google-map-polyline-point [latitude]="latB" [longitude]="lngB">
	 *          </sebm-google-map-polyline-point>
	 *      </sebm-google-map-polyline>
	 *    </sebm-google-map>
	 *  `
	 * })
	 * ```
	 */
	var SebmGoogleMapPolyline = (function () {
	    function SebmGoogleMapPolyline(_polylineManager) {
	        this._polylineManager = _polylineManager;
	        /**
	         * Indicates whether this Polyline handles mouse events. Defaults to true.
	         */
	        this.clickable = true;
	        /**
	         * If set to true, the user can drag this shape over the map. The geodesic property defines the
	         * mode of dragging. Defaults to false.
	         */
	        this.draggable = false;
	        /**
	         * If set to true, the user can edit this shape by dragging the control points shown at the
	         * vertices and on each segment. Defaults to false.
	         */
	        this.editable = false;
	        /**
	         * When true, edges of the polygon are interpreted as geodesic and will follow the curvature of
	         * the Earth. When false, edges of the polygon are rendered as straight lines in screen space.
	         * Note that the shape of a geodesic polygon may appear to change when dragged, as the dimensions
	         * are maintained relative to the surface of the earth. Defaults to false.
	         */
	        this.geodesic = false;
	        /**
	         * Whether this polyline is visible on the map. Defaults to true.
	         */
	        this.visible = true;
	        /**
	         * This event is fired when the DOM click event is fired on the Polyline.
	         */
	        this.lineClick = new core_1.EventEmitter();
	        /**
	         * This event is fired when the DOM dblclick event is fired on the Polyline.
	         */
	        this.lineDblClick = new core_1.EventEmitter();
	        /**
	         * This event is repeatedly fired while the user drags the polyline.
	         */
	        this.lineDrag = new core_1.EventEmitter();
	        /**
	         * This event is fired when the user stops dragging the polyline.
	         */
	        this.lineDragEnd = new core_1.EventEmitter();
	        /**
	         * This event is fired when the user starts dragging the polyline.
	         */
	        this.lineDragStart = new core_1.EventEmitter();
	        /**
	         * This event is fired when the DOM mousedown event is fired on the Polyline.
	         */
	        this.lineMouseDown = new core_1.EventEmitter();
	        /**
	         * This event is fired when the DOM mousemove event is fired on the Polyline.
	         */
	        this.lineMouseMove = new core_1.EventEmitter();
	        /**
	         * This event is fired on Polyline mouseout.
	         */
	        this.lineMouseOut = new core_1.EventEmitter();
	        /**
	         * This event is fired on Polyline mouseover.
	         */
	        this.lineMouseOver = new core_1.EventEmitter();
	        /**
	         * This event is fired whe the DOM mouseup event is fired on the Polyline
	         */
	        this.lineMouseUp = new core_1.EventEmitter();
	        /**
	         * This even is fired when the Polyline is right-clicked on.
	         */
	        this.lineRightClick = new core_1.EventEmitter();
	        this._polylineAddedToManager = false;
	        this._subscriptions = [];
	        this._id = (polylineId++).toString();
	    }
	    /** @internal */
	    SebmGoogleMapPolyline.prototype.ngAfterContentInit = function () {
	        var _this = this;
	        if (this.points.length) {
	            this.points.forEach(function (point) {
	                var s = point.positionChanged.subscribe(function () { _this._polylineManager.updatePolylinePoints(_this); });
	                _this._subscriptions.push(s);
	            });
	        }
	        if (!this._polylineAddedToManager) {
	            this._init();
	        }
	        var s = this.points.changes.subscribe(function () { return _this._polylineManager.updatePolylinePoints(_this); });
	        this._subscriptions.push(s);
	        this._polylineManager.updatePolylinePoints(this);
	    };
	    SebmGoogleMapPolyline.prototype.ngOnChanges = function (changes) {
	        if (!this._polylineAddedToManager) {
	            this._init();
	            return;
	        }
	        var options = {};
	        var optionKeys = Object.keys(changes).filter(function (k) { return SebmGoogleMapPolyline._polylineOptionsAttributes.indexOf(k) !== -1; });
	        optionKeys.forEach(function (k) { return options[k] = changes[k].currentValue; });
	        this._polylineManager.setPolylineOptions(this, options);
	    };
	    SebmGoogleMapPolyline.prototype._init = function () {
	        this._polylineManager.addPolyline(this);
	        this._polylineAddedToManager = true;
	        this._addEventListeners();
	    };
	    SebmGoogleMapPolyline.prototype._addEventListeners = function () {
	        var _this = this;
	        var handlers = [
	            { name: 'click', handler: function (ev) { return _this.lineClick.emit(ev); } },
	            { name: 'dbclick', handler: function (ev) { return _this.lineDblClick.emit(ev); } },
	            { name: 'drag', handler: function (ev) { return _this.lineDrag.emit(ev); } },
	            { name: 'dragend', handler: function (ev) { return _this.lineDragEnd.emit(ev); } },
	            { name: 'dragstart', handler: function (ev) { return _this.lineDragStart.emit(ev); } },
	            { name: 'mousedown', handler: function (ev) { return _this.lineMouseDown.emit(ev); } },
	            { name: 'mousemove', handler: function (ev) { return _this.lineMouseMove.emit(ev); } },
	            { name: 'mouseout', handler: function (ev) { return _this.lineMouseOut.emit(ev); } },
	            { name: 'mouseover', handler: function (ev) { return _this.lineMouseOver.emit(ev); } },
	            { name: 'mouseup', handler: function (ev) { return _this.lineMouseUp.emit(ev); } },
	            { name: 'rightclick', handler: function (ev) { return _this.lineRightClick.emit(ev); } },
	        ];
	        handlers.forEach(function (obj) {
	            var os = _this._polylineManager.createEventObservable(obj.name, _this).subscribe(obj.handler);
	            _this._subscriptions.push(os);
	        });
	    };
	    /** @internal */
	    SebmGoogleMapPolyline.prototype._getPoints = function () {
	        if (this.points) {
	            return this.points.toArray();
	        }
	        return [];
	    };
	    /** @internal */
	    SebmGoogleMapPolyline.prototype.id = function () { return this._id; };
	    /** @internal */
	    SebmGoogleMapPolyline.prototype.ngOnDestroy = function () {
	        this._polylineManager.deletePolyline(this);
	        // unsubscribe all registered observable subscriptions
	        this._subscriptions.forEach(function (s) { return s.unsubscribe(); });
	    };
	    SebmGoogleMapPolyline._polylineOptionsAttributes = [
	        'draggable', 'editable', 'visible', 'geodesic', 'strokeColor', 'strokeOpacity', 'strokeWeight',
	        'zIndex'
	    ];
	    SebmGoogleMapPolyline.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: 'sebm-google-map-polyline',
	                    inputs: [
	                        'clickable', 'draggable: polylineDraggable', 'editable', 'geodesic', 'strokeColor',
	                        'strokeWeight', 'strokeOpacity', 'visible', 'zIndex'
	                    ],
	                    outputs: [
	                        'lineClick', 'lineDblClick', 'lineDrag', 'lineDragEnd', 'lineMouseDown', 'lineMouseMove',
	                        'lineMouseOut', 'lineMouseOver', 'lineMouseUp', 'lineRightClick'
	                    ]
	                },] },
	    ];
	    /** @nocollapse */
	    SebmGoogleMapPolyline.ctorParameters = function () { return [
	        { type: polyline_manager_1.PolylineManager, },
	    ]; };
	    SebmGoogleMapPolyline.propDecorators = {
	        'points': [{ type: core_1.ContentChildren, args: [google_map_polyline_point_1.SebmGoogleMapPolylinePoint,] },],
	    };
	    return SebmGoogleMapPolyline;
	}());
	exports.SebmGoogleMapPolyline = SebmGoogleMapPolyline;
	//# sourceMappingURL=google-map-polyline.js.map

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	/**
	 * SebmGoogleMapPolylinePoint represents one element of a polyline within a  {@link
	 * SembGoogleMapPolyline}
	 */
	var SebmGoogleMapPolylinePoint = (function () {
	    function SebmGoogleMapPolylinePoint() {
	        /**
	         * This event emitter gets emitted when the position of the point changed.
	         */
	        this.positionChanged = new core_1.EventEmitter();
	    }
	    SebmGoogleMapPolylinePoint.prototype.ngOnChanges = function (changes) {
	        if (changes['latitude'] || changes['longitude']) {
	            var position = {
	                lat: changes['latitude'].currentValue,
	                lng: changes['longitude'].currentValue
	            };
	            this.positionChanged.emit(position);
	        }
	    };
	    SebmGoogleMapPolylinePoint.decorators = [
	        { type: core_1.Directive, args: [{ selector: 'sebm-google-map-polyline-point' },] },
	    ];
	    /** @nocollapse */
	    SebmGoogleMapPolylinePoint.ctorParameters = function () { return []; };
	    SebmGoogleMapPolylinePoint.propDecorators = {
	        'latitude': [{ type: core_1.Input },],
	        'longitude': [{ type: core_1.Input },],
	        'positionChanged': [{ type: core_1.Output },],
	    };
	    return SebmGoogleMapPolylinePoint;
	}());
	exports.SebmGoogleMapPolylinePoint = SebmGoogleMapPolylinePoint;
	//# sourceMappingURL=google-map-polyline-point.js.map

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var google_maps_api_wrapper_1 = __webpack_require__(157);
	exports.GoogleMapsAPIWrapper = google_maps_api_wrapper_1.GoogleMapsAPIWrapper;
	var circle_manager_1 = __webpack_require__(159);
	exports.CircleManager = circle_manager_1.CircleManager;
	var info_window_manager_1 = __webpack_require__(160);
	exports.InfoWindowManager = info_window_manager_1.InfoWindowManager;
	var marker_manager_1 = __webpack_require__(161);
	exports.MarkerManager = marker_manager_1.MarkerManager;
	var polygon_manager_1 = __webpack_require__(162);
	exports.PolygonManager = polygon_manager_1.PolygonManager;
	var polyline_manager_1 = __webpack_require__(163);
	exports.PolylineManager = polyline_manager_1.PolylineManager;
	var kml_layer_manager_1 = __webpack_require__(164);
	exports.KmlLayerManager = kml_layer_manager_1.KmlLayerManager;
	var lazy_maps_api_loader_1 = __webpack_require__(173);
	exports.GoogleMapsScriptProtocol = lazy_maps_api_loader_1.GoogleMapsScriptProtocol;
	exports.LAZY_MAPS_API_CONFIG = lazy_maps_api_loader_1.LAZY_MAPS_API_CONFIG;
	exports.LazyMapsAPILoader = lazy_maps_api_loader_1.LazyMapsAPILoader;
	var maps_api_loader_1 = __webpack_require__(158);
	exports.MapsAPILoader = maps_api_loader_1.MapsAPILoader;
	var noop_maps_api_loader_1 = __webpack_require__(175);
	exports.NoOpMapsAPILoader = noop_maps_api_loader_1.NoOpMapsAPILoader;
	//# sourceMappingURL=services.js.map

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var core_1 = __webpack_require__(3);
	var browser_globals_1 = __webpack_require__(174);
	var maps_api_loader_1 = __webpack_require__(158);
	(function (GoogleMapsScriptProtocol) {
	    GoogleMapsScriptProtocol[GoogleMapsScriptProtocol["HTTP"] = 1] = "HTTP";
	    GoogleMapsScriptProtocol[GoogleMapsScriptProtocol["HTTPS"] = 2] = "HTTPS";
	    GoogleMapsScriptProtocol[GoogleMapsScriptProtocol["AUTO"] = 3] = "AUTO";
	})(exports.GoogleMapsScriptProtocol || (exports.GoogleMapsScriptProtocol = {}));
	var GoogleMapsScriptProtocol = exports.GoogleMapsScriptProtocol;
	/**
	 * Token for the config of the LazyMapsAPILoader. Please provide an object of type {@link
	 * LazyMapsAPILoaderConfig}.
	 */
	exports.LAZY_MAPS_API_CONFIG = new core_1.OpaqueToken('angular2-google-maps LAZY_MAPS_API_CONFIG');
	var LazyMapsAPILoader = (function (_super) {
	    __extends(LazyMapsAPILoader, _super);
	    function LazyMapsAPILoader(config, w, d) {
	        _super.call(this);
	        this._config = config || {};
	        this._windowRef = w;
	        this._documentRef = d;
	    }
	    LazyMapsAPILoader.prototype.load = function () {
	        var _this = this;
	        if (this._scriptLoadingPromise) {
	            return this._scriptLoadingPromise;
	        }
	        var script = this._documentRef.getNativeDocument().createElement('script');
	        script.type = 'text/javascript';
	        script.async = true;
	        script.defer = true;
	        var callbackName = "angular2GoogleMapsLazyMapsAPILoader";
	        script.src = this._getScriptSrc(callbackName);
	        this._scriptLoadingPromise = new Promise(function (resolve, reject) {
	            _this._windowRef.getNativeWindow()[callbackName] = function () { resolve(); };
	            script.onerror = function (error) { reject(error); };
	        });
	        this._documentRef.getNativeDocument().body.appendChild(script);
	        return this._scriptLoadingPromise;
	    };
	    LazyMapsAPILoader.prototype._getScriptSrc = function (callbackName) {
	        var protocolType = (this._config && this._config.protocol) || GoogleMapsScriptProtocol.HTTPS;
	        var protocol;
	        switch (protocolType) {
	            case GoogleMapsScriptProtocol.AUTO:
	                protocol = '';
	                break;
	            case GoogleMapsScriptProtocol.HTTP:
	                protocol = 'http:';
	                break;
	            case GoogleMapsScriptProtocol.HTTPS:
	                protocol = 'https:';
	                break;
	        }
	        var hostAndPath = this._config.hostAndPath || 'maps.googleapis.com/maps/api/js';
	        var queryParams = {
	            v: this._config.apiVersion || '3',
	            callback: callbackName,
	            key: this._config.apiKey,
	            client: this._config.clientId,
	            channel: this._config.channel,
	            libraries: this._config.libraries,
	            region: this._config.region,
	            language: this._config.language
	        };
	        var params = Object.keys(queryParams)
	            .filter(function (k) { return queryParams[k] != null; })
	            .filter(function (k) {
	            // remove empty arrays
	            return !Array.isArray(queryParams[k]) ||
	                (Array.isArray(queryParams[k]) && queryParams[k].length > 0);
	        })
	            .map(function (k) {
	            // join arrays as comma seperated strings
	            var i = queryParams[k];
	            if (Array.isArray(i)) {
	                return { key: k, value: i.join(',') };
	            }
	            return { key: k, value: queryParams[k] };
	        })
	            .map(function (entry) { return entry.key + "=" + entry.value; })
	            .join('&');
	        return protocol + "//" + hostAndPath + "?" + params;
	    };
	    LazyMapsAPILoader.decorators = [
	        { type: core_1.Injectable },
	    ];
	    /** @nocollapse */
	    LazyMapsAPILoader.ctorParameters = function () { return [
	        { type: undefined, decorators: [{ type: core_1.Inject, args: [exports.LAZY_MAPS_API_CONFIG,] },] },
	        { type: browser_globals_1.WindowRef, },
	        { type: browser_globals_1.DocumentRef, },
	    ]; };
	    return LazyMapsAPILoader;
	}(maps_api_loader_1.MapsAPILoader));
	exports.LazyMapsAPILoader = LazyMapsAPILoader;
	//# sourceMappingURL=lazy-maps-api-loader.js.map

/***/ },
/* 174 */
/***/ function(module, exports) {

	"use strict";
	var WindowRef = (function () {
	    function WindowRef() {
	    }
	    WindowRef.prototype.getNativeWindow = function () { return window; };
	    return WindowRef;
	}());
	exports.WindowRef = WindowRef;
	var DocumentRef = (function () {
	    function DocumentRef() {
	    }
	    DocumentRef.prototype.getNativeDocument = function () { return document; };
	    return DocumentRef;
	}());
	exports.DocumentRef = DocumentRef;
	exports.BROWSER_GLOBALS_PROVIDERS = [WindowRef, DocumentRef];
	//# sourceMappingURL=browser-globals.js.map

/***/ },
/* 175 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * When using the NoOpMapsAPILoader, the Google Maps API must be added to the page via a `<script>`
	 * Tag.
	 * It's important that the Google Maps API script gets loaded first on the page.
	 */
	var NoOpMapsAPILoader = (function () {
	    function NoOpMapsAPILoader() {
	    }
	    NoOpMapsAPILoader.prototype.load = function () {
	        if (!window.google || !window.google.maps) {
	            throw new Error('Google Maps API not loaded on page. Make sure window.google.maps is available!');
	        }
	        return Promise.resolve();
	    };
	    ;
	    return NoOpMapsAPILoader;
	}());
	exports.NoOpMapsAPILoader = NoOpMapsAPILoader;
	//# sourceMappingURL=noop-maps-api-loader.js.map

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var google_map_kml_layer_1 = __webpack_require__(167);
	var google_map_1 = __webpack_require__(156);
	var google_map_circle_1 = __webpack_require__(165);
	var google_map_info_window_1 = __webpack_require__(166);
	var google_map_marker_1 = __webpack_require__(168);
	var google_map_polygon_1 = __webpack_require__(169);
	var google_map_polyline_1 = __webpack_require__(170);
	var google_map_polyline_point_1 = __webpack_require__(171);
	var lazy_maps_api_loader_1 = __webpack_require__(173);
	var lazy_maps_api_loader_2 = __webpack_require__(173);
	var maps_api_loader_1 = __webpack_require__(158);
	var browser_globals_1 = __webpack_require__(174);
	/**
	 * @internal
	 */
	function coreDirectives() {
	    return [
	        google_map_1.SebmGoogleMap, google_map_marker_1.SebmGoogleMapMarker, google_map_info_window_1.SebmGoogleMapInfoWindow, google_map_circle_1.SebmGoogleMapCircle,
	        google_map_polygon_1.SebmGoogleMapPolygon, google_map_polyline_1.SebmGoogleMapPolyline, google_map_polyline_point_1.SebmGoogleMapPolylinePoint, google_map_kml_layer_1.SebmGoogleMapKmlLayer
	    ];
	}
	exports.coreDirectives = coreDirectives;
	;
	/**
	 * The angular2-google-maps core module. Contains all Directives/Services/Pipes
	 * of the core module. Please use `AgmCoreModule.forRoot()` in your app module.
	 */
	var AgmCoreModule = (function () {
	    function AgmCoreModule() {
	    }
	    /**
	     * Please use this method when you register the module at the root level.
	     */
	    AgmCoreModule.forRoot = function (lazyMapsAPILoaderConfig) {
	        return {
	            ngModule: AgmCoreModule,
	            providers: browser_globals_1.BROWSER_GLOBALS_PROVIDERS.concat([
	                { provide: maps_api_loader_1.MapsAPILoader, useClass: lazy_maps_api_loader_1.LazyMapsAPILoader },
	                { provide: lazy_maps_api_loader_2.LAZY_MAPS_API_CONFIG, useValue: lazyMapsAPILoaderConfig }
	            ]),
	        };
	    };
	    AgmCoreModule.decorators = [
	        { type: core_1.NgModule, args: [{ declarations: coreDirectives(), exports: coreDirectives() },] },
	    ];
	    /** @nocollapse */
	    AgmCoreModule.ctorParameters = function () { return []; };
	    return AgmCoreModule;
	}());
	exports.AgmCoreModule = AgmCoreModule;
	//# sourceMappingURL=core-module.js.map

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(76);
	var main_service_1 = __webpack_require__(178);
	var MainComponent = (function () {
	    function MainComponent(_parentRouter, _mainService, route) {
	        this._mainService = _mainService;
	        this.route = route;
	        this.isCollapsed = false;
	        this.toggledFilters = false;
	        this.searchFilter = "";
	        this.router = _parentRouter;
	        this.selectedLanguage = "";
	        this.userName = "";
	        this.userRole = "guest";
	        //this.setUserRole(this.userRole);
	        this.classLoginModal = { 'model': true, 'show': false, 'hide': true };
	        this.classForgetPasswordModal = { 'model': true, 'show': false, 'hide': true };
	        this.classEmailSendedModal = { 'model': true, 'show': false, 'hide': true };
	        this.emailSended = false;
	        this.forgetPasswordEmailEmpty = false;
	        this.forgetPasswordEmailIncorrect = false;
	        this.loginEmail = "";
	        this.forgetPasswordEmail = "";
	        this.loginPassword = "";
	        this.loginCode = 0;
	        this.categoryTypeFilter = null;
	        this.sellerTypeFilter = null;
	        this.citiesFilter = [];
	        this.tagsFilter = [];
	        this.citiesIds = [];
	        this.tagsIds = [];
	        this.elementsThatContainsSearchValueById = [];
	        this.elementsThatContainsSearchValueByName = [];
	        this.nMessages = 0;
	    }
	    MainComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.selectedLanguage = this._mainService.getLanguage();
	        this.applyFilters();
	        this._mainService.getUserStatus().then(function (status) {
	            _this.userRole = status.role;
	            localStorage.setItem("userRole", _this.userRole);
	            _this.setUserRole(_this.userRole);
	            if (_this.userRole == "admin" || _this.userRole == "superuser" || _this.userRole == "user") {
	                _this.userName = _this._mainService.getUserName();
	                _this._mainService.getUnreadMessages().then(function (res) {
	                    if (res != null) {
	                        _this.nMessages = res.length;
	                    }
	                });
	            }
	        });
	        this.toggledFilters = false;
	    };
	    MainComponent.prototype.applyFilters = function () {
	        console.log(this.route.snapshot.firstChild.params);
	        var category = this.route.snapshot.firstChild.params['categoryType'];
	        if (category != null && category != undefined && category != "null" && category != "" && category != "undefined") {
	            this.categoryTypeFilter = category;
	        }
	        var seller = this.route.snapshot.firstChild.params['sellerType'];
	        if (seller != null && seller != undefined && seller != "null" && seller != "" && seller != "undefined") {
	            this.sellerTypeFilter = seller;
	        }
	        var citiesParam = this.route.snapshot.firstChild.params['citiesFilter'];
	        if (citiesParam != null && citiesParam != undefined && citiesParam != "null" && citiesParam != "" && citiesParam != "undefined") {
	            var cities = citiesParam.split("+");
	            for (var i = 0; i < cities.length; i++) {
	                this.citiesIds.push(Number(cities[i]));
	            }
	        }
	        var tagsParam = this.route.snapshot.firstChild.params['tagsFilter'];
	        if (tagsParam != null && tagsParam != undefined && tagsParam != "null" && tagsParam != "" && tagsParam != "undefined") {
	            var tags = tagsParam.split("+");
	            for (var i = 0; i < tags.length; i++) {
	                this.tagsIds.push(Number(tags[i]));
	            }
	        }
	    };
	    MainComponent.prototype.getLanguageColor = function (lang) {
	        if (this.selectedLanguage.toUpperCase() == lang) {
	            return "#6fb3cb";
	        }
	        else {
	            return "#ffffff";
	        }
	    };
	    MainComponent.prototype.setUserRole = function (userRole) {
	        if (userRole == "guest") {
	            this.userIsGuest = true;
	            this.userIsSuperUser = false;
	            this.userIsAdmin = false;
	        }
	        else if (userRole == "user") {
	            this.userIsGuest = false;
	            this.userIsSuperUser = true;
	            this.userIsAdmin = false;
	        }
	        else if (userRole == "superuser") {
	            this.userIsGuest = false;
	            this.userIsSuperUser = true;
	            this.userIsAdmin = false;
	        }
	        else if (userRole == "admin") {
	            this.userIsGuest = false;
	            this.userIsSuperUser = false;
	            this.userIsAdmin = true;
	        }
	    };
	    MainComponent.prototype.languageClicked = function (lang) {
	        if (this.selectedLanguage.toUpperCase() != lang.toUpperCase()) {
	            this.selectedLanguage = lang;
	            localStorage.setItem("language", lang);
	            location.reload();
	        }
	    };
	    MainComponent.prototype.accesButtonClicked = function () {
	        if (this.userRole == "guest") {
	            this.classLoginModal.show = true;
	            this.classLoginModal.hide = false;
	        }
	        else if (this.userRole == "superuser" || this.userRole == "admin" || this.userRole == "user") {
	            localStorage.removeItem('token');
	            localStorage.removeItem('userName');
	            localStorage.removeItem('idUser');
	            localStorage.removeItem('lang');
	            this.router.navigate(['/main', 'dashboard']);
	            location.reload();
	        }
	    };
	    MainComponent.prototype.toFavoritesClicked = function () {
	        if (this.userRole == "guest") {
	            this.accesButtonClicked();
	        }
	        else {
	            this.router.navigate(['/main', 'favorites']);
	        }
	    };
	    MainComponent.prototype.toMessagesClicked = function () {
	        if (this.userRole == "guest") {
	            this.accesButtonClicked();
	        }
	        else {
	            this.router.navigate(['/main', 'messages']);
	        }
	    };
	    MainComponent.prototype.toProfileClicked = function () {
	        var _this = this;
	        if (this.userRole == "superuser" || this.userRole == "admin") {
	            this._mainService.getUserStatus().then(function (res) {
	                localStorage.setItem("userActive", res.active);
	                _this.router.navigate(['/superuser', 'dashboard']);
	            });
	        }
	        else {
	            this.router.navigate(['/main', 'profile']);
	        }
	    };
	    MainComponent.prototype.categoryTypeClicked = function (categoryType) {
	        if (this.categoryTypeFilter != categoryType) {
	            this.categoryTypeFilter = categoryType;
	        }
	        else {
	            this.categoryTypeFilter = null;
	        }
	        var search_filter;
	        if (this.searchFilter == "" || this.searchFilter == null || this.searchFilter == undefined) {
	            search_filter = null;
	        }
	        else {
	            search_filter = this.searchFilter;
	        }
	        this.router.navigate(['/main', 'dashboard', { categoryType: this.categoryTypeFilter, sellerType: this.sellerTypeFilter, citiesFilter: this.arrayToStringByDelimeter(this.citiesFilter, "+"), tagsFilter: this.arrayToStringByDelimeter(this.tagsFilter, "+"), searchFilter: search_filter }]);
	    };
	    MainComponent.prototype.sellerTypeClicked = function (sellerType) {
	        if (this.sellerTypeFilter != sellerType) {
	            this.sellerTypeFilter = sellerType;
	        }
	        else {
	            this.sellerTypeFilter = null;
	        }
	        var search_filter;
	        if (this.searchFilter == "" || this.searchFilter == null || this.searchFilter == undefined) {
	            search_filter = null;
	        }
	        else {
	            search_filter = this.searchFilter;
	        }
	        this.router.navigate(['/main', 'dashboard', { categoryType: this.categoryTypeFilter, sellerType: this.sellerTypeFilter, citiesFilter: this.arrayToStringByDelimeter(this.citiesFilter, "+"), tagsFilter: this.arrayToStringByDelimeter(this.tagsFilter, "+"), searchFilter: search_filter }]);
	    };
	    MainComponent.prototype.getSellerType = function (sellerType) {
	        return (sellerType == this.sellerTypeFilter);
	    };
	    MainComponent.prototype.getSellerTypeColor = function (sellerType) {
	        if (sellerType == this.sellerTypeFilter) {
	            return "#6fb3cb";
	        }
	        else {
	            return "black";
	        }
	    };
	    MainComponent.prototype.getSellerSelection = function (sellerType) {
	        return sellerType == this.sellerTypeFilter;
	    };
	    MainComponent.prototype.getCategoryType = function (categoryType) {
	        return categoryType == this.categoryTypeFilter;
	    };
	    MainComponent.prototype.getCategoryTypeColor = function (categoryType) {
	        if (categoryType == this.categoryTypeFilter) {
	            return "#6fb3cb";
	        }
	        else {
	            return "black";
	        }
	    };
	    MainComponent.prototype.getCategorySelection = function (categoryType) {
	        return categoryType == this.categoryTypeFilter;
	    };
	    MainComponent.prototype.selectedCitiesReceived = function (event) {
	        console.log("WE RECEIVED!");
	        this.citiesFilter = event.value;
	        var search_filter;
	        if (this.searchFilter == "" || this.searchFilter == null || this.searchFilter == undefined) {
	            search_filter = null;
	        }
	        else {
	            search_filter = this.searchFilter;
	        }
	        this.router.navigate(['/main', 'dashboard', { categoryType: this.categoryTypeFilter, sellerType: this.sellerTypeFilter, citiesFilter: this.arrayToStringByDelimeter(this.citiesFilter, "+"), tagsFilter: this.arrayToStringByDelimeter(this.tagsFilter, "+"), searchFilter: search_filter }]);
	    };
	    MainComponent.prototype.selectedTagsReceived = function (event) {
	        this.tagsFilter = event.value;
	        var search_filter;
	        if (this.searchFilter == "" || this.searchFilter == null || this.searchFilter == undefined) {
	            search_filter = null;
	        }
	        else {
	            search_filter = this.searchFilter;
	        }
	        this.router.navigate(['/main', 'dashboard', { categoryType: this.categoryTypeFilter, sellerType: this.sellerTypeFilter, citiesFilter: this.arrayToStringByDelimeter(this.citiesFilter, "+"), tagsFilter: this.arrayToStringByDelimeter(this.tagsFilter, "+"), searchFilter: search_filter }]);
	    };
	    MainComponent.prototype.closeLoginModal = function () {
	        this.loginCode = 0;
	        this.classLoginModal.show = false;
	        this.classLoginModal.hide = true;
	    };
	    MainComponent.prototype.loginClicked = function () {
	        var _this = this;
	        this._mainService.login(this.loginEmail, this.loginPassword).subscribe(function (result) {
	            _this.loginCode = result.code;
	            if (result !== null && result.token !== undefined) {
	                localStorage.setItem('userName', result.user.name);
	                localStorage.setItem('idUser', result.user.id.toString());
	                _this._mainService.getUserLanguage().then(function (res) {
	                    if (res == 1) {
	                        localStorage.setItem("language", "cat");
	                    }
	                    else if (res == 2) {
	                        localStorage.setItem("language", "esp");
	                    }
	                    location.reload();
	                });
	            }
	        });
	    };
	    MainComponent.prototype.registerClicked = function () {
	        this.router.navigate(['/register']);
	    };
	    MainComponent.prototype.arrayToStringByDelimeter = function (array, delimeter) {
	        var res = "";
	        for (var i = 0; i < array.length; i++) {
	            res += array[i].id;
	            if (i < array.length - 1) {
	                res += delimeter;
	            }
	        }
	        if (res != "") {
	            return res;
	        }
	        else {
	            return null;
	        }
	    };
	    MainComponent.prototype.collapse = function () {
	        this.isCollapsed = true;
	    };
	    MainComponent.prototype.noCollapse = function () {
	        this.isCollapsed = false;
	    };
	    MainComponent.prototype.forgetPassword = function () {
	        this.classLoginModal.show = false;
	        this.classLoginModal.hide = true;
	        this.classForgetPasswordModal.show = true;
	        this.classForgetPasswordModal.hide = false;
	    };
	    MainComponent.prototype.getPasswordByEmail = function () {
	        var _this = this;
	        if (this.forgetPasswordEmail != undefined && this.forgetPasswordEmail != null && this.forgetPasswordEmail != "") {
	            this.forgetPasswordEmailEmpty = false;
	            this._mainService.verifyEmail(this.forgetPasswordEmail).then(function (res) {
	                if (res) {
	                    _this.forgetPasswordEmailIncorrect = false;
	                    _this._mainService.sendEmailRecoverPassword(_this.forgetPasswordEmail).then(function (res) {
	                        if (res == 1) {
	                            _this.classForgetPasswordModal.show = false;
	                            _this.classForgetPasswordModal.hide = true;
	                            _this.forgetPasswordEmailEmpty = false;
	                            _this.forgetPasswordEmailIncorrect = false;
	                            _this.classEmailSendedModal.show = true;
	                            _this.classEmailSendedModal.hide = false;
	                        }
	                    });
	                }
	                else {
	                    _this.forgetPasswordEmailIncorrect = true;
	                }
	            });
	        }
	        else {
	            this.forgetPasswordEmailEmpty = true;
	        }
	    };
	    MainComponent.prototype.resendEmailRecoverPassword = function () {
	        var _this = this;
	        this._mainService.sendEmailRecoverPassword(this.forgetPasswordEmail).then(function (res) {
	            if (res == 1) {
	                _this.emailSended = true;
	            }
	        });
	    };
	    MainComponent.prototype.closeForgetPasswordModal = function () {
	        this.classForgetPasswordModal.show = false;
	        this.classForgetPasswordModal.hide = true;
	        this.forgetPasswordEmail = "";
	        this.forgetPasswordEmailEmpty = false;
	        this.forgetPasswordEmailIncorrect = false;
	    };
	    MainComponent.prototype.closeEmailSendedModal = function () {
	        this.classEmailSendedModal.show = false;
	        this.classEmailSendedModal.hide = true;
	        this.forgetPasswordEmail = "";
	        this.emailSended = false;
	    };
	    MainComponent.prototype.searchFilterChanged = function (event) {
	        var _this = this;
	        if (this.searchFilter.length > 0) {
	            if (event.key == "Enter") {
	                this.router.navigate(['/main', 'dashboard', { categoryType: this.categoryTypeFilter, sellerType: this.sellerTypeFilter, citiesFilter: this.arrayToStringByDelimeter(this.citiesFilter, "+"), tagsFilter: this.arrayToStringByDelimeter(this.tagsFilter, "+"), searchFilter: this.searchFilter }]);
	                this.elementsThatContainsSearchValueById = [];
	                this.elementsThatContainsSearchValueByName = [];
	            }
	            else {
	                if (this.userRole == "guest") {
	                    this._mainService.getElementsBySearchFilterValue(this.searchFilter).then(function (res) {
	                        _this.elementsThatContainsSearchValueById = [];
	                        _this.elementsThatContainsSearchValueByName = [];
	                        if (res != null) {
	                            for (var i = 0; i < res.length; i++) {
	                                var introduced = false;
	                                if (res[i].comercial_name.toUpperCase().includes(_this.searchFilter.toUpperCase()) && !introduced) {
	                                    _this.elementsThatContainsSearchValueByName.push(res[i]);
	                                    introduced = true;
	                                }
	                                if (res[i].id.toString().includes(_this.searchFilter) && !introduced) {
	                                    _this.elementsThatContainsSearchValueById.push(res[i]);
	                                    introduced = true;
	                                }
	                                if ((res[i].id.toString() + " " + res[i].comercial_name).toUpperCase().includes((_this.searchFilter.toUpperCase())) && !introduced) {
	                                    _this.elementsThatContainsSearchValueByName.push(res[i]);
	                                    introduced = true;
	                                }
	                            }
	                        }
	                    });
	                }
	                else {
	                    this._mainService.getElementsAuthenticatedBySearchFilterValue(this.searchFilter).then(function (res) {
	                        _this.elementsThatContainsSearchValueById = [];
	                        _this.elementsThatContainsSearchValueByName = [];
	                        if (res != null) {
	                            for (var i = 0; i < res.length; i++) {
	                                var introduced = false;
	                                if (res[i].comercial_name.toUpperCase().includes(_this.searchFilter.toUpperCase()) && !introduced) {
	                                    _this.elementsThatContainsSearchValueByName.push(res[i]);
	                                    introduced = true;
	                                }
	                                if (res[i].id.toString().includes(_this.searchFilter) && !introduced) {
	                                    _this.elementsThatContainsSearchValueById.push(res[i]);
	                                    introduced = true;
	                                }
	                                if ((res[i].id.toString() + " " + res[i].comercial_name).toUpperCase().includes((_this.searchFilter.toUpperCase())) && !introduced) {
	                                    _this.elementsThatContainsSearchValueByName.push(res[i]);
	                                    introduced = true;
	                                }
	                            }
	                        }
	                    });
	                }
	            }
	        }
	        else {
	            this.router.navigate(['/main', 'dashboard', { categoryType: this.categoryTypeFilter, sellerType: this.sellerTypeFilter, citiesFilter: this.arrayToStringByDelimeter(this.citiesFilter, "+"), tagsFilter: this.arrayToStringByDelimeter(this.tagsFilter, "+"), searchFilter: null }]);
	            this.elementsThatContainsSearchValueById = [];
	            this.elementsThatContainsSearchValueByName = [];
	        }
	    };
	    MainComponent.prototype.searchDataClicked = function (element) {
	        this.searchFilter = "";
	        this.elementsThatContainsSearchValueById = [];
	        this.elementsThatContainsSearchValueByName = [];
	        this.router.navigate(['/main', 'elementdetail', { categoryType: null, sellerType: null, citiesFilter: null, tagsFilter: null, elementId: element.id, scroll: document.body.scrollTop, scrollHeight: document.body.scrollHeight, loadedPage: 0 }]);
	    };
	    MainComponent.prototype.searchFilterFocusOut = function () {
	        var _this = this;
	        setTimeout(function () {
	            _this.elementsThatContainsSearchValueById = [];
	            _this.elementsThatContainsSearchValueByName = [];
	        }, 350);
	    };
	    MainComponent.prototype.getCurrentChildRoute = function () {
	        var fullUrl = this.router.url;
	        var urlWithoutParams = fullUrl.split(";")[0];
	        var urlSegments = urlWithoutParams.split("/");
	        return urlSegments[urlSegments.length - 1];
	    };
	    MainComponent.prototype.toMainDashboard = function () {
	        this.router.navigate(['/main', 'dashboard']);
	        setTimeout(function () {
	            location.reload();
	        }, 100);
	    };
	    MainComponent = __decorate([
	        core_1.Component({
	            selector: 'main',
	            template: __webpack_require__(179),
	            providers: [main_service_1.MainService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _a) || Object, (typeof (_b = typeof main_service_1.MainService !== 'undefined' && main_service_1.MainService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object])
	    ], MainComponent);
	    return MainComponent;
	    var _a, _b, _c;
	}());
	exports.MainComponent = MainComponent;


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(30);
	var Observable_1 = __webpack_require__(5);
	var ng2_translate_1 = __webpack_require__(29);
	var json = __webpack_require__(95);
	var MainService = (function () {
	    function MainService(_translateService, http) {
	        this._translateService = _translateService;
	        this.http = http;
	        this._mainUrl = "/mainData";
	        this.getTokenService();
	        this.serverURL = json.api_url;
	    }
	    MainService.prototype.getTokenService = function () {
	        this.token = localStorage.getItem('token');
	    };
	    MainService.prototype.getLanguage = function () {
	        return this._translateService.currentLang;
	    };
	    MainService.prototype.getUserStatus = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        if (token != null && token != "") {
	            authHeader.append('Authorization', 'Bearer ' + token);
	            var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	            return this.http.get(this.serverURL + '/loginData/userStatus', options).toPromise().then(function (res) {
	                if (JSON.parse(res.text()).code == -1) {
	                    return "guest";
	                }
	                else {
	                    return JSON.parse(res.text());
	                }
	            }).catch(this.handleError);
	        }
	        else {
	            return Promise.resolve({ role: "guest" });
	        }
	    };
	    MainService.prototype.getUserLanguage = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token != null && token != "") {
	            authHeader.append('Authorization', 'Bearer ' + token);
	            var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	            return this.http.get(this.serverURL + this._mainUrl + "/language", options).toPromise().then(function (res) {
	                if (JSON.parse(res.text()).code == 1) {
	                    return JSON.parse(res.text()).language;
	                }
	            }).catch(this.handleError);
	        }
	    };
	    MainService.prototype.getUnreadMessages = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token != null && token != "") {
	            authHeader.append('Authorization', 'Bearer ' + token);
	            var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	            return this.http.get(this.serverURL + this._mainUrl + "/messages", options).toPromise().then(function (res) {
	                if (JSON.parse(res.text()).code == 1) {
	                    return JSON.parse(res.text()).rows;
	                }
	                else {
	                    return null;
	                }
	            }).catch(this.handleError);
	        }
	    };
	    MainService.prototype.getUserName = function () {
	        return localStorage.getItem("userName");
	    };
	    MainService.prototype.changeLanguage = function (lang) {
	        this._translateService.setDefaultLang(lang);
	        this._translateService.use(lang);
	    };
	    MainService.prototype.login = function (email, password) {
	        var _this = this;
	        var creds = "email=" + email + "&password=" + password;
	        return this.http.post(this.serverURL + '/loginData', creds, { headers: new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' }) }).map(function (res) {
	            var data = res.json();
	            if (data.token !== undefined) {
	                _this.token = data.token;
	                localStorage.setItem('token', _this.token);
	            }
	            return data;
	        });
	    };
	    MainService.prototype.verifyEmail = function (email) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        authHeader.append('Authorization', 'Bearer ' + token);
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.get(this.serverURL + "/usersData/existsEmail/" + email, options).toPromise().then(function (res) {
	            if (JSON.parse(res.text()).code == 1) {
	                return true;
	            }
	            else {
	                return false;
	            }
	        }).catch(this.handleError);
	    };
	    MainService.prototype.sendEmailRecoverPassword = function (email) {
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        return this.http.post(this.serverURL + "/loginData/forgetPassword", this.serializeObj({ email: email }), { headers: authHeader }).toPromise().then(function (result) {
	            return JSON.parse(result.text()).code;
	        }).catch(this.handleError);
	    };
	    MainService.prototype.changeUserPassword = function (encryptedEmail, password) {
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        return this.http.post(this.serverURL + "/passwordData/changePassword", this.serializeObj({ encrypted_email: encryptedEmail, password: password }), { headers: authHeader }).toPromise().then(function (result) {
	            if (JSON.parse(result.text()).code == 1) {
	                return JSON.parse(result.text());
	            }
	            else {
	                return null;
	            }
	        }).catch(this.handleError);
	    };
	    MainService.prototype.getElementsBySearchFilterValue = function (searchFilterValue) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        authHeader.append('Authorization', 'Bearer ' + token);
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.get(this.serverURL + this._mainUrl + "/search/" + searchFilterValue, options).toPromise().then(function (res) {
	            if (JSON.parse(res.text()).code == 1) {
	                return JSON.parse(res.text()).rows;
	            }
	            else {
	                return null;
	            }
	        }).catch(this.handleError);
	    };
	    MainService.prototype.getElementsAuthenticatedBySearchFilterValue = function (searchFilterValue) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        authHeader.append('Authorization', 'Bearer ' + token);
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.get(this.serverURL + this._mainUrl + "/search/authenticated/" + searchFilterValue, options).toPromise().then(function (res) {
	            if (JSON.parse(res.text()).code == 1) {
	                return JSON.parse(res.text()).rows;
	            }
	            else {
	                return null;
	            }
	        }).catch(this.handleError);
	    };
	    MainService.prototype.handleError = function (error) {
	        var errMsg = (error.message) ? error.message : error.status ? error.status + " - " + error.statusText : 'Server error';
	        console.error(errMsg);
	        return Observable_1.Observable.throw(errMsg);
	    };
	    MainService.prototype.serializeObj = function (obj) {
	        var result = [];
	        for (var property in obj) {
	            result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));
	        }
	        return result.join("&");
	    };
	    MainService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof ng2_translate_1.TranslateService !== 'undefined' && ng2_translate_1.TranslateService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], MainService);
	    return MainService;
	    var _a, _b;
	}());
	exports.MainService = MainService;


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<nav class=\"navbar navbar-fixed-top navbar-white\" style=\"margin-bottom: 0; padding-bottom: 0; background-color: #035d72!important; z-index: 99999; border-bottom: 0!important;\">\n    <div class=\"container-fluid\">\n        <div class=\"navbar-header\">\n            <button type=\"button\" class=\"navbar-toggle collapsed\" data-toggle=\"collapse\" (click)=\"isCollapsed=!isCollapsed;\" data-target=\"#navbar\"\n                aria-expanded=\"false\" aria-controls=\"navbar\" style=\"background-color: #337ab7;\">\n                <span class=\"sr-only\">Toggle navigation</span>\n                <span class=\"icon-bar\" style=\"background-color: white;\"></span>\n                <span class=\"icon-bar\" style=\"background-color: white;\"></span>\n                <span class=\"icon-bar\" style=\"background-color: white;\"></span>\n                </button>\n            <a class=\"navbar-brand clickable\" (click)=\"toMainDashboard()\"><img style=\"height: 2.7em; width: auto; margin-top: -0.7em;\" class=\"logo\" src=\"" + __webpack_require__(97) + "\"\n                /></a>                \n            <label class=\"hidden-xs\" style=\"text-align: left; font-size: 0.8em; color: #ffffff; padding-top: 3em;\">{{ 'AMBULANT_MARKET' | translate }}</label>\n        </div>\n        <div id=\"navbar\" class=\"navbar-collapse collapse\" [ngClass]=\"{in: isCollapsed}\">\n            <div class=\"navbar-left navbar-nav nav\">\n                <div class=\"input-group\" style=\"margin-left: 2em; margin-top: 1.3em;\">\n                    <div style=\"background-color: #ffffff; height: 2em; text-align: center; display: inline-block; padding-top: 0.35em; width: 2em;\">\n                        <span class=\"glyphicon glyphicon-search white big-glyphicon input-group-btn\" style=\"text-align: center;  color: #035d72;  display: inline;\"></span>\n                    </div>\n                    <input type=\"text\" class=\"inputSearch\" placeholder=\"{{ 'SEARCH...' | translate }}\" [(ngModel)]=\"searchFilter\" (keyup)=\"searchFilterChanged($event)\"\n                        style=\"border: 0px; border-bottom: 1.5px solid #ffffff; margin-left: 0; background: none; height: 2em; width: 13em; padding-left: 0.5em; color: white;\"\n                        (focusout)=\"searchFilterFocusOut()\" />\n                </div>\n                <!--Search Results Pop-Up-->\n                <div id=\"search-pop\" class=\"searchs-pop\" *ngIf=\"(elementsThatContainsSearchValueById.length > 0 || elementsThatContainsSearchValueByName.length > 0) && !isCollapsed\">\n                    <div *ngIf=\"elementsThatContainsSearchValueById.length > 0\" class=\"notification-pop\" style=\"border-bottom: 1px solid #ffffff; text-align: left; padding-left: 0.5em;\">\n                        <a class=\"no-link\" style=\"font-weight: bold; color: #ffffff;\">Id</a>\n                    </div>\n                    <div id=\"search-pop\" *ngFor=\"let element of elementsThatContainsSearchValueById\" class=\"notification-pop\">\n                        <a class=\"no-link\" (click)=\"searchDataClicked(element)\">\n                            <div id=\"search-pop\" class=\"notification-text-pop clickable\"><span style=\"font-weight: bold;\">#{{element.id}}</span> {{element.comercial_name}}</div>\n                        </a>\n                        <div id=\"search-pop\" class=\"notification-bar-pop\">\n                            <div id=\"search-pop\"></div>\n                        </div>\n                    </div>\n                    <div *ngIf=\"elementsThatContainsSearchValueByName.length > 0\" class=\"notification-pop\" style=\"border-bottom: 1px solid #ffffff; text-align: left; padding-left: 0.5em;\">\n                        <a class=\"no-link\" style=\"font-weight: bold; color: #ffffff;\">{{'NAME' | translate}}</a>\n                    </div>\n                    <div id=\"search-pop\" *ngFor=\"let element of elementsThatContainsSearchValueByName\" class=\"notification-pop\">\n                        <a class=\"no-link\" (click)=\"searchDataClicked(element)\">\n                            <div id=\"search-pop\" class=\"notification-text-pop clickable\"><span style=\"font-weight: bold;\">#{{element.id}}</span> {{element.comercial_name}}</div>\n                        </a>\n                        <div id=\"search-pop\" class=\"notification-bar-pop\">\n                            <div id=\"search-pop\"></div>\n                        </div>\n                    </div>\n                </div>\n\n            </div>\n            <ul class=\"nav navbar-nav navbar-right\" *ngIf=\"userIsSuperUser || userIsAdmin\">\n                <li class=\"clickable\" [ngClass]=\"{borderLine: isCollapsed}\" [ngClass]=\"{borderLineTop: isCollapsed}\"><a (click)=\"noCollapse(); toProfileClicked()\"><span class=\"glyphicon glyphicon-user big-glyphicon\" style=\"color: #fefefe\"></span><span style=\"color: #ffffff;\">  {{userName}} </span></a></li>\n                <li [ngClass]=\"{borderLine: isCollapsed}\" class=\"clickable\">\n                    <a (click)=\"noCollapse()\" href=\"http://digital.mveva.com/\"><span class=\"glyphicon glyphicon-align-left big-glyphicon\" style=\"color: #fefefe;\"></span><span style=\"color: #ffffff;\"> {{ 'SERVICES' | translate }}</span></a>\n                </li>\n                <li [ngClass]=\"{borderLine: isCollapsed}\"><a (click)=\"noCollapse()\" [routerLink]=\"['/main', 'messages']\"><span class=\"glyphicon glyphicon-envelope big-glyphicon\" style=\"color: #fefefe\"></span>\n                <span *ngIf=\"nMessages>0\" style=\"background-color: #005b6e; color: white; margin-left: -0.3em; z-index: 9999999; position: relative; top: 0.2em; padding-left: 0.1em; padding-right: 0.1em; font-size: 12px;\">{{nMessages}}</span>\n                <span *ngIf=\"isCollapsed\" style=\"color: #ffffff;\">  {{ 'MESSAGES' | translate }}</span></a></li>\n                <li [ngClass]=\"{borderLine: isCollapsed}\"><a (click)=\"noCollapse()\" [routerLink]=\"['/main', 'favorites']\"><span class=\"glyphicon glyphicon-heart big-glyphicon\" style=\"color: #fefefe\"></span><span *ngIf=\"isCollapsed\" style=\"color: #ffffff;\">  {{ 'FAVORITES' | translate }}</span></a></li>\n                <li [ngClass]=\"{borderLine: isCollapsed}\"><a (click)=\"noCollapse()\" [routerLink]=\"['/main', 'profile']\"><span class=\"glyphicon glyphicon-cog big-glyphicon\" style=\"color: #fefefe\"></span><span *ngIf=\"isCollapsed\" style=\"color: #ffffff;\"> {{ 'PROFILE' | translate }}</span></a></li>\n                <li class=\"clickable\"><a (click)=\"noCollapse()\" (click)=\"accesButtonClicked()\"><span class=\"glyphicon glyphicon-off big-glyphicon\" style=\"color: #fefefe\"></span><span *ngIf=\"isCollapsed\" style=\"color: #ffffff;\">  {{ 'LOGOUT' | translate }}</span></a></li>\n            </ul>\n            <ul class=\"nav navbar-nav navbar-right\" *ngIf=\"!userIsSuperUser && !userIsAdmin\">\n                <li [ngClass]=\"{borderLine: isCollapsed}\" style=\"margin-right: 6em; margin-top: 1em;\">\n                        <span style=\"color: #ffffff;\">\n                            &nbsp;&nbsp;\n                            <a style=\"color: white;\" (click)=\"noCollapse()\" [ngClass]=\"{languageSelected: selectedLanguage == 'cat' || selectedLanguage == 'CAT'}\" (click)=\"languageClicked('cat')\" class=\"clickable\">CAT</a>\n                            <label>/</label>\n                            <a style=\"color: white;\" (click)=\"noCollapse()\" [ngClass]=\"{languageSelected: selectedLanguage == 'esp' || selectedLanguage == 'ESP'}\" (click)=\"languageClicked('esp')\" class=\"clickable\">ES</a>\n                        </span>\n                </li>\n                <li [ngClass]=\"{borderLine: isCollapsed}\" class=\"clickable\">\n                    <a (click)=\"noCollapse()\" href=\"http://digital.mveva.com/\"><span class=\"glyphicon glyphicon-align-left big-glyphicon\" style=\"color: #ffffff;\"></span><span style=\"color: #eeeeee;\"> {{ 'SERVICES' | translate }}</span></a>\n                </li>\n                <li [ngClass]=\"{borderLine: isCollapsed}\" class=\"clickable\">\n                    <a (click)=\"noCollapse()\" [routerLink]=\"['/info']\"><span class=\"glyphicon glyphicon-info-sign big-glyphicon\" style=\"color: #ffffff;\"></span><span style=\"color: #eeeeee;\"> {{ 'INFO' | translate }}</span></a>\n                </li>\n                <li [ngClass]=\"{borderLine: isCollapsed}\" class=\"clickable\">\n                    <a href=\"https://www.facebook.com/mercadilloambulante.pagina/\" target=\"_blank\" (click)=\"noCollapse()\" style=\"color: black;\">\n                        <img style=\"height: 1em; width: auto;\" class=\"logo\" src=\"" + __webpack_require__(180) + "\" />\n                        <span *ngIf=\"isCollapsed\" style=\"color: #ffffff;\">  Facebook</span>\n                    </a>\n                </li>\n                <li [ngClass]=\"{borderLine: isCollapsed}\" class=\"clickable\">\n                    <a href=\"https://www.instagram.com/mercadilloambulante/\" target=\"_blank\" style=\"color: black;\">\n                        <img style=\"height: 1em; width: auto;\" class=\"logo\" src=\"" + __webpack_require__(181) + "\" />\n                        <span *ngIf=\"isCollapsed\" style=\"color: #ffffff;\">  Instagram</span>\n                    </a>\n                </li>\n                <li class=\"clickable\"><a (click)=\"noCollapse()\" (click)=\"accesButtonClicked()\"><span class=\"glyphicon glyphicon-off white big-glyphicon\"></span><span style=\"color: #ffffff;\">  {{ 'TO_ACCESS' | translate }}</span></a></li>\n            </ul>\n        </div>\n    </div>\n</nav>\n\n\n<div class=\"main\" style=\"margin-top: 3.8em; background-color: #6fb3cb;\">\n    <!--Filters-->\n    <div [ngClass]=\"{displayNone: toggledFilters}\" class=\"col-xs-1 visible-xs visible-md visible-sm hidden-lg\" style=\"position: fixed; float: left; background-color: #6fb3cb; z-index: 9999; height: 100%;  padding: 0; max-width: 2.5em;\"\n        (click)=\"toggledFilters=!toggledFilters\">\n        <span class=\"glyphicon glyphicon-chevron-right big-glyphicon clickable\" style=\"color: white; top: 46%; left: 18%; display: block;\"></span>\n    </div>\n    <div [ngClass]=\"{displayNone: !toggledFilters}\" class=\"col-xs-10 visible-xs visible-md visible-sm hidden-lg\" style=\"position: fixed; height: 100%; z-index: 9999; background-color: #8bbbd5; overflow-y: auto; top: 0; padding-top: 3.9em; padding-bottom: 1em; overflow-x: hidden;\">\n        <div class=\"col-xs-11\" style=\"float: left; background-color: transparent; padding: 0; padding-right: 1em;\">\n\n            <div class=\"col-xs-12 col-md-12\" style=\"margin-bottom: 1.5em; padding-left: 0em; padding-right: 0em;\">\n                <div class=\"col-xs-12 col-md-12 clickable\" style=\"margin-top: 1em;\" (click)=\"categoryTypeClicked('PRE')\" [ngClass]=\"{'labelDivSelected': getCategoryType('PRE'), 'labelDivNotSelected':!getCategoryType('PRE')}\">\n                    <a class=\"\"><img style=\"height: 3em; width: auto;\" class=\"logo\" src=\"" + __webpack_require__(182) + "\" /></a>\n                    &nbsp;\n                    <label class=\"clickable label-filters\" style=\"line-height: 100%;\">{{ 'PREMIUM' | translate}}</label>\n                </div>\n                <div class=\"col-xs-12 col-md-12 clickable\" style=\"margin-top: 1em\" (click)=\"categoryTypeClicked('PRO')\" [ngClass]=\"{'labelDivSelected': getCategoryType('PRO'), 'labelDivNotSelected':!getCategoryType('PRO')}\">\n                    <a class=\"\"><img style=\"height: 3em; width: auto;\" class=\"logo\" src=\"" + __webpack_require__(183) + "\" /></a>\n\n                    &nbsp;\n                    <label class=\"clickable label-filters\" style=\"line-height: 100%;\">{{ 'PROFESIONAL' | translate}}</label>\n                </div>\n                <div class=\"col-xs-12 col-md-12 clickable\" style=\"margin-top: 1em;\" (click)=\"categoryTypeClicked('TRA')\" [ngClass]=\"{'labelDivSelected': getCategoryType('TRA'), 'labelDivNotSelected':!getCategoryType('TRA')}\">\n                    <a class=\"\"><img style=\"height: 3em; width: auto;\" class=\"logo\" src=\"" + __webpack_require__(184) + "\" /></a>\n\n                    &nbsp;\n                    <label class=\"clickable label-filters\" style=\"line-height: 100%;\">{{ 'TRADITIONAL' | translate}}</label>\n                </div>\n            </div>\n            <div class=\"col-xs-12 col-md-12\" style=\"margin-bottom: 1.5em;  padding-left: 0em; padding-right: 0em;\">\n                <div class=\"col-xs-12 col-md-12 clickable\" style=\"margin-top: 1em;\" (click)=\"sellerTypeClicked('SEL')\" [ngClass]=\"{'labelDivSelected': getSellerType('SEL'), 'labelDivNotSelected':!getSellerType('SEL')}\">\n                    <a class=\"\"><img style=\"height: 3em; width: auto;\" class=\"logo\" src=\"" + __webpack_require__(185) + "\" /></a>\n\n                    &nbsp;\n                    <label class=\"clickable label-filters\" style=\"line-height: 100%;\" [ngClass]=\"{labelSelected: getSellerType('SEL')}\">{{ 'SELLER' | translate}}</label>\n                </div>\n                <div class=\"col-xs-12 col-md-12 clickable\" style=\"margin-top: 1em;\" (click)=\"sellerTypeClicked('ART')\" [ngClass]=\"{'labelDivSelected': getSellerType('ART'), 'labelDivNotSelected':!getSellerType('ART')}\">\n                    <a class=\"\"><img style=\"height: 3em; width: auto;\" class=\"logo\" src=\"" + __webpack_require__(186) + "\" /></a>\n\n                    &nbsp;\n                    <label class=\"clickable label-filters\" style=\"line-height: 100%;\">{{ 'ARTESAN' | translate}}</label>\n                </div>\n            </div>\n            <cities-seeker class=\"col-xs-12 col-md-12\" style=\"margin-top: 1.5em; margin-bottom: 1.5em; padding: 0;\" [loadedCitiesIds]=\"citiesIds\"\n                (emiter)=\"selectedCitiesReceived($event)\"></cities-seeker>\n            <tags-handler class=\"col-xs-12 col-md-12\" style=\"margin-top: 1.5em; padding: 0;\" [loadedTagsIds]=\"tagsIds\" (emiter)=\"selectedTagsReceived($event)\"></tags-handler>\n        </div>\n    </div>\n    <div [ngClass]=\"{displayNone: !toggledFilters}\" class=\"col-xs-1 col-xs-offset-10\" style=\"background-color: #6fb3cb; z-index: 9999; height: 100%;  padding: 0; position: fixed; max-width: 2.5em; padding-left: 0em; padding-right: 0em;\"\n        (click)=\"toggledFilters=!toggledFilters\">\n        <span class=\"glyphicon glyphicon-chevron-left big-glyphicon clickable\" style=\"color: white; top: 46%; left: 18%; display: block;\"></span>\n    </div>\n\n    <div class=\"col-xs-2 hidden-xs hidden-md hidden-sm display-lg\" style=\"position: fixed; height: 100%; z-index: 9999; background-color: #8bbbd5;  overflow-y: auto; overflow-x: hidden; padding-bottom: 5em; padding-left: 0em; padding-right: 0em;\">\n        <div class=\"col-xs-12\" style=\"float: left; background-color: transparent; padding: 0; padding-left: 0em; padding-right: 0em;\">\n\n            <div class=\"col-xs-12 col-md-12\" style=\"margin-bottom: 1.5em; padding-left: 0em; padding-right: 0em;\">\n                <div class=\"col-xs-12 col-md-12 clickable\" style=\"margin-top: 1em;\" (click)=\"categoryTypeClicked('PRE')\" [ngClass]=\"{'labelDivSelected': getCategoryType('PRE'), 'labelDivNotSelected':!getCategoryType('PRE')}\">\n                    <a class=\"\"><img style=\"height: 3em; width: auto;\" class=\"logo\" src=\"" + __webpack_require__(182) + "\" /></a>\n                    &nbsp;\n                    <label class=\"clickable label-filters\" style=\"line-height: 100%;\">{{ 'PREMIUM' | translate}}</label>\n                </div>\n                <div class=\"col-xs-12 col-md-12 clickable\" style=\"margin-top: 1em\" (click)=\"categoryTypeClicked('PRO')\" [ngClass]=\"{'labelDivSelected': getCategoryType('PRO'), 'labelDivNotSelected':!getCategoryType('PRO')}\">\n                    <a class=\"\"><img style=\"height: 3em; width: auto;\" class=\"logo\" src=\"" + __webpack_require__(183) + "\" /></a>\n\n                    &nbsp;\n                    <label class=\"clickable label-filters\" style=\"line-height: 100%;\">{{ 'PROFESIONAL' | translate}}</label>\n                </div>\n                <div class=\"col-xs-12 col-md-12 clickable\" style=\"margin-top: 1em;\" (click)=\"categoryTypeClicked('TRA')\" [ngClass]=\"{'labelDivSelected': getCategoryType('TRA'), 'labelDivNotSelected':!getCategoryType('TRA')}\">\n                    <a class=\"\"><img style=\"height: 3em; width: auto;\" class=\"logo\" src=\"" + __webpack_require__(184) + "\" /></a>\n\n                    &nbsp;\n                    <label class=\"clickable label-filters\" style=\"line-height: 100%;\">{{ 'TRADITIONAL' | translate}}</label>\n                </div>\n            </div>\n            <div class=\"col-xs-12 col-md-12\" style=\"margin-bottom: 1.5em;  padding-left: 0em; padding-right: 0em;\">\n                <div class=\"col-xs-12 col-md-12 clickable\" style=\"margin-top: 1em;\" (click)=\"sellerTypeClicked('SEL')\" [ngClass]=\"{'labelDivSelected': getSellerType('SEL'), 'labelDivNotSelected':!getSellerType('SEL')}\">\n                    <a class=\"\"><img style=\"height: 3em; width: auto;\" class=\"logo\" src=\"" + __webpack_require__(185) + "\" /></a>\n\n                    &nbsp;\n                    <label class=\"clickable label-filters\" style=\"line-height: 100%;\" [ngClass]=\"{labelSelected: getSellerType('SEL')}\">{{ 'SELLER' | translate}}</label>\n                </div>\n                <div class=\"col-xs-12 col-md-12 clickable\" style=\"margin-top: 1em;\" (click)=\"sellerTypeClicked('ART')\" [ngClass]=\"{'labelDivSelected': getSellerType('ART'), 'labelDivNotSelected':!getSellerType('ART')}\">\n                    <a class=\"\"><img style=\"height: 3em; width: auto;\" class=\"logo\" src=\"" + __webpack_require__(186) + "\" /></a>\n\n                    &nbsp;\n                    <label class=\"clickable label-filters\" style=\"line-height: 100%;\">{{ 'ARTESAN' | translate}}</label>\n                </div>\n            </div>\n            <cities-seeker class=\"col-xs-12 col-md-12\" style=\"margin-top: 1.5em; margin-bottom: 1.5em; padding: 0;\" [loadedCitiesIds]=\"citiesIds\"\n                (emiter)=\"selectedCitiesReceived($event)\"></cities-seeker>\n            <tags-handler class=\"col-xs-12 col-md-12\" style=\"margin-top: 1.5em; padding: 0;\" [loadedTagsIds]=\"tagsIds\" (emiter)=\"selectedTagsReceived($event)\"></tags-handler>\n        </div>\n    </div>\n    <div class=\"col-xs-11 col-lg-10 col-xs-offset-1 col-sm-offset-1 col-md-offset-1 col-lg-offset-2\" style=\"margin-top: 0.5em;\">\n        <router-outlet></router-outlet>\n    </div>\n\n</div>\n<div [ngClass]=\"classLoginModal\" role=\"dialog\">\n    <div class=\"modal-dialog\" style=\"z-index: 9999999999;\">\n        <!-- Modal content-->\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" (click)=\"closeLoginModal()\">&times;</button>\n                <h4 class=\"modal-title\">{{ 'TO_ACCESS' | translate}}</h4>\n            </div>\n            <div class=\"modal-body\" style=\"height: 15em;\">\n                <div>\n                    <div class=\"form-group\">\n                        <label for=\"email\">{{ 'EMAIL' | translate }}</label>\n                        <input [(ngModel)]=\"loginEmail\" type=\"email\" class=\"form-control\" id=\"email\" (keyup.enter)=\"loginClicked()\">\n                        <span *ngIf=\"loginCode === 530 || loginCode === 531\" class=\"login-error-msg\">{{ 'WRITE_YOUR_EMAIL' | translate }}</span>\n                        <span *ngIf=\"loginCode === 533\" class=\"login-error-msg\">{{ 'WRONG_EMAIL' | translate }}</span>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"password\">{{ 'PASSWORD' | translate }}</label>\n                        <input [(ngModel)]=\"loginPassword\" type=\"password\" class=\"form-control\" id=\"password\" (keyup.enter)=\"loginClicked()\">\n                        <span *ngIf=\"loginCode === 530 || loginCode === 532\" class=\"login-error-msg\">{{ 'WRITE_YOUR_PASSWORD' | translate }}</span>\n                        <span *ngIf=\"loginCode === 534\" class=\"login-error-msg\">{{ 'WRONG_PASSWORD' | translate }}</span>\n                    </div>\n                </div>\n            </div>\n            <div class=\"modal-footer\" style=\"margin-top: 2em;\">\n                <button type=\"button\" class=\"btn\" (click)=\"registerClicked()\" style=\"float: left; background-color: #6fb3cb; color: white;\">{{ 'REGISTER' | translate }}</button>\n                <span class=\"clickable\" style=\"float: left; color: #6fb3cb; margin-left: 1em; margin-top: 1em;\" (click)=\"forgetPassword()\">{{ 'FORGET_PASSWORD' | translate }}</span>\n                <button type=\"button\" class=\"btn btn-default submitbutton\" (click)=\"loginClicked()\" style=\" background-color: #6fb3cb; color: white;\">{{ 'LOGIN' | translate }}</button>\n                <button type=\"button\" class=\"btn\" (click)=\"closeLoginModal()\">{{ 'CLOSE' | translate }}</button>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div [ngClass]=\"classForgetPasswordModal\" role=\"dialog\">\n    <div class=\"modal-dialog\" style=\"z-index: 9999999999;\">\n        <!-- Modal content-->\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" (click)=\"closeLoginModal()\">&times;</button>\n                <h4 class=\"modal-title\">{{ 'FORGET_PASSWORD' | translate}}</h4>\n            </div>\n            <div class=\"modal-body\" style=\"height: 10em;\">\n                <div>\n                    <div class=\"form-group\">\n                        <label for=\"email\">{{ 'EMAIL' | translate }}</label>\n                        <input [(ngModel)]=\"forgetPasswordEmail\" type=\"email\" class=\"form-control\" id=\"email\">\n                        <span *ngIf=\"forgetPasswordEmailEmpty\" class=\"login-error-msg\">{{ 'WRITE_YOUR_EMAIL' | translate }}</span>\n                        <span *ngIf=\"forgetPasswordEmailIncorrect\" class=\"login-error-msg\">{{ 'WRONG_EMAIL' | translate }}</span>\n                    </div>\n                </div>\n            </div>\n            <div class=\"modal-footer\" style=\"margin-top: 2em;\">\n                <button type=\"button\" class=\"btn btn-default submitbutton\" (click)=\"getPasswordByEmail()\" style=\" background-color: #6fb3cb; color: white;\">{{ 'SEND' | translate }}</button>\n                <button type=\"button\" class=\"btn\" (click)=\"closeForgetPasswordModal()\">{{ 'CLOSE' | translate }}</button>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div [ngClass]=\"classEmailSendedModal\" role=\"dialog\">\n    <div class=\"modal-dialog\" style=\"z-index: 9999999999; width: 50em;\">\n        <!-- Modal content-->\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" (click)=\"closeLoginModal()\">&times;</button>\n                <h4 class=\"modal-title\">{{ 'RECOVER_PASSWORD' | translate}}</h4>\n            </div>\n            <div class=\"modal-body\" style=\"height: 10em;\">\n                <div>\n                    <div class=\"form-group\">\n                        <span>{{ 'EMAIL_RECOVER_PASSWORD_SENDED' | translate }}.</span><br/>\n                        <span>{{ 'RESEND_EMAIL' | translate }}</span>\n                        <span *ngIf=\"!emailSended\" (click)=\"resendEmailRecoverPassword()\" class=\"clickable\" style=\"text-decoration: underline; color: #6fb3cb;\">{{ 'HERE' | translate }}</span>\n                        <span *ngIf=\"emailSended\">{{'HERE' | translate}}</span>\n                        <br/>\n                        <span *ngIf=\"emailSended\" class=\"login-error-msg\">{{ 'EMAIL_SENDED_AGAIN' | translate}}</span>\n                    </div>\n                </div>\n            </div>\n            <div class=\"modal-footer\" style=\"margin-top: 2em;\">\n                <button type=\"button\" class=\"btn\" (click)=\"closeEmailSendedModal()\">{{ 'CLOSE' | translate }}</button>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/facebook_logo_white.fd8724588748cad71c09776b2ce95509.png";

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/instagram_logo_white.30fa0886f8b6840a53f5deb91f9722f5.png";

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/stand13w.a93184c42a84576b3e335d2516b1444d.png";

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/stand12w.3555c0cf37c991de8e7569ca18d582d6.png";

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/stand11w.9f2d5d9e71e71ac162630640edf5abcd.png";

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/seller1w.986d4c85645ac20115ff8d4c5cd81217.png";

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/artisan1w.7be6f63e6326f3087588074a0506e332.png";

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var dashboard_service_1 = __webpack_require__(188);
	var router_1 = __webpack_require__(76);
	var MainDashboardComponent = (function () {
	    function MainDashboardComponent(_dashboardService, _parentRouter, route) {
	        this._dashboardService = _dashboardService;
	        this.route = route;
	        this.router = _parentRouter;
	        this.elementsToShow = 10;
	        this.elementsPage = 0;
	        this.premiumsPage = 0;
	        this.selectedElement = null;
	        this.tagsToShowInElement = 5;
	        this.classLoginModal = { 'model': true, 'show': false, 'hide': true };
	        this.loginEmail = "";
	        this.loginPassword = "";
	        this.loginCode = 0;
	        this.classMessageModal = { 'model': true, 'show': false, 'hide': true };
	        this.messageTitle = "";
	        this.messageContent = "";
	        this.messageCode = 0;
	        this.userRole = "guest";
	        this.setUserRole(this.userRole);
	        this.pageHeightLimit = 200;
	        this.loading = false;
	        this.elementHover = -1;
	        this.showPremiums = true;
	    }
	    MainDashboardComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._dashboardService.getUserStatus().then(function (status) {
	            _this.userRole = status.role;
	            _this.setUserRole(_this.userRole);
	        });
	        this.route.params.subscribe(function (params) {
	            _this.elementsPage = 0;
	            _this.categoryFilter = params['categoryType'];
	            _this.sellerFilter = params['sellerType'];
	            _this.citiesFilter = params['citiesFilter'];
	            _this.tagsFilter = params['tagsFilter'];
	            _this.searchFilter = params['searchFilter'];
	            _this.scrollParam = params['scroll'];
	            _this.scrollHeight = Number(params['scrollHeight']);
	            _this.loadedPage = Number(params['loadedPage']);
	            _this.ngOnInit2();
	        });
	    };
	    MainDashboardComponent.prototype.ngOnInit2 = function () {
	        var _this = this;
	        console.log(this.filtersAreAplicated());
	        if (!this.filtersAreAplicated()) {
	            if (this.loadedPage != null && this.loadedPage != undefined && this.loadedPage > 0) {
	                this._dashboardService.getElementsUntilPage(this.loadedPage).subscribe(function (res) {
	                    if (res != null) {
	                        _this.listElements = res;
	                        for (var i = 0; i < _this.listElements.length; i++) {
	                            _this.listElements[i].tags_index = 0;
	                        }
	                        _this.elementsPage = _this.loadedPage;
	                    }
	                });
	            }
	            else {
	                this._dashboardService.getElementsByPage(this.elementsPage).subscribe(function (res) {
	                    if (res != null) {
	                        _this.listElements = res;
	                        for (var i = 0; i < _this.listElements.length; i++) {
	                            _this.listElements[i].tags_index = 0;
	                        }
	                    }
	                });
	            }
	            this.showPremiums = true;
	            this._dashboardService.getPremiumElementsByPage(this.premiumsPage).subscribe(function (res) {
	                if (res != null) {
	                    _this.premiumElements = res;
	                }
	            });
	            this._dashboardService.getElementsCount().subscribe(function (res) {
	                _this.elementsCount = res;
	            });
	        }
	        else {
	            if (!this.isNullOrEmpty(this.categoryFilter)) {
	                if (this.categoryFilter == "PRE") {
	                    this.showPremiums = false;
	                    if (this.loadedPage != null && this.loadedPage != undefined && this.loadedPage > 0) {
	                        this._dashboardService.getElementsUntilPageWithFilters(this.loadedPage, this.categoryFilter, this.sellerFilter, this.citiesFilter, this.tagsFilter, this.searchFilter).subscribe(function (res) {
	                            if (res != null) {
	                                _this.listElements = res;
	                                for (var i = 0; i < _this.listElements.length; i++) {
	                                    _this.listElements[i].tags_index = 0;
	                                }
	                                _this.elementsPage = _this.loadedPage;
	                            }
	                        });
	                    }
	                    else {
	                        this._dashboardService.getElementsByPageWithFilters(this.elementsPage, this.categoryFilter, this.sellerFilter, this.citiesFilter, this.tagsFilter, this.searchFilter).subscribe(function (res) {
	                            if (res != null) {
	                                _this.listElements = res;
	                                for (var i = 0; i < _this.listElements.length; i++) {
	                                    _this.listElements[i].tags_index = 0;
	                                }
	                            }
	                        });
	                    }
	                    this._dashboardService.getElementsCountWithFilters(this.categoryFilter, this.sellerFilter, this.citiesFilter, this.tagsFilter, this.searchFilter).subscribe(function (res) {
	                        _this.elementsCount = res;
	                    });
	                }
	                else if (this.categoryFilter == "PRO") {
	                    if (this.loadedPage != null && this.loadedPage != undefined && this.loadedPage > 0) {
	                        this._dashboardService.getElementsUntilPageWithFilters(this.loadedPage, this.categoryFilter, this.sellerFilter, this.citiesFilter, this.tagsFilter, this.searchFilter).subscribe(function (res) {
	                            if (res != null) {
	                                _this.listElements = res;
	                                for (var i = 0; i < _this.listElements.length; i++) {
	                                    _this.listElements[i].tags_index = 0;
	                                }
	                                _this.elementsPage = _this.loadedPage;
	                            }
	                        });
	                    }
	                    else {
	                        this._dashboardService.getElementsByPageWithFilters(this.elementsPage, this.categoryFilter, this.sellerFilter, this.citiesFilter, this.tagsFilter, this.searchFilter).subscribe(function (res) {
	                            if (res != null) {
	                                _this.listElements = res;
	                                for (var i = 0; i < _this.listElements.length; i++) {
	                                    _this.listElements[i].tags_index = 0;
	                                }
	                            }
	                        });
	                    }
	                    this.showPremiums = true;
	                    this._dashboardService.getPremiumElementsByPageWithFilters(this.premiumsPage, this.sellerFilter, this.citiesFilter, this.tagsFilter).subscribe(function (res) {
	                        if (res != null) {
	                            _this.premiumElements = res;
	                        }
	                    });
	                    this._dashboardService.getElementsCountWithFilters(this.categoryFilter, this.sellerFilter, this.citiesFilter, this.tagsFilter, this.searchFilter).subscribe(function (res) {
	                        _this.elementsCount = res;
	                    });
	                }
	                else if (this.categoryFilter == "TRA") {
	                    this.showPremiums = false;
	                    if (this.loadedPage != null && this.loadedPage != undefined && this.loadedPage > 0) {
	                        this._dashboardService.getElementsUntilPageWithFilters(this.loadedPage, this.categoryFilter, this.sellerFilter, this.citiesFilter, this.tagsFilter, this.searchFilter).subscribe(function (res) {
	                            if (res != null) {
	                                _this.listElements = res;
	                                for (var i = 0; i < _this.listElements.length; i++) {
	                                    _this.listElements[i].tags_index = 0;
	                                }
	                                _this.elementsPage = _this.loadedPage;
	                            }
	                        });
	                    }
	                    else {
	                        this._dashboardService.getElementsByPageWithFilters(this.elementsPage, this.categoryFilter, this.sellerFilter, this.citiesFilter, this.tagsFilter, this.searchFilter).subscribe(function (res) {
	                            if (res != null) {
	                                _this.listElements = res;
	                                for (var i = 0; i < _this.listElements.length; i++) {
	                                    _this.listElements[i].tags_index = 0;
	                                }
	                            }
	                        });
	                    }
	                    this._dashboardService.getElementsCountWithFilters(this.categoryFilter, this.sellerFilter, this.citiesFilter, this.tagsFilter, this.searchFilter).subscribe(function (res) {
	                        _this.elementsCount = res;
	                    });
	                }
	            }
	            else {
	                if (this.loadedPage != null && this.loadedPage != undefined && this.loadedPage > 0) {
	                    this._dashboardService.getElementsUntilPageWithFilters(this.loadedPage, this.categoryFilter, this.sellerFilter, this.citiesFilter, this.tagsFilter, this.searchFilter).subscribe(function (res) {
	                        if (res != null) {
	                            _this.listElements = res;
	                            for (var i = 0; i < _this.listElements.length; i++) {
	                                _this.listElements[i].tags_index = 0;
	                            }
	                        }
	                        _this.elementsPage = _this.loadedPage;
	                    });
	                }
	                else {
	                    this._dashboardService.getElementsByPageWithFilters(this.elementsPage, this.categoryFilter, this.sellerFilter, this.citiesFilter, this.tagsFilter, this.searchFilter).subscribe(function (res) {
	                        if (res != null) {
	                            _this.listElements = res;
	                            for (var i = 0; i < _this.listElements.length; i++) {
	                                _this.listElements[i].tags_index = 0;
	                            }
	                        }
	                    });
	                }
	                this.showPremiums = true;
	                this._dashboardService.getPremiumElementsByPageWithFilters(this.premiumsPage, this.sellerFilter, this.citiesFilter, this.tagsFilter).subscribe(function (res) {
	                    if (res != null) {
	                        _this.premiumElements = res;
	                    }
	                });
	                this._dashboardService.getElementsCountWithFilters(this.categoryFilter, this.sellerFilter, this.citiesFilter, this.tagsFilter, this.searchFilter).subscribe(function (res) {
	                    _this.elementsCount = res;
	                });
	            }
	        }
	    };
	    MainDashboardComponent.prototype.loadElements = function (page) {
	        if (this.loadedPage >= page) {
	            var res2 = this.loadElements(page + 1);
	            this._dashboardService.getElementsByPage(page).subscribe(function (res) {
	                for (var i = 0; i < res.length; i++) {
	                    res[i].tags_index = 0;
	                }
	                res = res.concat(res2);
	                return res;
	            });
	        }
	        else {
	            return [];
	        }
	    };
	    MainDashboardComponent.prototype.setScroll = function () {
	        if (!this.isNullOrEmpty(this.scrollParam) && document.body.scrollHeight >= this.scrollHeight) {
	            document.body.scrollTop = Number(this.scrollParam);
	            this.scrollParam = null;
	        }
	    };
	    MainDashboardComponent.prototype.filtersAreAplicated = function () {
	        if ((this.categoryFilter == null || this.categoryFilter == undefined || this.categoryFilter == "" || this.categoryFilter == "null") &&
	            (this.sellerFilter == null || this.sellerFilter == undefined || this.sellerFilter == "" || this.sellerFilter == "null") &&
	            (this.citiesFilter == null || this.citiesFilter == undefined || this.citiesFilter == "" || this.citiesFilter == "null") &&
	            (this.tagsFilter == null || this.tagsFilter == undefined || this.tagsFilter == "" || this.tagsFilter == "null") &&
	            (this.searchFilter == null || this.searchFilter == undefined || this.searchFilter == "" || this.searchFilter == "null")) {
	            return false;
	        }
	        else {
	            return true;
	        }
	    };
	    MainDashboardComponent.prototype.isNullOrEmpty = function (text) {
	        if (text == null || text == undefined || text == "" || text == "null") {
	            return true;
	        }
	        else {
	            return false;
	        }
	    };
	    MainDashboardComponent.prototype.previousTagsClicked = function (element) {
	        element.tags_index--;
	    };
	    MainDashboardComponent.prototype.nextTagsClicked = function (element) {
	        element.tags_index++;
	    };
	    MainDashboardComponent.prototype.loginClicked = function () {
	        var _this = this;
	        this._dashboardService.login(this.loginEmail, this.loginPassword).subscribe(function (result) {
	            _this.loginCode = result.code;
	            if (result !== null && result.token !== undefined) {
	                localStorage.setItem('userName', result.user.name);
	                location.reload();
	            }
	        });
	    };
	    MainDashboardComponent.prototype.sendMessageClicked = function () {
	        var _this = this;
	        var titleIntroduced;
	        if (this.messageTitle == null || this.messageTitle == undefined || this.messageTitle == "") {
	            titleIntroduced = false;
	        }
	        else {
	            titleIntroduced = true;
	        }
	        var contentIntroduced;
	        if (this.messageContent == null || this.messageContent == undefined || this.messageContent == "") {
	            contentIntroduced = false;
	        }
	        else {
	            contentIntroduced = true;
	        }
	        if (!titleIntroduced && contentIntroduced) {
	            this.messageCode = 1;
	        }
	        else if (titleIntroduced && !contentIntroduced) {
	            this.messageCode = 2;
	        }
	        else if (!titleIntroduced && !contentIntroduced) {
	            this.messageCode = 3;
	        }
	        else {
	            this._dashboardService.sendMessage(this.messageTitle, this.messageContent, this.selectedElement.user_id).then(function (res) {
	                if (res.code == 1) {
	                    _this.closeMessageModal();
	                }
	            });
	        }
	    };
	    MainDashboardComponent.prototype.elementFavoriteClicked = function (element) {
	        if (this.userRole == "guest") {
	            this.classLoginModal.show = true;
	            this.classLoginModal.hide = false;
	        }
	        else if (this.userRole == "admin" || this.userRole == "superuser" || this.userRole == "user") {
	            this._dashboardService.manageFavorite(element.id).then(function (result) {
	                if (result.code == 1) {
	                    if (result.type == "insert") {
	                        element.favorite = true;
	                    }
	                    else {
	                        element.favorite = false;
	                    }
	                }
	            });
	        }
	    };
	    MainDashboardComponent.prototype.elementMessageClicked = function (element) {
	        if (this.userRole == "guest") {
	            this.classLoginModal.show = true;
	            this.classLoginModal.hide = false;
	        }
	        else if (this.userRole == "admin" || this.userRole == "superuser" || this.userRole == "user") {
	            this.selectedElement = element;
	            this.classMessageModal.show = true;
	            this.classMessageModal.hide = false;
	        }
	    };
	    MainDashboardComponent.prototype.registerClicked = function () {
	        this.router.navigate(['/register']);
	    };
	    MainDashboardComponent.prototype.closeLoginModal = function () {
	        this.loginCode = 0;
	        this.classLoginModal.show = false;
	        this.classLoginModal.hide = true;
	    };
	    MainDashboardComponent.prototype.closeMessageModal = function () {
	        this.messageCode = 0;
	        this.classMessageModal.show = false;
	        this.classMessageModal.hide = true;
	    };
	    MainDashboardComponent.prototype.setUserRole = function (userRole) {
	        if (userRole == "guest") {
	            this.userIsGuest = true;
	            this.userIsSuperUser = false;
	            this.userIsAdmin = false;
	        }
	        else if (userRole == "superuser") {
	            this.userIsGuest = false;
	            this.userIsSuperUser = true;
	            this.userIsAdmin = false;
	        }
	        else if (userRole == "admin") {
	            this.userIsGuest = false;
	            this.userIsSuperUser = false;
	            this.userIsAdmin = true;
	        }
	    };
	    MainDashboardComponent.prototype.getFavoriteColor = function (element) {
	        if (element.favorite) {
	            return "green";
	        }
	        else {
	            return "#6fb3cb";
	        }
	    };
	    MainDashboardComponent.prototype.elementClicked = function (element) {
	        if (!this.filtersAreAplicated()) {
	            var category = null;
	            var seller = null;
	            var cities = null;
	            var tags = null;
	        }
	        else {
	            var category = this.categoryFilter;
	            var seller = this.sellerFilter;
	            var cities = this.citiesFilter;
	            var tags = this.tagsFilter;
	        }
	        this.router.navigate(['/main', 'elementdetail', { categoryType: category, sellerType: seller, citiesFilter: cities, tagsFilter: tags, elementId: element.id, scroll: document.body.scrollTop, scrollHeight: document.body.scrollHeight, loadedPage: this.elementsPage }]);
	    };
	    MainDashboardComponent.prototype.previousElements = function () {
	        var _this = this;
	        this.elementsPage--;
	        if (!this.filtersAreAplicated()) {
	            this._dashboardService.getElementsByPage(this.elementsPage).subscribe(function (res) {
	                if (res != null) {
	                    _this.listElements = res;
	                    for (var i = 0; i < _this.listElements.length; i++) {
	                        _this.listElements[i].tags_index = 0;
	                    }
	                }
	            });
	        }
	    };
	    MainDashboardComponent.prototype.nextElements = function () {
	        var _this = this;
	        this.elementsPage++;
	        if (!this.filtersAreAplicated()) {
	            this._dashboardService.getElementsByPage(this.elementsPage).subscribe(function (res) {
	                if (res != null) {
	                    _this.listElements = res;
	                    for (var i = 0; i < _this.listElements.length; i++) {
	                        _this.listElements[i].tags_index = 0;
	                    }
	                }
	            });
	        }
	    };
	    MainDashboardComponent.prototype.onScroll = function (event) {
	        var _this = this;
	        if (window.pageYOffset >= document.body.scrollHeight - window.innerHeight - this.pageHeightLimit && !this.loading) {
	            if (this.elementsCount > this.listElements.length) {
	                this.loading = true;
	                this.elementsPage++;
	                if (!this.filtersAreAplicated()) {
	                    this._dashboardService.getElementsByPage(this.elementsPage).subscribe(function (res) {
	                        if (res != null) {
	                            _this.listElements = _this.listElements.concat(res);
	                            for (var i = _this.elementsPage * _this.elementsToShow; i < _this.listElements.length; i++) {
	                                _this.listElements[i].tags_index = 0;
	                            }
	                        }
	                        _this.loading = false;
	                    });
	                }
	                else {
	                    this._dashboardService.getElementsByPageWithFilters(this.elementsPage, this.categoryFilter, this.sellerFilter, this.citiesFilter, this.tagsFilter, this.searchFilter).subscribe(function (res) {
	                        if (res != null) {
	                            _this.listElements = _this.listElements.concat(res);
	                            for (var i = _this.elementsPage * _this.elementsToShow; i < _this.listElements.length; i++) {
	                                _this.listElements[i].tags_index = 0;
	                            }
	                        }
	                        _this.loading = false;
	                    });
	                }
	            }
	        }
	    };
	    MainDashboardComponent.prototype.mouseOverElement = function (element_id) {
	        this.elementHover = element_id;
	    };
	    MainDashboardComponent.prototype.mouseLeaveElement = function () {
	        this.elementHover = -1;
	    };
	    MainDashboardComponent = __decorate([
	        core_1.Component({
	            selector: 'dashboard',
	            providers: [dashboard_service_1.DashboardService],
	            template: __webpack_require__(189),
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof dashboard_service_1.DashboardService !== 'undefined' && dashboard_service_1.DashboardService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object])
	    ], MainDashboardComponent);
	    return MainDashboardComponent;
	    var _a, _b, _c;
	}());
	exports.MainDashboardComponent = MainDashboardComponent;


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(30);
	var Observable_1 = __webpack_require__(5);
	var ng2_translate_1 = __webpack_require__(29);
	var json = __webpack_require__(95);
	var DashboardService = (function () {
	    function DashboardService(_translateService, http) {
	        this._translateService = _translateService;
	        this.http = http;
	        this._mainUrl = '/mainData';
	        this.serverURL = json.api_url;
	        this.getTokenService();
	    }
	    DashboardService.prototype.getElementsByPage = function (page) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        var language = this._translateService.currentLang;
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        var url;
	        if (token == null || token == undefined || token == "") {
	            url = this._mainUrl + "/" + language + "/" + page;
	        }
	        else {
	            url = this._mainUrl + "/authenticated/" + language + "/" + page;
	        }
	        return this.http.get(this.serverURL + url, options).map(function (response) { return response.json().rows; });
	    };
	    DashboardService.prototype.getElementsUntilPage = function (page) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        var language = this._translateService.currentLang;
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        var url;
	        if (token == null || token == undefined || token == "") {
	            url = this._mainUrl + "/until/" + language + "/" + page;
	        }
	        else {
	            url = this._mainUrl + "/until/authenticated/" + language + "/" + page;
	        }
	        return this.http.get(this.serverURL + url, options).map(function (response) { return response.json().rows; });
	    };
	    DashboardService.prototype.getPremiumElementsByPage = function (page) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        var url = this._mainUrl + "/premium/" + page;
	        return this.http.get(this.serverURL + url, options).map(function (response) { return response.json().rows; });
	    };
	    DashboardService.prototype.getPremiumElementsByPageWithFilters = function (page, sellerType, cities, tags) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        var url = this._mainUrl + "/premium/filters/" + page + "/" + sellerType + "/" + cities + "/" + tags;
	        return this.http.get(this.serverURL + url, options).map(function (response) { return response.json().rows; });
	    };
	    DashboardService.prototype.getElementsByPageWithFilters = function (page, categoryType, sellerType, cities, tags, search) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        var language = this._translateService.currentLang;
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        var url;
	        if (token == null || token == undefined || token == "") {
	            url = this._mainUrl + "/filters/" + language + "/" + page + "/" + categoryType + "/" + sellerType + "/" + cities + "/" + tags + "/" + search;
	        }
	        else {
	            url = this._mainUrl + "/filters/authenticated/" + language + "/" + page + "/" + categoryType + "/" + sellerType + "/" + cities + "/" + tags + "/" + search;
	        }
	        return this.http.get(this.serverURL + url, options).map(function (response) { return response.json().rows; });
	    };
	    DashboardService.prototype.getElementsUntilPageWithFilters = function (page, categoryType, sellerType, cities, tags, search) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        var language = this._translateService.currentLang;
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        var url;
	        if (token == null || token == undefined || token == "") {
	            url = this._mainUrl + "/until/filters/" + language + "/" + page + "/" + categoryType + "/" + sellerType + "/" + cities + "/" + tags + "/" + search;
	        }
	        else {
	            url = this._mainUrl + "/until/filters/authenticated/" + language + "/" + page + "/" + categoryType + "/" + sellerType + "/" + cities + "/" + tags + "/" + search;
	        }
	        return this.http.get(this.serverURL + url, options).map(function (response) { return response.json().rows; });
	    };
	    DashboardService.prototype.getElementsCount = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        var url = this._mainUrl + "/count";
	        return this.http.get(this.serverURL + url, options).map(function (response) { return response.json().count; });
	    };
	    DashboardService.prototype.sendMessage = function (messageTitle, messageContent, messageUserReceiverId) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        return this.http.post(this.serverURL + this._mainUrl + "/message", this.serializeObj({ message_title: messageTitle, message_content: messageContent, message_userReceiverId: messageUserReceiverId }), { headers: authHeader }).toPromise().then(function (result) {
	            return JSON.parse(result.text());
	        }).catch(this.handleError);
	    };
	    DashboardService.prototype.getElementsCountWithFilters = function (categoryType, sellerType, cities, tags, search) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        var url = this._mainUrl + "/filters/count/" + categoryType + "/" + sellerType + "/" + cities + "/" + tags + "/" + search;
	        return this.http.get(this.serverURL + url, options).map(function (response) { return response.json().count; });
	    };
	    DashboardService.prototype.getLanguage = function () {
	        return this._translateService.currentLang;
	    };
	    DashboardService.prototype.login = function (email, password) {
	        var _this = this;
	        var creds = "email=" + email + "&password=" + password;
	        return this.http.post(this.serverURL + '/loginData', creds, { headers: new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' }) }).map(function (res) {
	            var data = res.json();
	            if (data.token !== undefined) {
	                _this.token = data.token;
	                localStorage.setItem('token', _this.token);
	            }
	            return data;
	        });
	    };
	    DashboardService.prototype.getTokenService = function () {
	        this.token = localStorage.getItem('token');
	    };
	    DashboardService.prototype.getUserName = function () {
	        return localStorage.getItem("userName");
	    };
	    DashboardService.prototype.getUserStatus = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        if (token != null && token != "") {
	            authHeader.append('Authorization', 'Bearer ' + token);
	            var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	            return this.http.get(this.serverURL + '/loginData/userStatus', options).toPromise().then(function (res) {
	                if (JSON.parse(res.text()).code == -1) {
	                    return "guest";
	                }
	                else {
	                    return JSON.parse(res.text());
	                }
	            }).catch(this.handleError);
	        }
	        else {
	            return Promise.resolve({ role: "guest" });
	        }
	    };
	    DashboardService.prototype.changeLanguage = function (lang) {
	        if (lang == "CAT") {
	            this._translateService.currentLang = "cat";
	        }
	        else if (lang == "ESP") {
	            this._translateService.currentLang = "esp";
	        }
	        else if (lang == "ENG") {
	            this._translateService.currentLang = "eng";
	        }
	    };
	    DashboardService.prototype.manageFavorite = function (element_id) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        return this.http.post(this.serverURL + this._mainUrl, this.serializeObj({ id: element_id }), { headers: authHeader }).toPromise().then(function (result) {
	            return JSON.parse(result.text());
	        }).catch(this.handleError);
	    };
	    DashboardService.prototype.handleError = function (error) {
	        console.error(error);
	        return Observable_1.Observable.throw(error.json().error || 'Server error');
	    };
	    DashboardService.prototype.serializeObj = function (obj) {
	        var result = [];
	        for (var property in obj)
	            result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));
	        return result.join("&");
	    };
	    DashboardService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof ng2_translate_1.TranslateService !== 'undefined' && ng2_translate_1.TranslateService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], DashboardService);
	    return DashboardService;
	    var _a, _b;
	}());
	exports.DashboardService = DashboardService;


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<!--Premium Elements-->\n<div *ngIf=\"showPremiums\" class=\"col-xs-12 col-md-12\"  style=\"border-bottom: 1px solid #6fb3cb; padding-bottom: 1em;\">\n    <div *ngFor=\"let element of premiumElements\" (mouseenter)=\"mouseOverElement(element.id)\" (mouseleave)=\"mouseLeaveElement()\" class=\"col-xs-6 col-md-4 col-lg-2 clickable\" style=\"display: inline-block; position: relative; padding: 0; padding-left: 0.5em; padding-right: 0.5em; margin-top: 1em;\"         (click)=\"elementClicked(element)\">\n        <img src=\"{{element.mainImage}}\" style=\"width: 100%; height: auto;\"/>\n        <div style=\"position: absolute; top: 0; left: 0.5em; background-color: rgba(0, 0, 0, 0.5); padding-left: 0.5em; padding-top: 0.25em; padding-right: 0.5em; padding-bottom: 0.25em;\">\n            <span class=\"glyphicon glyphicon-heart big-glyphicon\" style=\"float: left; color: #6fb3cb; padding-top: 0.1em;\"></span>\n            <span style=\"float: left; margin-left: 0.5em; font-weight: 100; color: white;\">{{element.usage}}</span>            \n        </div>\n        <div *ngIf=\"elementHover == element.id\" style=\"position: absolute; bottom: 0; left: 0.5em; right: 0.5em; background-color: rgba(0, 0, 0, 0.5); padding-left: 0.5em; padding-top: 0.25em; padding-right: 0.5em; padding-bottom: 0.25em;\">\n            <span class=\"fontSizeVariable\" style=\"float: left; color: white; font-weight: bold;\">{{element.id_visible}}</span>\n            <span class=\"fontSizeVariable\" style=\"float: left; color: white; margin-left: 0.5em;\">{{element.comercial_name}}</span>\n        </div>\n    </div>\n</div>\n\n<!--List Elements-->\n<div (window:scroll)=\"onScroll($event)\" class=\"col-xs-12 col-md-12\" style=\"padding: 1.5em; text-align: left;\">\n    <!--<span [ngClass]=\"{noVisible: elementsPage == 0}\" class=\"col-xs-2 col-md-2 col-xs-offset-5 col-md-offset-5 glyphicon glyphicon-chevron-up big-glyphicon clickable\" \n            style=\"font-size: 5em; color: #6fb3cb;\" (click)=\"previousElements()\"></span>-->\n    <div *ngFor=\"let element of listElements; let last = last\" class=\"col-xs-12 col-md-6 col-lg-4 element\">\n        <!--Element Photo-->\n        <img src=\"{{element.mainImage}}\" class=\"clickable\" style=\"width: 100%; height: auto;\" (click)=\"elementClicked(element)\" />\n        <div class=\"col-xs-offset-2 col-md-offset-2\" style=\"position: absolute; margin-left: 0; top: 1.5em; left: 1.5em; background-color: rgba(0, 0, 0, 0.5); padding-left: 0.5em; padding-top: 0.25em; padding-right: 0.5em; padding-bottom: 0.25em;\">\n            <span class=\"glyphicon glyphicon-heart big-glyphicon padding-top: 0.1em;\" style=\"float: left; color: #6fb3cb; \"></span>\n            <span style=\"float: left; margin-left: 0.5em; font-weight: 100; color: white;\">{{element.usage}}</span>            \n        </div>\n        <!--Element Name-->\n        <div class=\"col-xs-12\" style=\"text-align: left; padding-left: 0; padding-right: 0;\">\n            <label class=\"messageBlockLabelNormal\" style=\"font-size: 1.3em;\">{{element.id_visible}}</label>\n            <label class=\"clickable messageBlockLabelBold\" style=\"font-size: 1.3em; color: #555555;\" (click)=\"elementClicked(element)\">{{element.comercial_name}}</label>\n            <span class=\"glyphicon glyphicon-envelope big-glyphicon clickable\" style=\"color: #6fb3cb; margin-top: 0.2em; font-size: 1.3em; float: right;\" (click)=\"elementMessageClicked(element)\"></span>\n            <span class=\"glyphicon glyphicon-heart big-glyphicon clickable\" [ngClass]=\"{isFavorite: element.favorite}\"\n                style=\"color: #6fb3cb; margin-top: 0.2em; float: right; padding-right: 0.5em; font-size: 1.3em;\" (click)=\"elementFavoriteClicked(element)\"></span>\n        </div>\n        <!--Element Tags-->\n        <!--<div class=\"col-xs-12 col-md-12\">\n            <div class=\"col-xs-12\" style=\"padding: 0\">\n               <span [ngClass]=\"{displayNone: element.tags_index == 0}\" class=\"col-xs-1 col-md-1 glyphicon glyphicon-chevron-left big-glyphicon clickable\"\n                style=\"color: #6fb3cb; margin-top: 0.2em; margin-right: 0.7em;\" (click)=\"previousTagsClicked(element)\"></span>\n                    <div *ngFor=\"let tag of element.tags.slice(element.tags_index * tagsToShowInElement, element.tags_index * tagsToShowInElement + tagsToShowInElement)\" style=\" float: left;\">\n                        <label class=\"tagMainSelected\">{{tag.name}}</label>\n                        <label style=\"margin-left: -1.4em; z-index: 999; position: relative; color: white;\">●</label>\n                    </div>\n                    <span [ngClass]=\"{displayNone: element.tags_index * tagsToShowInElement + (tagsToShowInElement + 1) > element.tags.length}\"\n                class=\"col-xs-1 col-md-1 glyphicon glyphicon-chevron-right big-glyphicon clickable\" style=\"color: #6fb3cb; margin-top: 0.2em;\"\n                (click)=\"nextTagsClicked(element)\"></span>\n            </div>\n        </div>-->\n        <!--Element Cities-->\n        <!--<div class=\"col-xs-12 col-md-12\" style=\"margin-top: 1em;\">\n            <div *ngFor=\"let day of element.days\" style=\"padding-top:0.3em; background-color: #ededed; display: inline-block; height: 2em; margin-right: 1em; margin-bottom: 1em; padding-right: 0.7em;\">\n                <img style=\"height: 2.5em; margin-top: -1em; margin-left: -0.5em;\" src=\"" + __webpack_require__(190) + "\"/>\n                <label style=\"font-weight: 100; font-size: 0.8em; color: grey; padding-right: 0.2em;\">{{day.city_name}}</label>\n            </div>\n        </div>-->\n        {{last ? setScroll() : ''}}\n    </div>\n    <!--<span [ngClass]=\"{noVisible: (elementsPage + 1) * elementsToShow >= elementsCount}\" class=\"col-xs-2 col-md-2 col-xs-offset-5 col-md-offset-5 glyphicon glyphicon-chevron-down big-glyphicon clickable\" style=\"font-size: 5em; color: #6fb3cb;\" (click)=\"nextElements()\"></span>-->\n</div>\n\n<div [ngClass]=\"classLoginModal\" role=\"dialog\">\n    <div class=\"modal-dialog\" style=\"z-index: 9999999999;\">\n        <!-- Modal content-->\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" (click)=\"closeLoginModal()\">&times;</button>\n                <h4 class=\"modal-title\">{{ 'TO_ACCESS' | translate}}</h4>\n            </div>\n            <div class=\"modal-body\" style=\"height: 15em;\">\n                <div>\n                    <div class=\"form-group\">\n                        <label for=\"email\">{{ 'EMAIL' | translate }}</label>\n                        <input [(ngModel)]=\"loginEmail\" type=\"email\" class=\"form-control\" id=\"email\" (keyup.enter)=\"loginClicked()\">\n                        <span *ngIf=\"loginCode === 530 || loginCode === 531\" class=\"login-error-msg\">{{ 'WRITE_YOUR_EMAIL' | translate }}</span>\n                        <span *ngIf=\"loginCode === 533\" class=\"login-error-msg\">{{ 'WRONG_EMAIL' | translate }}</span>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"password\">{{ 'PASSWORD' | translate }}</label>\n                        <input [(ngModel)]=\"loginPassword\" type=\"password\" class=\"form-control\" id=\"password\" (keyup.enter)=\"loginClicked()\">\n                        <span *ngIf=\"loginCode === 530 || loginCode === 532\" class=\"login-error-msg\">{{ 'WRITE_YOUR_PASSWORD' | translate }}</span>\n                        <span *ngIf=\"loginCode === 534\" class=\"login-error-msg\">{{ 'WRONG_PASSWORD' | translate }}</span>\n                    </div>\n                </div>\n            </div>\n            <div class=\"modal-footer\" style=\"margin-top: 2em;\">\n                <button type=\"button\" class=\"btn\" (click)=\"registerClicked()\" style=\"float: left; background-color: #6fb3cb; color: white;\">{{ 'REGISTER' | translate }}</button>\n                <button type=\"button\" class=\"btn btn-default submitbutton\" (click)=\"loginClicked()\" style=\" background-color: #6fb3cb; color: white;\">{{ 'LOGIN' | translate }}</button>\n                <button type=\"button\" class=\"btn\" (click)=\"closeLoginModal()\">{{ 'CLOSE' | translate }}</button>\n            </div>\n        </div>\n    </div>\n</div>\n<div [ngClass]=\"classMessageModal\" role=\"dialog\">\n    <div class=\"modal-dialog\" style=\"z-index: 9999999999;\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" (click)=\"closeMessageModal()\">&times;</button>\n                <h4 *ngIf=\"selectedElement != null\" class=\"modal-title\">{{selectedElement.id_visible}}&nbsp;-&nbsp;{{selectedElement.comercial_name}}</h4>\n                <h5 class=\"modal-title\">{{ 'SEND_MESSAGE' | translate }}</h5>\n            </div>\n            <div class=\"modal-body\" style=\"height: 20em;\">\n                <div>\n                    <div class=\"form-group\">\n                        <label for=\"title\">{{ 'TITLE' | translate }}</label>\n                        <input [(ngModel)]=\"messageTitle\" type=\"text\" class=\"form-control\" id=\"title\" (keyup.enter)=\"sendMessageClicked()\">\n                        <span *ngIf=\"messageCode === 1 || messageCode === 3\" class=\"login-error-msg\">{{ 'WRITE_A_TITLE' | translate }}</span>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"content\">{{ 'CONTENT' | translate }}</label>\n                         <textarea [(ngModel)]=\"messageContent\" maxlength=\"1000\" class=\"form-control\" style=\"height: 8em; resize: none; color: grey;\"></textarea>\n                         <span *ngIf=\"messageCode === 2 || messageCode === 3\" class=\"login-error-msg\">{{ 'WRITE_A_CONTENT' | translate }}</span>                        \n                    </div>                    \n                </div>\n            </div>\n            <div class=\"modal-footer\" style=\"margin-top: 2em;\">\n                <button type=\"button\" class=\"btn btn-default submitbutton\" (click)=\"sendMessageClicked()\" style=\"background-color: #6fb3cb; color: white;\">{{ 'SEND' | translate }}</button>\n                <button type=\"button\" class=\"btn\" (click)=\"closeMessageModal()\">{{ 'CLOSE' | translate }}</button>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/place-min-grey-2.96d08cd91ad3507c37ae5247a88aa5b1.png";

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(76);
	var element_detail_service_1 = __webpack_require__(192);
	var MainElementDetailComponent = (function () {
	    function MainElementDetailComponent(_elementDetailService, _parentRouter, route) {
	        this._elementDetailService = _elementDetailService;
	        this.route = route;
	        this.days = [
	            { id: 1, name: "MONDAY" },
	            { id: 2, name: "TUESDAY" },
	            { id: 3, name: "WEDNESDAY" },
	            { id: 4, name: "THURSDAY" },
	            { id: 5, name: "FRIDAY" },
	            { id: 6, name: "SATURDAY" },
	            { id: 7, name: "SUNDAY" }
	        ];
	        this.router = _parentRouter;
	        this.tagsToShowInElement = 6;
	        this.photosToShowInElement = 3;
	        this.selectedPhotoUrl = "";
	        this.classPhotoModal = { 'model': true, 'show': false, 'hide': true };
	        this.userRole = "guest";
	        this.setUserRole(this.userRole);
	        this.classLoginModal = { 'model': true, 'show': false, 'hide': true };
	        this.loginEmail = "";
	        this.loginPassword = "";
	        this.loginCode = 0;
	        this.classMessageModal = { 'model': true, 'show': false, 'hide': true };
	        this.messageTitle = "";
	        this.messageContent = "";
	        this.messageCode = 0;
	        this.classUbicationModal = { 'model': true, 'show': false, 'hide': true };
	        this.cityName = "";
	        this.cityLatitude = null;
	        this.cityLongitude = null;
	        this.openLinks = false;
	        this.openTags = false;
	        this.openDays = false;
	        this.openPhotos = false;
	        this.openDescription = false;
	    }
	    MainElementDetailComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._elementDetailService.getUserStatus().then(function (status) {
	            _this.userRole = status.role;
	            _this.setUserRole(_this.userRole);
	        });
	        this.route.params.subscribe(function (params) {
	            _this.idReceived = Number(params['elementId']);
	            _this.scroll = Number(params['scroll']);
	            _this.scrollHeight = Number(params['scrollHeight']);
	            _this.elementsPage = Number(params['loadedPage']);
	            _this.categoryFilter = params['categoryType'];
	            _this.sellerFilter = params['sellerType'];
	            _this.citiesFilter = params['citiesFilter'];
	            _this.tagsFilter = params['tagsFilter'];
	            _this._elementDetailService.getElementsById(_this.idReceived).then(function (result) {
	                if (result != null) {
	                    console.log(result);
	                    var index;
	                    for (index = 0; index < result.days.length; ++index) {
	                        result.days[index].latitude = Number(result.days[index].latitude);
	                        result.days[index].longitude = Number(result.days[index].longitude);
	                    }
	                    _this.element = result;
	                    _this.element.tags_index = 0;
	                    _this.element.photos_index = 0;
	                }
	            });
	        });
	    };
	    MainElementDetailComponent.prototype.openLinksEvent = function () {
	        this.openLinks = !this.openLinks;
	    };
	    MainElementDetailComponent.prototype.openTagsEvent = function () {
	        this.openTags = !this.openTags;
	    };
	    MainElementDetailComponent.prototype.openDaysEvent = function () {
	        this.openDays = !this.openDays;
	    };
	    MainElementDetailComponent.prototype.openPhotosEvent = function () {
	        this.openPhotos = !this.openPhotos;
	    };
	    MainElementDetailComponent.prototype.openDescriptionEvent = function () {
	        this.openDescription = !this.openDescription;
	    };
	    MainElementDetailComponent.prototype.photoSelected = function (photoUrl) {
	        this.selectedPhotoUrl = photoUrl;
	        this.classPhotoModal.show = true;
	        this.classPhotoModal.hide = false;
	    };
	    MainElementDetailComponent.prototype.previousTagsClicked = function (element) {
	        element.tags_index--;
	    };
	    MainElementDetailComponent.prototype.nextTagsClicked = function (element) {
	        element.tags_index++;
	    };
	    MainElementDetailComponent.prototype.previousPhotosClicked = function (element) {
	        element.photos_index--;
	    };
	    MainElementDetailComponent.prototype.nextPhotosClicked = function (element) {
	        element.photos_index++;
	    };
	    MainElementDetailComponent.prototype.closePhotoModal = function () {
	        this.classPhotoModal.show = false;
	        this.classPhotoModal.hide = true;
	    };
	    MainElementDetailComponent.prototype.closeLoginModal = function () {
	        this.loginCode = 0;
	        this.classLoginModal.show = false;
	        this.classLoginModal.hide = true;
	    };
	    MainElementDetailComponent.prototype.backClicked = function () {
	        this.router.navigate(['/main', 'dashboard', { categoryType: this.categoryFilter, sellerType: this.sellerFilter, citiesFilter: this.citiesFilter, tagsFilter: this.tagsFilter, scroll: this.scroll, scrollHeight: this.scrollHeight, loadedPage: this.elementsPage }]);
	    };
	    MainElementDetailComponent.prototype.setUserRole = function (userRole) {
	        if (userRole == "guest") {
	            this.userIsGuest = true;
	            this.userIsSuperUser = false;
	            this.userIsAdmin = false;
	        }
	        else if (userRole == "superuser") {
	            this.userIsGuest = false;
	            this.userIsSuperUser = true;
	            this.userIsAdmin = false;
	        }
	        else if (userRole == "admin") {
	            this.userIsGuest = false;
	            this.userIsSuperUser = false;
	            this.userIsAdmin = true;
	        }
	    };
	    MainElementDetailComponent.prototype.elementFavoriteClicked = function (element) {
	        if (this.userRole == "guest") {
	            this.classLoginModal.show = true;
	            this.classLoginModal.hide = false;
	        }
	        else if (this.userRole == "admin" || this.userRole == "superuser" || this.userRole == "user") {
	            this._elementDetailService.manageFavorite(element.id).then(function (result) {
	                if (result.code == 1) {
	                    if (result.type == "insert") {
	                        element.favorite = true;
	                    }
	                    else {
	                        element.favorite = false;
	                    }
	                }
	            });
	        }
	    };
	    MainElementDetailComponent.prototype.elementMessageClicked = function (element) {
	        if (this.userRole == "guest") {
	            this.classLoginModal.show = true;
	            this.classLoginModal.hide = false;
	        }
	        else if (this.userRole == "admin" || this.userRole == "superuser" || this.userRole == "user") {
	            this.classMessageModal.show = true;
	            this.classMessageModal.hide = false;
	        }
	    };
	    MainElementDetailComponent.prototype.loginClicked = function () {
	        var _this = this;
	        this._elementDetailService.login(this.loginEmail, this.loginPassword).subscribe(function (result) {
	            _this.loginCode = result.code;
	            if (result !== null && result.token !== undefined) {
	                localStorage.setItem('userName', result.user.name);
	                location.reload();
	            }
	        });
	    };
	    MainElementDetailComponent.prototype.dayClicked = function (day) {
	        console.log(day);
	        this.cityName = day.city_name;
	        console.log(this.cityName);
	        this.cityLatitude = Number(day.latitude);
	        console.log(this.cityLatitude);
	        this.cityLongitude = Number(day.longitude);
	        console.log(this.cityLongitude);
	        if (this.days[day.id - 1].clicked) {
	            this.days[day.id - 1].clicked = false;
	        }
	        else {
	            this.days[day.id - 1].clicked = true;
	        }
	    };
	    MainElementDetailComponent.prototype.closeUbicationModal = function () {
	        this.classUbicationModal.show = false;
	        this.classUbicationModal.hide = true;
	        this.cityName = "";
	        this.cityLongitude = null;
	        this.cityLatitude = null;
	    };
	    MainElementDetailComponent.prototype.registerClicked = function () {
	        this.router.navigate(['/register']);
	    };
	    MainElementDetailComponent.prototype.closeMessageModal = function () {
	        this.messageCode = 0;
	        this.classMessageModal.show = false;
	        this.classMessageModal.hide = true;
	    };
	    MainElementDetailComponent.prototype.sendMessageClicked = function () {
	        var _this = this;
	        var titleIntroduced;
	        if (this.messageTitle == null || this.messageTitle == undefined || this.messageTitle == "") {
	            titleIntroduced = false;
	        }
	        else {
	            titleIntroduced = true;
	        }
	        var contentIntroduced;
	        if (this.messageContent == null || this.messageContent == undefined || this.messageContent == "") {
	            contentIntroduced = false;
	        }
	        else {
	            contentIntroduced = true;
	        }
	        if (!titleIntroduced && contentIntroduced) {
	            this.messageCode = 1;
	        }
	        else if (titleIntroduced && !contentIntroduced) {
	            this.messageCode = 2;
	        }
	        else if (!titleIntroduced && !contentIntroduced) {
	            this.messageCode = 3;
	        }
	        else {
	            this._elementDetailService.sendMessage(this.messageTitle, this.messageContent, this.element.user_id).then(function (res) {
	                if (res.code == 1) {
	                    _this.closeMessageModal();
	                }
	            });
	        }
	    };
	    MainElementDetailComponent.prototype.validateFacebookSite = function (facebook) {
	        if (facebook.indexOf("www.facebook.com") >= 0 || facebook.indexOf("www.facebook.es") >= 0) {
	            var urlParams = facebook.split("/");
	            var facebookUrl = "/";
	            for (var i = 1; i < urlParams.length; i++) {
	                facebookUrl += urlParams[i];
	                if (i != urlParams.length - 1) {
	                    facebookUrl += "/";
	                }
	            }
	            return facebookUrl;
	        }
	        else {
	            if (facebook.indexOf("/") != 0) {
	                return "/" + facebook;
	            }
	            else {
	                return facebook;
	            }
	        }
	    };
	    MainElementDetailComponent = __decorate([
	        core_1.Component({
	            selector: 'elementdetail',
	            providers: [element_detail_service_1.ElementDetailService],
	            template: __webpack_require__(193),
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof element_detail_service_1.ElementDetailService !== 'undefined' && element_detail_service_1.ElementDetailService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object])
	    ], MainElementDetailComponent);
	    return MainElementDetailComponent;
	    var _a, _b, _c;
	}());
	exports.MainElementDetailComponent = MainElementDetailComponent;


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(30);
	var Observable_1 = __webpack_require__(5);
	var ng2_translate_1 = __webpack_require__(29);
	var json = __webpack_require__(95);
	var ElementDetailService = (function () {
	    function ElementDetailService(_translateService, http) {
	        this._translateService = _translateService;
	        this.http = http;
	        this._mainUrl = '/mainData';
	        this._elementDetailUrl = '/elementDetailData';
	        this.serverURL = json.api_url;
	        this.getTokenService();
	    }
	    ElementDetailService.prototype.getElementsById = function (element_id) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        var language = this._translateService.currentLang;
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        var url;
	        if (token == null || token == undefined || token == "") {
	            url = this._elementDetailUrl + "/" + language + "/" + element_id;
	        }
	        else {
	            url = this._elementDetailUrl + "/authenticated/" + language + "/" + element_id;
	        }
	        return this.http.get(this.serverURL + url, options).toPromise().then(function (res) {
	            if (JSON.parse(res.text()).code == 1) {
	                return JSON.parse(res.text()).rows[0];
	            }
	            else {
	                return null;
	            }
	        }, this.handleError);
	    };
	    ElementDetailService.prototype.manageFavorite = function (element_id) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        return this.http.post(this.serverURL + this._mainUrl, this.serializeObj({ id: element_id }), { headers: authHeader }).toPromise().then(function (result) {
	            return JSON.parse(result.text());
	        }).catch(this.handleError);
	    };
	    ElementDetailService.prototype.sendMessage = function (messageTitle, messageContent, messageUserReceiverId) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        return this.http.post(this.serverURL + this._mainUrl + "/message", this.serializeObj({ message_title: messageTitle, message_content: messageContent, message_userReceiverId: messageUserReceiverId }), { headers: authHeader }).toPromise().then(function (result) {
	            return JSON.parse(result.text());
	        }).catch(this.handleError);
	    };
	    ElementDetailService.prototype.login = function (email, password) {
	        var _this = this;
	        var creds = "email=" + email + "&password=" + password;
	        return this.http.post(this.serverURL + '/loginData', creds, { headers: new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' }) }).map(function (res) {
	            var data = res.json();
	            if (data.token !== undefined) {
	                _this.token = data.token;
	                localStorage.setItem('token', _this.token);
	            }
	            return data;
	        });
	    };
	    ElementDetailService.prototype.getUserStatus = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        if (token != null && token != "") {
	            authHeader.append('Authorization', 'Bearer ' + token);
	            var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	            return this.http.get(this.serverURL + '/loginData/userStatus', options).toPromise().then(function (res) {
	                if (JSON.parse(res.text()).code == -1) {
	                    return "guest";
	                }
	                else {
	                    return JSON.parse(res.text());
	                }
	            }).catch(this.handleError);
	        }
	        else {
	            return new Promise(function (resolve, reject) {
	                return "guest";
	            });
	        }
	    };
	    ElementDetailService.prototype.getTokenService = function () {
	        this.token = localStorage.getItem('token');
	    };
	    ElementDetailService.prototype.handleError = function (error) {
	        console.error(error);
	        return Observable_1.Observable.throw(error.json().error || 'Server error');
	    };
	    ElementDetailService.prototype.serializeObj = function (obj) {
	        var result = [];
	        for (var property in obj)
	            result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));
	        return result.join("&");
	    };
	    ElementDetailService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof ng2_translate_1.TranslateService !== 'undefined' && ng2_translate_1.TranslateService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], ElementDetailService);
	    return ElementDetailService;
	    var _a, _b;
	}());
	exports.ElementDetailService = ElementDetailService;


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div *ngIf=\"element\" class=\"col-xs-12 col-md-12\" style=\"height: 100%;\">\n    <div class=\"col-xs-12\" style=\"padding: 0\">\n        <div class=\"col-xs-12 hidden-xs\" style=\"padding: 0\">\n            <button style=\"float: right; color: #035d72; background-color: transparent; border-radius: 0%\" (click)=\"backClicked()\">{{ 'BACK' | translate }}</button>\n        </div>\n        <div class=\"col-xs-12 col-md-3\" style=\"padding: 0\">                        \n            <img src=\"{{element.mainImage}}\" class=\"col-xs-12 col-md-12 clickable\" style=\"height: auto; padding-bottom: 1em;\" (click)=\"photoSelected(element.mainImage)\"/>                        \n        </div>\n        \n        <div class=\"col-xs-12 col-md-9 hidden-xs\" >\n            <div>\n                <div class=\"col-xs-2 col-md-2\" style=\"padding: 0;\">\n                    <img *ngIf=\"element.user_subrole == 2 || element.user_subrole == 4 || element.user_subrole == 8 || element.user_subrole == 9\" style=\"height: auto; max-width: 100%;\" class=\"logo\" src=\"" + __webpack_require__(194) + "\" />\n                    <img *ngIf=\"element.user_subrole == 1 || element.user_subrole == 3\" style=\"height: auto; max-width: 100%;\" src=\"" + __webpack_require__(195) + "\" class=\"logo\"/>  \n                </div>                \n                <div class=\"col-xs-10 col-md-10\" style=\"padding-left: 0em;\">\n                    <div class=\"col-xs-12\">\n                        <!--VENEDOR-->\n                        <label *ngIf=\"element.user_subrole == 1\" style=\"float: left; font-weight: 100; color: #353535; line-height: 100%;\">{{ 'PROFESSIONAL_SELLER_CATEGORY' | translate }}</label>\n                        <label *ngIf=\"element.user_subrole == 2\" style=\"float: left; font-weight: 100; color: #353535; line-height: 100%;\">{{ 'TRADITIONAL_SELLER_CATEGORY' | translate }}</label>\n                        <label *ngIf=\"element.user_subrole == 8\" style=\"float: left; font-weight: 100; color: #353535; line-height: 100%;\">{{ 'STANDARD_SELLER_CATEGORY' | translate }}</label>\n\n                        <!--ARTESÀ-->\n                        <label *ngIf=\"element.user_subrole == 3\" style=\"float: left; font-weight: 100; color: #353535; line-height: 100%;\">{{ 'PROFESSIONAL_ARTISAN_CATEGORY' | translate }}</label>\n                        <label *ngIf=\"element.user_subrole == 4\" style=\"float: left; font-weight: 100; color: #353535; line-height: 100%;\">{{ 'TRADITIONAL_ARTISAN_CATEGORY' | translate }}</label>\n                        <label *ngIf=\"element.user_subrole == 9\" style=\"float: left; font-weight: 100; color: #353535; line-height: 100%;\">{{ 'STANDARD_ARTISAN_CATEGORY' | translate }}</label>\n                    </div>\n                    <div class=\"col-xs-12\">\n                        <label style=\"padding-right: 1em; font-size: 1.6em; color: #555555;\">{{element.id_visible}}</label>\n                        <label style=\"font-size: 1.3em; font-weight: 100\">{{element.comercial_name}}</label>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-xs-12\" style=\"padding-top: 1em\">\n                <span [ngClass]=\"{isFavorite: element.favorite}\" class=\"glyphicon glyphicon-heart big-glyphicon clickable\" style=\"color: #6fb3cb; font-size: 2em; text-align: center;\" (click)=\"elementFavoriteClicked(element)\"></span>\n                &nbsp;\n                <span style=\"font-size: 1.5em;  color: #353535;\">{{element.usage}}</span>\n                &nbsp;&nbsp;&nbsp;&nbsp;\n                <span class=\"glyphicon glyphicon-envelope big-glyphicon clickable\" (click)=\"elementMessageClicked(element)\" style=\"color: #6fb3cb; font-size: 2em; text-align: center;\"></span>\n                <!--&nbsp;\n                <span style=\"font-size: 1em;\">{{ 'SEND_MESSAGE' | translate }}</span>-->\n            </div>\n            <div class=\"col-xs-12 hidden-xs\">\n                <span style=\"margin-top: 0.5em; float: left;  color: #353535;\">{{element.description}}</span>\n            </div>\n        </div>\n\n        <div class=\"col-xs-12 visible-xs\" style=\"padding: 0;\">\n            <div class=\"col-xs-12\" style=\"padding: 0;\">\n                <div class=\"col-xs-2\" style=\"padding: 0;\">\n                    <img *ngIf=\"element.user_subrole == 2 || element.user_subrole == 4 || element.user_subrole == 8 || element.user_subrole == 9\" style=\"height: auto; max-width: 100%;\" class=\"logo\" src=\"" + __webpack_require__(194) + "\" />\n                    <img *ngIf=\"element.user_subrole == 1 || element.user_subrole == 3\" style=\"height: auto; max-width: 100%;\" class=\"logo\" src=\"" + __webpack_require__(195) + "\" />  \n                </div>\n                <div class=\"col-xs-10\" style=\"padding: 0;\">\n                    <label *ngIf=\"element.user_subrole == 1\" style=\"font-weight: 100; color: #353535;\">{{ 'PROFESSIONAL_SELLER_CATEGORY' | translate }}</label>\n                    <label *ngIf=\"element.user_subrole == 2\" style=\"float: left; font-weight: 100; color: #353535;\">{{ 'TRADITIONAL_SELLER_CATEGORY' | translate }}</label>\n                    <label *ngIf=\"element.user_subrole == 8\" style=\"float: left; font-weight: 100; color: #353535;\">{{ 'STANDARD_SELLER_CATEGORY' | translate }}</label>\n                    <label *ngIf=\"element.user_subrole == 3\" style=\"float: left; font-weight: 100; color: #353535;\">{{ 'PROFESSIONAL_ARTISAN_CATEGORY' | translate }}</label>\n                    <label *ngIf=\"element.user_subrole == 4\" style=\"float: left; font-weight: 100; color: #353535;\">{{ 'TRADITIONAL_ARTISAN_CATEGORY' | translate }}</label>\n                    <label *ngIf=\"element.user_subrole == 9\" style=\"float: left; font-weight: 100; color: #353535;\">{{ 'STANDARD_ARTISAN_CATEGORY' | translate }}</label>\n                </div>\n            </div>\n            <div class=\"col-xs-12\" style=\"padding: 0; margin-top: 0.2em;\">                \n                <label style=\"font-size: 1.1em;\"><span style=\"color: black; font-weight: bold; font-size: 1.3em;\">{{element.id_visible}}</span> {{element.comercial_name}}</label>\n            </div>\n        </div>\n        <div class=\"col-xs-12 visible-xs\" style=\"padding-top: 0.2em\">\n            <span [ngClass]=\"{isFavorite: element.favorite}\" class=\"glyphicon glyphicon-heart big-glyphicon clickable\" style=\"color: #6fb3cb; font-size: 2em; text-align: center;\" (click)=\"elementFavoriteClicked(element)\"></span>            \n            <span style=\"font-size: 1.5em;  color: #353535;\">{{element.usage}}</span>\n            &nbsp;&nbsp;&nbsp;&nbsp;\n            <span class=\"glyphicon glyphicon-envelope big-glyphicon clickable\" (click)=\"elementMessageClicked(element)\" style=\"color: #6fb3cb; font-size: 2em; text-align: center;\"></span>            \n        </div>\n    </div>\n\n<!--LINKS-->\n    <!--TABLET I PC-->\n    <div class=\"col-xs-12 hidden-xs\" style=\"padding: 0; margin-top: 0.2em;\">\n        <div *ngIf=\"element.web_site != '' && element.web_site != null && element.web_site != undefined && element.web_site != 'null' && element.web_site != 'undefined'\" class=\"col-xs-12\">\n            <img style=\"height: 2.5em; width: auto;\" class=\"logo col-xs-1\" src=\"" + __webpack_require__(121) + "\" />\n            <a style=\"line-height: 2em; font-size: 1.5em;\" href=\"http://{{element.web_site}}\" target=\"_blank\">{{element.web_site}}</a>\n        </div>\n        <div *ngIf=\"element.facebook_site != '' && element.facebook_site != null && element.facebook_site != undefined && element.facebook_site != 'null' && element.facebook_site != 'undefined'\"  class=\"col-xs-12\" style=\"margin-top: 0.1em;\">\n            <img style=\"height: 2.5em; width: auto;\" class=\"logo col-xs-1\" src=\"" + __webpack_require__(122) + "\" />\n            <a style=\"line-height: 2em; font-size: 1.5em;\" href=\"http://{{element.facebook_site}}\" target=\"_blank\">{{validateFacebookSite(element.facebook_site)}}</a>\n        </div>\n    </div>\n    <!--MOVIL-->\n    <div *ngIf=\"element.description != null && element.description != undefined && element.description != '' && element.description != 'null' && element.description != 'undefined'\" \n    class=\"col-xs-12 visible-xs clickable drop-option\" [ngClass]=\"{isDropped: openDescription}\" style=\"margin-top: 0.2em;\" (click)=\"openDescriptionEvent()\">\n        <label *ngIf=\"!openDescription\" class=\"col-xs-9\" style=\"text-align: left; color: #035d72;\">{{ 'DESCRIPTION' | translate }}</label>\n        <label *ngIf=\"openDescription\" class=\"col-xs-9\" style=\"text-align: left; color: white;\">{{ 'DESCRIPTION' | translate }}</label>\n        <span *ngIf=\"!openDescription\" class=\"col-xs-3 glyphicon glyphicon-chevron-right big-glyphicon\" style=\"color: #035d72; text-align: center;\"></span>\n        <span *ngIf=\"openDescription\" class=\"col-xs-3 glyphicon glyphicon-chevron-down big-glyphicon\" style=\"color: white; text-align: center;\"></span>        \n    </div>\n    <div *ngIf=\"openDescription\" class=\"col-xs-12 visible-xs\" style=\"margin-bottom: 0.9em;\">\n        <span style=\"margin-top: 0.9em; float: left;  color: #353535;\">{{element.description}}</span>\n    </div>\n\n    <div *ngIf=\"(element.web_site != '' && element.web_site != null && element.web_site != undefined && element.web_site != 'null' && element.web_site != 'undefined') || (element.facebook_site != '' && element.facebook_site != null && element.facebook_site != undefined && element.facebook_site != 'null' && element.facebook_site != 'undefined')\" \n    class=\"col-xs-12 visible-xs clickable drop-option\" [ngClass]=\"{isDropped: openLinks}\" (click)=\"openLinksEvent();\">\n        <label *ngIf=\"!openLinks\" class=\"col-xs-9\" style=\"text-align: left; color: #035d72;\">{{ 'LINKS' | translate }}</label>\n        <label *ngIf=\"openLinks\" class=\"col-xs-9\" style=\"text-align: left; color: white\">{{ 'LINKS' | translate }}</label>\n        <span *ngIf=\"!openLinks\" class=\"col-xs-3 glyphicon glyphicon-chevron-right big-glyphicon\" style=\"color: #035d72; text-align: center;\"></span>\n        <span *ngIf=\"openLinks\" class=\"col-xs-3 glyphicon glyphicon-chevron-down big-glyphicon\" style=\"color: white; text-align: center;\"></span>        \n    </div>\n    <div *ngIf=\"openLinks\" class=\"col-xs-12 visible-xs\" style=\"padding: 0; margin-top: 0.9em; margin-bottom: 0.9em;\">\n        <div *ngIf=\"element.web_site != '' && element.web_site != null && element.web_site != undefined && element.web_site != 'null' && element.web_site != 'undefined'\" class=\"col-xs-12\">\n            <img style=\"height: auto; width: 8.33%\" class=\"logo\" src=\"" + __webpack_require__(121) + "\" />\n            <a style=\"font-size: 3.5vw; margin-left: 1em;\" href=\"http://{{element.web_site}}\" target=\"_blank\">{{element.web_site}}</a>\n        </div>\n        <div *ngIf=\"element.facebook_site != '' && element.facebook_site != null && element.facebook_site != undefined && element.facebook_site != 'null' && element.facebook_site != 'undefined'\"  class=\"col-xs-12\" style=\"margin-top: 0.1em;\">\n            <img style=\"height: auto; width: 8.33%\" class=\"logo\" src=\"" + __webpack_require__(122) + "\" />\n            <a style=\"font-size: 3.5vw; margin-left: 1em;\" href=\"http://{{element.facebook_site}}\" target=\"_blank\">{{validateFacebookSite(element.facebook_site)}}</a>\n        </div>\n    </div>\n\n    <div *ngIf=\"element.tags.length > 0\" class=\"col-xs-12 visible-xs clickable drop-option\" [ngClass]=\"{isDropped: openTags}\" (click)=\"openTagsEvent()\">\n        <label *ngIf=\"!openTags\" class=\"col-xs-9\" style=\"text-align: left; color: #035d72;\">{{ 'TAGS' | translate }}</label>\n        <label *ngIf=\"openTags\" class=\"col-xs-9\" style=\"text-align: left; color: white;\">{{ 'TAGS' | translate }}</label>\n        <span *ngIf=\"!openTags\" class=\"col-xs-3 glyphicon glyphicon-chevron-right big-glyphicon\" style=\"color: #035d72; text-align: center;\"></span>\n        <span *ngIf=\"openTags\" class=\"col-xs-3 glyphicon glyphicon-chevron-down big-glyphicon\" style=\"color: white; text-align: center;\"></span>\n    </div>\n    <div *ngIf=\"openTags\" class=\"col-xs-12 xs-visible\" style=\"text-align: left; margin-top: 0.9em;\">\n        <div *ngFor=\"let tag of element.tags\" (click)=\"selectTagMain(tag.id)\">\n            <label class=\"tag-element\">{{tag.name}}</label>\n            <label style=\"margin-left: -1.4em; z-index: 999; position: relative; color: white;\">●</label>\n        </div>\t\n    </div>\n\n    <div *ngIf=\"element.days.length > 0\" class=\"col-xs-12 visible-xs clickable drop-option\" [ngClass]=\"{isDropped: openDays}\" (click)=\"openDaysEvent()\">\n        <label *ngIf=\"!openDays\" class=\"col-xs-9\" style=\"text-align: left; color: #035d72;\">{{ 'UBICATIONS' | translate }}</label>\n        <label *ngIf=\"openDays\" class=\"col-xs-9\" style=\"text-align: left; color: white;\">{{ 'UBICATIONS' | translate }}</label>\n        <span *ngIf=\"!openDays\" class=\"col-xs-3 glyphicon glyphicon-chevron-right big-glyphicon\" style=\"color: #035d72; text-align: center;\"></span>\n        <span *ngIf=\"openDays\" class=\"col-xs-3 glyphicon glyphicon-chevron-down big-glyphicon\" style=\"color: white; text-align: center;\"></span>\n    </div>\n    <div *ngIf=\"openDays\" class=\"col-xs-12 xs-visible\" style=\"margin-top: 0.9em; text-align: left;\">\n        <div class=\"col-xs-12\" *ngFor=\"let day of element.days\" style=\"margin-bottom: 0.9em;\">\n            <span class=\"col-xs-12\" style=\"font-size: 1.3em; font-weight: bold;\">{{ days[day.id-1].name | translate }}</span>\n            <span style=\"font-size: 1em;\" class=\"col-xs-12\">{{ day.information }}</span>\n            <div style=\"padding-top:0.3em; background-color: #ededed; display: inline-block; height: 2em; margin-top: 0.4em;\" class=\"clickable col-xs-12\" (click)=\"dayClicked(day)\">\n                <img style=\"height: 2.5em; margin-top: -1em;\" src=\"" + __webpack_require__(190) + "\"/>\n                <label style=\"font-weight: 100; font-size: 0.8em; color: grey;\">{{day.city_name}}</label>\n            </div>\n            <div *ngIf=\"days[day.id-1].clicked\" class=\"col-xs-12\" style=\"margin-top: 0.2em;\">\n                <sebm-google-map [latitude]=\"day.latitude\" [longitude]=\"day.longitude\" [zoom]=\"13\">\n                    <sebm-google-map-marker [latitude]=\"day.latitude\" [longitude]=\"day.longitude\" [markerDraggable]=\"draggable\"></sebm-google-map-marker>\n                </sebm-google-map>\n            </div>\n        </div>\n    </div>\n\n    <!--<div *ngIf=\"element.photos.length > 0\" class=\"col-xs-12 visible-xs clickable drop-option\" (click)=\"openPhotosEvent()\" style=\"margin-bottom: 0.9em;\">\n        <label class=\"col-xs-9\" style=\"text-align: left; color: #035d72;\">{{ 'PHOTOS' | translate }}</label>\n        <span *ngIf=\"!openPhotos\" class=\"col-xs-3 glyphicon glyphicon-chevron-right big-glyphicon\" style=\"color: #035d72; text-align: center;\"></span>\n        <span *ngIf=\"openPhotos\" class=\"col-xs-3 glyphicon glyphicon-chevron-down big-glyphicon\" style=\"color: #035d72; text-align: center;\"></span>\n    </div>-->\n    <div *ngIf=\"element.photos.length > 0\" class=\"col-xs-12 visible-xs\" style=\"padding: 0; margin-top: 0.9em;\">\n        <div class=\"col-xs-12 clickable elementPhoto\" *ngFor=\"let photo of element.photos\" style=\"margin-top: 0; padding: 0; margin-bottom: 0.9em;\">\n            <img src=\"{{photo.url}}\" class=\"col-xs-12 clickable\" style=\"height: auto; padding: 0;\" (click)=\"photoSelected(photo.url)\" />\n            <span *ngIf=\"photo.price && photo.price!='' && photo.price!='undefined'\" style=\"display: block; background: #6fb3cb; font-size: 1.3em; color: white; text-align: center;\">{{photo.price}} {{'COIN_TYPE' | translate}}</span>\n        </div> \n    </div>    \n\n\n    <div class=\"col-xs-12 hidden-xs\" style=\"padding: 0; margin-top: 1em;\">\n        <div class=\"col-xs-12 col-md-9\"> \n            <!--Element Tags--> \n            <div class=\"col-xs-12 col-md-12\" style=\"margin-top: 1em;\">\n                <div *ngFor=\"let tag of element.tags\" (click)=\"selectTagMain(tag.id)\" style=\"margin-bottom: 1em; float: left; margin-right: 2em;\">\n                    <label class=\"tag-element\">{{tag.name}}</label>\n                    <label style=\"margin-left: -1.4em; z-index: 999; position: relative; color: white;\">●</label>\n                </div>\t\n            </div>  \n            <!--Element Days-->\n            <div class=\"col-xs-12 col-md-12\" style=\"margin-top: 2em; margin-left: 0em; margin-right: 0em;\">\n                <div class=\"col-xs-12\" *ngFor=\"let day of element.days\" style=\"margin-left: 0em; margin-right: 0em; margin-top: 1em;\" >\n                    <span class=\"col-xs-6 col-md-2\" style=\"font-size: 1.3em;\">{{ days[day.id-1].name | translate }}</span>\n                    <div style=\"padding-top:0.3em; background-color: #ededed; display: inline-block; height: 2em;\" class=\"clickable col-xs-6 col-md-4\" (click)=\"dayClicked(day)\">\n                        <img style=\"height: 2.5em; margin-top: -1em;\" src=\"" + __webpack_require__(190) + "\"/>\n                        <label style=\"font-weight: 100; font-size: 0.8em; color: grey;\">{{day.city_name}}</label>                        \n                    </div>\n                    <span style=\"font-size: 1em;\" class=\"col-xs-12 col-md-6\">{{ day.information }}</span>\n                    <div *ngIf=\"days[day.id-1].clicked\" class=\"col-xs-12\">\n                        <sebm-google-map [latitude]=\"day.latitude\" [longitude]=\"day.longitude\" [zoom]=\"13\">\n                            <sebm-google-map-marker [latitude]=\"day.latitude\" [longitude]=\"day.longitude\" [markerDraggable]=\"draggable\"></sebm-google-map-marker>\n                        </sebm-google-map>\n                    </div>\n                </div>\n            </div>\n            \n            <!--Element Contact-->\n            <!--<div class=\"col-xs-12 col-md-12\" style=\"margin-top: 3em;\">\n                <div class=\"col-xs-3 col-md-3 col-xs-offset-1 col-md-offset-1\" style=\"height: 4em; line-height: 4.8em;\">\n                    <span class=\"glyphicon glyphicon-earphone big-glyphicon clickable\" style=\"color: #6fb3cb; font-size: 2em; text-align: center;\"></span>&nbsp;&nbsp;\n                    <span style=\"font-size: 1.5em;\">{{element.user_phone}}</span>\n                </div>\n                <div class=\"col-xs-6 col-md-6\" style=\"height: 4em;\">\n                    <span style=\"color: #6fb3cb; font-size: 2.5em; text-align: center; font-weight: bold;\" class=\"clickable\">@</span>&nbsp;&nbsp;\n                    <span style=\"font-size: 1.5em;\">{{element.user_email}}</span>\n                </div>\n            </div>-->\n        </div>\n    </div>\n    <div class=\"col-xs-12 hidden-xs\" style=\"padding: 0\">\n        <div class=\"col-xs-12 col-md-3 col-lg-2 clickable elementPhoto\" *ngFor=\"let photo of element.photos\">\n            <img src=\"{{photo.url}}\" class=\"col-xs-12 clickable\" style=\"height: auto; padding: 0;\" (click)=\"photoSelected(photo.url)\" />\n            <span *ngIf=\"photo.price && photo.price!='' && photo.price!='undefined'\" style=\"display: block; background: #6fb3cb; font-size: 1.3em; color: white; text-align: center;\">{{photo.price}} {{'COIN_TYPE' | translate}}</span>\n        </div> \n    </div>    \n</div>\n<div [ngClass]=\"classPhotoModal\" role=\"dialog\">\n    <div class=\"modal-dialog\" style=\"z-index: 9999999999;\">\n        <!-- Modal content-->\n        <div class=\"modal-content\">\n            <div class=\"modal-body\" style=\"text-align: center\">\n                <button type=\"button\" class=\"close\" (click)=\"closePhotoModal()\">&times;</button>                \n                <img style=\"width: 60%;\" src=\"{{selectedPhotoUrl}}\"/>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn\" (click)=\"closePhotoModal()\">{{ 'CLOSE' | translate }}</button>\n            </div>\n        </div>\n    </div>\n</div>\n<div [ngClass]=\"classLoginModal\" role=\"dialog\">\n    <div class=\"modal-dialog\" style=\"z-index: 9999999999;\">\n        <!-- Modal content-->\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" (click)=\"closeLoginModal()\">&times;</button>\n                <h4 class=\"modal-title\">{{ 'TO_ACCESS' | translate}}</h4>\n            </div>\n            <div class=\"modal-body\" style=\"height: 15em;\">\n                <div>\n                    <div class=\"form-group\">\n                        <label for=\"email\">{{ 'EMAIL' | translate }}</label>\n                        <input [(ngModel)]=\"loginEmail\" type=\"email\" class=\"form-control\" id=\"email\" (keyup.enter)=\"loginClicked()\">\n                        <span *ngIf=\"loginCode === 530 || loginCode === 531\" class=\"login-error-msg\">{{ 'WRITE_YOUR_EMAIL' | translate }}</span>\n                        <span *ngIf=\"loginCode === 533\" class=\"login-error-msg\">{{ 'WRONG_EMAIL' | translate }}</span>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"password\">{{ 'PASSWORD' | translate }}</label>\n                        <input [(ngModel)]=\"loginPassword\" type=\"password\" class=\"form-control\" id=\"password\" (keyup.enter)=\"loginClicked()\">\n                        <span *ngIf=\"loginCode === 530 || loginCode === 532\" class=\"login-error-msg\">{{ 'WRITE_YOUR_PASSWORD' | translate }}</span>\n                        <span *ngIf=\"loginCode === 534\" class=\"login-error-msg\">{{ 'WRONG_PASSWORD' | translate }}</span>\n                    </div>\n                </div>\n            </div>\n            <div class=\"modal-footer\" style=\"margin-top: 2em;\">\n                <button type=\"button\" class=\"btn\" (click)=\"registerClicked()\" style=\"float: left; background-color: #6fb3cb; color: white;\">{{ 'REGISTER' | translate }}</button>\n                <button type=\"button\" class=\"btn btn-default submitbutton\" (click)=\"loginClicked()\" style=\" background-color: #6fb3cb; color: white;\">{{ 'LOGIN' | translate }}</button>\n                <button type=\"button\" class=\"btn\" (click)=\"closeLoginModal()\">{{ 'CLOSE' | translate }}</button>\n            </div>\n        </div>\n    </div>\n</div>\n<div [ngClass]=\"classMessageModal\" role=\"dialog\">\n    <div class=\"modal-dialog\" style=\"z-index: 9999999999;\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" (click)=\"closeMessageModal()\">&times;</button>\n                <h4 *ngIf=\"element != undefined\" class=\"modal-title\">{{element.id_visible}}&nbsp;-&nbsp;{{element.comercial_name}}</h4>\n                <h5 class=\"modal-title\">{{ 'SEND_MESSAGE' | translate }}</h5>\n            </div>\n            <div class=\"modal-body\" style=\"height: 20em;\">\n                <div>\n                    <div class=\"form-group\">\n                        <label for=\"title\">{{ 'TITLE' | translate }}</label>\n                        <input [(ngModel)]=\"messageTitle\" type=\"text\" class=\"form-control\" id=\"title\" (keyup.enter)=\"sendMessageClicked()\">\n                        <span *ngIf=\"messageCode === 1 || messageCode === 3\" class=\"login-error-msg\">{{ 'WRITE_A_TITLE' | translate }}</span>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"content\">{{ 'CONTENT' | translate }}</label>\n                         <textarea [(ngModel)]=\"messageContent\" maxlength=\"1000\" class=\"form-control\" style=\"height: 8em; resize: none; color: grey;\"></textarea>\n                         <span *ngIf=\"messageCode === 2 || messageCode === 3\" class=\"login-error-msg\">{{ 'WRITE_A_CONTENT' | translate }}</span>                        \n                    </div>                    \n                </div>\n            </div>\n            <div class=\"modal-footer\" style=\"margin-top: 2em;\">\n                <button type=\"button\" class=\"btn btn-default submitbutton\" (click)=\"sendMessageClicked()\" style=\"background-color: #6fb3cb; color: white;\">{{ 'SEND' | translate }}</button>\n                <button type=\"button\" class=\"btn\" (click)=\"closeMessageModal()\">{{ 'CLOSE' | translate }}</button>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/stand21.19ec158aed66537f5c9f36ea0eb9d4e7.png";

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/stand22.1d8fb4c0ac6727dfc170bd94b4201b8f.png";

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(76);
	var main_service_1 = __webpack_require__(178);
	var MainChangePasswordComponent = (function () {
	    function MainChangePasswordComponent(_mainService, route, _parentRouter) {
	        this._mainService = _mainService;
	        this.route = route;
	        this._parentRouter = _parentRouter;
	        this.emailKey = route.snapshot.params['emailKey'];
	        this.password1 = "";
	        this.password2 = "";
	        this.code = -1;
	        this.router = _parentRouter;
	    }
	    MainChangePasswordComponent.prototype.changePassword = function () {
	        var _this = this;
	        if (!this.isNullOrEmpty(this.password1) && !this.isNullOrEmpty(this.password2)) {
	            if (this.password1.length >= 5 && this.password2.length >= 5) {
	                if (this.password1 == this.password2) {
	                    this.code = -1;
	                    this._mainService.changeUserPassword(this.emailKey, this.password1).then(function (res) {
	                        if (res != null && res.code == 1) {
	                            localStorage.setItem('userName', res.user_name);
	                            localStorage.setItem('idUser', res.user_id.toString());
	                            localStorage.setItem('token', res.user_token);
	                            _this.router.navigate(['/main', 'dashboard']);
	                        }
	                    });
	                }
	                else {
	                    this.code = 7;
	                }
	            }
	            else if (this.password1.length < 5 && this.password2.length >= 5) {
	                this.code = 4;
	            }
	            else if (this.password1.length >= 5 && this.password2.length < 5) {
	                this.code = 5;
	            }
	            else {
	                this.code = 6;
	            }
	        }
	        else if (this.isNullOrEmpty(this.password1) && !this.isNullOrEmpty(this.password2)) {
	            this.code = 1;
	        }
	        else if (!this.isNullOrEmpty(this.password1) && this.isNullOrEmpty(this.password2)) {
	            this.code = 2;
	        }
	        else {
	            this.code = 3;
	        }
	    };
	    MainChangePasswordComponent.prototype.isNullOrEmpty = function (text) {
	        if (text == null || text == undefined || text == "") {
	            return true;
	        }
	        else {
	            return false;
	        }
	    };
	    MainChangePasswordComponent = __decorate([
	        core_1.Component({
	            selector: 'forgetPassword',
	            providers: [main_service_1.MainService],
	            template: __webpack_require__(197),
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof main_service_1.MainService !== 'undefined' && main_service_1.MainService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object])
	    ], MainChangePasswordComponent);
	    return MainChangePasswordComponent;
	    var _a, _b, _c;
	}());
	exports.MainChangePasswordComponent = MainChangePasswordComponent;


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"col-xs-12 col-md-12 col-lg-12 container center-container\" style=\"margin-top: 5em;\">\n    <div class=\"login\">\n        <img class=\"logo-progress\" src=\"" + __webpack_require__(198) + "\" />\n    </div>\n    <div class=\"login\">\n        <h1>{{ 'RECOVER_PASSWORD' | translate }}</h1>\n    </div>\n    <div class=\"login\">        \n        <div>\n            <input class=\"form-control\" type=\"password\" placeholder=\"{{ 'ENTER_NEW_PASSWORD' | translate }}\" [(ngModel)]=\"password1\" (keyup.enter)=\"changePassword()\">\n            <span *ngIf=\"code == 1 || code == 3\" class=\"login-error-msg\">{{ 'WRITE_YOUR_PASSWORD' | translate }} </span>            \n            <span *ngIf=\"code == 4 || code == 6\" class=\"login-error-msg\">{{ 'WRONG_LENGTH_PASSWORD' | translate }} </span>\n        </div>\n        <div style=\"margin-top: 0.5em;\">\n            <input class=\"form-control\" type=\"password\" placeholder=\"{{ 'CONFIRM_PASSWORD' | translate }}\" [(ngModel)]=\"password2\"  (keyup.enter)=\"changePassword()\">\n            <span *ngIf=\"code == 2 || code == 3\" class=\"login-error-msg\">{{ 'CONFIRM_PASSWORD' | translate }} </span>\n            <span *ngIf=\"code == 5 || code == 6\" class=\"login-error-msg\">{{ 'WRONG_LENGTH_PASSWORD' | translate }} </span>\n            <span *ngIf=\"code == 7\" class=\"login-error-msg\">{{ 'PASSWORDS_NO_MATCH' | translate }} </span>\n        </div>\n        <div class=\"form-group\" style=\"margin-top: 0.5em;\">\n            <button class=\"login-button\" (click)=\"changePassword()\">{{ 'CHANGE_PASSWORD' | translate }}</button>\n        </div>        \n    </div>\n</div>";

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/logo-default-stand.41c48676c0ef48489a56128baa31f3db.png";

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var ng2_completer_1 = __webpack_require__(61);
	var cities_1 = __webpack_require__(119);
	var CitiesSeekerComponent = (function () {
	    function CitiesSeekerComponent(_completerService) {
	        this._completerService = _completerService;
	        this.emiter = new core_1.EventEmitter();
	        this.dataService = this._completerService.local(cities_1.CITIES, 'name', 'name');
	        this.citySearcher = "";
	        this.selectedCities = [];
	        this.overCity = null;
	    }
	    CitiesSeekerComponent.prototype.ngOnInit = function () {
	        for (var i = 0; i < cities_1.CITIES.length; i++) {
	            for (var j = 0; j < this.citiesIds.length; j++) {
	                if (cities_1.CITIES[i].id == this.citiesIds[j]) {
	                    var city = { "id": cities_1.CITIES[i].id, "name": cities_1.CITIES[i].name };
	                    if (!this.selectedCitiesContainsCity(this.selectedCities, city)) {
	                        this.selectedCities.push(city);
	                    }
	                }
	            }
	        }
	        // if(this.selectedCities.length > 0) {
	        //     this.emiter.emit({
	        //         value: this.selectedCities
	        //     })
	        // }
	    };
	    CitiesSeekerComponent.prototype.onCitySelected = function () {
	        for (var i = 0; i < cities_1.CITIES.length; i++) {
	            if (cities_1.CITIES[i].name == this.citySearcher) {
	                var cityId = cities_1.CITIES[i].id;
	            }
	        }
	        var selectedCity = { "id": cityId, "name": this.citySearcher };
	        if (!this.selectedCitiesContainsCity(this.selectedCities, selectedCity)) {
	            this.selectedCities.push(selectedCity);
	            this.emiter.emit({
	                value: this.selectedCities
	            });
	        }
	    };
	    CitiesSeekerComponent.prototype.selectedCitiesContainsCity = function (cities, city) {
	        var contains = false;
	        for (var i = 0; i < cities.length; i++) {
	            if (cities[i].name === city.name) {
	                contains = true;
	            }
	        }
	        return contains;
	    };
	    CitiesSeekerComponent.prototype.mouseOverCity = function (city) {
	        this.overCity = city;
	    };
	    CitiesSeekerComponent.prototype.mouseLeaveCity = function () {
	        this.overCity = null;
	    };
	    CitiesSeekerComponent.prototype.deleteCity = function (city) {
	        var index = this.selectedCities.indexOf(city);
	        this.selectedCities.splice(index, 1);
	        this.emiter.emit({
	            value: this.selectedCities
	        });
	    };
	    __decorate([
	        core_1.Input('loadedCitiesIds'), 
	        __metadata('design:type', Array)
	    ], CitiesSeekerComponent.prototype, "citiesIds", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], CitiesSeekerComponent.prototype, "emiter", void 0);
	    CitiesSeekerComponent = __decorate([
	        core_1.Component({
	            selector: 'cities-seeker',
	            providers: [ng2_completer_1.CompleterService],
	            template: __webpack_require__(200),
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof ng2_completer_1.CompleterService !== 'undefined' && ng2_completer_1.CompleterService) === 'function' && _a) || Object])
	    ], CitiesSeekerComponent);
	    return CitiesSeekerComponent;
	    var _a;
	}());
	exports.CitiesSeekerComponent = CitiesSeekerComponent;


/***/ },
/* 200 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <div style=\"display: flex; align-items: center; margin-bottom: 1.3em;\">\n        <div style=\"width: 100%\">\n            <ng2-completer [(ngModel)]=\"citySearcher\" [datasource]=\"dataService\" (keyup.enter)=\"onCitySelected()\" (selected)=\"onCitySelected()\"\n                [minSearchLength]=\"2\" placeholder=\"{{'ADD_CITY' | translate}}\" [textNoResults]=\"('CITY_NOT_FOUND' | translate)\"\n                [autoMatch]=\"true\" [textSearching]=\"('SEARCHING...' | translate)\"></ng2-completer>\n        </div>\n        <!--<span class=\"glyphicon glyphicon-search black big-glyphicon input-group-btn\" style=\"border: 1px solid grey; width: 2.5em; line-height: 2.1em; height: 2.1em; text-align: center;\" \n        (click)=\"onCitySelected()\"></span> -->\n    </div>\n    <div style=\"margin-top: 0.5em; display: inline-block;\" class=\"col-xs-12 col-md-12\" style=\"padding: 0\">\n        <div *ngFor=\"let city of selectedCities\" (mouseenter)=\"mouseOverCity(city)\" (mouseleave)=\"mouseLeaveCity()\" style=\"padding-top:0.3em; background-color: #035d72; width: 100%; display: inline-block; height: 2em; margin-right: 1em; margin-bottom: 0.2em;\">\n            <label style=\"font-weight: 100; font-size: 0.8em; color: white; padding-left: 1em;\">{{city.name}}</label>\n            <label class=\"clickable\" style=\"padding-right: 0.7em; padding-left: 0.5em; color: white; float: right;\" (click)=\"deleteCity(city)\">X</label>\n        </div>\n    </div>\n</div>";

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var tags_service_1 = __webpack_require__(202);
	var TagsHandlerComponent = (function () {
	    function TagsHandlerComponent(_tagsService) {
	        this._tagsService = _tagsService;
	        this.emiter = new core_1.EventEmitter();
	        this.allTags = [];
	        this.toShowTags = [];
	        this.selectedTags = [];
	        this.tagsToShow = 12;
	        this.page = 0;
	        this.tagsSearcher = "";
	    }
	    TagsHandlerComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._tagsService.getTagsOrderedByName().then(function (result) {
	            _this.allTags = result;
	            for (var i = 0; i < _this.allTags.length; i++) {
	                _this.allTags[i].selected = false;
	                for (var j = 0; j < _this.tagsIds.length; j++) {
	                    if (_this.allTags[i].id == _this.tagsIds[j]) {
	                        if (!_this.allTags[i].selected) {
	                            _this.allTags[i].selected = true;
	                            _this.selectedTags.push(_this.allTags[i]);
	                        }
	                    }
	                }
	            }
	            _this.toShowTags = _this.allTags;
	            // if(this.selectedTags.length > 0) {
	            //     this.emiter.emit({
	            //         value: this.selectedTags
	            //     })
	            // }
	        });
	    };
	    TagsHandlerComponent.prototype.tagClicked = function (tag) {
	        if (!tag.selected) {
	            tag.selected = true;
	            this.selectedTags.push(tag);
	        }
	        else {
	            tag.selected = false;
	            var index = this.selectedTags.indexOf(tag);
	            this.selectedTags.splice(index, 1);
	        }
	    };
	    TagsHandlerComponent.prototype.removeTags = function () {
	        for (var i = 0; i < this.toShowTags.length; i++) {
	            this.toShowTags[i].selected = false;
	        }
	        this.selectedTags = [];
	        this.applyFiltersClicked();
	    };
	    TagsHandlerComponent.prototype.applyFiltersClicked = function () {
	        this.tagsSearcher = "";
	        this.toShowTags = this.allTags;
	        this.page = 0;
	        this.emiter.emit({
	            value: this.selectedTags
	        });
	    };
	    TagsHandlerComponent.prototype.getTagColor = function (tag) {
	        if (tag.selected) {
	            return "#97D685";
	        }
	        else {
	            return "#6fb3cb";
	        }
	    };
	    TagsHandlerComponent.prototype.isSelected = function (tag) {
	        return tag.selected;
	    };
	    TagsHandlerComponent.prototype.previousTagsClicked = function () {
	        this.page--;
	    };
	    TagsHandlerComponent.prototype.nextTagsClicked = function () {
	        this.page++;
	    };
	    TagsHandlerComponent.prototype.tagsSearcherChanged = function () {
	        this.page = 0;
	        if (this.tagsSearcher != null && this.tagsSearcher != undefined && this.tagsSearcher != "") {
	            this.toShowTags = [];
	            for (var i = 0; i < this.allTags.length; i++) {
	                var tagName = this.toUpperCaseReplacingAccents(this.allTags[i].name);
	                var tagsSearcherFilter = this.toUpperCaseReplacingAccents(this.tagsSearcher);
	                if (tagName.indexOf(tagsSearcherFilter) !== -1) {
	                    this.toShowTags.push(this.allTags[i]);
	                }
	            }
	        }
	        else {
	            this.toShowTags = this.allTags;
	        }
	    };
	    TagsHandlerComponent.prototype.toUpperCaseReplacingAccents = function (text) {
	        var mapObj = {
	            Á: "A",
	            À: "A",
	            Ä: "A",
	            É: "E",
	            È: "E",
	            Ë: "E",
	            Í: "I",
	            Ì: "I",
	            Ï: "I",
	            Ó: "O",
	            Ò: "O",
	            Ö: "O",
	            Ú: "U",
	            Ù: "U",
	            Ü: "U"
	        };
	        var trim = text.toUpperCase();
	        trim = trim.replace(/Á|À|Ä|É|È|Ë|Í|Ì|Ï|Ó|Ò|Ö|Ú|Ù|Ü/g, function (char) {
	            return mapObj[char];
	        });
	        return trim;
	    };
	    __decorate([
	        core_1.Input('loadedTagsIds'), 
	        __metadata('design:type', Array)
	    ], TagsHandlerComponent.prototype, "tagsIds", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], TagsHandlerComponent.prototype, "emiter", void 0);
	    TagsHandlerComponent = __decorate([
	        core_1.Component({
	            selector: 'tags-handler',
	            providers: [tags_service_1.TagsService],
	            template: __webpack_require__(203),
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof tags_service_1.TagsService !== 'undefined' && tags_service_1.TagsService) === 'function' && _a) || Object])
	    ], TagsHandlerComponent);
	    return TagsHandlerComponent;
	    var _a;
	}());
	exports.TagsHandlerComponent = TagsHandlerComponent;


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(30);
	var Observable_1 = __webpack_require__(5);
	var ng2_translate_1 = __webpack_require__(29);
	var json = __webpack_require__(95);
	var TagsService = (function () {
	    function TagsService(_translateService, http) {
	        this._translateService = _translateService;
	        this.http = http;
	        this._tagsUrl = '/tagsData';
	        this.serverURL = json.api_url;
	    }
	    TagsService.prototype.getTagsOrderedByUsage = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        var language = this._translateService.currentLang;
	        return this.http.get(this.serverURL + this._tagsUrl + "/orderedByUsage/" + language, options).toPromise().then(function (res) {
	            if (JSON.parse(res.text()).code == 1) {
	                return JSON.parse(res.text()).rows;
	            }
	        }, this.handleError);
	    };
	    TagsService.prototype.getTagsOrderedByName = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        var language = this._translateService.currentLang;
	        return this.http.get(this.serverURL + this._tagsUrl + "/orderedByName/" + language, options).toPromise().then(function (res) {
	            if (JSON.parse(res.text()).code == 1) {
	                return JSON.parse(res.text()).rows;
	            }
	        }, this.handleError);
	    };
	    TagsService.prototype.handleError = function (error) {
	        // In a real world app, we might use a remote logging infrastructure
	        // We'd also dig deeper into the error to get a better message
	        var errMsg = (error.message) ? error.message :
	            error.status ? error.status + " - " + error.statusText : 'Server error';
	        console.error(errMsg); // log to console instead
	        return Observable_1.Observable.throw(errMsg);
	    };
	    TagsService.prototype.serializeObj = function (obj) {
	        var result = [];
	        for (var property in obj)
	            result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));
	        return result.join("&");
	    };
	    TagsService.prototype.serializeTags = function (tags) {
	        var result = [];
	        for (var i = 0; i < tags.length; i++) {
	            result.push("tags[]=" + tags[i].id);
	        }
	        return result.join("&");
	    };
	    TagsService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof ng2_translate_1.TranslateService !== 'undefined' && ng2_translate_1.TranslateService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], TagsService);
	    return TagsService;
	    var _a, _b;
	}());
	exports.TagsService = TagsService;


/***/ },
/* 203 */
/***/ function(module, exports) {

	module.exports = "<div class=\"col-xs-12\" style=\"padding:0\">\n    <div class=\"col-xs-12\" style=\"padding:0\">\n        <input type=\"text\" [(ngModel)]=\"tagsSearcher\" (ngModelChange)=\"tagsSearcherChanged()\" class=\"form-control col-xs-12 col-md-12\"\n            placeholder=\"{{'SEARCHING_TAG...' | translate}}\" />\n        <span class=\"glyphicon glyphicon-search form-control-feedback\" style=\"margin-right: 1em;\"></span>\n    </div>\n    <div class=\"col-xs-12\" style=\"padding:0; margin-top: 1em;\">\n        <div *ngFor=\"let tag of toShowTags.slice(page * tagsToShow,page * tagsToShow + tagsToShow)\" class=\"clickable\" (click)=\"tagClicked(tag)\" [ngClass]=\"{tagMainSelected: isSelected(tag), tagMain: !isSelected(tag)}\" style=\" float: left; padding-right: 0.8rem;\">\n            <label class=\"clickable\" >{{tag.name}}</label>\n        </div>\t\n    </div>\n    <div class=\"col-xs-12\" style=\"padding: 0\">\n        <label class=\"clickable\" style=\"float: left; color: #035d72; font-weight: bold; padding-left: 0.5em;\" (click)=\"applyFiltersClicked()\">{{\"APLY_TAG_FILTERS\" | translate}}</label>\n        <span [ngClass]=\"{noVisible: page * tagsToShow + tagsToShow >= toShowTags.length}\" class=\"glyphicon glyphicon-chevron-right big-glyphicon clickable\" style=\"color: white; float: right;\"\n            (click)=\"nextTagsClicked()\"></span>\n        <span [ngClass]=\"{noVisible: page == 0}\" class=\"glyphicon glyphicon-chevron-left big-glyphicon clickable\" style=\"color: white; float: right;\"\n            (click)=\"previousTagsClicked()\"></span>        \n    </div>    \n    <div class=\"col-xs-12\" style=\"padding: 0\">\n        <label class=\"clickable\" style=\"float: left; color: #035d72; font-weight: bold; padding-left: 0.5em;\" (click)=\"removeTags()\">{{ 'REMOVE_TAG_FILTERS' | translate }}</label>\n    </div>\n</div>";

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(76);
	var login_service_1 = __webpack_require__(205);
	var login_1 = __webpack_require__(206);
	var LoginComponent = (function () {
	    function LoginComponent(_loginService, router) {
	        this._loginService = _loginService;
	        this.router = router;
	        this.error = false;
	        this.code = 0;
	        this.model = new login_1.Login("", "");
	    }
	    LoginComponent.prototype.ngOnInit = function () {
	        this.code = Number(localStorage.getItem("code"));
	        localStorage.removeItem("code");
	        this._loginService.getUserStatus().then(function (status) {
	            localStorage.setItem("userRole", status.role);
	        });
	        //L'API retorna 302 si el login es correcte
	        if (this.code == 302) {
	            this.router.navigate(['/main', 'dashboard']);
	        }
	    };
	    LoginComponent.prototype.onSubmit = function (value) {
	        var _this = this;
	        this._loginService.login(value.email, value.password).subscribe(function (result) {
	            _this.code = result.code;
	            localStorage.setItem("code", result.code);
	            if (result !== null && result.token !== undefined) {
	                location.reload();
	            }
	        }, function () { _this.error = true; });
	    };
	    LoginComponent = __decorate([
	        core_1.Component({
	            selector: 'login',
	            providers: [login_service_1.LoginService],
	            template: __webpack_require__(207)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof login_service_1.LoginService !== 'undefined' && login_service_1.LoginService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object])
	    ], LoginComponent);
	    return LoginComponent;
	    var _a, _b;
	}());
	exports.LoginComponent = LoginComponent;


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(30);
	var json = __webpack_require__(95);
	var LoginService = (function () {
	    function LoginService(http) {
	        this.http = http;
	        this.serverURL = json.api_url;
	        this.getTokenService();
	    }
	    LoginService.prototype.login = function (email, password) {
	        var _this = this;
	        /*
	         * If we had a login api, we would have done something like this
	         */
	        var creds = "email=" + email +
	            "&password=" + password;
	        return this.http.post(this.serverURL + '/loginData', creds, {
	            headers: new http_1.Headers({
	                'Content-Type': 'application/x-www-form-urlencoded'
	            })
	        })
	            .map(function (res) {
	            var data = res.json();
	            if (data.token !== undefined) {
	                _this.token = data.token;
	                localStorage.setItem('token', _this.token);
	                localStorage.setItem('userName', data.user.name);
	                localStorage.setItem('idUser', data.user.id.toString());
	            }
	            return data;
	        });
	        //for the purpose of this cookbook, we will juste simulate that
	        /*
	        if (email === 'test' && password === 'test') {
	          this.token = 'token';
	          localStorage.setItem('token', this.token);
	          return Observable.of('token');
	        }*/
	        //return Observable.throw('authentication failure');
	    };
	    LoginService.prototype.register = function (formData) {
	        var _this = this;
	        /*
	         * If we had a login api, we would have done something like this
	         */
	        return this.http.post(this.serverURL + '/loginData/register', this.serializeObj(formData), {
	            headers: new http_1.Headers({
	                'Content-Type': 'application/x-www-form-urlencoded'
	            })
	        })
	            .map(function (res) {
	            var data = res.json();
	            _this.token = data.token;
	            localStorage.setItem('token', _this.token);
	            localStorage.setItem('idUser', data.user_id.toString());
	            localStorage.setItem('userName', data.user_name);
	            return data;
	        });
	        //for the purpose of this cookbook, we will juste simulate that
	        /*
	        if (email === 'test' && password === 'test') {
	          this.token = 'token';
	          localStorage.setItem('token', this.token);
	          return Observable.of('token');
	        }*/
	        //return Observable.throw('authentication failure');
	    };
	    LoginService.prototype.logout = function () {
	        /*
	         * If we had a login api, we would have done something like this
	    *
	        return this.http.get(this.config.serverUrl + '/auth/logout', {
	          headers: new Headers({
	            'x-security-token': this.token
	          })
	        })
	        .map((res : any) => {
	          this.token = undefined;
	          localStorage.removeItem('token');
	        });
	         */
	        this.token = undefined;
	        localStorage.removeItem('token');
	        return true;
	    };
	    LoginService.prototype.isLogged = function () {
	        return !!localStorage.getItem('token');
	    };
	    LoginService.prototype.getTokenService = function () {
	        this.token = localStorage.getItem('token');
	    };
	    LoginService.prototype.getToken = function () {
	        return this.token;
	    };
	    LoginService.prototype.getUserStatus = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        if (token != null && token != "") {
	            authHeader.append('Authorization', 'Bearer ' + token);
	            var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	            return this.http.get(this.serverURL + '/loginData/userStatus', options).toPromise().then(function (res) {
	                if (JSON.parse(res.text()).code == -1) {
	                    return "guest";
	                }
	                else {
	                    return JSON.parse(res.text());
	                }
	            }).catch(this.handleError);
	        }
	        else {
	            return Promise.resolve({ role: "guest" });
	        }
	    };
	    LoginService.prototype.refresh = function () {
	        this.getTokenService();
	    };
	    LoginService.prototype.existsEmail = function (email) {
	        return this.http.get(this.serverURL + '/usersData/existsEmail/' + email).toPromise()
	            .then(function (res) {
	            if (JSON.parse(res.text()).code == 1) {
	                return true;
	            }
	            else {
	                return false;
	            }
	        }, this.handleError);
	    };
	    LoginService.prototype.extractData = function (res) {
	        var body = res.json();
	        return body.data || "guest";
	    };
	    LoginService.prototype.handleError = function (error) {
	        console.error('An error occurred', error);
	        return Promise.reject(error.message || error);
	    };
	    LoginService.prototype.serializeObj = function (obj) {
	        var result = [];
	        for (var property in obj)
	            result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));
	        return result.join("&");
	    };
	    LoginService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], LoginService);
	    return LoginService;
	    var _a;
	}());
	exports.LoginService = LoginService;


/***/ },
/* 206 */
/***/ function(module, exports) {

	"use strict";
	var Login = (function () {
	    function Login(email, password) {
	        this.email = email;
	        this.password = password;
	    }
	    return Login;
	}());
	exports.Login = Login;


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div style=\"\n    background-image: url('img/portada.jpg');\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background-repeat: no-repeat;\n    background-position: initial;\n    background-size: cover;\n    overflow-x: overlay;\n\">\n    <div class=\"container center-container\" style=\"background-color: rgba(255,255,255,0.98); width: 100%; min-height: 50%;\">\n        <div class=\"col-xs-6 col-lg-5 pull-right\" style=\"padding-top: 1em;\">\n            <div class=\"col-xs-12 col-lg-4 pull-right clickable\" [routerLink]=\"['/info']\">\n                <img src=\"" + __webpack_require__(208) + "\" style=\"width: 3em;\" />\n                <label class=\"clickable\" style=\"color: #C75560; font-size: 1.4em;\n    vertical-align: bottom; padding-left: 1em;\">{{ 'INFORMATION' | translate }}</label>\n            </div>\n            <div class=\"col-xs-12 col-lg-4 pull-right clickable\" [routerLink]=\"['/who']\">\n                <img src=\"" + __webpack_require__(209) + "\" style=\"width: 3em;\" />\n                <label class=\"clickable\" style=\"color: #A29F27; font-size: 1.4em;\n    vertical-align: bottom; padding-left: 1em;\">{{ 'CONTACT' | translate }}</label>\n            </div>\n            <div class=\"col-xs-12 col-lg-4 pull-right clickable\" [routerLink]=\"['/faq']\">\n                <img src=\"" + __webpack_require__(210) + "\" style=\"width: 3em;\" />\n                <label class=\"clickable\" style=\"color: #1a6287; font-size: 1.4em;\n    vertical-align: bottom; padding-left: 1em;\">{{ 'FAQ' | translate }}</label>\n            </div>\n        </div>\n        <div class=\"col-xs-12\">\n            <div class=\"login\">\n                <a [routerLink]=\"['/main', 'dashboard']\">\n                    <img class=\"logo-progress\" src=\"" + __webpack_require__(198) + "\" />\n                </a>\n            </div>\n            <div class=\"login\">\n                <h1>{{ 'HAWKER_WEB_PORTAL' | translate }}</h1>\n            </div>\n            <div class=\"login\">\n                <form (submit)=\"onSubmit(model)\" #informationForm=\"ngForm\">\n                    <div>\n                        <input class=\"form-control\" type=\"text\" [(ngModel)]=\"model.email\" placeholder=\"{{ 'ENTER_EMAIL' | translate }}\" [ngModelOptions]=\"{standalone: true}\">\n                        <span *ngIf=\"code === 530 || code === 531\" class=\"login-error-msg\" id=\"errormsg_0_Email\">{{ 'WRITE_YOUR_EMAIL' | translate }} </span>\n                        <span *ngIf=\"code === 533\" class=\"login-error-msg\" id=\"errormsg_1_Email\">{{ 'WRONG_EMAIL' | translate }} </span>\n\n                    </div>\n                    <div>\n                        <input class=\"form-control\" type=\"password\" [(ngModel)]=\"model.password\" placeholder=\"{{ 'ENTER_PASSWORD' | translate }}\" [ngModelOptions]=\"{standalone: true}\">\n                        <span *ngIf=\"code === 530 || code === 532\" class=\"login-error-msg\" id=\"errormsg_0_Password\">{{ 'WRITE_YOUR_PASSWORD' | translate }} </span>\n                        <span *ngIf=\"code === 534\" class=\"login-error-msg\" id=\"errormsg_1_Password\">{{ 'WRONG_PASSWORD' | translate }} </span>\n                    </div>\n                    <div class=\"form-group\">\n                        <button class=\"login-button\" type=\"submit\">{{ 'LOGIN' | translate }}</button>\n                    </div>\n                </form>\n            </div>\n            <div class=\"login\">\n                <a [routerLink]=\"['/register']\"> {{ 'ACCOUNT_CREATE' | translate }} </a>\n            </div>\n        </div>\n\n    </div>\n    <div class=\"container center-container information\" style=\"background-color: rgba(61,121,153,0.9); width: 100%; padding-top: 5em; padding-bottom: 7em;\">\n        <div class=\"col-xs-12\" style=\"padding-left: 2em; padding-right: 2em; padding-top: 2em;\">\n            <div class=\"col-xs-12 col-lg-3 information-marks\">\n                <img src=\"" + __webpack_require__(211) + "\" />\n                <h2>{{ 'IDENTIFY' | translate }}</h2>\n            </div>\n            <div class=\"col-xs-12 col-lg-3 information-marks\">\n                <img src=\"" + __webpack_require__(212) + "\" />\n                <h2>{{ 'LOCATE' | translate }}</h2>\n            </div>\n            <div class=\"col-xs-12 col-lg-3 information-marks\">\n                <img src=\"" + __webpack_require__(213) + "\" />\n                <h2>{{ 'PARTNER' | translate }}</h2>\n            </div>\n            <div class=\"col-xs-12 col-lg-3 information-marks\">\n                <img src=\"" + __webpack_require__(214) + "\" />\n                <h2>{{ 'EASY_AND_FOR_EVERYBODY' | translate }}</h2>\n            </div>\n        </div>\n\n        <div class=\"col-xs-12 col-lg-12 information-marks\" style=\"text-align: center; padding-top: 2em;\">\n            <img src=\"" + __webpack_require__(215) + "\" />\n            <h2 style=\"font-size: 2.4em; vertical-align: bottom;\">{{ 'PROMOTION_TITLE' | translate }}</h2>\n            <div class=\"col-xs-12\" style=\"text-align: center\">\n                <p style=\"color: white; width: 100%; margin: 0 0; display: inline-block; font-size: 1.7em; padding-top: 01.5em;\">{{ 'PROMOTION_TEXT' | translate }}</p>\n            </div>\n        </div>\n\n    </div>\n\n    <div class=\"row\" style=\"background-color: rgba(255,255,255,1); width: 100%; text-align: center; padding-top: 4em; padding-bottom: 5em;\">\n        <div class=\"col-xs-12 col-lg-5\" style=\"    display: inline-block;    text-align: left;    margin-right: -4px;    float: none;\">\n            <h2 style=\"font-size: 2.8em;    vertical-align: bottom;    color: #003740;    text-align: center;    width: 100%;\">{{ 'CATEGORY_1_PLURAL' | translate }}</h2>\n            <div style=\"text-align: center; width: 100%;\"><img src=\"" + __webpack_require__(216) + "\" style=\"width: 26em;     max-width: 100%;\" /></div>\n            <p style=\"padding-top: 0.9em; font-size: 1.8em;    vertical-align: bottom;    color: #003740;    text-align: center;    width: 100%;\">{{ 'CATEGORY_1_DESC' | translate }}</p>\n        </div>\n        <div class=\"col-xs-12 col-lg-5\" style=\"    display: inline-block;    text-align: left;    margin-right: -4px;    float: none;\">\n            <h2 style=\"font-size: 2.8em;    vertical-align: bottom;    color: #777320;    text-align: center;    width: 100%;\">{{ 'CATEGORY_2_PLURAL' | translate }}</h2>\n            <div style=\"text-align: center; width: 100%;\"><img src=\"" + __webpack_require__(217) + "\" style=\"width: 26em;     max-width: 100%;\" /> </div>\n            <p style=\"padding-top: 0.9em; font-size: 1.8em;    vertical-align: bottom;    color: #777320;    text-align: center;    width: 100%;\">{{ 'CATEGORY_2_DESC' | translate }}</p>\n        </div>\n    </div>\n    <div class=\"row\" style=\"background-color: rgba(61,121,153,0.9);  width: 100%; text-align: center; height: 16em;\">\n    </div>\n    <div class=\"row\" style=\"background-color: rgba(255,255,255,1);  width: 100%; text-align: center; padding-top:4em; padding-bottom: 4em;\">\n        <div class=\"col-xs-12 col-lg-4\" style=\"    display: inline-block;    text-align: left;    margin-right: -4px;    float: none;\">\n            <div class=\"col-xs-6\" style=\"text-align: right;\">\n                <p style=\"padding-top: 0.9em; font-size: 1.8em;    vertical-align: bottom;    color: #003740;    text-align: right;    width: 100%;padding-bottom: 0em; margin-bottom: 0em;\">{{ 'PRICE_0' | translate }}\n                <h2 style=\"font-size: 1.8em;    vertical-align: bottom;    color: #003740;    text-align: right;    width: 100%; padding-top: 0em; margin-top: 0em;  font-weight: 600;\">{{ 'FREE' | translate }}</h2>\n            </div>\n            <div class=\"col-xs-6\">\n                <div style=\"text-align: left; width: 100%;\"><img src=\"" + __webpack_require__(194) + "\" style=\"width: 14em; margin-top: 2em;    max-width: 100%;\" /></div>\n            </div>\n        </div>\n        <div class=\"col-xs-12 col-lg-4\" style=\"    display: inline-block;    text-align: left;    margin-right: -4px;    float: none;\">\n            <div class=\"col-xs-6\" style=\"text-align: right;\">\n                <p style=\"padding-top: 0.9em; font-size: 1.8em;    vertical-align: bottom;    color: #003740;    text-align: right;    width: 100%;padding-bottom: 0em; margin-bottom: 0em;\">{{ 'PRICE_1' | translate }}\n                <h2 style=\"font-size: 1.8em;    vertical-align: bottom;    color: #003740;    text-align: right;    width: 100%; padding-top: 0em; margin-top: 0em;  font-weight: 600;\">{{ 'TRADITIONAL' | translate }}</h2>\n                <p style=\"font-size: 1.4em;    vertical-align: bottom;    color: #003740;    text-align: right;    width: 100%;\">{{ 'CUOTE_TRADITIONAL' | translate }}</p>\n            </div>\n            <div class=\"col-xs-6\">\n                <div style=\"text-align: left; width: 100%;\"><img src=\"" + __webpack_require__(195) + "\" style=\"width: 14em; margin-top: 2em;    max-width: 100%;\" /></div>\n            </div>\n        </div>\n        <div class=\"col-xs-12 col-lg-4\" style=\"    display: inline-block;    text-align: left;    margin-right: -4px;    float: none;\">\n            <div class=\"col-xs-6\" style=\"text-align: right;\">\n                <p style=\"padding-top: 0.9em; font-size: 1.8em;    vertical-align: bottom;    color: #003740;    text-align: right;    width: 100%;padding-bottom: 0em; margin-bottom: 0em;\">{{ 'PRICE_2' | translate }}\n                <h2 style=\"font-size: 1.8em;    vertical-align: bottom;    color: #003740;    text-align: right;    width: 100%; padding-top: 0em; margin-top: 0em; font-weight: 600;\">{{ 'PROFESIONAL' | translate }}</h2>\n                <p style=\" font-size: 1.4em;    vertical-align: bottom;    color: #003740;    text-align: right;    width: 100%;\">{{ 'CUOTE_PROFESIONAL' | translate }}</p>\n            </div>\n            <div class=\"col-xs-6\">\n                <div style=\"text-align: left; width: 100%;\"><img src=\"" + __webpack_require__(218) + "\" style=\"width: 14em; margin-top: 2em;    max-width: 100%;\" /></div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row\" style=\"background-color: rgba(61,121,153,0.9);  width: 100%; text-align: center; height: 16em;\">\n    </div>\n    <div class=\"row\" style=\"background-color: rgba(255,255,255,1); width: 100%; text-align: center; padding-top: 3em; padding-bottom: 2em;\">\n        <div class=\"col-xs-12 col-md-4\" style=\"    display: inline-block;    text-align: center;    margin-right: -4px;    float: none;\">\n            <h2 style=\"font-size: 2.2em;    vertical-align: bottom;    color: #003740;    text-align: center;    width: 100%;\">{{ 'SLOGAN_1' | translate }}</h2>\n            <h2 style=\"font-size: 2.2em;    vertical-align: bottom;    color: #003740;    text-align: center;    width: 100%;\">{{ 'SLOGAN_2' | translate }}</h2>\n            <button class=\"login-button\" style=\"max-width: 100%;    width: 13em;    font-size: 2em;    margin-top: 1em;\" [routerLink]=\"['/register']\">{{ 'REGISTER' | translate }}</button>\n        </div>\n        \n    </div>\n</div>";

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/what.72a9555fe9bc663e595c923352c0feca.png";

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/who.2698dfbbb79fc5c3cba9f1cd8505ea66.png";

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/faq.cab0ac8b288ff2f8efd4f22a79ce7f27.png";

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/ticket.91d7ed333e03c94ca2b308b974d95d05.png";

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/place.a5f2313835c34ef7e78d6e842260df81.png";

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/share.3bac4219d75a73d27b5366149b21dcaf.png";

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/easy.01f1679ccce3f2923cb1af1e1f76c527.png";

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/star.2ee70ca12681f1f40b579443a013415c.png";

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/icons-vendor.6871ae05bc64251b7113276427f45f76.png";

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/icons-artesan.c753b9beda563732416fe706289f1857.png";

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/stand23.ff05c800cb08c4043f9878967e663864.png";

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(76);
	var register_service_1 = __webpack_require__(220);
	var Register_1 = __webpack_require__(221);
	var RegisterComponent = (function () {
	    function RegisterComponent(_registerService, router) {
	        this._registerService = _registerService;
	        this.router = router;
	        this.error = false;
	        this.code = 0;
	        this.isProfesional = false;
	        this.preserveDNI = "";
	        this.formNif = "";
	        this.errorCodes = [];
	        this.model = new Register_1.Register("", "", "", "");
	        this.passwordType = "password";
	        var hostname = location.host;
	        if (hostname == "www.mercadilloambulante.com" || hostname == "www.mercadilloambulante.eu" || hostname == "mercadilloambulante.com" || hostname == "mercadilloambulante.eu") {
	            this.language = "ES";
	        }
	        else if (hostname == "www.mercatambulant.cat" || hostname == "mercatambulant.cat" || hostname == "localhost") {
	            this.language = "CAT";
	        }
	        else {
	            this.language = "ES";
	        }
	    }
	    RegisterComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._registerService.getUserStatus().then(function (data) {
	            if (data.role != "guest") {
	                _this.router.navigate(['/main', 'dashboard']);
	            }
	        });
	    };
	    RegisterComponent.prototype.changeProfesional = function ($event, profesional) {
	        this.isProfesional = profesional;
	        if (!this.isProfesional) {
	            this.preserveDNI = this.model.nif;
	            this.formNif = "";
	        }
	        else {
	            this.formNif = this.preserveDNI;
	            this.preserveDNI = "";
	        }
	    };
	    RegisterComponent.prototype.onSubmit = function (value) {
	        var _this = this;
	        if (this.checkParams(value)) {
	            this._registerService.existsEmail(value.email).then(function (res) {
	                if (res) {
	                    _this.errorCodes.push(534);
	                }
	                else {
	                    value.profesional = _this.isProfesional;
	                    value.language = _this.language;
	                    _this._registerService.register(value)
	                        .subscribe(function (result) {
	                        _this.code = result.code;
	                        if (result !== null && result.token !== undefined) {
	                            //location.reload();
	                            if (value.profesional) {
	                                localStorage.setItem("userRole", "superuser");
	                                _this.router.navigate(['/superuser', 'start']);
	                            }
	                            else {
	                                localStorage.setItem("userRole", "user");
	                                _this.router.navigate(['/main', 'dashboard']);
	                            }
	                        }
	                    }, function () { _this.error = true; });
	                }
	            });
	        }
	    };
	    RegisterComponent.prototype.codeError = function (code) {
	        var found = false;
	        var i = 0;
	        while (!found && i < this.errorCodes.length) {
	            if (code == this.errorCodes[i]) {
	                found = true;
	            }
	            i++;
	        }
	        return found;
	    };
	    RegisterComponent.prototype.checkParams = function (value) {
	        var _this = this;
	        this.errorCodes = [];
	        //email check
	        if (value.email.length === 0) {
	            this.errorCodes.push(531);
	        }
	        else if (value.email.length > 50) {
	            this.errorCodes.push(53);
	        }
	        else if (!this.validateEmail(value.email)) {
	            this.errorCodes.push(533);
	        }
	        //password check
	        if (value.password.length === 0) {
	            this.errorCodes.push(535);
	        }
	        else if (value.password.length < 4) {
	            this.errorCodes.push(536);
	        }
	        else if (value.password.length > 40) {
	            this.errorCodes.push(537);
	        }
	        //name check
	        if (value.name.length === 0) {
	            this.errorCodes.push(538);
	        }
	        else if (value.name.length < 2) {
	            this.errorCodes.push(539);
	        }
	        else if (value.name.length > 60) {
	            this.errorCodes.push(540);
	        }
	        if (this.isProfesional) {
	            //nif check
	            if (value.nif === 0) {
	                this.errorCodes.push(541);
	            }
	            else if (!this.validateNIF(value.nif)) {
	                this.errorCodes.push(542);
	            }
	        }
	        if (this.errorCodes.length > 0) {
	            this._registerService.existsEmail(value.email).then(function (res) {
	                if (res) {
	                    _this.errorCodes.push(534);
	                }
	            });
	        }
	        return this.errorCodes.length === 0;
	    };
	    RegisterComponent.prototype.validateEmail = function (email) {
	        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	        return re.test(email);
	    };
	    RegisterComponent.prototype.validateNIF = function (value) {
	        var validChars = 'TRWAGMYFPDXBNJZSQVHLCKET';
	        var nifRexp = /^[0-9]{8}(-?)[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i;
	        var nieRexp = /^[XYZ]{1}[0-9]{7}(-?)[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i;
	        var str = value.toString().toUpperCase();
	        if (!nifRexp.test(str) && !nieRexp.test(str))
	            return false;
	        var nie = str
	            .replace(/^[X]/, '0')
	            .replace(/^[Y]/, '1')
	            .replace(/^[Z]/, '2');
	        var letter = str.substr(-1);
	        var charIndex = parseInt(nie.substr(0, 8)) % 23;
	        if (validChars.charAt(charIndex) === letter)
	            return true;
	        return false;
	    };
	    RegisterComponent.prototype.onChangePassword = function (flag) {
	        if (!flag) {
	            this.passwordType = "password";
	        }
	        else {
	            this.passwordType = "text";
	        }
	    };
	    RegisterComponent = __decorate([
	        core_1.Component({
	            selector: 'register',
	            providers: [register_service_1.RegisterService],
	            template: __webpack_require__(222)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof register_service_1.RegisterService !== 'undefined' && register_service_1.RegisterService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object])
	    ], RegisterComponent);
	    return RegisterComponent;
	    var _a, _b;
	}());
	exports.RegisterComponent = RegisterComponent;


/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(30);
	var json = __webpack_require__(95);
	var RegisterService = (function () {
	    function RegisterService(http) {
	        this.http = http;
	        this.serverURL = json.api_url;
	    }
	    RegisterService.prototype.getUserStatus = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        if (token != null && token != "") {
	            authHeader.append('Authorization', 'Bearer ' + token);
	            var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	            return this.http.get(this.serverURL + '/loginData/userStatus', options).toPromise().then(function (res) {
	                if (JSON.parse(res.text()).code == -1) {
	                    return "guest";
	                }
	                else {
	                    return JSON.parse(res.text());
	                }
	            }).catch(this.handleError);
	        }
	        else {
	            return Promise.resolve({ role: "guest" });
	        }
	    };
	    RegisterService.prototype.existsEmail = function (email) {
	        return this.http.get(this.serverURL + '/usersData/existsEmail/' + email).toPromise()
	            .then(function (res) {
	            if (JSON.parse(res.text()).code == 1) {
	                return true;
	            }
	            else {
	                return false;
	            }
	        }, this.handleError);
	    };
	    RegisterService.prototype.register = function (formData) {
	        /*
	         * If we had a login api, we would have done something like this
	         */
	        return this.http.post(this.serverURL + '/loginData/register', this.serializeObj(formData), {
	            headers: new http_1.Headers({
	                'Content-Type': 'application/x-www-form-urlencoded'
	            })
	        })
	            .map(function (res) {
	            var data = res.json();
	            localStorage.setItem('token', data.token);
	            localStorage.setItem('idUser', data.user_id.toString());
	            localStorage.setItem('userName', data.user_name);
	            return data;
	        });
	    };
	    RegisterService.prototype.handleError = function (error) {
	        console.error('An error occurred', error);
	        return Promise.reject(error.message || error);
	    };
	    RegisterService.prototype.serializeObj = function (obj) {
	        var result = [];
	        for (var property in obj)
	            result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));
	        return result.join("&");
	    };
	    RegisterService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], RegisterService);
	    return RegisterService;
	    var _a;
	}());
	exports.RegisterService = RegisterService;


/***/ },
/* 221 */
/***/ function(module, exports) {

	"use strict";
	var Register = (function () {
	    function Register(email, password, name, nif) {
	        this.email = email;
	        this.password = password;
	        this.name = name;
	        this.nif = nif;
	    }
	    return Register;
	}());
	exports.Register = Register;


/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div style=\"\n    background-image: url('img/portada.jpg');\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background-repeat: no-repeat;\n    background-position: initial;\n    background-size: cover;\n    overflow-x: overlay;\n\">\n    <div class=\"container center-container\" style=\"background-color: rgba(255,255,255,0.98); width: 100%; min-height: 50%;\">\n        <div class=\"col-xs-6 col-lg-5 pull-right\" style=\"padding-top: 1em;\">\n            <div class=\"col-xs-12 col-lg-4 pull-right clickable\" [routerLink]=\"['/info']\">\n                <img src=\"" + __webpack_require__(208) + "\" style=\"width: 3em;\" />\n                <label class=\"clickable\" style=\"color: #C75560; font-size: 1.4em;\n    vertical-align: bottom; padding-left: 1em;\">{{ 'INFORMATION' | translate }}</label>\n            </div>\n            <div class=\"col-xs-12 col-lg-4 pull-right clickable\" [routerLink]=\"['/who']\">\n                <img src=\"" + __webpack_require__(209) + "\" style=\"width: 3em;\" />\n                <label class=\"clickable\" style=\"color: #A29F27; font-size: 1.4em;\n    vertical-align: bottom; padding-left: 1em;\">{{ 'CONTACT' | translate }}</label>\n            </div>\n            <div class=\"col-xs-12 col-lg-4 pull-right clickable\" [routerLink]=\"['/faq']\">\n                <img src=\"" + __webpack_require__(210) + "\" style=\"width: 3em;\" />\n                <label class=\"clickable\" style=\"color: #1a6287; font-size: 1.4em;\n    vertical-align: bottom; padding-left: 1em;\">{{ 'FAQ' | translate }}</label>\n            </div>\n        </div>\n        <div class=\"col-xs-12\">\n            <div class=\"login\">\n                <a [routerLink]=\"['/main', 'dashboard']\">\n                    <img class=\"logo-progress\" src=\"" + __webpack_require__(198) + "\" />\n                </a>\n            </div>\n            <div class=\"login\">\n                <h1>{{ 'HAWKER_WEB_PORTAL' | translate }}</h1>\n            </div>\n            <div class=\"login\">\n                <form (submit)=\"onSubmit(model)\" #informationForm=\"ngForm\">\n                    <div>\n                        <div class=\"col-xs-12 col-lg-6\">\n                            <img src=\"" + __webpack_require__(223) + "\" style=\"width: 7em;\" />\n                            <div class=\"radio\">\n                                <label style=\"padding-left: 0.5em; font-size: 1.3em; color: #555555;\"> <input (change)=\"changeProfesional($event, false)\" type=\"radio\" name=\"role\" value=\"superuser\" checked />{{'USERS'  | translate}}</label>\n                            </div>\n                        </div>\n                        <div class=\"col-xs-12 col-lg-6\">\n                            <img src=\"" + __webpack_require__(224) + "\" style=\"width: 7em;\" />\n                            <div class=\"radio\">\n                                <label style=\"padding-left: 0.5em; font-size: 1.3em; color: #555555;\"> <input (change)=\"changeProfesional($event, true)\" type=\"radio\" name=\"role\" value=\"superuser\"  />{{'SELLERS'  | translate}}</label>\n                            </div>\n                        </div>\n                    </div>\n                    <div>\n                        <input class=\"form-control\" type=\"text\" [(ngModel)]=\"model.email\" placeholder=\"{{ 'ENTER_EMAIL_REGISTER' | translate }}\" [ngModelOptions]=\"{standalone: true}\">\n                        <span *ngIf=\"codeError('531')\" class=\"login-error-msg\" id=\"errormsg_531\">{{ 'REGISTER_INFORMATION_1_1' | translate }}</span>\n                        <span *ngIf=\"codeError('533')\" class=\"login-error-msg\" id=\"errormsg_533\">{{ 'REGISTER_INFORMATION_1_2' | translate }}</span>\n                        <span *ngIf=\"codeError('532')\" class=\"login-error-msg\" id=\"errormsg_533\">{{ 'REGISTER_INFORMATION_1_3' | translate }}</span>\n                        <span *ngIf=\"codeError('534')\" class=\"login-error-msg\" id=\"errormsg_534\">{{ 'REGISTER_INFORMATION_1_4' | translate }}</span>\n                    </div>\n                    <div style=\"text-align: left;\">\n                        <input class=\"form-control\" type=\"{{passwordType}}\" [(ngModel)]=\"model.password\" ngControl=\"password\" placeholder=\"{{ 'ENTER_PASSWORD_REGISTER' | translate }}\" [ngModelOptions]=\"{standalone: true}\">\n                        <input type=\"checkbox\" #cvPassword [checked]=\"false\" (change)=\"onChangePassword(cvPassword.checked)\" style=\"height: auto; margin-left: 0.5em; margin-top: 0.5em;\"> <label style=\"margin: 0; color: #666666\">{{ 'SHOW_PASSWORD' | translate }}</label>\n                        <span *ngIf=\"codeError('535')\" class=\"login-error-msg\" id=\"errormsg_532\">{{ 'REGISTER_INFORMATION_2_1' | translate }}</span>\n                        <span *ngIf=\"codeError('536')\" class=\"login-error-msg\" id=\"errormsg_535\">{{ 'REGISTER_INFORMATION_2_2' | translate }}</span>\n                        <span *ngIf=\"codeError('537')\" class=\"login-error-msg\" id=\"errormsg_536\">{{ 'REGISTER_INFORMATION_2_3' | translate }}</span>\n                    </div>\n                    <div>\n                        <input class=\"form-control\" type=\"text\" [(ngModel)]=\"model.name\" ngControl=\"name\" placeholder=\"{{ 'ENTER_NAME_REGISTER' | translate }}\" [ngModelOptions]=\"{standalone: true}\">\n                         <span *ngIf=\"codeError('538')\" class=\"login-error-msg\" id=\"errormsg_537\">{{ 'REGISTER_INFORMATION_3_1' | translate }}</span>\n                        <span *ngIf=\"codeError('539')\" class=\"login-error-msg\" id=\"errormsg_538\">{{ 'REGISTER_INFORMATION_3_2' | translate }}</span>\n                        <span *ngIf=\"codeError('540')\" class=\"login-error-msg\" id=\"errormsg_539\">{{ 'REGISTER_INFORMATION_3_3' | translate }}</span>\n                    </div>\n                    <div *ngIf=\"isProfesional\">\n                        <input class=\"form-control\" type=\"text\" [(ngModel)]=\"model.nif\" ngControl=\"nif\" [(ngModel)]=\"formNif\" placeholder=\"{{ 'ENTER_NIF_REGISTER' | translate }}\" [ngModelOptions]=\"{standalone: true}\">\n                         <span *ngIf=\"codeError('541')\" class=\"login-error-msg\" id=\"errormsg_540\">{{ 'REGISTER_INFORMATION_4_1' | translate }}</span>\n                        <span *ngIf=\"codeError('542')\" class=\"login-error-msg\" id=\"errormsg_541\">{{ 'REGISTER_INFORMATION_4_2' | translate }}</span>\n                    </div>\n                    <div class=\"form-group\">\n                        <button class=\"login-button\" type=\"submit\">{{ 'REGISTER' | translate }}</button>\n                    </div>\n                </form>\n            </div>\n            <div class=\"login\">\n                <a [routerLink]=\"['/login']\">{{ 'REGISTERED_DONE' | translate }}</a>\n            </div>\n        </div>\n    </div>\n    <div class=\"container center-container information\" style=\"background-color: rgba(61,121,153,0.9); width: 100%; padding-top: 5em; padding-bottom: 7em;\">\n        <div class=\"col-xs-12\" style=\"padding-left: 2em; padding-right: 2em; padding-top: 2em;\">\n            <div class=\"col-xs-12 col-lg-3 information-marks\">\n                <img src=\"" + __webpack_require__(211) + "\" />\n                <h2>{{ 'IDENTIFY' | translate }}</h2>\n            </div>\n            <div class=\"col-xs-12 col-lg-3 information-marks\">\n                <img src=\"" + __webpack_require__(212) + "\" />\n                <h2>{{ 'LOCATE' | translate }}</h2>\n            </div>\n            <div class=\"col-xs-12 col-lg-3 information-marks\">\n                <img src=\"" + __webpack_require__(213) + "\" />\n                <h2>{{ 'PARTNER' | translate }}</h2>\n            </div>\n            <div class=\"col-xs-12 col-lg-3 information-marks\">\n                <img src=\"" + __webpack_require__(214) + "\" />\n                <h2>{{ 'EASY_AND_FOR_EVERYBODY' | translate }}</h2>\n            </div>\n        </div>\n\n        <div class=\"col-xs-12 col-lg-12 information-marks\" style=\"text-align: center; padding-top: 2em;\">\n            <img src=\"" + __webpack_require__(215) + "\" />\n            <h2 style=\"font-size: 2.4em; vertical-align: bottom;\">{{ 'PROMOTION_TITLE' | translate }}</h2>\n            <div class=\"col-xs-12\" style=\"text-align: center\">\n                <p style=\"color: white; width: 100%; margin: 0 0; display: inline-block; font-size: 1.7em; padding-top: 01.5em;\">{{ 'PROMOTION_TEXT' | translate }}</p>\n            </div>\n        </div>\n\n    </div>\n\n    <div class=\"row\" style=\"background-color: rgba(255,255,255,1); width: 100%; text-align: center; padding-top: 4em; padding-bottom: 5em;\">\n        <div class=\"col-xs-12 col-lg-5\" style=\"    display: inline-block;    text-align: left;    margin-right: -4px;    float: none;\">\n            <h2 style=\"font-size: 2.8em;    vertical-align: bottom;    color: #003740;    text-align: center;    width: 100%;\">{{ 'CATEGORY_1_PLURAL' | translate }}</h2>\n            <div style=\"text-align: center; width: 100%;\"><img src=\"" + __webpack_require__(216) + "\" style=\"width: 26em;     max-width: 100%;\" /></div>\n            <p style=\"padding-top: 0.9em; font-size: 1.8em;    vertical-align: bottom;    color: #003740;    text-align: center;    width: 100%;\">{{ 'CATEGORY_1_DESC' | translate }}</p>\n        </div>\n        <div class=\"col-xs-12 col-lg-5\" style=\"    display: inline-block;    text-align: left;    margin-right: -4px;    float: none;\">\n            <h2 style=\"font-size: 2.8em;    vertical-align: bottom;    color: #777320;    text-align: center;    width: 100%;\">{{ 'CATEGORY_2_PLURAL' | translate }}</h2>\n            <div style=\"text-align: center; width: 100%;\"><img src=\"" + __webpack_require__(217) + "\" style=\"width: 26em;     max-width: 100%;\" /> </div>\n            <p style=\"padding-top: 0.9em; font-size: 1.8em;    vertical-align: bottom;    color: #777320;    text-align: center;    width: 100%;\">{{ 'CATEGORY_2_DESC' | translate }}</p>\n        </div>\n    </div>\n    <div class=\"row\" style=\"background-color: rgba(61,121,153,0.9);  width: 100%; text-align: center; height: 16em;\">\n    </div>\n    <div class=\"row\" style=\"background-color: rgba(255,255,255,1);  width: 100%; text-align: center; padding-top:4em; padding-bottom: 4em;\">\n        <div class=\"col-xs-12 col-lg-4\" style=\"    display: inline-block;    text-align: left;    margin-right: -4px;    float: none;\">\n            <div class=\"col-xs-6\" style=\"text-align: right;\">\n                <p style=\"padding-top: 0.9em; font-size: 1.8em;    vertical-align: bottom;    color: #003740;    text-align: right;    width: 100%;padding-bottom: 0em; margin-bottom: 0em;\">{{ 'PRICE_0' | translate }}\n                <h2 style=\"font-size: 1.8em;    vertical-align: bottom;    color: #003740;    text-align: right;    width: 100%; padding-top: 0em; margin-top: 0em;  font-weight: 600;\">{{ 'FREE' | translate }}</h2>\n            </div>\n            <div class=\"col-xs-6\">\n                <div style=\"text-align: left; width: 100%;\"><img src=\"" + __webpack_require__(194) + "\" style=\"width: 14em; margin-top: 2em;    max-width: 100%;\" /></div>\n            </div>\n        </div>\n        <div class=\"col-xs-12 col-lg-4\" style=\"    display: inline-block;    text-align: left;    margin-right: -4px;    float: none;\">\n            <div class=\"col-xs-6\" style=\"text-align: right;\">\n                <p style=\"padding-top: 0.9em; font-size: 1.8em;    vertical-align: bottom;    color: #003740;    text-align: right;    width: 100%;padding-bottom: 0em; margin-bottom: 0em;\">{{ 'PRICE_1' | translate }}\n                <h2 style=\"font-size: 1.8em;    vertical-align: bottom;    color: #003740;    text-align: right;    width: 100%; padding-top: 0em; margin-top: 0em;  font-weight: 600;\">{{ 'TRADITIONAL' | translate }}</h2>\n                <p style=\"font-size: 1.4em;    vertical-align: bottom;    color: #003740;    text-align: right;    width: 100%;\">{{ 'CUOTE_TRADITIONAL' | translate }}</p>\n            </div>\n            <div class=\"col-xs-6\">\n                <div style=\"text-align: left; width: 100%;\"><img src=\"" + __webpack_require__(195) + "\" style=\"width: 14em; margin-top: 2em;    max-width: 100%;\" /></div>\n            </div>\n        </div>\n        <div class=\"col-xs-12 col-lg-4\" style=\"    display: inline-block;    text-align: left;    margin-right: -4px;    float: none;\">\n            <div class=\"col-xs-6\" style=\"text-align: right;\">\n                <p style=\"padding-top: 0.9em; font-size: 1.8em;    vertical-align: bottom;    color: #003740;    text-align: right;    width: 100%;padding-bottom: 0em; margin-bottom: 0em;\">{{ 'PRICE_2' | translate }}\n                <h2 style=\"font-size: 1.8em;    vertical-align: bottom;    color: #003740;    text-align: right;    width: 100%; padding-top: 0em; margin-top: 0em; font-weight: 600;\">{{ 'PROFESIONAL' | translate }}</h2>\n                <p style=\" font-size: 1.4em;    vertical-align: bottom;    color: #003740;    text-align: right;    width: 100%;\">{{ 'CUOTE_PROFESIONAL' | translate }}</p>\n            </div>\n            <div class=\"col-xs-6\">\n                <div style=\"text-align: left; width: 100%;\"><img src=\"" + __webpack_require__(218) + "\" style=\"width: 14em; margin-top: 2em;    max-width: 100%;\" /></div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row\" style=\"background-color: rgba(61,121,153,0.9);  width: 100%; text-align: center; height: 16em;\">\n    </div>\n    <div class=\"row\" style=\"background-color: rgba(255,255,255,1); width: 100%; text-align: center; padding-top: 3em; padding-bottom: 2em;\">\n        <div class=\"col-xs-12 col-md-4\" style=\"    display: inline-block;    text-align: center;    margin-right: -4px;    float: none;\">\n            <h2 style=\"font-size: 2.2em;    vertical-align: bottom;    color: #003740;    text-align: center;    width: 100%;\">{{ 'SLOGAN_1' | translate }}</h2>\n            <h2 style=\"font-size: 2.2em;    vertical-align: bottom;    color: #003740;    text-align: center;    width: 100%;\">{{ 'SLOGAN_2' | translate }}</h2>\n            <button class=\"login-button\" style=\"max-width: 100%;    width: 13em;    font-size: 2em;    margin-top: 1em;\" [routerLink]=\"['/register']\">{{ 'REGISTER' | translate }}</button>\n        </div>        \n    </div>\n</div>";

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/users.8ad0fd3c7d4c83e66ebb4e8d8b7ebff4.png";

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/seller.eb23c16211798fecc35b9322001193e2.png";

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(76);
	var FaqComponent = (function () {
	    function FaqComponent(router) {
	        this.router = router;
	    }
	    FaqComponent = __decorate([
	        core_1.Component({
	            selector: 'faq',
	            template: __webpack_require__(226)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _a) || Object])
	    ], FaqComponent);
	    return FaqComponent;
	    var _a;
	}());
	exports.FaqComponent = FaqComponent;


/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div style=\"\n    background-image: url('img/portada.jpg');\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background-repeat: no-repeat;\n    background-position: initial;\n    background-size: cover;\n        overflow-x: overlay;\n\">\n    <div class=\"container center-container\" style=\"background-color: rgba(255,255,255,0.98); width: 100%; min-height: 50%;\">\n        <div class=\"col-xs-12 col-lg-3 clickable\" [routerLink]=\"['/login']\" style=\"padding-top: 1em;\">\n            <img src=\"" + __webpack_require__(227) + "\" style=\"width: 5em;\" />\n        </div>\n        <div class=\"col-xs-6 col-lg-5 pull-right\" style=\"padding-top: 1em;\">\n            <div class=\"col-xs-12 col-lg-4 pull-right clickable\" [routerLink]=\"['/info']\">\n                <img src=\"" + __webpack_require__(208) + "\" style=\"width: 3em;\" />\n                <label class=\"clickable\" style=\"color: #C75560; font-size: 1.4em;\n    vertical-align: bottom; padding-left: 1em;\">{{ 'INFORMATION' | translate }}</label>\n            </div>\n            <div class=\"col-xs-12 col-lg-4 pull-right clickable\" [routerLink]=\"['/who']\">\n                <img src=\"" + __webpack_require__(209) + "\" style=\"width: 3em;\" />\n                <label class=\"clickable\" style=\"color: #A29F27; font-size: 1.4em;\n    vertical-align: bottom; padding-left: 1em;\">{{ 'CONTACT' | translate }}</label>\n            </div>\n            <div class=\"col-xs-12 col-lg-4 pull-right clickable\" [routerLink]=\"['/faq']\">\n                <img src=\"" + __webpack_require__(210) + "\" style=\"width: 3em;\" />\n                <label class=\"clickable\" style=\"color: #1a6287; font-size: 1.4em;\n    vertical-align: bottom; padding-left: 1em;\">{{ 'FAQ' | translate }}</label>\n            </div>\n        </div>\n        <div class=\"col-xs-12 contact\" style=\"text-align: left;\">\n            <div style=\"padding-top: 2em\">\n                <h1 style=\"font-size: 1.3em;\">{{ 'FAQ_1_1' | translate }}</h1>\n                <span>{{ 'FAQ_1_2' | translate }}</span>\n            </div>\n            <div style=\"padding-top: 1em\">\n                <h1 style=\"font-size: 1.3em;\">{{ 'FAQ_2_1' | translate }}</h1>\n                <span>{{ 'FAQ_2_2' | translate }}</span>\n            </div>\n            <div style=\"padding-top: 1em\">\n                <h1 style=\"font-size: 1.3em;\">{{ 'FAQ_3_1' | translate }}</h1>\n                <span>{{ 'FAQ_3_2' | translate }}</span>\n            </div>\n            <div style=\"padding-top: 1em\">\n                <h1 style=\"font-size: 1.3em;\">{{ 'FAQ_4_1' | translate }}</h1>\n                <span>{{ 'FAQ_4_2' | translate }}</span>\n            </div>\n            <div style=\"padding-top: 1em\">\n                <h1 style=\"font-size: 1.3em;\">{{ 'FAQ_5_1' | translate }}</h1>\n                <span>{{ 'FAQ_5_2' | translate }}</span> <a class=\"clickable\" href=\"http://{{ 'WEB_LINK' | translate }}\">{{ 'WEB_LINK' | translate }}</a><span>{{ 'FAQ_5_3' | translate }}</span>\n            </div>\n            <div style=\"padding-top: 1em\">\n                <h1 style=\"font-size: 1.3em;\">{{ 'FAQ_6_1' | translate }}</h1>\n                <span>{{ 'FAQ_6_2' | translate }}</span>\n            </div>\n            <div style=\"padding-top: 1em\">\n                <h1 style=\"font-size: 1.3em;\">{{ 'FAQ_7_1' | translate }}</h1>\n                <span>{{ 'FAQ_7_2' | translate }}</span>\n            </div>\n            <div style=\"padding-top: 1em\">\n                <h1 style=\"font-size: 1.3em;\">{{ 'FAQ_8_1' | translate }}</h1>\n                <span>{{ 'FAQ_8_2' | translate }}</span>\n            </div>\n            <div style=\"padding-top: 1em\">\n                <h1 style=\"font-size: 1.3em;\">{{ 'FAQ_9_1' | translate }}</h1>\n                <span>{{ 'FAQ_9_2' | translate }}</span>\n            </div>\n            <div style=\"padding-top: 1em\">\n                <h1 style=\"font-size: 1.3em;\">{{ 'FAQ_10_1' | translate }}</h1>\n                <span>{{ 'FAQ_10_2' | translate }}</span>\n            </div>\n            <div style=\"padding-top: 1em\">\n                <h1 style=\"font-size: 1.3em;\">{{ 'FAQ_11_1' | translate }}</h1>\n                <span>{{ 'FAQ_11_2' | translate }}</span>\n            </div>\n            <div style=\"padding-top: 1em\">\n                <h1 style=\"font-size: 1.3em;\">{{ 'FAQ_12_1' | translate }}</h1>\n                <span>{{ 'FAQ_12_2' | translate }}</span>\n            </div>\n            <div style=\"padding-top: 1em\">\n                <h1 style=\"font-size: 1.3em;\">{{ 'FAQ_13_1' | translate }}</h1>\n                <span>{{ 'FAQ_13_2' | translate }}</span>\n            </div>\n            <div style=\"padding-top: 1em; padding-bottom: 2em;\">\n                <h1 style=\"font-size: 1.3em;\">{{ 'FAQ_14_1' | translate }}</h1>\n                <span>{{ 'FAQ_14_2' | translate }}<a class=\"clickable\" href=\"mailto:{{ 'EMAIL_ALTAS' | translate }}\">{{ 'EMAIL_ALTAS' | translate }}</a></span>\n            </div>\n\n        </div>\n    </div>\n    <div class=\"container center-container information\" style=\"background-color: rgba(61,121,153,0.9); width: 100%; padding-top: 5em; padding-bottom: 7em;\">\n        <div class=\"col-xs-12\" style=\"padding-left: 2em; padding-right: 2em; padding-top: 2em;\">\n\n        </div>\n\n    </div>\n</div>";

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/logo.b714a370acb384db84f22b9100a3ef8a.png";

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(76);
	var InfoComponent = (function () {
	    function InfoComponent(router) {
	        this.router = router;
	    }
	    InfoComponent = __decorate([
	        core_1.Component({
	            selector: 'info',
	            template: __webpack_require__(229)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _a) || Object])
	    ], InfoComponent);
	    return InfoComponent;
	    var _a;
	}());
	exports.InfoComponent = InfoComponent;


/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div style=\"\n    background-image: url('img/portada.jpg');\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background-repeat: no-repeat;\n    background-position: initial;\n    background-size: cover;\n        overflow-x: overlay;\n\">\n    <div class=\"container center-container\" style=\"background-color: rgba(255,255,255,0.98); width: 100%; min-height: 50%;\">\n        <div class=\"col-xs-12 col-lg-3 clickable\" [routerLink]=\"['/login']\" style=\"padding-top: 1em;\">\n            <img src=\"" + __webpack_require__(227) + "\" style=\"width: 5em;\" />\n        </div>\n        <div class=\"col-xs-6 col-lg-5 pull-right\" style=\"padding-top: 1em;\">\n            <div class=\"col-xs-12 col-lg-4 pull-right clickable\" [routerLink]=\"['/info']\">\n                <img src=\"" + __webpack_require__(208) + "\" style=\"width: 3em;\" />\n                <label class=\"clickable\" style=\"color: #C75560; font-size: 1.4em;\n    vertical-align: bottom; padding-left: 1em;\">{{ 'INFORMATION' | translate }}</label>\n            </div>\n            <div class=\"col-xs-12 col-lg-4 pull-right clickable\" [routerLink]=\"['/who']\">\n                <img src=\"" + __webpack_require__(209) + "\" style=\"width: 3em;\" />\n                <label class=\"clickable\" style=\"color: #A29F27; font-size: 1.4em;\n    vertical-align: bottom; padding-left: 1em;\">{{ 'CONTACT' | translate }}</label>\n            </div>\n            <div class=\"col-xs-12 col-lg-4 pull-right clickable\" [routerLink]=\"['/faq']\">\n                <img src=\"" + __webpack_require__(210) + "\" style=\"width: 3em;\" />\n                <label class=\"clickable\" style=\"color: #1a6287; font-size: 1.4em;\n    vertical-align: bottom; padding-left: 1em;\">{{ 'FAQ' | translate }}</label>\n            </div>\n        </div>\n        <div class=\"col-xs-12 contact\" style=\"text-align: left;\">\n            <div style=\"padding-top: 3em; padding-bottom: 1.2em;\">\n                <span>{{ 'INFORMATION_1' | translate }}</span>\n            </div>\n            <div style=\"padding-bottom: 1.2em;\">\n                <span>{{ 'INFORMATION_2' | translate }}</span>\n            </div>\n            <div style=\"padding-bottom: 0.3em;\">\n                <span>{{ 'INFORMATION_3' | translate }}</span><a class=\"clickable\" target=\"_blank\" href=\"http://www.mveva.com/#/register\">http://www.mveva.com/#/register</a>\n            </div>\n            <div style=\"padding-bottom: 0.3em;\">\n                <span>{{ 'INFORMATION_4' | translate }}</span><a class=\"clickable\" target=\"_blank\" href=\"http://www.mveva.com/#/who\">http://www.mveva.com/#/who</a>\n            </div>\n            <div style=\"padding-bottom: 0.3em;\">\n                <span>{{ 'INFORMATION_5' | translate }}</span><a class=\"clickable\" target=\"_blank\" href=\"http://www.mveva.com/#/faq\">http://www.mveva.com/#/faq</a>\n            </div>\n            <div style=\"padding-bottom: 0.3em;\">\n                <span>{{ 'INFORMATION_6' | translate }}</span><a class=\"clickable\" target=\"_top\" href=\"mailto:{{ 'EMAIL_CONTACT' | translate }}\">{{ 'EMAIL_CONTACT' | translate }}</a>\n            </div>\n            <div style=\"padding-bottom: 0.3em;\">\n                <span>{{ 'INFORMATION_7' | translate }}</span><a class=\"clickable\" target=\"_top\" href=\"mailto:{{ 'EMAIL_ALTAS' | translate }}\">{{ 'EMAIL_ALTAS' | translate }}</a>\n            </div>\n            <div style=\"padding-bottom: 0.3em;\">\n                <span>{{ 'INFORMATION_8' | translate }}</span><a class=\"clickable\" target=\"_blank\" href=\"http://www.mveva.com\">http://www.mveva.com</a>\n            </div>\n            <div style=\"padding-bottom: 0.3em;\">\n                <span>{{ 'INFORMATION_9' | translate }}</span><a class=\"clickable\" target=\"_blank\" href=\"http://www.mercadilloambulante.com\">http://www.mercadilloambulante.com</a>\n            </div>\n            <div style=\"padding-bottom: 0.3em;\">\n                <span>{{ 'INFORMATION_10' | translate }}</span><a class=\"clickable\" target=\"_blank\" href=\"http://www.mercatambulant.cat\">http://www.mercatambulant.cat</a>\n            </div>\n            <!--<div style=\"padding-bottom: 0.3em;\">\n                <span>{{ 'INFORMATION_11' | translate }}</span><a class=\"clickable\" target=\"_blank\" href=\"https://www.facebook.com/profile.php?id=100015748711920\">https://www.facebook.com/profile.php?id=100015748711920</a>\n            </div>-->\n            <div style=\"padding-bottom: 0.3em;\">\n                <span>{{ 'INFORMATION_12' | translate }}</span><a class=\"clickable\" target=\"_blank\" href=\"https://www.facebook.com/mercadilloambulante.pagina\">https://www.facebook.com/mercadilloambulante.pagina</a>\n            </div>\n            <div style=\"padding-bottom: 0.3em;\">\n                <span>{{ 'INFORMATION_13' | translate }}</span><a class=\"clickable\" target=\"_blank\" href=\"https://www.instagram.com/mercadilloambulante\">https://www.instagram.com/mercadilloambulante</a>\n            </div>\n            <div style=\"padding-bottom: 1.2em;\">\n                <span>{{ 'INFORMATION_14' | translate }}</span><a class=\"clickable\" target=\"_blank\" href=\"https://www.youtube.com/channel/UCpWqjPUA4epb7QvDIvR_e4A\">\"https://www.youtube.com/channel/UCpWqjPUA4epb7QvDIvR_e4A</a>\n            </div>\n            <div style=\"padding-bottom: 1.2em;\">\n                <span>{{ 'CLIENT_PROMOTION' | translate }}</span><br/>\n                <ul>\n                    <li><span>{{ 'CLIENT_PROMOTION_1' | translate }}</span></li>\n                    <li><span>{{ 'CLIENT_PROMOTION_2' | translate }}</span></li>\n                </ul>\n            </div>\n            <div style=\"padding-bottom: 1.2em;\">\n                <span>{{ 'PROFESIONAL_PROMOTION' | translate }}</span><br/>\n                <ul>\n                    <li><span>{{ 'PROFESIONAL_PROMOTION_1' | translate }}</span></li>\n                    <li><span>{{ 'PROFESIONAL_PROMOTION_2' | translate }}</span></li>\n                    <li><span>{{ 'PROFESIONAL_PROMOTION_3' | translate }}</span></li>\n                    <li><span>{{ 'PROFESIONAL_PROMOTION_4' | translate }}</span></li>\n                    <li><span>{{ 'PROFESIONAL_PROMOTION_5' | translate }}</span></li>\n                    <li><span>{{ 'PROFESIONAL_PROMOTION_6' | translate }}</span></li>\n                    <li><span>{{ 'PROFESIONAL_PROMOTION_7' | translate }}</span></li>\n                    <li><span>{{ 'PROFESIONAL_PROMOTION_8' | translate }}</span></li>\n                </ul>\n            </div>\n            <div style=\"padding-bottom: 1.2em;\">\n                <span>{{ 'TRADITIONAL_PROMOTION' | translate }}</span><br/>\n                <ul>\n                    <li><span>{{ 'TRADITIONAL_PROMOTION_1' | translate }}</span></li>\n                    <li><span>{{ 'TRADITIONAL_PROMOTION_2' | translate }}</span></li>\n                    <li><span>{{ 'TRADITIONAL_PROMOTION_3' | translate }}</span></li>\n                    <li><span>{{ 'TRADITIONAL_PROMOTION_4' | translate }}</span></li>\n                    <li><span>{{ 'TRADITIONAL_PROMOTION_5' | translate }}</span></li>\n                    <li><span>{{ 'TRADITIONAL_PROMOTION_6' | translate }}</span></li>\n                    <li><span>{{ 'TRADITIONAL_PROMOTION_7' | translate }}</span></li>\n                </ul>\n            </div>\n            <div style=\"padding-bottom: 1.2em;\">\n                <span>{{ 'FREE_PROMOTION' | translate }}</span><br/>\n                <ul>\n                    <li><span>{{ 'FREE_PROMOTION_1' | translate }}</span></li>\n                    <li><span>{{ 'FREE_PROMOTION_2' | translate }}</span></li>\n                    <li><span>{{ 'FREE_PROMOTION_3' | translate }}</span></li>\n                    <li><span>{{ 'FREE_PROMOTION_4' | translate }}</span></li>\n                    <li><span>{{ 'FREE_PROMOTION_5' | translate }}</span></li>\n                    <li><span>{{ 'FREE_PROMOTION_6' | translate }}</span></li>\n                </ul>\n            </div>\n            <div style=\"padding-top: 0.5em; padding-bottom: 0.6em;\">\n                <span>{{ 'PROJECT_EXPLANATION' | translate }}</span>\n            </div>\n            <div style=\"padding-top: 0.5em; padding-bottom: 0.3em;\">\n                <span>{{ 'PROJECT_EXPLANATION_1' | translate }}</span>\n            </div>\n            <div style=\"padding-top: 0.5em; padding-bottom: 0.3em;\">\n                <span>{{ 'PROJECT_EXPLANATION_2' | translate }}</span>\n            </div>\n            <div style=\"padding-top: 0.5em; padding-bottom: 0.3em;\">\n                <span>{{ 'PROJECT_EXPLANATION_3' | translate }}</span>\n            </div>\n            <div style=\"padding-top: 0.5em; padding-bottom: 0.3em;\">\n                <span>{{ 'PROJECT_EXPLANATION_4' | translate }}</span>\n            </div>\n            <div style=\"padding-top: 0.5em; padding-bottom: 0.3em;\">\n                <span>{{ 'PROJECT_EXPLANATION_5' | translate }}</span>\n            </div>\n            <div style=\"padding-top: 0.5em; padding-bottom: 0.3em;\">\n                <span>{{ 'PROJECT_EXPLANATION_6' | translate }}</span>\n            </div>\n            <div style=\"padding-top: 0.5em; padding-bottom: 0.3em;\">\n                <span>{{ 'PROJECT_EXPLANATION_7' | translate }}</span>\n            </div>\n            <div style=\"padding-top: 1.5em; padding-bottom: 1.3em;\">\n                <span>{{ 'PROJECT_EXPLANATION_8' | translate }}</span> <a target=\"_top\" class=\"clickable\" href=\"mailto:{{ 'EMAIL_CONTACT' | translate }}\">{{ 'EMAIL_CONTACT' | translate }}</a>  \n            </div>\n        </div>\n    </div>\n    <div class=\"container center-container information\" style=\"background-color: rgba(61,121,153,0.9); width: 100%; padding-top: 5em; padding-bottom: 7em;\">\n        <div class=\"col-xs-12\" style=\"padding-left: 2em; padding-right: 2em; padding-top: 2em;\">\n            \n        </div>\n\n    </div>\n</div>";

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(76);
	var WhoComponent = (function () {
	    function WhoComponent(router) {
	        this.router = router;
	    }
	    WhoComponent = __decorate([
	        core_1.Component({
	            selector: 'who',
	            template: __webpack_require__(231)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _a) || Object])
	    ], WhoComponent);
	    return WhoComponent;
	    var _a;
	}());
	exports.WhoComponent = WhoComponent;


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div style=\"\n    background-image: url('img/portada.jpg');\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background-repeat: no-repeat;\n    background-position: initial;\n    background-size: cover;\n        overflow-x: overlay;\n\">\n    <div class=\"container center-container\" style=\"background-color: rgba(255,255,255,0.98); width: 100%; min-height: 50%;\">\n        <div class=\"col-xs-12 col-lg-3 clickable\" [routerLink]=\"['/login']\" style=\"padding-top: 1em;\">\n            <img src=\"" + __webpack_require__(227) + "\" style=\"width: 5em;\" />\n        </div>\n        <div class=\"col-xs-6 col-lg-5 pull-right\" style=\"padding-top: 1em;\">\n            <div class=\"col-xs-12 col-lg-4 pull-right clickable\" [routerLink]=\"['/info']\">\n                <img src=\"" + __webpack_require__(208) + "\" style=\"width: 3em;\" />\n                <label class=\"clickable\" style=\"color: #C75560; font-size: 1.4em;\n    vertical-align: bottom; padding-left: 1em;\">{{ 'INFORMATION' | translate }}</label>\n            </div>\n            <div class=\"col-xs-12 col-lg-4 pull-right clickable\" [routerLink]=\"['/who']\">\n                <img src=\"" + __webpack_require__(209) + "\" style=\"width: 3em;\" />\n                <label class=\"clickable\" style=\"color: #A29F27; font-size: 1.4em;\n    vertical-align: bottom; padding-left: 1em;\">{{ 'CONTACT' | translate }}</label>\n            </div>\n            <div class=\"col-xs-12 col-lg-4 pull-right clickable\" [routerLink]=\"['/faq']\">\n                <img src=\"" + __webpack_require__(210) + "\" style=\"width: 3em;\" />\n                <label class=\"clickable\" style=\"color: #1a6287; font-size: 1.4em;\n    vertical-align: bottom; padding-left: 1em;\">{{ 'FAQ' | translate }}</label>\n            </div>\n        </div>\n        <div class=\"col-xs-12 contact\">\n            <div>\n                <h1>{{ 'ENTERPRISE' | translate }}</h1>\n                <span>{{ 'CONTACT_1' | translate }}</span><br/>\n                <span>{{ 'CONTACT_2' | translate }}</span><br/>\n                <span>{{ 'CONTACT_3' | translate }} <b>{{ 'NIF' | translate }}</b> {{ 'CONTACT_4' | translate }}</span>\n            </div>\n            <div>\n                <h1>{{ 'CONTACT_5' | translate }}</h1>\n                <span>{{ 'CONTACT_6' | translate }}</span><br/>\n                <iframe src=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d739.8580391269572!2d2.454587561102791!3d42.11963080429951!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12a5334c4e54dec7%3A0x9c66a3891022a5c8!2sCarrer+d&#39;Olot%2C+21%2C+17176+Sant+Esteve+d&#39;en+Bas%2C+Girona!5e0!3m2!1ses!2ses!4v1471846049073\"\n                    width=\"800\" height=\"250\" frameborder=\"0\" style=\"border:0\" allowfullscreen></iframe>\n            </div>\n            <div style=\"padding-bottom: 1em;\">\n                <h1>{{ 'CONTACT_7' | translate }}</h1>\n                <a class=\"clickable\" href=\"mailto:contacte@mercatambulant.cat\">{{ 'EMAIL_CONTACT' | translate }}</a>\n            </div>\n        </div>\n\n    </div>\n    <div class=\"container center-container information\" style=\"background-color: rgba(61,121,153,0.9); width: 100%; padding-top: 5em; padding-bottom: 7em;\">\n        <div class=\"col-xs-12\" style=\"padding-left: 2em; padding-right: 2em; padding-top: 2em;\">\n            \n        </div>\n\n    </div>\n</div>";

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(76);
	var forum_service_1 = __webpack_require__(233);
	var ForumComponent = (function () {
	    function ForumComponent(_forumService, _parentRouter) {
	        this._forumService = _forumService;
	        this.isCollapsed = false;
	        this.router = _parentRouter;
	        this.userStatus = "";
	        this.searchFilter = "";
	        this.userName = "";
	        this.nMessages = 0;
	        this.elementsThatContainsSearchValueById = [];
	        this.elementsThatContainsSearchValueByName = [];
	        this.loginCode = 0;
	        this.loginPassword = "";
	        this.loginEmail = "";
	        this.classLoginModal = { 'model': true, 'show': false, 'hide': true };
	        this.classForgetPasswordModal = { 'model': true, 'show': false, 'hide': true };
	        this.forgetPasswordEmail = "";
	        this.forgetPasswordEmailEmpty = false;
	        this.forgetPasswordEmailIncorrect = false;
	        this.classEmailSendedModal = { 'model': true, 'show': false, 'hide': true };
	        this.emailSended = false;
	    }
	    ForumComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._forumService.getUserStatus().then(function (status) {
	            _this.userStatus = status.role;
	            if (_this.userStatus == "admin" || _this.userStatus == "superuser" || _this.userStatus == "user") {
	                _this.userName = _this._forumService.getUserName();
	                _this._forumService.getUnreadMessages().then(function (res) {
	                    if (res != null) {
	                        _this.nMessages = res.length;
	                    }
	                });
	            }
	        });
	    };
	    ForumComponent.prototype.collapse = function () {
	        this.isCollapsed = true;
	    };
	    ForumComponent.prototype.noCollapse = function () {
	        this.isCollapsed = false;
	    };
	    ForumComponent.prototype.searchFilterChanged = function (event) {
	        var _this = this;
	        if (this.searchFilter.length > 0) {
	            if (event.key == "Enter") {
	                this.router.navigate(['/main', 'dashboard', { categoryType: null, sellerType: null, citiesFilter: null, tagsFilter: null, searchFilter: this.searchFilter }]);
	                this.elementsThatContainsSearchValueById = [];
	                this.elementsThatContainsSearchValueByName = [];
	            }
	            else {
	                if (this.userStatus == "guest") {
	                    this._forumService.getElementsBySearchFilterValue(this.searchFilter).then(function (res) {
	                        _this.elementsThatContainsSearchValueById = [];
	                        _this.elementsThatContainsSearchValueByName = [];
	                        if (res != null) {
	                            for (var i = 0; i < res.length; i++) {
	                                var introduced = false;
	                                if (res[i].comercial_name.toUpperCase().includes(_this.searchFilter.toUpperCase()) && !introduced) {
	                                    _this.elementsThatContainsSearchValueByName.push(res[i]);
	                                    introduced = true;
	                                }
	                                if (res[i].id.toString().includes(_this.searchFilter) && !introduced) {
	                                    _this.elementsThatContainsSearchValueById.push(res[i]);
	                                    introduced = true;
	                                }
	                                if ((res[i].id.toString() + " " + res[i].comercial_name).toUpperCase().includes((_this.searchFilter.toUpperCase())) && !introduced) {
	                                    _this.elementsThatContainsSearchValueByName.push(res[i]);
	                                    introduced = true;
	                                }
	                            }
	                        }
	                    });
	                }
	                else {
	                    this._forumService.getElementsAuthenticatedBySearchFilterValue(this.searchFilter).then(function (res) {
	                        _this.elementsThatContainsSearchValueById = [];
	                        _this.elementsThatContainsSearchValueByName = [];
	                        if (res != null) {
	                            for (var i = 0; i < res.length; i++) {
	                                var introduced = false;
	                                if (res[i].comercial_name.toUpperCase().includes(_this.searchFilter.toUpperCase()) && !introduced) {
	                                    _this.elementsThatContainsSearchValueByName.push(res[i]);
	                                    introduced = true;
	                                }
	                                if (res[i].id.toString().includes(_this.searchFilter) && !introduced) {
	                                    _this.elementsThatContainsSearchValueById.push(res[i]);
	                                    introduced = true;
	                                }
	                                if ((res[i].id.toString() + " " + res[i].comercial_name).toUpperCase().includes((_this.searchFilter.toUpperCase())) && !introduced) {
	                                    _this.elementsThatContainsSearchValueByName.push(res[i]);
	                                    introduced = true;
	                                }
	                            }
	                        }
	                    });
	                }
	            }
	        }
	        else {
	            this.elementsThatContainsSearchValueById = [];
	            this.elementsThatContainsSearchValueByName = [];
	        }
	    };
	    ForumComponent.prototype.searchDataClicked = function (element) {
	        this.searchFilter = "";
	        this.elementsThatContainsSearchValueById = [];
	        this.elementsThatContainsSearchValueByName = [];
	        this.router.navigate(['/main', 'elementdetail', { categoryType: null, sellerType: null, citiesFilter: null, tagsFilter: null, elementId: element.id, scroll: document.body.scrollTop, scrollHeight: document.body.scrollHeight, loadedPage: 0 }]);
	    };
	    ForumComponent.prototype.searchFilterFocusOut = function () {
	        var _this = this;
	        setTimeout(function () {
	            _this.elementsThatContainsSearchValueById = [];
	            _this.elementsThatContainsSearchValueByName = [];
	        }, 200);
	    };
	    ForumComponent.prototype.toProfileClicked = function () {
	        var _this = this;
	        if (this.userStatus == "superuser" || this.userStatus == "admin") {
	            this._forumService.getUserStatus().then(function (res) {
	                localStorage.setItem("userActive", res.active);
	                _this.router.navigate(['/superuser', 'dashboard']);
	            });
	        }
	        else {
	            this.router.navigate(['/main', 'profile']);
	        }
	    };
	    ForumComponent.prototype.accesButtonClicked = function () {
	        if (this.userStatus == "guest") {
	            this.classLoginModal.show = true;
	            this.classLoginModal.hide = false;
	        }
	        else if (this.userStatus == "superuser" || this.userStatus == "admin" || this.userStatus == "user") {
	            localStorage.removeItem('token');
	            localStorage.removeItem('userName');
	            localStorage.removeItem('idUser');
	            localStorage.removeItem('lang');
	            this.router.navigate(['/main', 'dashboard']);
	            location.reload();
	        }
	    };
	    ForumComponent.prototype.loginClicked = function () {
	        var _this = this;
	        this._forumService.login(this.loginEmail, this.loginPassword).subscribe(function (result) {
	            _this.loginCode = result.code;
	            if (result !== null && result.token !== undefined) {
	                localStorage.setItem('userName', result.user.name);
	                localStorage.setItem('idUser', result.user.id.toString());
	                location.reload();
	            }
	        });
	    };
	    ForumComponent.prototype.registerClicked = function () {
	        this.router.navigate(['/register']);
	    };
	    ForumComponent.prototype.forgetPassword = function () {
	        this.classLoginModal.show = false;
	        this.classLoginModal.hide = true;
	        this.classForgetPasswordModal.show = true;
	        this.classForgetPasswordModal.hide = false;
	    };
	    ForumComponent.prototype.closeLoginModal = function () {
	        this.loginCode = 0;
	        this.classLoginModal.show = false;
	        this.classLoginModal.hide = true;
	    };
	    ForumComponent.prototype.resendEmailRecoverPassword = function () {
	        var _this = this;
	        this._forumService.sendEmailRecoverPassword(this.forgetPasswordEmail).then(function (res) {
	            if (res == 1) {
	                _this.emailSended = true;
	            }
	        });
	    };
	    ForumComponent.prototype.closeForgetPasswordModal = function () {
	        this.classForgetPasswordModal.show = false;
	        this.classForgetPasswordModal.hide = true;
	        this.forgetPasswordEmail = "";
	        this.forgetPasswordEmailEmpty = false;
	        this.forgetPasswordEmailIncorrect = false;
	    };
	    ForumComponent.prototype.getPasswordByEmail = function () {
	        var _this = this;
	        if (this.forgetPasswordEmail != undefined && this.forgetPasswordEmail != null && this.forgetPasswordEmail != "") {
	            this.forgetPasswordEmailEmpty = false;
	            this._forumService.verifyEmail(this.forgetPasswordEmail).then(function (res) {
	                if (res) {
	                    _this.forgetPasswordEmailIncorrect = false;
	                    _this._forumService.sendEmailRecoverPassword(_this.forgetPasswordEmail).then(function (res) {
	                        if (res == 1) {
	                            _this.classForgetPasswordModal.show = false;
	                            _this.classForgetPasswordModal.hide = true;
	                            _this.forgetPasswordEmailEmpty = false;
	                            _this.forgetPasswordEmailIncorrect = false;
	                            _this.classEmailSendedModal.show = true;
	                            _this.classEmailSendedModal.hide = false;
	                        }
	                    });
	                }
	                else {
	                    _this.forgetPasswordEmailIncorrect = true;
	                }
	            });
	        }
	        else {
	            this.forgetPasswordEmailEmpty = true;
	        }
	    };
	    ForumComponent.prototype.closeEmailSendedModal = function () {
	        this.classEmailSendedModal.show = false;
	        this.classEmailSendedModal.hide = true;
	        this.forgetPasswordEmail = "";
	        this.emailSended = false;
	    };
	    ForumComponent = __decorate([
	        core_1.Component({
	            selector: 'forum',
	            template: __webpack_require__(234),
	            providers: [forum_service_1.ForumService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof forum_service_1.ForumService !== 'undefined' && forum_service_1.ForumService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object])
	    ], ForumComponent);
	    return ForumComponent;
	    var _a, _b;
	}());
	exports.ForumComponent = ForumComponent;


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(30);
	var Observable_1 = __webpack_require__(5);
	var json = __webpack_require__(95);
	var ForumService = (function () {
	    function ForumService(http) {
	        this.http = http;
	        this._forumURL = "/forumData";
	        this._mainUrl = "/mainData";
	        this.getTokenService();
	        this.serverURL = json.api_url;
	    }
	    ForumService.prototype.getTokenService = function () {
	        this.token = localStorage.getItem('token');
	    };
	    ForumService.prototype.getUserStatus = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        if (token != null && token != "") {
	            authHeader.append('Authorization', 'Bearer ' + token);
	            var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	            return this.http.get(this.serverURL + '/loginData/userStatus', options).toPromise().then(function (res) {
	                if (JSON.parse(res.text()).code == -1) {
	                    return "guest";
	                }
	                else {
	                    return JSON.parse(res.text());
	                }
	            }).catch(this.handleError);
	        }
	        else {
	            return Promise.resolve({ role: "guest" });
	        }
	    };
	    ForumService.prototype.getUserName = function () {
	        return localStorage.getItem("userName");
	    };
	    ForumService.prototype.getUnreadMessages = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token != null && token != "") {
	            authHeader.append('Authorization', 'Bearer ' + token);
	            var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	            return this.http.get(this.serverURL + this._mainUrl + "/messages", options).toPromise().then(function (res) {
	                if (JSON.parse(res.text()).code == 1) {
	                    return JSON.parse(res.text()).rows;
	                }
	                else {
	                    return null;
	                }
	            }).catch(this.handleError);
	        }
	        else {
	            return new Promise(function (resolve, reject) { return "guest"; });
	        }
	    };
	    ForumService.prototype.getElementsBySearchFilterValue = function (searchFilterValue) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        authHeader.append('Authorization', 'Bearer ' + token);
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.get(this.serverURL + this._mainUrl + "/search/" + searchFilterValue, options).toPromise().then(function (res) {
	            if (JSON.parse(res.text()).code == 1) {
	                return JSON.parse(res.text()).rows;
	            }
	            else {
	                return null;
	            }
	        }).catch(this.handleError);
	    };
	    ForumService.prototype.getElementsAuthenticatedBySearchFilterValue = function (searchFilterValue) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        authHeader.append('Authorization', 'Bearer ' + token);
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.get(this.serverURL + this._mainUrl + "/search/authenticated/" + searchFilterValue, options).toPromise().then(function (res) {
	            if (JSON.parse(res.text()).code == 1) {
	                return JSON.parse(res.text()).rows;
	            }
	            else {
	                return null;
	            }
	        }).catch(this.handleError);
	    };
	    ForumService.prototype.login = function (email, password) {
	        var _this = this;
	        var creds = "email=" + email + "&password=" + password;
	        return this.http.post(this.serverURL + '/loginData', creds, { headers: new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' }) }).map(function (res) {
	            var data = res.json();
	            if (data.token !== undefined) {
	                _this.token = data.token;
	                localStorage.setItem('token', _this.token);
	            }
	            return data;
	        });
	    };
	    ForumService.prototype.sendEmailRecoverPassword = function (email) {
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        return this.http.post(this.serverURL + "/loginData/forgetPassword", this.serializeObj({ email: email }), { headers: authHeader }).toPromise().then(function (result) {
	            return JSON.parse(result.text()).code;
	        }).catch(this.handleError);
	    };
	    ForumService.prototype.verifyEmail = function (email) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        authHeader.append('Authorization', 'Bearer ' + token);
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.get(this.serverURL + "/usersData/existsEmail/" + email, options).toPromise().then(function (res) {
	            if (JSON.parse(res.text()).code == 1) {
	                return true;
	            }
	            else {
	                return false;
	            }
	        }).catch(this.handleError);
	    };
	    ForumService.prototype.getTitle = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        authHeader.append('Authorization', 'Bearer ' + token);
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.get(this.serverURL + this._forumURL + "/title", options).toPromise().then(function (res) {
	            if (JSON.parse(res.text()).code == 1) {
	                return JSON.parse(res.text()).title;
	            }
	            else {
	                return null;
	            }
	        }).catch(this.handleError);
	    };
	    ForumService.prototype.getTopics = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        authHeader.append('Authorization', 'Bearer ' + token);
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.get(this.serverURL + this._forumURL + "/topics", options).toPromise().then(function (res) {
	            if (JSON.parse(res.text()).code == 1) {
	                return JSON.parse(res.text()).rows;
	            }
	            else {
	                return null;
	            }
	        }).catch(this.handleError);
	    };
	    ForumService.prototype.getTopicById = function (topic_id) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        authHeader.append('Authorization', 'Bearer ' + token);
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.get(this.serverURL + this._forumURL + "/topic/" + topic_id, options).toPromise().then(function (res) {
	            if (JSON.parse(res.text()).code == 1) {
	                return JSON.parse(res.text()).row;
	            }
	            else {
	                return null;
	            }
	        }).catch(this.handleError);
	    };
	    ForumService.prototype.getForumMessagesByTopicId = function (topic_id) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        authHeader.append('Authorization', 'Bearer ' + token);
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.get(this.serverURL + this._forumURL + "/messages/" + topic_id, options).toPromise().then(function (res) {
	            if (JSON.parse(res.text()).code == 1) {
	                return JSON.parse(res.text()).rows;
	            }
	            else {
	                return null;
	            }
	        }).catch(this.handleError);
	    };
	    ForumService.prototype.getMessageById = function (message_id) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        authHeader.append('Authorization', 'Bearer ' + token);
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.get(this.serverURL + this._forumURL + "/message/" + message_id, options).toPromise().then(function (res) {
	            if (JSON.parse(res.text()).code == 1) {
	                return JSON.parse(res.text()).row;
	            }
	            else {
	                return null;
	            }
	        }).catch(this.handleError);
	    };
	    ForumService.prototype.postTopic = function (topic_name) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        return this.http.post(this.serverURL + this._forumURL + "/topic", this.serializeObj({ topicName: topic_name }), { headers: authHeader }).toPromise().then(function (result) {
	            return JSON.parse(result.text());
	        }).catch(this.handleError);
	    };
	    ForumService.prototype.postMessage = function (message_content, topic_id, message_parent_id) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        return this.http.post(this.serverURL + this._forumURL + "/message", this.serializeObj({ messageContent: message_content, topicId: topic_id, messageParentId: message_parent_id }), { headers: authHeader }).toPromise().then(function (result) {
	            return JSON.parse(result.text());
	        }).catch(this.handleError);
	    };
	    ForumService.prototype.handleError = function (error) {
	        var errMsg = (error.message) ? error.message : error.status ? error.status + " - " + error.statusText : 'Server error';
	        console.error(errMsg);
	        return Observable_1.Observable.throw(errMsg);
	    };
	    ForumService.prototype.serializeObj = function (obj) {
	        var result = [];
	        for (var property in obj) {
	            result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));
	        }
	        return result.join("&");
	    };
	    ForumService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], ForumService);
	    return ForumService;
	    var _a;
	}());
	exports.ForumService = ForumService;


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<nav class=\"navbar navbar-fixed-top navbar-white\" style=\"margin-bottom: 0; padding-bottom: 0; background-color: #035d72!important; z-index: 99999; border-bottom: 0!important;\">\n    <div class=\"container-fluid\">\n        <div class=\"navbar-header\">            \n                <button type=\"button\" class=\"navbar-toggle collapsed\" data-toggle=\"collapse\" (click)=\"isCollapsed=!isCollapsed;\" data-target=\"#navbar\"\n                    aria-expanded=\"false\" aria-controls=\"navbar\" style=\"background-color: #337ab7;\">\n                    <span class=\"sr-only\">Toggle navigation</span>\n                    <span class=\"icon-bar\" style=\"background-color: white;\"></span>\n                    <span class=\"icon-bar\" style=\"background-color: white;\"></span>\n                    <span class=\"icon-bar\" style=\"background-color: white;\"></span>\n                </button>\n                <a class=\"navbar-brand\" [routerLink]=\"['/main', 'dashboard']\"><img style=\"height: 2.7em; width: auto; margin-top: -0.7em;\" class=\"logo\" src=\"" + __webpack_require__(97) + "\" /></a>\n                <label class=\"hidden-xs\" style=\"text-align: left; font-size: 0.8em; color: #ffffff; padding-top: 3em;\">{{ 'AMBULANT_MARKET' | translate }}</label>                                                                                \n        </div>\n        <div id=\"navbar\" class=\"navbar-collapse collapse\" [ngClass]=\"{in: isCollapsed}\">\n            <div class=\"navbar-left navbar-nav nav\">\n                <div class=\"input-group\" style=\"margin-left: 2em; margin-top: 1.3em;\">\n                    <div style=\"background-color: #ffffff; height: 2em; text-align: center; display: inline-block; padding-top: 0.35em; float: left; width: 2em;\">\n                        <span class=\"glyphicon glyphicon-search white big-glyphicon input-group-btn\" style=\"text-align: center;  color: #035d72;  display: inline;\"></span>\n                    </div>\n                    <input type=\"text\" class=\"inputSearch\" placeholder=\"{{ 'SEARCH...' | translate }}\" [(ngModel)]=\"searchFilter\" (keyup)=\"searchFilterChanged($event)\"\n                        style=\"border: 0px; border-bottom: 1.5px solid #ffffff; margin-left: 0; background: none; height: 2em; width: 13em; padding-left: 0.5em; color: white;\"\n                        (focusout)=\"searchFilterFocusOut()\" />                    \n                </div>\n                <div id=\"search-pop\" class=\"searchs-pop\" *ngIf=\"(elementsThatContainsSearchValueById.length > 0 || elementsThatContainsSearchValueByName.length > 0) && !isCollapsed\">                    \n                    <div *ngIf=\"elementsThatContainsSearchValueById.length > 0\" class=\"notification-pop\" style=\"border-bottom: 1px solid #ffffff; text-align: left; padding-left: 0.5em;\">\n                        <a class=\"no-link\" style=\"font-weight: bold; color: #ffffff;\">Id</a>\n                    </div>\n                    <div id=\"search-pop\" *ngFor=\"let element of elementsThatContainsSearchValueById\" class=\"notification-pop\">                        \n                        <a class=\"no-link\" (click)=\"searchDataClicked(element)\">\n                            <div id=\"search-pop\" class=\"notification-text-pop clickable\"><span style=\"font-weight: bold;\">#{{element.id}}</span> {{element.comercial_name}}</div>\n                        </a>\n                        <div id=\"search-pop\" class=\"notification-bar-pop\">\n                            <div id=\"search-pop\"></div>\n                        </div>\n                    </div>\n                    <div *ngIf=\"elementsThatContainsSearchValueByName.length > 0\" class=\"notification-pop\" style=\"border-bottom: 1px solid #ffffff; text-align: left; padding-left: 0.5em;\">\n                        <a class=\"no-link\" style=\"font-weight: bold; color: #ffffff\">{{'NAME' | translate}}</a>\n                    </div>\n                    <div id=\"search-pop\" *ngFor=\"let element of elementsThatContainsSearchValueByName\" class=\"notification-pop\">                        \n                        <a class=\"no-link\" (click)=\"searchDataClicked(element)\">\n                            <div id=\"search-pop\" class=\"notification-text-pop clickable\"><span style=\"font-weight: bold;\">#{{element.id}}</span> {{element.comercial_name}}</div>\n                        </a>\n                        <div id=\"search-pop\" class=\"notification-bar-pop\">\n                            <div id=\"search-pop\"></div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <ul class=\"nav navbar-nav navbar-right\" *ngIf=\"userStatus == 'superuser' || userStatus == 'admin' || userStatus == 'user'\">                \n                <li class=\"clickable\" [ngClass]=\"{borderLine: isCollapsed}\" [ngClass]=\"{borderLineTop: isCollapsed}\"><a (click)=\"noCollapse(); toProfileClicked()\"><span class=\"glyphicon glyphicon-user big-glyphicon\" style=\"color: #fefefe\"></span><span style=\"color: #ffffff;\">  {{userName}} </span></a></li>                \n                <li [ngClass]=\"{borderLine: isCollapsed}\">\n                    <a (click)=\"noCollapse()\" [routerLink]=\"['/main', 'messages']\"><span class=\"glyphicon glyphicon-envelope big-glyphicon\" style=\"color: #fefefe\"></span>\n                <span *ngIf=\"nMessages>0\" style=\"background-color: #005b6e; color: white; margin-left: -0.3em; z-index: 9999999; position: relative; top: 0.2em; padding-left: 0.1em; padding-right: 0.1em; font-size: 12px;\">{{nMessages}}</span>\n                <span *ngIf=\"isCollapsed\" style=\"color: #ffffff;\">  {{ 'MESSAGES' | translate }}</span></a></li>\n                <li [ngClass]=\"{borderLine: isCollapsed}\"><a (click)=\"noCollapse()\" [routerLink]=\"['/main', 'favorites']\"><span class=\"glyphicon glyphicon-heart big-glyphicon\" style=\"color: #fefefe\"></span><span *ngIf=\"isCollapsed\" style=\"color: #ffffff;\">  {{ 'FAVORITES' | translate }}</span></a></li>\n                <li [ngClass]=\"{borderLine: isCollapsed}\"><a (click)=\"noCollapse()\" [routerLink]=\"['/main', 'profile']\"><span class=\"glyphicon glyphicon-cog big-glyphicon\" style=\"color: #fefefe\"></span><span *ngIf=\"isCollapsed\" style=\"color: #ffffff;\">{{ 'PROFILE' | translate }}</span></a></li>\n                <li class=\"clickable\"><a (click)=\"noCollapse()\" (click)=\"accesButtonClicked()\"><span class=\"glyphicon glyphicon-off big-glyphicon\" style=\"color: #fefefe\"></span><span *ngIf=\"isCollapsed\" style=\"color: #ffffff;\">  {{ 'LOGOUT' | translate }}</span></a></li>\n            </ul>\n            <ul class=\"nav navbar-nav navbar-right\" *ngIf=\"userStatus == 'guest'\">                \n                <li [ngClass]=\"{borderLine: isCollapsed}\" class=\"clickable\">\n                    <a (click)=\"noCollapse()\" [routerLink]=\"['/info']\"><span class=\"glyphicon glyphicon-info-sign big-glyphicon\" style=\"color: #ffffff;\"></span><span style=\"color: #eeeeee;\"> {{ 'INFO' | translate }}</span></a>\n                </li>\n                <li [ngClass]=\"{borderLine: isCollapsed}\" class=\"clickable\">\n                    <a href=\"https://www.facebook.com/mercadillo.ambulante?fref=ts\" target=\"_blank\" (click)=\"noCollapse()\" style=\"color: black;\">\n                        <img style=\"height: 1em; width: auto;\" class=\"logo\" src=\"" + __webpack_require__(180) + "\" />\n                        <span *ngIf=\"isCollapsed\" style=\"color: #ffffff;\">  Facebook</span>\n                    </a>\n                </li>\n                <li [ngClass]=\"{borderLine: isCollapsed}\" class=\"clickable\">\n                    <a href=\"https://www.instagram.com/mercadilloambulante/\" target=\"_blank\" style=\"color: black;\">\n                        <img style=\"height: 1em; width: auto;\" class=\"logo\" src=\"" + __webpack_require__(181) + "\" />\n                        <span *ngIf=\"isCollapsed\" style=\"color: #ffffff;\">  Instagram</span>\n                    </a>\n                </li>                \n                <li class=\"clickable\"><a (click)=\"noCollapse()\" (click)=\"accesButtonClicked()\"><span class=\"glyphicon glyphicon-off white big-glyphicon\"></span><span style=\"color: #ffffff;\">  {{ 'TO_ACCESS' | translate }}</span></a></li>\n            </ul>            \n        </div>\n    </div>\n</nav>\n\n<router-outlet></router-outlet>\n\n    <div [ngClass]=\"classLoginModal\" role=\"dialog\">\n        <div class=\"modal-dialog\" style=\"z-index: 9999999999;\">\n            <!-- Modal content-->\n            <div class=\"modal-content\">\n                <div class=\"modal-header\">\n                    <button type=\"button\" class=\"close\" (click)=\"closeLoginModal()\">&times;</button>\n                    <h4 class=\"modal-title\">{{ 'TO_ACCESS' | translate}}</h4>\n                </div>\n                <div class=\"modal-body\" style=\"height: 15em;\">\n                    <div>\n                        <div class=\"form-group\">\n                            <label for=\"email\">{{ 'EMAIL' | translate }}</label>\n                            <input [(ngModel)]=\"loginEmail\" type=\"email\" class=\"form-control\" id=\"email\" (keyup.enter)=\"loginClicked()\">\n                            <span *ngIf=\"loginCode === 530 || loginCode === 531\" class=\"login-error-msg\">{{ 'WRITE_YOUR_EMAIL' | translate }}</span>\n                            <span *ngIf=\"loginCode === 533\" class=\"login-error-msg\">{{ 'WRONG_EMAIL' | translate }}</span>\n                        </div>\n                        <div class=\"form-group\">\n                            <label for=\"password\">{{ 'PASSWORD' | translate }}</label>\n                            <input [(ngModel)]=\"loginPassword\" type=\"password\" class=\"form-control\" id=\"password\" (keyup.enter)=\"loginClicked()\">\n                            <span *ngIf=\"loginCode === 530 || loginCode === 532\" class=\"login-error-msg\">{{ 'WRITE_YOUR_PASSWORD' | translate }}</span>\n                            <span *ngIf=\"loginCode === 534\" class=\"login-error-msg\">{{ 'WRONG_PASSWORD' | translate }}</span>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"modal-footer\" style=\"margin-top: 2em;\">\n                    <button type=\"button\" class=\"btn\" (click)=\"registerClicked()\" style=\"float: left; background-color: #6fb3cb; color: white;\">{{ 'REGISTER' | translate }}</button>\n                    <span class=\"clickable\" style=\"float: left; color: #6fb3cb; margin-left: 1em; margin-top: 1em;\" (click)=\"forgetPassword()\">{{ 'FORGET_PASSWORD' | translate }}</span>\n                    <button type=\"button\" class=\"btn btn-default submitbutton\" (click)=\"loginClicked()\" style=\" background-color: #6fb3cb; color: white;\">{{ 'LOGIN' | translate }}</button>\n                    <button type=\"button\" class=\"btn\" (click)=\"closeLoginModal()\">{{ 'CLOSE' | translate }}</button>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div [ngClass]=\"classForgetPasswordModal\" role=\"dialog\">\n        <div class=\"modal-dialog\" style=\"z-index: 9999999999;\">\n            <!-- Modal content-->\n            <div class=\"modal-content\">\n                <div class=\"modal-header\">\n                    <button type=\"button\" class=\"close\" (click)=\"closeForgetpasswordModal()\">&times;</button>\n                    <h4 class=\"modal-title\">{{ 'FORGET_PASSWORD' | translate}}</h4>\n                </div>\n                <div class=\"modal-body\" style=\"height: 10em;\">\n                    <div>\n                        <div class=\"form-group\">\n                            <label for=\"email\">{{ 'EMAIL' | translate }}</label>\n                            <input [(ngModel)]=\"forgetPasswordEmail\" type=\"email\" class=\"form-control\" id=\"email\">\n                            <span *ngIf=\"forgetPasswordEmailEmpty\" class=\"login-error-msg\">{{ 'WRITE_YOUR_EMAIL' | translate }}</span>\n                            <span *ngIf=\"forgetPasswordEmailIncorrect\" class=\"login-error-msg\">{{ 'WRONG_EMAIL' | translate }}</span>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"modal-footer\" style=\"margin-top: 2em;\">\n                    <button type=\"button\" class=\"btn btn-default submitbutton\" (click)=\"getPasswordByEmail()\" style=\" background-color: #6fb3cb; color: white;\">{{ 'SEND' | translate }}</button>\n                    <button type=\"button\" class=\"btn\" (click)=\"closeForgetPasswordModal()\">{{ 'CLOSE' | translate }}</button>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div [ngClass]=\"classEmailSendedModal\" role=\"dialog\">\n        <div class=\"modal-dialog\" style=\"z-index: 9999999999; width: 50em;\">\n            <!-- Modal content-->\n            <div class=\"modal-content\">\n                <div class=\"modal-header\">\n                    <button type=\"button\" class=\"close\" (click)=\"closeEmailSendedModal()\">&times;</button>\n                    <h4 class=\"modal-title\">{{ 'RECOVER_PASSWORD' | translate}}</h4>\n                </div>\n                <div class=\"modal-body\" style=\"height: 10em;\">\n                    <div>\n                        <div class=\"form-group\">\n                            <span>{{ 'EMAIL_RECOVER_PASSWORD_SENDED' | translate }}.</span><br/>\n                            <span>{{ 'RESEND_EMAIL' | translate }}</span>\n                            <span *ngIf=\"!emailSended\" (click)=\"resendEmailRecoverPassword()\" class=\"clickable\" style=\"text-decoration: underline; color: #6fb3cb;\">{{ 'HERE' | translate }}</span>\n                            <span *ngIf=\"emailSended\">{{'HERE' | translate}}</span>\n                            <br/>\n                            <span *ngIf=\"emailSended\" class=\"login-error-msg\">{{ 'EMAIL_SENDED_AGAIN' | translate}}</span>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"modal-footer\" style=\"margin-top: 2em;\">\n                    <button type=\"button\" class=\"btn\" (click)=\"closeEmailSendedModal()\">{{ 'CLOSE' | translate }}</button>\n                </div>\n            </div>\n        </div>\n    </div>";

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(76);
	var forum_service_1 = __webpack_require__(233);
	var ForumDashboardComponent = (function () {
	    function ForumDashboardComponent(_forumService, _parentRouter) {
	        this._forumService = _forumService;
	        this.router = _parentRouter;
	        this.userStatus = "";
	        this.title = "";
	        this.topics = [];
	        this.topicModal = { 'model': true, 'show': false, 'hide': true };
	        this.topicName = "";
	        this.topicNameError = false;
	        this.classLoginModal = { 'model': true, 'show': false, 'hide': true };
	        this.classForgetPasswordModal = { 'model': true, 'show': false, 'hide': true };
	        this.loginCode = 0;
	        this.loginEmail = "";
	        this.loginPassword = "";
	        this.forgetPasswordEmail = "";
	        this.forgetPasswordEmailEmpty = false;
	        this.forgetPasswordEmailIncorrect = false;
	        this.classEmailSendedModal = { 'model': true, 'show': false, 'hide': true };
	        this.emailSended = false;
	    }
	    ForumDashboardComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._forumService.getUserStatus().then(function (status) {
	            _this.userStatus = status.role;
	        });
	        this._forumService.getTitle().then(function (res) {
	            if (res != null) {
	                _this.title = res;
	            }
	        });
	        this._forumService.getTopics().then(function (res) {
	            if (res != null) {
	                _this.topics = res;
	            }
	        });
	    };
	    ForumDashboardComponent.prototype.addNewTopic = function () {
	        if (this.userStatus != "guest") {
	            this.topicModal.show = true;
	            this.topicModal.hide = false;
	        }
	        else {
	            this.classLoginModal.show = true;
	            this.classLoginModal.hide = false;
	        }
	    };
	    ForumDashboardComponent.prototype.closeTopicModal = function () {
	        this.topicName = "";
	        this.topicNameError = false;
	        this.topicModal.show = false;
	        this.topicModal.hide = true;
	    };
	    ForumDashboardComponent.prototype.saveTopicModal = function () {
	        var _this = this;
	        if (this.topicName != null && this.topicName != undefined && this.topicName.length > 0) {
	            this.topicNameError = false;
	            this._forumService.postTopic(this.topicName).then(function (res) {
	                if (res.code == 1) {
	                    _this.closeTopicModal();
	                    _this._forumService.getTopics().then(function (res) {
	                        if (res != null) {
	                            _this.topics = res;
	                        }
	                    });
	                }
	            });
	        }
	        else {
	            this.topicNameError = true;
	        }
	    };
	    ForumDashboardComponent.prototype.closeLoginModal = function () {
	        this.loginCode = 0;
	        this.classLoginModal.show = false;
	        this.classLoginModal.hide = true;
	    };
	    ForumDashboardComponent.prototype.loginClicked = function () {
	        var _this = this;
	        this._forumService.login(this.loginEmail, this.loginPassword).subscribe(function (result) {
	            _this.loginCode = result.code;
	            if (result !== null && result.token !== undefined) {
	                localStorage.setItem('userName', result.user.name);
	                localStorage.setItem('idUser', result.user.id.toString());
	                location.reload();
	            }
	        });
	    };
	    ForumDashboardComponent.prototype.registerClicked = function () {
	        this.router.navigate(['/register']);
	    };
	    ForumDashboardComponent.prototype.forgetPassword = function () {
	        this.classLoginModal.show = false;
	        this.classLoginModal.hide = true;
	        this.classForgetPasswordModal.show = true;
	        this.classForgetPasswordModal.hide = false;
	    };
	    ForumDashboardComponent.prototype.closeForgetPasswordModal = function () {
	        this.classForgetPasswordModal.show = false;
	        this.classForgetPasswordModal.hide = true;
	        this.forgetPasswordEmail = "";
	        this.forgetPasswordEmailEmpty = false;
	        this.forgetPasswordEmailIncorrect = false;
	    };
	    ForumDashboardComponent.prototype.getPasswordByEmail = function () {
	        var _this = this;
	        if (this.forgetPasswordEmail != undefined && this.forgetPasswordEmail != null && this.forgetPasswordEmail != "") {
	            this.forgetPasswordEmailEmpty = false;
	            this._forumService.verifyEmail(this.forgetPasswordEmail).then(function (res) {
	                if (res) {
	                    _this.forgetPasswordEmailIncorrect = false;
	                    _this._forumService.sendEmailRecoverPassword(_this.forgetPasswordEmail).then(function (res) {
	                        if (res == 1) {
	                            _this.classForgetPasswordModal.show = false;
	                            _this.classForgetPasswordModal.hide = true;
	                            _this.forgetPasswordEmailEmpty = false;
	                            _this.forgetPasswordEmailIncorrect = false;
	                            _this.classEmailSendedModal.show = true;
	                            _this.classEmailSendedModal.hide = false;
	                        }
	                    });
	                }
	                else {
	                    _this.forgetPasswordEmailIncorrect = true;
	                }
	            });
	        }
	        else {
	            this.forgetPasswordEmailEmpty = true;
	        }
	    };
	    ForumDashboardComponent.prototype.resendEmailRecoverPassword = function () {
	        var _this = this;
	        this._forumService.sendEmailRecoverPassword(this.forgetPasswordEmail).then(function (res) {
	            if (res == 1) {
	                _this.emailSended = true;
	            }
	        });
	    };
	    ForumDashboardComponent.prototype.closeEmailSendedModal = function () {
	        this.classEmailSendedModal.show = false;
	        this.classEmailSendedModal.hide = true;
	        this.forgetPasswordEmail = "";
	        this.emailSended = false;
	    };
	    ForumDashboardComponent.prototype.getDays = function (date) {
	        var dateNow = new Date();
	        var dateComment = new Date(date);
	        var difference = dateNow.getTime() / 1000 - dateComment.getTime() / 1000;
	        return Math.floor(difference / 60 / 60 / 24);
	    };
	    ForumDashboardComponent.prototype.getHours = function (date) {
	        var dateNow = new Date();
	        var dateComment = new Date(date);
	        var difference = dateNow.getTime() / 1000 - dateComment.getTime() / 1000;
	        return Math.floor(difference / 60 / 60);
	    };
	    ForumDashboardComponent = __decorate([
	        core_1.Component({
	            selector: 'dashboard',
	            template: __webpack_require__(236),
	            providers: [forum_service_1.ForumService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof forum_service_1.ForumService !== 'undefined' && forum_service_1.ForumService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object])
	    ], ForumDashboardComponent);
	    return ForumDashboardComponent;
	    var _a, _b;
	}());
	exports.ForumDashboardComponent = ForumDashboardComponent;


/***/ },
/* 236 */
/***/ function(module, exports) {

	module.exports = "<div class=\"main\" style=\"margin-top: 4em; padding-top: 1em; padding-left: 3em;\">\n    <div class=\"col-xs-12\" style=\"border-bottom: 1px solid #035d72; padding-left: 0em; color: gray;\">\n        <h1 style=\"float: left;\n    font-weight: 600;\n    vertical-align: bottom;\n    font-size: 1.3em;\n    background-color: #035d72;\n    padding-left: 1em;\n    padding-right: 1em;\n    padding-top: 0.4em;\n    padding-bottom: 0.4em;\n    margin-bottom: 0em;\n    margin-top: 0em;\n    color: white;\">{{title}}</h1>\n            <a style=\"display: inline-block; float: right; color: #035d72; margin-top: 1em;\" (click)=\"addNewTopic()\">+ {{ 'ADD_TOPIC' | translate }}</a>\n    </div>\n    <div *ngFor=\"let topic of topics\" class=\"col-xs-12 clickable\" style=\"margin-top: 0.5em; border-bottom: 1px #035d72 solid;\" [routerLink]=\"['/forum', 'topicdetail', {topic_id: topic.id}]\">\n        <div class=\"col-xs-12\">\n            <label style=\"float: left; font-size: 1.5em;\">{{topic.name}}</label>\n        </div>\n        <div class=\"col-xs-12\">\n            <label style=\"font-weight: 100;\">{{ 'SUBMMITED' | translate }}</label> <label style=\"font-weight: 100; font-style: italic;\">{{topic.user_name}}</label>\n            <label *ngIf=\"getDays(topic.creation_date)>0\" style=\"font-weight: 100;\"> {{getDays(topic.creation_date)}} {{ 'DAYS' | translate }}</label>\n            <label *ngIf=\"getDays(topic.creation_date)==0\" style=\"font-weight: 100;\"> {{getHours(topic.creation_date)}} {{ 'HOURS' | translate }}</label>\n        </div>\n        <div class=\"col-xs-12\">\n            <label style=\"font-weight: 100;\">{{topic.comments}} {{ 'COMMENTS' | translate }}</label>\n        </div>\n    </div>\n</div>\n\n<!--MODAL-->\n<div [ngClass]=\"topicModal\" role=\"dialog\">\n    <div class=\"modal-dialog\" style=\"z-index: 9999999999; width: 50em;\">\n        <!-- Modal content-->\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" (click)=\"closeTopicModal()\">&times;</button>\n                <h4 class=\"modal-title\">{{ 'ADD_TOPIC' | translate}}</h4>\n            </div>\n            <div class=\"modal-body\" style=\"height: 10em;\">\n                <div class=\"form-group\">\n                    <label for=\"topicName\">{{ 'TOPIC_NAME' | translate }}</label>\n                    <input type=\"text\" id=\"topicName\" class=\"form-control\" [(ngModel)]=\"topicName\" (keyup.enter)=\"saveTopicModal()\" />\n                    <span *ngIf=\"topicNameError\" class=\"login-error-msg\">{{ 'TOPIC_NAME_MINIM_LENGTH' | translate }}</span>\n                </div>\n            </div>\n            <div class=\"modal-footer\" style=\"margin-top: 2em;\">\n                <button type=\"button\" class=\"btn\" (click)=\"saveTopicModal()\">{{ 'SAVE' | translate }}</button>\n                <button type=\"button\" class=\"btn\" (click)=\"closeTopicModal()\">{{ 'CLOSE' | translate }}</button>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div [ngClass]=\"classLoginModal\" role=\"dialog\">\n    <div class=\"modal-dialog\" style=\"z-index: 9999999999;\">\n        <!-- Modal content-->\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" (click)=\"closeLoginModal()\">&times;</button>\n                <h4 class=\"modal-title\">{{ 'TO_ACCESS' | translate}}</h4>\n            </div>\n            <div class=\"modal-body\" style=\"height: 15em;\">\n                <div>\n                    <div class=\"form-group\">\n                        <label for=\"email\">{{ 'EMAIL' | translate }}</label>\n                        <input [(ngModel)]=\"loginEmail\" type=\"email\" class=\"form-control\" id=\"email\" (keyup.enter)=\"loginClicked()\">\n                        <span *ngIf=\"loginCode === 530 || loginCode === 531\" class=\"login-error-msg\">{{ 'WRITE_YOUR_EMAIL' | translate }}</span>\n                        <span *ngIf=\"loginCode === 533\" class=\"login-error-msg\">{{ 'WRONG_EMAIL' | translate }}</span>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"password\">{{ 'PASSWORD' | translate }}</label>\n                        <input [(ngModel)]=\"loginPassword\" type=\"password\" class=\"form-control\" id=\"password\" (keyup.enter)=\"loginClicked()\">\n                        <span *ngIf=\"loginCode === 530 || loginCode === 532\" class=\"login-error-msg\">{{ 'WRITE_YOUR_PASSWORD' | translate }}</span>\n                        <span *ngIf=\"loginCode === 534\" class=\"login-error-msg\">{{ 'WRONG_PASSWORD' | translate }}</span>\n                    </div>\n                </div>\n            </div>\n            <div class=\"modal-footer\" style=\"margin-top: 2em;\">\n                <button type=\"button\" class=\"btn\" (click)=\"registerClicked()\" style=\"float: left; background-color: #6fb3cb; color: white;\">{{ 'REGISTER' | translate }}</button>\n                <span class=\"clickable\" style=\"float: left; color: #6fb3cb; margin-left: 1em; margin-top: 1em;\" (click)=\"forgetPassword()\">{{ 'FORGET_PASSWORD' | translate }}</span>\n                <button type=\"button\" class=\"btn btn-default submitbutton\" (click)=\"loginClicked()\" style=\" background-color: #6fb3cb; color: white;\">{{ 'LOGIN' | translate }}</button>\n                <button type=\"button\" class=\"btn\" (click)=\"closeLoginModal()\">{{ 'CLOSE' | translate }}</button>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div [ngClass]=\"classForgetPasswordModal\" role=\"dialog\">\n    <div class=\"modal-dialog\" style=\"z-index: 9999999999;\">\n        <!-- Modal content-->\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" (click)=\"closeForgetpasswordModal()\">&times;</button>\n                <h4 class=\"modal-title\">{{ 'FORGET_PASSWORD' | translate}}</h4>\n            </div>\n            <div class=\"modal-body\" style=\"height: 10em;\">\n                <div>\n                    <div class=\"form-group\">\n                        <label for=\"email\">{{ 'EMAIL' | translate }}</label>\n                        <input [(ngModel)]=\"forgetPasswordEmail\" type=\"email\" class=\"form-control\" id=\"email\">\n                        <span *ngIf=\"forgetPasswordEmailEmpty\" class=\"login-error-msg\">{{ 'WRITE_YOUR_EMAIL' | translate }}</span>\n                        <span *ngIf=\"forgetPasswordEmailIncorrect\" class=\"login-error-msg\">{{ 'WRONG_EMAIL' | translate }}</span>\n                    </div>\n                </div>\n            </div>\n            <div class=\"modal-footer\" style=\"margin-top: 2em;\">\n                <button type=\"button\" class=\"btn btn-default submitbutton\" (click)=\"getPasswordByEmail()\" style=\" background-color: #6fb3cb; color: white;\">{{ 'SEND' | translate }}</button>\n                <button type=\"button\" class=\"btn\" (click)=\"closeForgetPasswordModal()\">{{ 'CLOSE' | translate }}</button>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div [ngClass]=\"classEmailSendedModal\" role=\"dialog\">\n    <div class=\"modal-dialog\" style=\"z-index: 9999999999; width: 50em;\">\n        <!-- Modal content-->\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" (click)=\"closeEmailSendedModal()\">&times;</button>\n                <h4 class=\"modal-title\">{{ 'RECOVER_PASSWORD' | translate}}</h4>\n            </div>\n            <div class=\"modal-body\" style=\"height: 10em;\">\n                <div>\n                    <div class=\"form-group\">\n                        <span>{{ 'EMAIL_RECOVER_PASSWORD_SENDED' | translate }}.</span><br/>\n                        <span>{{ 'RESEND_EMAIL' | translate }}</span>\n                        <span *ngIf=\"!emailSended\" (click)=\"resendEmailRecoverPassword()\" class=\"clickable\" style=\"text-decoration: underline; color: #6fb3cb;\">{{ 'HERE' | translate }}</span>\n                        <span *ngIf=\"emailSended\">{{'HERE' | translate}}</span>\n                        <br/>\n                        <span *ngIf=\"emailSended\" class=\"login-error-msg\">{{ 'EMAIL_SENDED_AGAIN' | translate}}</span>\n                    </div>\n                </div>\n            </div>\n            <div class=\"modal-footer\" style=\"margin-top: 2em;\">\n                <button type=\"button\" class=\"btn\" (click)=\"closeEmailSendedModal()\">{{ 'CLOSE' | translate }}</button>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(76);
	var forum_service_1 = __webpack_require__(233);
	var ForumTopicDetailComponent = (function () {
	    function ForumTopicDetailComponent(_forumService, _parentRouter, route) {
	        this._forumService = _forumService;
	        this._parentRouter = _parentRouter;
	        this.route = route;
	        this.router = _parentRouter;
	        this.userStatus = "";
	        this.topic = { id: 0, name: "", forum_id: 0, user_id: 0, user_name: "", creation_date: new Date() };
	        this.messagesForum = [];
	        this.messageModal = { 'model': true, 'show': false, 'hide': true };
	        this.messageContent = "";
	        this.messageError = false;
	        this.messageToAnswer = null;
	        this.classLoginModal = { 'model': true, 'show': false, 'hide': true };
	        this.classForgetPasswordModal = { 'model': true, 'show': false, 'hide': true };
	        this.loginCode = 0;
	        this.loginEmail = "";
	        this.loginPassword = "";
	        this.forgetPasswordEmail = "";
	        this.forgetPasswordEmailEmpty = false;
	        this.forgetPasswordEmailIncorrect = false;
	        this.classEmailSendedModal = { 'model': true, 'show': false, 'hide': true };
	        this.emailSended = false;
	    }
	    ForumTopicDetailComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._forumService.getUserStatus().then(function (status) {
	            _this.userStatus = status.role;
	        });
	        this._forumService.getTopicById(parseInt(this.route.snapshot.params['topic_id'])).then(function (res) {
	            if (res != null) {
	                _this.topic = res;
	                _this._forumService.getForumMessagesByTopicId(_this.topic.id).then(function (res2) {
	                    if (res2 != null) {
	                        _this.messagesForum = res2;
	                    }
	                });
	            }
	        });
	    };
	    ForumTopicDetailComponent.prototype.messageClicked = function (message, event) {
	        if (message.selected) {
	            this.collapseMessage(message);
	        }
	        else {
	            if (message.childs.length > 0) {
	                message.selected = true;
	            }
	        }
	    };
	    ForumTopicDetailComponent.prototype.collapseMessage = function (message) {
	        message.selected = false;
	        if (message.childs.length > 0) {
	            for (var i = 0; i < message.childs.length; i++) {
	                this.collapseMessage(message.childs[i]);
	            }
	        }
	    };
	    ForumTopicDetailComponent.prototype.answerClicked = function (message) {
	        this.messageToAnswer = message;
	        this.messageModal.show = true;
	        this.messageModal.hide = false;
	    };
	    ForumTopicDetailComponent.prototype.addNewMessage = function () {
	        if (this.userStatus != "guest") {
	            this.messageToAnswer = null;
	            this.messageModal.show = true;
	            this.messageModal.hide = false;
	        }
	        else {
	            this.classLoginModal.show = true;
	            this.classLoginModal.hide = false;
	        }
	    };
	    ForumTopicDetailComponent.prototype.messageReceived = function (event) {
	        this.answerClicked(event.value);
	    };
	    ForumTopicDetailComponent.prototype.closeMessageModal = function () {
	        this.messageContent = "";
	        this.messageError = false;
	        this.messageToAnswer = null;
	        this.messageModal.show = false;
	        this.messageModal.hide = true;
	    };
	    ForumTopicDetailComponent.prototype.saveMessageModal = function () {
	        var _this = this;
	        if (this.messageContent != null && this.messageContent != undefined && this.messageContent.length > 0) {
	            this.messageError = false;
	            var messageToAnswerId = -1;
	            if (this.messageToAnswer != null) {
	                messageToAnswerId = this.messageToAnswer.id;
	            }
	            this._forumService.postMessage(this.messageContent, this.topic.id, messageToAnswerId).then(function (res) {
	                if (res.code == 1) {
	                    if (messageToAnswerId == -1) {
	                        var message = {
	                            "id": res.message_id,
	                            "content": _this.messageContent,
	                            "topic_id": _this.topic.id,
	                            "user_id": Number(localStorage.getItem("idUser")),
	                            "user_name": localStorage.getItem("userName"),
	                            "forum_message_id": null,
	                            "creation_date": new Date(),
	                            "childs": [],
	                            "selected": false,
	                            "messages": 0
	                        };
	                        _this.messagesForum.push(message);
	                    }
	                    else {
	                        var message = {
	                            "id": res.message_id,
	                            "content": _this.messageContent,
	                            "topic_id": _this.topic.id,
	                            "user_id": Number(localStorage.getItem("idUser")),
	                            "user_name": localStorage.getItem("userName"),
	                            "forum_message_id": _this.messageToAnswer.id,
	                            "creation_date": new Date(),
	                            "childs": [],
	                            "selected": false,
	                            "messages": 0
	                        };
	                        _this.messageToAnswer.messages++;
	                        _this.messageToAnswer.childs.push(message);
	                        _this.messageToAnswer.selected = true;
	                    }
	                    _this.closeMessageModal();
	                }
	            });
	        }
	        else {
	            this.messageError = true;
	        }
	    };
	    ForumTopicDetailComponent.prototype.getDaysComments = function (date) {
	        var dateNow = new Date();
	        var dateComment = new Date(date);
	        var difference = dateNow.getTime() / 1000 - dateComment.getTime() / 1000;
	        return Math.floor(difference / 60 / 60 / 24);
	    };
	    ForumTopicDetailComponent.prototype.getHoursComments = function (date) {
	        var dateNow = new Date();
	        var dateComment = new Date(date);
	        var difference = dateNow.getTime() / 1000 - dateComment.getTime() / 1000;
	        return Math.floor(difference / 60 / 60);
	    };
	    ForumTopicDetailComponent.prototype.closeLoginModal = function () {
	        this.loginCode = 0;
	        this.classLoginModal.show = false;
	        this.classLoginModal.hide = true;
	    };
	    ForumTopicDetailComponent.prototype.loginClicked = function () {
	        var _this = this;
	        this._forumService.login(this.loginEmail, this.loginPassword).subscribe(function (result) {
	            _this.loginCode = result.code;
	            if (result !== null && result.token !== undefined) {
	                localStorage.setItem('userName', result.user.name);
	                localStorage.setItem('idUser', result.user.id.toString());
	                location.reload();
	            }
	        });
	    };
	    ForumTopicDetailComponent.prototype.registerClicked = function () {
	        this.router.navigate(['/register']);
	    };
	    ForumTopicDetailComponent.prototype.forgetPassword = function () {
	        this.classLoginModal.show = false;
	        this.classLoginModal.hide = true;
	        this.classForgetPasswordModal.show = true;
	        this.classForgetPasswordModal.hide = false;
	    };
	    ForumTopicDetailComponent.prototype.closeForgetPasswordModal = function () {
	        this.classForgetPasswordModal.show = false;
	        this.classForgetPasswordModal.hide = true;
	        this.forgetPasswordEmail = "";
	        this.forgetPasswordEmailEmpty = false;
	        this.forgetPasswordEmailIncorrect = false;
	    };
	    ForumTopicDetailComponent.prototype.getPasswordByEmail = function () {
	        var _this = this;
	        if (this.forgetPasswordEmail != undefined && this.forgetPasswordEmail != null && this.forgetPasswordEmail != "") {
	            this.forgetPasswordEmailEmpty = false;
	            this._forumService.verifyEmail(this.forgetPasswordEmail).then(function (res) {
	                if (res) {
	                    _this.forgetPasswordEmailIncorrect = false;
	                    _this._forumService.sendEmailRecoverPassword(_this.forgetPasswordEmail).then(function (res) {
	                        if (res == 1) {
	                            _this.classForgetPasswordModal.show = false;
	                            _this.classForgetPasswordModal.hide = true;
	                            _this.forgetPasswordEmailEmpty = false;
	                            _this.forgetPasswordEmailIncorrect = false;
	                            _this.classEmailSendedModal.show = true;
	                            _this.classEmailSendedModal.hide = false;
	                        }
	                    });
	                }
	                else {
	                    _this.forgetPasswordEmailIncorrect = true;
	                }
	            });
	        }
	        else {
	            this.forgetPasswordEmailEmpty = true;
	        }
	    };
	    ForumTopicDetailComponent.prototype.resendEmailRecoverPassword = function () {
	        var _this = this;
	        this._forumService.sendEmailRecoverPassword(this.forgetPasswordEmail).then(function (res) {
	            if (res == 1) {
	                _this.emailSended = true;
	            }
	        });
	    };
	    ForumTopicDetailComponent.prototype.closeEmailSendedModal = function () {
	        this.classEmailSendedModal.show = false;
	        this.classEmailSendedModal.hide = true;
	        this.forgetPasswordEmail = "";
	        this.emailSended = false;
	    };
	    ForumTopicDetailComponent = __decorate([
	        core_1.Component({
	            selector: 'topicDetail',
	            template: __webpack_require__(238),
	            providers: [forum_service_1.ForumService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof forum_service_1.ForumService !== 'undefined' && forum_service_1.ForumService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object])
	    ], ForumTopicDetailComponent);
	    return ForumTopicDetailComponent;
	    var _a, _b, _c;
	}());
	exports.ForumTopicDetailComponent = ForumTopicDetailComponent;


/***/ },
/* 238 */
/***/ function(module, exports) {

	module.exports = "<div class=\"main\" style=\"margin-top: 4em; padding-top: 1em; padding-left: 3em;\">\n    <div class=\"col-xs-12\" style=\"border-bottom: 1px solid #035d72; padding-left: 0em;\">\n        <div class=\"col-xs-8\">\n            <div class=\"col-xs-12\">\n                <label style=\"float: left; font-size: 1.5em;\">{{topic.name}}</label>\n            </div>\n            <div class=\"col-xs-12\">\n                <label style=\"font-weight: 100;\">{{ 'SUBMMITED' | translate }}</label> <label style=\"font-weight: 100; font-style: italic;\">{{topic.user_name}}</label>\n                <label *ngIf=\"getDaysComments(topic.creation_date)>0\" style=\"font-weight: 100;\"> {{getDaysComments(topic.creation_date)}} {{ 'DAYS' | translate }}</label>\n                <label *ngIf=\"getDaysComments(topic.creation_date)==0\" style=\"font-weight: 100;\"> {{getHoursComments(topic.creation_date)}} {{ 'HOURS' | translate }}</label>\n            </div>\n        </div>\n        <div class=\"col-xs-4\">\n            <a style=\"display: inline-block; float: right; color: #035d72; margin-top: 2.5em;\" (click)=\"addNewMessage()\">+ {{ 'ADD_MESSAGE' | translate }}</a>\n        </div>\n\n    </div>\n    <div *ngFor=\"let message of messagesForum\" class=\"col-xs-12\" style=\"margin-top: 1em; border-left:1px;\">\n        <div class=\"col-xs-12\">\n            <div class=\"col-xs-12 clickable\" (click)=\"messageClicked(message, $event)\">\n                <label style=\"float: left;\">{{message.content}}</label>\n            </div>\n            <div class=\"col-xs-12 clickable\" (click)=\"messageClicked(message, $event)\">\n                <label style=\"font-weight: 100;\">{{ 'SUBMMITED' | translate }}</label> <label style=\"font-weight: 100; font-style: italic;\">{{message.user_name}}</label>\n                <label *ngIf=\"getDaysComments(topic.creation_date)>0\" style=\"font-weight: 100;\"> {{getDaysComments(message.creation_date)}} {{ 'DAYS' | translate }}</label>\n                <label *ngIf=\"getDaysComments(topic.creation_date)==0\" style=\"font-weight: 100;\"> {{getHoursComments(message.creation_date)}} {{ 'HOURS' | translate }}</label>\n            </div>\n            <div class=\"col-xs-12 clickable\" *ngIf=\"message.messages>0\" (click)=\"messageClicked(message, $event)\">\n                <label style=\"font-weight: 100; font-style: italic;\">{{message.messages}}</label> <label style=\"font-weight: 100;\">{{ 'COMMENTS' | translate }}</label>\n            </div>\n            <div *ngIf=\"userStatus != 'guest'\" class=\"col-xs-12\">\n                <a (click)=\"answerClicked(message)\" style=\"color: #035d72\">{{ 'ANSWER' | translate }}</a>\n            </div>\n        </div>\n\n\n        <div *ngIf=\"message.selected\" style=\"padding-left: 1em;\">\n            <message-childs [messageClicked]=\"message\" (emiter)=\"messageReceived($event)\"></message-childs>\n        </div>\n    </div>\n</div>\n\n<!--MODAL-->\n<div [ngClass]=\"messageModal\" role=\"dialog\">\n    <div class=\"modal-dialog\" style=\"z-index: 9999999999; width: 50em;\">\n        <!-- Modal content-->\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" (click)=\"closeMessageModal()\">&times;</button>\n                <h4 class=\"modal-title\">{{ 'ADD_MESSAGE' | translate}}</h4>\n            </div>\n            <div class=\"modal-body\" style=\"height: 10em;\">\n                <div class=\"form-group\">\n                    <label for=\"messageContent\">{{ 'MESSAGE_CONTENT' | translate }}</label>\n                    <input type=\"text\" id=\"messageContent\" class=\"form-control\" [(ngModel)]=\"messageContent\" (keyup.enter)=\"saveMessageModal()\" />\n                    <span *ngIf=\"messageError\" class=\"login-error-msg\">{{ 'MESSAGE_CONTENT_MINIM_LENGTH' | translate }}</span>\n                </div>\n            </div>\n            <div class=\"modal-footer\" style=\"margin-top: 2em;\">\n                <button type=\"button\" class=\"btn\" (click)=\"saveMessageModal()\">{{ 'SAVE' | translate }}</button>\n                <button type=\"button\" class=\"btn\" (click)=\"closeMessageModal()\">{{ 'CLOSE' | translate }}</button>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div [ngClass]=\"classLoginModal\" role=\"dialog\">\n        <div class=\"modal-dialog\" style=\"z-index: 9999999999;\">\n            <!-- Modal content-->\n            <div class=\"modal-content\">\n                <div class=\"modal-header\">\n                    <button type=\"button\" class=\"close\" (click)=\"closeLoginModal()\">&times;</button>\n                    <h4 class=\"modal-title\">{{ 'TO_ACCESS' | translate}}</h4>\n                </div>\n                <div class=\"modal-body\" style=\"height: 15em;\">\n                    <div>\n                        <div class=\"form-group\">\n                            <label for=\"email\">{{ 'EMAIL' | translate }}</label>\n                            <input [(ngModel)]=\"loginEmail\" type=\"email\" class=\"form-control\" id=\"email\" (keyup.enter)=\"loginClicked()\">\n                            <span *ngIf=\"loginCode === 530 || loginCode === 531\" class=\"login-error-msg\">{{ 'WRITE_YOUR_EMAIL' | translate }}</span>\n                            <span *ngIf=\"loginCode === 533\" class=\"login-error-msg\">{{ 'WRONG_EMAIL' | translate }}</span>\n                        </div>\n                        <div class=\"form-group\">\n                            <label for=\"password\">{{ 'PASSWORD' | translate }}</label>\n                            <input [(ngModel)]=\"loginPassword\" type=\"password\" class=\"form-control\" id=\"password\" (keyup.enter)=\"loginClicked()\">\n                            <span *ngIf=\"loginCode === 530 || loginCode === 532\" class=\"login-error-msg\">{{ 'WRITE_YOUR_PASSWORD' | translate }}</span>\n                            <span *ngIf=\"loginCode === 534\" class=\"login-error-msg\">{{ 'WRONG_PASSWORD' | translate }}</span>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"modal-footer\" style=\"margin-top: 2em;\">\n                    <button type=\"button\" class=\"btn\" (click)=\"registerClicked()\" style=\"float: left; background-color: #6fb3cb; color: white;\">{{ 'REGISTER' | translate }}</button>\n                    <span class=\"clickable\" style=\"float: left; color: #6fb3cb; margin-left: 1em; margin-top: 1em;\" (click)=\"forgetPassword()\">{{ 'FORGET_PASSWORD' | translate }}</span>\n                    <button type=\"button\" class=\"btn btn-default submitbutton\" (click)=\"loginClicked()\" style=\" background-color: #6fb3cb; color: white;\">{{ 'LOGIN' | translate }}</button>\n                    <button type=\"button\" class=\"btn\" (click)=\"closeLoginModal()\">{{ 'CLOSE' | translate }}</button>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div [ngClass]=\"classForgetPasswordModal\" role=\"dialog\">\n        <div class=\"modal-dialog\" style=\"z-index: 9999999999;\">\n            <!-- Modal content-->\n            <div class=\"modal-content\">\n                <div class=\"modal-header\">\n                    <button type=\"button\" class=\"close\" (click)=\"closeForgetpasswordModal()\">&times;</button>\n                    <h4 class=\"modal-title\">{{ 'FORGET_PASSWORD' | translate}}</h4>\n                </div>\n                <div class=\"modal-body\" style=\"height: 10em;\">\n                    <div>\n                        <div class=\"form-group\">\n                            <label for=\"email\">{{ 'EMAIL' | translate }}</label>\n                            <input [(ngModel)]=\"forgetPasswordEmail\" type=\"email\" class=\"form-control\" id=\"email\">\n                            <span *ngIf=\"forgetPasswordEmailEmpty\" class=\"login-error-msg\">{{ 'WRITE_YOUR_EMAIL' | translate }}</span>\n                            <span *ngIf=\"forgetPasswordEmailIncorrect\" class=\"login-error-msg\">{{ 'WRONG_EMAIL' | translate }}</span>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"modal-footer\" style=\"margin-top: 2em;\">\n                    <button type=\"button\" class=\"btn btn-default submitbutton\" (click)=\"getPasswordByEmail()\" style=\" background-color: #6fb3cb; color: white;\">{{ 'SEND' | translate }}</button>\n                    <button type=\"button\" class=\"btn\" (click)=\"closeForgetPasswordModal()\">{{ 'CLOSE' | translate }}</button>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div [ngClass]=\"classEmailSendedModal\" role=\"dialog\">\n        <div class=\"modal-dialog\" style=\"z-index: 9999999999; width: 50em;\">\n            <!-- Modal content-->\n            <div class=\"modal-content\">\n                <div class=\"modal-header\">\n                    <button type=\"button\" class=\"close\" (click)=\"closeEmailSendedModal()\">&times;</button>\n                    <h4 class=\"modal-title\">{{ 'RECOVER_PASSWORD' | translate}}</h4>\n                </div>\n                <div class=\"modal-body\" style=\"height: 10em;\">\n                    <div>\n                        <div class=\"form-group\">\n                            <span>{{ 'EMAIL_RECOVER_PASSWORD_SENDED' | translate }}.</span><br/>\n                            <span>{{ 'RESEND_EMAIL' | translate }}</span>\n                            <span *ngIf=\"!emailSended\" (click)=\"resendEmailRecoverPassword()\" class=\"clickable\" style=\"text-decoration: underline; color: #6fb3cb;\">{{ 'HERE' | translate }}</span>\n                            <span *ngIf=\"emailSended\">{{'HERE' | translate}}</span>\n                            <br/>\n                            <span *ngIf=\"emailSended\" class=\"login-error-msg\">{{ 'EMAIL_SENDED_AGAIN' | translate}}</span>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"modal-footer\" style=\"margin-top: 2em;\">\n                    <button type=\"button\" class=\"btn\" (click)=\"closeEmailSendedModal()\">{{ 'CLOSE' | translate }}</button>\n                </div>\n            </div>\n        </div>\n    </div>";

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var forummessage_1 = __webpack_require__(240);
	var forum_service_1 = __webpack_require__(233);
	var ForumMessageChildsComponent = (function () {
	    function ForumMessageChildsComponent(_forumService) {
	        this._forumService = _forumService;
	        this.emiter = new core_1.EventEmitter();
	        this.userStatus = "";
	    }
	    ForumMessageChildsComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._forumService.getUserStatus().then(function (status) {
	            _this.userStatus = status.role;
	        });
	    };
	    ForumMessageChildsComponent.prototype.messageClicked = function (message, event) {
	        if (message.childs.length > 0) {
	            message.selected = !message.selected;
	        }
	    };
	    ForumMessageChildsComponent.prototype.answerClicked = function (message) {
	        this.emiter.emit({
	            value: message
	        });
	    };
	    ForumMessageChildsComponent.prototype.messageReceived = function (event) {
	        this.answerClicked(event.value);
	    };
	    ForumMessageChildsComponent.prototype.getDaysChild = function (date) {
	        var dateNow = new Date();
	        var dateComment = new Date(date);
	        var difference = dateNow.getTime() / 1000 - dateComment.getTime() / 1000;
	        return Math.floor(difference / 60 / 60 / 24);
	    };
	    ForumMessageChildsComponent.prototype.getHoursChild = function (date) {
	        var dateNow = new Date();
	        var dateComment = new Date(date);
	        var difference = dateNow.getTime() / 1000 - dateComment.getTime() / 1000;
	        return Math.floor(difference / 60 / 60);
	    };
	    __decorate([
	        core_1.Input('messageClicked'), 
	        __metadata('design:type', (typeof (_a = typeof forummessage_1.ForumMessage !== 'undefined' && forummessage_1.ForumMessage) === 'function' && _a) || Object)
	    ], ForumMessageChildsComponent.prototype, "message", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], ForumMessageChildsComponent.prototype, "emiter", void 0);
	    ForumMessageChildsComponent = __decorate([
	        core_1.Component({
	            selector: 'message-childs',
	            template: __webpack_require__(241),
	            providers: [forum_service_1.ForumService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof forum_service_1.ForumService !== 'undefined' && forum_service_1.ForumService) === 'function' && _b) || Object])
	    ], ForumMessageChildsComponent);
	    return ForumMessageChildsComponent;
	    var _a, _b;
	}());
	exports.ForumMessageChildsComponent = ForumMessageChildsComponent;


/***/ },
/* 240 */
146,
/* 241 */
/***/ function(module, exports) {

	module.exports = "<div *ngFor=\"let child of message.childs\" class=\"col-xs-12\" style=\"padding-right: 0; margin-top: 1em; margin-left: 1.5em; border-left: 1px solid lightgray\">\n    <div class=\"col-xs-12 clickable\" (click)=\"messageClicked(child, $event)\">\n        <label style=\"float: left;\">{{child.content}}</label>\n    </div>\n    <div class=\"col-xs-12 clickable\" (click)=\"messageClicked(child, $event)\">\n        <label style=\"font-weight: 100;\">{{ 'SUBMMITED' | translate }}</label> <label style=\"font-weight: 100; font-style: italic;\">{{child.user_name}}</label>\n        <label *ngIf=\"getDaysChild(child.creation_date)>0\" style=\"font-weight: 100;\"> {{getDaysChild(child.creation_date)}} {{ 'DAYS' | translate }}</label>\n        <label *ngIf=\"getDaysChild(child.creation_date)==0\" style=\"font-weight: 100;\"> {{getHoursChild(child.creation_date)}} {{ 'HOURS' | translate }}</label>\n    </div>\n    <div class=\"col-xs-12 clickable\" *ngIf=\"child.messages>0\" (click)=\"messageClicked(child, $event)\">\n        <label style=\"font-weight: 100; font-style: italic;\">{{child.messages}}</label> <label style=\"font-weight: 100;\">{{ 'COMMENTS' | translate }}</label>\n    </div>\n    <div *ngIf=\"userStatus != 'guest'\" class=\"col-xs-12\">\n        <a (click)=\"answerClicked(child)\" style=\"color: #035d72;\">{{ 'ANSWER' | translate }}</a>\n    </div>\n    <div *ngIf=\"child.selected\">\n        <message-childs [messageClicked]=\"child\" (emiter)=\"messageReceived($event)\"></message-childs>\n    </div>\n</div>";

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(76);
	var profile_service_1 = __webpack_require__(243);
	var cities_1 = __webpack_require__(119);
	var MainProfileComponent = (function () {
	    function MainProfileComponent(_profileService, _parentRouter) {
	        this._profileService = _profileService;
	        this._parentRouter = _parentRouter;
	        this.classMapModal = { 'model': true, 'show': false, 'hide': true };
	        this.classTermsModal = { 'model': true, 'show': false, 'hide': true };
	        this.editingProfile = false;
	        this.changingEmail = false;
	        this.changingPassword = false;
	        this.changingSubrole = false;
	        this.changingCategory = false;
	        this.changingEmailPassword = false;
	        this.changingLanguage = false;
	        this.invalidChangeEmail = false;
	        this.invalidLengthEmail = false;
	        this.invalidExistsEmail = false;
	        this.wrongPassword = false;
	        this.invalidUserPasswordToChangeEmail = false;
	        this.wrongName = false;
	        this.wrongNif = false;
	        this.wrongPhone = false;
	        this.wrongCity = false;
	        this.wrongAddress = false;
	        this.wrongZip = false;
	        this.emptyOldUserPassword = false;
	        this.emptyOrShortNewUserPassword = false;
	        this.modalTitle = "";
	        this.oldUserPassword = "";
	        this.newUserPassword = "";
	        this.userPasswordToChangeEmail = "";
	        this.emailSend = false;
	    }
	    MainProfileComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._profileService.getProfile().then(function (profile) {
	            _this.userProfile = profile.row;
	            _this.userProfileClean = profile.row[0];
	            var cities = cities_1.CITIES.filter(function (city) { return city.id === profile.row[0].city_id; });
	            _this.userProfile[0].city_name = cities[0].name;
	            _this.userProfileClean.city_name = cities[0].name;
	        });
	        this._profileService.getUserLanguage().then(function (lang) {
	            if (lang == 1) {
	                _this.userLanguage = "CATALAN";
	            }
	            else if (lang == 2) {
	                _this.userLanguage = "SPANISH";
	            }
	        });
	    };
	    MainProfileComponent.prototype.editProfile = function () {
	        this.changingEmail = false;
	        this.changingSubrole = false;
	        this.editingProfile = true;
	        this.changingPassword = false;
	        this.changingLanguage = false;
	        this.changingEmailPassword = false;
	        this.changingCategory = false;
	        this.classMapModal.show = true;
	        this.classMapModal.hide = false;
	        this.modalTitle = "EDIT_PROFILE";
	    };
	    MainProfileComponent.prototype.changePassword = function () {
	        this.changingEmail = false;
	        this.changingSubrole = false;
	        this.changingPassword = true;
	        this.changingLanguage = false;
	        this.editingProfile = false;
	        this.changingEmailPassword = false;
	        this.changingCategory = false;
	        this.classMapModal.show = true;
	        this.classMapModal.hide = false;
	        this.modalTitle = "CHANGE_PASSWORD";
	    };
	    MainProfileComponent.prototype.changeSubrole = function () {
	        this.changingEmail = false;
	        this.changingPassword = false;
	        this.changingLanguage = false;
	        this.editingProfile = false;
	        this.changingEmailPassword = false;
	        this.changingCategory = false;
	        this.changingSubrole = true;
	        this.classMapModal.show = true;
	        this.classMapModal.hide = false;
	        this.modalTitle = "CHANGE_SUBROLE";
	    };
	    MainProfileComponent.prototype.changeEmailPassword = function () {
	        this.changingEmail = false;
	        this.changingPassword = false;
	        this.editingProfile = false;
	        this.changingSubrole = false;
	        this.changingLanguage = false;
	        this.changingCategory = false;
	        this.changingEmailPassword = true;
	        this.classMapModal.show = true;
	        this.classMapModal.hide = false;
	        this.modalTitle = "CHANGE_EMAIL";
	    };
	    MainProfileComponent.prototype.changeEmail = function () {
	        this.changingPassword = false;
	        this.editingProfile = false;
	        this.changingEmailPassword = false;
	        this.changingEmail = true;
	        this.changingSubrole = false;
	        this.changingCategory = false;
	        this.changingLanguage = false;
	        this.classMapModal.show = true;
	        this.classMapModal.hide = false;
	        this.modalTitle = "CHANGE_EMAIL";
	    };
	    MainProfileComponent.prototype.sendEmail = function () {
	        var _this = this;
	        this._profileService.sendEmail().then(function (result) {
	            _this.emailSend = true;
	        });
	    };
	    MainProfileComponent.prototype.close = function (savedUser) {
	        this.editingProfile = false;
	        this.changingPassword = false;
	        this.changingEmailPassword = false;
	        this.changingCategory = false;
	        this.changingLanguage = false;
	        this.changingEmail = false;
	        this.changingSubrole = false;
	    };
	    MainProfileComponent.prototype.closeModal = function () {
	        this.classMapModal.show = false;
	        this.classMapModal.hide = true;
	    };
	    MainProfileComponent.prototype.saveModel = function () {
	        var _this = this;
	        if (this.editingProfile) {
	            this.checkUserFields();
	            if (this.wrongName || this.wrongNif || this.wrongPhone || this.wrongCity || this.wrongAddress || this.wrongZip) {
	                this.closeModal();
	                this.editProfile();
	            }
	            else {
	                var city = cities_1.CITIES.filter(function (city) { return city.name.toLowerCase() === _this.userProfileClean.city_name.toLowerCase(); });
	                this._profileService.editProfileInfo(this.userProfileClean, city[0].id).then(function (res) {
	                    if (res == 1) {
	                        location.reload();
	                    }
	                });
	                this.editingProfile = false;
	                this.closeModal();
	            }
	        }
	        else if (this.changingCategory) {
	            this._profileService.changeCategory(this.categoryUpdatedV).subscribe(function (result) {
	                console.log(result);
	                if (result != -1) {
	                    _this.userProfileClean.subrole = result;
	                    _this.closeModal();
	                }
	                else {
	                    _this.closeModal();
	                }
	            }, function () { });
	        }
	        else if (this.changingLanguage) {
	            this._profileService.getUserLanguage().then(function (lang) {
	                if (lang == 1) {
	                    var language = "CATALAN";
	                }
	                else if (lang == 2) {
	                    var language = "SPANISH";
	                }
	                if (language != _this.userLanguage) {
	                    _this._profileService.changeLanguage(_this.userLanguage).subscribe(function (res) {
	                        if (res.code = 1) {
	                            _this.closeModal();
	                            if (_this.userLanguage == "CATALAN") {
	                                localStorage.setItem("language", "cat");
	                            }
	                            else if (_this.userLanguage == "SPANISH") {
	                                localStorage.setItem("language", "esp");
	                            }
	                            location.reload();
	                        }
	                    });
	                }
	                else {
	                    _this.closeModal();
	                }
	            });
	        }
	        else if (this.changingPassword) {
	            console.log(this.oldUserPassword);
	            if (!this.oldUserPassword) {
	                this.emptyOldUserPassword = true;
	            }
	            else {
	                this.emptyOldUserPassword = false;
	            }
	            console.log(this.newUserPassword);
	            if (!this.newUserPassword || this.newUserPassword.length < 4) {
	                this.emptyOrShortNewUserPassword = true;
	            }
	            else {
	                this.emptyOrShortNewUserPassword = false;
	            }
	            if (this.emptyOldUserPassword || this.emptyOrShortNewUserPassword) {
	                this.wrongPassword = false;
	                this.closeModal();
	                this.changePassword();
	            }
	            else {
	                this._profileService.verifyPassword(this.oldUserPassword).then(function (result) {
	                    if (result) {
	                        _this._profileService.changePassword(_this.newUserPassword).then(function (result) {
	                            _this.wrongPassword = false;
	                            _this.closeModal();
	                        });
	                    }
	                    else {
	                        _this.closeModal();
	                        _this.wrongPassword = true;
	                        _this.changePassword();
	                    }
	                });
	            }
	        }
	        else if (this.changingEmailPassword) {
	            this._profileService.verifyPassword(this.userPasswordToChangeEmail).then(function (result) {
	                if (result) {
	                    _this.invalidUserPasswordToChangeEmail = false;
	                    _this.closeModal();
	                    _this.changeEmail();
	                }
	                else {
	                    _this.closeModal();
	                    _this.invalidUserPasswordToChangeEmail = true;
	                    _this.changeEmailPassword();
	                }
	            });
	        }
	        else if (this.changingEmail) {
	            if (this.userEmailChange.length == 0 || this.userEmailChange.length > 50) {
	                this.invalidLengthEmail = true;
	            }
	            else {
	                this.invalidLengthEmail = false;
	                if (!this.validateEmail(this.userEmailChange)) {
	                    this.invalidChangeEmail = true;
	                }
	                else {
	                    this.invalidChangeEmail = false;
	                }
	            }
	            if (this.invalidChangeEmail || this.invalidLengthEmail) {
	                this.closeModal();
	                this.changeEmail();
	            }
	            else {
	                this._profileService.existsEmail(this.userEmailChange).then(function (res) {
	                    if (!res) {
	                        _this._profileService.changeEmail(_this.userEmailChange).then(function (result) {
	                            if (result = "1") {
	                                _this.closeModal();
	                                _this.userProfile[0].email = _this.userEmailChange;
	                                _this.userProfileClean.email_active = false;
	                            }
	                            else {
	                            }
	                        });
	                    }
	                    else {
	                        _this.invalidExistsEmail = true;
	                        _this.closeModal();
	                        _this.changeEmail();
	                    }
	                });
	            }
	        }
	    };
	    MainProfileComponent.prototype.checkUserFields = function () {
	        this.checkName();
	        this.checkNif();
	        this.checkPhone();
	        this.checkCity();
	        this.checkAddress();
	        this.checkZip();
	    };
	    MainProfileComponent.prototype.checkName = function () {
	        if (this.userName.length == 0 || this.userName.length < 2 || this.userName.length > 60) {
	            this.wrongName = true;
	        }
	        else {
	            this.wrongName = false;
	        }
	    };
	    MainProfileComponent.prototype.checkNif = function () {
	        if (this.userNif.length == 0 || !this.validateNIF(this.userNif)) {
	            this.wrongNif = true;
	        }
	        else {
	            this.wrongNif = false;
	        }
	    };
	    MainProfileComponent.prototype.checkPhone = function () {
	        if (this.userPhone.length == 0 || !this.validPhone(this.userPhone)) {
	            this.wrongPhone = true;
	        }
	        else {
	            this.wrongPhone = false;
	        }
	    };
	    MainProfileComponent.prototype.checkCity = function () {
	        var _this = this;
	        var cities = cities_1.CITIES.filter(function (city) { return city.name.toLowerCase() == _this.userCity.toLowerCase(); });
	        if (cities.length != 0 && cities[0] !== undefined && cities[0] !== null) {
	            this.userCity = cities[0].name;
	            this.userProfile[0].city_name = cities[0].name;
	            this.wrongCity = false;
	        }
	        else {
	            this.wrongCity = true;
	        }
	    };
	    MainProfileComponent.prototype.checkAddress = function () {
	        if (this.userAddress.length < 5 || this.userAddress.length > 120) {
	            this.wrongAddress = true;
	        }
	        else {
	            this.wrongAddress = false;
	        }
	    };
	    MainProfileComponent.prototype.checkZip = function () {
	        if (this.userZip.length == 0 || !this.validZip(this.userZip)) {
	            this.wrongZip = true;
	        }
	        else {
	            this.wrongZip = false;
	        }
	    };
	    MainProfileComponent.prototype.userNameFunction = function (event) {
	        this.userName = event.value;
	    };
	    MainProfileComponent.prototype.userNifFunction = function (event) {
	        this.userNif = event.value;
	    };
	    MainProfileComponent.prototype.userPhoneFunction = function (event) {
	        this.userPhone = event.value;
	    };
	    MainProfileComponent.prototype.userCityFunction = function (event) {
	        this.userCity = event.value;
	    };
	    MainProfileComponent.prototype.userAddressFunction = function (event) {
	        this.userAddress = event.value;
	    };
	    MainProfileComponent.prototype.userZipFunction = function (event) {
	        this.userZip = event.value;
	    };
	    MainProfileComponent.prototype.oldUserPasswordFunction = function (event) {
	        this.oldUserPassword = event.value;
	    };
	    MainProfileComponent.prototype.newUserPasswordFunction = function (event) {
	        this.newUserPassword = event.value;
	    };
	    MainProfileComponent.prototype.userPasswordToChangeEmailFunction = function (event) {
	        this.userPasswordToChangeEmail = event.value;
	    };
	    MainProfileComponent.prototype.userChangeEmailFunction = function (event) {
	        this.userEmailChange = event.value;
	    };
	    MainProfileComponent.prototype.validateNIF = function (value) {
	        var validChars = 'TRWAGMYFPDXBNJZSQVHLCKET';
	        var nifRexp = /^[0-9]{8}(-?)[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i;
	        var nieRexp = /^[XYZ]{1}[0-9]{7}(-?)[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i;
	        var str = value.toString().toUpperCase();
	        if (!nifRexp.test(str) && !nieRexp.test(str))
	            return false;
	        var nie = str
	            .replace(/^[X]/, '0')
	            .replace(/^[Y]/, '1')
	            .replace(/^[Z]/, '2');
	        var letter = str.substr(-1);
	        var charIndex = parseInt(nie.substr(0, 8)) % 23;
	        if (validChars.charAt(charIndex) === letter)
	            return true;
	        return false;
	    };
	    MainProfileComponent.prototype.validPhone = function (phone) {
	        var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{3,6}$/im;
	        var re2 = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{2}[-\s\.]?[0-9]{2}[-\s\.]?[0-9]{2}$/im;
	        return re.test(phone) || re2.test(phone);
	    };
	    MainProfileComponent.prototype.validZip = function (zip) {
	        var re = /^[\+]?[(]?[0-9]{5}$/im;
	        return re.test(zip);
	    };
	    MainProfileComponent.prototype.validateEmail = function (email) {
	        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	        return re.test(email);
	    };
	    MainProfileComponent.prototype.showTerms = function () {
	        this.classTermsModal.show = true;
	        this.classTermsModal.hide = false;
	    };
	    MainProfileComponent.prototype.closeTermsModal = function () {
	        this.classTermsModal.show = false;
	        this.classTermsModal.hide = true;
	    };
	    MainProfileComponent.prototype.getSubrole = function () {
	        if (this.userProfileClean.subrole == 1 || this.userProfileClean.subrole == 3) {
	            return "PROFESIONAL";
	        }
	        else if (this.userProfileClean.subrole == 2 || this.userProfileClean.subrole == 4) {
	            return "TRADITIONAL";
	        }
	        else if (this.userProfileClean.subrole == 8 || this.userProfileClean.subrole == 9) {
	            return "STANDARD";
	        }
	        else {
	            return "UNDEFINED";
	        }
	    };
	    MainProfileComponent.prototype.subroleUpdatedAnswer = function (event) {
	        var _this = this;
	        this.closeModal();
	        if (event.value) {
	            this._profileService.getProfile().then(function (profile) {
	                _this.userProfile = profile.row;
	                _this.userProfileClean = profile.row[0];
	                var cities = cities_1.CITIES.filter(function (city) { return city.id === profile.row[0].city_id; });
	                _this.userProfile[0].city_name = cities[0].name;
	                _this.userProfileClean.city_name = cities[0].name;
	            });
	        }
	    };
	    MainProfileComponent.prototype.getCategory = function () {
	        if (this.userProfileClean.subrole == 1 || this.userProfileClean.subrole == 2 || this.userProfileClean.subrole == 8) {
	            return "CATEGORY_1";
	        }
	        else if (this.userProfileClean.subrole == 3 || this.userProfileClean.subrole == 4 || this.userProfileClean.subrole == 9) {
	            return "CATEGORY_2";
	        }
	    };
	    MainProfileComponent.prototype.changeCategory = function () {
	        this.changingEmail = false;
	        this.changingPassword = false;
	        this.editingProfile = false;
	        this.changingEmailPassword = false;
	        this.changingSubrole = false;
	        this.changingLanguage = false;
	        this.changingCategory = true;
	        this.classMapModal.show = true;
	        this.classMapModal.hide = false;
	        this.modalTitle = "CHANGE_CATEGORY";
	    };
	    MainProfileComponent.prototype.categoryUpdated = function (event) {
	        console.log("category " + event.value);
	        this.categoryUpdatedV = event.value;
	    };
	    MainProfileComponent.prototype.languageUpdatedFunction = function (event) {
	        this.userLanguage = event.value;
	    };
	    MainProfileComponent.prototype.changeLanguage = function () {
	        this.changingEmail = false;
	        this.changingPassword = false;
	        this.editingProfile = false;
	        this.changingEmailPassword = false;
	        this.changingSubrole = false;
	        this.changingCategory = false;
	        this.changingLanguage = true;
	        this.classMapModal.show = true;
	        this.classMapModal.hide = false;
	        this.modalTitle = "CHANGE_LANGUAGE";
	    };
	    MainProfileComponent = __decorate([
	        core_1.Component({
	            selector: 'profile',
	            template: __webpack_require__(244),
	            providers: [profile_service_1.ProfileService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof profile_service_1.ProfileService !== 'undefined' && profile_service_1.ProfileService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object])
	    ], MainProfileComponent);
	    return MainProfileComponent;
	    var _a, _b;
	}());
	exports.MainProfileComponent = MainProfileComponent;


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(30);
	var json = __webpack_require__(95);
	var ProfileService = (function () {
	    function ProfileService(http) {
	        this.http = http;
	        this._profileUrl = '/profileData';
	        this.serverURL = json.api_url;
	    }
	    ProfileService.prototype.getUserStatus = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        if (token != null && token != "") {
	            authHeader.append('Authorization', 'Bearer ' + token);
	            var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	            return this.http.get(this.serverURL + 'loginData/userStatus', options).toPromise().then(function (res) {
	                if (JSON.parse(res.text()).code == -1) {
	                    return "guest";
	                }
	                else {
	                    return JSON.parse(res.text());
	                }
	            }).catch(this.handleError);
	        }
	        else {
	            return Promise.resolve({ role: "guest" });
	        }
	    };
	    ProfileService.prototype.getProfile = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.get(this.serverURL + this._profileUrl, options)
	            .toPromise()
	            .then(function (res) { return JSON.parse(res.text()); }, this.handleError);
	    };
	    ProfileService.prototype.editProfile = function (profile) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        return this.http.put(this.serverURL + this._profileUrl, this.serializeObj(profile), { headers: authHeader }).toPromise().then(function (res) {
	            return res;
	        });
	    };
	    ProfileService.prototype.editProfileInfo = function (profile, city_id) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        var url = this._profileUrl + "/" + city_id;
	        return this.http.put(this.serverURL + url, this.serializeObj(profile), { headers: authHeader }).toPromise().then(function (res) {
	            if (JSON.parse(res.text()).code == 1) {
	                localStorage.setItem("userName", JSON.parse(res.text()).user_name);
	            }
	            return JSON.parse(res.text()).code;
	        });
	    };
	    ProfileService.prototype.sendEmail = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        authHeader.append('Authorization', 'Bearer ' + token);
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.get(this.serverURL + '/emailData/sendEmailProfile', options)
	            .toPromise()
	            .then(function (res) {
	            if (JSON.parse(res.text()).code == -1) {
	                return JSON.parse(res.text()).active != 2;
	            }
	            else {
	                return false;
	            }
	        });
	    };
	    ProfileService.prototype.verifyPassword = function (password) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        return this.http.post(this.serverURL + this._profileUrl, this.serializeObj({ "password": password }), { headers: authHeader }).toPromise().then(function (result) {
	            return JSON.parse(result.text()).isMatch;
	        }).catch(this.handleError);
	    };
	    ProfileService.prototype.changePassword = function (password) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        return this.http.put(this.serverURL + this._profileUrl, this.serializeObj({ "password": password }), { headers: authHeader }).toPromise().then(function (result) {
	            return JSON.parse(result.text()).code;
	        }).catch(this.handleError);
	    };
	    ProfileService.prototype.changeEmail = function (email) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        var url = this._profileUrl + "/" + "email";
	        return this.http.put(this.serverURL + url, this.serializeObj({ "email": email }), { headers: authHeader }).toPromise().then(function (result) {
	            return JSON.parse(result.text()).code;
	        }).catch(this.handleError);
	    };
	    ProfileService.prototype.existsEmail = function (email) {
	        return this.http.get(this.serverURL + '/usersData/existsEmail/' + email).toPromise()
	            .then(function (res) {
	            if (JSON.parse(res.text()).code == 1) {
	                return true;
	            }
	            else {
	                return false;
	            }
	        }, this.handleError);
	    };
	    ProfileService.prototype.createTransaction = function (accountType, method) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        authHeader.append('Authorization', 'Bearer ' + token);
	        return this.http.post(this.serverURL + '/transactions/createTransaction', this.serializeObj({ "accountType": accountType, "method": method }), {
	            headers: authHeader
	        })
	            .toPromise()
	            .then(function (res) {
	            if (JSON.parse(res.text()).code == 1) {
	                return JSON.parse(res.text());
	            }
	            else {
	                return JSON.parse(res.text());
	            }
	        });
	    };
	    ProfileService.prototype.updateTransaction = function (id, method) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        authHeader.append('Authorization', 'Bearer ' + token);
	        return this.http.post(this.serverURL + '/transactions/updateTransaction', this.serializeObj({ "method": method, "id": id }), {
	            headers: authHeader
	        })
	            .toPromise()
	            .then(function (res) {
	            if (JSON.parse(res.text()).code == 1) {
	                return JSON.parse(res.text());
	            }
	            else {
	                return JSON.parse(res.text());
	            }
	        });
	    };
	    ProfileService.prototype.registerFree = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        authHeader.append('Authorization', 'Bearer ' + token);
	        return this.http.post(this.serverURL + '/transactions/registerFree', {}, {
	            headers: authHeader
	        })
	            .map(function (res) {
	            var data = res.json();
	            return data.code;
	        });
	    };
	    ProfileService.prototype.changeCategory = function (cat) {
	        console.log(cat);
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        authHeader.append('Authorization', 'Bearer ' + token);
	        return this.http.post(this.serverURL + '/elementData/changeCategory', this.serializeObj({ "category": cat }), {
	            headers: authHeader
	        }).map(function (res) {
	            var data = res.json();
	            return data.subrole;
	        });
	    };
	    ProfileService.prototype.changeLanguage = function (lang) {
	        console.log(lang);
	        var language = 0;
	        if (lang == "CATALAN") {
	            language = 1;
	        }
	        else if (lang == "SPANISH") {
	            language = 2;
	        }
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        authHeader.append('Authorization', 'Bearer ' + token);
	        return this.http.post(this.serverURL + this._profileUrl + "/language", this.serializeObj({ "language": language }), { headers: authHeader }).map(function (res) {
	            var data = res.json();
	            return data;
	        });
	    };
	    ProfileService.prototype.getUserLanguage = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
	        if (token != null && token != "") {
	            authHeader.append('Authorization', 'Bearer ' + token);
	            var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	            return this.http.get(this.serverURL + "/mainData" + "/language", options).toPromise().then(function (res) {
	                if (JSON.parse(res.text()).code == 1) {
	                    return JSON.parse(res.text()).language;
	                }
	            }).catch(this.handleError);
	        }
	    };
	    ProfileService.prototype.handleError = function (error) {
	        // In a real world app, we might use a remote logging infrastructure
	        // We'd also dig deeper into the error to get a better message
	        var errMsg = (error.message) ? error.message :
	            error.status ? error.status + " - " + error.statusText : 'Server error';
	        console.error(errMsg); // log to console instead
	        return Promise.reject(errMsg);
	    };
	    ProfileService.prototype.serializeObj = function (obj) {
	        var result = [];
	        for (var property in obj)
	            result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));
	        return result.join("&");
	    };
	    ProfileService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], ProfileService);
	    return ProfileService;
	    var _a;
	}());
	exports.ProfileService = ProfileService;


/***/ },
/* 244 */
/***/ function(module, exports) {

	module.exports = "\n        <div style=\"    border-bottom: 1px solid grey; padding-bottom: 0.5em; padding-top: 0.5em;\">\n            <span class=\"glyphicon glyphicon-user big-glyphicon\"></span><h2 style=\"display: inline; font-size: 1.4em; padding-left: 1.5em;\">{{ 'USER_PROFILE' | translate }}</h2>\n        </div>\n        <div style=\"border-bottom: 1px solid grey; margin-top: 1em; border-top: 1px solid grey; padding-top: 0.4em; padding-left: 1em;\">\n            <h4 class=\"subtitle\" style=\"display: inline; font-size: 1.2em;\">{{ 'USER_DATA' | translate }}</h4><label class=\"clickable\" style=\"font-size: 0.8em; margin-left: 3em;\" (click)=\"editProfile()\">{{ 'EDIT_PROFILE' | translate }}</label>\n        </div>\n        <div style=\"padding-left: 1em; padding-top: 1em;\" *ngFor=\"let profile of userProfile\">\n                <label>{{ 'NAME' | translate }}:</label> <label style=\"font-weight:100\">{{profile.name}}</label><br/>\n                <label>{{ 'DNI' | translate }}:</label> <label style=\"font-weight:100\">{{profile.nif}}</label><br/>\n                <label>{{ 'PHONE' | translate }}:</label> <label style=\"font-weight:100\">{{profile.phone}}</label><br/>  \n                <label>{{ 'CITY_FIELD' | translate }}:</label> <label style=\"font-weight:100\">{{profile.city_name}}</label><br/>\n                <label>{{ 'ADDRESS_FIELD' | translate }}:</label> <label style=\"font-weight:100\">{{profile.address}}</label><br/>\n                <label>{{ 'ZIP_FIELD' | translate }}:</label> <label style=\"font-weight:100\">{{profile.zip}}</label><br/>\n        </div>\n        \n        <br/>\n        <div style=\"border-bottom: 1px solid grey; margin-top: 1em; border-top: 1px solid grey; padding-top: 0.4em; padding-left: 1em;\">\n            <h4 class=\"subtitle\" style=\"display: inline; font-size: 1.2em;\">{{ 'EMAIL' | translate }}</h4><label class=\"clickable\" style=\"font-size: 0.8em; margin-left: 3em;\" (click)=\"changeEmailPassword()\">{{ 'CHANGE_EMAIL' | translate }}</label>\n        </div>\n        <div style=\"padding-left: 1em; padding-top: 1em;\" *ngFor=\"let profile of userProfile\">\n            <label>{{profile.email}}</label>\n            <div *ngIf=\"!userProfileClean.email_active\">\n                <label style=\"font-size: 1em; font-weight: 100;\">{{ 'EMAIL_NOT_VALIDATED' | translate }}!</label>\n                <label *ngIf=\"!emailSend\" style=\"font-size: 0.8em; margin-left: 2em;\" class=\"clickable\" (click)=\"sendEmail()\">{{ 'VALIDATE_EMAIL_1' | translate }}</label>\n                <label *ngIf=\"emailSend\" style=\"font-size: 0.8em; margin-left: 2em;\">{{ 'EMAIL_SEND' | translate }}</label>\n            </div>\n        </div>\n        <br/>\n        <div style=\"border-bottom: 1px solid grey; margin-top: 1em; border-top: 1px solid grey; padding-top: 0.4em; padding-left: 1em;\">\n            <h4 class=\"subtitle\" style=\"display: inline; font-size: 1.2em;\">{{ 'PASSWORD' | translate }}</h4><label class=\"clickable\" style=\"font-size: 0.8em; margin-left: 3em;\" (click)=\"changePassword()\">{{ 'CHANGE_PASSWORD' | translate }}</label>\n        </div>\n        <div style=\"padding-left: 1em; padding-top: 1em;\" *ngFor=\"let profile of userProfile\">\n            <label style=\"font-size: 1em;\">********</label>\n        </div>   \n        <div *ngIf=\"userProfileClean!=undefined && userProfileClean.role == 3\"  style=\"border-bottom: 1px solid grey; margin-top: 1em; border-top: 1px solid grey; padding-top:0.4em; padding-left: 1em\">\n            <h4 class=\"subtitle\" style=\"display: inline; font-size: 1.2em;\">{{ 'SUBROLE' | translate }}</h4><label *ngIf=\"userProfileClean.subrole != 1 && userProfileClean.subrole != 3\" class=\"clickable\" style=\"font-size: 0.8em; margin-left: 3em;\" (click)=\"changeSubrole()\">{{ 'CHANGE_SUBROLE' | translate}}</label>\n        </div>\n        <div *ngIf=\"userProfileClean!=undefined && userProfileClean.role == 3\" style=\"padding-left: 1em; padding-top: 1em;\">\n            <label style=\"font-size: 1em;\">{{getSubrole() | translate}}</label>\n        </div>\n        <div *ngIf=\"userProfileClean!=undefined && userProfileClean.role == 3\"  style=\"border-bottom: 1px solid grey; margin-top: 1em; border-top: 1px solid grey; padding-top:0.4em; padding-left: 1em\">\n            <h4 class=\"subtitle\" style=\"display: inline; font-size: 1.2em;\">{{ 'CATEGORY' | translate }}</h4><label class=\"clickable\" style=\"font-size: 0.8em; margin-left: 3em;\" (click)=\"changeCategory()\">{{ 'CHANGE_CATEGORY' | translate}}</label>\n        </div>\n        <div *ngIf=\"userProfileClean!=undefined && userProfileClean.role == 3\" style=\"padding-left: 1em; padding-top: 1em;\">\n            <label style=\"font-size: 1em;\">{{getCategory() | translate}}</label>\n        </div>\n        <div style=\"border-bottom: 1px solid grey; margin-top: 1em; border-top: 1px solid grey; padding-top: 0.4em; padding-left: 1em;\">\n            <h4 class=\"subtitle\" style=\"display: inline; font-size: 1.2em;\">{{ 'LANGUAGE' | translate }}</h4><label class=\"clickable\" style=\"font-size: 0.8em; margin-left: 3em;\" (click)=\"changeLanguage()\">{{ 'CHANGE_LANGUAGE' | translate }}</label>\n        </div>\n        <div style=\"padding-left: 1em; padding-top: 1em;\">\n            <label style=\"font-size: 1em;\">{{ userLanguage | translate }}</label>\n        </div>\n        <br/>     \n        <div style=\"padding-left: 1em; margin-top: 3em;\">\n            <a (click)=\"showTerms()\">{{'CONDITIONS_3' | translate}}</a>\n        </div>\n\n\n<div [ngClass]=\"classMapModal\" role=\"dialog\">\n    <div class=\"modal-dialog\" style=\"z-index: 99999\">\n        <!-- Modal content-->\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" (click)=\"closeModal()\">&times;</button>\n                <h4 class=\"modal-title\">{{ modalTitle | translate }}</h4>\n            </div>\n            <div class=\"modal-body\" style=\"overflow-y: scroll; height: 33em;\">\n                <div *ngIf=\"editingProfile\">\n                    <main-profile-edit [profile-obj]=\"userProfileClean\" \n                    [isNameWrong]=\"wrongName\" (nameWrong)=\"userNameFunction($event)\" \n                    [isNifWrong]=\"wrongNif\" (nifWrong)=\"userNifFunction($event)\" \n                    [isPhoneWrong]=\"wrongPhone\" (phoneWrong)=\"userPhoneFunction($event)\" \n                    [isCityWrong]=\"wrongCity\" (cityWrong)=\"userCityFunction($event)\"\n                    [isAddressWrong]=\"wrongAddress\" (addressWrong)=\"userAddressFunction($event)\"\n                    [isZipWrong]=\"wrongZip\" (zipWrong)=\"userZipFunction($event)\"\n                    (close)=\"close($event)\"></main-profile-edit>\n                    <!--(submit-profile)=\"profileAct($event);\"-->\n                </div>\n                <div *ngIf=\"changingPassword\">\n                    <main-profile-change-password [isWrongPassword]=\"wrongPassword\" [isOldPasswordEmpty]=\"emptyOldUserPassword\" [isNewPasswordEmptyOrShort]=\"emptyOrShortNewUserPassword\" (oldUserPassword)=\"oldUserPasswordFunction($event)\" (newUserPassword)=\"newUserPasswordFunction($event)\" (close)=\"close($event)\"></main-profile-change-password>\n                </div>\n                <div *ngIf=\"changingEmailPassword\">\n                    <main-profile-change-email-password [invalidPasswordToChangeEmail]=\"invalidUserPasswordToChangeEmail\" (userPassword)=\"userPasswordToChangeEmailFunction($event)\" (close)=\"close($event)\"></main-profile-change-email-password>\n                </div>\n                <div *ngIf=\"changingEmail\">\n                    <main-profile-change-email [invalidEmail]=\"invalidChangeEmail\" [invalidEmailLength]=\"invalidLengthEmail\" [invalidEmailExists]=\"invalidExistsEmail\" (userEmail)=\"userChangeEmailFunction($event)\" (close)=\"close($event)\"></main-profile-change-email>\n                </div>   \n                <div *ngIf=\"changingSubrole\">\n                    <main-profile-change-subrole [subrole]=\"userProfileClean.subrole\" (subroleUpdated)=\"subroleUpdatedAnswer($event)\"></main-profile-change-subrole>\n                </div>         \n                <div *ngIf=\"changingCategory\">\n                    <main-profile-change-category [subroleCat]=\"userProfileClean.subrole\" (subroleUpdatedCat)=\"categoryUpdated($event)\"></main-profile-change-category>\n                </div>    \n                <div *ngIf=\"changingLanguage\">\n                    <main-profile-change-language [language]=\"userLanguage\" (languageUpdated)=\"languageUpdatedFunction($event)\"></main-profile-change-language>\n                </div>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn\" (click)=\"closeModal()\">{{ 'CLOSE' | translate }}</button>\n                <button type=\"button\" class=\"btn btn-default\" (click)=\"saveModel()\" *ngIf=\"!changingSubrole\">{{ 'SAVE' | translate }}</button>\n            </div>\n        </div>\n    </div>\n</div>\n<div [ngClass]=\"classTermsModal\" role=\"dialog\">\n            <div class=\"modal-dialog\"  style=\"width: 700px; z-index: 99999;\">\n                <!-- Modal content-->\n                <div class=\"modal-content\">\n                    <div class=\"modal-header\" >\n                        <button type=\"button\" class=\"close\" (click)=\"closeTermsModal()\">&times;</button>\n                        <h4 class=\"modal-title\"><b>{{ 'TERMS_AND_CONDITIONS' | translate }}</b></h4>\n                    </div>\n                    <div class=\"modal-body\" style=\"text-align: center; overflow-y: scroll; height: 45em;\" [ngClass]=\"{padding2bottom: imageDelete==0}\">\n                        <button *ngIf=\"imageDelete==0\" type=\"button\" class=\"close\" (click)=\"closeTermsModal()\">&times;</button>\n                        <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_1' | translate }}</p>\n                        <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_2' | translate }}</p>\n                        <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_4' | translate }}</p>\n                        <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_5' | translate }}</p>\n                        <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_6' | translate }}</p>\n                        <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_7' | translate }}</p>\n                        <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_8' | translate }}</p>\n                        <p style=\"text-align: left\"><b>{{ 'TERMS_AND_CONDITIONS_9' | translate }}</b></p>\n                        <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_10' | translate }}</p>\n                        <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_11' | translate }}</p>\n                        <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_12' | translate }}</p>\n                        <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_13' | translate }}</p>\n                        <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_14' | translate }}</p>\n                        <p style=\"text-align: left\"><b>{{ 'TERMS_AND_CONDITIONS_15' | translate }}</b></p>\n                        <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_16' | translate }}</p>\n                        <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_17' | translate }}</p>\n                        <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_18' | translate }}</p>\n                        <p style=\"text-align: left\"><b>{{ 'TERMS_AND_CONDITIONS_19' | translate }}</b></p>\n                        <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_20' | translate }}</p>\n                        <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_21' | translate }}</p>\n                        <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_22' | translate }}</p>\n                        <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_23' | translate }}</p>\n                        <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_24' | translate }}</p>\n                        <p style=\"text-align: left\"><b>{{ 'TERMS_AND_CONDITIONS_25' | translate }}</b></p>\n                        <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_26' | translate }}</p>\n                        <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_27' | translate }}</p>\n                        <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_28' | translate }}</p>\n                        <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_29' | translate }}</p>\n                        <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_30' | translate }}</p>\n                        <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_31' | translate }}</p>\n                        <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_32' | translate }}</p>\n                        <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_33' | translate }}</p>\n                        <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_34' | translate }}</p>\n                        <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_35' | translate }}</p>\n                        <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_36' | translate }}</p>\n                        <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_37' | translate }}</p>\n                        <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_38' | translate }}</p>\n                        <p style=\"text-align: left\"><b>{{ 'TERMS_AND_CONDITIONS_39' | translate }}</b></p>\n                        <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_40' | translate }}</p>\n                        <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_41' | translate }}</p>\n                        <p style=\"text-align: left\"><b>{{ 'TERMS_AND_CONDITIONS_42' | translate }}</b></p>\n                        <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_43' | translate }}</p>\n                    </div>\n                </div>\n            </div>\n        </div>";

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var MainProfileChangeEmailComponent = (function () {
	    function MainProfileChangeEmailComponent() {
	        this.userEmail = new core_1.EventEmitter();
	        this.email = "";
	    }
	    MainProfileChangeEmailComponent.prototype.ngOnInit = function () {
	    };
	    MainProfileChangeEmailComponent.prototype.ngDoCheck = function () {
	        this.userEmail.emit({
	            value: this.email
	        });
	    };
	    MainProfileChangeEmailComponent.prototype.goBack = function () {
	        window.history.back();
	    };
	    __decorate([
	        core_1.Input('invalidEmail'), 
	        __metadata('design:type', Boolean)
	    ], MainProfileChangeEmailComponent.prototype, "wrongEmailChange", void 0);
	    __decorate([
	        core_1.Input('invalidEmailLength'), 
	        __metadata('design:type', Boolean)
	    ], MainProfileChangeEmailComponent.prototype, "wrongEmailLength", void 0);
	    __decorate([
	        core_1.Input('invalidEmailExists'), 
	        __metadata('design:type', Boolean)
	    ], MainProfileChangeEmailComponent.prototype, "wrongEmailExists", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], MainProfileChangeEmailComponent.prototype, "userEmail", void 0);
	    MainProfileChangeEmailComponent = __decorate([
	        core_1.Component({
	            selector: 'main-profile-change-email',
	            template: __webpack_require__(246)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], MainProfileChangeEmailComponent);
	    return MainProfileChangeEmailComponent;
	}());
	exports.MainProfileChangeEmailComponent = MainProfileChangeEmailComponent;


/***/ },
/* 246 */
135,
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var MainProfileChangeEmailPasswordComponent = (function () {
	    function MainProfileChangeEmailPasswordComponent() {
	        this.userPassword = new core_1.EventEmitter();
	        this.passwordType = "password";
	        this.password = "";
	    }
	    MainProfileChangeEmailPasswordComponent.prototype.ngOnInit = function () {
	    };
	    MainProfileChangeEmailPasswordComponent.prototype.ngDoCheck = function () {
	        this.userPassword.emit({
	            value: this.password
	        });
	    };
	    MainProfileChangeEmailPasswordComponent.prototype.onChange = function (flag) {
	        if (!flag) {
	            this.passwordType = "password";
	        }
	        else {
	            this.passwordType = "text";
	        }
	    };
	    MainProfileChangeEmailPasswordComponent.prototype.goBack = function () {
	        window.history.back();
	    };
	    __decorate([
	        core_1.Input('invalidPasswordToChangeEmail'), 
	        __metadata('design:type', Boolean)
	    ], MainProfileChangeEmailPasswordComponent.prototype, "wrongPassword", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], MainProfileChangeEmailPasswordComponent.prototype, "userPassword", void 0);
	    MainProfileChangeEmailPasswordComponent = __decorate([
	        core_1.Component({
	            selector: 'main-profile-change-email-password',
	            template: __webpack_require__(248)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], MainProfileChangeEmailPasswordComponent);
	    return MainProfileChangeEmailPasswordComponent;
	}());
	exports.MainProfileChangeEmailPasswordComponent = MainProfileChangeEmailPasswordComponent;


/***/ },
/* 248 */
137,
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var MainProfileChangePasswordComponent = (function () {
	    function MainProfileChangePasswordComponent() {
	        this.oldUserPassword = new core_1.EventEmitter();
	        this.newUserPassword = new core_1.EventEmitter();
	        this.newPasswordType = "password";
	        this.actualPassword = "";
	        this.newPassword = "";
	    }
	    MainProfileChangePasswordComponent.prototype.ngOnInit = function () {
	    };
	    MainProfileChangePasswordComponent.prototype.ngDoCheck = function () {
	        this.oldUserPassword.emit({
	            value: this.actualPassword
	        });
	        this.newUserPassword.emit({
	            value: this.newPassword
	        });
	    };
	    MainProfileChangePasswordComponent.prototype.onChangeNew = function (flag) {
	        if (!flag) {
	            this.newPasswordType = "password";
	        }
	        else {
	            this.newPasswordType = "text";
	        }
	    };
	    MainProfileChangePasswordComponent.prototype.goBack = function () {
	        window.history.back();
	    };
	    __decorate([
	        core_1.Input('isWrongPassword'), 
	        __metadata('design:type', Boolean)
	    ], MainProfileChangePasswordComponent.prototype, "wrongPassword", void 0);
	    __decorate([
	        core_1.Input('isOldPasswordEmpty'), 
	        __metadata('design:type', Boolean)
	    ], MainProfileChangePasswordComponent.prototype, "oldPasswordEmpty", void 0);
	    __decorate([
	        core_1.Input('isNewPasswordEmptyOrShort'), 
	        __metadata('design:type', Boolean)
	    ], MainProfileChangePasswordComponent.prototype, "newPasswordEmptyOrShort", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], MainProfileChangePasswordComponent.prototype, "oldUserPassword", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], MainProfileChangePasswordComponent.prototype, "newUserPassword", void 0);
	    MainProfileChangePasswordComponent = __decorate([
	        core_1.Component({
	            selector: 'main-profile-change-password',
	            template: __webpack_require__(250)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], MainProfileChangePasswordComponent);
	    return MainProfileChangePasswordComponent;
	}());
	exports.MainProfileChangePasswordComponent = MainProfileChangePasswordComponent;


/***/ },
/* 250 */
139,
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var profile_service_1 = __webpack_require__(243);
	var MainProfileChangeSubroleComponent = (function () {
	    function MainProfileChangeSubroleComponent(_profileService) {
	        this._profileService = _profileService;
	        this.subroleUpdated = new core_1.EventEmitter();
	        this.paymentParams = {
	            "parameters": "",
	            "signature": "",
	            "signatureVersion": "",
	            "id": 0,
	            "code": "",
	            "amount": ""
	        };
	        this.accountType = 0;
	        this.paymentMethod = 0;
	        this.paymentPosted = false;
	        this.printMode = false;
	    }
	    MainProfileChangeSubroleComponent.prototype.ngOnInit = function () {
	    };
	    MainProfileChangeSubroleComponent.prototype.changeAccountType = function (type) {
	        this.accountType = type;
	    };
	    MainProfileChangeSubroleComponent.prototype.submitPayment = function () {
	        if (this.paymentMethod == 1) {
	            this.paymentPosted = true;
	        }
	        else if (this.paymentMethod == 2) {
	        }
	        else {
	        }
	    };
	    MainProfileChangeSubroleComponent.prototype.changePaymentMethod = function (method) {
	        var _this = this;
	        if (this.paymentMethod == 0) {
	            this._profileService.createTransaction(this.accountType, method).then(function (res) {
	                _this.paymentParams.parameters = res.PARAMS;
	                _this.paymentParams.signature = res.SIGNATURE;
	                _this.paymentParams.signatureVersion = res.VERSION;
	                _this.paymentParams.code = res.TRANSACTION_CODE;
	                _this.paymentParams.id = res.TRANSACTION_ID;
	                _this.paymentParams.amount = res.TRANSACTION_AMOUNT;
	                _this.paymentMethod = method;
	            });
	        }
	        else if (method == this.paymentMethod) { }
	        else {
	            this._profileService.updateTransaction(this.paymentParams.id, method).then(function (res) {
	                _this.paymentMethod = method;
	                _this.paymentPosted = false;
	            });
	        }
	    };
	    MainProfileChangeSubroleComponent.prototype.printBankTransfer = function () {
	        this.printMode = !this.printMode;
	    };
	    MainProfileChangeSubroleComponent.prototype.registerFree = function () {
	        var _this = this;
	        this._profileService.registerFree().subscribe(function (result) {
	            if (result == 1) {
	                _this.subroleUpdated.emit({
	                    value: true
	                });
	            }
	            else {
	                _this.subroleUpdated.emit({
	                    value: false
	                });
	            }
	        }, function () { });
	    };
	    MainProfileChangeSubroleComponent.prototype.changeSubscription = function () {
	        this.accountType = 0;
	        this.paymentMethod = 0;
	        this.paymentPosted = false;
	    };
	    __decorate([
	        core_1.Input('subrole'), 
	        __metadata('design:type', Number)
	    ], MainProfileChangeSubroleComponent.prototype, "userSubrole", void 0);
	    __decorate([
	        core_1.Output('subroleUpdated'), 
	        __metadata('design:type', Object)
	    ], MainProfileChangeSubroleComponent.prototype, "subroleUpdated", void 0);
	    MainProfileChangeSubroleComponent = __decorate([
	        core_1.Component({
	            selector: 'main-profile-change-subrole',
	            template: __webpack_require__(252),
	            providers: [profile_service_1.ProfileService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof profile_service_1.ProfileService !== 'undefined' && profile_service_1.ProfileService) === 'function' && _a) || Object])
	    ], MainProfileChangeSubroleComponent);
	    return MainProfileChangeSubroleComponent;
	    var _a;
	}());
	exports.MainProfileChangeSubroleComponent = MainProfileChangeSubroleComponent;


/***/ },
/* 252 */
141,
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var ng2_completer_1 = __webpack_require__(61);
	var user_1 = __webpack_require__(254);
	var profile_service_1 = __webpack_require__(243);
	var cities_1 = __webpack_require__(119);
	var MainProfileEditComponent = (function () {
	    function MainProfileEditComponent(_profileService, _completerService) {
	        this._profileService = _profileService;
	        this.submitProfile = new core_1.EventEmitter();
	        this.nameWrong = new core_1.EventEmitter();
	        this.nifWrong = new core_1.EventEmitter();
	        this.phoneWrong = new core_1.EventEmitter();
	        this.cityWrong = new core_1.EventEmitter();
	        this.addressWrong = new core_1.EventEmitter();
	        this.zipWrong = new core_1.EventEmitter();
	        this.dataService = _completerService.local(cities_1.CITIES, 'name', 'name');
	    }
	    MainProfileEditComponent.prototype.ngOnInit = function () {
	        this.copyUser(this.user);
	    };
	    MainProfileEditComponent.prototype.ngDoCheck = function () {
	        if (!this.userEquals(this.user, this.previousUser)) {
	            // inputSettings changed
	            // some logic here to react to the change
	            this.copyUser(this.user);
	            this.submitProfile.emit({
	                value: this.user
	            });
	        }
	        this.nameWrong.emit({
	            value: this.user.name
	        });
	        this.nifWrong.emit({
	            value: this.user.nif
	        });
	        this.phoneWrong.emit({
	            value: this.user.phone
	        });
	        this.cityWrong.emit({
	            value: this.user.city_name
	        });
	        this.addressWrong.emit({
	            value: this.user.address
	        });
	        this.zipWrong.emit({
	            value: this.user.zip
	        });
	    };
	    MainProfileEditComponent.prototype.goBack = function () {
	        window.history.back();
	    };
	    MainProfileEditComponent.prototype.onCitySelected = function (selected) {
	    };
	    MainProfileEditComponent.prototype.copyUser = function (user) {
	        this.previousUser = Object.assign({}, this.user);
	        /* this.previousUser.id = user.id;
	         this.previousUser.name = user.name;
	         this.previousUser.nif = user.nif;
	         this.previousUser.phone = user.phone;*/
	    };
	    MainProfileEditComponent.prototype.userEquals = function (user1, user2) {
	        return user1.email == user2.email &&
	            user1.name == user2.name &&
	            user1.nif == user2.nif &&
	            user1.phone == user2.phone;
	    };
	    __decorate([
	        core_1.Input('profile-obj'), 
	        __metadata('design:type', (typeof (_a = typeof user_1.User !== 'undefined' && user_1.User) === 'function' && _a) || Object)
	    ], MainProfileEditComponent.prototype, "user", void 0);
	    __decorate([
	        core_1.Input('isNameWrong'), 
	        __metadata('design:type', Boolean)
	    ], MainProfileEditComponent.prototype, "isNameWrong", void 0);
	    __decorate([
	        core_1.Input('isNifWrong'), 
	        __metadata('design:type', Boolean)
	    ], MainProfileEditComponent.prototype, "isNifWrong", void 0);
	    __decorate([
	        core_1.Input('isPhoneWrong'), 
	        __metadata('design:type', Boolean)
	    ], MainProfileEditComponent.prototype, "isPhoneWrong", void 0);
	    __decorate([
	        core_1.Input('isCityWrong'), 
	        __metadata('design:type', Boolean)
	    ], MainProfileEditComponent.prototype, "isCityWrong", void 0);
	    __decorate([
	        core_1.Input('isAddressWrong'), 
	        __metadata('design:type', Boolean)
	    ], MainProfileEditComponent.prototype, "isAddressWrong", void 0);
	    __decorate([
	        core_1.Input('isZipWrong'), 
	        __metadata('design:type', Boolean)
	    ], MainProfileEditComponent.prototype, "isZipWrong", void 0);
	    __decorate([
	        core_1.Output('submit-profile'), 
	        __metadata('design:type', Object)
	    ], MainProfileEditComponent.prototype, "submitProfile", void 0);
	    __decorate([
	        core_1.Output('nameWrong'), 
	        __metadata('design:type', Object)
	    ], MainProfileEditComponent.prototype, "nameWrong", void 0);
	    __decorate([
	        core_1.Output('nifWrong'), 
	        __metadata('design:type', Object)
	    ], MainProfileEditComponent.prototype, "nifWrong", void 0);
	    __decorate([
	        core_1.Output('phoneWrong'), 
	        __metadata('design:type', Object)
	    ], MainProfileEditComponent.prototype, "phoneWrong", void 0);
	    __decorate([
	        core_1.Output('cityWrong'), 
	        __metadata('design:type', Object)
	    ], MainProfileEditComponent.prototype, "cityWrong", void 0);
	    __decorate([
	        core_1.Output('addressWrong'), 
	        __metadata('design:type', Object)
	    ], MainProfileEditComponent.prototype, "addressWrong", void 0);
	    __decorate([
	        core_1.Output('zipWrong'), 
	        __metadata('design:type', Object)
	    ], MainProfileEditComponent.prototype, "zipWrong", void 0);
	    MainProfileEditComponent = __decorate([
	        core_1.Component({
	            selector: 'main-profile-edit',
	            template: __webpack_require__(255),
	            providers: [ng2_completer_1.CompleterService, profile_service_1.ProfileService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof profile_service_1.ProfileService !== 'undefined' && profile_service_1.ProfileService) === 'function' && _b) || Object, (typeof (_c = typeof ng2_completer_1.CompleterService !== 'undefined' && ng2_completer_1.CompleterService) === 'function' && _c) || Object])
	    ], MainProfileEditComponent);
	    return MainProfileEditComponent;
	    var _a, _b, _c;
	}());
	exports.MainProfileEditComponent = MainProfileEditComponent;


/***/ },
/* 254 */
146,
/* 255 */
/***/ function(module, exports) {

	module.exports = "<div *ngIf=\"user\">\n    <div class=\"form-group\">\n        <label for=\"userName\">{{ 'USER_NAME' | translate }}</label>\n        <input type=\"text\" class=\"form-control\" id=\"userName\" [(ngModel)]=\"user.name\" (ngModelChange)=\"user.name\">\n    </div>    \n    <div *ngIf=\"isNameWrong\" class=\"form-group\">\n        <span class=\"login-error-msg\">{{ 'WRONG_NAME' | translate }}</span>\n    </div>\n    <div class=\"form-group\">\n        <label for=\"userNif\">{{ 'DNI' | translate }}</label>\n        <input type=\"text\" class=\"form-control\" id=\"userNif\" [(ngModel)]=\"user.nif\" (ngModelChange)=\"user.nif\">\n    </div>\n    <div *ngIf=\"isNifWrong\" class=\"form-group\">\n        <span class=\"login-error-msg\">{{ 'WRONG_NIF' | translate }}</span>\n    </div>\n    <div class=\"form-group\">\n        <label for=\"userPhone\">{{ 'PHONE' | translate }}</label>\n        <input type=\"text\" class=\"form-control\" id=\"userPhone\" [(ngModel)]=\"user.phone\" (ngModelChange)=\"user.phone\">\n    </div>\n    <div *ngIf=\"isPhoneWrong\" class=\"form-group\">\n        <span class=\"login-error-msg\">{{ 'WRONG_PHONE' | translate }}</span>\n    </div>\n    <div class=\"form-group\">\n        <label for=\"userCity\">{{ 'CITY_FIELD' | translate }}</label>\n        <ng2-completer [datasource]=\"dataService\" [(ngModel)]=\"user.city_name\" [ngModelOptions]=\"{standalone: true}\" (selected)=\"onCitySelected($event)\"\n                            [minSearchLength]=\"2\" [placeholder]=\"('CITY_FIELD' | translate)\" [textNoResults]=\"('CITY_NOT_FOUND' | translate)\" [autoMatch]=\"true\"></ng2-completer>\n        <!--<input type=\"text\" class=\"form-control\" id=\"userCity\" [(ngModel)]=\"user.city_name\" (ngModelChange)=\"user.city_name\">-->\n    </div>\n    <div *ngIf=\"isCityWrong\" class=\"form-group\">\n        <span class=\"login-error-msg\">{{ 'WRONG_CITY' | translate }}</span>\n    </div>\n    <div class=\"form-group\">\n        <label for=\"userAddress\">{{ 'ADDRESS_FIELD' | translate }}</label>\n        <input type=\"text\" class=\"form-control\" id=\"userAddress\" [(ngModel)]=\"user.address\" (ngModelChange)=\"user.address\">\n    </div>\n    <div *ngIf=\"isAddressWrong\" class=\"form-group\">\n        <span class=\"login-error-msg\">{{ 'WRONG_ADDRESS' | translate }}</span>\n    </div>\n    <div class=\"form-group\">\n        <label for=\"userZip\">{{ 'ZIP_FIELD' | translate }}</label>\n        <input type=\"text\" class=\"form-control\" id=\"userZip\" [(ngModel)]=\"user.zip\" (ngModelChange)=\"user.zip\">\n    </div>\n    <div *ngIf=\"isZipWrong\" class=\"form-group\">\n        <span class=\"login-error-msg\">{{ 'WRONG_ZIP' | translate }}</span>\n    </div>\n</div>";

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(76);
	var messages_service_1 = __webpack_require__(257);
	var MainMessagesComponent = (function () {
	    function MainMessagesComponent(_messagesService, _parentRouter) {
	        this._messagesService = _messagesService;
	        this.parentMessages = [];
	        this.readMessages = [];
	        this.unreadMessages = [];
	        this.sendedMessages = [];
	        this.user_id = -1;
	        this.showReceivedMessages = true;
	        this.showSendedMessages = false;
	        this.router = _parentRouter;
	    }
	    MainMessagesComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._messagesService.getParentMessages().then(function (res) {
	            if (res != null) {
	                _this.parentMessages = res.rows;
	                _this.user_id = res.user_id;
	                _this.organizeMessages();
	            }
	        });
	    };
	    MainMessagesComponent.prototype.organizeMessages = function () {
	        var _this = this;
	        for (var i = 0; i < this.parentMessages.length; i++) {
	            this._messagesService.getMessageWithChilds(this.parentMessages[i]).then(function (result) {
	                var message = result[0];
	                message.total_messages_conversation = 1;
	                message.selected = false;
	                _this.setMessageDateFormat(message);
	                //El missatge és rebut
	                if (message.user_receiver_id == _this.user_id) {
	                    if (message.childs.length == 0) {
	                        if (message.read) {
	                            _this.readMessages.push(message);
	                        }
	                        else {
	                            _this.unreadMessages.push(message);
	                        }
	                    }
	                    else {
	                        _this.organizeMessage(message);
	                    }
	                }
	                else if (message.user_sender_id == _this.user_id) {
	                    if (message.childs.length == 0) {
	                        _this.sendedMessages.push(message);
	                    }
	                    else {
	                        _this.organizeMessage(message);
	                    }
	                }
	            });
	        }
	    };
	    MainMessagesComponent.prototype.setMessageDateFormat = function (message) {
	        var messageDate = new Date(message.creation_date);
	        var day = messageDate.getDate().toString();
	        if (day.length < 2) {
	            day = "0" + day;
	        }
	        var month = (messageDate.getMonth() + 1).toString();
	        if (month.length < 2) {
	            month = "0" + month;
	        }
	        var year = messageDate.getFullYear().toString();
	        var hour = messageDate.getHours().toString();
	        if (hour.length < 2) {
	            hour = "0" + hour;
	        }
	        var minute = messageDate.getMinutes().toString();
	        if (minute.length < 2) {
	            minute = "0" + minute;
	        }
	        var seconds = messageDate.getSeconds().toString();
	        if (seconds.length < 2) {
	            seconds = "0" + seconds;
	        }
	        message.date_to_show = day + "/" + month + "/" + year + " - " + hour + ":" + minute + ":" + seconds;
	    };
	    MainMessagesComponent.prototype.organizeMessage = function (message) {
	        var messagesReceived = this.getMessagesReceivedChilds(message);
	        var messagesSended = this.getMessagesSendedChilds(message);
	        message.total_messages_conversation += messagesReceived.length + messagesSended.length;
	        if (messagesReceived.length == 0 && message.user_receiver_id == this.user_id) {
	            if (message.read) {
	                this.readMessages.push(message);
	            }
	            else {
	                this.unreadMessages.push(message);
	            }
	        }
	        else if (messagesReceived.length > 0) {
	            this.sortArrayByMessageDate(messagesReceived);
	            //Aquesta instrucció no serà necessària ja que ens encarregarem que al insertar un missatge fill nou a la base de dades automàticament tingui el title del pare
	            messagesReceived[0].title = message.title;
	            messagesReceived[0].total_messages_conversation = message.total_messages_conversation;
	            if (message.user_sender_id == this.user_id) {
	                messagesReceived[0].user_sender_name = message.user_receiver_name;
	            }
	            else if (message.user_receiver_id == this.user_id) {
	                messagesReceived[0].user_sender_name = message.user_sender_name;
	            }
	            this.setMessageDateFormat(messagesReceived[0]);
	            if (messagesReceived[0].read) {
	                this.readMessages.push(messagesReceived[0]);
	            }
	            else {
	                this.unreadMessages.push(messagesReceived[0]);
	            }
	        }
	        if (messagesSended.length == 0 && message.user_sender_id == this.user_id) {
	            this.sendedMessages.push(message);
	        }
	        else if (messagesSended.length > 0) {
	            this.sortArrayByMessageDate(messagesSended);
	            //Aquesta instrucció no serà necessària ja que ens encarregarem que al insertar un missatge fill nou a la base de dades automàticament tingui el title del pare
	            messagesSended[0].title = message.title;
	            messagesSended[0].total_messages_conversation = message.total_messages_conversation;
	            if (message.user_sender_id == this.user_id) {
	                messagesSended[0].user_receiver_name = message.user_receiver_name;
	            }
	            else if (message.user_receiver_id == this.user_id) {
	                messagesSended[0].user_receiver_name = message.user_sender_name;
	            }
	            this.setMessageDateFormat(messagesSended[0]);
	            this.sendedMessages.push(messagesSended[0]);
	        }
	    };
	    MainMessagesComponent.prototype.getMessagesReceivedChilds = function (message) {
	        var messageChilds = [];
	        for (var i = 0; i < message.childs.length; i++) {
	            message.childs[i].selected = false;
	            if (message.childs[i].user_receiver_id == this.user_id) {
	                messageChilds.push(message.childs[i]);
	            }
	            if (message.childs[i].childs.length > 0) {
	                messageChilds = messageChilds.concat(this.getMessagesReceivedChilds(message.childs[i]));
	            }
	        }
	        return messageChilds;
	    };
	    MainMessagesComponent.prototype.getMessagesSendedChilds = function (message) {
	        var messageChilds = [];
	        for (var i = 0; i < message.childs.length; i++) {
	            message.childs[i].selected = false;
	            if (message.childs[i].user_sender_id == this.user_id) {
	                messageChilds.push(message.childs[i]);
	            }
	            if (message.childs[i].childs.length > 0) {
	                messageChilds = messageChilds.concat(this.getMessagesSendedChilds(message.childs[i]));
	            }
	        }
	        return messageChilds;
	    };
	    MainMessagesComponent.prototype.sortArrayByMessageDate = function (array) {
	        array.sort(function (a, b) {
	            return new Date(b.creation_date).getTime() - new Date(a.creation_date).getTime();
	        });
	    };
	    MainMessagesComponent.prototype.changeToReceivedMessages = function () {
	        this.showReceivedMessages = true;
	        this.showSendedMessages = false;
	    };
	    MainMessagesComponent.prototype.changeToSendedMessages = function () {
	        this.showReceivedMessages = false;
	        this.showSendedMessages = true;
	    };
	    //Section 0: Read Message
	    //Section 1: Unread Message
	    //Section 2: Sended Message
	    MainMessagesComponent.prototype.messageClicked = function (message, message_section) {
	        this.router.navigate(['/main', 'message', { mainId: message.main_parent_id, section: message_section }]);
	    };
	    MainMessagesComponent.prototype.backClicked = function () {
	        this.router.navigate(['/main', 'dashboard']);
	    };
	    MainMessagesComponent = __decorate([
	        core_1.Component({
	            selector: 'messages',
	            template: __webpack_require__(258),
	            providers: [messages_service_1.MessagesService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof messages_service_1.MessagesService !== 'undefined' && messages_service_1.MessagesService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object])
	    ], MainMessagesComponent);
	    return MainMessagesComponent;
	    var _a, _b;
	}());
	exports.MainMessagesComponent = MainMessagesComponent;


/***/ },
/* 257 */
125,
/* 258 */
/***/ function(module, exports) {

	module.exports = "<div class=\"col-xs-12 col-md-12\" style=\"height: 100%;\">\n        <div class=\"col-xs-12\">\n            <div class=\"col-xs-6\">\n                <!--<button class=\"selectedButton\">{{'SEND'|translate}}</button>-->\n                <button [ngClass]=\"{selectedButton: showReceivedMessages, notSelectedButton: !showReceivedMessages}\" (click)=\"changeToReceivedMessages()\">{{'RECEIVEDS'|translate}}</button>\n                <button [ngClass]=\"{selectedButton: showSendedMessages, notSelectedButton: !showSendedMessages}\" (click)=\"changeToSendedMessages()\">{{'SENDS'|translate}}</button>\n            </div>\n            <div class=\"col-xs-6\" style=\"text-align: right\">\n                <button [ngClass]=\"selectedButton\" (click)=\"backClicked()\">{{'BACK'|translate}}</button>\n            </div>\n        </div>\n\n        <div *ngIf=\"showReceivedMessages\" class=\"col-xs-12 messageBlock\">\n            <div class=\"messageBlockHead col-xs-12\" style=\"padding: 0;\">\n                <div class=\"messageBlockHeadColor col-xs-6 col-xs-offset-6\">\n                    <h4 class=\"messageBlockHeadColorTitle\" style=\"display: inline; font-size: 1.2em;\">{{ 'NO_READS' | translate }}</h4>\n                </div>\n            </div>\n            <div *ngFor=\"let message of unreadMessages\" class=\"col-xs-12 messageBlockBodyRead clickable\" style=\"padding: 0;\" (click)=\"messageClicked(message, 1)\">\n                <div class=\"col-xs-12\" style=\"padding: 0;\">\n                    <div class=\"col-xs-6\" style=\"text-align: left;\">\n                        <label class=\"messageBlockLabelNormal\">{{message.user_sender_name}}</label>\n                    </div>\n                    <div class=\"col-xs-6\" style=\"text-align: right;\">\n                        <label class=\"messageBlockLabelSmall\">{{message.date_to_show}}</label>\n                    </div>\n                </div>\n                <div class=\"col-xs-12\" style=\"padding-left: 3em;\">\n                    <div style=\"float: left; padding-right: 1em;\">\n                        <label class=\"messageBlockLabelNormal\" *ngIf=\"message.total_messages_conversation > 1\">&nbsp;({{message.total_messages_conversation}})</label>\n                        <label class=\"messageBlockLabelHigh\">{{message.title}}</label>\n                    </div>\n                    <div style=\"float: left\">\n                        <label class=\"messageBlockLabelNormal\" *ngIf=\"message.content.length > 30\">{{message.content.substr(0,30)}}...</label>\n                        <label class=\"messageBlockLabelNormal\" *ngIf=\"message.content.length <= 30\">{{message.content}}</label>\n                    </div>\n\n                </div>\n            </div>\n        </div>\n\n        <div *ngIf=\"showReceivedMessages\" class=\"col-xs-12 messageBlock\" style=\"margin-top: 2em;\">\n            <div class=\"messageBlockHead col-xs-12\" style=\"padding: 0;\">\n                <div class=\"messageBlockHeadColor col-xs-6 col-xs-offset-6\">\n                    <h4 class=\"messageBlockHeadColorTitle\" style=\"display: inline; font-size: 1.2em;\">{{ 'READS' | translate }}</h4>\n                </div>\n            </div>\n            <div *ngFor=\"let message of readMessages\" class=\"col-xs-12 messageBlockBody clickable\" style=\"padding: 0;\" (click)=\"messageClicked(message, 0)\">\n                <div class=\"col-xs-12\" style=\"padding: 0;\">\n                    <div class=\"col-xs-6\" style=\"text-align: left;\">\n                        <label class=\"messageBlockLabelNormal\">{{message.user_sender_name}}</label>\n                    </div>\n                    <div class=\"col-xs-6\" style=\"text-align: right;\">\n                        <label class=\"messageBlockLabelSmall\">{{message.date_to_show}}</label>\n                    </div>\n                </div>\n                <div class=\"col-xs-12\" style=\"padding-left: 3em;\">\n                    <div style=\"float: left; padding-right: 1em;\">\n                        <label class=\"messageBlockLabelNormal\" *ngIf=\"message.total_messages_conversation > 1\">&nbsp;({{message.total_messages_conversation}})</label>\n                        <label class=\"messageBlockLabelHigh\">{{message.title}}</label>\n                    </div>\n                    <div style=\"float: left\">\n                        <label class=\"messageBlockLabelNormal\" *ngIf=\"message.content.length > 30\">{{message.content.substr(0,30)}}...</label>\n                        <label class=\"messageBlockLabelNormal\" *ngIf=\"message.content.length <= 30\">{{message.content}}</label>\n                    </div>\n\n                </div>\n            </div>\n        </div>\n\n        <div *ngIf=\"showSendedMessages\" class=\"col-xs-12 messageBlock\">\n            <div class=\"messageBlockHead col-xs-12\" style=\"padding: 0;\">\n                <div class=\"messageBlockHeadColor col-xs-6 col-xs-offset-6\">\n                    <h4 class=\"messageBlockHeadColorTitle\" style=\"display: inline; font-size: 1.2em;\">{{ 'SENDS' | translate }}</h4>\n                </div>\n            </div>\n            <div *ngFor=\"let message of sendedMessages\" class=\"col-xs-12 messageBlockBodyRead clickable\" style=\"padding: 0;\" (click)=\"messageClicked(message, 2)\">\n                <div class=\"col-xs-12\" style=\"padding: 0;\">\n                    <div class=\"col-xs-6\" style=\"text-align: left;\">\n                        <label class=\"messageBlockLabelNormal\">{{message.user_receiver_name}}</label>\n                    </div>\n                    <div class=\"col-xs-6\" style=\"text-align: right;\">\n                        <label class=\"messageBlockLabelSmall\">{{message.date_to_show}}</label>\n                    </div>\n                </div>\n                <div class=\"col-xs-12\" style=\"padding-left: 3em;\">\n                    <div style=\"float: left; padding-right: 1em;\">\n                        <label class=\"messageBlockLabelNormal\" *ngIf=\"message.total_messages_conversation > 1\">&nbsp;({{message.total_messages_conversation}})</label>\n                        <label class=\"messageBlockLabelHigh\">{{message.title}}</label>\n                    </div>\n                    <div style=\"float: left\">\n                        <label class=\"messageBlockLabelNormal\" *ngIf=\"message.content.length > 30\">{{message.content.substr(0,30)}}...</label>\n                        <label class=\"messageBlockLabelNormal\" *ngIf=\"message.content.length <= 30\">{{message.content}}</label>\n                    </div>\n\n                </div>\n            </div>\n        </div>\n    </div>";

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(76);
	var messages_service_1 = __webpack_require__(257);
	var MainMessageDetailComponent = (function () {
	    function MainMessageDetailComponent(_messagesService, route, _parentRouter) {
	        this._messagesService = _messagesService;
	        this.route = route;
	        this.main_message = { "id": Number(route.snapshot.params['mainId']), "title": "", "content": "", "creation_date": "", "date_to_show": "", "read": false, "user_sender_id": 0,
	            "user_sender_name": "", "user_receiver_id": 0, "user_receiver_name": "", "message_parent_id": 0, "childs": [], "total_messages_conversation": 0,
	            "main_parent_id": 0, "selected": false };
	        this.messages = [];
	        this.iluminatedMessages = [];
	        this.section = Number(route.snapshot.params['section']);
	        this.user_id = Number(localStorage.getItem("idUser"));
	        this.router = _parentRouter;
	    }
	    MainMessageDetailComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._messagesService.getMessageWithChilds(this.main_message).then(function (result) {
	            _this.main_message = result[0];
	            _this.organizeMessages(_this.main_message);
	            _this.sortArrayByMessageId(_this.messages);
	            _this.organizeSection(_this.section);
	        });
	    };
	    MainMessageDetailComponent.prototype.organizeMessages = function (message) {
	        this.setMessageDateFormat(message);
	        message.selected = false;
	        this.messages.push(message);
	        if (message.childs.length > 0) {
	            for (var i = 0; i < message.childs.length; i++) {
	                this.organizeMessages(message.childs[i]);
	            }
	        }
	    };
	    MainMessageDetailComponent.prototype.setMessageDateFormat = function (message) {
	        var messageDate = new Date(message.creation_date);
	        var day = messageDate.getDate().toString();
	        if (day.length < 2) {
	            day = "0" + day;
	        }
	        var month = (messageDate.getMonth() + 1).toString();
	        if (month.length < 2) {
	            month = "0" + month;
	        }
	        var year = messageDate.getFullYear().toString();
	        var hour = messageDate.getHours().toString();
	        if (hour.length < 2) {
	            hour = "0" + hour;
	        }
	        var minute = messageDate.getMinutes().toString();
	        if (minute.length < 2) {
	            minute = "0" + minute;
	        }
	        var seconds = messageDate.getSeconds().toString();
	        if (seconds.length < 2) {
	            seconds = "0" + seconds;
	        }
	        message.date_to_show = day + "/" + month + "/" + year + " - " + hour + ":" + minute + ":" + seconds;
	    };
	    MainMessageDetailComponent.prototype.sortArrayByMessageId = function (array) {
	        array.sort(function (a, b) {
	            return a.id - b.id;
	        });
	    };
	    MainMessageDetailComponent.prototype.organizeSection = function (section) {
	        var _this = this;
	        //Read messages
	        if (section == 0) {
	            this.messages[this.messages.length - 1].selected = true;
	        }
	        else if (section == 1) {
	            for (var i = 0; i < this.messages.length; i++) {
	                if (this.messages[i].user_receiver_id == this.user_id && !this.messages[i].read) {
	                    this.messages[i].selected = true;
	                }
	            }
	            this._messagesService.putMessagesRead(this.main_message).then(function (result) {
	                if (result == 1) {
	                    _this.putMessagesRead(_this.messages);
	                }
	            });
	        }
	        else if (section == 2) {
	            for (var i = 0; i < this.messages.length; i++) {
	                if (this.messages[i].user_sender_id == this.user_id) {
	                    this.messages[i].selected = true;
	                }
	            }
	        }
	    };
	    MainMessageDetailComponent.prototype.putMessagesRead = function (messages) {
	        for (var i = 0; i < messages.length; i++) {
	            if (messages[i].user_receiver_id == this.user_id && !messages[i].read) {
	                messages[i].read = true;
	                this.iluminatedMessages.push(messages[i]);
	            }
	        }
	    };
	    MainMessageDetailComponent.prototype.goBack = function () {
	        this.router.navigate(['/main', 'messages']);
	    };
	    MainMessageDetailComponent.prototype.getColor = function (message) {
	        if (this.arrayContains(this.iluminatedMessages, message)) {
	            return "#6fb3cb";
	        }
	    };
	    MainMessageDetailComponent.prototype.arrayContains = function (array, object) {
	        for (var i = 0; i < array.length; i++) {
	            if (array[i] == object) {
	                return true;
	            }
	        }
	        return false;
	    };
	    MainMessageDetailComponent.prototype.messageClicked = function (message) {
	        if (message.selected) {
	            message.selected = false;
	        }
	        else {
	            message.selected = true;
	        }
	        if (this.arrayContains(this.iluminatedMessages, message)) {
	            var index = this.iluminatedMessages.indexOf(message);
	            this.iluminatedMessages.splice(index, 1);
	        }
	    };
	    MainMessageDetailComponent.prototype.sendMessage = function () {
	        var _this = this;
	        if (!this.isTextEmpty(this.textAreaContent)) {
	            if (this.user_id == this.main_message.user_sender_id) {
	                var userSenderId = this.main_message.user_sender_id;
	                var userReceiverId = this.main_message.user_receiver_id;
	                var userSenderName = this.main_message.user_sender_name;
	                var userReceiverName = this.main_message.user_receiver_name;
	            }
	            else {
	                var userSenderId = this.main_message.user_receiver_id;
	                var userReceiverId = this.main_message.user_sender_id;
	                var userSenderName = this.main_message.user_receiver_name;
	                var userReceiverName = this.main_message.user_sender_name;
	            }
	            var message = { "id": 0, "title": this.main_message.title, "content": this.textAreaContent, "creation_date": "", "date_to_show": "", "read": false,
	                "user_sender_id": userSenderId, "user_sender_name": userSenderName, "user_receiver_id": userReceiverId, "user_receiver_name": userReceiverName,
	                "message_parent_id": 0, "childs": [], "total_messages_conversation": 0, "main_parent_id": this.main_message.id, "selected": false };
	            this._messagesService.postMessage(message).then(function (result) {
	                if (result.code == 1) {
	                    _this.addMessage(result.insertId).then(function (data_void) {
	                        _this.sortArrayByMessageId(_this.messages);
	                        _this.textAreaContent = "";
	                    });
	                }
	            });
	        }
	    };
	    MainMessageDetailComponent.prototype.isTextEmpty = function (text) {
	        if (text == null || text == undefined || text == "") {
	            return true;
	        }
	        else {
	            var trim = text.replace(/ /g, "");
	            var trim = trim.replace(/\n/g, "");
	            if (trim == "") {
	                return true;
	            }
	            else {
	                return false;
	            }
	        }
	    };
	    MainMessageDetailComponent.prototype.addMessage = function (id) {
	        var _this = this;
	        return this._messagesService.getMessageById(id).then(function (result) {
	            var message = result[0];
	            _this.setMessageDateFormat(message);
	            message.selected = false;
	            message.childs = [];
	            _this.messages.push(message);
	        });
	    };
	    MainMessageDetailComponent = __decorate([
	        core_1.Component({
	            selector: 'message',
	            template: __webpack_require__(260),
	            providers: [messages_service_1.MessagesService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof messages_service_1.MessagesService !== 'undefined' && messages_service_1.MessagesService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object])
	    ], MainMessageDetailComponent);
	    return MainMessageDetailComponent;
	    var _a, _b, _c;
	}());
	exports.MainMessageDetailComponent = MainMessageDetailComponent;


/***/ },
/* 260 */
/***/ function(module, exports) {

	module.exports = "\n        <div class=\"col-xs-12 col-md-12\" style=\"border-left: 1px solid #6fb3cb; height: 100%;\">\n            <div style=\"margin-bottom: 1em\">\n                <button class=\"selectedButton\" (click)=\"goBack()\">{{'BACK'|translate}}</button>\n            </div>\n            <div class=\"messageBlockHead col-xs-12\" style=\"padding: 0;\">\n                <div class=\"messageBlockHeadColor col-xs-6\">\n                    <h4 class=\"messageBlockHeadColorTitle\" style=\"display: inline; font-size: 1.2em;\">{{main_message.title}}</h4>\n                </div>\n            </div>\n             <div *ngFor=\"let message of messages\" [ngClass]=\"{messageSelected: message.selected}\" class=\"col-xs-12 message clickable\" (click)=\"messageClicked(message)\">\n                <div *ngIf=\"!message.selected\" class=\"clickable\">                    \n                    <div class=\"col-xs-12\" style=\"padding: 0;\">                        \n                        <div class=\"col-xs-6\" style=\"text-align: left;\">\n                            <span *ngIf=\"message.user_sender_id == user_id\" class=\"glyphicon glyphicon-menu-up big-glyphicon\" style=\"color: red; float: left; width: 1em; margin-top: 0.17em;\"></span>\n                            <span *ngIf=\"message.user_receiver_id == user_id\" class=\"glyphicon glyphicon-menu-down big-glyphicon\" style=\"color: green; float: left; width: 1em; margin-top: 0.17em;\"></span>\n                            <label class=\"messageBlockLabelNormal\" style=\"margin-left: 0.7em;\">{{message.user_sender_name}}</label>\n                        </div>\n                        <div class=\"col-xs-6\" style=\"text-align: right;\">\n                            <label class=\"messageBlockLabelSmall\">{{message.date_to_show}}</label>\n                        </div>\n                    </div>\n                    <div class=\"col-xs-12\" style=\"padding-left: 3em;\">\n                        <div>\n                            <label class=\"messageBlockLabelNormal\" *ngIf=\"message.content.length > 120\">{{message.content.substr(0,120)}}...</label>\n                            <label class=\"messageBlockLabelNormal\" *ngIf=\"message.content.length <= 120\">{{message.content}}</label>\n                        </div>\n\n                    </div>  \n                </div> \n\n                <div *ngIf=\"message.selected\" class=\"clickable\">                    \n                    <div class=\"col-xs-12\" style=\"padding: 0;\">                        \n                        <div class=\"col-xs-6\" style=\"text-align: left;\">\n                            <span *ngIf=\"message.user_sender_id == user_id\" class=\"glyphicon glyphicon-menu-up big-glyphicon\" style=\"color: red; float: left; width: 1em; margin-top: 0.17em;\"></span>\n                            <span *ngIf=\"message.user_receiver_id == user_id\" class=\"glyphicon glyphicon-menu-down big-glyphicon\" style=\"color: green; float: left; width: 1em; margin-top: 0.17em;\"></span>\n                            <label class=\"messageBlockLabelNormal\" style=\"margin-left: 0.7em;\">{{message.user_sender_name}}</label>\n                        </div>\n                        <div class=\"col-xs-6\" style=\"text-align: right;\">\n                            <label class=\"messageBlockLabelSmall\">{{message.date_to_show}}</label>\n                        </div>\n                    </div>\n                    <div class=\"col-xs-12\" style=\"padding-left: 3em;\">\n                        <div>\n                            <label class=\"messageBlockLabelNormal\">{{message.content}}</label>\n                        </div>\n                    </div>\n                </div>     \n            </div>   \n            <textarea maxlength=\"1000\" class=\"col-xs-12\" style=\"margin-top: 1em; margin-bottom: 0.5em; height: 8em; resize: none; color: grey;\" [(ngModel)]=\"textAreaContent\"></textarea>\n            <div class=\"col-xs-12\" style=\"margin-bottom: 1em; text-align: left; padding-left: 0em;\">\n                <button class=\"selectedButton\" (click)=\"sendMessage()\">{{'SEND'|translate}}</button>\n            </div>                          \n        </div>";

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(76);
	var favorites_service_1 = __webpack_require__(262);
	var MainFavoritesComponent = (function () {
	    function MainFavoritesComponent(_favoritesService, _parentRouter) {
	        this._favoritesService = _favoritesService;
	        this.router = _parentRouter;
	    }
	    MainFavoritesComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._favoritesService.getFavoritesSellersByUser().then(function (result) {
	            _this.sellers = result;
	        });
	        this._favoritesService.getFavoritesArtisansByUser().then(function (result) {
	            _this.artisans = result;
	        });
	    };
	    MainFavoritesComponent.prototype.favoriteClicked = function (element) {
	        this.router.navigate(['/main', 'elementdetail', { elementId: element.id }]);
	    };
	    MainFavoritesComponent.prototype.backClicked = function () {
	        this.router.navigate(['/main', 'dashboard']);
	    };
	    MainFavoritesComponent = __decorate([
	        core_1.Component({
	            selector: 'favorites',
	            providers: [favorites_service_1.FavoritesService],
	            template: __webpack_require__(263),
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof favorites_service_1.FavoritesService !== 'undefined' && favorites_service_1.FavoritesService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object])
	    ], MainFavoritesComponent);
	    return MainFavoritesComponent;
	    var _a, _b;
	}());
	exports.MainFavoritesComponent = MainFavoritesComponent;


/***/ },
/* 262 */
152,
/* 263 */
/***/ function(module, exports) {

	module.exports = "<div style=\"height: 100%;\">\n        <div class=\"col-xs-12\">\n            <div class=\"col-xs-6\">\n                <!--<button class=\"selectedButton\">{{'SEND'|translate}}</button>-->\n                <button [ngClass]=\"selectedButton\" (click)=\"backClicked()\">{{'BACK'|translate}}</button>\n                \n            </div>\n            <div class=\"col-xs-6\" style=\"text-align: right\">\n                \n            </div>\n        </div>\n    <!--Venedors-->\n    <div class=\"col-xs-12 col-md-12\" style=\" padding-bottom: 2em;\">\n        <div class=\"messageBlockHead col-xs-12\" style=\"padding: 0;\">\n                <div class=\"messageBlockHeadColor col-xs-6 col-xs-offset-6\">\n                    <h4 class=\"messageBlockHeadColorTitle\" style=\"display: inline; font-size: 1.2em;\">{{ 'SELLERS' | translate }}</h4>\n                </div>\n            </div>\n            <div *ngFor=\"let seller of sellers\" class=\"col-xs-12 messageBlockBody clickable\" style=\"padding: 0;\" (click)=\"favoriteClicked(seller)\">\n                <div class=\"col-xs-12\" style=\"padding-left: 3em;\">\n                    <div style=\"float: left; padding-right: 1em;\">\n                        <label class=\"messageBlockLabelNormal\" style=\"padding-right: 1.3em\">{{seller.id_visible}}</label>\n                        <label class=\"messageBlockLabelHigh\">{{seller.comercial_name}}</label>\n                    </div>\n                    <div style=\"float: left\" *ngIf=\"seller.description\">\n                        <label class=\"messageBlockLabelNormal\" *ngIf=\"seller.description.length > 50\">{{seller.description.substr(0,50)}}...</label>\n                        <label class=\"messageBlockLabelNormal\" *ngIf=\"seller.description.length <= 50\">{{seller.description}}</label>\n                    </div>\n\n                </div>\n            </div>\n    </div>\n    <!--artisans-->    \n    <div class=\"col-xs-12 col-md-12\">\n        <div class=\"messageBlockHead col-xs-12\" style=\"padding: 0;\">\n                <div class=\"messageBlockHeadColor col-xs-6 col-xs-offset-6\">\n                    <h4 class=\"messageBlockHeadColorTitle\" style=\"display: inline; font-size: 1.2em;\">{{ 'ARTISANS' | translate }}</h4>\n                </div>\n            </div>\n            <div *ngFor=\"let artisan of artisans\" class=\"col-xs-12 messageBlockBody clickable\" style=\"padding: 0;\" (click)=\"favoriteClicked(artisan)\">\n                <div class=\"col-xs-12\" style=\"padding-left: 3em;\">\n                    <div style=\"float: left; padding-right: 1em;\">\n                        <label class=\"messageBlockLabelNormal\" style=\"padding-right: 1.3em\">{{artisan.id_visible}}</label>\n                        <label class=\"messageBlockLabelHigh\">{{artisan.comercial_name}}</label>\n                    </div>\n                    <div style=\"float: left\" *ngIf=\"artisan.description\">\n                        <label class=\"messageBlockLabelNormal\" *ngIf=\"artisan.description.length > 50\">{{artisan.description.substr(0,50)}}...</label>\n                        <label class=\"messageBlockLabelNormal\" *ngIf=\"artisan.description.length <= 50\">{{artisan.description}}</label>\n                    </div>\n                </div>\n          </div>\n    </div> \n</div>";

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var common_1 = __webpack_require__(22);
	var router_1 = __webpack_require__(76);
	var ng2_completer_1 = __webpack_require__(61);
	var start_service_1 = __webpack_require__(265);
	var cities_1 = __webpack_require__(119);
	var information_1 = __webpack_require__(266);
	var SuperUserStartComponent = (function () {
	    function SuperUserStartComponent(_startService, _completerService, location, _parentRouter) {
	        this._startService = _startService;
	        this._completerService = _completerService;
	        this.errorCodes = [];
	        this.showTerms = false;
	        this.search_city = "Ciutat";
	        this.city_not_found = "Ciutat no trobada";
	        this.model = new information_1.Information("", "", "", "", "");
	        this.paymentParams = {
	            "parameters": "",
	            "signature": "",
	            "signatureVersion": "",
	            "id": 0,
	            "code": "",
	            "amount": ""
	        };
	        this.router = _parentRouter;
	        this.emailValidation = false;
	        this.userProperties = false;
	        this.dataService = this._completerService.local(cities_1.CITIES, 'name', 'name');
	        this.accountType = 0;
	        this.paymentMethod = 0;
	        this.paymentPosted = false;
	        this.printMode = false;
	        this.category = 0;
	        this.classMapModal = { 'model': true, 'show': false, 'hide': true };
	    }
	    SuperUserStartComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._startService.userProperties().then(function (data) {
	            if (data.active == 1) {
	                _this.router.navigate(['/superuser', 'dashboard']);
	            }
	            _this.emailValidation = (data.email_active == 1);
	            _this.userProperties = (data.info == 1);
	            _this.paymentValidation = (data.payment == 1 || data.payment == 2 || data.payment == 3);
	            _this.conditionsValidation = (data.terms == 1);
	        });
	    };
	    SuperUserStartComponent.prototype.onCitySelected = function (selected) {
	        this.citySelected = selected.originalObject.id;
	    };
	    SuperUserStartComponent.prototype.acceptTerms = function (event) {
	        var _this = this;
	        this._startService.acceptTerms().then(function (data) { _this.conditionsValidation = true; });
	    };
	    SuperUserStartComponent.prototype.resendEmail = function () {
	        var _this = this;
	        this._startService.resendEmail().then(function (data) { _this.emailSent = true; });
	    };
	    SuperUserStartComponent.prototype.changeAccountType = function (type) {
	        this.accountType = type;
	    };
	    SuperUserStartComponent.prototype.changePaymentMethod = function (method) {
	        var _this = this;
	        if (this.paymentMethod == 0) {
	            this._startService.createTransaction(this.accountType, method).then(function (res) {
	                _this.paymentParams.parameters = res.PARAMS;
	                _this.paymentParams.signature = res.SIGNATURE;
	                _this.paymentParams.signatureVersion = res.VERSION;
	                _this.paymentParams.code = res.TRANSACTION_CODE;
	                _this.paymentParams.id = res.TRANSACTION_ID;
	                _this.paymentParams.amount = res.TRANSACTION_AMOUNT;
	                _this.paymentMethod = method;
	            });
	        }
	        else if (method == this.paymentMethod) { }
	        else {
	            this._startService.updateTransaction(this.paymentParams.id, method).then(function (res) {
	                _this.paymentMethod = method;
	            });
	        }
	    };
	    SuperUserStartComponent.prototype.submitPayment = function () {
	        if (this.paymentMethod == 1) {
	            this.paymentPosted = true;
	        }
	        else if (this.paymentMethod == 2) {
	        }
	        else {
	        }
	    };
	    SuperUserStartComponent.prototype.onSubmit = function (value) {
	        var _this = this;
	        var cities = cities_1.CITIES.filter(function (city) { return city.name.toLowerCase() == value.city.toLowerCase(); });
	        if (cities.length != 0 && cities[0] !== undefined && cities[0] !== null) {
	            value.city = cities[0].name;
	            value.city_id = cities[0].id;
	            this.citySelected = cities[0].id;
	        }
	        value.category = this.category;
	        if (this.checkParams(value)) {
	            if (value.email != "") {
	                this._startService.existsEmail(value.email).then(function (res) {
	                    if (!res) {
	                        _this.errorCodes.push(552);
	                    }
	                    else {
	                        _this.submitInformation(value);
	                    }
	                });
	            }
	            else {
	                this.submitInformation(value);
	            }
	        }
	    };
	    SuperUserStartComponent.prototype.submitInformation = function (value) {
	        var _this = this;
	        this._startService.postInformation(value)
	            .subscribe(function (result) {
	            if (result == 1) {
	                _this.userProperties = true;
	            }
	        }, function () { });
	    };
	    SuperUserStartComponent.prototype.codeError = function (code) {
	        var found = false;
	        var i = 0;
	        while (!found && i < this.errorCodes.length) {
	            if (code == this.errorCodes[i]) {
	                found = true;
	            }
	            i++;
	        }
	        return found;
	    };
	    SuperUserStartComponent.prototype.checkParams = function (value) {
	        var _this = this;
	        this.errorCodes = [];
	        //email check
	        if (value.phone.length === 0) {
	            this.errorCodes.push(543);
	        }
	        else if (!this.validPhone(value.phone)) {
	            this.errorCodes.push(544);
	        }
	        if (value.address.length === 0) {
	            this.errorCodes.push(545);
	        }
	        else if (value.address.length < 5) {
	            this.errorCodes.push(546);
	        }
	        else if (value.address.length > 120) {
	            this.errorCodes.push(547);
	        }
	        if (value.zip.length === 0) {
	            this.errorCodes.push(548);
	        }
	        else if (!this.validZip(value.zip)) {
	            this.errorCodes.push(549);
	        }
	        if (value.city.length === 0) {
	            this.errorCodes.push(550);
	        }
	        else if (!this.existsCity(value.city)) {
	            this.errorCodes.push(551);
	        }
	        console.log(value.category);
	        if (value.category == 0) {
	            this.errorCodes.push(553);
	        }
	        if (this.errorCodes.length > 0) {
	            if (value.email != "") {
	                this._startService.existsEmail(value.email).then(function (res) {
	                    if (!res) {
	                        _this.errorCodes.push(552);
	                    }
	                });
	            }
	        }
	        return this.errorCodes.length === 0;
	    };
	    SuperUserStartComponent.prototype.registerFree = function () {
	        var _this = this;
	        this._startService.registerFree()
	            .subscribe(function (result) {
	            if (result == 1) {
	                _this.paymentValidation = true;
	            }
	        }, function () { });
	    };
	    SuperUserStartComponent.prototype.validPhone = function (phone) {
	        var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{3,6}$/im;
	        var re2 = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{2}[-\s\.]?[0-9]{2}[-\s\.]?[0-9]{2}$/im;
	        return re.test(phone) || re2.test(phone);
	    };
	    SuperUserStartComponent.prototype.existsCity = function (city) {
	        for (var i = 0; i < cities_1.CITIES.length; i++) {
	            if (cities_1.CITIES[i].id == this.citySelected) {
	                if (cities_1.CITIES[i].name == city)
	                    return true;
	                else
	                    return false;
	            }
	        }
	        return false;
	    };
	    SuperUserStartComponent.prototype.validZip = function (zip) {
	        var re = /^[\+]?[(]?[0-9]{5}$/im;
	        return re.test(zip);
	    };
	    SuperUserStartComponent.prototype.changeCategory = function (category) {
	        this.category = category;
	    };
	    SuperUserStartComponent.prototype.printBankTransfer = function () {
	        this.printMode = !this.printMode;
	    };
	    SuperUserStartComponent.prototype.enterDashboard = function () {
	        var _this = this;
	        this._startService.enterDashboard().then(function (res) {
	            if (res) {
	                _this.router.navigate(['/superuser', 'dashboard']);
	            }
	        });
	    };
	    SuperUserStartComponent.prototype.showTermsF = function () {
	        if (!this.classMapModal.show) {
	            this.classMapModal.show = true;
	            this.classMapModal.hide = false;
	        }
	        else {
	            this.classMapModal.show = false;
	            this.classMapModal.hide = true;
	        }
	    };
	    SuperUserStartComponent.prototype.closeModal = function () {
	        this.showTermsF();
	    };
	    SuperUserStartComponent = __decorate([
	        core_1.Component({
	            selector: 'start',
	            template: __webpack_require__(267),
	            providers: [ng2_completer_1.CompleterService, start_service_1.StartService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof start_service_1.StartService !== 'undefined' && start_service_1.StartService) === 'function' && _a) || Object, (typeof (_b = typeof ng2_completer_1.CompleterService !== 'undefined' && ng2_completer_1.CompleterService) === 'function' && _b) || Object, (typeof (_c = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object])
	    ], SuperUserStartComponent);
	    return SuperUserStartComponent;
	    var _a, _b, _c, _d;
	}());
	exports.SuperUserStartComponent = SuperUserStartComponent;


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(30);
	var json = __webpack_require__(95);
	var StartService = (function () {
	    function StartService(http) {
	        this.http = http;
	        this._profileUrl = "/profileData";
	        this._userStatusUrl = "/loginData/userStatus";
	        this.serverURL = json.api_url;
	    }
	    StartService.prototype.emailValidated = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        authHeader.append('Authorization', 'Bearer ' + token);
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.get(this.serverURL + this._userStatusUrl, options)
	            .toPromise()
	            .then(function (res) {
	            console.log(JSON.parse(res.text()).active);
	            if (JSON.parse(res.text()).code != -1) {
	                return JSON.parse(res.text()).active != 2;
	            }
	            else {
	                return false;
	            }
	        });
	    };
	    StartService.prototype.userProperties = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        if (token) {
	            authHeader.append('Authorization', 'Bearer ' + token);
	        }
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.get(this.serverURL + this._profileUrl, options)
	            .toPromise()
	            .then(function (res) { return JSON.parse(res.text()).row[0]; })
	            .catch(this.handleError);
	    };
	    StartService.prototype.acceptTerms = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        authHeader.append('Authorization', 'Bearer ' + token);
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.get(this.serverURL + '/start/termsValidation', options)
	            .toPromise()
	            .then(function (res) {
	            if (JSON.parse(res.text()).code == -1) {
	                return JSON.parse(res.text()).active != 2;
	            }
	            else {
	                return false;
	            }
	        });
	    };
	    StartService.prototype.createTransaction = function (accountType, method) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        authHeader.append('Authorization', 'Bearer ' + token);
	        return this.http.post(this.serverURL + '/transactions/createTransaction', this.serializeObj({ "accountType": accountType, "method": method }), {
	            headers: authHeader
	        })
	            .toPromise()
	            .then(function (res) {
	            if (JSON.parse(res.text()).code == 1) {
	                return JSON.parse(res.text());
	            }
	            else {
	                return JSON.parse(res.text());
	            }
	        });
	    };
	    StartService.prototype.updateTransaction = function (id, method) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        authHeader.append('Authorization', 'Bearer ' + token);
	        return this.http.post(this.serverURL + '/transactions/updateTransaction', this.serializeObj({ "method": method, "id": id }), {
	            headers: authHeader
	        })
	            .toPromise()
	            .then(function (res) {
	            if (JSON.parse(res.text()).code == 1) {
	                return JSON.parse(res.text());
	            }
	            else {
	                return JSON.parse(res.text());
	            }
	        });
	    };
	    StartService.prototype.resendEmail = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        authHeader.append('Authorization', 'Bearer ' + token);
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.get(this.serverURL + '/emailData/resendEmail', options)
	            .toPromise()
	            .then(function (res) {
	            if (JSON.parse(res.text()).code == -1) {
	                return JSON.parse(res.text()).active != 2;
	            }
	            else {
	                return false;
	            }
	        });
	    };
	    StartService.prototype.existsEmail = function (email) {
	        return this.http.get(this.serverURL + '/usersData/existsEmail/' + email).toPromise()
	            .then(function (res) {
	            console.log(res);
	            if (JSON.parse(res.text()).code == 1) {
	                return true;
	            }
	            else {
	                return false;
	            }
	        }, this.handleError);
	    };
	    StartService.prototype.enterDashboard = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        authHeader.append('Authorization', 'Bearer ' + token);
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        console.log("validateAccount");
	        return this.http.get(this.serverURL + '/validateAccount', options).toPromise()
	            .then(function (res) {
	            console.log(res);
	            if (JSON.parse(res.text()).code == 1) {
	                return true;
	            }
	            else {
	                return false;
	            }
	        }, this.handleError);
	    };
	    StartService.prototype.postInformation = function (values) {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        console.log(this.serializeObj(values));
	        authHeader.append('Authorization', 'Bearer ' + token);
	        return this.http.post(this.serverURL + '/usersInfoData', this.serializeObj(values), {
	            headers: authHeader
	        })
	            .map(function (res) {
	            var data = res.json();
	            return data.code;
	        });
	    };
	    StartService.prototype.registerFree = function () {
	        var token = localStorage.getItem('token');
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        authHeader.append('Authorization', 'Bearer ' + token);
	        return this.http.post(this.serverURL + '/transactions/registerFree', {}, {
	            headers: authHeader
	        })
	            .map(function (res) {
	            var data = res.json();
	            return data.code;
	        });
	    };
	    StartService.prototype.handleError = function (error) {
	        // In a real world app, we might use a remote logging infrastructure
	        // We'd also dig deeper into the error to get a better message
	        var errMsg = (error.message) ? error.message :
	            error.status ? error.status + " - " + error.statusText : 'Server error';
	        console.error(errMsg); // log to console instead
	        return Promise.reject(errMsg);
	    };
	    StartService.prototype.serializeObj = function (obj) {
	        var result = [];
	        for (var property in obj)
	            if (encodeURIComponent(obj[property]) != "")
	                result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));
	        return result.join("&");
	    };
	    StartService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], StartService);
	    return StartService;
	    var _a;
	}());
	exports.StartService = StartService;


/***/ },
/* 266 */
/***/ function(module, exports) {

	"use strict";
	var Information = (function () {
	    function Information(phone, address, zip, city, email) {
	        this.phone = phone;
	        this.address = address;
	        this.zip = zip;
	        this.city = city;
	        this.email = email;
	    }
	    return Information;
	}());
	exports.Information = Information;


/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"col-sm-9 col-sm-offset-3 col-md-10 col-md-offset-2 main start\">\n    <div>\n        <p>{{ 'WELCOME_MESSAGE' | translate }}</p>\n    </div>\n    <div [ngClass]=\"{rowfieldready: emailValidation, rowfieldnotready: !emailValidation}\" class=\"col-xs-12\">\n        <div class=\"informationfield col-xs-12 col-md-5\" [ngClass]=\"{readyfield: emailValidation, notreadyfield: !emailValidation}\">\n            <img style=\"display: inline-block; width: 1.6em;\" *ngIf=\"emailValidation\" src=\"" + __webpack_require__(268) + "\">\n            <h3 style=\"display: inline-block; vertical-align: top; padding-left: 1em;\">{{ 'VALIDATE_EMAIL_1' | translate }}</h3>\n        </div>\n        <div class=\"col-xs-12\" style=\"padding-bottom: 2em; padding-top: 1em;\" *ngIf=\"!emailValidation\">\n            <p>{{ 'VALIDATE_EMAIL_2' | translate }}</p>\n            <a (click)=\"resendEmail()\" *ngIf=\"!emailSent\"><img src=\"" + __webpack_require__(269) + "\" class=\"email-icon\" /><span style=\"vertical-align: bottom;\">{{ 'RESEND_EMAIL_1' | translate }}</span></a>\n            <a *ngIf=\"emailSent\" class=\"disabledLink\"><img src=\"" + __webpack_require__(269) + "\" class=\"email-icon\" /><span style=\"vertical-align: bottom;\">{{ 'RESEND_EMAIL_2' | translate }}</span></a>\n        </div>\n    </div>\n    <div [ngClass]=\"{rowfieldready: userProperties, rowfieldnotready: !userProperties}\" class=\"col-xs-12\">\n        <div class=\"informationfield col-xs-12 col-md-5\" [ngClass]=\"{readyfield: userProperties, notreadyfield: !userProperties}\">\n            <img style=\"display: inline-block; width: 1.6em;\" *ngIf=\"userProperties\" src=\"" + __webpack_require__(268) + "\">\n            <h3 style=\"display: inline-block; vertical-align: top; padding-left: 1em;\">{{ 'COMPLETE_INFORMATION' | translate }}</h3>\n        </div>\n        <div class=\"col-xs-12\" style=\"padding-top: 1em; padding-right: 0em;\" *ngIf=\"!userProperties\">\n            <form class=\"col-xs-12\" style=\"padding-right: 0em; margin-bottom: 0em; \" (submit)=\"onSubmit(model)\" #informationForm=\"ngForm\">\n                <div class=\"col-xs-12\">\n                    <h2 class=\"startHeader\">{{ 'CATEGORY' | translate }}</h2>\n                    <div class=\"col-xs-12 col-md-3\">\n                        <div class=\"radio marginInputs\">\n                            <label style=\"padding-left: 0.5em; font-size: 1.3em; color: #555555;\"> <input (change)=\"changeCategory(1)\" type=\"radio\" name=\"role\" value=\"superuser\" />{{ 'CATEGORY_2' | translate }}</label>\n                        </div>\n                    </div>\n                    <div class=\"col-xs-12 col-md-3\">\n                        <div class=\"radio marginInputs\">\n                            <label style=\"padding-left: 0.5em; font-size: 1.3em; color: #555555;\"> <input (change)=\"changeCategory(2)\" type=\"radio\" name=\"role\" value=\"superuser\" />{{ 'CATEGORY_1' | translate }}</label>\n                        </div>\n                    </div>\n                    <span *ngIf=\"codeError('553')\" class=\"login-error-msg col-xs-12\" id=\"errormsg_537\">{{ 'CHOOSE_CATEGORY' | translate }}</span>\n                </div>\n                <div class=\"col-xs-12 col-md-6\" style=\"padding-bottom: 2em;\">\n                    <div>\n                        <input class=\"form-control marginInputs\" type=\"text\" [(ngModel)]=\"model.phone\" placeholder=\"{{ 'PHONE_FIELD' | translate }}\"\n                            [ngModelOptions]=\"{standalone: true}\">\n                        <span *ngIf=\"codeError('543')\" class=\"login-error-msg\" id=\"errormsg_537\">{{ 'PHONE_VALIDATION_1' | translate }}</span>\n                        <span *ngIf=\"codeError('544')\" class=\"login-error-msg\" id=\"errormsg_538\">{{ 'PHONE_VALIDATION_2' | translate }}</span>\n                    </div>\n                    <div>\n                        <input class=\"form-control marginInputs\" type=\"text\" [(ngModel)]=\"model.address\" placeholder=\"{{ 'ADDRESS_FIELD' | translate }}\"\n                            [ngModelOptions]=\"{standalone: true}\">\n                        <span *ngIf=\"codeError('545')\" class=\"login-error-msg\" id=\"errormsg_537\">{{ 'ADDRESS_VALIDATION_1' | translate }}</span>\n                        <span *ngIf=\"codeError('546')\" class=\"login-error-msg\" id=\"errormsg_538\">{{ 'ADDRESS_VALIDATION_2' | translate }}</span>\n                        <span *ngIf=\"codeError('547')\" class=\"login-error-msg\" id=\"errormsg_538\">{{ 'ADDRESS_VALIDATION_3' | translate }}</span>\n                    </div>\n                </div>\n                <div class=\"col-xs-12 col-md-6\" style=\"padding-bottom: 2em; padding-right: 0;\">\n                    <div>\n                        <input class=\"form-control marginInputs\" type=\"text\" [(ngModel)]=\"model.zip\" placeholder=\"{{ 'ZIP_FIELD' | translate }}\"\n                            [ngModelOptions]=\"{standalone: true}\">\n                        <span *ngIf=\"codeError('548')\" class=\"login-error-msg\" id=\"errormsg_537\">{{ 'ZIP_VALIDATION_1' | translate }}</span>\n                        <span *ngIf=\"codeError('549')\" class=\"login-error-msg\" id=\"errormsg_538\">{{ 'ZIP_VALIDATION_2' | translate }}</span>\n                    </div>\n                    <div>\n                        <ng2-completer [(ngModel)]=\"model.city\" [ngModelOptions]=\"{standalone: true}\" [datasource]=\"dataService\" (selected)=\"onCitySelected($event)\"\n                            [minSearchLength]=\"2\" [placeholder]=\"('CITY_FIELD' | translate)\" [textNoResults]=\"('CITY_NOT_FOUND' | translate)\" [autoMatch]=\"true\"></ng2-completer>                        \n\n                        <span *ngIf=\"codeError('550')\" class=\"login-error-msg\" id=\"errormsg_537\">{{ 'CITY_VALIDATION_1' | translate }}</span>\n                        <span *ngIf=\"codeError('551')\" class=\"login-error-msg\" id=\"errormsg_538\">{{ 'CITY_VALIDATION_2' | translate }}</span>\n                    </div>\n                </div>\n                <div class=\"col-xs-12\" style=\"padding-bottom: 2em;\">\n                    <div class=\"col-xs-12 col-md-6\" style=\"padding-left: 0em;\">\n                        <input class=\"form-control marginInputs\" type=\"text\" [(ngModel)]=\"model.email\" placeholder=\"{{ 'EMAIL_FIELD' | translate }}\"\n                            [ngModelOptions]=\"{standalone: true}\">\n                        <span *ngIf=\"codeError('552')\" class=\"login-error-msg\" id=\"errormsg_538\">{{ 'EMAIL_FIELD' | translate }}</span>\n                    </div>\n                </div>\n                <div class=\"col-xs-12\" style=\"padding-right: 0;\">\n                    <button class=\"start-button col-xs-12 col-md-2\" type=\"submit\">{{ 'SEND_INFORMATION' | translate }}</button>\n                </div>\n\n                <!--<div class=\"row\">\n                    <ng2-completer [dataService]=\"dataService2\" (selected)=\"onQuoteSelected($event)\" [minSearchLength]=\"0\" [placeholder]=\"'search quote by author name'\" [textNoResults]=\"'No quotes found'\" [matchClass]=\"'match'\">\n                    </ng2-completer>\n                </div>\n                <div class=\"row\">\n                    <p>Quote: {{quote}}</p>\n                </div>-->\n            </form>\n        </div>\n    </div>\n    <div [ngClass]=\"{rowfieldready: paymentValidation, rowfieldnotready: !paymentValidation}\" class=\"col-xs-12\">\n        <div class=\"informationfield col-xs-12 col-md-5\" [ngClass]=\"{readyfield: paymentValidation, notreadyfield: !paymentValidation}\">\n            <img style=\"display: inline-block; width: 1.6em;\" *ngIf=\"paymentValidation\" src=\"" + __webpack_require__(268) + "\">\n            <h3 style=\"display: inline-block; vertical-align: top; padding-left: 1em;\">{{ 'MAKE_PAYMENT' | translate }}</h3>\n        </div>\n        <div class=\"col-xs-12\" style=\"padding-right: 0em;\" *ngIf=\"!paymentValidation\">\n            <div class=\"col-xs-12\" style=\"padding-right: 0em; padding-top: 1.5em;\">\n                <div *ngIf=\"accountType==0\">\n                    <div class=\"col-xs-12\" style=\"padding-bottom: 1.5em; padding-left: 0em; padding-right: 0em;\">\n                        <div class=\"alert alert-warning\">\n                            {{'VALID_REGISTER_FIRST' | translate}}\n                        </div>\n                        <p class=\"bg-warning\"></p>\n                        <div class=\"col-xs-12 col-md-4\" style=\"text-align: left; padding: 0; padding-top: 1em;\">\n                            <div class=\"col-xs-12\" style=\"padding: 0; padding-right: 0.33em;\">\n                                <div class=\"col-xs-12 account-type-header\">\n                                    <h3>{{ 'FREE' | translate }}</h3>\n                                </div>\n                                <div class=\"col-xs-12 account-type-properties\">\n                                    <div style=\"padding-top: 1em; padding-bottom: 1em;\">\n                                        <h3 class=\"account-type-properties-h3-big\">{{ 'PRICE_0' | translate }}</h3>\n                                    </div>\n                                    <div><img src=\"" + __webpack_require__(142) + "\"><span>{{ 'PAYMENT_INFORMATION_1_1' | translate }}</span></div>\n                                    <div><img src=\"" + __webpack_require__(142) + "\"><span style=\"color: #888888;\">{{ 'PAYMENT_INFORMATION_1_3_0' | translate }}</span></div>\n                                    <div><img src=\"" + __webpack_require__(142) + "\" style=\"visibility: hidden\"><span style=\"color: #888888;\">{{ 'PAYMENT_INFORMATION_1_2' | translate }}</span></div>\n                                    <div><img src=\"" + __webpack_require__(142) + "\" style=\"visibility: hidden\"><span style=\"color: #888888;\">{{ 'PAYMENT_INFORMATION_1_4' | translate }}</span></div>\n                                    <div><img src=\"" + __webpack_require__(142) + "\" style=\"visibility: hidden\"><span style=\"color: #888888;\">{{ 'PAYMENT_INFORMATION_1_5' | translate }}</span></div>\n                                    <div><img src=\"" + __webpack_require__(142) + "\" style=\"visibility: hidden\"><span style=\"color: #888888;\">{{ 'PAYMENT_INFORMATION_1_6' | translate }}</span></div>\n                                    <button (click)=\"changeAccountType(3)\">{{ 'SELECT' | translate }}</button>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"col-xs-12 col-md-4\" style=\"text-align: left; padding: 0;  padding-top: 1em;\">\n                            <div class=\"col-xs-12\" style=\"padding: 0; padding-left: 0.33em; padding-right: 0.33em;\">\n                                <div class=\"col-xs-12 account-type-2-header\">\n                                    <h3>{{ 'TRADITIONAL' | translate }}</h3>\n                                </div>\n                                <div class=\"col-xs-12 account-type-2-properties\">\n                                    <div style=\"padding-top: 1em; padding-bottom: 1em;\">\n                                        <h3 class=\"account-type-properties-h3-big\">{{ 'PRICE_1' | translate }}</h3>\n                                        <h3 class=\"account-type-2-properties-h3-small\">{{ '/ YEAR' | translate }}</h3>\n                                    </div>\n                                    <div><img src=\"" + __webpack_require__(142) + "\"><span>{{ 'PAYMENT_INFORMATION_1_1' | translate }}</span></div>\n                                    <div><img src=\"" + __webpack_require__(142) + "\"><span>{{ 'PAYMENT_INFORMATION_1_3_1' | translate }}</span></div>\n                                    <div><img src=\"" + __webpack_require__(142) + "\"><span>{{ 'PAYMENT_INFORMATION_1_2' | translate }}</span></div>\n                                    <div><img src=\"" + __webpack_require__(142) + "\"><span>{{ 'PAYMENT_INFORMATION_1_4' | translate }}</span></div>\n                                    <div><img src=\"" + __webpack_require__(142) + "\" style=\"visibility: hidden\"><span style=\"color: #888888;\">{{ 'PAYMENT_INFORMATION_1_5' | translate }}</span></div>\n                                    <div><img src=\"" + __webpack_require__(142) + "\" style=\"visibility: hidden\"><span style=\"color: #888888;\">{{ 'PAYMENT_INFORMATION_1_6' | translate }}</span></div>\n                                    <button (click)=\"changeAccountType(1)\">{{ 'SELECT' | translate }}</button>\n                                </div>\n                            </div>\n                        </div>\n\n                        <div class=\"col-xs-12 col-md-4\" style=\"text-align: left; padding: 0; padding-top: 1em;\">\n                            <div class=\"col-xs-12\" style=\"padding: 0; padding-left: 0.33em; \">\n                                <div class=\"col-xs-12 account-type-3-header\">\n                                    <h3>{{ 'PROFESIONAL' | translate }}</h3>\n                                </div>\n                                <div class=\"col-xs-12 account-type-3-properties\">\n                                    <div style=\"padding-top: 1em; padding-bottom: 1em;\">\n                                        <h3 class=\"account-type-properties-h3-big\">{{ 'PRICE_2' | translate }}</h3>\n                                        <h3 class=\"account-type-3-properties-h3-small\">{{ '/ FOREVER' | translate }}</h3>\n                                    </div>\n                                    <div><img src=\"" + __webpack_require__(142) + "\"><span>{{ 'PAYMENT_INFORMATION_1_1' | translate }}</span></div>\n                                    <div><img src=\"" + __webpack_require__(142) + "\"><span>{{ 'PAYMENT_INFORMATION_1_3_2' | translate }}</span></div>\n                                    <div><img src=\"" + __webpack_require__(142) + "\"><span>{{ 'PAYMENT_INFORMATION_1_2' | translate }}</span></div>\n                                    <div><img src=\"" + __webpack_require__(142) + "\"><span>{{ 'PAYMENT_INFORMATION_1_4' | translate }}</span></div>\n                                    <div><img src=\"" + __webpack_require__(142) + "\"><span>{{ 'PAYMENT_INFORMATION_1_5' | translate }}</span></div>\n                                    <div><img src=\"" + __webpack_require__(142) + "\"><span>{{ 'PAYMENT_INFORMATION_1_6' | translate }}</span></div>\n                                    <button (click)=\"changeAccountType(2)\">{{ 'SELECT' | translate }}</button>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"col-xs-12\" *ngIf=\"accountType!=0 && accountType!=3\" style=\"padding-right: 0em;\">\n                    <div class=\"col-xs-12\">\n                        <p *ngIf=\"accountType==1\">{{ 'TRADITIONAL_SUBSCRIPTION' | translate }} {{ 'PRICE_1' | translate }}<a *ngIf=\"accountType==1\"\n                                (click)=\"accountType=0\">{{ 'CHANGE_SUBSCRIPTION' | translate }}</a></p>\n                        <p *ngIf=\"accountType==2\">{{ 'PROFESSIONAL_SUBSCRIPTION' | translate }} {{ 'PRICE_2' | translate }}<a *ngIf=\"accountType==2\"\n                                (click)=\"accountType=0\">{{ 'CHANGE_SUBSCRIPTION' | translate }}</a></p>\n\n                    </div>\n\n                    <div *ngIf=\"!paymentPosted\" class=\"col-xs-12 col-md-3\" style=\"text-align: center\">\n                        <img src=\"" + __webpack_require__(143) + "\" style=\"width: 14em;\" />\n                        <div class=\"radio\">\n                            <label style=\"padding-left: 0.5em; font-size: 1.3em; color: #555555;\"> <input (change)=\"changePaymentMethod(1)\" type=\"radio\" name=\"role\" value=\"superuser\" />{{'BANK_TRANSFER' | translate}}</label>\n                        </div>\n                    </div>\n                    <div *ngIf=\"!paymentPosted\" class=\"col-xs-12 col-md-3\" style=\"text-align: center\">\n                        <img src=\"" + __webpack_require__(144) + "\" style=\"width: 14em;\" />\n                        <div class=\"radio\">\n                            <label style=\"padding-left: 0.5em; font-size: 1.3em; color: #555555;\"> <input (change)=\"changePaymentMethod(2)\" type=\"radio\" name=\"role\" value=\"superuser\" />{{'CREDIT_CARD' | translate}}</label>\n                        </div>\n                    </div>\n                    <div *ngIf=\"paymentMethod==1 && !paymentPosted\" class=\"col-xs-12\" style=\"padding-right: 0em;\">\n                        <button (click)=\"submitPayment()\" class=\"start-button col-xs-12 col-md-2\" type=\"submit\">{{'DO_PAYMENT' | translate}}</button>\n                    </div>\n                    <div *ngIf=\"paymentMethod==2 && !paymentPosted\" class=\"col-xs-12\" style=\"padding-right: 0em;\">\n                        <form ngNoForm action=\"https://sis.redsys.es/sis/realizarPago\" method=\"POST\" name=\"frm\" target=\"_blank\">\n                            <input name=\"Ds_MerchantParameters\" type=\"hidden\" value=\"{{paymentParams.parameters}}\" />\n                            <input name=\"Ds_Signature\" type=\"hidden\" value=\"{{paymentParams.signature}}\" />\n                            <input name=\"Ds_SignatureVersion\" type=\"hidden\" value=\"{{paymentParams.signatureVersion}}\" />\n                            <button class=\"start-button col-xs-12 col-md-2\" type=\"submit\">{{'DO_PAYMENT' | translate}}</button>\n                        </form>\n                    </div>\n                    <div *ngIf=\"paymentMethod==1 && paymentPosted\" class=\"col-xs-12\" [ngClass]=\"{printMode: printMode}\">\n                        <div id=\"bankTransfer\" class=\"bankTransfer col-xs-12 col-md-4\">\n                            <div *ngIf=\"!printMode\" style=\"text-align: right\"><span class=\"glyphicon glyphicon-print clickable\" (click)=\"printBankTransfer();\"></span></div>\n                            <span>{{'BANK_TRANSFER_INFO_1' | translate}}<b>{{'BANK' | translate}}</b> {{'BANK_TRANSFER_INFO_2' | translate}}  <b>{{'ENTERPRISE' | translate}} </b></span><br/>\n                            <span>{{'BANK_TRANSFER_INFO_3' | translate}}<b>{{'CC' | translate}}</b></span><br/>\n                            <span>{{'BANK_TRANSFER_INFO_4' | translate}}<b>{{'BANK_TRANSFER_CONCEPT' | translate}} {{paymentParams.code}}</b></span><br/>\n                            <span>{{'BANK_TRANSFER_INFO_5' | translate}}<b>{{paymentParams.amount}} {{'COIN' | translate}}</b></span><br/>\n                        </div>\n                        <div class=\"bankTransferInformation col-xs-12\">\n                            <span>{{'BANK_TRANSFER_INFO_6' | translate}}</span><br/>\n                            <span>{{'BANK_TRANSFER_INFO_7' | translate}} <a (click)=\"changePaymentMethod(2)\">{{'BANK_TRANSFER_INFO_8' | translate}}</a></span>\n                        </div>\n                        <div *ngIf=\"printMode\" class=\"clickable col-xs-12\" (click)=\"printBankTransfer()\">\n                            << {{ 'BACK' | translate}} </div>\n                        </div>\n                    </div>\n                    <div>\n                        <div class=\"col-xs-12\">\n                            <p *ngIf=\"accountType==3\">{{ 'FREE_SUBSCRIPTION' | translate }} {{ 'PRICE_0' | translate }} <a *ngIf=\"accountType==3\" (click)=\"accountType=0\">({{ 'CHANGE_SUBSCRIPTION' | translate }})</a></p>\n                        </div>\n\n                        <div class=\"col-xs-12\" style=\"padding-right: 0;\">\n                            <button *ngIf=\"accountType==3\" class=\"start-button col-xs-12 col-md-2\" (click)=\"registerFree()\">{{ 'VALIDATE_SUBSCRIPTION' | translate }}</button>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <div [ngClass]=\"{rowfieldready: conditionsValidation, rowfieldnotready: !conditionsValidation}\" class=\"col-xs-12\">\n                <div class=\"informationfield col-xs-12 col-md-5\" [ngClass]=\"{readyfield: conditionsValidation, notreadyfield: !conditionsValidation}\">\n                    <img style=\"display: inline-block; width: 1.6em;\" *ngIf=\"conditionsValidation\" src=\"" + __webpack_require__(268) + "\">\n                    <h3 style=\"display: inline-block; vertical-align: top; padding-left: 1em;\">{{'CONDITIONS_1' | translate}}</h3>\n                </div>\n                <div class=\"col-xs-12\" *ngIf=\"!conditionsValidation\">\n                    <div style=\"margin-top: 1em; padding-bottom: 2em;\">\n\n                        <input class=\"checkboxStart\" type=\"checkbox\" (change)=\"acceptTerms($event)\"><span>{{'CONDITIONS_2' | translate}} <a (click)=\"showTermsF()\">{{'CONDITIONS_3' | translate}}</a></span>\n                    </div>\n                </div>\n            </div>\n\n            <div *ngIf=\"conditionsValidation && userProperties && emailValidation && paymentValidation\" class=\"col-xs-12\" style=\"padding-left: 0; padding-top: 1em;\">\n                <div style=\"float: left;\" class=\"informationfield col-xs-12 col-md-5 start-button clickable\" (click)=\"enterDashboard();\">\n                    <span class=\"glyphicon glyphicon-play\"></span>\n                    <h3 style=\"display: inline-block; padding-left: 1em;\">{{'CREATE_STAND' | translate}}</h3>\n                </div>\n            </div>\n\n            <div [ngClass]=\"classMapModal\" role=\"dialog\">\n                <div class=\"modal-dialog\" style=\"width: 700px;\">\n                    <!-- Modal content-->\n                    <div class=\"modal-content\">\n                        <div class=\"modal-header\">\n                            <button type=\"button\" class=\"close\" (click)=\"closeModal()\">&times;</button>\n                            <h4 class=\"modal-title\"><b>{{ 'TERMS_AND_CONDITIONS' | translate }}</b></h4>\n                        </div>\n                        <div class=\"modal-body\" style=\"text-align: center; overflow-y: scroll; height: 45em;\" [ngClass]=\"{padding2bottom: imageDelete==0}\">\n                            <button *ngIf=\"imageDelete==0\" type=\"button\" class=\"close\" (click)=\"closeModal()\">&times;</button>\n                            <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_1' | translate }}</p>\n                            <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_2' | translate }}</p>\n                            <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_4' | translate }}</p>\n                            <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_5' | translate }}</p>\n                            <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_6' | translate }}</p>\n                            <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_7' | translate }}</p>\n                            <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_8' | translate }}</p>\n                            <p style=\"text-align: left\"><b>{{ 'TERMS_AND_CONDITIONS_9' | translate }}</b></p>\n                            <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_10' | translate }}</p>\n                            <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_11' | translate }}</p>\n                            <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_12' | translate }}</p>\n                            <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_13' | translate }}</p>\n                            <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_14' | translate }}</p>\n                            <p style=\"text-align: left\"><b>{{ 'TERMS_AND_CONDITIONS_15' | translate }}</b></p>\n                            <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_16' | translate }}</p>\n                            <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_17' | translate }}</p>\n                            <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_18' | translate }}</p>\n                            <p style=\"text-align: left\"><b>{{ 'TERMS_AND_CONDITIONS_19' | translate }}</b></p>\n                            <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_20' | translate }}</p>\n                            <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_21' | translate }}</p>\n                            <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_22' | translate }}</p>\n                            <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_23' | translate }}</p>\n                            <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_24' | translate }}</p>\n                            <p style=\"text-align: left\"><b>{{ 'TERMS_AND_CONDITIONS_25' | translate }}</b></p>\n                            <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_26' | translate }}</p>\n                            <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_27' | translate }}</p>\n                            <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_28' | translate }}</p>\n                            <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_29' | translate }}</p>\n                            <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_30' | translate }}</p>\n                            <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_31' | translate }}</p>\n                            <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_32' | translate }}</p>\n                            <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_33' | translate }}</p>\n                            <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_34' | translate }}</p>\n                            <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_35' | translate }}</p>\n                            <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_36' | translate }}</p>\n                            <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_37' | translate }}</p>\n                            <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_38' | translate }}</p>\n                            <p style=\"text-align: left\"><b>{{ 'TERMS_AND_CONDITIONS_39' | translate }}</b></p>\n                            <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_40' | translate }}</p>\n                            <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_41' | translate }}</p>\n                            <p style=\"text-align: left\"><b>{{ 'TERMS_AND_CONDITIONS_42' | translate }}</b></p>\n                            <p style=\"text-align: left\">{{ 'TERMS_AND_CONDITIONS_43' | translate }}</p>\n                        </div>\n                    </div>\n                </div>\n            </div>";

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/tick-rounded.8d197e13e8ffaa609d35859de904c068.png";

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/email.645431dfbc5e4124242fd003a0454844.png";

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(76);
	var verify_email_service_1 = __webpack_require__(271);
	var SuperUserVerifyEmailComponent = (function () {
	    function SuperUserVerifyEmailComponent(_verifyEmailService, route, _parentRouter) {
	        this._verifyEmailService = _verifyEmailService;
	        this.route = route;
	        this._parentRouter = _parentRouter;
	        this.emailKey = route.snapshot.params['emailKey'];
	    }
	    SuperUserVerifyEmailComponent.prototype.ngOnInit = function () {
	        console.log(this.emailKey);
	        this._verifyEmailService.verifyEmail(this.emailKey);
	    };
	    SuperUserVerifyEmailComponent = __decorate([
	        core_1.Component({
	            selector: 'emailData/verifyEmail',
	            providers: [verify_email_service_1.VerifyEmailService],
	            template: __webpack_require__(272)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof verify_email_service_1.VerifyEmailService !== 'undefined' && verify_email_service_1.VerifyEmailService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object])
	    ], SuperUserVerifyEmailComponent);
	    return SuperUserVerifyEmailComponent;
	    var _a, _b, _c;
	}());
	exports.SuperUserVerifyEmailComponent = SuperUserVerifyEmailComponent;


/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(30);
	var router_1 = __webpack_require__(76);
	var json = __webpack_require__(95);
	var VerifyEmailService = (function () {
	    function VerifyEmailService(http, router) {
	        this.http = http;
	        this.router = router;
	        this._verifyEmailUrl = '/emailData/verifyEmail';
	        this.serverURL = json.api_url;
	    }
	    VerifyEmailService.prototype.verifyEmail = function (emailKey) {
	        var _this = this;
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        return this.http.get(this.serverURL + this._verifyEmailUrl + "/" + emailKey, options)
	            .toPromise()
	            .then(function (res) {
	            console.log(res);
	            localStorage.setItem('token', JSON.parse(res.text()).token);
	            //localStorage.setItem('token', JSON.parse(res.text()).id_user);
	            _this.router.navigate(['/superuser', 'start']);
	        }, this.handleError);
	    };
	    VerifyEmailService.prototype.handleError = function (error) {
	        // In a real world app, we might use a remote logging infrastructure
	        // We'd also dig deeper into the error to get a better message
	        var errMsg = (error.message) ? error.message :
	            error.status ? error.status + " - " + error.statusText : 'Server error';
	        console.error(errMsg); // log to console instead
	    };
	    VerifyEmailService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object])
	    ], VerifyEmailService);
	    return VerifyEmailService;
	    var _a, _b;
	}());
	exports.VerifyEmailService = VerifyEmailService;


/***/ },
/* 272 */
/***/ function(module, exports) {

	module.exports = "<h3>Verifying email...</h3>";

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(76);
	var logout_service_1 = __webpack_require__(274);
	var SuperUserLogoutComponent = (function () {
	    function SuperUserLogoutComponent(_logoutService, _parentRouter) {
	        this._logoutService = _logoutService;
	        this.router = _parentRouter;
	    }
	    SuperUserLogoutComponent.prototype.ngOnInit = function () {
	        if (this._logoutService.logout()) {
	            this.router.navigate(['/main', 'dashboard']);
	        }
	        ;
	    };
	    SuperUserLogoutComponent = __decorate([
	        core_1.Component({
	            selector: 'logout',
	            template: __webpack_require__(275),
	            providers: [logout_service_1.LogoutService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof logout_service_1.LogoutService !== 'undefined' && logout_service_1.LogoutService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object])
	    ], SuperUserLogoutComponent);
	    return SuperUserLogoutComponent;
	    var _a, _b;
	}());
	exports.SuperUserLogoutComponent = SuperUserLogoutComponent;


/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var LogoutService = (function () {
	    function LogoutService() {
	    }
	    LogoutService.prototype.logout = function () {
	        localStorage.removeItem('token');
	        localStorage.removeItem('idUser');
	        localStorage.removeItem('userName');
	        return true;
	    };
	    LogoutService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], LogoutService);
	    return LogoutService;
	}());
	exports.LogoutService = LogoutService;


/***/ },
/* 275 */
/***/ function(module, exports) {

	module.exports = "<h3>Closing session...</h3>";

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var profile_service_1 = __webpack_require__(132);
	var SuperUserProfileChangeCategoryComponent = (function () {
	    function SuperUserProfileChangeCategoryComponent(_profileService) {
	        this._profileService = _profileService;
	        this.subroleUpdated = new core_1.EventEmitter();
	    }
	    SuperUserProfileChangeCategoryComponent.prototype.ngOnInit = function () {
	        if (this.userSubrole == 1 || this.userSubrole == 2 || this.userSubrole == 8) {
	            this.category = 1;
	        }
	        else if (this.userSubrole == 3 || this.userSubrole == 4 || this.userSubrole == 9) {
	            this.category = 2;
	        }
	    };
	    SuperUserProfileChangeCategoryComponent.prototype.changeCategory = function (cat) {
	        this.category = cat;
	        this.subroleUpdated.emit({
	            value: cat
	        });
	    };
	    __decorate([
	        core_1.Input('subroleCat'), 
	        __metadata('design:type', Number)
	    ], SuperUserProfileChangeCategoryComponent.prototype, "userSubrole", void 0);
	    __decorate([
	        core_1.Output('subroleUpdatedCat'), 
	        __metadata('design:type', Object)
	    ], SuperUserProfileChangeCategoryComponent.prototype, "subroleUpdated", void 0);
	    SuperUserProfileChangeCategoryComponent = __decorate([
	        core_1.Component({
	            selector: 'profile-change-category',
	            template: __webpack_require__(277),
	            providers: [profile_service_1.ProfileService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof profile_service_1.ProfileService !== 'undefined' && profile_service_1.ProfileService) === 'function' && _a) || Object])
	    ], SuperUserProfileChangeCategoryComponent);
	    return SuperUserProfileChangeCategoryComponent;
	    var _a;
	}());
	exports.SuperUserProfileChangeCategoryComponent = SuperUserProfileChangeCategoryComponent;


/***/ },
/* 277 */
/***/ function(module, exports) {

	module.exports = "<div class=\"col-xs-12\" style=\"padding-right: 0em;\">\n    <div class=\"col-xs-12\">\n        <h2 class=\"startHeader\">{{ 'CATEGORY' | translate }}</h2>\n        <div class=\"col-xs-12 col-md-3\">\n            <div class=\"radio marginInputs\">\n                <label style=\"padding-left: 0.5em; font-size: 1.3em; color: #555555;\"> \n                <input (change)=\"changeCategory(1)\" type=\"radio\" name=\"role\" value=\"superuser\" />{{ 'CATEGORY_2' | translate }}</label>\n            </div>\n        </div>\n        <div class=\"col-xs-12 col-md-3\">\n            <div class=\"radio marginInputs\">\n                <label style=\"padding-left: 0.5em; font-size: 1.3em; color: #555555;\"> \n                <input (change)=\"changeCategory(2)\" type=\"radio\" name=\"role\" value=\"superuser\" />{{ 'CATEGORY_1' | translate }}</label>\n            </div>\n        </div>\n        <span *ngIf=\"error\" class=\"login-error-msg col-xs-12\" id=\"errormsg_537\">{{ 'CHOOSE_CATEGORY' | translate }}</span>\n    </div>\n</div>";

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var profile_service_1 = __webpack_require__(243);
	var MainProfileChangeCategoryComponent = (function () {
	    function MainProfileChangeCategoryComponent(_profileService) {
	        this._profileService = _profileService;
	        this.subroleUpdated = new core_1.EventEmitter();
	    }
	    MainProfileChangeCategoryComponent.prototype.ngOnInit = function () {
	        if (this.userSubrole == 1 || this.userSubrole == 2 || this.userSubrole == 8) {
	            this.category = 1;
	        }
	        else if (this.userSubrole == 3 || this.userSubrole == 4 || this.userSubrole == 9) {
	            this.category = 2;
	        }
	    };
	    MainProfileChangeCategoryComponent.prototype.changeCategory = function (cat) {
	        this.category = cat;
	        this.subroleUpdated.emit({
	            value: cat
	        });
	    };
	    __decorate([
	        core_1.Input('subroleCat'), 
	        __metadata('design:type', Number)
	    ], MainProfileChangeCategoryComponent.prototype, "userSubrole", void 0);
	    __decorate([
	        core_1.Output('subroleUpdatedCat'), 
	        __metadata('design:type', Object)
	    ], MainProfileChangeCategoryComponent.prototype, "subroleUpdated", void 0);
	    MainProfileChangeCategoryComponent = __decorate([
	        core_1.Component({
	            selector: 'main-profile-change-category',
	            template: __webpack_require__(279),
	            providers: [profile_service_1.ProfileService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof profile_service_1.ProfileService !== 'undefined' && profile_service_1.ProfileService) === 'function' && _a) || Object])
	    ], MainProfileChangeCategoryComponent);
	    return MainProfileChangeCategoryComponent;
	    var _a;
	}());
	exports.MainProfileChangeCategoryComponent = MainProfileChangeCategoryComponent;


/***/ },
/* 279 */
277,
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var common_1 = __webpack_require__(22);
	var router_1 = __webpack_require__(76);
	var transaction_return_service_1 = __webpack_require__(281);
	var SuperUserTransactionReturnComponent = (function () {
	    function SuperUserTransactionReturnComponent(_transactionReturnService, location, _parentRouter, route) {
	        this._transactionReturnService = _transactionReturnService;
	        this.route = route;
	        this.paymentFailed = false;
	        this.router = _parentRouter;
	        this.transactionKey = route.snapshot.params['transactionKey'];
	    }
	    SuperUserTransactionReturnComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        console.log("In Transaction Return Component -> NgOnInit");
	        console.log(this.transactionKey);
	        this._transactionReturnService.verifyTransaction(this.transactionKey).then(function (data) {
	            console.log(data);
	            if (data.code == 1) {
	                _this.router.navigate(['/superuser', 'start']);
	            }
	            else {
	                _this.paymentFailed = true;
	            }
	        });
	    };
	    SuperUserTransactionReturnComponent = __decorate([
	        core_1.Component({
	            selector: 'transaction-return',
	            template: __webpack_require__(282),
	            providers: [transaction_return_service_1.TransactionReturnService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof transaction_return_service_1.TransactionReturnService !== 'undefined' && transaction_return_service_1.TransactionReturnService) === 'function' && _a) || Object, (typeof (_b = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object])
	    ], SuperUserTransactionReturnComponent);
	    return SuperUserTransactionReturnComponent;
	    var _a, _b, _c, _d;
	}());
	exports.SuperUserTransactionReturnComponent = SuperUserTransactionReturnComponent;


/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(30);
	var json = __webpack_require__(95);
	var TransactionReturnService = (function () {
	    function TransactionReturnService(http) {
	        this.http = http;
	        this._verifyTransactionUrl = '/transactions/verifyTransaction';
	        this.serverURL = json.api_url;
	    }
	    TransactionReturnService.prototype.verifyTransaction = function (transactionKey) {
	        console.log("IN Transaction Return Service -> VerifyTransaction");
	        var authHeader = new http_1.Headers({
	            'Content-Type': 'application/x-www-form-urlencoded'
	        });
	        var options = new http_1.RequestOptions({ headers: authHeader, body: "" });
	        console.log("URL:");
	        console.log(this.serverURL + this._verifyTransactionUrl + "/" + transactionKey);
	        return this.http.get(this.serverURL + this._verifyTransactionUrl + "/" + transactionKey, options).toPromise().then(function (res) {
	            console.log("INSIDE RESPONSE");
	            console.log(res);
	            return JSON.parse(res.text());
	        }, this.handleError);
	    };
	    TransactionReturnService.prototype.handleError = function (error) {
	        // In a real world app, we might use a remote logging infrastructure
	        // We'd also dig deeper into the error to get a better message
	        var errMsg = (error.message) ? error.message :
	            error.status ? error.status + " - " + error.statusText : 'Server error';
	        console.error(errMsg); // log to console instead
	    };
	    TransactionReturnService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], TransactionReturnService);
	    return TransactionReturnService;
	    var _a;
	}());
	exports.TransactionReturnService = TransactionReturnService;


/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"col-xs-12 main\" style=\"text-align: center\">\n    <img *ngIf=\"!paymentFailed\" style=\"width: 5em;\" src=\"" + __webpack_require__(283) + "\" />\n    <label style=\"color: red\" *ngIf=\"paymentFailed\">Payment failed</label>\n</div>";

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/loading.0bfedcce0738d562de473374a286d478.gif";

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var profile_service_1 = __webpack_require__(243);
	var MainProfileChangeLanguageComponent = (function () {
	    function MainProfileChangeLanguageComponent(_profileService) {
	        this._profileService = _profileService;
	        this.languageUpdated = new core_1.EventEmitter();
	    }
	    MainProfileChangeLanguageComponent.prototype.ngOnInit = function () {
	    };
	    MainProfileChangeLanguageComponent.prototype.changeLanguage = function (lang) {
	        this.languageUpdated.emit({
	            value: lang
	        });
	    };
	    __decorate([
	        core_1.Input('language'), 
	        __metadata('design:type', String)
	    ], MainProfileChangeLanguageComponent.prototype, "userLanguage", void 0);
	    __decorate([
	        core_1.Output('languageUpdated'), 
	        __metadata('design:type', Object)
	    ], MainProfileChangeLanguageComponent.prototype, "languageUpdated", void 0);
	    MainProfileChangeLanguageComponent = __decorate([
	        core_1.Component({
	            selector: 'main-profile-change-language',
	            template: __webpack_require__(285),
	            providers: [profile_service_1.ProfileService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof profile_service_1.ProfileService !== 'undefined' && profile_service_1.ProfileService) === 'function' && _a) || Object])
	    ], MainProfileChangeLanguageComponent);
	    return MainProfileChangeLanguageComponent;
	    var _a;
	}());
	exports.MainProfileChangeLanguageComponent = MainProfileChangeLanguageComponent;


/***/ },
/* 285 */
/***/ function(module, exports) {

	module.exports = "<div class=\"col-xs-12\" style=\"padding-right: 0em;\">\n    <div class=\"col-xs-12\">\n        <h2 class=\"startHeader\">{{ 'LANGUAGE' | translate }}</h2>\n        <div class=\"col-xs-12 col-md-3\">\n            <div class=\"radio marginInputs\">\n                <label style=\"padding-left: 0.5em; font-size: 1.3em; color: #555555;\"> \n                <input (change)=\"changeLanguage('CATALAN')\" type=\"radio\" name=\"role\" value=\"superuser\" />{{ 'CATALAN' | translate }}</label>\n            </div>\n        </div>\n        <div class=\"col-xs-12 col-md-3\">\n            <div class=\"radio marginInputs\">\n                <label style=\"padding-left: 0.5em; font-size: 1.3em; color: #555555;\"> \n                <input (change)=\"changeLanguage('SPANISH')\" type=\"radio\" name=\"role\" value=\"superuser\" />{{ 'SPANISH' | translate }}</label>\n            </div>\n        </div>\n        <span *ngIf=\"error\" class=\"login-error-msg col-xs-12\" id=\"errormsg_537\">{{ 'CHOOSE_LANGUAGE' | translate }}</span>\n    </div>\n</div>";

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var profile_service_1 = __webpack_require__(132);
	var SuperUserProfileChangeLanguageComponent = (function () {
	    function SuperUserProfileChangeLanguageComponent(_profileService) {
	        this._profileService = _profileService;
	        this.languageUpdated = new core_1.EventEmitter();
	    }
	    SuperUserProfileChangeLanguageComponent.prototype.ngOnInit = function () {
	    };
	    SuperUserProfileChangeLanguageComponent.prototype.changeLanguage = function (lang) {
	        this.languageUpdated.emit({
	            value: lang
	        });
	    };
	    __decorate([
	        core_1.Input('language'), 
	        __metadata('design:type', String)
	    ], SuperUserProfileChangeLanguageComponent.prototype, "userLanguage", void 0);
	    __decorate([
	        core_1.Output('languageUpdated'), 
	        __metadata('design:type', Object)
	    ], SuperUserProfileChangeLanguageComponent.prototype, "languageUpdated", void 0);
	    SuperUserProfileChangeLanguageComponent = __decorate([
	        core_1.Component({
	            selector: 'profile-change-language',
	            template: __webpack_require__(287),
	            providers: [profile_service_1.ProfileService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof profile_service_1.ProfileService !== 'undefined' && profile_service_1.ProfileService) === 'function' && _a) || Object])
	    ], SuperUserProfileChangeLanguageComponent);
	    return SuperUserProfileChangeLanguageComponent;
	    var _a;
	}());
	exports.SuperUserProfileChangeLanguageComponent = SuperUserProfileChangeLanguageComponent;


/***/ },
/* 287 */
285,
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(76);
	var auth_service_1 = __webpack_require__(289);
	var AuthGuard = (function () {
	    function AuthGuard(_authService, router) {
	        this._authService = _authService;
	        this.router = router;
	    }
	    AuthGuard.prototype.canActivate = function (route, state) {
	        var parentRoute = state.url.split("/")[1];
	        var childRoute = state.url.split("/")[2];
	        var role = localStorage.getItem("userRole");
	        var status = this._authService.getUserStatus();
	        console.log(parentRoute);
	        console.log(role);
	        console.log(childRoute);
	        console.log(status);
	        if (parentRoute == "main") {
	            if (role == "admin" || role == "superuser" || role == "user") {
	                return true;
	            }
	            else {
	                this.router.navigate(['/main', 'dashboard']);
	                return false;
	            }
	        }
	        else if (parentRoute == "superuser") {
	            if (role == "admin" || role == "superuser") {
	                if (childRoute != "start" && childRoute != "transactionReturn") {
	                    if (status == 1) {
	                        return true;
	                    }
	                    else {
	                        this.router.navigate(['/superuser', 'start']);
	                        return false;
	                    }
	                }
	                else {
	                    return true;
	                }
	            }
	            else {
	                this.router.navigate(['/main', 'dashboard']);
	                return false;
	            }
	        }
	        else {
	            return false;
	        }
	    };
	    AuthGuard = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object])
	    ], AuthGuard);
	    return AuthGuard;
	    var _a, _b;
	}());
	exports.AuthGuard = AuthGuard;


/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(30);
	__webpack_require__(31);
	__webpack_require__(290);
	__webpack_require__(292);
	var json = __webpack_require__(95);
	var AuthService = (function () {
	    function AuthService(http) {
	        this.http = http;
	        this.getTokenService();
	        this.serverURL = json.api_url;
	    }
	    AuthService.prototype.getUserStatus = function () {
	        return Number(localStorage.getItem("userActive"));
	    };
	    AuthService.prototype.getTokenService = function () {
	        this.token = localStorage.getItem('token');
	    };
	    AuthService.prototype.handleError = function (error) {
	        console.log(error);
	        console.error('An error occurred', error);
	        return Promise.reject(error.message || error);
	    };
	    AuthService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
	    ], AuthService);
	    return AuthService;
	    var _a;
	}());
	exports.AuthService = AuthService;


/***/ }
]);


/** WEBPACK FOOTER **
 ** app.592a125404cac0313b64.js
 **/